var $dkmxp$graphqlrequest = require("graphql-request");
var $dkmxp$graphql = require("graphql");
var $dkmxp$graphqltag = require("graphql-tag");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "initializeDocumentUploadSdk", () => $0dd523eaeec6a5c8$export$9063cee3c5d28fcb);



var $2f53fee15f29b056$export$2cdfb06d6edcb7f5 = /*#__PURE__*/ function(AchTransferStatus) {
    /** You requested to cancel the transfer. */ AchTransferStatus["CANCELED"] = "CANCELED";
    /** The transfer failed. Additional details are available in ACHTransferStatusCode. */ AchTransferStatus["FAILED"] = "FAILED";
    /** A transfer request has been initiated. */ AchTransferStatus["INITIATED"] = "INITIATED";
    /** The transfer has successfully been processed by the bank and funds are available. */ AchTransferStatus["PROCESSED"] = "PROCESSED";
    /** The transfer is processing at Highnote and at the bank, but funds are not available yet. */ AchTransferStatus["PROCESSING"] = "PROCESSING";
    /** The transfer has been returned by the bank. */ AchTransferStatus["RETURNED"] = "RETURNED";
    return AchTransferStatus;
}({});
var $2f53fee15f29b056$export$ce99641528a5b517 = /*#__PURE__*/ function(AchTransferStatusReasonCode) {
    /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */ AchTransferStatusReasonCode["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** R16 - The account is frozen. */ AchTransferStatusReasonCode["ACCOUNT_FROZEN"] = "ACCOUNT_FROZEN";
    /** R11 - Loading funds via ACH is not supported by this program. */ AchTransferStatusReasonCode["ACH_LOAD_NOT_SUPPORTED"] = "ACH_LOAD_NOT_SUPPORTED";
    /** R19 - There is an error in the amount field. */ AchTransferStatusReasonCode["AMOUNT_FIELD_ERROR"] = "AMOUNT_FIELD_ERROR";
    /** R07 - The Authorization was revoked by Customer. */ AchTransferStatusReasonCode["AUTHORIZATION_REVOKED_BY_CUSTOMER"] = "AUTHORIZATION_REVOKED_BY_CUSTOMER";
    /** R11 - The account does not have the required corporate bank account feature enabled. */ AchTransferStatusReasonCode["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The amount of the transfer does not match the currency of the Highnote account. */ AchTransferStatusReasonCode["CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT"] = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT";
    /** R24 - Resulted in a Duplicate Entry. */ AchTransferStatusReasonCode["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    /** R11 - The transfer is not in accordance with the terms of the authorization. */ AchTransferStatusReasonCode["ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION"] = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION";
    /** R02 - The external account has been closed. */ AchTransferStatusReasonCode["EXTERNAL_ACCOUNT_CLOSED"] = "EXTERNAL_ACCOUNT_CLOSED";
    /** R03 - No matching external account was found. */ AchTransferStatusReasonCode["EXTERNAL_ACCOUNT_NOT_FOUND"] = "EXTERNAL_ACCOUNT_NOT_FOUND";
    /** R02 - The Highnote account has been closed. */ AchTransferStatusReasonCode["HIGHNOTE_ACCOUNT_CLOSED"] = "HIGHNOTE_ACCOUNT_CLOSED";
    /** R03 - No matching Highnote account was found. */ AchTransferStatusReasonCode["HIGHNOTE_ACCOUNT_NOT_FOUND"] = "HIGHNOTE_ACCOUNT_NOT_FOUND";
    /** R18 - Has an Improper Effective entry date. */ AchTransferStatusReasonCode["IMPROPER_EFFECTIVE_ENTRY_DATE"] = "IMPROPER_EFFECTIVE_ENTRY_DATE";
    /** R01 - This was a debit from an en external account did not have enough funds. */ AchTransferStatusReasonCode["INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT";
    /** R01 - This was a debit from an account at Highnote which did not have enough funds. */ AchTransferStatusReasonCode["INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT";
    /** There is an internal error with the transfer. */ AchTransferStatusReasonCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** R04 - Has an Invalid Account Number. */ AchTransferStatusReasonCode["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    /** R21 - Has an Invalid Company ID Number. */ AchTransferStatusReasonCode["INVALID_COMPANY_ID_NUMBER"] = "INVALID_COMPANY_ID_NUMBER";
    /** R22 - Has an Invalid Individual ID Number. */ AchTransferStatusReasonCode["INVALID_INDIVIDUAL_ID_NUMBER"] = "INVALID_INDIVIDUAL_ID_NUMBER";
    /** R20 - Is a Non Transactional Account. */ AchTransferStatusReasonCode["NON_TRANSACTION_ACCOUNT"] = "NON_TRANSACTION_ACCOUNT";
    /** R08 - The Payment was stopped. */ AchTransferStatusReasonCode["PAYMENT_STOPPED"] = "PAYMENT_STOPPED";
    /** R11 - The account does not have the required payroll advance feature enabled. */ AchTransferStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required payroll employer advance feature enabled. */ AchTransferStatusReasonCode["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** R06 - Funds were returned per OFDI Request. */ AchTransferStatusReasonCode["RETURNED_PER_ODFI_REQUEST"] = "RETURNED_PER_ODFI_REQUEST";
    /** R11 - The account does not have the required secure card feature enabled. */ AchTransferStatusReasonCode["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** R29 - The Transaction was not Authorized By Account Holder. */ AchTransferStatusReasonCode["TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER"] = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER";
    /** R11 - The transfer amount is below the minimum amount to reload. */ AchTransferStatusReasonCode["TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT";
    /** R11 - The transfer exceeds maximum the load limit. */ AchTransferStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT";
    /** R11 - The transfer exceeds the maximum reload limit. */ AchTransferStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT";
    /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */ AchTransferStatusReasonCode["UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE"] = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE";
    /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */ AchTransferStatusReasonCode["UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION"] = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION";
    /** R09 - Transaction represents Uncollected Funds. */ AchTransferStatusReasonCode["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    return AchTransferStatusReasonCode;
}({});
var $2f53fee15f29b056$export$767a71856c510da2 = /*#__PURE__*/ function(AtmLocationBrand) {
    /** An ATM that is powered by Money Pass. */ AtmLocationBrand["MONEY_PASS"] = "MONEY_PASS";
    return AtmLocationBrand;
}({});
var $2f53fee15f29b056$export$4302ce124fbe338e = /*#__PURE__*/ function(AtmLocationFeature) {
    /** The ATM is accessible. */ AtmLocationFeature["ACCESSIBLE"] = "ACCESSIBLE";
    /** The ATM can accept monetary deposits. */ AtmLocationFeature["DEPOSIT_AVAILABLE"] = "DEPOSIT_AVAILABLE";
    /** The ATM is open 24 hours a day. */ AtmLocationFeature["OPEN_24_HOURS"] = "OPEN_24_HOURS";
    return AtmLocationFeature;
}({});
var $2f53fee15f29b056$export$9cfd7bf8a57c8396 = /*#__PURE__*/ function(AvsResponseCode) {
    /** The address provided on the authorization matched the address on file for the Cardholder. */ AvsResponseCode["MATCH"] = "MATCH";
    /**
   * The check was not performed.
   *
   * Typically, this happens when an address is provided on the authorization, but we are unable to locate the same value in our vault.
   */ AvsResponseCode["NOT_PERFORMED"] = "NOT_PERFORMED";
    /** The address was not provided during authorization. */ AvsResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The address provided on the authorization did not match an address on file for the Cardholder. */ AvsResponseCode["NO_MATCH"] = "NO_MATCH";
    return AvsResponseCode;
}({});
var $2f53fee15f29b056$export$43fde3f6cc666018 = /*#__PURE__*/ function(AccountClosureBlocker) {
    /**
   * The account holder has funds remaining on their `FinancialAccount` and money
   * is due to the account holder. Required ledgers on the account must be $0 for
   * the `FinancialAccount` to close.
   */ AccountClosureBlocker["ACCOUNT_BALANCE_PAYABLE"] = "ACCOUNT_BALANCE_PAYABLE";
    /**
   * The account holder has funds remaining on their `FinancialAccount` and money
   * is owed by the account holder. Required ledgers on the account must be $0 for
   * the `FinancialAccount` to close.
   */ AccountClosureBlocker["ACCOUNT_BALANCE_RECEIVABLE"] = "ACCOUNT_BALANCE_RECEIVABLE";
    /** The `FinancialAccount` has one or more active authorized user financial accounts. */ AccountClosureBlocker["ACTIVE_AUTHORIZED_USER_ACCOUNTS"] = "ACTIVE_AUTHORIZED_USER_ACCOUNTS";
    /** The `FinancialAccount` has an active Military Lending Act notice. */ AccountClosureBlocker["ACTIVE_MLA"] = "ACTIVE_MLA";
    /**
   * The `FinancialAccount` has an active `PaymentCard`. All `PaymentCard`s
   * associated with the `FinancialAccount` should have a `PaymentCardStatus` of
   * `SUSPENDED` or `CLOSED`.
   */ AccountClosureBlocker["ACTIVE_PAYMENT_CARD"] = "ACTIVE_PAYMENT_CARD";
    /** The `FinancialAccount` has an active Servicemembers Civil Relief Act notice. */ AccountClosureBlocker["ACTIVE_SCRA"] = "ACTIVE_SCRA";
    /**
   * There is no `ExternalFinancialAccount` available to transfer funds out to.
   * The `owner` of the `FinancialAccount` must have at least one value in
   * its `externalFinancialAccounts` field.
   *
   * This is currently only supported for `USPersonAccountHolder` and
   * `USBusinessAccountHolder` type owners.
   */ AccountClosureBlocker["NO_EXTERNAL_FINANCIAL_ACCOUNT"] = "NO_EXTERNAL_FINANCIAL_ACCOUNT";
    /**
   * The line of credit for this `FinancialAccount` has not been closed.
   * The 'ACCOUNT_HOLDER_CREDIT_LIMIT' `Ledger` has a non-zero balance.
   */ AccountClosureBlocker["OPEN_LINE_OF_CREDIT"] = "OPEN_LINE_OF_CREDIT";
    /** The `FinancialAccount` has an outstanding payroll advance. There is a nonzero balance on the `PAYROLL_ADVANCE_PAYABLE` ledger. */ AccountClosureBlocker["PAYROLL_ADVANCE_PAYABLE"] = "PAYROLL_ADVANCE_PAYABLE";
    /**
   * There is a pending authorization on the `FinancialAccount`. At least one of
   * the 'AUTH', 'DEPOSIT_AUTH', 'REFUND_AUTH', or 'FEE_AUTH' `Ledger`s has a non
   * zero balance.
   */ AccountClosureBlocker["PENDING_AUTHORIZATION"] = "PENDING_AUTHORIZATION";
    /**
   * The `FinancialAccount` has a pending `ElectronicFundsTransfer` in progress.
   * Accounts can be closed when all transfers are in a terminal state, such as
   * `PROCESSED` or `FAILED`.
   */ AccountClosureBlocker["PENDING_TRANSFER"] = "PENDING_TRANSFER";
    /**
   * The `FinancialAccount` has a pseudo balance.
   * There is a non-zero balance on one of the following ledgers: `PSEUDO_CASH`, `PSEUDO_AVAILABLE_CASH`, `PSEUDO_AVAILABLE_CREDIT`, `PSEUDO_CREDIT_OUTSTANDING`.
   */ AccountClosureBlocker["PSEUDO_BALANCE"] = "PSEUDO_BALANCE";
    /**
   * There is a risk hold on an `ElectronicFundsTransfer` associated with this `FinancialAccount`.
   * The 'RISK_HOLD' `Ledger` has a non-zero balance.
   */ AccountClosureBlocker["RISK_HOLD"] = "RISK_HOLD";
    /**
   * There is a scheduled `ElectronicFundsTransfer` on the account. The
   * `ElectronicFundsTransfer` could be either a one time transfer or a recurring
   * transfer.
   */ AccountClosureBlocker["SCHEDULED_TRANSFER"] = "SCHEDULED_TRANSFER";
    return AccountClosureBlocker;
}({});
var $2f53fee15f29b056$export$4230465992e305be = /*#__PURE__*/ function(AccountHolderApplicationStatusCode) {
    /** The application was approved. */ AccountHolderApplicationStatusCode["APPROVED"] = "APPROVED";
    /** The application was closed. */ AccountHolderApplicationStatusCode["CLOSED"] = "CLOSED";
    /** The application was denied. */ AccountHolderApplicationStatusCode["DENIED"] = "DENIED";
    /** The application requires further review. */ AccountHolderApplicationStatusCode["IN_REVIEW"] = "IN_REVIEW";
    /** The application is currently being processed. */ AccountHolderApplicationStatusCode["PENDING"] = "PENDING";
    return AccountHolderApplicationStatusCode;
}({});
var $2f53fee15f29b056$export$9804aab0642366c1 = /*#__PURE__*/ function(AccountHolderProvisioningStatus) {
    /** The provisioning process has been successfully completed. */ AccountHolderProvisioningStatus["COMPLETED"] = "COMPLETED";
    /** An error occurred during the provisioning process. Further action may be required to resolve the issue. */ AccountHolderProvisioningStatus["ERROR"] = "ERROR";
    /** The provisioning process has been initiated but has not yet started. */ AccountHolderProvisioningStatus["INITIATED"] = "INITIATED";
    /** The provisioning process is currently in progress. */ AccountHolderProvisioningStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The provisioning process has been rejected due to an issue encountered during processing, preventing its completion. */ AccountHolderProvisioningStatus["REJECTED"] = "REJECTED";
    return AccountHolderProvisioningStatus;
}({});
var $2f53fee15f29b056$export$516fef2cc6b92e15 = /*#__PURE__*/ function(AccountHolderProvisioningWorkflowActionStatus) {
    /** The provisioning process has been successfully completed. */ AccountHolderProvisioningWorkflowActionStatus["COMPLETED"] = "COMPLETED";
    /** An error occurred during the provisioning process. Further action may be required to resolve the issue. */ AccountHolderProvisioningWorkflowActionStatus["ERROR"] = "ERROR";
    /** The provisioning process has been initiated but has not yet started. */ AccountHolderProvisioningWorkflowActionStatus["INITIATED"] = "INITIATED";
    /** The provisioning process is currently in progress. */ AccountHolderProvisioningWorkflowActionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The action was part of the provisioning process but was not executed. */ AccountHolderProvisioningWorkflowActionStatus["NOT_EXECUTED"] = "NOT_EXECUTED";
    return AccountHolderProvisioningWorkflowActionStatus;
}({});
var $2f53fee15f29b056$export$5a21c58fc30f1562 = /*#__PURE__*/ function(AccountHolderRiskVerificationStatusCode) {
    /** The account holder was denied. See the results of the risk verification for more details. */ AccountHolderRiskVerificationStatusCode["DENIED"] = "DENIED";
    /** The account holder is currently undergoing manual review. */ AccountHolderRiskVerificationStatusCode["IN_REVIEW"] = "IN_REVIEW";
    /** The account holder passed the risk verification requirements. */ AccountHolderRiskVerificationStatusCode["PASSED"] = "PASSED";
    /** The account holder is currently being verified. */ AccountHolderRiskVerificationStatusCode["PENDING"] = "PENDING";
    return AccountHolderRiskVerificationStatusCode;
}({});
var $2f53fee15f29b056$export$7a27249593baaf3d = /*#__PURE__*/ function(AccountHolderVerificationResultCode) {
    /** The account holder's address was able to be verified. */ AccountHolderVerificationResultCode["ADDRESS_MATCH"] = "ADDRESS_MATCH";
    /** The account holder's address could not be verified as provided. */ AccountHolderVerificationResultCode["ADDRESS_MISMATCH"] = "ADDRESS_MISMATCH";
    /** The account holder's address has previously been found to be part of previous fraudulent activity. */ AccountHolderVerificationResultCode["ADDRESS_WARNING"] = "ADDRESS_WARNING";
    /** The business name provided matches a registered business name (Applicable to Business Onboarding). */ AccountHolderVerificationResultCode["BUSINESS_NAME_MATCH"] = "BUSINESS_NAME_MATCH";
    /** The business name provided does not match a registered business name (Applicable to Business Onboarding). */ AccountHolderVerificationResultCode["BUSINESS_NAME_MISMATCH"] = "BUSINESS_NAME_MISMATCH";
    /** The overall verification score for the business was below the passing limit. */ AccountHolderVerificationResultCode["BUSINESS_VERIFICATION_SCORE_FAILED"] = "BUSINESS_VERIFICATION_SCORE_FAILED";
    /** The business data was verified and overall verification score was above the passing. */ AccountHolderVerificationResultCode["BUSINESS_VERIFICATION_SCORE_PASSED"] = "BUSINESS_VERIFICATION_SCORE_PASSED";
    /** The account holder may be verified but was denied due to fraudulent activity. */ AccountHolderVerificationResultCode["DENIED_FRAUD"] = "DENIED_FRAUD";
    /** The account holder could not be verified with the information provided. */ AccountHolderVerificationResultCode["DENIED_KYC"] = "DENIED_KYC";
    /** The account holder's device has been previously flagged for fraudulent activity. */ AccountHolderVerificationResultCode["DEVICE_WARNING"] = "DEVICE_WARNING";
    /** The account holder's date of birth was able to be verified. */ AccountHolderVerificationResultCode["DOB_MATCH"] = "DOB_MATCH";
    /** The account holder's date of birth may have been accidentally miskeyed. */ AccountHolderVerificationResultCode["DOB_MISKEY"] = "DOB_MISKEY";
    /** The date of birth provided does not match the date of birth of the account holder. */ AccountHolderVerificationResultCode["DOB_MISMATCH"] = "DOB_MISMATCH";
    /** The account holder's email has previously been found to be part of previous fraudulent activity. */ AccountHolderVerificationResultCode["EMAIL_WARNING"] = "EMAIL_WARNING";
    /** The business must provide a document to verify their employer identification number (Applicable to Business Onboarding). */ AccountHolderVerificationResultCode["FEIN_DOCUMENT_REQUIRED"] = "FEIN_DOCUMENT_REQUIRED";
    /** The business' provided employer identification number matches their registered employer identification number (Applicable to Business Onboarding). */ AccountHolderVerificationResultCode["FEIN_MATCH"] = "FEIN_MATCH";
    /** The business' provided employer identification number does not match their registered employer identification number (Applicable to Business Onboarding). */ AccountHolderVerificationResultCode["FEIN_MISMATCH"] = "FEIN_MISMATCH";
    /** The account holder's device has not been used in the past. */ AccountHolderVerificationResultCode["FOREIGN_DEVICE"] = "FOREIGN_DEVICE";
    /** The account holder is being reviewed. */ AccountHolderVerificationResultCode["FRAUD_REVIEW"] = "FRAUD_REVIEW";
    /** The account holder has been previously reported for fraud and has repeated fraudulent activity. This is a high risk warning. */ AccountHolderVerificationResultCode["FRAUD_RISK"] = "FRAUD_RISK";
    /** The account holder's data provided has resulted in suspected fraudulent activity. This is a medium risk warning. */ AccountHolderVerificationResultCode["FRAUD_WARNING"] = "FRAUD_WARNING";
    /** High probability of synthetic fraud. */ AccountHolderVerificationResultCode["HIGH_ABUSE_SCORE"] = "HIGH_ABUSE_SCORE";
    /** High probability of third party fraud. */ AccountHolderVerificationResultCode["HIGH_THEFT_SCORE"] = "HIGH_THEFT_SCORE";
    /** The account holder's data has been verified and is not associated with prior fraudulent activity. */ AccountHolderVerificationResultCode["KYC_FRAUD_PASS"] = "KYC_FRAUD_PASS";
    /** The account holder's data was unable to be fully verified. */ AccountHolderVerificationResultCode["KYC_WARNING"] = "KYC_WARNING";
    /** Low probability of synthetic fraud. */ AccountHolderVerificationResultCode["LOW_ABUSE_SCORE"] = "LOW_ABUSE_SCORE";
    /** Low probability of third party fraud. */ AccountHolderVerificationResultCode["LOW_THEFT_SCORE"] = "LOW_THEFT_SCORE";
    /** Moderate probability of synthetic fraud. */ AccountHolderVerificationResultCode["MEDIUM_ABUSE_SCORE"] = "MEDIUM_ABUSE_SCORE";
    /** Moderate probability of third party fraud. */ AccountHolderVerificationResultCode["MEDIUM_THEFT_SCORE"] = "MEDIUM_THEFT_SCORE";
    /** The account holder's name was able to be verified. */ AccountHolderVerificationResultCode["NAME_MATCH"] = "NAME_MATCH";
    /** The name provided does not match any known names for the account holder. */ AccountHolderVerificationResultCode["NAME_MISMATCH"] = "NAME_MISMATCH";
    /** The business data was found to be listed in the Treasury's OFAC list. */ AccountHolderVerificationResultCode["OFAC_MATCH"] = "OFAC_MATCH";
    /** The account holder's phone number was able to be verified. */ AccountHolderVerificationResultCode["PHONE_MATCH"] = "PHONE_MATCH";
    /** The phone number provided does not match any known phone numbers for the account holder. */ AccountHolderVerificationResultCode["PHONE_MISMATCH"] = "PHONE_MISMATCH";
    /** The primary authorized person is verified as representative of the business. */ AccountHolderVerificationResultCode["REPRESENTATIVE_MATCH"] = "REPRESENTATIVE_MATCH";
    /** The primary authorized person could not be verified as representative of the business. */ AccountHolderVerificationResultCode["REPRESENTATIVE_MISMATCH"] = "REPRESENTATIVE_MISMATCH";
    /** The business has an active registration with the Secretary of State (SOS). */ AccountHolderVerificationResultCode["SOS_ACTIVE"] = "SOS_ACTIVE";
    /** The business has registered with the Secretary of State (SOS), but does not have an active filing. */ AccountHolderVerificationResultCode["SOS_INACTIVE"] = "SOS_INACTIVE";
    /** The business has an active and registered Secretary of State (SOS) filing. The business address provided matches the Secretary of State (SOS) registration address. */ AccountHolderVerificationResultCode["SOS_MATCH"] = "SOS_MATCH";
    /** The business could not be verified with the Secretary of State (SOS). */ AccountHolderVerificationResultCode["SOS_MISMATCH"] = "SOS_MISMATCH";
    /** The business' registration with the Secretary of State (SOS) has been flagged or the filing status is unknown */ AccountHolderVerificationResultCode["SOS_UNKNOWN"] = "SOS_UNKNOWN";
    /** The account holder's social security number was able to be verified. */ AccountHolderVerificationResultCode["SSN_MATCH"] = "SSN_MATCH";
    /** The account holder's social security number may have been accidentally miskeyed. */ AccountHolderVerificationResultCode["SSN_MISKEY"] = "SSN_MISKEY";
    /** The account holder's social security number could not be verified as provided. */ AccountHolderVerificationResultCode["SSN_MISMATCH"] = "SSN_MISMATCH";
    /** The Social Security Number provided is associated with multiple identities. */ AccountHolderVerificationResultCode["SSN_MULTI_IDENTITY"] = "SSN_MULTI_IDENTITY";
    /** The social security number has been previously flagged for fraudulent activity. */ AccountHolderVerificationResultCode["SSN_WARNING"] = "SSN_WARNING";
    /** The account holder is currently on an active watchlist. */ AccountHolderVerificationResultCode["WATCHLIST_HIT"] = "WATCHLIST_HIT";
    /** The account holder is currently on an active watchlist. */ AccountHolderVerificationResultCode["WATCHLIST_WARNING"] = "WATCHLIST_WARNING";
    return AccountHolderVerificationResultCode;
}({});
var $2f53fee15f29b056$export$22c799da09f6093d = /*#__PURE__*/ function(AccountHolderVerificationStatusCode) {
    /** The account holder was denied. See the results of the verification for more details. */ AccountHolderVerificationStatusCode["DENIED"] = "DENIED";
    /** The account holder passed the verification requirements. */ AccountHolderVerificationStatusCode["PASSED"] = "PASSED";
    /** The account holder is currently being verified. */ AccountHolderVerificationStatusCode["PENDING"] = "PENDING";
    return AccountHolderVerificationStatusCode;
}({});
var $2f53fee15f29b056$export$7e5f2447def43de = /*#__PURE__*/ function(AccountHolderVerificationStatusReasonCode) {
    /** The account holder was denied. See the results of the verification for more details. */ AccountHolderVerificationStatusReasonCode["DENIED"] = "DENIED";
    /** Documents are needed to verify the account holder. */ AccountHolderVerificationStatusReasonCode["DOCUMENT_UPLOAD_REQUIRED"] = "DOCUMENT_UPLOAD_REQUIRED";
    /** An identity update has been requested to correct the information provided on the application. */ AccountHolderVerificationStatusReasonCode["IDENTITY_UPDATE_REQUESTED"] = "IDENTITY_UPDATE_REQUESTED";
    /** The account holder is currently being reviewed. */ AccountHolderVerificationStatusReasonCode["IN_REVIEW"] = "IN_REVIEW";
    /** The account holder is required to answer automated questions to complete verification. */ AccountHolderVerificationStatusReasonCode["KBA_REQUIRED"] = "KBA_REQUIRED";
    /** The account holder passed the verification requirements. */ AccountHolderVerificationStatusReasonCode["PASSED"] = "PASSED";
    /** The account holder is currently being verified. */ AccountHolderVerificationStatusReasonCode["PENDING"] = "PENDING";
    /** A manual review of the account holder is required to continue the verification process. */ AccountHolderVerificationStatusReasonCode["REVIEW_REQUIRED"] = "REVIEW_REQUIRED";
    return AccountHolderVerificationStatusReasonCode;
}({});
var $2f53fee15f29b056$export$1f539ee894a7b300 = /*#__PURE__*/ function(AccountRelationshipStatus) {
    /** The account relationship is active. */ AccountRelationshipStatus["ACTIVE"] = "ACTIVE";
    /** The account relationship is inactive. */ AccountRelationshipStatus["INACTIVE"] = "INACTIVE";
    return AccountRelationshipStatus;
}({});
var $2f53fee15f29b056$export$57d59911ccd094e6 = /*#__PURE__*/ function(AccountRelationshipType) {
    /** Merchant Cash Advance relationship. */ AccountRelationshipType["MERCHANT_CASH_ADVANCE"] = "MERCHANT_CASH_ADVANCE";
    /** Visa Flexible Credential relationship. */ AccountRelationshipType["VISA_FLEXIBLE_CREDENTIAL"] = "VISA_FLEXIBLE_CREDENTIAL";
    return AccountRelationshipType;
}({});
var $2f53fee15f29b056$export$98fffa1e1610bf69 = /*#__PURE__*/ function(AccountingDirection) {
    /** Indicates a credit. The money is moving into an account. */ AccountingDirection["CREDIT"] = "CREDIT";
    /** Indicates a debit. The money is moving out of an account. */ AccountingDirection["DEBIT"] = "DEBIT";
    return AccountingDirection;
}({});
var $2f53fee15f29b056$export$2c49c45ea64d5380 = /*#__PURE__*/ function(AchHoldStatus) {
    /** ACH Transaction had a hold but it has been removed. */ AchHoldStatus["HOLD_REMOVED"] = "HOLD_REMOVED";
    /** ACH Transaction is not on hold. */ AchHoldStatus["NO_HOLDS"] = "NO_HOLDS";
    /** ACH Transaction is on hold. */ AchHoldStatus["ON_HOLD"] = "ON_HOLD";
    return AchHoldStatus;
}({});
var $2f53fee15f29b056$export$90e3775ed9c3c1dc = /*#__PURE__*/ function(AchHoldType) {
    /** ACH Transaction is on hold or had a hold because it was flagged for risk review */ AchHoldType["RISK"] = "RISK";
    /** UNSPECIFIED */ AchHoldType["UNSPECIFIED"] = "UNSPECIFIED";
    return AchHoldType;
}({});
var $2f53fee15f29b056$export$a39fbb78e6dedd19 = /*#__PURE__*/ function(AchTransferPurpose) {
    /** The `AchTransfer` is a deposit to a Highnote `FinancialAccount`. */ AchTransferPurpose["DEPOSIT"] = "DEPOSIT";
    /** The `AchTransfer` is a disbursement from a network settlement to a merchant account. */ AchTransferPurpose["MERCHANT_DISBURSEMENT"] = "MERCHANT_DISBURSEMENT";
    /** The `AchTransfer` is a merchant payout. */ AchTransferPurpose["MERCHANT_PAYOUT"] = "MERCHANT_PAYOUT";
    /** The `AchTransfer` is a disbursement from a Highnote `FinancialAccount` to a merchant funding account. */ AchTransferPurpose["MERCHANT_PUSH_PAYMENT_FUNDING"] = "MERCHANT_PUSH_PAYMENT_FUNDING";
    /** The `AchTransfer` is a payroll transfer. */ AchTransferPurpose["PAYROLL"] = "PAYROLL";
    /** The `AchTransfer` is a card balance repayment. */ AchTransferPurpose["REPAYMENT"] = "REPAYMENT";
    /** The `AchTransfer` is a secured deposit. */ AchTransferPurpose["SECURED_DEPOSIT"] = "SECURED_DEPOSIT";
    /** The `AchTransfer` is a withdrawal from a Highnote `FinancialAccount`. */ AchTransferPurpose["WITHDRAWAL"] = "WITHDRAWAL";
    return AchTransferPurpose;
}({});
var $2f53fee15f29b056$export$ec00092f3b5ebd6 = /*#__PURE__*/ function(AchTransferSign) {
    /** The `AchTransfer` yields an decrease of funds on the Highnote `FinancialAccount`. */ AchTransferSign["NEGATIVE"] = "NEGATIVE";
    /** The `AchTransfer` yields an increase of funds on the Highnote `FinancialAccount`. */ AchTransferSign["POSITIVE"] = "POSITIVE";
    return AchTransferSign;
}({});
var $2f53fee15f29b056$export$d122f82f4f0dfeb0 = /*#__PURE__*/ function(AchTransferStatusFailureReason) {
    /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */ AchTransferStatusFailureReason["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** R11 - The account does not support ACH. */ AchTransferStatusFailureReason["ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "ACH_CAPABLE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R11 - Loading funds via ACH is not supported. */ AchTransferStatusFailureReason["ACH_LOAD_NOT_ALLOWED_BY_PROGRAM"] = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM";
    /** R25 - The addenda record is invalid. */ AchTransferStatusFailureReason["ADDENDA_ERROR"] = "ADDENDA_ERROR";
    /** R19 - There is an error in the amount field. */ AchTransferStatusFailureReason["AMOUNT_FIELD_ERROR"] = "AMOUNT_FIELD_ERROR";
    /** R07 - The Authorization was revoked by Customer. */ AchTransferStatusFailureReason["AUTHORIZATION_REVOKED_BY_CUSTOMER"] = "AUTHORIZATION_REVOKED_BY_CUSTOMER";
    /** R11 - The account does not have the required balance constraint feature enabled. */ AchTransferStatusFailureReason["BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED"] = "BALANCE_CONSTRAIN_FEATURE_NOT_ENABLED";
    /** R15 - The beneficiary or account holder is deceased. */ AchTransferStatusFailureReason["BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED"] = "BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED";
    /** R12 - The receiving financial institution was acquired by another financial institution */ AchTransferStatusFailureReason["BRANCH_SOLD_TO_ANOTHER_DFI"] = "BRANCH_SOLD_TO_ANOTHER_DFI";
    /** R11 - The account does not have the required card funding account feature enabled. */ AchTransferStatusFailureReason["CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "CARD_FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required charge card feature enabled. */ AchTransferStatusFailureReason["CHARGE_CARD_FEATURE_NOT_ENABLED"] = "CHARGE_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required credit pay in full credit card feature enabled. */ AchTransferStatusFailureReason["COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required commercial pay in full account feature enabled. */ AchTransferStatusFailureReason["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required corporate bank account feature enabled. */ AchTransferStatusFailureReason["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R74 - The RDFI is returning a corrected entry. */ AchTransferStatusFailureReason["CORRECTED_RETURN"] = "CORRECTED_RETURN";
    /** R11 - The account does not have the required credit card feature enabled. */ AchTransferStatusFailureReason["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** R23 - The receiver has refused the credit entry. */ AchTransferStatusFailureReason["CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER"] = "CREDIT_ENTRY_REFUSED_BY_THE_RECEIVER";
    /** R11 - The credit limit is not set on the account. */ AchTransferStatusFailureReason["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** R11 - The account does not have the required DDA feature enabled. */ AchTransferStatusFailureReason["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required debit card feature enabled. */ AchTransferStatusFailureReason["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required direct merchant settlement feature enabled. */ AchTransferStatusFailureReason["DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED"] = "DIRECT_MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED";
    /** R47 - The RDFI received a duplicate enrollment for the same transaction. */ AchTransferStatusFailureReason["DUPLICATE_ENROLLMENT"] = "DUPLICATE_ENROLLMENT";
    /** R24 - The RDFI received a duplicate entry for the same transaction. */ AchTransferStatusFailureReason["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    /** R67 - The RDFI received a duplicate return for the same transaction. */ AchTransferStatusFailureReason["DUPLICATE_RETURN"] = "DUPLICATE_RETURN";
    /** R11 - The transfer is not in accordance with the terms of the authorization. */ AchTransferStatusFailureReason["ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION"] = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION";
    /** R84 - The entry was not processed by the gateway. */ AchTransferStatusFailureReason["ENTRY_NOT_PROCESSED_BY_GATEWAY"] = "ENTRY_NOT_PROCESSED_BY_GATEWAY";
    /** R62 - Funds cannot be pulled from receiving account. */ AchTransferStatusFailureReason["ERRONEOUS_OR_REVERSING_DEBIT"] = "ERRONEOUS_OR_REVERSING_DEBIT";
    /** R02 - The external account has been closed. */ AchTransferStatusFailureReason["EXTERNAL_ACCOUNT_CLOSED"] = "EXTERNAL_ACCOUNT_CLOSED";
    /** R16 - The external financial account is frozen. */ AchTransferStatusFailureReason["EXTERNAL_ACCOUNT_FROZEN"] = "EXTERNAL_ACCOUNT_FROZEN";
    /** R03 - No matching external account was found. */ AchTransferStatusFailureReason["EXTERNAL_ACCOUNT_NOT_FOUND"] = "EXTERNAL_ACCOUNT_NOT_FOUND";
    /** R69 - The entry contains multiple errors. */ AchTransferStatusFailureReason["FIELD_ERRORS"] = "FIELD_ERRORS";
    /** R17 - The transaction contains invalid fields initiated under questionable circumstances */ AchTransferStatusFailureReason["FILE_RECORD_EDIT_CRITERIA"] = "FILE_RECORD_EDIT_CRITERIA";
    /** R11 - The account does not have the required fleet feature enabled. */ AchTransferStatusFailureReason["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** R83 - The foreign receiving DFI is unable to settle the transaction. */ AchTransferStatusFailureReason["FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE"] = "FOREIGN_RECEIVING_DFI_UNABLE_TO_SETTLE";
    /** R11 - The account does not have the required funding account feature enabled. */ AchTransferStatusFailureReason["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required funding card feature enabled. */ AchTransferStatusFailureReason["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** R02 - The Highnote `FinancialAccount` has been closed. */ AchTransferStatusFailureReason["HIGHNOTE_ACCOUNT_CLOSED"] = "HIGHNOTE_ACCOUNT_CLOSED";
    /** R11 - The account does not have the required Highnote account feature enabled. */ AchTransferStatusFailureReason["HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED"] = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R16 - The Highnote `FinancialAccount` is frozen. */ AchTransferStatusFailureReason["HIGHNOTE_ACCOUNT_FROZEN"] = "HIGHNOTE_ACCOUNT_FROZEN";
    /** R03 - No matching Highnote `FinancialAccount` was found. */ AchTransferStatusFailureReason["HIGHNOTE_ACCOUNT_NOT_FOUND"] = "HIGHNOTE_ACCOUNT_NOT_FOUND";
    /** R80 - The IAT entry was coded incorrectly. */ AchTransferStatusFailureReason["IAT_ENTRY_CODING_ERRORS"] = "IAT_ENTRY_CODING_ERRORS";
    /** R18 - Has an Improper Effective entry date. */ AchTransferStatusFailureReason["IMPROPER_EFFECTIVE_ENTRY_DATE"] = "IMPROPER_EFFECTIVE_ENTRY_DATE";
    /** R39 - The source document for the transaction is invalid. */ AchTransferStatusFailureReason["IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT"] = "IMPROPER_SOURCE_DOCUMENT_OR_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT";
    /** R11 - The account does not have the required income account feature enabled. */ AchTransferStatusFailureReason["INCOME_ACCOUNT_FEATURE_NOT_ENABLED"] = "INCOME_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R85 - The outbound international payment was coded incorrectly by the ODFI. */ AchTransferStatusFailureReason["INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT"] = "INCORRECTLY_CODED_OUTBOUND_INTERNATIONAL_PAYMENT";
    /** R01 - This was a debit from an en external account did not have enough funds. */ AchTransferStatusFailureReason["INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT";
    /** R01 - This was a debit from an account at Highnote which did not have enough funds. */ AchTransferStatusFailureReason["INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT";
    /** There is an internal error with the transfer. */ AchTransferStatusFailureReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** R13 - The provided ACH routing number is invalid. */ AchTransferStatusFailureReason["INVALID_ACH_ROUTING_NUMBER"] = "INVALID_ACH_ROUTING_NUMBER";
    /** R21 - Has an Invalid Company ID Number. */ AchTransferStatusFailureReason["INVALID_COMPANY_ID_NUMBER"] = "INVALID_COMPANY_ID_NUMBER";
    /** R43 - The DFI account number provided is invalid. */ AchTransferStatusFailureReason["INVALID_DFI_ACCOUNT_NUMBER"] = "INVALID_DFI_ACCOUNT_NUMBER";
    /** R04 - The external financial account has an invalid account number. */ AchTransferStatusFailureReason["INVALID_EXTERNAL_ACCOUNT_NUMBER"] = "INVALID_EXTERNAL_ACCOUNT_NUMBER";
    /** R82 - The foreign receiving DFI identification is invalid. */ AchTransferStatusFailureReason["INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION"] = "INVALID_FOREIGN_RECEIVING_DFI_IDENTIFICATION";
    /** R04 - The Highnote `FinancialAccount` has an invalid account number. */ AchTransferStatusFailureReason["INVALID_HIGHNOTE_ACCOUNT_NUMBER"] = "INVALID_HIGHNOTE_ACCOUNT_NUMBER";
    /** R22 - Has an Invalid Individual ID Number. */ AchTransferStatusFailureReason["INVALID_INDIVIDUAL_ID_NUMBER"] = "INVALID_INDIVIDUAL_ID_NUMBER";
    /** R44 - The individual ID number or identification number provided is invalid. */ AchTransferStatusFailureReason["INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER"] = "INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER";
    /** R45 - The individual name or company name provided is invalid. */ AchTransferStatusFailureReason["INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME"] = "INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME";
    /** R46 - The representative payee indicator is invalid. */ AchTransferStatusFailureReason["INVALID_REPRESENTATIVE_PAYEE_INDICATOR"] = "INVALID_REPRESENTATIVE_PAYEE_INDICATOR";
    /** R41 - The transaction code provided is invalid. */ AchTransferStatusFailureReason["INVALID_TRANSACTION_CODE"] = "INVALID_TRANSACTION_CODE";
    /** R53 - Both the item and the ACH entry have been presented for payment. */ AchTransferStatusFailureReason["ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT"] = "ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT";
    /** R51 - The item is ineligible for RCK processing; the required notice was not provided. */ AchTransferStatusFailureReason["ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER"] = "ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER";
    /** R11 - The account does not have the required JIT feature enabled. */ AchTransferStatusFailureReason["JIT_FEATURE_NOT_ENABLED"] = "JIT_FEATURE_NOT_ENABLED";
    /** R34 - The RDFI’s participation in the ACH system is limited. */ AchTransferStatusFailureReason["LIMITED_PARTICIPATION_DFI"] = "LIMITED_PARTICIPATION_DFI";
    /** R26 - A mandatory field is invalid. */ AchTransferStatusFailureReason["MANDATORY_FIELD_ERROR"] = "MANDATORY_FIELD_ERROR";
    /** R71 - The dishonored return entry was misrouted. */ AchTransferStatusFailureReason["MISROUTED_DISHONORED_RETURN"] = "MISROUTED_DISHONORED_RETURN";
    /** R61 - The RDFI is returning an entry that was misrouted to them. */ AchTransferStatusFailureReason["MISROUTED_RETURN"] = "MISROUTED_RETURN";
    /** R11 - The account does not have the required negative balance reserve feature enabled. */ AchTransferStatusFailureReason["NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED"] = "NEGATIVE_BALANCE_RESERVE_FEATURE_NOT_ENABLED";
    /** R77 - The RDFI does not accept R62 dishonored return entries. */ AchTransferStatusFailureReason["NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN"] = "NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN";
    /** R81 - The RDFI does not participate in the IAT program. */ AchTransferStatusFailureReason["NON_PARTICIPANT_IN_IAT_PROGRAM"] = "NON_PARTICIPANT_IN_IAT_PROGRAM";
    /** R20 - Is a Non Transactional Account. */ AchTransferStatusFailureReason["NON_TRANSACTION_ACCOUNT"] = "NON_TRANSACTION_ACCOUNT";
    /** R11 - The account does not have the required non-verified bank account feature enabled. */ AchTransferStatusFailureReason["NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "NON_VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R76 - No errors were found in the return entry. */ AchTransferStatusFailureReason["NO_ERRORS_FOUND"] = "NO_ERRORS_FOUND";
    /** R11 - The program does not support ACH origination. */ AchTransferStatusFailureReason["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** R11 - The account does not have the required partial funding feature enabled. */ AchTransferStatusFailureReason["PARTIAL_FUNDING_FEATURE_NOT_ENABLED"] = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED";
    /** R08 - The Payment was stopped. */ AchTransferStatusFailureReason["PAYMENT_STOPPED"] = "PAYMENT_STOPPED";
    /** R11 - The account does not have the required payroll advance feature enabled. */ AchTransferStatusFailureReason["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required payroll employer advance feature enabled. */ AchTransferStatusFailureReason["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** R31 - The corporate receiver authorized the return of the entry. */ AchTransferStatusFailureReason["PERMISSIBLE_RETURN_ENTRY"] = "PERMISSIBLE_RETURN_ENTRY";
    /** R70 - The RDFI chose not to accept a permissible return entry or the return was not requested by the ODFI. */ AchTransferStatusFailureReason["PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI"] = "PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI";
    /** R11 - The account does not have the required points rewards feature enabled. */ AchTransferStatusFailureReason["POINT_REWARDS_FEATURE_NOT_ENABLED"] = "POINT_REWARDS_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required prepaid card feature enabled. */ AchTransferStatusFailureReason["PREPAID_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required preprinted card feature enabled. */ AchTransferStatusFailureReason["PREPRINTED_CARD_FEATURE_NOT_ENABLED"] = "PREPRINTED_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required product funding feature enabled. */ AchTransferStatusFailureReason["PRODUCT_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required product reserve feature enabled. */ AchTransferStatusFailureReason["PRODUCT_RESERVE_FEATURE_NOT_ENABLED"] = "PRODUCT_RESERVE_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required product secured deposit feature enabled. */ AchTransferStatusFailureReason["PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED"] = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED";
    /** R32 - The RDFI is not able to settle the transaction. */ AchTransferStatusFailureReason["RDFI_NON_SETTLEMENT"] = "RDFI_NON_SETTLEMENT";
    /** R30 - The RDFI does not participate in check truncation program. */ AchTransferStatusFailureReason["RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM"] = "RDFI_NOT_A_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM";
    /** R11 - The account does not have the required repayment account feature enabled. */ AchTransferStatusFailureReason["REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED"] = "REPAYMENT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R86 - Repayment account not present on product */ AchTransferStatusFailureReason["REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT"] = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT";
    /** R14 - The representative payee is deceased or unable to continue in that capacity. */ AchTransferStatusFailureReason["REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY"] = "REPRESENTATIVE_PAYEE_DECEASED_OR_UNABLE_TO_CONTINUE_IN_THAT_CAPACITY";
    /** R06 - Funds were returned per ODFI Request. */ AchTransferStatusFailureReason["RETURNED_PER_ODFI_REQUEST"] = "RETURNED_PER_ODFI_REQUEST";
    /** R75 - The return entry is not a duplicate of an earlier return. */ AchTransferStatusFailureReason["RETURN_NOT_A_DUPLICATE"] = "RETURN_NOT_A_DUPLICATE";
    /** R40 - The ENR entry is being returned by federal government agency. */ AchTransferStatusFailureReason["RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY"] = "RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY";
    /** R36 - The transaction is an improper credit entry according to NACHA rules. */ AchTransferStatusFailureReason["RETURN_OF_IMPROPER_CREDIT_ENTRY"] = "RETURN_OF_IMPROPER_CREDIT_ENTRY";
    /** R35 - The transaction is an improper debit entry according to NACHA rules. */ AchTransferStatusFailureReason["RETURN_OF_IMPROPER_DEBIT_ENTRY"] = "RETURN_OF_IMPROPER_DEBIT_ENTRY";
    /** R33 - The RDFI is returning an XCK (destroyed check) entry. */ AchTransferStatusFailureReason["RETURN_OF_XCK_ENTRY"] = "RETURN_OF_XCK_ENTRY";
    /** R11 - The account does not have the required revolving card feature enabled. */ AchTransferStatusFailureReason["REVOLVING_CARD_FEATURE_NOT_ENABLED"] = "REVOLVING_CARD_FEATURE_NOT_ENABLED";
    /** R28 - The routing number provided contains an invalid check digit. */ AchTransferStatusFailureReason["ROUTING_NUMBER_CHECK_DIGIT_ERROR"] = "ROUTING_NUMBER_CHECK_DIGIT_ERROR";
    /** R42 - The routing number or check digit is invalid. */ AchTransferStatusFailureReason["ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR"] = "ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR";
    /** R11 - The account does not have the required secured credit card feature enabled. */ AchTransferStatusFailureReason["SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED"] = "SECURED_CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** R11 - The account does not have the required secured deposit feature enabled. */ AchTransferStatusFailureReason["SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED"] = "SECURED_DEPOSIT_ACCOUNT_NOT_ENABLED";
    /** R11 - The account does not have the required secure card feature enabled. */ AchTransferStatusFailureReason["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** R37 - The source document for the transaction was presented for payment. */ AchTransferStatusFailureReason["SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT"] = "SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT";
    /** R50 - State law prohibits the RDFI from accepting RCK entries. */ AchTransferStatusFailureReason["STATE_LAW_AFFECTING_RCK_ACCEPTANCE"] = "STATE_LAW_AFFECTING_RCK_ACCEPTANCE";
    /** R52 - The receiver requested a stop payment on the item. */ AchTransferStatusFailureReason["STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY"] = "STOP_PAYMENT_ON_ITEM_RELATED_TO_RCK_ENTRY";
    /** R38 - A stop payment was placed on the source document of the transaction. */ AchTransferStatusFailureReason["STOP_PAYMENT_ON_SOURCE_DOCUMENT"] = "STOP_PAYMENT_ON_SOURCE_DOCUMENT";
    /** R73 - The RDFI received a timely original return entry. */ AchTransferStatusFailureReason["TIMELY_ORIGINAL_RETURN"] = "TIMELY_ORIGINAL_RETURN";
    /** R27 - The trace number provided is invalid. */ AchTransferStatusFailureReason["TRACE_NUMBER_ERROR"] = "TRACE_NUMBER_ERROR";
    /** R29 - The Transaction was not Authorized By Account Holder. */ AchTransferStatusFailureReason["TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER"] = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER";
    /** R11 - The transfer was rejected by the originating partner bank. */ AchTransferStatusFailureReason["TRANSACTION_REJECTED_BY_PARTNER_BANK"] = "TRANSACTION_REJECTED_BY_PARTNER_BANK";
    /** R11 - The transfer amount is below the minimum program reload limit. */ AchTransferStatusFailureReason["TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT";
    /** R11 - The transfer amount exceeds the maximum program load limit. */ AchTransferStatusFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** R11 - The transfer amount exceeds the maximum program reload limit. */ AchTransferStatusFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT";
    /** R11 - The transfer amount is negative. */ AchTransferStatusFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE"] = "TRANSFER_AMOUNT_IS_NEGATIVE";
    /** R11 - The transfer amount is negative or zero. */ AchTransferStatusFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** R11 - The product does not support transfer between provided accounts. */ AchTransferStatusFailureReason["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */ AchTransferStatusFailureReason["UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE"] = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE";
    /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */ AchTransferStatusFailureReason["UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION"] = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION";
    /** R09 - Transaction represents Uncollected Funds. */ AchTransferStatusFailureReason["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    /** R72 - The dishonored return entry was received after the deadline. */ AchTransferStatusFailureReason["UNTIMELY_DISHONORED_RETURN"] = "UNTIMELY_DISHONORED_RETURN";
    /** R68 - The return was received after the deadline. */ AchTransferStatusFailureReason["UNTIMELY_RETURN"] = "UNTIMELY_RETURN";
    /** R11 - The account does not have the required verified bank account feature enabled. */ AchTransferStatusFailureReason["VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "VERIFIED_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    return AchTransferStatusFailureReason;
}({});
var $2f53fee15f29b056$export$ac9936370f0a7b30 = /*#__PURE__*/ function(AchTransferType) {
    /** The `AchTransfer` is a pull transfer. This means pulling funds from the receiving financial institution to the originating financial institution. */ AchTransferType["PULL"] = "PULL";
    /** The `AchTransfer` is a push transfer. This means pushing funds from the originating financial institution to the receiving financial institution. */ AchTransferType["PUSH"] = "PUSH";
    return AchTransferType;
}({});
var $2f53fee15f29b056$export$eae5a028bc94de79 = /*#__PURE__*/ function(AcquirerNetwork) {
    /** American Express */ AcquirerNetwork["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    /** Discover */ AcquirerNetwork["DISCOVER"] = "DISCOVER";
    /** Highnote payment processing */ AcquirerNetwork["HIGHNOTE"] = "HIGHNOTE";
    /** Interlink Network */ AcquirerNetwork["INTERLINK"] = "INTERLINK";
    /** Maestro */ AcquirerNetwork["MAESTRO"] = "MAESTRO";
    /** Mastercard */ AcquirerNetwork["MASTERCARD"] = "MASTERCARD";
    /** MNGS Discover */ AcquirerNetwork["MNGS_DISCOVER"] = "MNGS_DISCOVER";
    /** MNGS Pulse */ AcquirerNetwork["MNGS_PULSE"] = "MNGS_PULSE";
    /** American Express via Payroc */ AcquirerNetwork["PAYROC_AMERICAN_EXPRESS"] = "PAYROC_AMERICAN_EXPRESS";
    /** Pulse */ AcquirerNetwork["PULSE"] = "PULSE";
    /** Visa Network */ AcquirerNetwork["VISA"] = "VISA";
    return AcquirerNetwork;
}({});
var $2f53fee15f29b056$export$f42ef63b0e951272 = /*#__PURE__*/ function(AcquiringPaymentCardBrand) {
    /** The payment card belongs to the American Express brand. */ AcquiringPaymentCardBrand["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    /** The payment card belongs to the Diners Club brand. */ AcquiringPaymentCardBrand["DINERS_CLUB"] = "DINERS_CLUB";
    /** The payment card belongs to the Discover brand. */ AcquiringPaymentCardBrand["DISCOVER"] = "DISCOVER";
    /** The payment card belongs to the JCB brand. */ AcquiringPaymentCardBrand["JCB"] = "JCB";
    /** The payment card belongs to the Maestro brand. */ AcquiringPaymentCardBrand["MAESTRO"] = "MAESTRO";
    /** The payment card belongs to the Mastercard brand. */ AcquiringPaymentCardBrand["MASTERCARD"] = "MASTERCARD";
    /** The payment card belongs to the UnionPay brand. */ AcquiringPaymentCardBrand["UNIONPAY"] = "UNIONPAY";
    /** The payment card brand is unknown. */ AcquiringPaymentCardBrand["UNKNOWN"] = "UNKNOWN";
    /** The payment card belongs to the Visa brand. */ AcquiringPaymentCardBrand["VISA"] = "VISA";
    return AcquiringPaymentCardBrand;
}({});
var $2f53fee15f29b056$export$92d6d524b9f85acd = /*#__PURE__*/ function(AcquiringPaymentInitiator) {
    /** The payment method was submitted to the merchant with an agreement to use the payment method for installment payments. */ AcquiringPaymentInitiator["CUSTOMER_INITIATED_INSTALLMENT_FIRST"] = "CUSTOMER_INITIATED_INSTALLMENT_FIRST";
    /** The payment method was submitted to the merchant with an agreement to store the payment method for recurring payments. */ AcquiringPaymentInitiator["CUSTOMER_INITIATED_RECURRING_FIRST"] = "CUSTOMER_INITIATED_RECURRING_FIRST";
    /** The payment method was submitted to the merchant over mail order, or telephone. */ AcquiringPaymentInitiator["CUSTOMER_INITIATED_VIA_MAIL_ORDER_OR_TELEPHONE_ORDER"] = "CUSTOMER_INITIATED_VIA_MAIL_ORDER_OR_TELEPHONE_ORDER";
    /** The payment method was submitted to the merchant on the web. */ AcquiringPaymentInitiator["CUSTOMER_INITIATED_VIA_WEB"] = "CUSTOMER_INITIATED_VIA_WEB";
    /** The merchant is using a customer's stored payment method and the payment is for installment payments. */ AcquiringPaymentInitiator["MERCHANT_INITIATED_INSTALLMENT"] = "MERCHANT_INITIATED_INSTALLMENT";
    /**
   * The merchant is using a customer's stored payment method and the payment is recurring.
   *
   * An example of this is paying for a subscription.
   */ AcquiringPaymentInitiator["MERCHANT_INITIATED_RECURRING"] = "MERCHANT_INITIATED_RECURRING";
    /**
   * The merchant is using a customer's stored payment method and the payment is recurring.
   *
   * An example of this is paying for a subscription.
   * @deprecated use MERCHANT_INITIATED_RECURRING
   */ AcquiringPaymentInitiator["MERCHANT_INITIATED_TRANSACTION_RECURRING"] = "MERCHANT_INITIATED_TRANSACTION_RECURRING";
    /**
   * The merchant is using a customer's stored payment method and the payment is unscheduled.
   *
   * An example of when to use this would be reloading a balance or collecting payment after conditions have been met to take payment.
   * @deprecated use MERCHANT_INITIATED_UNSCHEDULED
   */ AcquiringPaymentInitiator["MERCHANT_INITIATED_TRANSACTION_UNSCHEDULED"] = "MERCHANT_INITIATED_TRANSACTION_UNSCHEDULED";
    /**
   * The merchant is using a customer's stored payment method and the payment is unscheduled.
   *
   * An example of when to use this would be reloading a balance or collecting payment after conditions have been met to take payment.
   */ AcquiringPaymentInitiator["MERCHANT_INITIATED_UNSCHEDULED"] = "MERCHANT_INITIATED_UNSCHEDULED";
    return AcquiringPaymentInitiator;
}({});
var $2f53fee15f29b056$export$5138bccc9f2d2961 = /*#__PURE__*/ function(AcquiringProviderType) {
    /** Cross River Bank */ AcquiringProviderType["CRB"] = "CRB";
    /** Highnote */ AcquiringProviderType["HIGHNOTE"] = "HIGHNOTE";
    /** Payroc */ AcquiringProviderType["PAYROC"] = "PAYROC";
    return AcquiringProviderType;
}({});
var $2f53fee15f29b056$export$5a8126faafbbb6bc = /*#__PURE__*/ function(AddressComponent) {
    /** The country code where the address resides. */ AddressComponent["COUNTRY_CODE_ALPHA_3"] = "COUNTRY_CODE_ALPHA_3";
    /** Additional data about the address, e.g. apartment or unit number. */ AddressComponent["EXTENDED_ADDRESS"] = "EXTENDED_ADDRESS";
    /** The locality of the address, e.g. town or city. */ AddressComponent["LOCALITY"] = "LOCALITY";
    /** The postal code of the address. */ AddressComponent["POSTAL_CODE"] = "POSTAL_CODE";
    /** A region for the address, e.g. state or province. */ AddressComponent["REGION"] = "REGION";
    /** The number and street of the address. */ AddressComponent["STREET_ADDRESS"] = "STREET_ADDRESS";
    return AddressComponent;
}({});
var $2f53fee15f29b056$export$664bd0ca44b25127 = /*#__PURE__*/ function(AddressDeliveryStatus) {
    /** The address delivery point is confirmed. */ AddressDeliveryStatus["CONFIRMED"] = "CONFIRMED";
    /** The address delivery point information is not available. */ AddressDeliveryStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    /** The primary address delivery point is confirmed, but the secondary address (e.g., apartment or unit) is missing or not confirmed. */ AddressDeliveryStatus["PARTIAL"] = "PARTIAL";
    /** The address delivery point could not be confirmed. */ AddressDeliveryStatus["UNCONFIRMED"] = "UNCONFIRMED";
    return AddressDeliveryStatus;
}({});
var $2f53fee15f29b056$export$40cfcf4e0484f65c = /*#__PURE__*/ function(AddressTokenScope) {
    /** The token can be used multiple times. */ AddressTokenScope["MULTI_USE"] = "MULTI_USE";
    /**
   * Represents a single-use token for accessing a Customer Attribute.
   *
   * Description: The generated token can only be used once. After the token is either consumed in an API call or has expired,
   * it becomes invalid.
   *
   * Constraints:
   * - Single-use only — a token cannot be reused.
   * - A new token must be generated once the previous token is used or expires.
   * - Tokens are required to access Customer Attributes in other APIs.
   *
   * Example:
   * 1. Generate a token for a Customer Attribute.
   * 2. Use the token in a downstream API request.
   * 3. Once used or expired, generate a new token before making another request.
   */ AddressTokenScope["SINGLE_USE"] = "SINGLE_USE";
    return AddressTokenScope;
}({});
var $2f53fee15f29b056$export$ab48b5d0e3b9d727 = /*#__PURE__*/ function(AdverseActionCode) {
    /** Bankruptcy */ AdverseActionCode["BANKRUPTCY"] = "BANKRUPTCY";
    /** Collections action or judgment */ AdverseActionCode["COLLECTIONS"] = "COLLECTIONS";
    /** The cardholder is deceased. */ AdverseActionCode["DECEASED"] = "DECEASED";
    /** Delinquent past or present credit obligations */ AdverseActionCode["DELINQUENT_CREDIT_OBLIGATIONS"] = "DELINQUENT_CREDIT_OBLIGATIONS";
    /** Applicant has excessive debt obligations */ AdverseActionCode["EXCESSIVE_DEBT_OBLIGATIONS"] = "EXCESSIVE_DEBT_OBLIGATIONS";
    /** The cardholder has excessive payment obligations in relation to their income. */ AdverseActionCode["EXCESSIVE_OBLIGATIONS_TO_INCOME"] = "EXCESSIVE_OBLIGATIONS_TO_INCOME";
    /** High credit utilization ratio */ AdverseActionCode["HIGH_UTILIZATION"] = "HIGH_UTILIZATION";
    /** Incomplete company or owners’ identity information */ AdverseActionCode["INCOMPLETE_IDENTITY_INFORMATION"] = "INCOMPLETE_IDENTITY_INFORMATION";
    /** Applicant cash or liquid balances are insufficient to support the credit request. */ AdverseActionCode["INSUFFICIENT_CASH_BALANCES"] = "INSUFFICIENT_CASH_BALANCES";
    /** Income insufficient for the amount of credit requested */ AdverseActionCode["INSUFFICIENT_INCOME"] = "INSUFFICIENT_INCOME";
    /** Applicant revenue does not meet the minimum required threshold. */ AdverseActionCode["INSUFFICIENT_REVENUE"] = "INSUFFICIENT_REVENUE";
    /** Length of employment is limited or unstable */ AdverseActionCode["LENGTH_OF_EMPLOYMENT"] = "LENGTH_OF_EMPLOYMENT";
    /** Length of time at residence is limited or unstable */ AdverseActionCode["LENGTH_OF_RESIDENCE"] = "LENGTH_OF_RESIDENCE";
    /** Does not meet lien position requirement */ AdverseActionCode["LIEN_POSITION"] = "LIEN_POSITION";
    /** Applicant has limited credit references or history */ AdverseActionCode["LIMITED_CREDIT_EXPERIENCE"] = "LIMITED_CREDIT_EXPERIENCE";
    /** Applicant credit score does not meet the minimum score requirements */ AdverseActionCode["MIN_CREDIT_SCORE"] = "MIN_CREDIT_SCORE";
    /** Does not meet the minimum length of business incorporation */ AdverseActionCode["MIN_YEARS_INCORPORATION"] = "MIN_YEARS_INCORPORATION";
    /** Too many accounts opened recently */ AdverseActionCode["RECENT_CREDIT_ACCOUNTS"] = "RECENT_CREDIT_ACCOUNTS";
    /** Too many recent credit applications */ AdverseActionCode["RECENT_CREDIT_APPLICATIONS"] = "RECENT_CREDIT_APPLICATIONS";
    /** Unable to verify applicant's credit references */ AdverseActionCode["UNABLE_TO_VERIFY_CREDIT_REFERENCES"] = "UNABLE_TO_VERIFY_CREDIT_REFERENCES";
    /** Unable to verify applicant's employment */ AdverseActionCode["UNABLE_TO_VERIFY_EMPLOYMENT"] = "UNABLE_TO_VERIFY_EMPLOYMENT";
    /** Unable to verify the Account Holder's identity. */ AdverseActionCode["UNABLE_TO_VERIFY_IDENTITY"] = "UNABLE_TO_VERIFY_IDENTITY";
    /** Unable to verify applicant’s income */ AdverseActionCode["UNABLE_TO_VERIFY_INCOME"] = "UNABLE_TO_VERIFY_INCOME";
    /** We do not offer credit to this industry */ AdverseActionCode["UNACCEPTED_BUSINESS_INDUSTRY"] = "UNACCEPTED_BUSINESS_INDUSTRY";
    /** The account holder has withdrawn their card product application */ AdverseActionCode["WITHDRAWN"] = "WITHDRAWN";
    return AdverseActionCode;
}({});
var $2f53fee15f29b056$export$77a92c0e6b1f9993 = /*#__PURE__*/ function(AdverseActionCodeInput) {
    /** Bankruptcy */ AdverseActionCodeInput["BANKRUPTCY"] = "BANKRUPTCY";
    /** Collections action or judgment */ AdverseActionCodeInput["COLLECTIONS"] = "COLLECTIONS";
    /** Delinquent past or present credit obligations */ AdverseActionCodeInput["DELINQUENT_CREDIT_OBLIGATIONS"] = "DELINQUENT_CREDIT_OBLIGATIONS";
    /** Applicant has excessive debt obligations */ AdverseActionCodeInput["EXCESSIVE_DEBT_OBLIGATIONS"] = "EXCESSIVE_DEBT_OBLIGATIONS";
    /** Applicant has excessive payment obligations in relation to their income */ AdverseActionCodeInput["EXCESSIVE_OBLIGATIONS_TO_INCOME"] = "EXCESSIVE_OBLIGATIONS_TO_INCOME";
    /** High credit utilization ratio */ AdverseActionCodeInput["HIGH_UTILIZATION"] = "HIGH_UTILIZATION";
    /** Incomplete company or owners’ identity information */ AdverseActionCodeInput["INCOMPLETE_IDENTITY_INFORMATION"] = "INCOMPLETE_IDENTITY_INFORMATION";
    /** Applicant cash or liquid balances are insufficient to support the credit request. */ AdverseActionCodeInput["INSUFFICIENT_CASH_BALANCES"] = "INSUFFICIENT_CASH_BALANCES";
    /** Income insufficient for the amount of credit requested */ AdverseActionCodeInput["INSUFFICIENT_INCOME"] = "INSUFFICIENT_INCOME";
    /** Applicant revenue does not meet the minimum required threshold. */ AdverseActionCodeInput["INSUFFICIENT_REVENUE"] = "INSUFFICIENT_REVENUE";
    /** Length of employment is limited or unstable */ AdverseActionCodeInput["LENGTH_OF_EMPLOYMENT"] = "LENGTH_OF_EMPLOYMENT";
    /** Length of time at residence is limited or unstable */ AdverseActionCodeInput["LENGTH_OF_RESIDENCE"] = "LENGTH_OF_RESIDENCE";
    /** Does not meet lien position requirement */ AdverseActionCodeInput["LIEN_POSITION"] = "LIEN_POSITION";
    /** Applicant has limited credit references or history */ AdverseActionCodeInput["LIMITED_CREDIT_EXPERIENCE"] = "LIMITED_CREDIT_EXPERIENCE";
    /** Applicant credit score does not meet the minimum score requirements */ AdverseActionCodeInput["MIN_CREDIT_SCORE"] = "MIN_CREDIT_SCORE";
    /** Does not meet the minimum length of business incorporation */ AdverseActionCodeInput["MIN_YEARS_INCORPORATION"] = "MIN_YEARS_INCORPORATION";
    /** Too many accounts opened recently */ AdverseActionCodeInput["RECENT_CREDIT_ACCOUNTS"] = "RECENT_CREDIT_ACCOUNTS";
    /** Too many recent credit applications */ AdverseActionCodeInput["RECENT_CREDIT_APPLICATIONS"] = "RECENT_CREDIT_APPLICATIONS";
    /** Unable to verify applicant's credit references */ AdverseActionCodeInput["UNABLE_TO_VERIFY_CREDIT_REFERENCES"] = "UNABLE_TO_VERIFY_CREDIT_REFERENCES";
    /** Unable to verify applicant's employment */ AdverseActionCodeInput["UNABLE_TO_VERIFY_EMPLOYMENT"] = "UNABLE_TO_VERIFY_EMPLOYMENT";
    /** Unable to verify the Account Holder's identity. */ AdverseActionCodeInput["UNABLE_TO_VERIFY_IDENTITY"] = "UNABLE_TO_VERIFY_IDENTITY";
    /** Unable to verify applicant’s income */ AdverseActionCodeInput["UNABLE_TO_VERIFY_INCOME"] = "UNABLE_TO_VERIFY_INCOME";
    /** We do not offer credit to this industry */ AdverseActionCodeInput["UNACCEPTED_BUSINESS_INDUSTRY"] = "UNACCEPTED_BUSINESS_INDUSTRY";
    /** The account holder has withdrawn their card product application */ AdverseActionCodeInput["WITHDRAWN"] = "WITHDRAWN";
    return AdverseActionCodeInput;
}({});
var $2f53fee15f29b056$export$e3d33b48cd1ced5f = /*#__PURE__*/ function(AdvertisingMethod) {
    /** Catalog and/or publications */ AdvertisingMethod["CATALOG_PUBLICATIONS"] = "CATALOG_PUBLICATIONS";
    /** Internet */ AdvertisingMethod["INTERNET"] = "INTERNET";
    /** Mass/Direct mail */ AdvertisingMethod["MASS_DIRECT_MAIL"] = "MASS_DIRECT_MAIL";
    /** Telemarketing */ AdvertisingMethod["TELEMARKETING"] = "TELEMARKETING";
    /** Word of mouth */ AdvertisingMethod["WORD_OF_MOUTH"] = "WORD_OF_MOUTH";
    /** Yellow pages */ AdvertisingMethod["YELLOW_PAGES"] = "YELLOW_PAGES";
    return AdvertisingMethod;
}({});
var $2f53fee15f29b056$export$8fd383f40308b2f7 = /*#__PURE__*/ function(ApplicableRuleUserType) {
    /** The associated rule will be evaluated for the authorized user. */ ApplicableRuleUserType["AUTHORIZED_USER"] = "AUTHORIZED_USER";
    return ApplicableRuleUserType;
}({});
var $2f53fee15f29b056$export$4b76e7cd09dbba24 = /*#__PURE__*/ function(ApplicationDenialReason) {
    /** The Application was denied due to the inability to decision on the Application within the timeframe as defined in the cardholder agreement due to missing information. */ ApplicationDenialReason["DENIED_DUE_TO_APPLICATION_INACTIVITY"] = "DENIED_DUE_TO_APPLICATION_INACTIVITY";
    /** The Application was denied due to other factors. */ ApplicationDenialReason["DENIED_DUE_TO_OTHER"] = "DENIED_DUE_TO_OTHER";
    return ApplicationDenialReason;
}({});
var $2f53fee15f29b056$export$144fce312cfe9747 = /*#__PURE__*/ function(ApplicationDocumentReviewReason) {
    /** The document uploaded is a blank document. */ ApplicationDocumentReviewReason["BLANK_DOCUMENT"] = "BLANK_DOCUMENT";
    /** The document uploaded is a duplicate of a previously uploaded document. */ ApplicationDocumentReviewReason["DUPLICATE_DOCUMENT"] = "DUPLICATE_DOCUMENT";
    /** The document uploaded is outdated or expired. */ ApplicationDocumentReviewReason["EXPIRED_DOCUMENT"] = "EXPIRED_DOCUMENT";
    /** The document uploaded is blurry or uneasy to read. */ ApplicationDocumentReviewReason["ILLEGIBLE_DOCUMENT"] = "ILLEGIBLE_DOCUMENT";
    /** The document uploaded does not meet the necessary business or person verification requirements */ ApplicationDocumentReviewReason["INCORRECT_DOCUMENT"] = "INCORRECT_DOCUMENT";
    /** The document uploaded is not a full or complete document - there may be missing information. */ ApplicationDocumentReviewReason["PARTIAL_DOCUMENT"] = "PARTIAL_DOCUMENT";
    /** The document uploaded could not have its authenticity verified. */ ApplicationDocumentReviewReason["UNACCEPTABLE_DOCUMENT"] = "UNACCEPTABLE_DOCUMENT";
    return ApplicationDocumentReviewReason;
}({});
var $2f53fee15f29b056$export$e83ea38f57906d14 = /*#__PURE__*/ function(ApplicationDocumentUploadSessionStatus) {
    /** The document upload session is created but has not been initiated. */ ApplicationDocumentUploadSessionStatus["CREATED"] = "CREATED";
    /**
   * A session has expired due to inactivity. A session can result in an expired state if it is never transitioned to submitted.
   * Files can no longer be attached to the application's document upload session.
   *
   * **Note: ** This is a terminal state.
   */ ApplicationDocumentUploadSessionStatus["EXPIRED"] = "EXPIRED";
    /**
   * A review has been submitted by a Highnote Agent and the review of the files are complete. A decision has been made for the application's status.
   *
   * **Note: ** This is a terminal state.
   */ ApplicationDocumentUploadSessionStatus["SUBMITTED"] = "SUBMITTED";
    return ApplicationDocumentUploadSessionStatus;
}({});
var $2f53fee15f29b056$export$b919ba1dee696ae0 = /*#__PURE__*/ function(ApplicationDocumentUploadStatus) {
    /** The document has been approved by a Highnote Agent */ ApplicationDocumentUploadStatus["APPROVED"] = "APPROVED";
    /** The document has been denied by a Highnote Agent */ ApplicationDocumentUploadStatus["DENIED"] = "DENIED";
    /** The document is in review by a Highnote Agent */ ApplicationDocumentUploadStatus["IN_REVIEW"] = "IN_REVIEW";
    /** The document has been uploaded by the applicant and is awaiting verification processing */ ApplicationDocumentUploadStatus["UPLOADED"] = "UPLOADED";
    return ApplicationDocumentUploadStatus;
}({});
var $2f53fee15f29b056$export$83d7e6ddd9582c6e = /*#__PURE__*/ function(AttachedLevel) {
    /** ACCOUNT */ AttachedLevel["ACCOUNT"] = "ACCOUNT";
    /** CARD */ AttachedLevel["CARD"] = "CARD";
    /** PLATFORM */ AttachedLevel["PLATFORM"] = "PLATFORM";
    /** PRODUCT */ AttachedLevel["PRODUCT"] = "PRODUCT";
    /** UNSPECIFIED */ AttachedLevel["UNSPECIFIED"] = "UNSPECIFIED";
    return AttachedLevel;
}({});
var $2f53fee15f29b056$export$516c4c5f3baf873 = /*#__PURE__*/ function(AuthorizedAccountHolderRelationshipStatus) {
    /** The relationship is currently active and valid. */ AuthorizedAccountHolderRelationshipStatus["ACTIVE"] = "ACTIVE";
    /** The relationship is inactive or has been revoked. */ AuthorizedAccountHolderRelationshipStatus["INACTIVE"] = "INACTIVE";
    return AuthorizedAccountHolderRelationshipStatus;
}({});
var $2f53fee15f29b056$export$3c8079d45dc44de2 = /*#__PURE__*/ function(AuthorizedUserApplicationStatusCode) {
    /** The application was approved. */ AuthorizedUserApplicationStatusCode["APPROVED"] = "APPROVED";
    /** The application was closed. */ AuthorizedUserApplicationStatusCode["CLOSED"] = "CLOSED";
    /** The application was denied. */ AuthorizedUserApplicationStatusCode["DENIED"] = "DENIED";
    /** The application requires further review. */ AuthorizedUserApplicationStatusCode["IN_REVIEW"] = "IN_REVIEW";
    /** The application is currently being processed. */ AuthorizedUserApplicationStatusCode["PENDING"] = "PENDING";
    return AuthorizedUserApplicationStatusCode;
}({});
var $2f53fee15f29b056$export$6568ec4fe366cd0b = /*#__PURE__*/ function(BalanceType) {
    /** Plan and statement entries are based on the PURCHASE balance Type. */ BalanceType["PURCHASE"] = "PURCHASE";
    return BalanceType;
}({});
var $2f53fee15f29b056$export$4809700e1481f601 = /*#__PURE__*/ function(BankAccountType) {
    /** Checking bank account. */ BankAccountType["CHECKING"] = "CHECKING";
    /** Saving bank account. */ BankAccountType["SAVINGS"] = "SAVINGS";
    return BankAccountType;
}({});
var $2f53fee15f29b056$export$8064a463be2b1735 = /*#__PURE__*/ function(BankName) {
    /** The value representing CFSB. */ BankName["CFSB_BANK"] = "CFSB_BANK";
    /** The value representing Cross River Bank. */ BankName["CROSS_RIVER_BANK"] = "CROSS_RIVER_BANK";
    /** The value representing Sutton Bank. */ BankName["SUTTON_BANK"] = "SUTTON_BANK";
    return BankName;
}({});
var $2f53fee15f29b056$export$e20ade93389cb05b = /*#__PURE__*/ function(BankVerificationProvider) {
    /** FINICITY */ BankVerificationProvider["FINICITY"] = "FINICITY";
    /** PLAID */ BankVerificationProvider["PLAID"] = "PLAID";
    /** PLAID_RESELLER */ BankVerificationProvider["PLAID_RESELLER"] = "PLAID_RESELLER";
    /** SIMULATED */ BankVerificationProvider["SIMULATED"] = "SIMULATED";
    /** UNSPECIFIED */ BankVerificationProvider["UNSPECIFIED"] = "UNSPECIFIED";
    return BankVerificationProvider;
}({});
var $2f53fee15f29b056$export$5f3edf7d82bc0970 = /*#__PURE__*/ function(BillingCycleType) {
    BillingCycleType["BIWEEKLY"] = "BIWEEKLY";
    BillingCycleType["MONTHLY"] = "MONTHLY";
    BillingCycleType["WEEKLY"] = "WEEKLY";
    return BillingCycleType;
}({});
var $2f53fee15f29b056$export$b9bb041b16fd1c16 = /*#__PURE__*/ function(BusinessAccountHolderClientTokenPermission) {
    /**
   * Read the business account holder information.
   *
   * Setting this permission will allow visibility to the account holder's information.
   */ BusinessAccountHolderClientTokenPermission["READ_BUSINESS_ACCOUNT_HOLDER_DETAILS"] = "READ_BUSINESS_ACCOUNT_HOLDER_DETAILS";
    return BusinessAccountHolderClientTokenPermission;
}({});
var $2f53fee15f29b056$export$b3f5773ccce0d57e = /*#__PURE__*/ function(BusinessAccountHolderIdentityUpdateType) {
    /** The annual revenue was modified. */ BusinessAccountHolderIdentityUpdateType["ANNUAL_REVENUE"] = "ANNUAL_REVENUE";
    /** The billing address was modified. */ BusinessAccountHolderIdentityUpdateType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    /** The employer identification number was modified. */ BusinessAccountHolderIdentityUpdateType["EMPLOYER_IDENTIFICATION_NUMBER"] = "EMPLOYER_IDENTIFICATION_NUMBER";
    /** The legal business name was modified. */ BusinessAccountHolderIdentityUpdateType["LEGAL_BUSINESS_NAME"] = "LEGAL_BUSINESS_NAME";
    return BusinessAccountHolderIdentityUpdateType;
}({});
var $2f53fee15f29b056$export$fc4c121973572c73 = /*#__PURE__*/ function(BusinessAssociatedPersonIdentityUpdateType) {
    /** The date of birth was modified. */ BusinessAssociatedPersonIdentityUpdateType["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    /** The full legal name was modified. */ BusinessAssociatedPersonIdentityUpdateType["FULL_LEGAL_NAME"] = "FULL_LEGAL_NAME";
    /** The home address was modified. */ BusinessAssociatedPersonIdentityUpdateType["HOME_ADDRESS"] = "HOME_ADDRESS";
    /** The social security number was modified. */ BusinessAssociatedPersonIdentityUpdateType["SOCIAL_SECURITY_NUMBER"] = "SOCIAL_SECURITY_NUMBER";
    return BusinessAssociatedPersonIdentityUpdateType;
}({});
var $2f53fee15f29b056$export$ade71168f32d9b4c = /*#__PURE__*/ function(BusinessCustomerInteractionMethod) {
    /** A business selling goods/services at a physical location. */ BusinessCustomerInteractionMethod["IN_PERSON"] = "IN_PERSON";
    /** A business selling goods/services through mail or telephone orders. */ BusinessCustomerInteractionMethod["MAIL_ORDER_TELEPHONE_ORDER"] = "MAIL_ORDER_TELEPHONE_ORDER";
    /** A business selling goods/services via an Android or iOS app. */ BusinessCustomerInteractionMethod["MOBILE"] = "MOBILE";
    /** An eCommerce business with a website selling goods/services. */ BusinessCustomerInteractionMethod["ONLINE"] = "ONLINE";
    return BusinessCustomerInteractionMethod;
}({});
var $2f53fee15f29b056$export$a3df483ca330b061 = /*#__PURE__*/ function(BusinessEntityType) {
    /** A government organization */ BusinessEntityType["GOVERNMENT"] = "GOVERNMENT";
    /** A privately held company */ BusinessEntityType["PRIVATE"] = "PRIVATE";
    /** A publicly traded company */ BusinessEntityType["PUBLIC"] = "PUBLIC";
    return BusinessEntityType;
}({});
var $2f53fee15f29b056$export$449a1cbfb359160c = /*#__PURE__*/ function(BusinessMetricAttributeSortedDirection) {
    /** Ascending order. */ BusinessMetricAttributeSortedDirection["ASCENDING"] = "ASCENDING";
    /** Descending order. */ BusinessMetricAttributeSortedDirection["DESCENDING"] = "DESCENDING";
    return BusinessMetricAttributeSortedDirection;
}({});
var $2f53fee15f29b056$export$fd201a0b0e5d6183 = /*#__PURE__*/ function(BusinessPlanIndicatorAttributeType) {
    /** Whether the business is exempt from fuel taxes. */ BusinessPlanIndicatorAttributeType["FUEL_TAX_EXEMPT"] = "FUEL_TAX_EXEMPT";
    return BusinessPlanIndicatorAttributeType;
}({});
var $2f53fee15f29b056$export$800811b19a447db8 = /*#__PURE__*/ function(BusinessPlanOperatingGoodsAndServiceCategory) {
    /** Offers farm management services or participates in farming operations. */ BusinessPlanOperatingGoodsAndServiceCategory["AGRICULTURAL_SERVICES"] = "AGRICULTURAL_SERVICES";
    /** Provides products and services that enable other businesses such as printing, cleaning, software development, or consulting. */ BusinessPlanOperatingGoodsAndServiceCategory["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
    /** Provides products and services related to charity */ BusinessPlanOperatingGoodsAndServiceCategory["CHARITABLE_ORGANIZATIONS"] = "CHARITABLE_ORGANIZATIONS";
    /** Sells clothing, footwear, accessories, or clothing-related services. */ BusinessPlanOperatingGoodsAndServiceCategory["CLOTHING_STORES"] = "CLOTHING_STORES";
    /** Provides general or specialized construction, publishing, or printing services. */ BusinessPlanOperatingGoodsAndServiceCategory["CONTRACTED_SERVICES"] = "CONTRACTED_SERVICES";
    /** Provides products and services related to government and legal organizations and operations. */ BusinessPlanOperatingGoodsAndServiceCategory["GOVERNMENT_SERVICES"] = "GOVERNMENT_SERVICES";
    /** A broad range of products and services such as home goods, appliances, musical instruments, computers, marketing, or medical supplies. */ BusinessPlanOperatingGoodsAndServiceCategory["MISCELLANEOUS_STORES"] = "MISCELLANEOUS_STORES";
    /** Provides medical, dental, and vision services as well as hospitals and clinics. */ BusinessPlanOperatingGoodsAndServiceCategory["PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS"] = "PROFESSIONAL_SERVICES_OR_MEMBERSHIP_ORGANIZATIONS";
    /** Sells products or services for business-to-business, wholesale, or business-to-consumer markets. */ BusinessPlanOperatingGoodsAndServiceCategory["RETAIL_OUTLET_SERVICES"] = "RETAIL_OUTLET_SERVICES";
    /** Provides consumer, commercial, and medical transportation services for Passengers and Cargo. */ BusinessPlanOperatingGoodsAndServiceCategory["TRANSPORTATION_SERVICES"] = "TRANSPORTATION_SERVICES";
    /** Offers products and services related to booking and providing travel experiences such as flights, hotels, and rental vehicles. */ BusinessPlanOperatingGoodsAndServiceCategory["TRAVEL"] = "TRAVEL";
    /** Constructs or operates public and private utilities such as electricity, phone service, and Internet service. */ BusinessPlanOperatingGoodsAndServiceCategory["UTILITY_SERVICES"] = "UTILITY_SERVICES";
    return BusinessPlanOperatingGoodsAndServiceCategory;
}({});
var $2f53fee15f29b056$export$bfb16b580ba33fd6 = /*#__PURE__*/ function(BusinessPlanOperatingModelType) {
    /** Whether the business has a forward commitment for delivery of sale. */ BusinessPlanOperatingModelType["FORWARD_COMMITMENT"] = "FORWARD_COMMITMENT";
    /** Whether the business sells physical goods. */ BusinessPlanOperatingModelType["PHYSICAL_GOODS_SOLD"] = "PHYSICAL_GOODS_SOLD";
    /** Whether the business is seasonal. */ BusinessPlanOperatingModelType["SEASONAL_BUSINESS"] = "SEASONAL_BUSINESS";
    return BusinessPlanOperatingModelType;
}({});
var $2f53fee15f29b056$export$a63225e12a84d3ac = /*#__PURE__*/ function(BusinessStructure) {
    /** Corporation. */ BusinessStructure["CORPORATION"] = "CORPORATION";
    /** Limited Liability Company (LLC). */ BusinessStructure["LLC"] = "LLC";
    /** Non profit. */ BusinessStructure["NON_PROFIT"] = "NON_PROFIT";
    /** Partnership. */ BusinessStructure["PARTNERSHIP"] = "PARTNERSHIP";
    /** A private corporation */ BusinessStructure["PRIVATE_CORPORATION"] = "PRIVATE_CORPORATION";
    /** A publicly traded corporation */ BusinessStructure["PUBLIC_CORPORATION"] = "PUBLIC_CORPORATION";
    /** Sole Proprietorship. */ BusinessStructure["SOLE_PROPRIETORSHIP"] = "SOLE_PROPRIETORSHIP";
    return BusinessStructure;
}({});
var $2f53fee15f29b056$export$a9fee6bcbcadff15 = /*#__PURE__*/ function(BusinessTitle) {
    /** Chief Executive Officer. */ BusinessTitle["CEO"] = "CEO";
    /** Chief Financial Officer. */ BusinessTitle["CFO"] = "CFO";
    /** Chief Operating Officer. */ BusinessTitle["COO"] = "COO";
    /** Owner. */ BusinessTitle["OWNER"] = "OWNER";
    /** President. */ BusinessTitle["PRESIDENT"] = "PRESIDENT";
    /** Treasurer. */ BusinessTitle["TREASURER"] = "TREASURER";
    /** Vice President. */ BusinessTitle["VICE_PRESIDENT"] = "VICE_PRESIDENT";
    return BusinessTitle;
}({});
var $2f53fee15f29b056$export$260474aeb740456e = /*#__PURE__*/ function(CvvResponseCode) {
    /** The CVV provided on the authorization did match an CVV on file for the card. */ CvvResponseCode["MATCH"] = "MATCH";
    /** Returned when the card on file does not have a CVV. */ CvvResponseCode["NOT_ON_CARD"] = "NOT_ON_CARD";
    /**
   * The CVV (or similar) check was not performed.
   * Typically this will occur if we are unable to locate the same value in our vault.
   */ CvvResponseCode["NOT_PERFORMED"] = "NOT_PERFORMED";
    /** Returned when the CVV is not provided on the authorization */ CvvResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The CVV provided on the authorization did not match the CVV on file for the card. */ CvvResponseCode["NO_MATCH"] = "NO_MATCH";
    return CvvResponseCode;
}({});
var $2f53fee15f29b056$export$6ebc2d6733d07f42 = /*#__PURE__*/ function(CalculatedTransferAmountType) {
    /** Indicates that the amount to be transferred is the minimum payment due on the latest statement billing period */ CalculatedTransferAmountType["MINIMUM_PAYMENT"] = "MINIMUM_PAYMENT";
    /** Indicates that the amount to be transferred is the outstanding balance on the account */ CalculatedTransferAmountType["OUTSTANDING_BALANCE"] = "OUTSTANDING_BALANCE";
    /** Indicates that the amount to be transferred is the remaining balance due on the latest statement billing period */ CalculatedTransferAmountType["OUTSTANDING_STATEMENT_BALANCE"] = "OUTSTANDING_STATEMENT_BALANCE";
    return CalculatedTransferAmountType;
}({});
var $2f53fee15f29b056$export$1e2fec264ca1d593 = /*#__PURE__*/ function(CaptureType) {
    /** This is the final capture for the authorized amount, and any remaining authorized amount will be canceled. */ CaptureType["FINAL_CAPTURE"] = "FINAL_CAPTURE";
    /** This is a partial capture for the authorized amount, and the remaining authorized amount will remain available for future captures. */ CaptureType["MULTI_CAPTURE"] = "MULTI_CAPTURE";
    return CaptureType;
}({});
var $2f53fee15f29b056$export$b8bd5cde31a7108f = /*#__PURE__*/ function(CardArtDocumentType) {
    /** The card art is the background image of a Digital Card */ CardArtDocumentType["DIGITAL_BACKGROUND"] = "DIGITAL_BACKGROUND";
    /** The card art document is a front image of a Digital Card */ CardArtDocumentType["DIGITAL_FRONT_OF_CARD"] = "DIGITAL_FRONT_OF_CARD";
    /** The card art is the icon image of a Digital Card */ CardArtDocumentType["DIGITAL_ICON"] = "DIGITAL_ICON";
    /** The card art is the logo image of a Digital Card */ CardArtDocumentType["DIGITAL_LOGO"] = "DIGITAL_LOGO";
    /** The card art document is a back image of a Physical Card */ CardArtDocumentType["PHYSICAL_BACK_OF_CARD"] = "PHYSICAL_BACK_OF_CARD";
    /** The card art document is a front image of a Physical Card */ CardArtDocumentType["PHYSICAL_FRONT_OF_CARD"] = "PHYSICAL_FRONT_OF_CARD";
    /** The card art document is a front image of a Virtual Card */ CardArtDocumentType["VIRTUAL_FRONT_OF_CARD"] = "VIRTUAL_FRONT_OF_CARD";
    /** The card logo for 3DS verification */ CardArtDocumentType["VIRTUAL_THREE_DS_VERIFICATION_LOGO"] = "VIRTUAL_THREE_DS_VERIFICATION_LOGO";
    return CardArtDocumentType;
}({});
var $2f53fee15f29b056$export$932181a27fddeca8 = /*#__PURE__*/ function(CardDataInputCapability) {
    /** The terminal supports reading the PAN via barcode or QR code. */ CardDataInputCapability["BARCODE_OR_QR_CODE"] = "BARCODE_OR_QR_CODE";
    /** The terminal’s PAN entry capability is unknown. */ CardDataInputCapability["CAPABILITY_UNKNOWN"] = "CAPABILITY_UNKNOWN";
    /** The terminal supports reading the PAN via the card’s contactless chip only. The terminal does not support reading the PAN via the card’s contact chip. */ CardDataInputCapability["CONTACTLESS_ONLY_SUPPORTED"] = "CONTACTLESS_ONLY_SUPPORTED";
    /** The terminal only supports reading the PAN via the card chip’s contactless method. */ CardDataInputCapability["CONTACTLESS_READ_VIA_CHIP_RULES"] = "CONTACTLESS_READ_VIA_CHIP_RULES";
    /** The terminal only supports reading the PAN via the magnetic stripe’s contactless method. */ CardDataInputCapability["CONTACTLESS_READ_VIA_MAG_STRIPE_RULES"] = "CONTACTLESS_READ_VIA_MAG_STRIPE_RULES";
    /** The terminal supports file reading, but does not supporting reading card data. */ CardDataInputCapability["FILE"] = "FILE";
    /** The terminal supports reading the PAN via the Integrated Circuit Card (ICC - chip). */ CardDataInputCapability["INTEGRATED_CIRCUIT_CARD"] = "INTEGRATED_CIRCUIT_CARD";
    /** The terminal supports keyed entry of the PAN. */ CardDataInputCapability["KEY_ENTERED"] = "KEY_ENTERED";
    /** The terminal supports reading the PAN via the card’s magnetic stripe. */ CardDataInputCapability["MAGNETIC_STRIPE"] = "MAGNETIC_STRIPE";
    /** The terminal supports an Integrated Circuit Card (ICC) and can read the PAN via the card’s contact chip, magnetic stripe, or contactless chip. */ CardDataInputCapability["MAG_STRIPE_READER_AND_EMV_ICC"] = "MAG_STRIPE_READER_AND_EMV_ICC";
    /** The terminal supports reading the PAN from the magnetic stripe or keyed entry of the PAN only. */ CardDataInputCapability["MAG_STRIPE_READER_AND_KEY_ENTRY"] = "MAG_STRIPE_READER_AND_KEY_ENTRY";
    /** The terminal supports reading the PAN from the magnetic stripe or the card’s chip only and keyed entry of the PAN. */ CardDataInputCapability["MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC"] = "MAG_STRIPE_READER_AND_KEY_ENTRY_AND_EMV_ICC";
    /** The PAN was entered manually, and the terminal was not used. */ CardDataInputCapability["MANUAL_NO_TERMINAL"] = "MANUAL_NO_TERMINAL";
    /** The terminal supports reading the PAN via Optical Character Recognition. */ CardDataInputCapability["OCR"] = "OCR";
    /** Secure Cardless Entry. */ CardDataInputCapability["SECURE_CARDLESS_ENTRY"] = "SECURE_CARDLESS_ENTRY";
    return CardDataInputCapability;
}({});
var $2f53fee15f29b056$export$a3008cc524687832 = /*#__PURE__*/ function(CardDigitalWalletTokenSourceEntryMethod) {
    /** The token is provisioned through an application. */ CardDigitalWalletTokenSourceEntryMethod["APP_PROVISIONED"] = "APP_PROVISIONED";
    /** The token is generated through a web browser. */ CardDigitalWalletTokenSourceEntryMethod["BROWSER"] = "BROWSER";
    /** The token is stored on the card network and can be used for transactions. */ CardDigitalWalletTokenSourceEntryMethod["CARD_ON_FILE"] = "CARD_ON_FILE";
    /** CHIP_DATA: The token is generated from the chip data on the card. */ CardDigitalWalletTokenSourceEntryMethod["CHIP_DATA"] = "CHIP_DATA";
    /** The token is manually entered by the user or merchant. */ CardDigitalWalletTokenSourceEntryMethod["MANUAL_ENTRY"] = "MANUAL_ENTRY";
    /** The token is generated by the card network or issuer. */ CardDigitalWalletTokenSourceEntryMethod["TOKEN"] = "TOKEN";
    return CardDigitalWalletTokenSourceEntryMethod;
}({});
var $2f53fee15f29b056$export$a62541a929257c0 = /*#__PURE__*/ function(CardDigitalWalletTokenState) {
    /** The card digital wallet token has been provisioned and is available for transaction use. */ CardDigitalWalletTokenState["ACTIVE"] = "ACTIVE";
    /** The initial state of the card digital wallet token. The card digital wallet token is not yet available for use. */ CardDigitalWalletTokenState["REQUESTED"] = "REQUESTED";
    /**
   * The card digital wallet token has been blocked from transaction use and action may be required by the account holder.
   * Card digital wallet token can be suspended by the Issuer, Program owner, or Account holder.
   */ CardDigitalWalletTokenState["SUSPENDED"] = "SUSPENDED";
    /** The card digital wallet token has been deleted and is no longer available for transaction use. */ CardDigitalWalletTokenState["TERMINATED"] = "TERMINATED";
    return CardDigitalWalletTokenState;
}({});
var $2f53fee15f29b056$export$921cfc4180977391 = /*#__PURE__*/ function(CardDigitalWalletTokenStateReason) {
    /** Account holder account closed. */ CardDigitalWalletTokenStateReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** Account holder has been deleted. */ CardDigitalWalletTokenStateReason["ACCOUNT_HOLDER_DELETED"] = "ACCOUNT_HOLDER_DELETED";
    /**
   * Account holder successfully authenticated with an activation method (activation
   * code by text message, email, Issuer mobile application, etc.) prior to activation.
   */ CardDigitalWalletTokenStateReason["ACTIVATION_METHOD"] = "ACTIVATION_METHOD";
    /** Account holder called customer agent for verification. */ CardDigitalWalletTokenStateReason["CUSTOMER_SERVICE_AGENT"] = "CUSTOMER_SERVICE_AGENT";
    /** A lost or stolen device has been found or recovered. */ CardDigitalWalletTokenStateReason["DEVICE_FOUND"] = "DEVICE_FOUND";
    /** Device was reported as lost. */ CardDigitalWalletTokenStateReason["DEVICE_LOST"] = "DEVICE_LOST";
    /** Device was reported as stolen. */ CardDigitalWalletTokenStateReason["DEVICE_STOLEN"] = "DEVICE_STOLEN";
    /** Fraudulent transactions have been reported by `Highnote` or the account holder. */ CardDigitalWalletTokenStateReason["FRAUDULENT_TRANSACTIONS"] = "FRAUDULENT_TRANSACTIONS";
    /** State changed based on Card Network request. */ CardDigitalWalletTokenStateReason["NETWORK_INITIATED"] = "NETWORK_INITIATED";
    /**
   * After reviewing transaction history,
   * the account holder or `Highnote` confirmed that there were no fraudulent transactions.
   */ CardDigitalWalletTokenStateReason["NON_FRAUDULENT_TRANSACTIONS"] = "NON_FRAUDULENT_TRANSACTIONS";
    /** Any other reason for the card digital wallet token state change. */ CardDigitalWalletTokenStateReason["OTHER"] = "OTHER";
    return CardDigitalWalletTokenStateReason;
}({});
var $2f53fee15f29b056$export$fd54462646916263 = /*#__PURE__*/ function(CardDigitalWalletTokenType) {
    /** The token is stored on file with the card network or issuer. */ CardDigitalWalletTokenType["CARD_ON_FILE"] = "CARD_ON_FILE";
    /** The token is stored in the cloud and can be used for transactions. */ CardDigitalWalletTokenType["CLOUD_BASED"] = "CLOUD_BASED";
    /** The token is stored in a secure element on the device. */ CardDigitalWalletTokenType["DEVICE_SECURE_ELEMENT"] = "DEVICE_SECURE_ELEMENT";
    /** The token is used for ecommerce transactions. */ CardDigitalWalletTokenType["ECOMMERCE"] = "ECOMMERCE";
    /** The token is static and does not change. */ CardDigitalWalletTokenType["STATIC"] = "STATIC";
    return CardDigitalWalletTokenType;
}({});
var $2f53fee15f29b056$export$f6ab3e438188d326 = /*#__PURE__*/ function(CardDigitalWalletTokenVerificationMethodType) {
    /** Customer service verification method. The cardholder must call the customer service number to verify their identity with a representative or automated system. In the digital wallet app, the user will see an option to "Call to Verify" with the customer service phone number displayed. */ CardDigitalWalletTokenVerificationMethodType["CUSTOMER_SERVICE"] = "CUSTOMER_SERVICE";
    /** Email verification method. The cardholder receives a one-time passcode (OTP) via email to their registered email address. In the digital wallet app, the user will see an option to "Verify via Email" and will need to enter the code they receive to complete provisioning. */ CardDigitalWalletTokenVerificationMethodType["EMAIL"] = "EMAIL";
    /** SMS verification method. The cardholder receives a one-time passcode (OTP) via text message to their registered phone number. In the digital wallet app, the user will see an option to "Verify via Text Message" and will need to enter the code they receive to complete provisioning. */ CardDigitalWalletTokenVerificationMethodType["SMS"] = "SMS";
    return CardDigitalWalletTokenVerificationMethodType;
}({});
var $2f53fee15f29b056$export$d7f6859f54a19f9c = /*#__PURE__*/ function(CardFormFactor) {
    /** A card which is issued physically and can be used across multiple channels. */ CardFormFactor["PHYSICAL"] = "PHYSICAL";
    /** A card which can only be used through virtual channels. */ CardFormFactor["VIRTUAL"] = "VIRTUAL";
    return CardFormFactor;
}({});
var $2f53fee15f29b056$export$138bb19fb341108b = /*#__PURE__*/ function(CardPaymentDisputeCategory) {
    /** Dispute categorized as a consumer dispute. */ CardPaymentDisputeCategory["CONSUMER_DISPUTE"] = "CONSUMER_DISPUTE";
    /** Dispute categorized as fraud. */ CardPaymentDisputeCategory["FRAUD"] = "FRAUD";
    /** Dispute categorized as an authorization issue. */ CardPaymentDisputeCategory["INVALID_AUTHORIZATION"] = "INVALID_AUTHORIZATION";
    /** Dispute categorized as a processing error. */ CardPaymentDisputeCategory["PROCESSING_ERROR"] = "PROCESSING_ERROR";
    return CardPaymentDisputeCategory;
}({});
var $2f53fee15f29b056$export$3e4e231a549ca0cd = /*#__PURE__*/ function(CardPaymentDisputeStageDecisionChoice) {
    /** Accept the dispute at this stage. */ CardPaymentDisputeStageDecisionChoice["ACCEPT"] = "ACCEPT";
    /** Challenge the dispute at this stage. */ CardPaymentDisputeStageDecisionChoice["CHALLENGE"] = "CHALLENGE";
    /** Withdraw from the dispute process. */ CardPaymentDisputeStageDecisionChoice["WITHDRAW"] = "WITHDRAW";
    return CardPaymentDisputeStageDecisionChoice;
}({});
var $2f53fee15f29b056$export$900a22801ae08df2 = /*#__PURE__*/ function(CardPaymentDisputeStageEvidenceCategory) {
    /** Correspondence or communication records between the merchant and cardholder. */ CardPaymentDisputeStageEvidenceCategory["CUSTOMER_COMMUNICATION"] = "CUSTOMER_COMMUNICATION";
    /** Identity verification documents confirming the cardholder's identity at the time of purchase. */ CardPaymentDisputeStageEvidenceCategory["IDENTITY_VERIFICATION"] = "IDENTITY_VERIFICATION";
    /** Order history or transaction records demonstrating a pattern of legitimate purchases by the cardholder. */ CardPaymentDisputeStageEvidenceCategory["ORDER_HISTORY"] = "ORDER_HISTORY";
    /** Documentation confirming delivery of goods or services (e.g., signed courier confirmation, tracking number). */ CardPaymentDisputeStageEvidenceCategory["PROOF_OF_DELIVERY"] = "PROOF_OF_DELIVERY";
    /** Proof that a refund was already issued or a reversal was processed for the disputed transaction. */ CardPaymentDisputeStageEvidenceCategory["REFUND_REVERSAL_PROOF"] = "REFUND_REVERSAL_PROOF";
    /** Documentation of the service provided (e.g., service agreement, completion certificate, usage logs). */ CardPaymentDisputeStageEvidenceCategory["SERVICE_DOCUMENTATION"] = "SERVICE_DOCUMENTATION";
    return CardPaymentDisputeStageEvidenceCategory;
}({});
var $2f53fee15f29b056$export$9bbe8901082fc991 = /*#__PURE__*/ function(CardPaymentDisputeStageEvidenceStatus) {
    /** The evidence was accepted by the network. */ CardPaymentDisputeStageEvidenceStatus["ACCEPTED"] = "ACCEPTED";
    /** The evidence has been uploaded but not yet submitted to the network. */ CardPaymentDisputeStageEvidenceStatus["PENDING"] = "PENDING";
    /** The evidence was rejected by the network. */ CardPaymentDisputeStageEvidenceStatus["REJECTED"] = "REJECTED";
    /** The evidence has been submitted to the network. */ CardPaymentDisputeStageEvidenceStatus["SUBMITTED"] = "SUBMITTED";
    return CardPaymentDisputeStageEvidenceStatus;
}({});
var $2f53fee15f29b056$export$9e334270bbd0c60 = /*#__PURE__*/ function(CardPaymentDisputeStageStatus) {
    /** The stage has been completed. */ CardPaymentDisputeStageStatus["COMPLETED"] = "COMPLETED";
    /** The stage has expired without action. */ CardPaymentDisputeStageStatus["EXPIRED"] = "EXPIRED";
    /** The stage is actively being worked on. */ CardPaymentDisputeStageStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The stage is awaiting action. */ CardPaymentDisputeStageStatus["PENDING"] = "PENDING";
    return CardPaymentDisputeStageStatus;
}({});
var $2f53fee15f29b056$export$8b71b2c1df0ff586 = /*#__PURE__*/ function(CardPaymentDisputeStatus) {
    /** The dispute is closed. */ CardPaymentDisputeStatus["CLOSED"] = "CLOSED";
    /** The dispute has been initiated. */ CardPaymentDisputeStatus["INITIATED"] = "INITIATED";
    /** The dispute is in review. */ CardPaymentDisputeStatus["IN_REVIEW"] = "IN_REVIEW";
    /** The issuer accepts responsibility for the dispute. Resolved in favor of the merchant. */ CardPaymentDisputeStatus["ISSUER_ACCEPTED"] = "ISSUER_ACCEPTED";
    /** The merchant accepts responsibility for the dispute. Resolved in favor of the issuer. */ CardPaymentDisputeStatus["MERCHANT_ACCEPTED"] = "MERCHANT_ACCEPTED";
    /** The dispute has timed out due to inaction. */ CardPaymentDisputeStatus["TIMED_OUT"] = "TIMED_OUT";
    /** The dispute has been withdrawn by the party that created it. */ CardPaymentDisputeStatus["WITHDRAWN"] = "WITHDRAWN";
    return CardPaymentDisputeStatus;
}({});
var $2f53fee15f29b056$export$d9c020c976c56ab8 = /*#__PURE__*/ function(CardProductApplicationOfferCategory) {
    /** A Secured Credit type offer */ CardProductApplicationOfferCategory["SECURED_CREDIT"] = "SECURED_CREDIT";
    /** An Unsecured Credit type offer */ CardProductApplicationOfferCategory["UNSECURED_CREDIT"] = "UNSECURED_CREDIT";
    return CardProductApplicationOfferCategory;
}({});
var $2f53fee15f29b056$export$d8b4d7f05339847c = /*#__PURE__*/ function(CardProductApplicationOfferStatus) {
    /** The offer has been extended and Accepted by the Applicant */ CardProductApplicationOfferStatus["ACCEPTED"] = "ACCEPTED";
    /** The offer has been disqualified and cannot be extended to the Applicant */ CardProductApplicationOfferStatus["DISQUALIFIED"] = "DISQUALIFIED";
    /** The offer has expired */ CardProductApplicationOfferStatus["EXPIRED"] = "EXPIRED";
    /** The offer has been extended to the Applicant */ CardProductApplicationOfferStatus["EXTENDED"] = "EXTENDED";
    /** The offer has not been extended or decisioned yet */ CardProductApplicationOfferStatus["OPEN"] = "OPEN";
    /** The offer has been rejected by the Applicant */ CardProductApplicationOfferStatus["REJECTED"] = "REJECTED";
    return CardProductApplicationOfferStatus;
}({});
var $2f53fee15f29b056$export$c9e174b77f097812 = /*#__PURE__*/ function(CardProductVertical) {
    /**
   * This `CardProduct` supports acquiring.
   *
   * This `CardProduct` cannot be used with issuance, and would result in a validation error if it is.
   */ CardProductVertical["ACQUIRING"] = "ACQUIRING";
    /** Cards issued to pay for invoices. */ CardProductVertical["AP_INVOICE_AUTOMATION"] = "AP_INVOICE_AUTOMATION";
    /** Cards issued to provide commercial credit. */ CardProductVertical["COMMERCIAL_CREDIT"] = "COMMERCIAL_CREDIT";
    /** Cards issued to proved commercial credit pay in full. */ CardProductVertical["COMMERCIAL_CREDIT_PAY_IN_FULL"] = "COMMERCIAL_CREDIT_PAY_IN_FULL";
    /** Cards issued to provide commercial debit. */ CardProductVertical["COMMERCIAL_DEBIT"] = "COMMERCIAL_DEBIT";
    /** Cards issued for commercial prepaid products. */ CardProductVertical["COMMERCIAL_PREPAID"] = "COMMERCIAL_PREPAID";
    /** Cards issued to provide consumer credit. */ CardProductVertical["CONSUMER_CREDIT"] = "CONSUMER_CREDIT";
    /** Cards issued to provide consumer prepaid. */ CardProductVertical["CONSUMER_PREPAID"] = "CONSUMER_PREPAID";
    /** Cards issued to provide people with advances for earned wages. */ CardProductVertical["EARNED_WAGE_ACCESS"] = "EARNED_WAGE_ACCESS";
    /** Cards issued to provide fleet commercial cards. */ CardProductVertical["FLEET"] = "FLEET";
    /** Cards issued to provide people with general reloadable cards. */ CardProductVertical["GENERAL_PURPOSE_RELOADABLE"] = "GENERAL_PURPOSE_RELOADABLE";
    /** This `CardProduct` supports money movement. */ CardProductVertical["MONEY_MOVEMENT"] = "MONEY_MOVEMENT";
    /** Cards issued for payroll products. */ CardProductVertical["PAYROLL"] = "PAYROLL";
    /**
   * Cards issued to provide secured deposited funded cards.
   * @deprecated The SECURED_COMMERCIAL_CREDIT CardProductVertical is deprecated. Please use COMMERCIAL_CREDIT instead. Please reach out to Highnote support with any questions.
   */ CardProductVertical["SECURED_COMMERCIAL_CREDIT"] = "SECURED_COMMERCIAL_CREDIT";
    return CardProductVertical;
}({});
var $2f53fee15f29b056$export$9c3325e81419488d = /*#__PURE__*/ function(CardProfileBankStatus) {
    /** Bank Status is approved */ CardProfileBankStatus["APPROVED"] = "APPROVED";
    /** Bank Status is in review */ CardProfileBankStatus["IN_REVIEW"] = "IN_REVIEW";
    /** Bank Status is PENDING */ CardProfileBankStatus["PENDING"] = "PENDING";
    /** Bank Status is ready for review */ CardProfileBankStatus["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    return CardProfileBankStatus;
}({});
var $2f53fee15f29b056$export$1ad424ffc084cfc3 = /*#__PURE__*/ function(CardProfilePaymentNetworkStatus) {
    /** Network Status is approved */ CardProfilePaymentNetworkStatus["APPROVED"] = "APPROVED";
    /** Network Status is in review */ CardProfilePaymentNetworkStatus["IN_REVIEW"] = "IN_REVIEW";
    /** Network Status is PENDING */ CardProfilePaymentNetworkStatus["PENDING"] = "PENDING";
    /** Network Status is ready for review */ CardProfilePaymentNetworkStatus["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    return CardProfilePaymentNetworkStatus;
}({});
var $2f53fee15f29b056$export$da2aa7ee4cb74d0f = /*#__PURE__*/ function(CardProfileSetIntent) {
    /** Intended to issue Digital cards */ CardProfileSetIntent["DIGITAL"] = "DIGITAL";
    /** Intended to issue Physical cards */ CardProfileSetIntent["PHYSICAL"] = "PHYSICAL";
    /** Intended to issue Virtual cards */ CardProfileSetIntent["VIRTUAL"] = "VIRTUAL";
    return CardProfileSetIntent;
}({});
var $2f53fee15f29b056$export$5d6ecb56576e5136 = /*#__PURE__*/ function(CardProfileSetNetwork) {
    /** Card Profile Set Network is MASTERCARD */ CardProfileSetNetwork["MASTERCARD"] = "MASTERCARD";
    /** Card Profile Set Network is VISA */ CardProfileSetNetwork["VISA"] = "VISA";
    return CardProfileSetNetwork;
}({});
var $2f53fee15f29b056$export$215ecbcb48503171 = /*#__PURE__*/ function(CardProfileSetStatus) {
    /** Card Profile Set Status is approved */ CardProfileSetStatus["APPROVED"] = "APPROVED";
    /** Card Profile Set Status is archived */ CardProfileSetStatus["ARCHIVED"] = "ARCHIVED";
    /** Card Profile Set Status is inactive */ CardProfileSetStatus["INACTIVE"] = "INACTIVE";
    /** Card Profile Set Status is in review */ CardProfileSetStatus["IN_REVIEW"] = "IN_REVIEW";
    /** Card Profile Set Status is PENDING */ CardProfileSetStatus["PENDING"] = "PENDING";
    /** Card Profile Set Status is ready for review */ CardProfileSetStatus["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    return CardProfileSetStatus;
}({});
var $2f53fee15f29b056$export$c5a47120742fb046 = /*#__PURE__*/ function(CardProfileStatus) {
    /** The profile was approved. */ CardProfileStatus["APPROVED"] = "APPROVED";
    /** The profile is inactive. */ CardProfileStatus["INACTIVE"] = "INACTIVE";
    /** The profile requires further review. */ CardProfileStatus["IN_REVIEW"] = "IN_REVIEW";
    /** The profile is currently being processed. */ CardProfileStatus["PENDING"] = "PENDING";
    /** The profile is ready for review. */ CardProfileStatus["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    return CardProfileStatus;
}({});
var $2f53fee15f29b056$export$8099198961a555c9 = /*#__PURE__*/ function(CardProfileVendorStatus) {
    /** Vendor Status is approved */ CardProfileVendorStatus["APPROVED"] = "APPROVED";
    /** Vendor Status is in review */ CardProfileVendorStatus["IN_REVIEW"] = "IN_REVIEW";
    /** Vendor Status is PENDING */ CardProfileVendorStatus["PENDING"] = "PENDING";
    /** Vendor Status is ready for review */ CardProfileVendorStatus["READY_FOR_REVIEW"] = "READY_FOR_REVIEW";
    return CardProfileVendorStatus;
}({});
var $2f53fee15f29b056$export$371199f4e8789171 = /*#__PURE__*/ function(CardTransactionProcessingType) {
    /** Account Verification. Category: `INQUIRY_SERVICE`. */ CardTransactionProcessingType["ACCOUNT_VERIFICATION"] = "ACCOUNT_VERIFICATION";
    /** Adjustment. Category: `CREDIT`. */ CardTransactionProcessingType["ADJUSTMENT_CREDIT"] = "ADJUSTMENT_CREDIT";
    /** Adjustment. Category: `DEBIT`. */ CardTransactionProcessingType["ADJUSTMENT_DEBIT"] = "ADJUSTMENT_DEBIT";
    /** Request to provide transaction history by ATM. Category: `INQUIRY_SERVICE`. */ CardTransactionProcessingType["ATM_MINI_STATEMENT"] = "ATM_MINI_STATEMENT";
    /** Available funds inquiry. Category: `INQUIRY_SERVICE`. */ CardTransactionProcessingType["AVAILABLE_FUNDS_INQUIRY"] = "AVAILABLE_FUNDS_INQUIRY";
    /** Balance inquiry. Category: `INQUIRY_SERVICE`. */ CardTransactionProcessingType["BALANCE_INQUIRY"] = "BALANCE_INQUIRY";
    /** Cardholder accounts transfer. Category: `TRANSFER_PAYMENT_TRANSFER_SERVICE`. */ CardTransactionProcessingType["CARDHOLDER_ACCOUNTS_TRANSFER"] = "CARDHOLDER_ACCOUNTS_TRANSFER";
    /** Cash. Category: `DEBIT`. */ CardTransactionProcessingType["CASH"] = "CASH";
    /** Cash disbursement. Category: `DEBIT`. */ CardTransactionProcessingType["CASH_DISBURSEMENT"] = "CASH_DISBURSEMENT";
    /** Deposits/Deposit payments. Category: `CREDIT`. */ CardTransactionProcessingType["DEPOSITS"] = "DEPOSITS";
    /** Eligibility inquiry. Category: `INQUIRY_SERVICE`. */ CardTransactionProcessingType["ELIGIBILITY_INQUIRY"] = "ELIGIBILITY_INQUIRY";
    /** Used to collect miscellaneous fees. Category: `DEBIT`. */ CardTransactionProcessingType["FEE_COLLECTION_DEBIT"] = "FEE_COLLECTION_DEBIT";
    /** Used to remit miscellaneous fees. Category: `CREDIT`. */ CardTransactionProcessingType["FUNDS_DISBURSEMENT_CREDIT"] = "FUNDS_DISBURSEMENT_CREDIT";
    /** Funds withdrawal for electronic purse. Category: `DEBIT`. */ CardTransactionProcessingType["FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE"] = "FUNDS_WITHDRAWAL_FOR_ELECTRONIC_PURSE";
    /** Goods and services. Category: `DEBIT`. */ CardTransactionProcessingType["GOODS_AND_SERVICES"] = "GOODS_AND_SERVICES";
    /** Goods and services with cash disbursement. Category: `DEBIT`. */ CardTransactionProcessingType["GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT"] = "GOODS_AND_SERVICES_WITH_CASH_DISBURSEMENT";
    /** Load funds onto a prepaid card. Category: `CREDIT`. */ CardTransactionProcessingType["LOAD_OF_PREPAID_OR_STORED_VALUE_CARD"] = "LOAD_OF_PREPAID_OR_STORED_VALUE_CARD";
    /** Non-cash financial for funding. Category: `DEBIT`. */ CardTransactionProcessingType["NON_CASH_FINANCIAL_FOR_FUNDING"] = "NON_CASH_FINANCIAL_FOR_FUNDING";
    /** Notification to bank. Category: `PRIVATE_USE`. */ CardTransactionProcessingType["NOTIFICATION_TO_BANK"] = "NOTIFICATION_TO_BANK";
    /** Enables funds to be credited to account numbers for a purpose other than refunding a purchase. Category: `CREDIT`. */ CardTransactionProcessingType["ORIGINAL_CREDIT"] = "ORIGINAL_CREDIT";
    /** Payment credit (P2P). Category: `CREDIT`. */ CardTransactionProcessingType["PAYMENT_CREDIT"] = "PAYMENT_CREDIT";
    /** Payment debit (P2P). Category: `DEBIT`. */ CardTransactionProcessingType["PAYMENT_DEBIT"] = "PAYMENT_DEBIT";
    /** Payment enclosed. Category: `CREDIT`. */ CardTransactionProcessingType["PAYMENT_ENCLOSED"] = "PAYMENT_ENCLOSED";
    /** Payment from third party. Category: `CREDIT`. */ CardTransactionProcessingType["PAYMENT_FROM_THIRD_PARTY"] = "PAYMENT_FROM_THIRD_PARTY";
    /** Payment to another party. Category: `DEBIT`. */ CardTransactionProcessingType["PAYMENT_TO_ANOTHER_PARTY"] = "PAYMENT_TO_ANOTHER_PARTY";
    /** Payment transaction. Category: `CREDIT`. */ CardTransactionProcessingType["PAYMENT_TRANSACTION"] = "PAYMENT_TRANSACTION";
    /** PIN change. Category: `PRIVATE_USE`. */ CardTransactionProcessingType["PIN_CHANGE"] = "PIN_CHANGE";
    /** PIN Unblock. Category: `PRIVATE_USE`. */ CardTransactionProcessingType["PIN_UNBLOCK"] = "PIN_UNBLOCK";
    /** Quasi-Cash and scrip. Category: `DEBIT`. */ CardTransactionProcessingType["QUASI_CASH_AND_SCRIP"] = "QUASI_CASH_AND_SCRIP";
    /** Returns. Category: `CREDIT`. */ CardTransactionProcessingType["RETURNS"] = "RETURNS";
    return CardTransactionProcessingType;
}({});
var $2f53fee15f29b056$export$306ffd7152220157 = /*#__PURE__*/ function(CardUsage) {
    /** Cards which can be used more than once. */ CardUsage["MULTI_USE"] = "MULTI_USE";
    /** Cards which can only be used once. */ CardUsage["SINGLE_USE"] = "SINGLE_USE";
    return CardUsage;
}({});
var $2f53fee15f29b056$export$94a02759df772acb = /*#__PURE__*/ function(ChargebackExternalNetworkType) {
    /** Mastercard Network Gateway Online Manager Case ID */ ChargebackExternalNetworkType["NGOM"] = "NGOM";
    /** Visa Resolve Online Case ID */ ChargebackExternalNetworkType["VROL"] = "VROL";
    return ChargebackExternalNetworkType;
}({});
var $2f53fee15f29b056$export$16d280511bdca5b7 = /*#__PURE__*/ function(CheckPaymentDocumentType) {
    /** A signature of the account holder. */ CheckPaymentDocumentType["ACCOUNT_HOLDER_SIGNATURE"] = "ACCOUNT_HOLDER_SIGNATURE";
    return CheckPaymentDocumentType;
}({});
var $2f53fee15f29b056$export$ca5c2f429a0b9367 = /*#__PURE__*/ function(CheckPaymentEventType) {
    /** The check has been delivered, and cashed or deposited. */ CheckPaymentEventType["COMPLETED"] = "COMPLETED";
    /** The check has failed. The reason for the failure is included in the event. */ CheckPaymentEventType["FAILED"] = "FAILED";
    /** The check has been funded and is pending disbursement. */ CheckPaymentEventType["FUNDING_COMPLETED"] = "FUNDING_COMPLETED";
    /** The funds have been disbursed to external accounts. */ CheckPaymentEventType["FUNDING_DISBURSED"] = "FUNDING_DISBURSED";
    /** The check has been initiated and is pending funding. */ CheckPaymentEventType["FUNDING_PENDING"] = "FUNDING_PENDING";
    /** The check funding has been initiated. */ CheckPaymentEventType["FUNDING_STARTED"] = "FUNDING_STARTED";
    /** The check has been put on hold for risk assessment */ CheckPaymentEventType["ON_RISK_HOLD"] = "ON_RISK_HOLD";
    /** The check has been paid out. */ CheckPaymentEventType["PAID"] = "PAID";
    /** The check is pending processing by Highnote. */ CheckPaymentEventType["PENDING_PROCESSING_BY_HIGHNOTE"] = "PENDING_PROCESSING_BY_HIGHNOTE";
    /** The check has been printed and is pending shipment. */ CheckPaymentEventType["PENDING_SHIPMENT"] = "PENDING_SHIPMENT";
    /** The check has been printed. */ CheckPaymentEventType["PRINTED"] = "PRINTED";
    /** The check has been processed by Highnote. */ CheckPaymentEventType["PROCESSED_BY_HIGHNOTE"] = "PROCESSED_BY_HIGHNOTE";
    /** The check is processing by Highnote. */ CheckPaymentEventType["PROCESSING_BY_HIGHNOTE"] = "PROCESSING_BY_HIGHNOTE";
    /** The check reversal has been completed. */ CheckPaymentEventType["REVERSAL_COMPLETED"] = "REVERSAL_COMPLETED";
    /** The check has been reversed due to voiding or failure. */ CheckPaymentEventType["REVERSAL_INITIATED"] = "REVERSAL_INITIATED";
    /** The check has been shipped. */ CheckPaymentEventType["SHIPPED"] = "SHIPPED";
    /** The check has been voided. */ CheckPaymentEventType["VOIDED"] = "VOIDED";
    return CheckPaymentEventType;
}({});
var $2f53fee15f29b056$export$fd7059f0d6de6960 = /*#__PURE__*/ function(CheckPaymentFailureReason) {
    /** The check failed due to a closed account. */ CheckPaymentFailureReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The check failed due since the `FinancialAccount` is not enabled for checks. */ CheckPaymentFailureReason["FINANCIAL_ACCOUNT_NOT_ENABLED_FOR_CHECK_PAYMENTS"] = "FINANCIAL_ACCOUNT_NOT_ENABLED_FOR_CHECK_PAYMENTS";
    /** The check failed due to insufficient funds. */ CheckPaymentFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The check failed due to a Highnote internal error. */ CheckPaymentFailureReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** The check failed due to the address being invalid. */ CheckPaymentFailureReason["INVALID_ADDRESS"] = "INVALID_ADDRESS";
    /** The check failed due to a stop payment request. */ CheckPaymentFailureReason["PAYMENT_STOPPED"] = "PAYMENT_STOPPED";
    /** The check failed due to a risk assessment. */ CheckPaymentFailureReason["RISK"] = "RISK";
    /** The check failed due to an unknown reason. Contact Highnote support for more information. */ CheckPaymentFailureReason["UNKNOWN"] = "UNKNOWN";
    return CheckPaymentFailureReason;
}({});
var $2f53fee15f29b056$export$b7940518b31e6e10 = /*#__PURE__*/ function(CheckPaymentShippingTime) {
    /** Certified mail. */ CheckPaymentShippingTime["CERTIFIED"] = "CERTIFIED";
    /** Expedited mail. */ CheckPaymentShippingTime["EXPEDITED"] = "EXPEDITED";
    /** Overnight mail. */ CheckPaymentShippingTime["OVERNIGHT"] = "OVERNIGHT";
    /** Standard mail. */ CheckPaymentShippingTime["STANDARD"] = "STANDARD";
    return CheckPaymentShippingTime;
}({});
var $2f53fee15f29b056$export$a79ed6b747081d90 = /*#__PURE__*/ function(CheckPaymentStatus) {
    /** The check has been completed. */ CheckPaymentStatus["COMPLETE"] = "COMPLETE";
    /** An event has occurred that has caused the check to fail. Check the `CheckPayment.failureReason` field for more information. */ CheckPaymentStatus["FAILED"] = "FAILED";
    /** The check is started and pending completion. */ CheckPaymentStatus["PENDING"] = "PENDING";
    return CheckPaymentStatus;
}({});
var $2f53fee15f29b056$export$c86f791866e858de = /*#__PURE__*/ function(CheckPaymentType) {
    /** A physical check. */ CheckPaymentType["PHYSICAL"] = "PHYSICAL";
    return CheckPaymentType;
}({});
var $2f53fee15f29b056$export$594d8a13f2eca4d9 = /*#__PURE__*/ function(ClientTokenUsage) {
    /**
   * The client token can only be used once. Once used, the client token is no longer valid.
   *
   * **Note:**
   *
   * In the event of a failure to process the request, the client token will be invalidated.
   */ ClientTokenUsage["SINGLE_USE"] = "SINGLE_USE";
    /** The client token can be repeatedly used until its expiration date. */ ClientTokenUsage["UNTIL_EXPIRATION"] = "UNTIL_EXPIRATION";
    return ClientTokenUsage;
}({});
var $2f53fee15f29b056$export$548721a9d218b7ad = /*#__PURE__*/ function(CollaborativeAuthorizationEndpointStatus) {
    /** The `CollaborativeAuthorizationEndpoint` was unable to be verified. */ CollaborativeAuthorizationEndpointStatus["ACTIVATION_FAILED"] = "ACTIVATION_FAILED";
    /** The `CollaborativeAuthorizationEndpoint` has been verified and events are being delivered. */ CollaborativeAuthorizationEndpointStatus["ACTIVE"] = "ACTIVE";
    /** The `CollaborativeAuthorizationEndpoint` has been manually deactivated or Highnote has detected an error delivering events. */ CollaborativeAuthorizationEndpointStatus["DEACTIVATED"] = "DEACTIVATED";
    /** The `CollaborativeAuthorizationEndpoint` has not yet been verified. Events will not be delivered. */ CollaborativeAuthorizationEndpointStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    return CollaborativeAuthorizationEndpointStatus;
}({});
var $2f53fee15f29b056$export$b4af3e9fb8122027 = /*#__PURE__*/ function(CollaborativeAuthorizationResponseCode) {
    /** `Transaction` approved */ CollaborativeAuthorizationResponseCode["APPROVED"] = "APPROVED";
    /** `Transaction` declined due to special condition - new card not activated or card is temporarily blocked */ CollaborativeAuthorizationResponseCode["BLOCKED_CARD"] = "BLOCKED_CARD";
    /** `Transaction` declined because Card Not Present transactions such as eCommerce are not permitted as a fraud prevention measure */ CollaborativeAuthorizationResponseCode["CARD_NOT_PRESENT_AT_POS"] = "CARD_NOT_PRESENT_AT_POS";
    /** `Transaction` declined because the transaction exceeded the cashback limit */ CollaborativeAuthorizationResponseCode["CASHBACK_LIMIT_EXCEEDED"] = "CASHBACK_LIMIT_EXCEEDED";
    /**
   * `Transaction` declined
   * @deprecated Deprecated in favor of more granular response codes
   */ CollaborativeAuthorizationResponseCode["DECLINED"] = "DECLINED";
    /** `Transaction` declined because it was a duplicate of a previous transaction */ CollaborativeAuthorizationResponseCode["DUPLICATE_TRANSACTION"] = "DUPLICATE_TRANSACTION";
    /**
   * Collaborative Authorization response resulted in an error
   *
   * **Note:** This response code is not meant to be returned by the Collaborative Authorization Partner. It is used by Highnote to indicate an `Error` occurred during Collaborative Authorization
   */ CollaborativeAuthorizationResponseCode["ERROR"] = "ERROR";
    /** `Transaction` declined because the transaction exceeded the frequency limit */ CollaborativeAuthorizationResponseCode["EXCEEDS_FREQUENCY"] = "EXCEEDS_FREQUENCY";
    /** `Transaction` declined because the amount exceeded the transaction limit */ CollaborativeAuthorizationResponseCode["EXCEEDS_LIMIT"] = "EXCEEDS_LIMIT";
    /** `Transaction` declined due to insufficient funds */ CollaborativeAuthorizationResponseCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** `Transaction` declined because the cardholder is not a recognized driver */ CollaborativeAuthorizationResponseCode["INVALID_DRIVER"] = "INVALID_DRIVER";
    /** `Transaction` declined because the cardholder did not provide a recognized ID number */ CollaborativeAuthorizationResponseCode["INVALID_ID"] = "INVALID_ID";
    /** `Transaction` declined because the cardholder attempted a transaction outside of their defined working area */ CollaborativeAuthorizationResponseCode["INVALID_LOCATION"] = "INVALID_LOCATION";
    /** `Transaction` declined because transaction will not be allowed at this merchant. Use this code for merchants that will never be allowed. */ CollaborativeAuthorizationResponseCode["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    /** `Transaction` declined because transaction will not be allowed at this `MerchantCategory`. Use this code for categories that will never be allowed. */ CollaborativeAuthorizationResponseCode["INVALID_MERCHANT_CATEGORY_CODE"] = "INVALID_MERCHANT_CATEGORY_CODE";
    /** `Transaction` declined because it occurred outside allowed hours */ CollaborativeAuthorizationResponseCode["INVALID_PURCHASE_TIME"] = "INVALID_PURCHASE_TIME";
    /** `Transaction` declined because it failed a partner defined special condition */ CollaborativeAuthorizationResponseCode["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
    /** `Transaction` declined because the cardholder did not provide a recognized vehicle number */ CollaborativeAuthorizationResponseCode["INVALID_VEHICLE"] = "INVALID_VEHICLE";
    /** `Transaction` declined because manually entering card details is not permitted as a fraud prevention measure */ CollaborativeAuthorizationResponseCode["MANUAL_KEY_ENTERED_AT_POS"] = "MANUAL_KEY_ENTERED_AT_POS";
    /** `Transaction` approved for partial amount */ CollaborativeAuthorizationResponseCode["PARTIAL_AMOUNT_APPROVED"] = "PARTIAL_AMOUNT_APPROVED";
    /** `Transaction` declined because the merchant appears to be the cardholder */ CollaborativeAuthorizationResponseCode["PROHIBITED_SELFPAY"] = "PROHIBITED_SELFPAY";
    /**
   * `Transaction` declined because card was used in a restricted region or country
   * @deprecated Deprecated in favor of `RESTRICTED_LOCATION`
   */ CollaborativeAuthorizationResponseCode["RESTRICTED_CARD"] = "RESTRICTED_CARD";
    /** `Transaction` declined because the use of the card is restricted in the region or country where the transaction occurs */ CollaborativeAuthorizationResponseCode["RESTRICTED_LOCATION"] = "RESTRICTED_LOCATION";
    /** `Transaction` declined because transactions are currently blocked for the merchant. */ CollaborativeAuthorizationResponseCode["RESTRICTED_MERCHANT"] = "RESTRICTED_MERCHANT";
    /** `Transaction` declined because transactions are currently blocked for the merchant category code. */ CollaborativeAuthorizationResponseCode["RESTRICTED_MERCHANT_CATEGORY_CODE"] = "RESTRICTED_MERCHANT_CATEGORY_CODE";
    /** `Transaction` declined due to suspected fraudulent activity */ CollaborativeAuthorizationResponseCode["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    /**
   * System did not receive Collaborative Authorization response within the allotted time
   *
   * **Note:** This response code is not meant to be returned by the Collaborative Authorization Partner. It is used by Highnote to indicate a `Timeout` occurred during Collaborative Authorization
   */ CollaborativeAuthorizationResponseCode["TIMEOUT"] = "TIMEOUT";
    return CollaborativeAuthorizationResponseCode;
}({});
var $2f53fee15f29b056$export$eb1419974ed76369 = /*#__PURE__*/ function(CollaborativeAuthorizationStandIn) {
    /** Transactions should be approved if Subcriber does not respond to collaborative authorization request. */ CollaborativeAuthorizationStandIn["APPROVE"] = "APPROVE";
    /** Transactions should be declined if the Subscriber does not respond to collaborative authorization request. */ CollaborativeAuthorizationStandIn["DECLINE"] = "DECLINE";
    return CollaborativeAuthorizationStandIn;
}({});
var $2f53fee15f29b056$export$3d5dbcc39af14cec = /*#__PURE__*/ function(ComputeRegion) {
    ComputeRegion["ASIA"] = "ASIA";
    ComputeRegion["EUROPE"] = "EUROPE";
    ComputeRegion["USA"] = "USA";
    return ComputeRegion;
}({});
var $2f53fee15f29b056$export$acdcf497420f2642 = /*#__PURE__*/ function(CreateScheduledTransferClientTokenPermission) {
    /** Setting this permission will enable creation of a scheduled transfer. */ CreateScheduledTransferClientTokenPermission["CREATE_SCHEDULED_TRANSFER"] = "CREATE_SCHEDULED_TRANSFER";
    return CreateScheduledTransferClientTokenPermission;
}({});
var $2f53fee15f29b056$export$e1be463168cfec68 = /*#__PURE__*/ function(CreditBalanceType) {
    CreditBalanceType["BALANCE_TRANSFER"] = "BALANCE_TRANSFER";
    CreditBalanceType["CASH_ADVANCE"] = "CASH_ADVANCE";
    CreditBalanceType["INSTALLMENT"] = "INSTALLMENT";
    CreditBalanceType["PURCHASE"] = "PURCHASE";
    return CreditBalanceType;
}({});
var $2f53fee15f29b056$export$3bcdee6148409a64 = /*#__PURE__*/ function(CreditBureau) {
    /** Experian */ CreditBureau["EXPERIAN"] = "EXPERIAN";
    return CreditBureau;
}({});
var $2f53fee15f29b056$export$d7fdc872ed770744 = /*#__PURE__*/ function(CreditCardProductFeature) {
    /** Charge credit. */ CreditCardProductFeature["CHARGE"] = "CHARGE";
    /** Revolving credit. */ CreditCardProductFeature["REVOLVING"] = "REVOLVING";
    return CreditCardProductFeature;
}({});
var $2f53fee15f29b056$export$65d9cc1fc5d64285 = /*#__PURE__*/ function(CreditDecisionResult) {
    /** The cardholder has an active bankruptcy. */ CreditDecisionResult["ACTIVE_BANKRUPTCY"] = "ACTIVE_BANKRUPTCY";
    /** The cardholder's address could not be verified as provided. */ CreditDecisionResult["ADDRESS_MISMATCH"] = "ADDRESS_MISMATCH";
    /** The age of the oldest tradeline in the cardholders's credit report is too recent. */ CreditDecisionResult["AGE_OF_OLDEST_TRADELINE"] = "AGE_OF_OLDEST_TRADELINE";
    /** The cardholder has filed for bankruptcy in the past. */ CreditDecisionResult["BANKRUPTCY"] = "BANKRUPTCY";
    /** The cardholder has had a tradeline sent to collections in the past. */ CreditDecisionResult["COLLECTIONS"] = "COLLECTIONS";
    /** The cardholder has placed a fraud alert on their credit report. */ CreditDecisionResult["CREDIT_REPORT_FRAUD_ALERT"] = "CREDIT_REPORT_FRAUD_ALERT";
    /** The cardholder has placed a freeze on their credit report. */ CreditDecisionResult["CREDIT_REPORT_FREEZE"] = "CREDIT_REPORT_FREEZE";
    /**
   * The cardholder has current debt obligations that exceed the set threshold.
   * ***Note** This attribute is deprecated and will be removed in a future release. Please refer to the `EXCESSIVE_DEBT_OBLIGATIONS`.
   */ CreditDecisionResult["CURRENT_DEBT_OBLIGATIONS"] = "CURRENT_DEBT_OBLIGATIONS";
    /** The cardholder currently has delinquent tradelines. */ CreditDecisionResult["CURRENT_DELINQUENT_CREDIT_OBLIGATIONS"] = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS";
    /** The cardholder currently has tradelines more than 30 days delinquent. */ CreditDecisionResult["CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_30"] = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_30";
    /** The cardholder currently has tradelines more than 90 days delinquent. */ CreditDecisionResult["CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_90"] = "CURRENT_DELINQUENT_CREDIT_OBLIGATIONS_90";
    /** The cardholder is deceased. */ CreditDecisionResult["DECEASED"] = "DECEASED";
    /** The cardholder has credit obligations that are delinquent. */ CreditDecisionResult["DELINQUENT_CREDIT_OBLIGATIONS"] = "DELINQUENT_CREDIT_OBLIGATIONS";
    /** The date of birth provided does not match the date of birth of the cardholder. */ CreditDecisionResult["DOB_MISMATCH"] = "DOB_MISMATCH";
    /** The cardholder has current debt obligations that exceed the set threshold. */ CreditDecisionResult["EXCESSIVE_DEBT_OBLIGATIONS"] = "EXCESSIVE_DEBT_OBLIGATIONS";
    /** The cardholder has excessive payment obligations in relation to their income. */ CreditDecisionResult["EXCESSIVE_OBLIGATIONS_TO_INCOME"] = "EXCESSIVE_OBLIGATIONS_TO_INCOME";
    /** The cardholder has a foreclosure on their credit report. */ CreditDecisionResult["FORECLOSURE"] = "FORECLOSURE";
    /** The cardholder has high credit card utilization. */ CreditDecisionResult["HIGH_CREDIT_CARD_UTILIZATION"] = "HIGH_CREDIT_CARD_UTILIZATION";
    /** The cardholder has a high debt-to-income ratio. */ CreditDecisionResult["HIGH_DEBT_TO_INCOME"] = "HIGH_DEBT_TO_INCOME";
    /** The cardholder has a high debt-to-income ratio (excluding monthly housing payments). */ CreditDecisionResult["HIGH_DEBT_TO_INCOME_EXCLUDING_HOUSING"] = "HIGH_DEBT_TO_INCOME_EXCLUDING_HOUSING";
    /** The cardholder has high revolving credit card utilization. */ CreditDecisionResult["HIGH_REVOLVING_CREDIT_CARD_UTILIZATION"] = "HIGH_REVOLVING_CREDIT_CARD_UTILIZATION";
    /** The cardholder does not meet the minimum income requirement. */ CreditDecisionResult["INSUFFICIENT_INCOME"] = "INSUFFICIENT_INCOME";
    /** The cardholder has limited credit references or history */ CreditDecisionResult["LIMITED_CREDIT_EXPERIENCE"] = "LIMITED_CREDIT_EXPERIENCE";
    /** The cardholder does not meet the minimum credit score requirement. */ CreditDecisionResult["MIN_CREDIT_SCORE"] = "MIN_CREDIT_SCORE";
    /** The cardholder is eligible for Military Lending Act (MLA) privileges. */ CreditDecisionResult["MLA_ELIGIBLE"] = "MLA_ELIGIBLE";
    /** The name provided does not match any known names for the cardholder. */ CreditDecisionResult["NAME_MISMATCH"] = "NAME_MISMATCH";
    /** The cardholder has no credit history. */ CreditDecisionResult["NO_CREDIT_HISTORY"] = "NO_CREDIT_HISTORY";
    /** The cardholder has too many open accounts. */ CreditDecisionResult["NUMBER_OF_OPEN_ACCOUNTS"] = "NUMBER_OF_OPEN_ACCOUNTS";
    /** The cardholder has tradeline chargeoffs on their credit report. */ CreditDecisionResult["PAST_CHARGE_OFFS"] = "PAST_CHARGE_OFFS";
    /** The cardholder has had delinquent tradelines in the past. */ CreditDecisionResult["PAST_DELINQUENT_CREDIT_OBLIGATIONS"] = "PAST_DELINQUENT_CREDIT_OBLIGATIONS";
    /** The cardholder has had a bankruptcy discharged or dismissed recently. */ CreditDecisionResult["RECENT_BANKRUPTCY"] = "RECENT_BANKRUPTCY";
    /** The cardholder has had an account charge off recently. */ CreditDecisionResult["RECENT_CHARGE_OFF"] = "RECENT_CHARGE_OFF";
    /** The cardholder has opened lines of credit a number of times that exceed the set threshold. */ CreditDecisionResult["RECENT_CREDIT_ACCOUNTS"] = "RECENT_CREDIT_ACCOUNTS";
    /** The cardholder has applied for lines of credit a number of times that exceed the set threshold. */ CreditDecisionResult["RECENT_CREDIT_APPLICATIONS"] = "RECENT_CREDIT_APPLICATIONS";
    /** The cardholder has had a delinquent account recently. */ CreditDecisionResult["RECENT_DELINQUENCY"] = "RECENT_DELINQUENCY";
    /** The cardholder has recent inquiries that exceed the set threshold. */ CreditDecisionResult["RECENT_INQUIRIES"] = "RECENT_INQUIRIES";
    /** The cardholder's social security number could not be verified as provided. */ CreditDecisionResult["SSN_MISMATCH"] = "SSN_MISMATCH";
    return CreditDecisionResult;
}({});
var $2f53fee15f29b056$export$e06266fbec6eb8c = /*#__PURE__*/ function(CreditInstallmentEligibilityStatusForTransactionEvent) {
    /** Indicates that the `TransactionEvent` meets the `Amount` range for at least one active `CreditPlan` of `CreditBalanceType` `INSTALLMENT`, and that the `TransactionEvent` has not yet been converted into an `InstallmentAgreement`. */ CreditInstallmentEligibilityStatusForTransactionEvent["ELIGIBLE"] = "ELIGIBLE";
    /** Indicates that either the `TransactionEvent` does not have an `Amount` within range for an active `CreditPlan` of `CreditBalanceType` `INSTALLMENT`, or the `TransactionEvent` has already been converted into an `InstallmentAgreement`. */ CreditInstallmentEligibilityStatusForTransactionEvent["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
    return CreditInstallmentEligibilityStatusForTransactionEvent;
}({});
var $2f53fee15f29b056$export$a04b8730233db760 = /*#__PURE__*/ function(CreditLimitChangeRequestFailureReason) {
    CreditLimitChangeRequestFailureReason["NSF"] = "NSF";
    CreditLimitChangeRequestFailureReason["OTHER"] = "OTHER";
    return CreditLimitChangeRequestFailureReason;
}({});
var $2f53fee15f29b056$export$665182303f93cd6b = /*#__PURE__*/ function(CreditLimitChangeRequestStatus) {
    CreditLimitChangeRequestStatus["APPROVED"] = "APPROVED";
    CreditLimitChangeRequestStatus["CLOSED"] = "CLOSED";
    CreditLimitChangeRequestStatus["DENIED"] = "DENIED";
    CreditLimitChangeRequestStatus["FAILED"] = "FAILED";
    CreditLimitChangeRequestStatus["INITIATED"] = "INITIATED";
    CreditLimitChangeRequestStatus["PENDING"] = "PENDING";
    return CreditLimitChangeRequestStatus;
}({});
var $2f53fee15f29b056$export$88c97d7e3b7950f2 = /*#__PURE__*/ function(CreditLimitChangeRequestType) {
    CreditLimitChangeRequestType["DECREASE"] = "DECREASE";
    CreditLimitChangeRequestType["INCREASE"] = "INCREASE";
    return CreditLimitChangeRequestType;
}({});
var $2f53fee15f29b056$export$2a59f11939425fe3 = /*#__PURE__*/ function(CreditLimitChangeRequestor) {
    CreditLimitChangeRequestor["CUSTOMER"] = "CUSTOMER";
    CreditLimitChangeRequestor["SUBSCRIBER"] = "SUBSCRIBER";
    return CreditLimitChangeRequestor;
}({});
var $2f53fee15f29b056$export$6d23cda5d68f5628 = /*#__PURE__*/ function(CreditPlanDurationUnits) {
    /** The time between billings. At the end of a billing cycle, a `FinancialAccountStatement` is generated. Generally, there will be a grace period before Payment is due. */ CreditPlanDurationUnits["BILLING_CYCLES"] = "BILLING_CYCLES";
    return CreditPlanDurationUnits;
}({});
var $2f53fee15f29b056$export$93e8b80226be9de = /*#__PURE__*/ function(CreditPlanStatus) {
    CreditPlanStatus["ACTIVE"] = "ACTIVE";
    CreditPlanStatus["DEPRECATED"] = "DEPRECATED";
    CreditPlanStatus["INACTIVE"] = "INACTIVE";
    return CreditPlanStatus;
}({});
var $2f53fee15f29b056$export$f789d5075b3cf062 = /*#__PURE__*/ function(CreditPlanTemplateStatus) {
    CreditPlanTemplateStatus["ACTIVE"] = "ACTIVE";
    CreditPlanTemplateStatus["DEPRECATED"] = "DEPRECATED";
    CreditPlanTemplateStatus["INACTIVE"] = "INACTIVE";
    return CreditPlanTemplateStatus;
}({});
var $2f53fee15f29b056$export$8b78614dcb585231 = /*#__PURE__*/ function(CreditPlanType) {
    CreditPlanType["PROMOTIONAL"] = "PROMOTIONAL";
    CreditPlanType["STANDARD"] = "STANDARD";
    return CreditPlanType;
}({});
var $2f53fee15f29b056$export$5d160033684d6071 = /*#__PURE__*/ function(CreditRepaymentMethod) {
    CreditRepaymentMethod["ACH"] = "ACH";
    CreditRepaymentMethod["FEE_ADJUSTMENT"] = "FEE_ADJUSTMENT";
    CreditRepaymentMethod["INTEREST_ADJUSTMENT"] = "INTEREST_ADJUSTMENT";
    CreditRepaymentMethod["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
    CreditRepaymentMethod["REWARD_BALANCE"] = "REWARD_BALANCE";
    return CreditRepaymentMethod;
}({});
var $2f53fee15f29b056$export$f6b82af3da5d8926 = /*#__PURE__*/ function(CreditRepaymentType) {
    CreditRepaymentType["CREDIT"] = "CREDIT";
    CreditRepaymentType["DEBIT"] = "DEBIT";
    return CreditRepaymentType;
}({});
var $2f53fee15f29b056$export$aaca2b2df3a219f7 = /*#__PURE__*/ function(CreditStatementCyclePeriod) {
    CreditStatementCyclePeriod["MONTHLY"] = "MONTHLY";
    CreditStatementCyclePeriod["WEEKLY"] = "WEEKLY";
    return CreditStatementCyclePeriod;
}({});
var $2f53fee15f29b056$export$59a441afcf5e3ab4 = /*#__PURE__*/ function(CreditStatementGracePeriodType) {
    CreditStatementGracePeriodType["FIXED"] = "FIXED";
    CreditStatementGracePeriodType["FLOATING"] = "FLOATING";
    return CreditStatementGracePeriodType;
}({});
var $2f53fee15f29b056$export$83ebd0be722a768 = /*#__PURE__*/ function(CreditUnderwritingVerificationReviewStatusReasonCode) {
    /** The account holder has placed a freeze on their credit report. Their report must be unfrozen in order to process an application. */ CreditUnderwritingVerificationReviewStatusReasonCode["AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN"] = "AWAITING_CREDIT_REPORT_TO_BE_UNFROZEN";
    /** The account holder has placed a fraud alert on their credit report. Their application data must be verified by phone. */ CreditUnderwritingVerificationReviewStatusReasonCode["AWAITING_FRAUD_ALERT_REVIEW"] = "AWAITING_FRAUD_ALERT_REVIEW";
    return CreditUnderwritingVerificationReviewStatusReasonCode;
}({});
var $2f53fee15f29b056$export$62e31b675346aa81 = /*#__PURE__*/ function(DeliveryAttemptStatus) {
    /** The delivery attempt was unsuccessful with a non 200 OK response */ DeliveryAttemptStatus["FAILURE"] = "FAILURE";
    /** The delivery attempt was skipped because the target was deactivated */ DeliveryAttemptStatus["SKIPPED"] = "SKIPPED";
    /** The delivery attempt was successful with a 200 OK response */ DeliveryAttemptStatus["SUCCESS"] = "SUCCESS";
    return DeliveryAttemptStatus;
}({});
var $2f53fee15f29b056$export$f9103fc209a992ff = /*#__PURE__*/ function(DepositProcessingNetwork) {
    /** Accel Processing Network */ DepositProcessingNetwork["ACCEL"] = "ACCEL";
    /** Accel Card Free Cash Processing Network */ DepositProcessingNetwork["ACCEL_CARD_FREE_CASH"] = "ACCEL_CARD_FREE_CASH";
    /** Accel Nebraska Processing Network */ DepositProcessingNetwork["ACCEL_NEBRASKA"] = "ACCEL_NEBRASKA";
    /** Accel No Pin Processing Network */ DepositProcessingNetwork["ACCEL_NO_PIN"] = "ACCEL_NO_PIN";
    /** Accel Surcharge Free Processing Network */ DepositProcessingNetwork["ACCEL_SURCHARGE_FREE"] = "ACCEL_SURCHARGE_FREE";
    /** AFFN Processing Network */ DepositProcessingNetwork["AFFN"] = "AFFN";
    /** AFFN High Ticket POS Processing Network */ DepositProcessingNetwork["AFFN_HIGH_TICKET_POS"] = "AFFN_HIGH_TICKET_POS";
    /** AFFN Low Ticket POS Processing Network */ DepositProcessingNetwork["AFFN_LOW_TICKET_POS"] = "AFFN_LOW_TICKET_POS";
    /** AFFN Reciprocal Processing Network */ DepositProcessingNetwork["AFFN_RECIPROCAL"] = "AFFN_RECIPROCAL";
    /** Alaska Option Processing Network */ DepositProcessingNetwork["ALASKA_OPTION"] = "ALASKA_OPTION";
    /** Allpoint Processing Network */ DepositProcessingNetwork["ALLPOINT_NETWORK"] = "ALLPOINT_NETWORK";
    /** American Express ATM Processing Network */ DepositProcessingNetwork["AMERICAN_EXPRESS_ATM"] = "AMERICAN_EXPRESS_ATM";
    /** Cirrus ATM Processing Network */ DepositProcessingNetwork["CIRRUS_ATM"] = "CIRRUS_ATM";
    /** Cirrus Europe Acquired Dual Message Processing Network */ DepositProcessingNetwork["CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE"] = "CIRRUS_EUROPE_ACQUIRED_DUAL_MESSAGE";
    /** Credit Union Cooperative ATM Processing Network */ DepositProcessingNetwork["CREDIT_UNION_COOPERATIVE_ATM"] = "CREDIT_UNION_COOPERATIVE_ATM";
    /** CU24 Processing Network */ DepositProcessingNetwork["CU24"] = "CU24";
    /** Culinace Processing Network */ DepositProcessingNetwork["CULIANCE"] = "CULIANCE";
    /** Culinace Cuhere MoneyPass Reciprocal Processing Network */ DepositProcessingNetwork["CULIANCE_CUHERE_MONEYPASS_RECIPROCAL"] = "CULIANCE_CUHERE_MONEYPASS_RECIPROCAL";
    /** Culinace Cuhere Presto Processing Network */ DepositProcessingNetwork["CULIANCE_CUHERE_PRESTO_PUBLIX"] = "CULIANCE_CUHERE_PRESTO_PUBLIX";
    /** Culinace Cuhere Processing Network */ DepositProcessingNetwork["CULIANCE_CUHERE_PROGRAM"] = "CULIANCE_CUHERE_PROGRAM";
    /** Culince Nyce Reciprocal Processing Network */ DepositProcessingNetwork["CULIANCE_NYCE_RECIPROCAL"] = "CULIANCE_NYCE_RECIPROCAL";
    /** Culinace Pinless Low Value POS Processing Network */ DepositProcessingNetwork["CULIANCE_PINLESS_LOW_VALUE_POS"] = "CULIANCE_PINLESS_LOW_VALUE_POS";
    /** Discover ATM Processing Network */ DepositProcessingNetwork["DISCOVER_ATM"] = "DISCOVER_ATM";
    /** EBT ATM Processing Network */ DepositProcessingNetwork["EBT_ATM"] = "EBT_ATM";
    /** EBT POS Processing Network */ DepositProcessingNetwork["EBT_POS"] = "EBT_POS";
    /** EBT Processing Network */ DepositProcessingNetwork["EBT_PROGRAMS"] = "EBT_PROGRAMS";
    /** Interlink Processing Network */ DepositProcessingNetwork["INTERLINK"] = "INTERLINK";
    /** Maestro Processing Network */ DepositProcessingNetwork["MAESTRO"] = "MAESTRO";
    /** Maestro Europe Acquirer Dual Message Processing Network */ DepositProcessingNetwork["MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE"] = "MAESTRO_EUROPE_ACQUIRER_DUAL_MESSAGE";
    /** Mastercard ATM Processing Network */ DepositProcessingNetwork["MASTERCARD_ATM"] = "MASTERCARD_ATM";
    /** Mastercard Dual Message Processing Network */ DepositProcessingNetwork["MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM"] = "MASTERCARD_DUAL_MESSAGE_AUTHORIZATION_SYSTEM";
    /** Mastercard Single Message Processing Network */ DepositProcessingNetwork["MASTERCARD_SINGLE_MESSAGE_SYSTEM"] = "MASTERCARD_SINGLE_MESSAGE_SYSTEM";
    /** MoneyPass Processing Network */ DepositProcessingNetwork["MONEY_PASS"] = "MONEY_PASS";
    /** MoneyPass ATM Nebraska Processing Network */ DepositProcessingNetwork["MONEY_PASS_ATM_NEBRASKA"] = "MONEY_PASS_ATM_NEBRASKA";
    /** MoneyPass ATM Star Processing Network */ DepositProcessingNetwork["MONEY_PASS_ATM_STAR"] = "MONEY_PASS_ATM_STAR";
    /** NETS Processing Network */ DepositProcessingNetwork["NETS"] = "NETS";
    /** NYCE Processing Network */ DepositProcessingNetwork["NYCE"] = "NYCE";
    /** NYCE AFFN Reciprocal Processing Network */ DepositProcessingNetwork["NYCE_AFFN_RECIPROCAL"] = "NYCE_AFFN_RECIPROCAL";
    /** NYCE Cross Border Processing Network */ DepositProcessingNetwork["NYCE_CROSS_BORDER"] = "NYCE_CROSS_BORDER";
    /** NYCE Culiance Reciprocal Processing Network */ DepositProcessingNetwork["NYCE_CULIANCE_RECIPROCAL"] = "NYCE_CULIANCE_RECIPROCAL";
    /** NYCE Direct Settlement Link Processing Network */ DepositProcessingNetwork["NYCE_DIRECT_SETTLEMENT_LINK"] = "NYCE_DIRECT_SETTLEMENT_LINK";
    /** NYCE Ecommerce Processing Network */ DepositProcessingNetwork["NYCE_ECOMMERCE"] = "NYCE_ECOMMERCE";
    /** NYCE International Reciprocal Group 1 Processing Network */ DepositProcessingNetwork["NYCE_INTERNATIONAL_RECIPROCAL_GROUP1"] = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP1";
    /** NYCE International Reciprocal Group 2 Processing Network */ DepositProcessingNetwork["NYCE_INTERNATIONAL_RECIPROCAL_GROUP2"] = "NYCE_INTERNATIONAL_RECIPROCAL_GROUP2";
    /** NYCE Pinless POS Processing Network */ DepositProcessingNetwork["NYCE_PINLESS_POS"] = "NYCE_PINLESS_POS";
    /** Plus ATM Processing Network */ DepositProcessingNetwork["PLUS_ATM"] = "PLUS_ATM";
    /** Primary Routing or Generic File Update */ DepositProcessingNetwork["PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE"] = "PRIMARY_ROUTING_OR_GENERIC_FILE_UPDATE";
    /** Pulse Processing Network */ DepositProcessingNetwork["PULSE"] = "PULSE";
    /** Pulse Accel Processing Network */ DepositProcessingNetwork["PULSE_ACCEL_RECIPROCAL"] = "PULSE_ACCEL_RECIPROCAL";
    /** Pulse Affn Reciprocal Processing Network */ DepositProcessingNetwork["PULSE_AFFN_RECIPROCAL"] = "PULSE_AFFN_RECIPROCAL";
    /** Pulse Canada Processing Network */ DepositProcessingNetwork["PULSE_CANADA"] = "PULSE_CANADA";
    /** Pulse Direct Settlement Link Processing Network */ DepositProcessingNetwork["PULSE_DIRECT_SETTLEMENT_LINK"] = "PULSE_DIRECT_SETTLEMENT_LINK";
    /** Pulse Mexico Processing Network */ DepositProcessingNetwork["PULSE_MEXICO"] = "PULSE_MEXICO";
    /** Pulse Pay Express Processing Network */ DepositProcessingNetwork["PULSE_PAY_EXPRESS"] = "PULSE_PAY_EXPRESS";
    /** Pulse Select Processing Network */ DepositProcessingNetwork["PULSE_SELECT"] = "PULSE_SELECT";
    /** Shazam Processing Network */ DepositProcessingNetwork["SHAZAM"] = "SHAZAM";
    /** Star Processing Network */ DepositProcessingNetwork["STAR"] = "STAR";
    /** Star Access Processing Network */ DepositProcessingNetwork["STAR_ACCESS"] = "STAR_ACCESS";
    /** Star BC Card Korea Reciprocal Processing Network */ DepositProcessingNetwork["STAR_BC_CARD_KOREA_RECIPROCAL"] = "STAR_BC_CARD_KOREA_RECIPROCAL";
    /** Star Direct Settlement Link Processing Network */ DepositProcessingNetwork["STAR_DIRECT_SETTLEMENT_LINK"] = "STAR_DIRECT_SETTLEMENT_LINK";
    /** Star Publix Presto Processing Network */ DepositProcessingNetwork["STAR_PUBLIX_PRESTO"] = "STAR_PUBLIX_PRESTO";
    /** Star Rapidflash Processing Network */ DepositProcessingNetwork["STAR_RAPIDFLASH"] = "STAR_RAPIDFLASH";
    /** Star SF Processing Network */ DepositProcessingNetwork["STAR_SF"] = "STAR_SF";
    /** Unknown Processing Network */ DepositProcessingNetwork["UNKNOWN"] = "UNKNOWN";
    /** Visa Processing Network */ DepositProcessingNetwork["VISA"] = "VISA";
    /** Visa Direct Processing Network */ DepositProcessingNetwork["VISA_DIRECT"] = "VISA_DIRECT";
    /** Visa Direct Settlement Link Processing Network */ DepositProcessingNetwork["VISA_DIRECT_SETTLEMENT_LINK"] = "VISA_DIRECT_SETTLEMENT_LINK";
    /** Visa Singapore Direct Settlement Link Processing Network */ DepositProcessingNetwork["VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK"] = "VISA_SINGAPORE_DIRECT_SETTLEMENT_LINK";
    return DepositProcessingNetwork;
}({});
var $2f53fee15f29b056$export$a08fa8a02e2d2ca4 = /*#__PURE__*/ function(DevicePaymentType) {
    /** Digital Secure Remote Payment */ DevicePaymentType["DSRP"] = "DSRP";
    /** Ecommerce payment type. */ DevicePaymentType["ECOMMERCE"] = "ECOMMERCE";
    /** Near Field Communication payment type. */ DevicePaymentType["NFC"] = "NFC";
    return DevicePaymentType;
}({});
var $2f53fee15f29b056$export$56e7ddb3f3f06853 = /*#__PURE__*/ function(DigitalWalletProvider) {
    /** Apple Pay */ DigitalWalletProvider["APPLE_PAY"] = "APPLE_PAY";
    /** Google Pay */ DigitalWalletProvider["GOOGLE_PAY"] = "GOOGLE_PAY";
    /** Samsung Pay */ DigitalWalletProvider["SAMSUNG_PAY"] = "SAMSUNG_PAY";
    return DigitalWalletProvider;
}({});
var $2f53fee15f29b056$export$f7bdf4029179ea8b = /*#__PURE__*/ function(DigitalWalletTokenStatus) {
    /** The `CardDigitalWalletToken` is active and ready for use. */ DigitalWalletTokenStatus["ACTIVE"] = "ACTIVE";
    /** The `CardDigitalWalletToken` is requested and pending activation. */ DigitalWalletTokenStatus["REQUESTED"] = "REQUESTED";
    /** The `CardDigitalWalletToken` has been suspended and authorizations will fail until the `CardDigitalWalletToken` is `ACTIVE` again. */ DigitalWalletTokenStatus["SUSPENDED"] = "SUSPENDED";
    /** The `CardDigitalWalletToken` has been terminated and all future authorizations will fail. */ DigitalWalletTokenStatus["TERMINATED"] = "TERMINATED";
    return DigitalWalletTokenStatus;
}({});
var $2f53fee15f29b056$export$6346cbfc5cf0eadb = /*#__PURE__*/ function(DigitalWalletTokenStatusChangeReason) {
    /** Financial Account has been closed. */ DigitalWalletTokenStatusChangeReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** Cardholder Account has been closed by issuer. */ DigitalWalletTokenStatusChangeReason["ACCOUNT_HOLDER_DELETED"] = "ACCOUNT_HOLDER_DELETED";
    /** Cardholder successfully authenticated with an activation method. */ DigitalWalletTokenStatusChangeReason["ACTIVATION_METHOD"] = "ACTIVATION_METHOD";
    /** Cardholder called customer agent for verification. */ DigitalWalletTokenStatusChangeReason["CUSTOMER_SERVICE_AGENT"] = "CUSTOMER_SERVICE_AGENT";
    /** Cardholder reported token device found. */ DigitalWalletTokenStatusChangeReason["DEVICE_FOUND"] = "DEVICE_FOUND";
    /** Cardholder reported token device lost. */ DigitalWalletTokenStatusChangeReason["DEVICE_LOST"] = "DEVICE_LOST";
    /** Cardholder reported token device stolen. */ DigitalWalletTokenStatusChangeReason["DEVICE_STOLEN"] = "DEVICE_STOLEN";
    /** Issuer or Cardholder reported fraudulent token transactions. */ DigitalWalletTokenStatusChangeReason["FRAUDULENT_TRANSACTIONS"] = "FRAUDULENT_TRANSACTIONS";
    /** Network request. */ DigitalWalletTokenStatusChangeReason["NETWORK_INITIATED"] = "NETWORK_INITIATED";
    /** Issuer or Cardholder reported no fraudulent token transactions. */ DigitalWalletTokenStatusChangeReason["NON_FRAUDULENT_TRANSACTIONS"] = "NON_FRAUDULENT_TRANSACTIONS";
    /** Other reason. */ DigitalWalletTokenStatusChangeReason["OTHER"] = "OTHER";
    return DigitalWalletTokenStatusChangeReason;
}({});
var $2f53fee15f29b056$export$5f40274525939b = /*#__PURE__*/ function(DirectDepositDetailClientTokenPermission) {
    /**
   * Read `accountNumber` for Direct Deposit Details.
   *
   * Setting this permission will allow using the token to query for a DirectDepositDetail and read its `restrictedDetails` property.
   */ DirectDepositDetailClientTokenPermission["READ_RESTRICTED_DETAILS"] = "READ_RESTRICTED_DETAILS";
    return DirectDepositDetailClientTokenPermission;
}({});
var $2f53fee15f29b056$export$93e4bf2c0353cec1 = /*#__PURE__*/ function(DisbursementTransferEventFailureReason) {
    /** The originating and receiving account do not belong to same product. */ DisbursementTransferEventFailureReason["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The originating or receiving account is closed. */ DisbursementTransferEventFailureReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The originating or receiving account is not active. */ DisbursementTransferEventFailureReason["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The originating or receiving account was not found. */ DisbursementTransferEventFailureReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The originating or receiving account not provided. */ DisbursementTransferEventFailureReason["ACCOUNT_NOT_PROVIDED"] = "ACCOUNT_NOT_PROVIDED";
    /** Ach load is not allowed by program. */ DisbursementTransferEventFailureReason["ACH_LOAD_NOT_ALLOWED_BY_PROGRAM"] = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM";
    /** Card funding feature not enabled on account. */ DisbursementTransferEventFailureReason["CARD_FUNDING_FEATURE_NOT_ENABLED"] = "CARD_FUNDING_FEATURE_NOT_ENABLED";
    /** Cash fund out not supported on product. */ DisbursementTransferEventFailureReason["CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT"] = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT";
    /** Commercial credit Pay In Full card feature is not enabled on account. */ DisbursementTransferEventFailureReason["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** Corporate bank account feature is not enabled. */ DisbursementTransferEventFailureReason["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Credit card feature is not enabled on account. */ DisbursementTransferEventFailureReason["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** The originating account does not have credit limit set. */ DisbursementTransferEventFailureReason["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The originating and receiving account have different currency. */ DisbursementTransferEventFailureReason["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** Dda feature is not enabled on account. */ DisbursementTransferEventFailureReason["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** Debit card feature is not enabled on account. */ DisbursementTransferEventFailureReason["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** Fleet card feature is not enabled on account. */ DisbursementTransferEventFailureReason["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** Funding account feature is not enabled on account. */ DisbursementTransferEventFailureReason["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Product funding feature is not enabled on account. */ DisbursementTransferEventFailureReason["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** Idempotency Key not provided. */ DisbursementTransferEventFailureReason["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The originating account of the FeeTransferEvent did not have enough funds to cover the requested amount. */ DisbursementTransferEventFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The amount specified for the disbursement is invalid. */ DisbursementTransferEventFailureReason["INVALID_DISBURSEMENT_AMOUNT"] = "INVALID_DISBURSEMENT_AMOUNT";
    /** Merchant settlement is not enabled on this account. */ DisbursementTransferEventFailureReason["MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED"] = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED";
    /** The originating or receiving account does not belong to the organization. */ DisbursementTransferEventFailureReason["NOT_AN_ORGANIZATION_OWNED_ACCOUNT"] = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT";
    /** The originating account does not have enough balance to reduce credit limit. */ DisbursementTransferEventFailureReason["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** Organization not provided. */ DisbursementTransferEventFailureReason["ORGANIZATION_ID_NOT_PROVIDED"] = "ORGANIZATION_ID_NOT_PROVIDED";
    /** Originated ach unload not supported on product */ DisbursementTransferEventFailureReason["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** Payroll advance feature not enabled. */ DisbursementTransferEventFailureReason["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** Payroll employer advance feature not enabled. */ DisbursementTransferEventFailureReason["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** Prepaid card feature is not enabled on account. */ DisbursementTransferEventFailureReason["PREPAID_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_FEATURE_NOT_ENABLED";
    /** Product funding feature is not enabled on account. */ DisbursementTransferEventFailureReason["PRODUCT_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED";
    /** Reward point feature not enabled. */ DisbursementTransferEventFailureReason["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    /** Secured card feature is not enabled on account. */ DisbursementTransferEventFailureReason["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** Tenant Id is not provided. */ DisbursementTransferEventFailureReason["TENANT_ID_NOT_PROVIDED"] = "TENANT_ID_NOT_PROVIDED";
    /** Transaction Id not provided. */ DisbursementTransferEventFailureReason["TRANSACTION_ID_NOT_PROVIDED"] = "TRANSACTION_ID_NOT_PROVIDED";
    /** Transfer amount below program minimum reload limit. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT";
    /** The requested amount exceeds the maximum aggregate credit distribution amount. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT";
    /** Transfer amount exceeding maximum program card balance. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE";
    /** Transfer amount exceeds allowed max program load limit. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** Transfer amount exceeds allowed max program reload limit. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT";
    /** Transfer amount is negative or zero. */ DisbursementTransferEventFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** Accounts do not have same primary account holder. */ DisbursementTransferEventFailureReason["TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED"] = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED";
    /** Transfer is not supported on product. */ DisbursementTransferEventFailureReason["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    /**
   * The `DisbursementTransferEvent` failure reason is unspecified.
   *
   * Contact Highnote support for more information.
   */ DisbursementTransferEventFailureReason["UNSPECIFIED"] = "UNSPECIFIED";
    return DisbursementTransferEventFailureReason;
}({});
var $2f53fee15f29b056$export$68038764add57735 = /*#__PURE__*/ function(DisbursementTransferEventStatus) {
    /** The `DisbursementTransferEvent` status is completed. */ DisbursementTransferEventStatus["COMPLETED"] = "COMPLETED";
    /** The `DisbursementTransferEvent` status is failed. */ DisbursementTransferEventStatus["FAILED"] = "FAILED";
    /** The `DisbursementTransferEvent` status is pending. */ DisbursementTransferEventStatus["PENDING"] = "PENDING";
    /**
   * The `DisbursementTransferEvent` status is unspecified.
   *
   * Contact Highnote support for more information.
   */ DisbursementTransferEventStatus["UNSPECIFIED"] = "UNSPECIFIED";
    return DisbursementTransferEventStatus;
}({});
var $2f53fee15f29b056$export$ad0621452983ea89 = /*#__PURE__*/ function(DisbursementTransferEventType) {
    /** The `DisbursementTransferEvent` type is a carry over event. */ DisbursementTransferEventType["DISBURSEMENT_CARRY_OVER"] = "DISBURSEMENT_CARRY_OVER";
    /** The `DisbursementTransferEvent` type is a chargeback fee event. */ DisbursementTransferEventType["DISBURSEMENT_CHARGEBACK_FEE"] = "DISBURSEMENT_CHARGEBACK_FEE";
    /** The `DisbursementTransferEvent` type is for an interchange fee. */ DisbursementTransferEventType["DISBURSEMENT_INTERCHANGE_FEE"] = "DISBURSEMENT_INTERCHANGE_FEE";
    /** The `DisbursementTransferEvent` type is an interchange fee precision adjustment event. */ DisbursementTransferEventType["DISBURSEMENT_INTERCHANGE_FEE_PRECISION_ADJUSTMENT"] = "DISBURSEMENT_INTERCHANGE_FEE_PRECISION_ADJUSTMENT";
    /** The `DisbursementTransferEvent` type is for a network fee. */ DisbursementTransferEventType["DISBURSEMENT_NETWORK_FEE"] = "DISBURSEMENT_NETWORK_FEE";
    /** The `DisbursementTransferEvent` type is a payable event. */ DisbursementTransferEventType["DISBURSEMENT_PAYABLE"] = "DISBURSEMENT_PAYABLE";
    /** The `DisbursementTransferEvent` type is a payment event. */ DisbursementTransferEventType["DISBURSEMENT_PAYMENT"] = "DISBURSEMENT_PAYMENT";
    /** The `DisbursementTransferEvent` type is a payout payable event. */ DisbursementTransferEventType["DISBURSEMENT_PAYOUT_PAYABLE"] = "DISBURSEMENT_PAYOUT_PAYABLE";
    /** The `DisbursementTransferEvent` type is for a platform fee. */ DisbursementTransferEventType["DISBURSEMENT_PLATFORM_FEE"] = "DISBURSEMENT_PLATFORM_FEE";
    /**
   * The `DisbursementTransferEvent` type is unspecified.
   *
   * Contact Highnote support for more information.
   */ DisbursementTransferEventType["UNSPECIFIED"] = "UNSPECIFIED";
    return DisbursementTransferEventType;
}({});
var $2f53fee15f29b056$export$caa04b8e11542534 = /*#__PURE__*/ function(DistanceUnit) {
    /** A unit of distance in the metric system. */ DistanceUnit["KILOMETER"] = "KILOMETER";
    /** A British imperial unit and US customary unit of distance. */ DistanceUnit["MILE"] = "MILE";
    return DistanceUnit;
}({});
var $2f53fee15f29b056$export$f144f067598462b8 = /*#__PURE__*/ function(DocumentCategoryType) {
    /** A primary document */ DocumentCategoryType["PRIMARY_DOCUMENT_TYPE"] = "PRIMARY_DOCUMENT_TYPE";
    /** A secondary document */ DocumentCategoryType["SECONDARY_DOCUMENT_TYPE"] = "SECONDARY_DOCUMENT_TYPE";
    /** A supporting document type */ DocumentCategoryType["SUPPORTING_DOCUMENT_TYPE"] = "SUPPORTING_DOCUMENT_TYPE";
    return DocumentCategoryType;
}({});
var $2f53fee15f29b056$export$d1d99cf900472499 = /*#__PURE__*/ function(DocumentType) {
    /** The signature of the account holder */ DocumentType["ACCOUNT_HOLDER_SIGNATURE"] = "ACCOUNT_HOLDER_SIGNATURE";
    /**
   * Articles of incorporation for a business
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["ARTICLES_OF_INCORPORATION"] = "ARTICLES_OF_INCORPORATION";
    /** An insurance document related to an insurance policy on an automobile */ DocumentType["AUTO_INSURANCE"] = "AUTO_INSURANCE";
    /**
   * A printed record of the balance in a bank account and the amounts that have been paid into it and withdrawn from it, issued periodically to the holder of the account.
   *
   * The bank statement must be dated within the last 60 days.
   *
   * The document must show the account holder's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */ DocumentType["BANK_STATEMENT"] = "BANK_STATEMENT";
    /** A birth certificate */ DocumentType["BIRTH_CERTIFICATE"] = "BIRTH_CERTIFICATE";
    /** The official document for complete information pertaining to your brokerage account's value, holdings, and activity */ DocumentType["BROKERAGE_STATEMENT"] = "BROKERAGE_STATEMENT";
    /**
   * Permits issued by government agencies that allow individuals or companies to conduct business within the government's geographical jurisdiction.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["BUSINESS_LICENSE"] = "BUSINESS_LICENSE";
    /**
   * Business registration issued by the Secretary of State.
   *
   * The business registration must be current and active within the State where the Business operates.
   *
   *  The document must show the business name and full physical address.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["BUSINESS_REGISTRATION"] = "BUSINESS_REGISTRATION";
    /** A cable bill is an account or bill for the charges for access to paid television. */ DocumentType["CABLE_BILL"] = "CABLE_BILL";
    /** A document confirming citizenship */ DocumentType["CERTIFICATE_OF_CITIZENSHIP"] = "CERTIFICATE_OF_CITIZENSHIP";
    /**
   * A document indicating that the business has filed all reports and fees with the Secretary of State's office.
   * It serves as proof, or evidence, that the entity exists and is authorized to transact business in the state
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["CERTIFICATE_OF_GOOD_STANDING"] = "CERTIFICATE_OF_GOOD_STANDING";
    /** A military record indicating an individuals release or dischage from active duty */ DocumentType["CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY"] = "CERTIFICATE_OF_RELEASE_OR_DISCHARGE_FROM_ACTIVE_DUTY";
    /** A legal name change document provided by the court */ DocumentType["COURT_ORDER_FOR_LEGAL_NAME_CHANGE"] = "COURT_ORDER_FOR_LEGAL_NAME_CHANGE";
    /** The card art is the background image of a Digital Card */ DocumentType["DIGITAL_BACKGROUND"] = "DIGITAL_BACKGROUND";
    /** The card art document is a front image of a Digital Card */ DocumentType["DIGITAL_FRONT_OF_CARD"] = "DIGITAL_FRONT_OF_CARD";
    /** The card art is the icon image of a Digital Card */ DocumentType["DIGITAL_ICON"] = "DIGITAL_ICON";
    /** The card art is the logo image of a Digital Card */ DocumentType["DIGITAL_LOGO"] = "DIGITAL_LOGO";
    /** A certificate of a divorce */ DocumentType["DIVORCE_DECREE"] = "DIVORCE_DECREE";
    /**
   * A document permitting a person to drive a motor vehicle.
   *
   * The driver's license must be unexpired and valid.
   *
   * The document must show the driver's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */ DocumentType["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    /**
   * Federal Employer Identification Number
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER"] = "FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER";
    /** A report on mortgage interest (including points, defined later) of $600 or more you received during the year in the course of your trade or business from an individual, including a sole proprietor */ DocumentType["FORM_1098"] = "FORM_1098";
    /** A collection of tax forms documenting different types of payments made by an individual or a business that typically isn't your employer */ DocumentType["FORM_1099"] = "FORM_1099";
    /** A form submitted by the trustee or issuer of your individual retirement arrangement (IRA) to report contributions, including any catch-up contributions, required minimum distributions (RMDs), and the fair market value (FMV) of the account */ DocumentType["FORM_5498"] = "FORM_5498";
    /**
   * IRS Form CP-575 - Confirmation of Federal Employer Identification Number letter.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["FORM_CP_575"] = "FORM_CP_575";
    /** An insurance document related to an insurance policy on the health of the policy holder */ DocumentType["HEALTH_INSURANCE"] = "HEALTH_INSURANCE";
    /** An internet bill is an account or bill for the charges for access to internet. */ DocumentType["INTERNET_BILL"] = "INTERNET_BILL";
    /** A federal tax returrn issued by United States of America Internal Revenue Service. */ DocumentType["IRS_ISSUED_FEDERAL_TAX_RETURN"] = "IRS_ISSUED_FEDERAL_TAX_RETURN";
    /** A state tax return issued by a state in the United States. */ DocumentType["IRS_ISSUED_STATE_TAX_RETURN"] = "IRS_ISSUED_STATE_TAX_RETURN";
    /**
   * A business tax return, indicating taxes filed for the filing year, proving the business is current with IRS filing requirements.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["IRS_ISSUED_TAX_RETURN"] = "IRS_ISSUED_TAX_RETURN";
    /**
   * A contractual arrangement calling for the user to pay the owner for use of property.
   *
   * The lease agreement must be current and valid.
   *
   * The document must show the user's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */ DocumentType["LEASE_AGREEMENT"] = "LEASE_AGREEMENT";
    /** An insurance document related to an insurance policy on the life of the policy holder */ DocumentType["LIFE_INSURANCE"] = "LIFE_INSURANCE";
    /** A certificate of marriage */ DocumentType["MARRIAGE_CERTIFICATE"] = "MARRIAGE_CERTIFICATE";
    /** A document representing the medicare card */ DocumentType["MEDICARE_CARD"] = "MEDICARE_CARD";
    /** An identification card issued by a municipality */ DocumentType["MUNICIPAL_ID"] = "MUNICIPAL_ID";
    /**
   * Non Profit 501c3 charter for a business
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["NON_PROFIT_501_C3"] = "NON_PROFIT_501_C3";
    /**
   * A key document used by limited liability companies (LLCs)  to outline the business' financial and functional decisions including rules, regulations, and provisions.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["OPERATING_AGREEMENT"] = "OPERATING_AGREEMENT";
    /**
   * A legal document that dictates the way a business is run and details the relationship between each partner
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["PARTNERSHIP_AGREEMENT"] = "PARTNERSHIP_AGREEMENT";
    /** An official document issued by a government, certifying the holder's identity and citizenship and entitling them to travel under its protection to and from foreign countries */ DocumentType["PASSPORT"] = "PASSPORT";
    /** A document issued by an employer to pay an employee for services rendered. */ DocumentType["PAY_STUB"] = "PAY_STUB";
    /** A phone bill is an account or bill for the charges for a telephone and line and for calls made from it */ DocumentType["PHONE_BILL"] = "PHONE_BILL";
    /** The card art document is a back image of a Physical Card */ DocumentType["PHYSICAL_BACK_OF_CARD"] = "PHYSICAL_BACK_OF_CARD";
    /** The card art document is a front image of a Physical Card */ DocumentType["PHYSICAL_FRONT_OF_CARD"] = "PHYSICAL_FRONT_OF_CARD";
    /** The identification card and associated number used by the State or Federal entity to track an inmate */ DocumentType["PRISON_ID"] = "PRISON_ID";
    /** All certified document(s) granted to applicant at the time of discharge from a correctional institution */ DocumentType["PRISON_RELEASE_PAPERWORK"] = "PRISON_RELEASE_PAPERWORK";
    /** A social security card */ DocumentType["SOCIAL_SECURITY_CARD"] = "SOCIAL_SECURITY_CARD";
    /**
   * Identification Document representing a social security card
   *
   * **Note: ** A social security for a business is only accepted for business' that are sole proprietorships.
   */ DocumentType["SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD"] = "SOLE_PROPRIETOR_SOCIAL_SECURITY_CARD";
    /** A summary of the investments in a 401k retirement account */ DocumentType["STATEMENT_401K"] = "STATEMENT_401K";
    /** A document that many consulates issue to identify the citizens of their country who reside abroad */ DocumentType["STATE_CONSULAR_IDENTIFICATION_CARD"] = "STATE_CONSULAR_IDENTIFICATION_CARD";
    /** A state issued benefit card */ DocumentType["STATE_ISSUED_BENEFIT_CARD"] = "STATE_ISSUED_BENEFIT_CARD";
    /** A State ID Card is a government issued form of identification containing personal and biometric information, that allows its holder to prove their identity and citizenship. */ DocumentType["STATE_ISSUED_ID"] = "STATE_ISSUED_ID";
    /** A state issued permit */ DocumentType["STATE_ISSUED_PERMIT"] = "STATE_ISSUED_PERMIT";
    /** Tribal identification cards are issued by tribes as proof of your enrollment and membership in the tribe */ DocumentType["STATE_TRIBAL_ID"] = "STATE_TRIBAL_ID";
    /** An identity document used by nationals of Mexico to enter the United States. */ DocumentType["STATE_US_BORDER_CROSSING_CARD"] = "STATE_US_BORDER_CROSSING_CARD";
    /** An identity document indicating the right to employment within the United States of America. */ DocumentType["STATE_US_EMPLOYMENT_AUTHORIZATION_CARD"] = "STATE_US_EMPLOYMENT_AUTHORIZATION_CARD";
    /** An identification document issued by the United State of America Military Armed Forces */ DocumentType["STATE_US_MILITARY_ARMED_FORCES_ID"] = "STATE_US_MILITARY_ARMED_FORCES_ID";
    /** An permanent resident card issued by the United State of America */ DocumentType["STATE_US_PERMANENT_RESIDENT_CARD"] = "STATE_US_PERMANENT_RESIDENT_CARD";
    /**
   * Confirmation of application submission - Tax ID Number.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["TAX_ID_APPLICATION"] = "TAX_ID_APPLICATION";
    /**
   * An estate planning document that allows the business to transfer ownership of its assets to a third party.
   *
   * **Note: ** To be used only for a business account holder type
   */ DocumentType["TRUST_AGREEMENT"] = "TRUST_AGREEMENT";
    /** A document representing a record of service in the US military */ DocumentType["US_MILITARY_RECORD_OF_SERVICE"] = "US_MILITARY_RECORD_OF_SERVICE";
    /** A tax form from the United States */ DocumentType["US_TAX_FORM"] = "US_TAX_FORM";
    /**
   * A utility bill is a monthly statement of the amount a household or business owes for essential services or utilities.
   *
   * The utility bill must be dated within the last 60 days.
   *
   * The document must show the biller's full name and full physical address. The address cannot be associated to a PO Box or CMRA.
   */ DocumentType["UTILITY_BILL"] = "UTILITY_BILL";
    /**
   * A VA award letter is issued by the Department of Veterans Affairs (VA) when a decision has been made regarding a veteran's claim for benefits.
   * Specifically, this letter indicates a veteran's disability rating(s) along with the corresponding amount of monthly compensation.
   */ DocumentType["VETERAN_AFFAIRS_BENEFITS_LETTER"] = "VETERAN_AFFAIRS_BENEFITS_LETTER";
    /** The card art document is a front image of a Virtual Card */ DocumentType["VIRTUAL_FRONT_OF_CARD"] = "VIRTUAL_FRONT_OF_CARD";
    /** The card art document for 3DS Verification Logo */ DocumentType["VIRTUAL_THREE_DS_VERIFICATION_LOGO"] = "VIRTUAL_THREE_DS_VERIFICATION_LOGO";
    /** A W2 or Income tax form */ DocumentType["W2"] = "W2";
    /** Verifies that a wire transfer was sent or received. */ DocumentType["WIRE_CONFIRMATION"] = "WIRE_CONFIRMATION";
    return DocumentType;
}({});
var $2f53fee15f29b056$export$f2c43adf413f91d5 = /*#__PURE__*/ function(DocumentUploadCategory) {
    /** A primary document */ DocumentUploadCategory["APPLICATION"] = "APPLICATION";
    /** A supporting document type */ DocumentUploadCategory["CARD_ART"] = "CARD_ART";
    /** A supporting document type */ DocumentUploadCategory["CHECK_PAYMENTS"] = "CHECK_PAYMENTS";
    /** A secondary document */ DocumentUploadCategory["DISPUTES"] = "DISPUTES";
    /** A supporting document type */ DocumentUploadCategory["IDENTITY_CASE"] = "IDENTITY_CASE";
    /** A supporting document type */ DocumentUploadCategory["MANUAL_REQUEST"] = "MANUAL_REQUEST";
    return DocumentUploadCategory;
}({});
var $2f53fee15f29b056$export$db418483f31da7ee = /*#__PURE__*/ function(DocumentUploadClientTokenPermission) {
    /**
   * Manage the lifecycle of a document upload session.
   *
   * Setting this permission will allow the using the token to start and end the session. Additionally, the client will be allowed to
   * initiate file uploads for the specified session in the token.
   */ DocumentUploadClientTokenPermission["MANAGE_DOCUMENT_UPLOAD_SESSION"] = "MANAGE_DOCUMENT_UPLOAD_SESSION";
    return DocumentUploadClientTokenPermission;
}({});
var $2f53fee15f29b056$export$85ba72f86d0cb5ac = /*#__PURE__*/ function(DocumentUploadLinkStatusCode) {
    /** A file upload completed successfully and has been securely stored in the document store */ DocumentUploadLinkStatusCode["COMPLETED"] = "COMPLETED";
    /** A file upload has been denied due to malicious content or malware present in the file */ DocumentUploadLinkStatusCode["DENIED"] = "DENIED";
    /** A file upload has failed due to server communication and needs to be retried */ DocumentUploadLinkStatusCode["FAILED"] = "FAILED";
    /** A file upload is currently in progress and is being processed */ DocumentUploadLinkStatusCode["IN_PROGRESS"] = "IN_PROGRESS";
    /** The upload link has been created and is waiting for a file to be uploaded */ DocumentUploadLinkStatusCode["PENDING"] = "PENDING";
    return DocumentUploadLinkStatusCode;
}({});
var $2f53fee15f29b056$export$7153f0dd9edde3be = /*#__PURE__*/ function(DocumentUploadSessionStatusCode) {
    /** The document upload session is created, but has not been initiated */ DocumentUploadSessionStatusCode["CREATED"] = "CREATED";
    /**
   * A session has expired due to inactivity. A session can result in an expired state if it is never transitioned to submitted.
   * Files can no longer be uploaded to the session.
   */ DocumentUploadSessionStatusCode["EXPIRED"] = "EXPIRED";
    /** The document upload session has been initiated and files can now be uploaded to the session */ DocumentUploadSessionStatusCode["INITIATED"] = "INITIATED";
    /** A session has started and a file upload request has been initiated. */ DocumentUploadSessionStatusCode["IN_PROGRESS"] = "IN_PROGRESS";
    /**
   * A session has ended.
   * Files can no longer be uploaded to the session.
   */ DocumentUploadSessionStatusCode["SUBMITTED"] = "SUBMITTED";
    return DocumentUploadSessionStatusCode;
}({});
var $2f53fee15f29b056$export$3b3cb9f9d555a110 = /*#__PURE__*/ function(EarnRuleType) {
    /** Earning points on a per transaction basis. */ EarnRuleType["PER_TRANSACTION_SPEND_AMOUNT"] = "PER_TRANSACTION_SPEND_AMOUNT";
    return EarnRuleType;
}({});
var $2f53fee15f29b056$export$745216f779fa08e6 = /*#__PURE__*/ function(ElectronicFundTransferSource) {
    /** Transfer funds using wire transfer */ ElectronicFundTransferSource["WIRE"] = "WIRE";
    return ElectronicFundTransferSource;
}({});
var $2f53fee15f29b056$export$978d240f447d4ef2 = /*#__PURE__*/ function(EmploymentStatus) {
    /** The person account holder is currently employed by an employer. */ EmploymentStatus["EMPLOYED"] = "EMPLOYED";
    /** The person account holder has another employment status. */ EmploymentStatus["OTHER"] = "OTHER";
    /** The person account holder is not employed and currently retired. */ EmploymentStatus["RETIRED"] = "RETIRED";
    /** The person account holder is currently self-employed. */ EmploymentStatus["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    /** The person account holder is not employed and currently a student. */ EmploymentStatus["STUDENT"] = "STUDENT";
    /** The person account holder is not employed. */ EmploymentStatus["UNEMPLOYED"] = "UNEMPLOYED";
    return EmploymentStatus;
}({});
var $2f53fee15f29b056$export$abdd0b476c4962b7 = /*#__PURE__*/ function(ExternalBankAccountDetailClientTokenPermission) {
    /**
   * Read `accountNumber` for Direct Deposit Details.
   *
   * Setting this permission will allow using the token to query for a DirectDepositDetail and read its `restrictedDetails` property.
   */ ExternalBankAccountDetailClientTokenPermission["READ_RESTRICTED_DETAILS"] = "READ_RESTRICTED_DETAILS";
    return ExternalBankAccountDetailClientTokenPermission;
}({});
var $2f53fee15f29b056$export$4e665abfe824db3e = /*#__PURE__*/ function(ExternalFinancialAccountStatus) {
    /** The `ExternalFinancialAccount` is active and in good standing. */ ExternalFinancialAccountStatus["ACTIVE"] = "ACTIVE";
    /**
   * The `ExternalFinancialAccount` is Closed.
   *
   * This is a terminal state and cannot be reversed.
   */ ExternalFinancialAccountStatus["CLOSED"] = "CLOSED";
    return ExternalFinancialAccountStatus;
}({});
var $2f53fee15f29b056$export$37ef339335ac8060 = /*#__PURE__*/ function(ExternalMoneyMovementTransactionEventStatus) {
    /** The `ExternalMoneyMovementTransactionEvent` has failed. See `failureReason` for more information. */ ExternalMoneyMovementTransactionEventStatus["FAILED"] = "FAILED";
    /** The `ExternalMoneyMovementTransactionEvent` has been initiated. */ ExternalMoneyMovementTransactionEventStatus["INITIATED"] = "INITIATED";
    /** The `ExternalMoneyMovementTransactionEvent` has been processed. */ ExternalMoneyMovementTransactionEventStatus["PROCESSED"] = "PROCESSED";
    /** The `ExternalMoneyMovementTransactionEvent` is processing. */ ExternalMoneyMovementTransactionEventStatus["PROCESSING"] = "PROCESSING";
    return ExternalMoneyMovementTransactionEventStatus;
}({});
var $2f53fee15f29b056$export$3daca5e5f6aaac04 = /*#__PURE__*/ function(ExternalMoneyMovementTransactionEventStatusFailureReason) {
    /** The source or receiving account was not found. */ ExternalMoneyMovementTransactionEventStatusFailureReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** Idempotency Key not provided. */ ExternalMoneyMovementTransactionEventStatusFailureReason["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The source account of the transfer did not have enough funds to cover the requested amount. */ ExternalMoneyMovementTransactionEventStatusFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The account number provided was invalid. */ ExternalMoneyMovementTransactionEventStatusFailureReason["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    /** Transfer amount is negative or zero. */ ExternalMoneyMovementTransactionEventStatusFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** The reason for the failure is unspecified, contact Highnote support for more information. */ ExternalMoneyMovementTransactionEventStatusFailureReason["UNSPECIFIED"] = "UNSPECIFIED";
    return ExternalMoneyMovementTransactionEventStatusFailureReason;
}({});
var $2f53fee15f29b056$export$a1182d6df682ff8d = /*#__PURE__*/ function(ExternalMoneyMovementTransactionEventType) {
    /** Indicates a payout event. */ ExternalMoneyMovementTransactionEventType["PAYOUT"] = "PAYOUT";
    /** Indicates a platform fee event. */ ExternalMoneyMovementTransactionEventType["PLATFORM_FEE"] = "PLATFORM_FEE";
    return ExternalMoneyMovementTransactionEventType;
}({});
var $2f53fee15f29b056$export$220754076c875842 = /*#__PURE__*/ function(ExternalMoneyMovementTransactionStatus) {
    /** The payment has been completed. */ ExternalMoneyMovementTransactionStatus["COMPLETED"] = "COMPLETED";
    /** The payment has been failed. */ ExternalMoneyMovementTransactionStatus["FAILED"] = "FAILED";
    /** The payment has been initiated. */ ExternalMoneyMovementTransactionStatus["INITIATED"] = "INITIATED";
    /** The payment is pending. */ ExternalMoneyMovementTransactionStatus["PENDING"] = "PENDING";
    /** The payment status is unspecified. Contact Highnote support for more information. */ ExternalMoneyMovementTransactionStatus["UNSPECIFIED"] = "UNSPECIFIED";
    return ExternalMoneyMovementTransactionStatus;
}({});
var $2f53fee15f29b056$export$c1770bb6dba869ae = /*#__PURE__*/ function(ExternalMoneyMovementTransactionStatusReasonCode) {
    /** The source or receiving account was not found. */ ExternalMoneyMovementTransactionStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** Idempotency Key not provided. */ ExternalMoneyMovementTransactionStatusReasonCode["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The source account of the transfer did not have enough funds to cover the requested amount. */ ExternalMoneyMovementTransactionStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The account number provided was invalid. */ ExternalMoneyMovementTransactionStatusReasonCode["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    /** Transfer amount is negative or zero. */ ExternalMoneyMovementTransactionStatusReasonCode["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** The reason for the failure is unspecified, contact Highnote support for more information. */ ExternalMoneyMovementTransactionStatusReasonCode["UNSPECIFIED"] = "UNSPECIFIED";
    return ExternalMoneyMovementTransactionStatusReasonCode;
}({});
var $2f53fee15f29b056$export$cc1581846e7ab2d8 = /*#__PURE__*/ function(ExternalMoneyMovementTransactionType) {
    /** Indicates a payout. */ ExternalMoneyMovementTransactionType["PAYOUT"] = "PAYOUT";
    /** Indicates a platform fee. */ ExternalMoneyMovementTransactionType["PLATFORM_FEE"] = "PLATFORM_FEE";
    return ExternalMoneyMovementTransactionType;
}({});
var $2f53fee15f29b056$export$ad2f88cec3bd3184 = /*#__PURE__*/ function(ExternallyInitiatedAchHoldStatus) {
    /** The ACH Transaction had a hold but it has been removed */ ExternallyInitiatedAchHoldStatus["HOLD_REMOVED"] = "HOLD_REMOVED";
    /** The ACH Transaction is not on hold */ ExternallyInitiatedAchHoldStatus["NO_HOLDS"] = "NO_HOLDS";
    /** The ACH Transaction is currently on hold */ ExternallyInitiatedAchHoldStatus["ON_HOLD"] = "ON_HOLD";
    /** The hold status is unspecified */ ExternallyInitiatedAchHoldStatus["UNSPECIFIED"] = "UNSPECIFIED";
    return ExternallyInitiatedAchHoldStatus;
}({});
var $2f53fee15f29b056$export$4462d494ea85a5ca = /*#__PURE__*/ function(ExternallyInitiatedAchStatus) {
    /** The transfer has been canceled by Highnote. This status is rare and typically indicates the transfer was received in error. */ ExternallyInitiatedAchStatus["CANCELED"] = "CANCELED";
    /** The transfer failed. More details are available in `ExternallyInitiatedACHStatusReasonCode`. */ ExternallyInitiatedAchStatus["FAILED"] = "FAILED";
    /** The transfer has been received by Highnote, but cannot be processed yet as the effective date is in the future. */ ExternallyInitiatedAchStatus["PENDING"] = "PENDING";
    /** The transfer has successfully been processed by Highnote. */ ExternallyInitiatedAchStatus["PROCESSED"] = "PROCESSED";
    /** The transfer is processing at Highnote, but funds are not available yet. */ ExternallyInitiatedAchStatus["PROCESSING"] = "PROCESSING";
    /** The transfer has been returned to the bank that initiated it. More details are available in `ExternallyInitiatedACHStatusReasonCode`. */ ExternallyInitiatedAchStatus["RETURNED"] = "RETURNED";
    /** The transfer has been returned to the bank that initiated it. */ ExternallyInitiatedAchStatus["REVERSED"] = "REVERSED";
    return ExternallyInitiatedAchStatus;
}({});
var $2f53fee15f29b056$export$2b13c6090b9ab816 = /*#__PURE__*/ function(ExternallyInitiatedAchStatusReasonCode) {
    /** R11 - The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */ ExternallyInitiatedAchStatusReasonCode["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The Highnote account was closed. */ ExternallyInitiatedAchStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** R16 - The account is frozen. */ ExternallyInitiatedAchStatusReasonCode["ACCOUNT_FROZEN"] = "ACCOUNT_FROZEN";
    /** The Highnote account could not be found. */ ExternallyInitiatedAchStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** Loading funds via ACH is not supported. */ ExternallyInitiatedAchStatusReasonCode["ACH_LOAD_NOT_SUPPORTED"] = "ACH_LOAD_NOT_SUPPORTED";
    /** R19 - There is an error in the amount field. */ ExternallyInitiatedAchStatusReasonCode["AMOUNT_FIELD_ERROR"] = "AMOUNT_FIELD_ERROR";
    /** R07 - The Authorization was revoked by Customer. */ ExternallyInitiatedAchStatusReasonCode["AUTHORIZATION_REVOKED_BY_CUSTOMER"] = "AUTHORIZATION_REVOKED_BY_CUSTOMER";
    /** R11 - The account does not have the required commercial pay in full account feature enabled. */ ExternallyInitiatedAchStatusReasonCode["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** The account does not have the required corporate bank account feature enabled. */ ExternallyInitiatedAchStatusReasonCode["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R11 - The credit limit is not set on the account. */ ExternallyInitiatedAchStatusReasonCode["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The currency of the transfer did not match the currency of the Highnote account. */ ExternallyInitiatedAchStatusReasonCode["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** R24 - Resulted in a Duplicate Entry. */ ExternallyInitiatedAchStatusReasonCode["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    /** R11 - The transfer is not in accordance with the terms of the account. */ ExternallyInitiatedAchStatusReasonCode["ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION"] = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION";
    /** R18 - Has an Improper Effective entry date. */ ExternallyInitiatedAchStatusReasonCode["IMPROPER_EFFECTIVE_ENTRY_DATE"] = "IMPROPER_EFFECTIVE_ENTRY_DATE";
    /** This was a debit from an account at Highnote which did not have enough funds. */ ExternallyInitiatedAchStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** There is an internal error with the transfer. */ ExternallyInitiatedAchStatusReasonCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** R04 - Has an Invalid Account Number. */ ExternallyInitiatedAchStatusReasonCode["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    /** R21 - Has an Invalid Company ID Number. */ ExternallyInitiatedAchStatusReasonCode["INVALID_COMPANY_ID_NUMBER"] = "INVALID_COMPANY_ID_NUMBER";
    /** R22 - Has an Invalid Individual ID Number. */ ExternallyInitiatedAchStatusReasonCode["INVALID_INDIVIDUAL_ID_NUMBER"] = "INVALID_INDIVIDUAL_ID_NUMBER";
    /** R20 - Is a Non Transactional Account. */ ExternallyInitiatedAchStatusReasonCode["NON_TRANSACTION_ACCOUNT"] = "NON_TRANSACTION_ACCOUNT";
    /** R08 - The Payment was stopped. */ ExternallyInitiatedAchStatusReasonCode["PAYMENT_STOPPED"] = "PAYMENT_STOPPED";
    /** The account does not have the required payroll advance feature enabled. */ ExternallyInitiatedAchStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** The account does not have the required payroll employer advance feature enabled. */ ExternallyInitiatedAchStatusReasonCode["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** R06 - Funds were returned per OFDI Request. */ ExternallyInitiatedAchStatusReasonCode["RETURNED_PER_ODFI_REQUEST"] = "RETURNED_PER_ODFI_REQUEST";
    /** R29 - The Transaction was not Authorized By Account Holder. */ ExternallyInitiatedAchStatusReasonCode["TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER"] = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER";
    /** The transfer amount is below the minimum amount to reload. */ ExternallyInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT";
    /** The transfer exceeds the maximum load limit. */ ExternallyInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT";
    /** The transfer exceeds the maximum reload limit. */ ExternallyInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT";
    /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */ ExternallyInitiatedAchStatusReasonCode["UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE"] = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE";
    /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */ ExternallyInitiatedAchStatusReasonCode["UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION"] = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION";
    /** R09 - Transaction represents Uncollected Funds. */ ExternallyInitiatedAchStatusReasonCode["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    return ExternallyInitiatedAchStatusReasonCode;
}({});
var $2f53fee15f29b056$export$9976ffc780f46c85 = /*#__PURE__*/ function(ExternallyInitiatedTransferType) {
    /** Credit Funds */ ExternallyInitiatedTransferType["CREDIT_FUNDS"] = "CREDIT_FUNDS";
    /** Debit Funds */ ExternallyInitiatedTransferType["DEBIT_FUNDS"] = "DEBIT_FUNDS";
    /** Payroll */ ExternallyInitiatedTransferType["PAYROLL"] = "PAYROLL";
    return ExternallyInitiatedTransferType;
}({});
var $2f53fee15f29b056$export$a6c2814328b4f6d1 = /*#__PURE__*/ function(FeeChargeConditionDuration) {
    /** Calendar day (UTC). Accumulated count/amount is reset each day. */ FeeChargeConditionDuration["DAY"] = "DAY";
    /** Lifetime of the account. Accumulated count/amount is never reset. */ FeeChargeConditionDuration["LIFETIME"] = "LIFETIME";
    /** Calendar month (UTC). Accumulated count/amount is reset each month. */ FeeChargeConditionDuration["MONTH"] = "MONTH";
    /** Applies to all without aggregation. */ FeeChargeConditionDuration["NONE"] = "NONE";
    /** Calendar week, starting on Sunday (UTC). Accumulated count/amount is reset each week. */ FeeChargeConditionDuration["WEEK"] = "WEEK";
    /** Calendar year (UTC). Accumulated count/amount is reset each year. */ FeeChargeConditionDuration["YEAR"] = "YEAR";
    return FeeChargeConditionDuration;
}({});
var $2f53fee15f29b056$export$f99c644466cc0ef9 = /*#__PURE__*/ function(FeeChargeOperator) {
    /** Between count/amount and maximumCount/maximumAmount inclusive. */ FeeChargeOperator["BETWEEN"] = "BETWEEN";
    /** Equal */ FeeChargeOperator["EQUAL"] = "EQUAL";
    /** Greater than. */ FeeChargeOperator["GREATER_THAN"] = "GREATER_THAN";
    /** Greater than or equal. */ FeeChargeOperator["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    /** Less than. */ FeeChargeOperator["LESS_THAN"] = "LESS_THAN";
    /** Less than or equal. */ FeeChargeOperator["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    /** Not equal */ FeeChargeOperator["NOT_EQUAL"] = "NOT_EQUAL";
    return FeeChargeOperator;
}({});
var $2f53fee15f29b056$export$38cec0c63be49129 = /*#__PURE__*/ function(FeeConditionAggregation) {
    /** Account. */ FeeConditionAggregation["ACCOUNT"] = "ACCOUNT";
    /** Payment Card. */ FeeConditionAggregation["PAYMENT_CARD"] = "PAYMENT_CARD";
    return FeeConditionAggregation;
}({});
var $2f53fee15f29b056$export$f7cfc28b1f80a1e2 = /*#__PURE__*/ function(FeeScheduleStatus) {
    /** Fee schedule is active and currently applicable. */ FeeScheduleStatus["ACTIVE"] = "ACTIVE";
    /** The fee schedule is inactive and no longer applicable. */ FeeScheduleStatus["INACTIVE"] = "INACTIVE";
    /** The fee schedule is pending. Pending status is when fee schedule activation date is in future. */ FeeScheduleStatus["PENDING"] = "PENDING";
    return FeeScheduleStatus;
}({});
var $2f53fee15f29b056$export$13953dd2af58593e = /*#__PURE__*/ function(FeeTransferEventFailureType) {
    /** The originating and receiving account do not belong to same product. */ FeeTransferEventFailureType["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The originating or receiving account is closed. */ FeeTransferEventFailureType["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The originating or receiving account is not active. */ FeeTransferEventFailureType["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The originating or receiving account was not found. */ FeeTransferEventFailureType["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The originating or receiving account not provided. */ FeeTransferEventFailureType["ACCOUNT_NOT_PROVIDED"] = "ACCOUNT_NOT_PROVIDED";
    /** Ach load is not allowed by program. */ FeeTransferEventFailureType["ACH_LOAD_NOT_ALLOWED_BY_PROGRAM"] = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM";
    /** Card funding feature not enabled on account. */ FeeTransferEventFailureType["CARD_FUNDING_FEATURE_NOT_ENABLED"] = "CARD_FUNDING_FEATURE_NOT_ENABLED";
    /** Cash fund out not supported on product. */ FeeTransferEventFailureType["CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT"] = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT";
    /** Commercial credit Pay In Full card feature is not enabled on account. */ FeeTransferEventFailureType["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** Corporate bank account feature is not enabled. */ FeeTransferEventFailureType["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Credit card feature is not enabled on account. */ FeeTransferEventFailureType["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** The originating account does not have credit limit set. */ FeeTransferEventFailureType["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The originating and receiving account have different currency. */ FeeTransferEventFailureType["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** Dda feature is not enabled on account. */ FeeTransferEventFailureType["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** Debit card feature is not enabled on account. */ FeeTransferEventFailureType["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** Fleet card feature is not enabled on account. */ FeeTransferEventFailureType["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** Funding account feature is not enabled on account. */ FeeTransferEventFailureType["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Product funding feature is not enabled on account. */ FeeTransferEventFailureType["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** Idempotency Key not provided. */ FeeTransferEventFailureType["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The originating account of the FeeTransferEvent did not have enough funds to cover the requested amount. */ FeeTransferEventFailureType["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The originating or receiving account does not belong to the organization. */ FeeTransferEventFailureType["NOT_AN_ORGANIZATION_OWNED_ACCOUNT"] = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT";
    /** The originating account does not have enough balance to reduce credit limit. */ FeeTransferEventFailureType["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** Organization not provided. */ FeeTransferEventFailureType["ORGANIZATION_ID_NOT_PROVIDED"] = "ORGANIZATION_ID_NOT_PROVIDED";
    /** Originated ach unload not supported on product */ FeeTransferEventFailureType["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** Payroll advance feature not enabled. */ FeeTransferEventFailureType["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** Payroll employer advance feature not enabled. */ FeeTransferEventFailureType["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** Prepaid card feature is not enabled on account. */ FeeTransferEventFailureType["PREPAID_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_FEATURE_NOT_ENABLED";
    /** Product funding feature is not enabled on account. */ FeeTransferEventFailureType["PRODUCT_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED";
    /** Reward point feature not enabled. */ FeeTransferEventFailureType["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    /** Secured card feature is not enabled on account. */ FeeTransferEventFailureType["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** Tenant Id is not provided. */ FeeTransferEventFailureType["TENANT_ID_NOT_PROVIDED"] = "TENANT_ID_NOT_PROVIDED";
    /** Transaction Id not provided. */ FeeTransferEventFailureType["TRANSACTION_ID_NOT_PROVIDED"] = "TRANSACTION_ID_NOT_PROVIDED";
    /** Transfer amount below program minimum reload limit. */ FeeTransferEventFailureType["TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT";
    /** Transfer amount exceeding maximum program card balance. */ FeeTransferEventFailureType["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE";
    /** Fransfer amount exceeds allowed max program load limit. */ FeeTransferEventFailureType["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** Transfer amount exceeds allowed max program reload limit. */ FeeTransferEventFailureType["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT";
    /** Transfer amount is negative or zero. */ FeeTransferEventFailureType["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** Accounts do not have same primary account holder. */ FeeTransferEventFailureType["TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED"] = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED";
    /** Transfer is not supported on product. */ FeeTransferEventFailureType["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    return FeeTransferEventFailureType;
}({});
var $2f53fee15f29b056$export$836c5a20e6be01be = /*#__PURE__*/ function(FeeTransferEventFeeActivityType) {
    /** Account inactivity */ FeeTransferEventFeeActivityType["ACCOUNT_INACTIVITY_FEE"] = "ACCOUNT_INACTIVITY_FEE";
    /** Account initiation */ FeeTransferEventFeeActivityType["ACCOUNT_INITIATION_FEE"] = "ACCOUNT_INITIATION_FEE";
    /** ATM balance inquiry (in-network) */ FeeTransferEventFeeActivityType["ATM_BALANCE_INQUIRY_IN_NETWORK_FEE"] = "ATM_BALANCE_INQUIRY_IN_NETWORK_FEE";
    /** ATM balance inquiry (international, in-network) */ FeeTransferEventFeeActivityType["ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE"] = "ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE";
    /** ATM balance inquiry (out-of-network) */ FeeTransferEventFeeActivityType["ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE"] = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE";
    /** ATM balance inquiry (international) */ FeeTransferEventFeeActivityType["ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE"] = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE";
    /** ATM decline */ FeeTransferEventFeeActivityType["ATM_DECLINE_FEE"] = "ATM_DECLINE_FEE";
    /** ATM decline (international) */ FeeTransferEventFeeActivityType["ATM_DECLINE_INTERNATIONAL_FEE"] = "ATM_DECLINE_INTERNATIONAL_FEE";
    /** ATM withdrawal (in-network) */ FeeTransferEventFeeActivityType["ATM_WITHDRAWAL_IN_NETWORK_FEE"] = "ATM_WITHDRAWAL_IN_NETWORK_FEE";
    /** ATM withdrawal (international, in-network) */ FeeTransferEventFeeActivityType["ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE"] = "ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE";
    /** ATM withdrawal (out-of-network) */ FeeTransferEventFeeActivityType["ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE"] = "ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE";
    /** ATM withdrawal (international) */ FeeTransferEventFeeActivityType["ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE"] = "ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE";
    /** Cash back at bank tell */ FeeTransferEventFeeActivityType["CASH_BACK_OTC_FEE"] = "CASH_BACK_OTC_FEE";
    /** Cash back at point of sale terminal */ FeeTransferEventFeeActivityType["CASH_BACK_POS_FEE"] = "CASH_BACK_POS_FEE";
    /** Expedited physical card */ FeeTransferEventFeeActivityType["EXPEDITED_PHYSICAL_CARD_FEE"] = "EXPEDITED_PHYSICAL_CARD_FEE";
    /** Foreign exchange */ FeeTransferEventFeeActivityType["FOREIGN_EXCHANGE_FEE"] = "FOREIGN_EXCHANGE_FEE";
    /** Credit Installment */ FeeTransferEventFeeActivityType["INSTALLMENT_FEE"] = "INSTALLMENT_FEE";
    /** International transaction */ FeeTransferEventFeeActivityType["INTERNATIONAL_TRANSACTION_FEE"] = "INTERNATIONAL_TRANSACTION_FEE";
    /** Late Payment */ FeeTransferEventFeeActivityType["LATE_PAYMENT_FEE"] = "LATE_PAYMENT_FEE";
    /** Monthly account anniversary fee */ FeeTransferEventFeeActivityType["MONTHLY_ACCOUNT_ANNIVERSARY_FEE"] = "MONTHLY_ACCOUNT_ANNIVERSARY_FEE";
    /** Physical card reissue (new PAN) */ FeeTransferEventFeeActivityType["PHYSICAL_CARD_REISSUE_FEE"] = "PHYSICAL_CARD_REISSUE_FEE";
    /** Returned ACH origication */ FeeTransferEventFeeActivityType["RETURN_PAYMENT_FEE"] = "RETURN_PAYMENT_FEE";
    /** Virtual card reissue (new PAN) */ FeeTransferEventFeeActivityType["VIRTUAL_CARD_REISSUE_FEE"] = "VIRTUAL_CARD_REISSUE_FEE";
    return FeeTransferEventFeeActivityType;
}({});
var $2f53fee15f29b056$export$1ba026d2a1cc0434 = /*#__PURE__*/ function(FeeTransferEventFeeActivityTypeInput) {
    /** Account inactivity */ FeeTransferEventFeeActivityTypeInput["ACCOUNT_INACTIVITY_FEE"] = "ACCOUNT_INACTIVITY_FEE";
    /** Account initiation */ FeeTransferEventFeeActivityTypeInput["ACCOUNT_INITIATION_FEE"] = "ACCOUNT_INITIATION_FEE";
    /** ATM balance inquiry (in-network) */ FeeTransferEventFeeActivityTypeInput["ATM_BALANCE_INQUIRY_IN_NETWORK_FEE"] = "ATM_BALANCE_INQUIRY_IN_NETWORK_FEE";
    /** ATM balance inquiry (international, in-network) */ FeeTransferEventFeeActivityTypeInput["ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE"] = "ATM_BALANCE_INQUIRY_IN_NETWORK_INTERNATIONAL_FEE";
    /** ATM balance inquiry (out-of-network) */ FeeTransferEventFeeActivityTypeInput["ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE"] = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_FEE";
    /** ATM balance inquiry (international) */ FeeTransferEventFeeActivityTypeInput["ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE"] = "ATM_BALANCE_INQUIRY_OUT_OF_NETWORK_INTERNATIONAL_FEE";
    /** ATM decline */ FeeTransferEventFeeActivityTypeInput["ATM_DECLINE_FEE"] = "ATM_DECLINE_FEE";
    /** ATM decline (international) */ FeeTransferEventFeeActivityTypeInput["ATM_DECLINE_INTERNATIONAL_FEE"] = "ATM_DECLINE_INTERNATIONAL_FEE";
    /** ATM withdrawal (in-network) */ FeeTransferEventFeeActivityTypeInput["ATM_WITHDRAWAL_IN_NETWORK_FEE"] = "ATM_WITHDRAWAL_IN_NETWORK_FEE";
    /** ATM withdrawal (international, in-network) */ FeeTransferEventFeeActivityTypeInput["ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE"] = "ATM_WITHDRAWAL_IN_NETWORK_INTERNATIONAL_FEE";
    /** ATM withdrawal (out-of-network) */ FeeTransferEventFeeActivityTypeInput["ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE"] = "ATM_WITHDRAWAL_OUT_OF_NETWORK_FEE";
    /** ATM withdrawal (international) */ FeeTransferEventFeeActivityTypeInput["ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE"] = "ATM_WITHDRAWAL_OUT_OF_NETWORK_INTERNATIONAL_FEE";
    /** Cash back at bank tell */ FeeTransferEventFeeActivityTypeInput["CASH_BACK_OTC_FEE"] = "CASH_BACK_OTC_FEE";
    /** Cash back at point of sale terminal */ FeeTransferEventFeeActivityTypeInput["CASH_BACK_POS_FEE"] = "CASH_BACK_POS_FEE";
    /** Expedited physical card */ FeeTransferEventFeeActivityTypeInput["EXPEDITED_PHYSICAL_CARD_FEE"] = "EXPEDITED_PHYSICAL_CARD_FEE";
    /** Foreign exchange */ FeeTransferEventFeeActivityTypeInput["FOREIGN_EXCHANGE_FEE"] = "FOREIGN_EXCHANGE_FEE";
    /** Credit Installment */ FeeTransferEventFeeActivityTypeInput["INSTALLMENT_FEE"] = "INSTALLMENT_FEE";
    /** International transaction */ FeeTransferEventFeeActivityTypeInput["INTERNATIONAL_TRANSACTION_FEE"] = "INTERNATIONAL_TRANSACTION_FEE";
    /** Late Payment */ FeeTransferEventFeeActivityTypeInput["LATE_PAYMENT_FEE"] = "LATE_PAYMENT_FEE";
    /** Monthly account anniversary fee */ FeeTransferEventFeeActivityTypeInput["MONTHLY_ACCOUNT_ANNIVERSARY_FEE"] = "MONTHLY_ACCOUNT_ANNIVERSARY_FEE";
    /** Physical card reissue (new PAN) */ FeeTransferEventFeeActivityTypeInput["PHYSICAL_CARD_REISSUE_FEE"] = "PHYSICAL_CARD_REISSUE_FEE";
    /** Returned ACH origination */ FeeTransferEventFeeActivityTypeInput["RETURN_PAYMENT_FEE"] = "RETURN_PAYMENT_FEE";
    /** Virtual card reissue (new PAN) */ FeeTransferEventFeeActivityTypeInput["VIRTUAL_CARD_REISSUE_FEE"] = "VIRTUAL_CARD_REISSUE_FEE";
    return FeeTransferEventFeeActivityTypeInput;
}({});
var $2f53fee15f29b056$export$2b58b12a1712bc7 = /*#__PURE__*/ function(FeeTransferEventStatus) {
    /** The Fee Transfer Event completed. */ FeeTransferEventStatus["COMPLETE"] = "COMPLETE";
    /** The Fee Transfer Event failed. Additional details are available in failureReason. */ FeeTransferEventStatus["FAIL"] = "FAIL";
    /** The Fee Transfer Event is pending. */ FeeTransferEventStatus["PENDING"] = "PENDING";
    return FeeTransferEventStatus;
}({});
var $2f53fee15f29b056$export$bf4aa5a0e3c75a49 = /*#__PURE__*/ function(FeedbackCode) {
    /** This code will tell the risk system to override the rule results. */ FeedbackCode["OVERRIDE_RULE_RESULTS_TO_ACCEPTED"] = "OVERRIDE_RULE_RESULTS_TO_ACCEPTED";
    /** This code will indicate that the override was denied. */ FeedbackCode["OVERRIDE_RULE_RESULTS_TO_DENIED"] = "OVERRIDE_RULE_RESULTS_TO_DENIED";
    return FeedbackCode;
}({});
var $2f53fee15f29b056$export$a0c321da2840c37c = /*#__PURE__*/ function(FinancialAccountActivitySign) {
    /** The activity decreases available cash or credit. */ FinancialAccountActivitySign["NEGATIVE"] = "NEGATIVE";
    /** The activity increases available cash or credit. */ FinancialAccountActivitySign["POSITIVE"] = "POSITIVE";
    return FinancialAccountActivitySign;
}({});
var $2f53fee15f29b056$export$6a5555a77608c5f3 = /*#__PURE__*/ function(FinancialAccountActivityType) {
    /** Is the financial account activity an account holder fee type */ FinancialAccountActivityType["ACCOUNT_HOLDER_FEE"] = "ACCOUNT_HOLDER_FEE";
    /** Is the financial account activity an externally initiated ACH */ FinancialAccountActivityType["EXTERNALLY_INITIATED_ACH"] = "EXTERNALLY_INITIATED_ACH";
    /** Is the financial account activity an integrator initiated ACH */ FinancialAccountActivityType["INTEGRATOR_INITIATED_ACH"] = "INTEGRATOR_INITIATED_ACH";
    /** Is the financial account activity an internal transfer type */ FinancialAccountActivityType["INTERNAL_TRANSFER"] = "INTERNAL_TRANSFER";
    /** Is the financial account activity a payment card type */ FinancialAccountActivityType["PAYMENT_CARD"] = "PAYMENT_CARD";
    return FinancialAccountActivityType;
}({});
var $2f53fee15f29b056$export$89d95dc30780e504 = /*#__PURE__*/ function(FinancialAccountAttribute) {
    /** The account is under investigation for potential account takeover. */ FinancialAccountAttribute["ACCOUNT_TAKEOVER"] = "ACCOUNT_TAKEOVER";
    /** The account is under investigation for unusual electronic funds transfer activity. */ FinancialAccountAttribute["ACH_RISK_HOLD"] = "ACH_RISK_HOLD";
    /** The account is charged off and suspended for excessive delinquency based on the number of days set on your card product. */ FinancialAccountAttribute["CHARGE_OFF"] = "CHARGE_OFF";
    /** The account has been closed with an outstanding balance payable and repayment is required. */ FinancialAccountAttribute["CLOSED_WITH_BALANCE"] = "CLOSED_WITH_BALANCE";
    /** The account’s payment is delinquent and may be reported to the credit bureaus as such based on the number of days set on your card product. */ FinancialAccountAttribute["DELINQUENT"] = "DELINQUENT";
    /** The account is suspended for authorizations for excessive delinquency based on the number of days set on your card product. */ FinancialAccountAttribute["DELINQUENT_SUSPENDED"] = "DELINQUENT_SUSPENDED";
    /** The account is under investigation for potential identity theft. */ FinancialAccountAttribute["IDENTITY_THEFT"] = "IDENTITY_THEFT";
    /** The account is under investigation for a potential OFAC match. */ FinancialAccountAttribute["OFAC_WARNING"] = "OFAC_WARNING";
    /** The account is being processed for closure. */ FinancialAccountAttribute["PENDING_CLOSURE"] = "PENDING_CLOSURE";
    /** The account is suspended due to program owner initiated suspension. */ FinancialAccountAttribute["PROGRAM_OWNER_INITIATED_SUSPENSION"] = "PROGRAM_OWNER_INITIATED_SUSPENSION";
    /** The account is under investigation for suspected fraud. */ FinancialAccountAttribute["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    return FinancialAccountAttribute;
}({});
var $2f53fee15f29b056$export$426a3cee32722d36 = /*#__PURE__*/ function(FinancialAccountAttributeReason) {
    /** The `FinancialAccount` is being suspended due to account holder request. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_HOLDER_REQUEST";
    /** The `FinancialAccount` is being suspended due to account review. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACCOUNT_REVIEW";
    /** The `FinancialAccount` is being suspended due to related ACH transfer returns. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_ACH_RETURNS";
    /** The `FinancialAccount` is being suspended due to delinquency. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_DELINQUENCY";
    /** The `FinancialAccount` is being suspended due to lost or stolen `PaymentCard`. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_LOST_OR_STOLEN_CARD";
    /** The `FinancialAccount` is being suspended due to suspected fraud. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_SUSPECTED_FRAUD";
    /** The `FinancialAccount` is being suspended due to unspecified reason. */ FinancialAccountAttributeReason["PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED"] = "PROGRAM_OWNER_INITIATED_SUSPENSION_REASON_UNSPECIFIED";
    return FinancialAccountAttributeReason;
}({});
var $2f53fee15f29b056$export$f83760e6ff2ce712 = /*#__PURE__*/ function(FinancialAccountBalanceSearchField) {
    /**
   * The available cash balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["AVAILABLE_CASH_LEDGER_BALANCE"] = "AVAILABLE_CASH_LEDGER_BALANCE";
    /**
   * The available credit balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["AVAILABLE_CREDIT_LEDGER_BALANCE"] = "AVAILABLE_CREDIT_LEDGER_BALANCE";
    /**
   * The `CardProduct` ID of the `FinancialAccount`.
   *
   * If choosing this field, the `stringFilter` must be used.
   */ FinancialAccountBalanceSearchField["CARD_PRODUCT_ID"] = "CARD_PRODUCT_ID";
    /**
   * The cash balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["CASH_LEDGER_BALANCE"] = "CASH_LEDGER_BALANCE";
    /**
   * The credit outstanding balance of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["CREDIT_OUTSTANDING_LEDGER_BALANCE"] = "CREDIT_OUTSTANDING_LEDGER_BALANCE";
    /**
   * The `FinancialAccount` created at date.
   *
   * If choosing this field, the `timestampFilter` must be used.
   */ FinancialAccountBalanceSearchField["FINANCIAL_ACCOUNT_CREATED_AT"] = "FINANCIAL_ACCOUNT_CREATED_AT";
    /**
   * The `FinancialAccount` ID pertaining the `FinancialAccount` balance.
   *
   * If choosing this field, the `stringFilter` must be used.
   */ FinancialAccountBalanceSearchField["FINANCIAL_ACCOUNT_ID"] = "FINANCIAL_ACCOUNT_ID";
    /**
   * The ID of the `FinancialAccountOwner`.
   *
   * If choosing this field, the `stringFilter` must be used.
   */ FinancialAccountBalanceSearchField["FINANCIAL_ACCOUNT_OWNER_ID"] = "FINANCIAL_ACCOUNT_OWNER_ID";
    /**
   * The outstanding balance payable of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `creditBalance` for positive amounts and `debitBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["OUTSTANDING_BALANCE_PAYABLE_LEDGER_BALANCE"] = "OUTSTANDING_BALANCE_PAYABLE_LEDGER_BALANCE";
    /**
   * The outstanding balance receivable of the `FinancialAccount`.
   *
   * If choosing this field, the `signedBalance` can be used to search by the current balance.
   * Otherwise, use `debitBalance` for positive amounts and `creditBalance` for negative amounts.
   */ FinancialAccountBalanceSearchField["OUTSTANDING_BALANCE_RECEIVABLE_LEDGER_BALANCE"] = "OUTSTANDING_BALANCE_RECEIVABLE_LEDGER_BALANCE";
    return FinancialAccountBalanceSearchField;
}({});
var $2f53fee15f29b056$export$16b3c3f023ea3bf6 = /*#__PURE__*/ function(FinancialAccountClosureReason) {
    /** Account is closed at the request of the account holder. */ FinancialAccountClosureReason["ACCOUNT_HOLDER_REQUEST"] = "ACCOUNT_HOLDER_REQUEST";
    /** Account is closed due to bankruptcy. */ FinancialAccountClosureReason["BANKRUPTCY"] = "BANKRUPTCY";
    /** Account is closed due to a negative balance on the account. */ FinancialAccountClosureReason["CHARGE_OFF"] = "CHARGE_OFF";
    /** Information has been provided that determines the account holder is deceased. */ FinancialAccountClosureReason["DECEASED"] = "DECEASED";
    /** Account is closed due to inactivity. */ FinancialAccountClosureReason["INACTIVITY"] = "INACTIVITY";
    /** Account is closed due to lost or stolen card. */ FinancialAccountClosureReason["LOST_OR_STOLEN_CARD"] = "LOST_OR_STOLEN_CARD";
    /** Account is closed due to the business type. */ FinancialAccountClosureReason["PROHIBITED_BUSINESS_TYPE"] = "PROHIBITED_BUSINESS_TYPE";
    /** Requested information not received or there is suspect activity occurring on the account that could not be verified. */ FinancialAccountClosureReason["SECURITY_CONCERN"] = "SECURITY_CONCERN";
    /** Account is closed due to unusual activity taking place on the account. */ FinancialAccountClosureReason["UNUSUAL_ACTIVITY"] = "UNUSUAL_ACTIVITY";
    return FinancialAccountClosureReason;
}({});
var $2f53fee15f29b056$export$d18973ac9d84c42f = /*#__PURE__*/ function(FinancialAccountCreditLimitUpdateFromProductFundingStatus) {
    /** The platform has completed the credit limit update. */ FinancialAccountCreditLimitUpdateFromProductFundingStatus["COMPLETED"] = "COMPLETED";
    /** The platform was not able to complete the credit limit update. See `statusReasonCode` for more information. */ FinancialAccountCreditLimitUpdateFromProductFundingStatus["FAILED"] = "FAILED";
    /** The platform is currently validating and executing the credit limit update. */ FinancialAccountCreditLimitUpdateFromProductFundingStatus["PENDING"] = "PENDING";
    /**
   * The platform has started processing the credit limit update.
   * @deprecated unused
   */ FinancialAccountCreditLimitUpdateFromProductFundingStatus["PROCESSING"] = "PROCESSING";
    return FinancialAccountCreditLimitUpdateFromProductFundingStatus;
}({});
var $2f53fee15f29b056$export$9aa297ca57010f5f = /*#__PURE__*/ function(FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode) {
    /** The associated product funding account or account is closed. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The account was not found. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The associated product funding account did not have enough funds to cover the requested amount. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The requested amount is more than max program limit. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** There is not enough balance to reduce the credit limit. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** The requested amount exceeds the maximum aggregate credit distribution amount. */ FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT";
    return FinancialAccountCreditLimitUpdateFromProductFundingStatusReasonCode;
}({});
var $2f53fee15f29b056$export$b2f01acb8dcd96ce = /*#__PURE__*/ function(FinancialAccountDelinquencyState) {
    /** Account is closed. */ FinancialAccountDelinquencyState["CLOSED"] = "CLOSED";
    /** Account is chargedOff and now in the process of closing. */ FinancialAccountDelinquencyState["CLOSING"] = "CLOSING";
    /** Most recent required payment was received before its due date. */ FinancialAccountDelinquencyState["CURRENT"] = "CURRENT";
    /** At least one required payment was not received before its due date. */ FinancialAccountDelinquencyState["DELINQUENT"] = "DELINQUENT";
    return FinancialAccountDelinquencyState;
}({});
var $2f53fee15f29b056$export$a47deb50c600beba = /*#__PURE__*/ function(FinancialAccountFeatureType) {
    /** Whether or not the `FinancialAccount` is associated to the authorized user. */ FinancialAccountFeatureType["AUTHORIZED_USER"] = "AUTHORIZED_USER";
    /** Whether or not the Financial Account supports Card Funding. */ FinancialAccountFeatureType["CARD_FUNDING_ACCOUNT"] = "CARD_FUNDING_ACCOUNT";
    /** Whether or not the Financial Account supports a Credit Payment Card. */ FinancialAccountFeatureType["CREDIT_PAYMENT_CARD"] = "CREDIT_PAYMENT_CARD";
    /** Whether or not the Financial Account supports a Debit Payment Card. */ FinancialAccountFeatureType["DEBIT_PAYMENT_CARD"] = "DEBIT_PAYMENT_CARD";
    /** The account and routing number can be used to deposit funds. */ FinancialAccountFeatureType["DIRECT_DEPOSIT"] = "DIRECT_DEPOSIT";
    /** Whether or not the Financial Account supports the Income Account feature. */ FinancialAccountFeatureType["INCOME_ACCOUNT"] = "INCOME_ACCOUNT";
    /** Whether or not the Financial Account supports Just-in-time Funding. */ FinancialAccountFeatureType["JUST_IN_TIME_FUNDING"] = "JUST_IN_TIME_FUNDING";
    /** Whether or not the `FinancialAccount` supports the merchant settlement account feature. */ FinancialAccountFeatureType["MERCHANT_SETTLEMENT"] = "MERCHANT_SETTLEMENT";
    /** Whether or not the Financial Account supports Negative Balance Reserve. */ FinancialAccountFeatureType["NEGATIVE_BALANCE_RESERVE"] = "NEGATIVE_BALANCE_RESERVE";
    /** Whether or not the Financial Account supports On-Demand Funding. */ FinancialAccountFeatureType["ON_DEMAND_FUNDING"] = "ON_DEMAND_FUNDING";
    /** Whether or not the Financial Account supports Payroll Advance. */ FinancialAccountFeatureType["PAYROLL_ADVANCE"] = "PAYROLL_ADVANCE";
    /** Whether or not the Financial Account supports Payroll Employer Advance. */ FinancialAccountFeatureType["PAYROLL_EMPLOYER_ADVANCE"] = "PAYROLL_EMPLOYER_ADVANCE";
    /** Whether or not the Financial Account supports Point Rewards. */ FinancialAccountFeatureType["POINT_REWARDS"] = "POINT_REWARDS";
    /** Whether or not the Financial Account supports a PrePaid Payment Card. */ FinancialAccountFeatureType["PREPAID_PAYMENT_CARD"] = "PREPAID_PAYMENT_CARD";
    /** Whether or not the `FinancialAccount` supports the preprinted card account feature. */ FinancialAccountFeatureType["PREPRINTED_CARD"] = "PREPRINTED_CARD";
    /** Whether or not the Financial Account supports Product Funding. */ FinancialAccountFeatureType["PRODUCT_FUNDING"] = "PRODUCT_FUNDING";
    /** Whether or not the Financial Account supports Product Reserve. */ FinancialAccountFeatureType["PRODUCT_RESERVE"] = "PRODUCT_RESERVE";
    /** Whether or not the `FinancialAccount` supports the product secured deposit account feature. */ FinancialAccountFeatureType["PRODUCT_SECURED_DEPOSIT"] = "PRODUCT_SECURED_DEPOSIT";
    /** Whether or not the `FinancialAccount` supports the repayment account feature. */ FinancialAccountFeatureType["REPAYMENT_ACCOUNT"] = "REPAYMENT_ACCOUNT";
    /** Whether or not the `FinancialAccount` supports the reset balance account feature. */ FinancialAccountFeatureType["RESET_BALANCE"] = "RESET_BALANCE";
    /** Whether or not the Financial Account supports a Secured Deposit Funded Credit Payment Card. */ FinancialAccountFeatureType["SECURED_CREDIT_PAYMENT_CARD"] = "SECURED_CREDIT_PAYMENT_CARD";
    /** Whether or not the `FinancialAccount` supports the secured deposit account feature. */ FinancialAccountFeatureType["SECURED_DEPOSIT"] = "SECURED_DEPOSIT";
    /** Whether or not the `FinancialAccount` supports the suspense account feature. */ FinancialAccountFeatureType["SUSPENSE"] = "SUSPENSE";
    return FinancialAccountFeatureType;
}({});
var $2f53fee15f29b056$export$efd86e4752961a85 = /*#__PURE__*/ function(FinancialAccountPseudoBalanceUpdateStatus) {
    /** The platform has completed the pseudo balance update. */ FinancialAccountPseudoBalanceUpdateStatus["COMPLETED"] = "COMPLETED";
    /** The platform was not able to complete the limit update. See `statusReasonCode` for more information. */ FinancialAccountPseudoBalanceUpdateStatus["FAILED"] = "FAILED";
    /** The platform is currently validating and executing the limit update. */ FinancialAccountPseudoBalanceUpdateStatus["PENDING"] = "PENDING";
    return FinancialAccountPseudoBalanceUpdateStatus;
}({});
var $2f53fee15f29b056$export$abc1ca3d19aab842 = /*#__PURE__*/ function(FinancialAccountPseudoBalanceUpdateStatusReason) {
    /** The account has been closed so the pseudo balance update can not be applied. */ FinancialAccountPseudoBalanceUpdateStatusReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The financial account ID provided was not tied to a valid financial account. Double check the `financialAccountId` and try again. */ FinancialAccountPseudoBalanceUpdateStatusReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    return FinancialAccountPseudoBalanceUpdateStatusReason;
}({});
var $2f53fee15f29b056$export$f764f1691e6b97f = /*#__PURE__*/ function(FinancialAccountStatus) {
    /** The `FinancialAccount` is active and in good standing. */ FinancialAccountStatus["ACTIVE"] = "ACTIVE";
    /**
   * The Financial Account is Closed.
   *
   * This is a terminal state and cannot be reversed.
   */ FinancialAccountStatus["CLOSED"] = "CLOSED";
    /**
   * The `FinancialAccount` is pending closure and will be restricted until it is closed.
   *
   * Once a `FinancialAccount` is marked for closure, it cannot be reversed. A `PENDING_CLOSURE` account status may become `CLOSED` when the Issuer completes checks on the account.
   */ FinancialAccountStatus["PENDING_CLOSURE"] = "PENDING_CLOSURE";
    /**
   * The `FinancialAccount` is suspended and may have certain restrictions in effect.
   *
   * There may have been possible fraudulent activity associated with the `FinancialAccount`. The `AccountHolder` may need to contact customer support to resolve these issues prior to the `FinancialAccount` being reinstated.
   */ FinancialAccountStatus["SUSPENDED"] = "SUSPENDED";
    /**
   * The `FinancialAccount` is under review and may have certain restrictions in effect.
   *
   * There may have been possible fraudulent activity associated with the `FinancialAccount`. The `AccountHolder` may need to contact customer support to resolve these issues prior to the `FinancialAccount` being reinstated.
   */ FinancialAccountStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
    return FinancialAccountStatus;
}({});
var $2f53fee15f29b056$export$2d352ece5ad9f5aa = /*#__PURE__*/ function(FinancialAccountSuspensionReasonInput) {
    /** The `FinancialAccount` is being suspended due to account holder request. */ FinancialAccountSuspensionReasonInput["ACCOUNT_HOLDER_REQUEST"] = "ACCOUNT_HOLDER_REQUEST";
    /** The `FinancialAccount` is being suspended due to account review. */ FinancialAccountSuspensionReasonInput["ACCOUNT_REVIEW"] = "ACCOUNT_REVIEW";
    /** The `FinancialAccount` is being suspended due to related ACH transfer returns. */ FinancialAccountSuspensionReasonInput["ACH_RETURNS"] = "ACH_RETURNS";
    /** The `FinancialAccount` is being suspended due to delinquency. */ FinancialAccountSuspensionReasonInput["DELINQUENCY"] = "DELINQUENCY";
    /** The `FinancialAccount` is being suspended due to lost or stolen `PaymentCard`. */ FinancialAccountSuspensionReasonInput["LOST_OR_STOLEN_CARD"] = "LOST_OR_STOLEN_CARD";
    /** The `FinancialAccount` is being suspended due to suspected fraud. */ FinancialAccountSuspensionReasonInput["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    return FinancialAccountSuspensionReasonInput;
}({});
var $2f53fee15f29b056$export$1dc8e727ee0a96cf = /*#__PURE__*/ function(FinancialEventType) {
    /** The name of a financial event representing ADJUST_FEE. */ FinancialEventType["ADJUST_FEE"] = "ADJUST_FEE";
    /** The name of a financial event representing ADJUST_SETTLEMENT_AMOUNT. */ FinancialEventType["ADJUST_SETTLEMENT_AMOUNT"] = "ADJUST_SETTLEMENT_AMOUNT";
    /** The name of a financial event representing ADJUST_TRANSACTION_AMOUNT. */ FinancialEventType["ADJUST_TRANSACTION_AMOUNT"] = "ADJUST_TRANSACTION_AMOUNT";
    /** The name of a financial event representing AUTHORIZATION. */ FinancialEventType["AUTHORIZATION"] = "AUTHORIZATION";
    /**
   * The name of a financial event representing AUTHORIZATION_AND_CLEAR_EVENT.
   * @deprecated Use AUTHORIZE_AND_CLEAR instead
   */ FinancialEventType["AUTHORIZATION_AND_CLEAR_EVENT"] = "AUTHORIZATION_AND_CLEAR_EVENT";
    /**
   * The name of a financial event representing AUTHORIZATION_EVENT.
   * @deprecated Use AUTHORIZATION or AUTHORIZE instead
   */ FinancialEventType["AUTHORIZATION_EVENT"] = "AUTHORIZATION_EVENT";
    /** The name of a financial event representing AUTHORIZE. */ FinancialEventType["AUTHORIZE"] = "AUTHORIZE";
    /** The name of a financial event representing AUTHORIZE_AND_CLEAR. */ FinancialEventType["AUTHORIZE_AND_CLEAR"] = "AUTHORIZE_AND_CLEAR";
    /** The name of a financial event representing CLEAR. */ FinancialEventType["CLEAR"] = "CLEAR";
    /** The name of a financial event representing CLEARING. */ FinancialEventType["CLEARING"] = "CLEARING";
    /**
   * The name of a financial event representing CLEARING_EVENT.
   * @deprecated Use CLEARING instead
   */ FinancialEventType["CLEARING_EVENT"] = "CLEARING_EVENT";
    /** The name of a financial event representing CREDIT_CARD_TRANSFER. */ FinancialEventType["CREDIT_CARD_TRANSFER"] = "CREDIT_CARD_TRANSFER";
    /**
   * The name of a financial event representing CREDIT_CARD_TRANSFER_EVENT.
   * @deprecated Use CREDIT_CARD_TRANSFER instead
   */ FinancialEventType["CREDIT_CARD_TRANSFER_EVENT"] = "CREDIT_CARD_TRANSFER_EVENT";
    /** The name of a financial event representing CREDIT_FUNDS_ACH_TRANSFER. */ FinancialEventType["CREDIT_FUNDS_ACH_TRANSFER"] = "CREDIT_FUNDS_ACH_TRANSFER";
    /**
   * The name of a financial event representing CREDIT_FUNDS_ACH_TRANSFER_EVENT.
   * @deprecated Use CREDIT_FUNDS_ACH_TRANSFER instead
   */ FinancialEventType["CREDIT_FUNDS_ACH_TRANSFER_EVENT"] = "CREDIT_FUNDS_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing DEBIT_FUNDS_ACH_TRANSFER. */ FinancialEventType["DEBIT_FUNDS_ACH_TRANSFER"] = "DEBIT_FUNDS_ACH_TRANSFER";
    /**
   * The name of a financial event representing DEBIT_FUNDS_ACH_TRANSFER_EVENT.
   * @deprecated Use DEBIT_FUNDS_ACH_TRANSFER instead
   */ FinancialEventType["DEBIT_FUNDS_ACH_TRANSFER_EVENT"] = "DEBIT_FUNDS_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing DISBURSEMENT_TRANSFER. */ FinancialEventType["DISBURSEMENT_TRANSFER"] = "DISBURSEMENT_TRANSFER";
    /**
   * The name of a financial event representing DISBURSEMENT_TRANSFER_EVENT.
   * @deprecated Use DISBURSEMENT_TRANSFER instead
   */ FinancialEventType["DISBURSEMENT_TRANSFER_EVENT"] = "DISBURSEMENT_TRANSFER_EVENT";
    /** The name of a financial event representing EFT. */ FinancialEventType["EFT"] = "EFT";
    /**
   * The name of a financial event representing EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER.
   * @deprecated Use EXTERNAL_MONEY_MOVEMENT instead
   */ FinancialEventType["EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER"] = "EXTERNALLY_INITIATED_ACH_RELEASE_HOLD_TRANSFER";
    /** The name of a financial event representing EXTERNAL_MONEY_MOVEMENT. */ FinancialEventType["EXTERNAL_MONEY_MOVEMENT"] = "EXTERNAL_MONEY_MOVEMENT";
    /**
   * The name of a financial event representing EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT.
   * @deprecated Use EXTERNAL_MONEY_MOVEMENT instead
   */ FinancialEventType["EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT"] = "EXTERNAL_MONEY_MOVEMENT_TRANSACTION_EVENT";
    /** The name of a financial event representing FEE_TRANSFER. */ FinancialEventType["FEE_TRANSFER"] = "FEE_TRANSFER";
    /**
   * The name of a financial event representing FEE_TRANSFER_EVENT.
   * @deprecated Use FEE_TRANSFER instead
   */ FinancialEventType["FEE_TRANSFER_EVENT"] = "FEE_TRANSFER_EVENT";
    /**
   * The name of a financial event representing FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING.
   * @deprecated No longer supported
   */ FinancialEventType["FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING"] = "FINANCIAL_ACCOUNT_CREDIT_LIMIT_UPDATE_FROM_PRODUCT_FUNDING";
    /**
   * The name of a financial event representing FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE.
   * @deprecated No longer supported
   */ FinancialEventType["FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE"] = "FINANCIAL_ACCOUNT_PSEUDO_BALANCE_UPDATE";
    /** The name of a financial event representing INSTANT_NETWORK_TRANSFER. */ FinancialEventType["INSTANT_NETWORK_TRANSFER"] = "INSTANT_NETWORK_TRANSFER";
    /** The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER. */ FinancialEventType["INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER"] = "INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER";
    /**
   * The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT.
   * @deprecated No longer supported
   */ FinancialEventType["INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT"] = "INTEGRATOR_INITIATED_FUNDS_DEPOSIT_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER. */ FinancialEventType["INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER"] = "INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER";
    /**
   * The name of a financial event representing INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT.
   * @deprecated No longer supported
   */ FinancialEventType["INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT"] = "INTEGRATOR_INITIATED_FUNDS_WITHDRAWAL_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing INTER_FINANCIAL_ACCOUNT_TRANSFER. */ FinancialEventType["INTER_FINANCIAL_ACCOUNT_TRANSFER"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER";
    /**
   * The name of a financial event representing INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT.
   * @deprecated No longer supported
   */ FinancialEventType["INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER_EVENT";
    /** The name of a financial event representing ISSUER_PRELIMINARY_AUTHORIZATION. */ FinancialEventType["ISSUER_PRELIMINARY_AUTHORIZATION"] = "ISSUER_PRELIMINARY_AUTHORIZATION";
    /**
   * The name of a financial event representing ISSUER_PRELIMINARY_AUTHORIZATION_EVENT.
   * @deprecated No longer supported
   */ FinancialEventType["ISSUER_PRELIMINARY_AUTHORIZATION_EVENT"] = "ISSUER_PRELIMINARY_AUTHORIZATION_EVENT";
    /**
   * The name of a financial event representing MANUAL_ADJUSTMENT_EVENT.
   * @deprecated Use MANUAL_RECONCILE instead
   */ FinancialEventType["MANUAL_ADJUSTMENT_EVENT"] = "MANUAL_ADJUSTMENT_EVENT";
    /** The name of a financial event representing MANUAL_RECONCILE. */ FinancialEventType["MANUAL_RECONCILE"] = "MANUAL_RECONCILE";
    /** The name of a financial event representing PAYROLL_ACH_TRANSFER. */ FinancialEventType["PAYROLL_ACH_TRANSFER"] = "PAYROLL_ACH_TRANSFER";
    /**
   * The name of a financial event representing PAYROLL_ACH_TRANSFER_EVENT.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */ FinancialEventType["PAYROLL_ACH_TRANSFER_EVENT"] = "PAYROLL_ACH_TRANSFER_EVENT";
    /**
   * The name of a financial event representing PAYROLL_ADVANCE_REPAYMENT_TRANSFER.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */ FinancialEventType["PAYROLL_ADVANCE_REPAYMENT_TRANSFER"] = "PAYROLL_ADVANCE_REPAYMENT_TRANSFER";
    /**
   * The name of a financial event representing PAYROLL_ADVANCE_WRITEOFF_TRANSFER.
   * @deprecated Use PAYROLL_ACH_TRANSFER instead
   */ FinancialEventType["PAYROLL_ADVANCE_WRITEOFF_TRANSFER"] = "PAYROLL_ADVANCE_WRITEOFF_TRANSFER";
    /** The name of a financial event representing RECONCILIATION_ACCOUNT_TRANSFER. */ FinancialEventType["RECONCILIATION_ACCOUNT_TRANSFER"] = "RECONCILIATION_ACCOUNT_TRANSFER";
    /**
   * The name of a financial event representing REVERSAL_EVENT.
   * @deprecated Use REVERSAL instead
   */ FinancialEventType["REVERSAL_EVENT"] = "REVERSAL_EVENT";
    /** The name of a financial event representing REVERSE. */ FinancialEventType["REVERSE"] = "REVERSE";
    /** The name of a financial event representing REWARD_POINTS_TRANSFER. */ FinancialEventType["REWARD_POINTS_TRANSFER"] = "REWARD_POINTS_TRANSFER";
    /** The name of a financial event representing SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER. */ FinancialEventType["SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER"] = "SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER";
    /**
   * The name of a financial event representing SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT.
   * @deprecated Use SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER instead
   */ FinancialEventType["SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT"] = "SECURE_CARD_BALANCE_REPAYMENT_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing SECURE_DEPOSIT_ACH_TRANSFER. */ FinancialEventType["SECURE_DEPOSIT_ACH_TRANSFER"] = "SECURE_DEPOSIT_ACH_TRANSFER";
    /**
   * The name of a financial event representing SECURE_DEPOSIT_ACH_TRANSFER_EVENT.
   * @deprecated Use SECURE_DEPOSIT_ACH_TRANSFER instead
   */ FinancialEventType["SECURE_DEPOSIT_ACH_TRANSFER_EVENT"] = "SECURE_DEPOSIT_ACH_TRANSFER_EVENT";
    /** The name of a financial event representing SECURE_DEPOSIT_TRANSFER. */ FinancialEventType["SECURE_DEPOSIT_TRANSFER"] = "SECURE_DEPOSIT_TRANSFER";
    /**
   * The name of a financial event representing SECURE_DEPOSIT_TRANSFER_EVENT.
   * @deprecated Use SECURE_DEPOSIT_TRANSFER instead
   */ FinancialEventType["SECURE_DEPOSIT_TRANSFER_EVENT"] = "SECURE_DEPOSIT_TRANSFER_EVENT";
    /** The name of a financial event representing TRANSFER. */ FinancialEventType["TRANSFER"] = "TRANSFER";
    /**
   * The name of a financial event representing WIRE_TRANSFER.
   * @deprecated Use TRANSFER instead
   */ FinancialEventType["WIRE_TRANSFER"] = "WIRE_TRANSFER";
    return FinancialEventType;
}({});
var $2f53fee15f29b056$export$ef2374253d085998 = /*#__PURE__*/ function(FinicityProductType) {
    /** Retrieves a customer's ACH routing and account numbers. */ FinicityProductType["ACH_DETAILS"] = "ACH_DETAILS";
    /** Retrieves the names and addresses of the account owner from a financial institution. */ FinicityProductType["ACH_OWNER_DETAILS"] = "ACH_OWNER_DETAILS";
    /**
   * Retrieves the latest cached available and cleared account balances for a single customer account.
   * Faster than CURRENT_BALANCE.
   */ FinicityProductType["APPROXIMATE_BALANCE"] = "APPROXIMATE_BALANCE";
    /** Retrieves a customer's up-to-date account balance. */ FinicityProductType["CURRENT_BALANCE"] = "CURRENT_BALANCE";
    return FinicityProductType;
}({});
var $2f53fee15f29b056$export$94e02056c47e8f0f = /*#__PURE__*/ function(FormFactorType) {
    /** Physical card */ FormFactorType["PHYSICAL_CARD"] = "PHYSICAL_CARD";
    /** Wristband */ FormFactorType["WRISTBAND"] = "WRISTBAND";
    return FormFactorType;
}({});
var $2f53fee15f29b056$export$779c7f8fdc1a54e2 = /*#__PURE__*/ function(GenerateFinancialAccountSingleUseClientTokenPermission) {
    /** Allows issuing a payment card for a financial account */ GenerateFinancialAccountSingleUseClientTokenPermission["ISSUE_PAYMENT_CARD"] = "ISSUE_PAYMENT_CARD";
    return GenerateFinancialAccountSingleUseClientTokenPermission;
}({});
var $2f53fee15f29b056$export$148dcdc02730120d = /*#__PURE__*/ function(GeneratePaymentMethodTokenizationClientTokenPermission) {
    /** Setting this permission will enable the tokenization of a payment method via the Secure Inputs SDK. */ GeneratePaymentMethodTokenizationClientTokenPermission["TOKENIZE_PAYMENT_METHOD"] = "TOKENIZE_PAYMENT_METHOD";
    return GeneratePaymentMethodTokenizationClientTokenPermission;
}({});
var $2f53fee15f29b056$export$e76daf6a602bb208 = /*#__PURE__*/ function(GlobalNoteAggregateEntityType) {
    /** The account holder aggregate type. When using this type you can resolve all global notes on the `AccountHolder`. */ GlobalNoteAggregateEntityType["ACCOUNT_HOLDER"] = "ACCOUNT_HOLDER";
    return GlobalNoteAggregateEntityType;
}({});
var $2f53fee15f29b056$export$a95e10a15e7bc41c = /*#__PURE__*/ function(GlobalNotePrimaryEntityType) {
    /** The account holder card product application primary type. When using this type you can resolve global notes on the `AccountHolderCardProductApplication` object. */ GlobalNotePrimaryEntityType["ACCOUNT_HOLDER_CARD_PRODUCT_APPLICATION"] = "ACCOUNT_HOLDER_CARD_PRODUCT_APPLICATION";
    /** The financial account primary type. When using this type you can resolve global notes on the `FinancialAccount` object. */ GlobalNotePrimaryEntityType["FINANCIAL_ACCOUNT"] = "FINANCIAL_ACCOUNT";
    return GlobalNotePrimaryEntityType;
}({});
var $2f53fee15f29b056$export$20355276c34a6730 = /*#__PURE__*/ function(Iso3166Alpha3Country) {
    /** The country code for Aruba. */ Iso3166Alpha3Country["ABW"] = "ABW";
    /** The country code for Afghanistan. */ Iso3166Alpha3Country["AFG"] = "AFG";
    /** The country code for Angola. */ Iso3166Alpha3Country["AGO"] = "AGO";
    /** The country code for Anguilla. */ Iso3166Alpha3Country["AIA"] = "AIA";
    /** The country code for Åland Islands. */ Iso3166Alpha3Country["ALA"] = "ALA";
    /** The country code for Albania. */ Iso3166Alpha3Country["ALB"] = "ALB";
    /** The country code for Andorra. */ Iso3166Alpha3Country["AND"] = "AND";
    /** The country code for United Arab Emirates. */ Iso3166Alpha3Country["ARE"] = "ARE";
    /** The country code for Argentina. */ Iso3166Alpha3Country["ARG"] = "ARG";
    /** The country code for Armenia. */ Iso3166Alpha3Country["ARM"] = "ARM";
    /** The country code for American Samoa. */ Iso3166Alpha3Country["ASM"] = "ASM";
    /** The country code for Antarctica. */ Iso3166Alpha3Country["ATA"] = "ATA";
    /** The country code for French Southern Territories. */ Iso3166Alpha3Country["ATF"] = "ATF";
    /** The country code for Antigua and Barbuda. */ Iso3166Alpha3Country["ATG"] = "ATG";
    /** The country code for Australia. */ Iso3166Alpha3Country["AUS"] = "AUS";
    /** The country code for Austria. */ Iso3166Alpha3Country["AUT"] = "AUT";
    /** The country code for Azerbaijan. */ Iso3166Alpha3Country["AZE"] = "AZE";
    /** The country code for Burundi. */ Iso3166Alpha3Country["BDI"] = "BDI";
    /** The country code for Belgium. */ Iso3166Alpha3Country["BEL"] = "BEL";
    /** The country code for Benin. */ Iso3166Alpha3Country["BEN"] = "BEN";
    /** The country code for "Bonaire, Sint Eustatius and Saba". */ Iso3166Alpha3Country["BES"] = "BES";
    /** The country code for Burkina Faso. */ Iso3166Alpha3Country["BFA"] = "BFA";
    /** The country code for Bangladesh. */ Iso3166Alpha3Country["BGD"] = "BGD";
    /** The country code for Bulgaria. */ Iso3166Alpha3Country["BGR"] = "BGR";
    /** The country code for Bahrain. */ Iso3166Alpha3Country["BHR"] = "BHR";
    /** The country code for Bahamas. */ Iso3166Alpha3Country["BHS"] = "BHS";
    /** The country code for Bosnia and Herzegovina. */ Iso3166Alpha3Country["BIH"] = "BIH";
    /** The country code for Saint Barthélemy. */ Iso3166Alpha3Country["BLM"] = "BLM";
    /** The country code for Belarus. */ Iso3166Alpha3Country["BLR"] = "BLR";
    /** The country code for Belize. */ Iso3166Alpha3Country["BLZ"] = "BLZ";
    /** The country code for Bermuda. */ Iso3166Alpha3Country["BMU"] = "BMU";
    /** The country code for Bolivia (Plurinational State of). */ Iso3166Alpha3Country["BOL"] = "BOL";
    /** The country code for Brazil. */ Iso3166Alpha3Country["BRA"] = "BRA";
    /** The country code for Barbados. */ Iso3166Alpha3Country["BRB"] = "BRB";
    /** The country code for Brunei Darussalam. */ Iso3166Alpha3Country["BRN"] = "BRN";
    /** The country code for Bhutan. */ Iso3166Alpha3Country["BTN"] = "BTN";
    /** The country code for Bouvet Island. */ Iso3166Alpha3Country["BVT"] = "BVT";
    /** The country code for Botswana. */ Iso3166Alpha3Country["BWA"] = "BWA";
    /** The country code for Central African Republic. */ Iso3166Alpha3Country["CAF"] = "CAF";
    /** The country code for Canada. */ Iso3166Alpha3Country["CAN"] = "CAN";
    /** The country code for Cocos (Keeling) Islands. */ Iso3166Alpha3Country["CCK"] = "CCK";
    /** The country code for Switzerland. */ Iso3166Alpha3Country["CHE"] = "CHE";
    /** The country code for Chile. */ Iso3166Alpha3Country["CHL"] = "CHL";
    /** The country code for China. */ Iso3166Alpha3Country["CHN"] = "CHN";
    /** The country code for Côte d'Ivoire. */ Iso3166Alpha3Country["CIV"] = "CIV";
    /** The country code for Cameroon. */ Iso3166Alpha3Country["CMR"] = "CMR";
    /** The country code for "Congo, Democratic Republic of the". */ Iso3166Alpha3Country["COD"] = "COD";
    /** The country code for Congo. */ Iso3166Alpha3Country["COG"] = "COG";
    /** The country code for Cook Islands. */ Iso3166Alpha3Country["COK"] = "COK";
    /** The country code for Colombia. */ Iso3166Alpha3Country["COL"] = "COL";
    /** The country code for Comoros. */ Iso3166Alpha3Country["COM"] = "COM";
    /** The country code for Cabo Verde. */ Iso3166Alpha3Country["CPV"] = "CPV";
    /** The country code for Costa Rica. */ Iso3166Alpha3Country["CRI"] = "CRI";
    /** The country code for Cuba. */ Iso3166Alpha3Country["CUB"] = "CUB";
    /** The country code for Curaçao. */ Iso3166Alpha3Country["CUW"] = "CUW";
    /** The country code for Christmas Island. */ Iso3166Alpha3Country["CXR"] = "CXR";
    /** The country code for Cayman Islands. */ Iso3166Alpha3Country["CYM"] = "CYM";
    /** The country code for Cyprus. */ Iso3166Alpha3Country["CYP"] = "CYP";
    /** The country code for Czechia. */ Iso3166Alpha3Country["CZE"] = "CZE";
    /** The country code for Germany. */ Iso3166Alpha3Country["DEU"] = "DEU";
    /** The country code for Djibouti. */ Iso3166Alpha3Country["DJI"] = "DJI";
    /** The country code for Dominica. */ Iso3166Alpha3Country["DMA"] = "DMA";
    /** The country code for Denmark. */ Iso3166Alpha3Country["DNK"] = "DNK";
    /** The country code for Dominican Republic. */ Iso3166Alpha3Country["DOM"] = "DOM";
    /** The country code for Algeria. */ Iso3166Alpha3Country["DZA"] = "DZA";
    /** The country code for Ecuador. */ Iso3166Alpha3Country["ECU"] = "ECU";
    /** The country code for Egypt. */ Iso3166Alpha3Country["EGY"] = "EGY";
    /** The country code for Eritrea. */ Iso3166Alpha3Country["ERI"] = "ERI";
    /** The country code for Western Sahara. */ Iso3166Alpha3Country["ESH"] = "ESH";
    /** The country code for Spain. */ Iso3166Alpha3Country["ESP"] = "ESP";
    /** The country code for Estonia. */ Iso3166Alpha3Country["EST"] = "EST";
    /** The country code for Ethiopia. */ Iso3166Alpha3Country["ETH"] = "ETH";
    /** The country code for Finland. */ Iso3166Alpha3Country["FIN"] = "FIN";
    /** The country code for Fiji. */ Iso3166Alpha3Country["FJI"] = "FJI";
    /** The country code for Falkland Islands (Malvinas). */ Iso3166Alpha3Country["FLK"] = "FLK";
    /** The country code for France. */ Iso3166Alpha3Country["FRA"] = "FRA";
    /** The country code for Faroe Islands. */ Iso3166Alpha3Country["FRO"] = "FRO";
    /** The country code for Micronesia (Federated States of). */ Iso3166Alpha3Country["FSM"] = "FSM";
    /** The country code for Gabon. */ Iso3166Alpha3Country["GAB"] = "GAB";
    /** The country code for United Kingdom of Great Britain and Northern Ireland. */ Iso3166Alpha3Country["GBR"] = "GBR";
    /** The country code for Georgia. */ Iso3166Alpha3Country["GEO"] = "GEO";
    /** The country code for Guernsey. */ Iso3166Alpha3Country["GGY"] = "GGY";
    /** The country code for Ghana. */ Iso3166Alpha3Country["GHA"] = "GHA";
    /** The country code for Gibraltar. */ Iso3166Alpha3Country["GIB"] = "GIB";
    /** The country code for Guinea. */ Iso3166Alpha3Country["GIN"] = "GIN";
    /** The country code for Guadeloupe. */ Iso3166Alpha3Country["GLP"] = "GLP";
    /** The country code for Gambia. */ Iso3166Alpha3Country["GMB"] = "GMB";
    /** The country code for Guinea-Bissau. */ Iso3166Alpha3Country["GNB"] = "GNB";
    /** The country code for Equatorial Guinea. */ Iso3166Alpha3Country["GNQ"] = "GNQ";
    /** The country code for Greece. */ Iso3166Alpha3Country["GRC"] = "GRC";
    /** The country code for Grenada. */ Iso3166Alpha3Country["GRD"] = "GRD";
    /** The country code for Greenland. */ Iso3166Alpha3Country["GRL"] = "GRL";
    /** The country code for Guatemala. */ Iso3166Alpha3Country["GTM"] = "GTM";
    /** The country code for French Guiana. */ Iso3166Alpha3Country["GUF"] = "GUF";
    /** The country code for Guam. */ Iso3166Alpha3Country["GUM"] = "GUM";
    /** The country code for Guyana. */ Iso3166Alpha3Country["GUY"] = "GUY";
    /** The country code for Hong Kong. */ Iso3166Alpha3Country["HKG"] = "HKG";
    /** The country code for Heard Island and McDonald Islands. */ Iso3166Alpha3Country["HMD"] = "HMD";
    /** The country code for Honduras. */ Iso3166Alpha3Country["HND"] = "HND";
    /** The country code for Croatia. */ Iso3166Alpha3Country["HRV"] = "HRV";
    /** The country code for Haiti. */ Iso3166Alpha3Country["HTI"] = "HTI";
    /** The country code for Hungary. */ Iso3166Alpha3Country["HUN"] = "HUN";
    /** The country code for Indonesia. */ Iso3166Alpha3Country["IDN"] = "IDN";
    /** The country code for Isle of Man. */ Iso3166Alpha3Country["IMN"] = "IMN";
    /** The country code for India. */ Iso3166Alpha3Country["IND"] = "IND";
    /** The country code for British Indian Ocean Territory. */ Iso3166Alpha3Country["IOT"] = "IOT";
    /** The country code for Ireland. */ Iso3166Alpha3Country["IRL"] = "IRL";
    /** The country code for Iran (Islamic Republic of). */ Iso3166Alpha3Country["IRN"] = "IRN";
    /** The country code for Iraq. */ Iso3166Alpha3Country["IRQ"] = "IRQ";
    /** The country code for Iceland. */ Iso3166Alpha3Country["ISL"] = "ISL";
    /** The country code for Israel. */ Iso3166Alpha3Country["ISR"] = "ISR";
    /** The country code for Italy. */ Iso3166Alpha3Country["ITA"] = "ITA";
    /** The country code for Jamaica. */ Iso3166Alpha3Country["JAM"] = "JAM";
    /** The country code for Jersey. */ Iso3166Alpha3Country["JEY"] = "JEY";
    /** The country code for Jordan. */ Iso3166Alpha3Country["JOR"] = "JOR";
    /** The country code for Japan. */ Iso3166Alpha3Country["JPN"] = "JPN";
    /** The country code for Kazakhstan. */ Iso3166Alpha3Country["KAZ"] = "KAZ";
    /** The country code for Kenya. */ Iso3166Alpha3Country["KEN"] = "KEN";
    /** The country code for Kyrgyzstan. */ Iso3166Alpha3Country["KGZ"] = "KGZ";
    /** The country code for Cambodia. */ Iso3166Alpha3Country["KHM"] = "KHM";
    /** The country code for Kiribati. */ Iso3166Alpha3Country["KIR"] = "KIR";
    /** The country code for Saint Kitts and Nevis. */ Iso3166Alpha3Country["KNA"] = "KNA";
    /** The country code for "Korea, Republic of". */ Iso3166Alpha3Country["KOR"] = "KOR";
    /** The country code for Kuwait. */ Iso3166Alpha3Country["KWT"] = "KWT";
    /** The country code for Lao People's Democratic Republic. */ Iso3166Alpha3Country["LAO"] = "LAO";
    /** The country code for Lebanon. */ Iso3166Alpha3Country["LBN"] = "LBN";
    /** The country code for Liberia. */ Iso3166Alpha3Country["LBR"] = "LBR";
    /** The country code for Libya. */ Iso3166Alpha3Country["LBY"] = "LBY";
    /** The country code for Saint Lucia. */ Iso3166Alpha3Country["LCA"] = "LCA";
    /** The country code for Liechtenstein. */ Iso3166Alpha3Country["LIE"] = "LIE";
    /** The country code for Sri Lanka. */ Iso3166Alpha3Country["LKA"] = "LKA";
    /** The country code for Lesotho. */ Iso3166Alpha3Country["LSO"] = "LSO";
    /** The country code for Lithuania. */ Iso3166Alpha3Country["LTU"] = "LTU";
    /** The country code for Luxembourg. */ Iso3166Alpha3Country["LUX"] = "LUX";
    /** The country code for Latvia. */ Iso3166Alpha3Country["LVA"] = "LVA";
    /** The country code for Macao. */ Iso3166Alpha3Country["MAC"] = "MAC";
    /** The country code for Saint Martin (French part). */ Iso3166Alpha3Country["MAF"] = "MAF";
    /** The country code for Morocco. */ Iso3166Alpha3Country["MAR"] = "MAR";
    /** The country code for Monaco. */ Iso3166Alpha3Country["MCO"] = "MCO";
    /** The country code for "Moldova, Republic of". */ Iso3166Alpha3Country["MDA"] = "MDA";
    /** The country code for Madagascar. */ Iso3166Alpha3Country["MDG"] = "MDG";
    /** The country code for Maldives. */ Iso3166Alpha3Country["MDV"] = "MDV";
    /** The country code for Mexico. */ Iso3166Alpha3Country["MEX"] = "MEX";
    /** The country code for Marshall Islands. */ Iso3166Alpha3Country["MHL"] = "MHL";
    /** The country code for North Macedonia. */ Iso3166Alpha3Country["MKD"] = "MKD";
    /** The country code for Mali. */ Iso3166Alpha3Country["MLI"] = "MLI";
    /** The country code for Malta. */ Iso3166Alpha3Country["MLT"] = "MLT";
    /** The country code for Myanmar. */ Iso3166Alpha3Country["MMR"] = "MMR";
    /** The country code for Montenegro. */ Iso3166Alpha3Country["MNE"] = "MNE";
    /** The country code for Mongolia. */ Iso3166Alpha3Country["MNG"] = "MNG";
    /** The country code for Northern Mariana Islands. */ Iso3166Alpha3Country["MNP"] = "MNP";
    /** The country code for Mozambique. */ Iso3166Alpha3Country["MOZ"] = "MOZ";
    /** The country code for Mauritania. */ Iso3166Alpha3Country["MRT"] = "MRT";
    /** The country code for Montserrat. */ Iso3166Alpha3Country["MSR"] = "MSR";
    /** The country code for Martinique. */ Iso3166Alpha3Country["MTQ"] = "MTQ";
    /** The country code for Mauritius. */ Iso3166Alpha3Country["MUS"] = "MUS";
    /** The country code for Malawi. */ Iso3166Alpha3Country["MWI"] = "MWI";
    /** The country code for Malaysia. */ Iso3166Alpha3Country["MYS"] = "MYS";
    /** The country code for Mayotte. */ Iso3166Alpha3Country["MYT"] = "MYT";
    /** The country code for Namibia. */ Iso3166Alpha3Country["NAM"] = "NAM";
    /** The country code for New Caledonia. */ Iso3166Alpha3Country["NCL"] = "NCL";
    /** The country code for Niger. */ Iso3166Alpha3Country["NER"] = "NER";
    /** The country code for Norfolk Island. */ Iso3166Alpha3Country["NFK"] = "NFK";
    /** The country code for Nigeria. */ Iso3166Alpha3Country["NGA"] = "NGA";
    /** The country code for Nicaragua. */ Iso3166Alpha3Country["NIC"] = "NIC";
    /** The country code for Niue. */ Iso3166Alpha3Country["NIU"] = "NIU";
    /** The country code for Netherlands. */ Iso3166Alpha3Country["NLD"] = "NLD";
    /** The country code for Norway. */ Iso3166Alpha3Country["NOR"] = "NOR";
    /** The country code for Nepal. */ Iso3166Alpha3Country["NPL"] = "NPL";
    /** The country code for Nauru. */ Iso3166Alpha3Country["NRU"] = "NRU";
    /** The country code for New Zealand. */ Iso3166Alpha3Country["NZL"] = "NZL";
    /** The country code for Oman. */ Iso3166Alpha3Country["OMN"] = "OMN";
    /** The country code for Pakistan. */ Iso3166Alpha3Country["PAK"] = "PAK";
    /** The country code for Panama. */ Iso3166Alpha3Country["PAN"] = "PAN";
    /** The country code for Pitcairn. */ Iso3166Alpha3Country["PCN"] = "PCN";
    /** The country code for Peru. */ Iso3166Alpha3Country["PER"] = "PER";
    /** The country code for Philippines. */ Iso3166Alpha3Country["PHL"] = "PHL";
    /** The country code for Palau. */ Iso3166Alpha3Country["PLW"] = "PLW";
    /** The country code for Papua New Guinea. */ Iso3166Alpha3Country["PNG"] = "PNG";
    /** The country code for Poland. */ Iso3166Alpha3Country["POL"] = "POL";
    /** The country code for Puerto Rico. */ Iso3166Alpha3Country["PRI"] = "PRI";
    /** The country code for Korea (Democratic People's Republic of). */ Iso3166Alpha3Country["PRK"] = "PRK";
    /** The country code for Portugal. */ Iso3166Alpha3Country["PRT"] = "PRT";
    /** The country code for Paraguay. */ Iso3166Alpha3Country["PRY"] = "PRY";
    /** The country code for "Palestine, State of". */ Iso3166Alpha3Country["PSE"] = "PSE";
    /** The country code for French Polynesia. */ Iso3166Alpha3Country["PYF"] = "PYF";
    /** The country code for Qatar. */ Iso3166Alpha3Country["QAT"] = "QAT";
    /** The country code for Kosovo. Note: "It is not ISO 3166 approved, but is approved by Visa and Mastercard" */ Iso3166Alpha3Country["QZZ"] = "QZZ";
    /** The country code for Réunion. */ Iso3166Alpha3Country["REU"] = "REU";
    /** The country code for Romania. */ Iso3166Alpha3Country["ROU"] = "ROU";
    /** The country code for Russian Federation. */ Iso3166Alpha3Country["RUS"] = "RUS";
    /** The country code for Rwanda. */ Iso3166Alpha3Country["RWA"] = "RWA";
    /** The country code for Saudi Arabia. */ Iso3166Alpha3Country["SAU"] = "SAU";
    /** The country code for Sudan. */ Iso3166Alpha3Country["SDN"] = "SDN";
    /** The country code for Senegal. */ Iso3166Alpha3Country["SEN"] = "SEN";
    /** The country code for Singapore. */ Iso3166Alpha3Country["SGP"] = "SGP";
    /** The country code for South Georgia and the South Sandwich Islands. */ Iso3166Alpha3Country["SGS"] = "SGS";
    /** The country code for "Saint Helena, Ascension and Tristan da Cunha". */ Iso3166Alpha3Country["SHN"] = "SHN";
    /** The country code for Svalbard and Jan Mayen. */ Iso3166Alpha3Country["SJM"] = "SJM";
    /** The country code for Solomon Islands. */ Iso3166Alpha3Country["SLB"] = "SLB";
    /** The country code for Sierra Leone. */ Iso3166Alpha3Country["SLE"] = "SLE";
    /** The country code for El Salvador. */ Iso3166Alpha3Country["SLV"] = "SLV";
    /** The country code for San Marino. */ Iso3166Alpha3Country["SMR"] = "SMR";
    /** The country code for Somalia. */ Iso3166Alpha3Country["SOM"] = "SOM";
    /** The country code for Saint Pierre and Miquelon. */ Iso3166Alpha3Country["SPM"] = "SPM";
    /** The country code for Serbia. */ Iso3166Alpha3Country["SRB"] = "SRB";
    /** The country code for South Sudan. */ Iso3166Alpha3Country["SSD"] = "SSD";
    /** The country code for Sao Tome and Principe. */ Iso3166Alpha3Country["STP"] = "STP";
    /** The country code for Suriname. */ Iso3166Alpha3Country["SUR"] = "SUR";
    /** The country code for Slovakia. */ Iso3166Alpha3Country["SVK"] = "SVK";
    /** The country code for Slovenia. */ Iso3166Alpha3Country["SVN"] = "SVN";
    /** The country code for Sweden. */ Iso3166Alpha3Country["SWE"] = "SWE";
    /** The country code for Eswatini. */ Iso3166Alpha3Country["SWZ"] = "SWZ";
    /** The country code for Sint Maarten (Dutch part). */ Iso3166Alpha3Country["SXM"] = "SXM";
    /** The country code for Seychelles. */ Iso3166Alpha3Country["SYC"] = "SYC";
    /** The country code for Syrian Arab Republic. */ Iso3166Alpha3Country["SYR"] = "SYR";
    /** The country code for Turks and Caicos Islands. */ Iso3166Alpha3Country["TCA"] = "TCA";
    /** The country code for Chad. */ Iso3166Alpha3Country["TCD"] = "TCD";
    /** The country code for Togo. */ Iso3166Alpha3Country["TGO"] = "TGO";
    /** The country code for Thailand. */ Iso3166Alpha3Country["THA"] = "THA";
    /** The country code for Tajikistan. */ Iso3166Alpha3Country["TJK"] = "TJK";
    /** The country code for Tokelau. */ Iso3166Alpha3Country["TKL"] = "TKL";
    /** The country code for Turkmenistan. */ Iso3166Alpha3Country["TKM"] = "TKM";
    /** The country code for Timor-Leste. */ Iso3166Alpha3Country["TLS"] = "TLS";
    /** The country code for Tonga. */ Iso3166Alpha3Country["TON"] = "TON";
    /** The country code for Trinidad and Tobago. */ Iso3166Alpha3Country["TTO"] = "TTO";
    /** The country code for Tunisia. */ Iso3166Alpha3Country["TUN"] = "TUN";
    /** The country code for Turkey. */ Iso3166Alpha3Country["TUR"] = "TUR";
    /** The country code for Tuvalu. */ Iso3166Alpha3Country["TUV"] = "TUV";
    /** The country code for "Taiwan, Province of China". */ Iso3166Alpha3Country["TWN"] = "TWN";
    /** The country code for "Tanzania, United Republic of". */ Iso3166Alpha3Country["TZA"] = "TZA";
    /** The country code for Uganda. */ Iso3166Alpha3Country["UGA"] = "UGA";
    /** The country code for Ukraine. */ Iso3166Alpha3Country["UKR"] = "UKR";
    /** The country code for United States Minor Outlying Islands. */ Iso3166Alpha3Country["UMI"] = "UMI";
    /** The country code for Uruguay. */ Iso3166Alpha3Country["URY"] = "URY";
    /** The country code for United States of America. */ Iso3166Alpha3Country["USA"] = "USA";
    /** The country code for Uzbekistan. */ Iso3166Alpha3Country["UZB"] = "UZB";
    /** The country code for Holy See. */ Iso3166Alpha3Country["VAT"] = "VAT";
    /** The country code for Saint Vincent and the Grenadines. */ Iso3166Alpha3Country["VCT"] = "VCT";
    /** The country code for Venezuela (Bolivarian Republic of). */ Iso3166Alpha3Country["VEN"] = "VEN";
    /** The country code for Virgin Islands (British). */ Iso3166Alpha3Country["VGB"] = "VGB";
    /** The country code for Virgin Islands (U.S.). */ Iso3166Alpha3Country["VIR"] = "VIR";
    /** The country code for Viet Nam. */ Iso3166Alpha3Country["VNM"] = "VNM";
    /** The country code for Vanuatu. */ Iso3166Alpha3Country["VUT"] = "VUT";
    /** The country code for Wallis and Futuna. */ Iso3166Alpha3Country["WLF"] = "WLF";
    /** The country code for Samoa. */ Iso3166Alpha3Country["WSM"] = "WSM";
    /** The country code for Yemen. */ Iso3166Alpha3Country["YEM"] = "YEM";
    /** The country code for South Africa. */ Iso3166Alpha3Country["ZAF"] = "ZAF";
    /** The country code for Zambia. */ Iso3166Alpha3Country["ZMB"] = "ZMB";
    /** The country code for Zimbabwe. */ Iso3166Alpha3Country["ZWE"] = "ZWE";
    return Iso3166Alpha3Country;
}({});
var $2f53fee15f29b056$export$794a1c356b77220e = /*#__PURE__*/ function(Iso4217Alpha3CurrencyCode) {
    /** The code for Andorran Peseta. */ Iso4217Alpha3CurrencyCode["ADP"] = "ADP";
    /** The code for UAE Dirham. */ Iso4217Alpha3CurrencyCode["AED"] = "AED";
    /** The code for Afghani. */ Iso4217Alpha3CurrencyCode["AFA"] = "AFA";
    /** The code for Afghani. */ Iso4217Alpha3CurrencyCode["AFN"] = "AFN";
    /** The code for Old Lek. */ Iso4217Alpha3CurrencyCode["ALK"] = "ALK";
    /** The code for Lek. */ Iso4217Alpha3CurrencyCode["ALL"] = "ALL";
    /** The code for Armenian Dram. */ Iso4217Alpha3CurrencyCode["AMD"] = "AMD";
    /** The code for Netherlands Antillean Guilder. */ Iso4217Alpha3CurrencyCode["ANG"] = "ANG";
    /** The code for Kwanza. */ Iso4217Alpha3CurrencyCode["AOA"] = "AOA";
    /** The code for Kwanza. */ Iso4217Alpha3CurrencyCode["AOK"] = "AOK";
    /** The code for New Kwanza. */ Iso4217Alpha3CurrencyCode["AON"] = "AON";
    /** The code for Kwanza Reajustado. */ Iso4217Alpha3CurrencyCode["AOR"] = "AOR";
    /** The code for Austral. */ Iso4217Alpha3CurrencyCode["ARA"] = "ARA";
    /** The code for Peso Argentino. */ Iso4217Alpha3CurrencyCode["ARP"] = "ARP";
    /** The code for Argentine Peso. */ Iso4217Alpha3CurrencyCode["ARS"] = "ARS";
    /** The code for Peso. */ Iso4217Alpha3CurrencyCode["ARY"] = "ARY";
    /** The code for Schilling. */ Iso4217Alpha3CurrencyCode["ATS"] = "ATS";
    /** The code for Australian Dollar. */ Iso4217Alpha3CurrencyCode["AUD"] = "AUD";
    /** The code for Aruban Florin. */ Iso4217Alpha3CurrencyCode["AWG"] = "AWG";
    /** The code for Azerbaijan Manat. */ Iso4217Alpha3CurrencyCode["AYM"] = "AYM";
    /** The code for Azerbaijanian Manat. */ Iso4217Alpha3CurrencyCode["AZM"] = "AZM";
    /** The code for Azerbaijan Manat. */ Iso4217Alpha3CurrencyCode["AZN"] = "AZN";
    /** The code for Dinar. */ Iso4217Alpha3CurrencyCode["BAD"] = "BAD";
    /** The code for Convertible Mark. */ Iso4217Alpha3CurrencyCode["BAM"] = "BAM";
    /** The code for Barbados Dollar. */ Iso4217Alpha3CurrencyCode["BBD"] = "BBD";
    /** The code for Taka. */ Iso4217Alpha3CurrencyCode["BDT"] = "BDT";
    /** The code for Convertible Franc. */ Iso4217Alpha3CurrencyCode["BEC"] = "BEC";
    /** The code for Belgian Franc. */ Iso4217Alpha3CurrencyCode["BEF"] = "BEF";
    /** The code for Financial Franc. */ Iso4217Alpha3CurrencyCode["BEL"] = "BEL";
    /** The code for Lev A/52. */ Iso4217Alpha3CurrencyCode["BGJ"] = "BGJ";
    /** The code for Lev A/62. */ Iso4217Alpha3CurrencyCode["BGK"] = "BGK";
    /** The code for Lev. */ Iso4217Alpha3CurrencyCode["BGL"] = "BGL";
    /** The code for Bulgarian Lev. */ Iso4217Alpha3CurrencyCode["BGN"] = "BGN";
    /** The code for Bahraini Dinar. */ Iso4217Alpha3CurrencyCode["BHD"] = "BHD";
    /** The code for Burundi Franc. */ Iso4217Alpha3CurrencyCode["BIF"] = "BIF";
    /** The code for Bermudian Dollar. */ Iso4217Alpha3CurrencyCode["BMD"] = "BMD";
    /** The code for Brunei Dollar. */ Iso4217Alpha3CurrencyCode["BND"] = "BND";
    /** The code for Boliviano. */ Iso4217Alpha3CurrencyCode["BOB"] = "BOB";
    /** The code for Peso boliviano. */ Iso4217Alpha3CurrencyCode["BOP"] = "BOP";
    /** The code for Mvdol. */ Iso4217Alpha3CurrencyCode["BOV"] = "BOV";
    /** The code for Cruzeiro. */ Iso4217Alpha3CurrencyCode["BRB"] = "BRB";
    /** The code for Cruzado. */ Iso4217Alpha3CurrencyCode["BRC"] = "BRC";
    /** The code for Cruzeiro. */ Iso4217Alpha3CurrencyCode["BRE"] = "BRE";
    /** The code for Brazilian Real. */ Iso4217Alpha3CurrencyCode["BRL"] = "BRL";
    /** The code for New Cruzado. */ Iso4217Alpha3CurrencyCode["BRN"] = "BRN";
    /** The code for Cruzeiro Real. */ Iso4217Alpha3CurrencyCode["BRR"] = "BRR";
    /** The code for Bahamian Dollar. */ Iso4217Alpha3CurrencyCode["BSD"] = "BSD";
    /** The code for Ngultrum. */ Iso4217Alpha3CurrencyCode["BTN"] = "BTN";
    /** The code for Kyat. */ Iso4217Alpha3CurrencyCode["BUK"] = "BUK";
    /** The code for Pula. */ Iso4217Alpha3CurrencyCode["BWP"] = "BWP";
    /** The code for Belarusian Ruble. */ Iso4217Alpha3CurrencyCode["BYB"] = "BYB";
    /** The code for Belarusian Ruble. */ Iso4217Alpha3CurrencyCode["BYN"] = "BYN";
    /** The code for Belarusian Ruble. */ Iso4217Alpha3CurrencyCode["BYR"] = "BYR";
    /** The code for Belize Dollar. */ Iso4217Alpha3CurrencyCode["BZD"] = "BZD";
    /** The code for Canadian Dollar. */ Iso4217Alpha3CurrencyCode["CAD"] = "CAD";
    /** The code for Congolese Franc. */ Iso4217Alpha3CurrencyCode["CDF"] = "CDF";
    /** The code for WIR Franc (for electronic). */ Iso4217Alpha3CurrencyCode["CHC"] = "CHC";
    /** The code for WIR Euro. */ Iso4217Alpha3CurrencyCode["CHE"] = "CHE";
    /** The code for Swiss Franc. */ Iso4217Alpha3CurrencyCode["CHF"] = "CHF";
    /** The code for WIR Franc. */ Iso4217Alpha3CurrencyCode["CHW"] = "CHW";
    /** The code for Unidad de Fomento. */ Iso4217Alpha3CurrencyCode["CLF"] = "CLF";
    /** The code for Chilean Peso. */ Iso4217Alpha3CurrencyCode["CLP"] = "CLP";
    /** The code for Yuan Renminbi. */ Iso4217Alpha3CurrencyCode["CNY"] = "CNY";
    /** The code for Colombian Peso. */ Iso4217Alpha3CurrencyCode["COP"] = "COP";
    /** The code for Unidad de Valor Real. */ Iso4217Alpha3CurrencyCode["COU"] = "COU";
    /** The code for Costa Rican Colon. */ Iso4217Alpha3CurrencyCode["CRC"] = "CRC";
    /** The code for Serbian Dinar. */ Iso4217Alpha3CurrencyCode["CSD"] = "CSD";
    /** The code for Krona A/53. */ Iso4217Alpha3CurrencyCode["CSJ"] = "CSJ";
    /** The code for Koruna. */ Iso4217Alpha3CurrencyCode["CSK"] = "CSK";
    /** The code for Peso Convertible. */ Iso4217Alpha3CurrencyCode["CUC"] = "CUC";
    /** The code for Cuban Peso. */ Iso4217Alpha3CurrencyCode["CUP"] = "CUP";
    /** The code for Cabo Verde Escudo. */ Iso4217Alpha3CurrencyCode["CVE"] = "CVE";
    /** The code for Cyprus Pound. */ Iso4217Alpha3CurrencyCode["CYP"] = "CYP";
    /** The code for Czech Koruna. */ Iso4217Alpha3CurrencyCode["CZK"] = "CZK";
    /** The code for Mark der DDR. */ Iso4217Alpha3CurrencyCode["DDM"] = "DDM";
    /** The code for Deutsche Mark. */ Iso4217Alpha3CurrencyCode["DEM"] = "DEM";
    /** The code for Djibouti Franc. */ Iso4217Alpha3CurrencyCode["DJF"] = "DJF";
    /** The code for Danish Krone. */ Iso4217Alpha3CurrencyCode["DKK"] = "DKK";
    /** The code for Dominican Peso. */ Iso4217Alpha3CurrencyCode["DOP"] = "DOP";
    /** The code for Algerian Dinar. */ Iso4217Alpha3CurrencyCode["DZD"] = "DZD";
    /** The code for Sucre. */ Iso4217Alpha3CurrencyCode["ECS"] = "ECS";
    /** The code for Unidad de Valor Constante (UVC). */ Iso4217Alpha3CurrencyCode["ECV"] = "ECV";
    /** The code for Kroon. */ Iso4217Alpha3CurrencyCode["EEK"] = "EEK";
    /** The code for Egyptian Pound. */ Iso4217Alpha3CurrencyCode["EGP"] = "EGP";
    /** The code for Nakfa. */ Iso4217Alpha3CurrencyCode["ERN"] = "ERN";
    /** The code for Spanish Peseta. */ Iso4217Alpha3CurrencyCode["ESA"] = "ESA";
    /** The code for Account (convertible Peseta Account). */ Iso4217Alpha3CurrencyCode["ESB"] = "ESB";
    /** The code for Spanish Peseta. */ Iso4217Alpha3CurrencyCode["ESP"] = "ESP";
    /** The code for Ethiopian Birr. */ Iso4217Alpha3CurrencyCode["ETB"] = "ETB";
    /** The code for Euro. */ Iso4217Alpha3CurrencyCode["EUR"] = "EUR";
    /** The code for Markka. */ Iso4217Alpha3CurrencyCode["FIM"] = "FIM";
    /** The code for Fiji Dollar. */ Iso4217Alpha3CurrencyCode["FJD"] = "FJD";
    /** The code for Falkland Islands Pound. */ Iso4217Alpha3CurrencyCode["FKP"] = "FKP";
    /** The code for French Franc. */ Iso4217Alpha3CurrencyCode["FRF"] = "FRF";
    /** The code for Pound Sterling. */ Iso4217Alpha3CurrencyCode["GBP"] = "GBP";
    /** The code for Georgian Coupon. */ Iso4217Alpha3CurrencyCode["GEK"] = "GEK";
    /** The code for Lari. */ Iso4217Alpha3CurrencyCode["GEL"] = "GEL";
    /** The code for Cedi. */ Iso4217Alpha3CurrencyCode["GHC"] = "GHC";
    /** The code for Ghana Cedi. */ Iso4217Alpha3CurrencyCode["GHP"] = "GHP";
    /** The code for Ghana Cedi. */ Iso4217Alpha3CurrencyCode["GHS"] = "GHS";
    /** The code for Gibraltar Pound. */ Iso4217Alpha3CurrencyCode["GIP"] = "GIP";
    /** The code for Dalasi. */ Iso4217Alpha3CurrencyCode["GMD"] = "GMD";
    /** The code for Syli. */ Iso4217Alpha3CurrencyCode["GNE"] = "GNE";
    /** The code for Guinean Franc. */ Iso4217Alpha3CurrencyCode["GNF"] = "GNF";
    /** The code for Syli. */ Iso4217Alpha3CurrencyCode["GNS"] = "GNS";
    /** The code for Ekwele. */ Iso4217Alpha3CurrencyCode["GQE"] = "GQE";
    /** The code for Drachma. */ Iso4217Alpha3CurrencyCode["GRD"] = "GRD";
    /** The code for Quetzal. */ Iso4217Alpha3CurrencyCode["GTQ"] = "GTQ";
    /** The code for Guinea Escudo. */ Iso4217Alpha3CurrencyCode["GWE"] = "GWE";
    /** The code for Guinea-Bissau Peso. */ Iso4217Alpha3CurrencyCode["GWP"] = "GWP";
    /** The code for Guyana Dollar. */ Iso4217Alpha3CurrencyCode["GYD"] = "GYD";
    /** The code for Hong Kong Dollar. */ Iso4217Alpha3CurrencyCode["HKD"] = "HKD";
    /** The code for Lempira. */ Iso4217Alpha3CurrencyCode["HNL"] = "HNL";
    /** The code for Croatian Dinar. */ Iso4217Alpha3CurrencyCode["HRD"] = "HRD";
    /** The code for Croatian Kuna. */ Iso4217Alpha3CurrencyCode["HRK"] = "HRK";
    /** The code for Gourde. */ Iso4217Alpha3CurrencyCode["HTG"] = "HTG";
    /** The code for Forint. */ Iso4217Alpha3CurrencyCode["HUF"] = "HUF";
    /** The code for Rupiah. */ Iso4217Alpha3CurrencyCode["IDR"] = "IDR";
    /** The code for Irish Pound. */ Iso4217Alpha3CurrencyCode["IEP"] = "IEP";
    /** The code for Pound. */ Iso4217Alpha3CurrencyCode["ILP"] = "ILP";
    /** The code for Old Shekel. */ Iso4217Alpha3CurrencyCode["ILR"] = "ILR";
    /** The code for New Israeli Sheqel. */ Iso4217Alpha3CurrencyCode["ILS"] = "ILS";
    /** The code for Indian Rupee. */ Iso4217Alpha3CurrencyCode["INR"] = "INR";
    /** The code for Iraqi Dinar. */ Iso4217Alpha3CurrencyCode["IQD"] = "IQD";
    /** The code for Iranian Rial. */ Iso4217Alpha3CurrencyCode["IRR"] = "IRR";
    /** The code for Old Krona. */ Iso4217Alpha3CurrencyCode["ISJ"] = "ISJ";
    /** The code for Iceland Krona. */ Iso4217Alpha3CurrencyCode["ISK"] = "ISK";
    /** The code for Italian Lira. */ Iso4217Alpha3CurrencyCode["ITL"] = "ITL";
    /** The code for Jamaican Dollar. */ Iso4217Alpha3CurrencyCode["JMD"] = "JMD";
    /** The code for Jordanian Dinar. */ Iso4217Alpha3CurrencyCode["JOD"] = "JOD";
    /** The code for Yen. */ Iso4217Alpha3CurrencyCode["JPY"] = "JPY";
    /** The code for Kenyan Shilling. */ Iso4217Alpha3CurrencyCode["KES"] = "KES";
    /** The code for Som. */ Iso4217Alpha3CurrencyCode["KGS"] = "KGS";
    /** The code for Riel. */ Iso4217Alpha3CurrencyCode["KHR"] = "KHR";
    /** The code for Comorian Franc . */ Iso4217Alpha3CurrencyCode["KMF"] = "KMF";
    /** The code for North Korean Won. */ Iso4217Alpha3CurrencyCode["KPW"] = "KPW";
    /** The code for Won. */ Iso4217Alpha3CurrencyCode["KRW"] = "KRW";
    /** The code for Kuwaiti Dinar. */ Iso4217Alpha3CurrencyCode["KWD"] = "KWD";
    /** The code for Cayman Islands Dollar. */ Iso4217Alpha3CurrencyCode["KYD"] = "KYD";
    /** The code for Tenge. */ Iso4217Alpha3CurrencyCode["KZT"] = "KZT";
    /** The code for Pathet Lao Kip. */ Iso4217Alpha3CurrencyCode["LAJ"] = "LAJ";
    /** The code for Lao Kip. */ Iso4217Alpha3CurrencyCode["LAK"] = "LAK";
    /** The code for Lebanese Pound. */ Iso4217Alpha3CurrencyCode["LBP"] = "LBP";
    /** The code for Sri Lanka Rupee. */ Iso4217Alpha3CurrencyCode["LKR"] = "LKR";
    /** The code for Liberian Dollar. */ Iso4217Alpha3CurrencyCode["LRD"] = "LRD";
    /** The code for Loti. */ Iso4217Alpha3CurrencyCode["LSL"] = "LSL";
    /** The code for Loti. */ Iso4217Alpha3CurrencyCode["LSM"] = "LSM";
    /** The code for Lithuanian Litas. */ Iso4217Alpha3CurrencyCode["LTL"] = "LTL";
    /** The code for Talonas. */ Iso4217Alpha3CurrencyCode["LTT"] = "LTT";
    /** The code for Luxembourg Convertible Franc. */ Iso4217Alpha3CurrencyCode["LUC"] = "LUC";
    /** The code for Luxembourg Franc. */ Iso4217Alpha3CurrencyCode["LUF"] = "LUF";
    /** The code for Luxembourg Financial Franc. */ Iso4217Alpha3CurrencyCode["LUL"] = "LUL";
    /** The code for Latvian Lats. */ Iso4217Alpha3CurrencyCode["LVL"] = "LVL";
    /** The code for Latvian Ruble. */ Iso4217Alpha3CurrencyCode["LVR"] = "LVR";
    /** The code for Libyan Dinar. */ Iso4217Alpha3CurrencyCode["LYD"] = "LYD";
    /** The code for Moroccan Dirham. */ Iso4217Alpha3CurrencyCode["MAD"] = "MAD";
    /** The code for Moldovan Leu. */ Iso4217Alpha3CurrencyCode["MDL"] = "MDL";
    /** The code for Malagasy Ariary. */ Iso4217Alpha3CurrencyCode["MGA"] = "MGA";
    /** The code for Malagasy Franc. */ Iso4217Alpha3CurrencyCode["MGF"] = "MGF";
    /** The code for Denar. */ Iso4217Alpha3CurrencyCode["MKD"] = "MKD";
    /** The code for Mali Franc. */ Iso4217Alpha3CurrencyCode["MLF"] = "MLF";
    /** The code for Kyat. */ Iso4217Alpha3CurrencyCode["MMK"] = "MMK";
    /** The code for Tugrik. */ Iso4217Alpha3CurrencyCode["MNT"] = "MNT";
    /** The code for Pataca. */ Iso4217Alpha3CurrencyCode["MOP"] = "MOP";
    /** The code for Ouguiya. */ Iso4217Alpha3CurrencyCode["MRO"] = "MRO";
    /** The code for Ouguiya. */ Iso4217Alpha3CurrencyCode["MRU"] = "MRU";
    /** The code for Maltese Lira. */ Iso4217Alpha3CurrencyCode["MTL"] = "MTL";
    /** The code for Maltese Pound. */ Iso4217Alpha3CurrencyCode["MTP"] = "MTP";
    /** The code for Mauritius Rupee. */ Iso4217Alpha3CurrencyCode["MUR"] = "MUR";
    /** The code for Maldive Rupee. */ Iso4217Alpha3CurrencyCode["MVQ"] = "MVQ";
    /** The code for Rufiyaa. */ Iso4217Alpha3CurrencyCode["MVR"] = "MVR";
    /** The code for Kwacha. */ Iso4217Alpha3CurrencyCode["MWK"] = "MWK";
    /** The code for Mexican Peso. */ Iso4217Alpha3CurrencyCode["MXN"] = "MXN";
    /** The code for Mexican Peso. */ Iso4217Alpha3CurrencyCode["MXP"] = "MXP";
    /** The code for Mexican Unidad de Inversion (UDI). */ Iso4217Alpha3CurrencyCode["MXV"] = "MXV";
    /** The code for Malaysian Ringgit. */ Iso4217Alpha3CurrencyCode["MYR"] = "MYR";
    /** The code for Mozambique Escudo. */ Iso4217Alpha3CurrencyCode["MZE"] = "MZE";
    /** The code for Mozambique Metical. */ Iso4217Alpha3CurrencyCode["MZM"] = "MZM";
    /** The code for Mozambique Metical. */ Iso4217Alpha3CurrencyCode["MZN"] = "MZN";
    /** The code for Namibia Dollar. */ Iso4217Alpha3CurrencyCode["NAD"] = "NAD";
    /** The code for Naira. */ Iso4217Alpha3CurrencyCode["NGN"] = "NGN";
    /** The code for Cordoba. */ Iso4217Alpha3CurrencyCode["NIC"] = "NIC";
    /** The code for Cordoba Oro. */ Iso4217Alpha3CurrencyCode["NIO"] = "NIO";
    /** The code for Netherlands Guilder. */ Iso4217Alpha3CurrencyCode["NLG"] = "NLG";
    /** The code for Norwegian Krone. */ Iso4217Alpha3CurrencyCode["NOK"] = "NOK";
    /** The code for Nepalese Rupee. */ Iso4217Alpha3CurrencyCode["NPR"] = "NPR";
    /** The code for New Zealand Dollar. */ Iso4217Alpha3CurrencyCode["NZD"] = "NZD";
    /** The code for Rial Omani. */ Iso4217Alpha3CurrencyCode["OMR"] = "OMR";
    /** The code for Balboa. */ Iso4217Alpha3CurrencyCode["PAB"] = "PAB";
    /** The code for Sol. */ Iso4217Alpha3CurrencyCode["PEH"] = "PEH";
    /** The code for Inti. */ Iso4217Alpha3CurrencyCode["PEI"] = "PEI";
    /** The code for Sol. */ Iso4217Alpha3CurrencyCode["PEN"] = "PEN";
    /** The code for Sol. */ Iso4217Alpha3CurrencyCode["PES"] = "PES";
    /** The code for Kina. */ Iso4217Alpha3CurrencyCode["PGK"] = "PGK";
    /** The code for Philippine Peso. */ Iso4217Alpha3CurrencyCode["PHP"] = "PHP";
    /** The code for Pakistan Rupee. */ Iso4217Alpha3CurrencyCode["PKR"] = "PKR";
    /** The code for Zloty. */ Iso4217Alpha3CurrencyCode["PLN"] = "PLN";
    /** The code for Zloty. */ Iso4217Alpha3CurrencyCode["PLZ"] = "PLZ";
    /** The code for Portuguese Escudo. */ Iso4217Alpha3CurrencyCode["PTE"] = "PTE";
    /** The code for Guarani. */ Iso4217Alpha3CurrencyCode["PYG"] = "PYG";
    /** The code for Qatari Rial. */ Iso4217Alpha3CurrencyCode["QAR"] = "QAR";
    /** The code for Rhodesian Dollar. */ Iso4217Alpha3CurrencyCode["RHD"] = "RHD";
    /** The code for Leu A/52. */ Iso4217Alpha3CurrencyCode["ROK"] = "ROK";
    /** The code for Old Leu. */ Iso4217Alpha3CurrencyCode["ROL"] = "ROL";
    /** The code for Romanian Leu. */ Iso4217Alpha3CurrencyCode["RON"] = "RON";
    /** The code for Serbian Dinar. */ Iso4217Alpha3CurrencyCode["RSD"] = "RSD";
    /** The code for Russian Ruble. */ Iso4217Alpha3CurrencyCode["RUB"] = "RUB";
    /** The code for Russian Ruble. */ Iso4217Alpha3CurrencyCode["RUR"] = "RUR";
    /** The code for Rwanda Franc. */ Iso4217Alpha3CurrencyCode["RWF"] = "RWF";
    /** The code for Saudi Riyal. */ Iso4217Alpha3CurrencyCode["SAR"] = "SAR";
    /** The code for Solomon Islands Dollar. */ Iso4217Alpha3CurrencyCode["SBD"] = "SBD";
    /** The code for Seychelles Rupee. */ Iso4217Alpha3CurrencyCode["SCR"] = "SCR";
    /** The code for Sudanese Dinar. */ Iso4217Alpha3CurrencyCode["SDD"] = "SDD";
    /** The code for Sudanese Pound. */ Iso4217Alpha3CurrencyCode["SDG"] = "SDG";
    /** The code for Sudanese Pound. */ Iso4217Alpha3CurrencyCode["SDP"] = "SDP";
    /** The code for Swedish Krona. */ Iso4217Alpha3CurrencyCode["SEK"] = "SEK";
    /** The code for Singapore Dollar. */ Iso4217Alpha3CurrencyCode["SGD"] = "SGD";
    /** The code for Saint Helena Pound. */ Iso4217Alpha3CurrencyCode["SHP"] = "SHP";
    /** The code for Tolar. */ Iso4217Alpha3CurrencyCode["SIT"] = "SIT";
    /** The code for Slovak Koruna. */ Iso4217Alpha3CurrencyCode["SKK"] = "SKK";
    /** The code for Leone. */ Iso4217Alpha3CurrencyCode["SLL"] = "SLL";
    /** The code for Somali Shilling. */ Iso4217Alpha3CurrencyCode["SOS"] = "SOS";
    /** The code for Surinam Dollar. */ Iso4217Alpha3CurrencyCode["SRD"] = "SRD";
    /** The code for Surinam Guilder. */ Iso4217Alpha3CurrencyCode["SRG"] = "SRG";
    /** The code for South Sudanese Pound. */ Iso4217Alpha3CurrencyCode["SSP"] = "SSP";
    /** The code for Dobra. */ Iso4217Alpha3CurrencyCode["STD"] = "STD";
    /** The code for Dobra. */ Iso4217Alpha3CurrencyCode["STN"] = "STN";
    /** The code for Rouble. */ Iso4217Alpha3CurrencyCode["SUR"] = "SUR";
    /** The code for El Salvador Colon. */ Iso4217Alpha3CurrencyCode["SVC"] = "SVC";
    /** The code for Syrian Pound. */ Iso4217Alpha3CurrencyCode["SYP"] = "SYP";
    /** The code for Lilangeni. */ Iso4217Alpha3CurrencyCode["SZL"] = "SZL";
    /** The code for Baht. */ Iso4217Alpha3CurrencyCode["THB"] = "THB";
    /** The code for Tajik Ruble. */ Iso4217Alpha3CurrencyCode["TJR"] = "TJR";
    /** The code for Somoni. */ Iso4217Alpha3CurrencyCode["TJS"] = "TJS";
    /** The code for Turkmenistan Manat. */ Iso4217Alpha3CurrencyCode["TMM"] = "TMM";
    /** The code for Turkmenistan New Manat. */ Iso4217Alpha3CurrencyCode["TMT"] = "TMT";
    /** The code for Tunisian Dinar. */ Iso4217Alpha3CurrencyCode["TND"] = "TND";
    /** The code for Pa'anga. */ Iso4217Alpha3CurrencyCode["TOP"] = "TOP";
    /** The code for Timor Escudo. */ Iso4217Alpha3CurrencyCode["TPE"] = "TPE";
    /** The code for Old Turkish Lira. */ Iso4217Alpha3CurrencyCode["TRL"] = "TRL";
    /** The code for Turkish Lira. */ Iso4217Alpha3CurrencyCode["TRY"] = "TRY";
    /** The code for Trinidad and Tobago Dollar. */ Iso4217Alpha3CurrencyCode["TTD"] = "TTD";
    /** The code for New Taiwan Dollar. */ Iso4217Alpha3CurrencyCode["TWD"] = "TWD";
    /** The code for Tanzanian Shilling. */ Iso4217Alpha3CurrencyCode["TZS"] = "TZS";
    /** The code for Hryvnia. */ Iso4217Alpha3CurrencyCode["UAH"] = "UAH";
    /** The code for Karbovanet. */ Iso4217Alpha3CurrencyCode["UAK"] = "UAK";
    /** The code for Uganda Shilling. */ Iso4217Alpha3CurrencyCode["UGS"] = "UGS";
    /** The code for Old Shilling. */ Iso4217Alpha3CurrencyCode["UGW"] = "UGW";
    /** The code for Uganda Shilling. */ Iso4217Alpha3CurrencyCode["UGX"] = "UGX";
    /** The code for US Dollar. */ Iso4217Alpha3CurrencyCode["USD"] = "USD";
    /** The code for US Dollar (Next day). */ Iso4217Alpha3CurrencyCode["USN"] = "USN";
    /** The code for US Dollar (Same day). */ Iso4217Alpha3CurrencyCode["USS"] = "USS";
    /** The code for Uruguay Peso en Unidades Indexadas (UI). */ Iso4217Alpha3CurrencyCode["UYI"] = "UYI";
    /** The code for Old Uruguay Peso. */ Iso4217Alpha3CurrencyCode["UYN"] = "UYN";
    /** The code for Uruguayan Peso. */ Iso4217Alpha3CurrencyCode["UYP"] = "UYP";
    /** The code for Peso Uruguayo. */ Iso4217Alpha3CurrencyCode["UYU"] = "UYU";
    /** The code for Unidad Previsional. */ Iso4217Alpha3CurrencyCode["UYW"] = "UYW";
    /** The code for Uzbekistan Sum. */ Iso4217Alpha3CurrencyCode["UZS"] = "UZS";
    /** The code for Bolivar. */ Iso4217Alpha3CurrencyCode["VEB"] = "VEB";
    /** The code for Bolivar. */ Iso4217Alpha3CurrencyCode["VEF"] = "VEF";
    /** The code for Bolívar Soberano. */ Iso4217Alpha3CurrencyCode["VES"] = "VES";
    /** The code for Old Dong. */ Iso4217Alpha3CurrencyCode["VNC"] = "VNC";
    /** The code for Dong. */ Iso4217Alpha3CurrencyCode["VND"] = "VND";
    /** The code for Vatu. */ Iso4217Alpha3CurrencyCode["VUV"] = "VUV";
    /** The code for Tala. */ Iso4217Alpha3CurrencyCode["WST"] = "WST";
    /** The code for CFA Franc BEAC. */ Iso4217Alpha3CurrencyCode["XAF"] = "XAF";
    /** The code for Silver. */ Iso4217Alpha3CurrencyCode["XAG"] = "XAG";
    /** The code for Gold. */ Iso4217Alpha3CurrencyCode["XAU"] = "XAU";
    /** The code for Bond Markets Unit European Composite Unit (EURCO). */ Iso4217Alpha3CurrencyCode["XBA"] = "XBA";
    /** The code for Bond Markets Unit European Monetary Unit (E.M.U.-6). */ Iso4217Alpha3CurrencyCode["XBB"] = "XBB";
    /** The code for Bond Markets Unit European Unit of Account 9 (E.U.A.-9). */ Iso4217Alpha3CurrencyCode["XBC"] = "XBC";
    /** The code for Bond Markets Unit European Unit of Account 17 (E.U.A.-17). */ Iso4217Alpha3CurrencyCode["XBD"] = "XBD";
    /** The code for East Caribbean Dollar. */ Iso4217Alpha3CurrencyCode["XCD"] = "XCD";
    /** The code for SDR (Special Drawing Right). */ Iso4217Alpha3CurrencyCode["XDR"] = "XDR";
    /** The code for European Currency Unit (E.C.U). */ Iso4217Alpha3CurrencyCode["XEU"] = "XEU";
    /** The code for Gold-Franc. */ Iso4217Alpha3CurrencyCode["XFO"] = "XFO";
    /** The code for UIC-Franc. */ Iso4217Alpha3CurrencyCode["XFU"] = "XFU";
    /** The code for CFA Franc BCEAO. */ Iso4217Alpha3CurrencyCode["XOF"] = "XOF";
    /** The code for Palladium. */ Iso4217Alpha3CurrencyCode["XPD"] = "XPD";
    /** The code for CFP Franc. */ Iso4217Alpha3CurrencyCode["XPF"] = "XPF";
    /** The code for Platinum. */ Iso4217Alpha3CurrencyCode["XPT"] = "XPT";
    /** The code for RINET Funds Code. */ Iso4217Alpha3CurrencyCode["XRE"] = "XRE";
    /** The code for Sucre. */ Iso4217Alpha3CurrencyCode["XSU"] = "XSU";
    /** The code for Codes specifically reserved for testing purposes. */ Iso4217Alpha3CurrencyCode["XTS"] = "XTS";
    /** The code for ADB Unit of Account. */ Iso4217Alpha3CurrencyCode["XUA"] = "XUA";
    /** The code for The codes assigned for transactions where no currency is involved. */ Iso4217Alpha3CurrencyCode["XXX"] = "XXX";
    /** The code for Yemeni Dinar. */ Iso4217Alpha3CurrencyCode["YDD"] = "YDD";
    /** The code for Yemeni Rial. */ Iso4217Alpha3CurrencyCode["YER"] = "YER";
    /** The code for New Yugoslavian Dinar. */ Iso4217Alpha3CurrencyCode["YUD"] = "YUD";
    /** The code for New Dinar. */ Iso4217Alpha3CurrencyCode["YUM"] = "YUM";
    /** The code for Yugoslavian Dinar. */ Iso4217Alpha3CurrencyCode["YUN"] = "YUN";
    /** The code for Financial Rand. */ Iso4217Alpha3CurrencyCode["ZAL"] = "ZAL";
    /** The code for Rand. */ Iso4217Alpha3CurrencyCode["ZAR"] = "ZAR";
    /** The code for Zambian Kwacha. */ Iso4217Alpha3CurrencyCode["ZMK"] = "ZMK";
    /** The code for Zambian Kwacha. */ Iso4217Alpha3CurrencyCode["ZMW"] = "ZMW";
    /** The code for New Zaire. */ Iso4217Alpha3CurrencyCode["ZRN"] = "ZRN";
    /** The code for Zaire. */ Iso4217Alpha3CurrencyCode["ZRZ"] = "ZRZ";
    /** The code for Rhodesian Dollar. */ Iso4217Alpha3CurrencyCode["ZWC"] = "ZWC";
    /** The code for Zimbabwe Dollar. */ Iso4217Alpha3CurrencyCode["ZWD"] = "ZWD";
    /** The code for Zimbabwe Dollar. */ Iso4217Alpha3CurrencyCode["ZWL"] = "ZWL";
    /** The code for Zimbabwe Dollar (new). */ Iso4217Alpha3CurrencyCode["ZWN"] = "ZWN";
    /** The code for Zimbabwe Dollar. */ Iso4217Alpha3CurrencyCode["ZWR"] = "ZWR";
    return Iso4217Alpha3CurrencyCode;
}({});
var $2f53fee15f29b056$export$97b0b8e1c0fb6d7a = /*#__PURE__*/ function(Iso4217Alpha3SupportedCurrency) {
    /** The code for US Dollar. */ Iso4217Alpha3SupportedCurrency["USD"] = "USD";
    return Iso4217Alpha3SupportedCurrency;
}({});
var $2f53fee15f29b056$export$27c204c67dc712c4 = /*#__PURE__*/ function(IdentityRiskLevel) {
    /** A high risk assessment. Seeing this means fraud is likely. */ IdentityRiskLevel["HIGH"] = "HIGH";
    /** A low risk assessment. Seeing this means fraud is not likely. */ IdentityRiskLevel["LOW"] = "LOW";
    /** A medium risk assessment. Seeing this means fraud is somewhat likely. */ IdentityRiskLevel["MEDIUM"] = "MEDIUM";
    /** A medium low risk assessment. Seeing this means fraud is somewhat not likely. */ IdentityRiskLevel["MEDIUM_LOW"] = "MEDIUM_LOW";
    /** A very high risk assessment. Seeing this means fraud is very likely. */ IdentityRiskLevel["VERY_HIGH"] = "VERY_HIGH";
    return IdentityRiskLevel;
}({});
var $2f53fee15f29b056$export$db752bcde43d2808 = /*#__PURE__*/ function(IdentityTaskGroupReviewCategory) {
    IdentityTaskGroupReviewCategory["ENHANCED_DUE_DILIGENCE"] = "ENHANCED_DUE_DILIGENCE";
    return IdentityTaskGroupReviewCategory;
}({});
var $2f53fee15f29b056$export$cfb4c3fb157cc198 = /*#__PURE__*/ function(IdentityVerificationDocumentRequestReason) {
    /** The documents are being requested for an update initiated by the account holder. */ IdentityVerificationDocumentRequestReason["ACCOUNT_HOLDER_UPDATE"] = "ACCOUNT_HOLDER_UPDATE";
    /** The documents are being requested for CIP verification. */ IdentityVerificationDocumentRequestReason["CIP_VERIFICATION"] = "CIP_VERIFICATION";
    return IdentityVerificationDocumentRequestReason;
}({});
var $2f53fee15f29b056$export$28ad5073225e0ead = /*#__PURE__*/ function(InitiateSecureDepositClientTokenPermission) {
    /** Setting this permission will enable management of the lifecycle of a secure deposit. */ InitiateSecureDepositClientTokenPermission["INITIATE_SECURE_DEPOSIT"] = "INITIATE_SECURE_DEPOSIT";
    return InitiateSecureDepositClientTokenPermission;
}({});
var $2f53fee15f29b056$export$56bfdffac79216f2 = /*#__PURE__*/ function(InstallmentAgreementStatus) {
    InstallmentAgreementStatus["CHARGED_OFF"] = "CHARGED_OFF";
    InstallmentAgreementStatus["OPEN"] = "OPEN";
    InstallmentAgreementStatus["PAID_OFF"] = "PAID_OFF";
    InstallmentAgreementStatus["REVERSED"] = "REVERSED";
    return InstallmentAgreementStatus;
}({});
var $2f53fee15f29b056$export$f8597f9b6ed2a049 = /*#__PURE__*/ function(InstallmentFrequency) {
    /** Monthly. */ InstallmentFrequency["MONTHLY"] = "MONTHLY";
    return InstallmentFrequency;
}({});
var $2f53fee15f29b056$export$d80dae9dc2cc6d3b = /*#__PURE__*/ function(InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus) {
    /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability disabled. */ InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus["DISABLED"] = "DISABLED";
    /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability enabled. */ InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus["ENABLED"] = "ENABLED";
    /** The `PaymentInstrument` is undergoing a review to determine the status. */ InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus["REQUIRES_REVIEW"] = "REQUIRES_REVIEW";
    return InstantNetworkTransferDestinationPaymentInstrumentCapabilityStatus;
}({});
var $2f53fee15f29b056$export$1a6febf484c94bb7 = /*#__PURE__*/ function(InstantNetworkTransferEventType) {
    /** The `InstantNetworkTransfer`'s event to authorize the pulling of funds. */ InstantNetworkTransferEventType["AUTHORIZE_PULL_PAYMENT_FUND"] = "AUTHORIZE_PULL_PAYMENT_FUND";
    /** The `InstantNetworkTransfer`'s event to authorize the pushing of funds. */ InstantNetworkTransferEventType["AUTHORIZE_PUSH_PAYMENT_FUND"] = "AUTHORIZE_PUSH_PAYMENT_FUND";
    /** The `InstantNetworkTransfer`'s event to clear the pulling of funds. */ InstantNetworkTransferEventType["CLEAR_PULL_PAYMENT_FUND"] = "CLEAR_PULL_PAYMENT_FUND";
    /** The `InstantNetworkTransfer`'s event to clear the pushing of funds. */ InstantNetworkTransferEventType["CLEAR_PUSH_PAYMENT_FUND"] = "CLEAR_PUSH_PAYMENT_FUND";
    /** The `InstantNetworkTransfer`'s event for compliance review. */ InstantNetworkTransferEventType["COMPLIANCE_REVIEW"] = "COMPLIANCE_REVIEW";
    /** The `InstantNetworkTransfer`'s event for the request to initiate the transfer. */ InstantNetworkTransferEventType["INITIAL_REQUEST"] = "INITIAL_REQUEST";
    /** The `InstantNetworkTransfer`'s event to pull the funds. */ InstantNetworkTransferEventType["PULL_PAYMENT"] = "PULL_PAYMENT";
    /** The `InstantNetworkTransfer`'s event to push the funds. */ InstantNetworkTransferEventType["PUSH_PAYMENT"] = "PUSH_PAYMENT";
    /** The `InstantNetworkTransfer`'s event to reverse the pulling of funds. */ InstantNetworkTransferEventType["REVERSE_PULL_PAYMENT_FUND"] = "REVERSE_PULL_PAYMENT_FUND";
    /** The `InstantNetworkTransfer`'s event to reverse the pushing of funds. */ InstantNetworkTransferEventType["REVERSE_PUSH_PAYMENT_FUND"] = "REVERSE_PUSH_PAYMENT_FUND";
    return InstantNetworkTransferEventType;
}({});
var $2f53fee15f29b056$export$a6ceb91adfcef2d8 = /*#__PURE__*/ function(InstantNetworkTransferFailureReason) {
    /** The `InstantNetworkTransfer` failed because the source and destination accounts do not belong to the same product. */ InstantNetworkTransferFailureReason["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the account is closed. */ InstantNetworkTransferFailureReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The `InstantNetworkTransfer` failed because the account is not active. */ InstantNetworkTransferFailureReason["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The `InstantNetworkTransfer` failed because the account could not be found. */ InstantNetworkTransferFailureReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The `InstantNetworkTransfer` failed because the account was not provided. */ InstantNetworkTransferFailureReason["ACCOUNT_NOT_PROVIDED"] = "ACCOUNT_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because ACH loads are not allowed by the program. */ InstantNetworkTransferFailureReason["ACH_LOAD_NOT_ALLOWED_BY_PROGRAM"] = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM";
    /** The `InstantNetworkTransfer` failed because ANI verification failed. */ InstantNetworkTransferFailureReason["ANI_VERIFICATION_FAILED"] = "ANI_VERIFICATION_FAILED";
    /** The `InstantNetworkTransfer` failed because the CVC3/DCVV is invalid. */ InstantNetworkTransferFailureReason["BAD_CVC3_DCVV"] = "BAD_CVC3_DCVV";
    /** The `InstantNetworkTransfer` failed because the CVV is invalid. */ InstantNetworkTransferFailureReason["BAD_CVV"] = "BAD_CVV";
    /** The `InstantNetworkTransfer` failed because the CVV2 is invalid. */ InstantNetworkTransferFailureReason["BAD_CVV2"] = "BAD_CVV2";
    /** The `InstantNetworkTransfer` failed because the bank-managed beta account feature is not enabled. */ InstantNetworkTransferFailureReason["BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED"] = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the card is blocked. */ InstantNetworkTransferFailureReason["BLOCKED_CARD"] = "BLOCKED_CARD";
    /** The `InstantNetworkTransfer` failed because the card funding feature is not enabled. */ InstantNetworkTransferFailureReason["CARD_FUNDING_FEATURE_NOT_ENABLED"] = "CARD_FUNDING_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the cash back limit was exceeded. */ InstantNetworkTransferFailureReason["CASH_BACK_LIMIT_EXCEEDED"] = "CASH_BACK_LIMIT_EXCEEDED";
    /** The `InstantNetworkTransfer` failed because cash fund-out is not supported on this product. */ InstantNetworkTransferFailureReason["CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT"] = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the charge-off amount exceeds the account balance. */ InstantNetworkTransferFailureReason["CHARGE_OFF_EXCEEDS_BALANCE"] = "CHARGE_OFF_EXCEEDS_BALANCE";
    /** The `InstantNetworkTransfer` failed because the check-capable account feature is not enabled. */ InstantNetworkTransferFailureReason["CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED"] = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because check payments are not supported on this product. */ InstantNetworkTransferFailureReason["CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT"] = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because chip card ARQC validation failed. */ InstantNetworkTransferFailureReason["CHIP_CARD_ARQC_VALIDATION_FAILURE"] = "CHIP_CARD_ARQC_VALIDATION_FAILURE";
    /** The `InstantNetworkTransfer` failed because the commercial credit (pay-in-full) feature is not enabled. */ InstantNetworkTransferFailureReason["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because compliance verification failed. */ InstantNetworkTransferFailureReason["COMPLIANCE_VERIFICATION_FAILED"] = "COMPLIANCE_VERIFICATION_FAILED";
    /** The `InstantNetworkTransfer` failed because the corporate bank account feature is not enabled. */ InstantNetworkTransferFailureReason["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the credit card feature is not enabled. */ InstantNetworkTransferFailureReason["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because a credit limit has not been set on the account. */ InstantNetworkTransferFailureReason["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The `InstantNetworkTransfer` failed because the source and destination accounts use different currencies. */ InstantNetworkTransferFailureReason["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The `InstantNetworkTransfer` failed because the DDA feature is not enabled. */ InstantNetworkTransferFailureReason["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the debit card feature is not enabled. */ InstantNetworkTransferFailureReason["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the dispute chargeback feature is not enabled. */ InstantNetworkTransferFailureReason["DISPUTE_CHARGEBACK_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because provisional credit for chargebacks is not enabled. */ InstantNetworkTransferFailureReason["DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the transaction was declined. */ InstantNetworkTransferFailureReason["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    /** The `InstantNetworkTransfer` failed because the approval amount limit was exceeded. */ InstantNetworkTransferFailureReason["EXCEEDS_APPROVAL_AMOUNT_LIMIT"] = "EXCEEDS_APPROVAL_AMOUNT_LIMIT";
    /** The `InstantNetworkTransfer` failed because the withdrawal frequency limit was exceeded. */ InstantNetworkTransferFailureReason["EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT"] = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT";
    /** The `InstantNetworkTransfer` failed because the card has expired. */ InstantNetworkTransferFailureReason["EXPIRED_CARD"] = "EXPIRED_CARD";
    /** The `InstantNetworkTransfer` failed because external money movement is not supported on this product. */ InstantNetworkTransferFailureReason["EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT"] = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the fleet feature is not enabled. */ InstantNetworkTransferFailureReason["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the funding account feature is not enabled. */ InstantNetworkTransferFailureReason["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the funding card is not supported. */ InstantNetworkTransferFailureReason["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** The `InstantNetworkTransfer` failed because the Highnote account feature is not enabled. */ InstantNetworkTransferFailureReason["HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED"] = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the idempotency key was not provided. */ InstantNetworkTransferFailureReason["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because the source account has insufficient funds. */ InstantNetworkTransferFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The `InstantNetworkTransfer` failed because of an internal server error. */ InstantNetworkTransferFailureReason["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    /** The `InstantNetworkTransfer` failed because inter-financial account transfer rules were not satisfied. */ InstantNetworkTransferFailureReason["INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED";
    /** The `InstantNetworkTransfer` failed because the authorization has expired. */ InstantNetworkTransferFailureReason["INVALID_AUTHORIZATION_EXPIRATION"] = "INVALID_AUTHORIZATION_EXPIRATION";
    /** The `InstantNetworkTransfer` failed because the card number is invalid. */ InstantNetworkTransferFailureReason["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    /** The `InstantNetworkTransfer` failed because the disbursement amount is invalid. */ InstantNetworkTransferFailureReason["INVALID_DISBURSEMENT_AMOUNT"] = "INVALID_DISBURSEMENT_AMOUNT";
    /** The `InstantNetworkTransfer` failed because the merchant is invalid. */ InstantNetworkTransferFailureReason["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    /** The `InstantNetworkTransfer` failed because the track data is invalid. */ InstantNetworkTransferFailureReason["INVALID_TRACK_DATA"] = "INVALID_TRACK_DATA";
    /** The `InstantNetworkTransfer` failed because the transaction is invalid. */ InstantNetworkTransferFailureReason["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
    /** The `InstantNetworkTransfer` failed because the JIT (Just-In-Time) feature is not enabled. */ InstantNetworkTransferFailureReason["JIT_FEATURE_NOT_ENABLED"] = "JIT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the merchant funding feature is not enabled. */ InstantNetworkTransferFailureReason["MERCHANT_FUNDING_FEATURE_NOT_ENABLED"] = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the merchant settlement feature is not enabled. */ InstantNetworkTransferFailureReason["MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED"] = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the account is not organization-owned as required. */ InstantNetworkTransferFailureReason["NOT_AN_ORGANIZATION_OWNED_ACCOUNT"] = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT";
    /** The `InstantNetworkTransfer` failed because the balance is insufficient to reduce the credit limit. */ InstantNetworkTransferFailureReason["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** The `InstantNetworkTransfer` failed because the ODF feature is not enabled. */ InstantNetworkTransferFailureReason["ODF_FEATURE_NOT_ENABLED"] = "ODF_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the organization ID was not provided. */ InstantNetworkTransferFailureReason["ORGANIZATION_ID_NOT_PROVIDED"] = "ORGANIZATION_ID_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because originated ACH unloads are not supported on this product. */ InstantNetworkTransferFailureReason["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the partial funding feature is not enabled. */ InstantNetworkTransferFailureReason["PARTIAL_FUNDING_FEATURE_NOT_ENABLED"] = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the payroll advance feature is not enabled on the account. */ InstantNetworkTransferFailureReason["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the payroll employer advance feature is not enabled on the account. */ InstantNetworkTransferFailureReason["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the prepaid card feature is not enabled. */ InstantNetworkTransferFailureReason["PREPAID_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the pre-authorization has expired. */ InstantNetworkTransferFailureReason["PRE_AUTHORIZATION_EXPIRED"] = "PRE_AUTHORIZATION_EXPIRED";
    /** The `InstantNetworkTransfer` failed because the product funding feature is not enabled. */ InstantNetworkTransferFailureReason["PRODUCT_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the product-secured deposit account feature is not enabled. */ InstantNetworkTransferFailureReason["PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the pseudo balance feature is not enabled. */ InstantNetworkTransferFailureReason["PSEUDO_BALANCE_NOT_ENABLED"] = "PSEUDO_BALANCE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the pull payment did not succeed. */ InstantNetworkTransferFailureReason["PULL_PAYMENT_FAILED"] = "PULL_PAYMENT_FAILED";
    /** The `InstantNetworkTransfer` failed because the push payment did not succeed. */ InstantNetworkTransferFailureReason["PUSH_PAYMENT_FAILED"] = "PUSH_PAYMENT_FAILED";
    /** The `InstantNetworkTransfer` failed because the receivable purchase feature is not enabled. */ InstantNetworkTransferFailureReason["RECEIVABLE_PURCHASE_NOT_ENABLED"] = "RECEIVABLE_PURCHASE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the repayment account is not present on the product. */ InstantNetworkTransferFailureReason["REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT"] = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the location is restricted. */ InstantNetworkTransferFailureReason["RESTRICTED_LOCATION"] = "RESTRICTED_LOCATION";
    /** The `InstantNetworkTransfer` failed because the reward point feature is not enabled. */ InstantNetworkTransferFailureReason["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the transaction needs to be re-entered. */ InstantNetworkTransferFailureReason["RE_ENTER_TRANSACTION"] = "RE_ENTER_TRANSACTION";
    /** The `InstantNetworkTransfer` failed because it was declined due to risk. */ InstantNetworkTransferFailureReason["RISK_DECLINE"] = "RISK_DECLINE";
    /** The `InstantNetworkTransfer` failed because the secured deposit account feature is not enabled. */ InstantNetworkTransferFailureReason["SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because the secure card feature is not enabled. */ InstantNetworkTransferFailureReason["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** The `InstantNetworkTransfer` failed because of a special condition with no pickup. */ InstantNetworkTransferFailureReason["SPECIAL_CONDITION_NO_PICK_UP"] = "SPECIAL_CONDITION_NO_PICK_UP";
    /** The `InstantNetworkTransfer` failed because the card is suspended. */ InstantNetworkTransferFailureReason["SUSPENDED_CARD"] = "SUSPENDED_CARD";
    /** The `InstantNetworkTransfer` failed because the tenant ID was not provided. */ InstantNetworkTransferFailureReason["TENANT_ID_NOT_PROVIDED"] = "TENANT_ID_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because the card is terminated. */ InstantNetworkTransferFailureReason["TERMINATED_CARD"] = "TERMINATED_CARD";
    /** The `InstantNetworkTransfer` failed because the transaction ID was not provided. */ InstantNetworkTransferFailureReason["TRANSACTION_ID_NOT_PROVIDED"] = "TRANSACTION_ID_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because the transaction is not permitted. */ InstantNetworkTransferFailureReason["TRANSACTION_NOT_PERMITTED"] = "TRANSACTION_NOT_PERMITTED";
    /** The `InstantNetworkTransfer` failed because the transfer amount is below the program’s minimum reload limit. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT";
    /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the maximum allowed for credit distribution. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT";
    /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum card balance. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE";
    /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum load limit. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** The `InstantNetworkTransfer` failed because the transfer amount exceeds the program’s maximum reload limit. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT";
    /** The `InstantNetworkTransfer` failed because the transfer amount is negative or zero. */ InstantNetworkTransferFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** The `InstantNetworkTransfer` failed because transfers between different products are not allowed. */ InstantNetworkTransferFailureReason["TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED"] = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED";
    /** The `InstantNetworkTransfer` failed because the accounts do not have the same primary account holder. */ InstantNetworkTransferFailureReason["TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED"] = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED";
    /** The `InstantNetworkTransfer` failed because transfers between the source and destination accounts are not supported. */ InstantNetworkTransferFailureReason["TRANSFER_NOT_SUPPORTED"] = "TRANSFER_NOT_SUPPORTED";
    /** The `InstantNetworkTransfer` failed because this product does not support this type of transfer. */ InstantNetworkTransferFailureReason["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    /** The `InstantNetworkTransfer` failed because the transfer orchestration ID was not provided. */ InstantNetworkTransferFailureReason["TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED"] = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED";
    /** The `InstantNetworkTransfer` failed because the card is not activated. */ InstantNetworkTransferFailureReason["UNACTIVATED_CARD"] = "UNACTIVATED_CARD";
    /** The `InstantNetworkTransfer` failed because the valid account amount is not supported. */ InstantNetworkTransferFailureReason["VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED"] = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED";
    return InstantNetworkTransferFailureReason;
}({});
var $2f53fee15f29b056$export$6d51a5fe41f24bf4 = /*#__PURE__*/ function(InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus) {
    /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability disabled. */ InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus["DISABLED"] = "DISABLED";
    /** The `PaymentInstrument` has the `InstantNetworkTransfer` capability enabled. */ InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus["ENABLED"] = "ENABLED";
    /** The `PaymentInstrument` is undergoing a review to determine the status. */ InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus["REQUIRES_REVIEW"] = "REQUIRES_REVIEW";
    return InstantNetworkTransferSourcePaymentInstrumentCapabilityStatus;
}({});
var $2f53fee15f29b056$export$59a1341469e4faaa = /*#__PURE__*/ function(InstantNetworkTransferStatus) {
    /** The `InstantNetworkTransfer` has completed. */ InstantNetworkTransferStatus["COMPLETED"] = "COMPLETED";
    /** The `InstantNetworkTransfer` has failed. */ InstantNetworkTransferStatus["FAILED"] = "FAILED";
    /** The `InstantNetworkTransfer` is pending. */ InstantNetworkTransferStatus["PENDING"] = "PENDING";
    return InstantNetworkTransferStatus;
}({});
var $2f53fee15f29b056$export$a98bc84f2d21abc2 = /*#__PURE__*/ function(InstantSettlementTransactionEventType) {
    /** An ACH event. */ InstantSettlementTransactionEventType["ACH"] = "ACH";
    /** A fee variance transfer event. */ InstantSettlementTransactionEventType["FEE_VARIANCE_TRANSFER"] = "FEE_VARIANCE_TRANSFER";
    return InstantSettlementTransactionEventType;
}({});
var $2f53fee15f29b056$export$321cafc20991ded5 = /*#__PURE__*/ function(InstantSettlementTransactionStatus) {
    /** The `InstantSettlementTransaction` has completed. */ InstantSettlementTransactionStatus["COMPLETED"] = "COMPLETED";
    /** The `InstantSettlementTransaction` has failed. */ InstantSettlementTransactionStatus["FAILED"] = "FAILED";
    /** The `InstantSettlementTransaction` is pending. */ InstantSettlementTransactionStatus["PENDING"] = "PENDING";
    return InstantSettlementTransactionStatus;
}({});
var $2f53fee15f29b056$export$fbf42ed080eaf28d = /*#__PURE__*/ function(IntegrationEnvironment) {
    IntegrationEnvironment["LIVE"] = "LIVE";
    IntegrationEnvironment["TEST"] = "TEST";
    return IntegrationEnvironment;
}({});
var $2f53fee15f29b056$export$bb10b1f3ff590b = /*#__PURE__*/ function(IntegratorInitiatedAchHoldStatus) {
    /** The ACH Transaction had a hold but it has been removed */ IntegratorInitiatedAchHoldStatus["HOLD_REMOVED"] = "HOLD_REMOVED";
    /** The ACH Transaction is not on hold */ IntegratorInitiatedAchHoldStatus["NO_HOLDS"] = "NO_HOLDS";
    /** The ACH Transaction is currently on hold */ IntegratorInitiatedAchHoldStatus["ON_HOLD"] = "ON_HOLD";
    /** The hold status is unspecified */ IntegratorInitiatedAchHoldStatus["UNSPECIFIED"] = "UNSPECIFIED";
    return IntegratorInitiatedAchHoldStatus;
}({});
var $2f53fee15f29b056$export$1c5404cdc2cc5557 = /*#__PURE__*/ function(IntegratorInitiatedAchStatus) {
    /** You requested to cancel the transfer. */ IntegratorInitiatedAchStatus["CANCELED"] = "CANCELED";
    /** The transfer failed. Additional details are available in IntegratorInitiatedACHStatusCode. */ IntegratorInitiatedAchStatus["FAILED"] = "FAILED";
    /** A transfer request has been initiated. */ IntegratorInitiatedAchStatus["INITIATED"] = "INITIATED";
    /** The transfer has successfully been processed by the bank and funds are available. */ IntegratorInitiatedAchStatus["PROCESSED"] = "PROCESSED";
    /** The transfer is processing at Highnote and at the bank, but funds are not available yet. */ IntegratorInitiatedAchStatus["PROCESSING"] = "PROCESSING";
    /** The transfer has been returned by the bank. */ IntegratorInitiatedAchStatus["RETURNED"] = "RETURNED";
    return IntegratorInitiatedAchStatus;
}({});
var $2f53fee15f29b056$export$baa17796c208697 = /*#__PURE__*/ function(IntegratorInitiatedAchStatusReasonCode) {
    /** The `fromFinancialAccount` and `toFinancialAccount` do not belong to the same product. */ IntegratorInitiatedAchStatusReasonCode["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** R16 - The account is frozen. */ IntegratorInitiatedAchStatusReasonCode["ACCOUNT_FROZEN"] = "ACCOUNT_FROZEN";
    /** Loading funds via ACH is not supported. */ IntegratorInitiatedAchStatusReasonCode["ACH_LOAD_NOT_SUPPORTED"] = "ACH_LOAD_NOT_SUPPORTED";
    /** R19 - There is an error in the amount field. */ IntegratorInitiatedAchStatusReasonCode["AMOUNT_FIELD_ERROR"] = "AMOUNT_FIELD_ERROR";
    /** R07 - The Authorization was revoked by Customer. */ IntegratorInitiatedAchStatusReasonCode["AUTHORIZATION_REVOKED_BY_CUSTOMER"] = "AUTHORIZATION_REVOKED_BY_CUSTOMER";
    /** R11 - The account does not have the required commercial pay in full account feature enabled. */ IntegratorInitiatedAchStatusReasonCode["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** The account does not have the required corporate bank account feature enabled. */ IntegratorInitiatedAchStatusReasonCode["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** R11 - The credit limit is not set on the account. */ IntegratorInitiatedAchStatusReasonCode["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The amount of the transfer does not match the currency of the Highnote account. */ IntegratorInitiatedAchStatusReasonCode["CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT"] = "CURRENCY_MISMATCH_WITH_HIGHNOTE_ACCOUNT";
    /** R24 - Resulted in a Duplicate Entry. */ IntegratorInitiatedAchStatusReasonCode["DUPLICATE_ENTRY"] = "DUPLICATE_ENTRY";
    /** R11 - The transfer is not in accordance with the terms of the authorization. */ IntegratorInitiatedAchStatusReasonCode["ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION"] = "ENTRY_NOT_IN_ACCORDANCE_WITH_TERMS_OF_AUTHORIZATION";
    /** The external account has been closed. */ IntegratorInitiatedAchStatusReasonCode["EXTERNAL_ACCOUNT_CLOSED"] = "EXTERNAL_ACCOUNT_CLOSED";
    /** No matching external account was found. */ IntegratorInitiatedAchStatusReasonCode["EXTERNAL_ACCOUNT_NOT_FOUND"] = "EXTERNAL_ACCOUNT_NOT_FOUND";
    /** The Highnote account has been closed. */ IntegratorInitiatedAchStatusReasonCode["HIGHNOTE_ACCOUNT_CLOSED"] = "HIGHNOTE_ACCOUNT_CLOSED";
    /** No matching Highnote account was found. */ IntegratorInitiatedAchStatusReasonCode["HIGHNOTE_ACCOUNT_NOT_FOUND"] = "HIGHNOTE_ACCOUNT_NOT_FOUND";
    /** R18 - Has an Improper Effective entry date. */ IntegratorInitiatedAchStatusReasonCode["IMPROPER_EFFECTIVE_ENTRY_DATE"] = "IMPROPER_EFFECTIVE_ENTRY_DATE";
    /** This was a debit from an en external account did not have enough funds. */ IntegratorInitiatedAchStatusReasonCode["INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_EXTERNAL_ACCOUNT";
    /** This was a debit from an account at Highnote which did not have enough funds. */ IntegratorInitiatedAchStatusReasonCode["INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT"] = "INSUFFICIENT_FUNDS_IN_HIGHNOTE_ACCOUNT";
    /** There is an internal error with the transfer. */ IntegratorInitiatedAchStatusReasonCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** R04 - Has an Invalid Account Number. */ IntegratorInitiatedAchStatusReasonCode["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    /** R21 - Has an Invalid Company ID Number. */ IntegratorInitiatedAchStatusReasonCode["INVALID_COMPANY_ID_NUMBER"] = "INVALID_COMPANY_ID_NUMBER";
    /** R22 - Has an Invalid Individual ID Number. */ IntegratorInitiatedAchStatusReasonCode["INVALID_INDIVIDUAL_ID_NUMBER"] = "INVALID_INDIVIDUAL_ID_NUMBER";
    /** R20 - Is a Non Transactional Account. */ IntegratorInitiatedAchStatusReasonCode["NON_TRANSACTION_ACCOUNT"] = "NON_TRANSACTION_ACCOUNT";
    /** R08 - The Payment was stopped. */ IntegratorInitiatedAchStatusReasonCode["PAYMENT_STOPPED"] = "PAYMENT_STOPPED";
    /** The account does not have the required payroll advance feature enabled. */ IntegratorInitiatedAchStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** The account does not have the required payroll employer advance feature enabled. */ IntegratorInitiatedAchStatusReasonCode["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** R06 - Funds were returned per OFDI Request. */ IntegratorInitiatedAchStatusReasonCode["RETURNED_PER_ODFI_REQUEST"] = "RETURNED_PER_ODFI_REQUEST";
    /** The account does not have the required secure card feature enabled. */ IntegratorInitiatedAchStatusReasonCode["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** R29 - The Transaction was not Authorized By Account Holder. */ IntegratorInitiatedAchStatusReasonCode["TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER"] = "TRANSACTION_NOT_AUTHORIZED_BY_ACCOUNT_HOLDER";
    /** The transfer amount is below the minimum amount to reload. */ IntegratorInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_RELOAD_LIMIT";
    /** The transfer exceeds the maximum load limit. */ IntegratorInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_LOAD_LIMIT";
    /** The transfer exceeds the maximum reload limit. */ IntegratorInitiatedAchStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_RELOAD_LIMIT";
    /** R05 - Is an Unauthorized Debit to Consumer Account Using Corporate SEC Code. */ IntegratorInitiatedAchStatusReasonCode["UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE"] = "UNAUTHORIZED_CONSUMER_DEBIT_USING_CORPORATE_SEC_CODE";
    /** R10 - Is an Unauthorized, Improper, Ineligible, or Incomplete Transaction. */ IntegratorInitiatedAchStatusReasonCode["UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION"] = "UNAUTHORIZED_IMPROPER_INELIGIBLE_OR_INCOMPLETE_TRANSACTION";
    /** R09 - Transaction represents Uncollected Funds. */ IntegratorInitiatedAchStatusReasonCode["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    return IntegratorInitiatedAchStatusReasonCode;
}({});
var $2f53fee15f29b056$export$2a2dc0f4bff167a5 = /*#__PURE__*/ function(IntegratorInitiatedTransferType) {
    /** Funds deposit filters to `IntegratorInitiatedFundsDepositACHTransfer`. */ IntegratorInitiatedTransferType["FUNDS_DEPOSIT"] = "FUNDS_DEPOSIT";
    /** Funds withdrawal filters to `IntegratorInitiatedFundsWithdrawalACHTransfer`. */ IntegratorInitiatedTransferType["FUNDS_WITHDRAWAL"] = "FUNDS_WITHDRAWAL";
    /** Repayment filters to `SecureCardBalanceRepaymentACHTransfer`. */ IntegratorInitiatedTransferType["REPAYMENT"] = "REPAYMENT";
    /** Secure Deposit filters to `SecureDepositACHTransfer`. */ IntegratorInitiatedTransferType["SECURE_DEPOSIT"] = "SECURE_DEPOSIT";
    return IntegratorInitiatedTransferType;
}({});
var $2f53fee15f29b056$export$e4f7e9655f505dff = /*#__PURE__*/ function(InterFinancialAccountTransferAccountType) {
    /** The account from which an inter financial account transfer moves funds. */ InterFinancialAccountTransferAccountType["SOURCE"] = "SOURCE";
    return InterFinancialAccountTransferAccountType;
}({});
var $2f53fee15f29b056$export$aff900e91f6e25ce = /*#__PURE__*/ function(InterFinancialAccountTransferActivityType) {
    /** Transfer for payroll advance. */ InterFinancialAccountTransferActivityType["ACCOUNT_PAYROLL_ADVANCE"] = "ACCOUNT_PAYROLL_ADVANCE";
    /** Transfer for payroll advance repayment. */ InterFinancialAccountTransferActivityType["ACCOUNT_PAYROLL_ADVANCE_REPAYMENT"] = "ACCOUNT_PAYROLL_ADVANCE_REPAYMENT";
    /** Transfer for adjustment. */ InterFinancialAccountTransferActivityType["ADJUSTMENT"] = "ADJUSTMENT";
    /** `Transfer` of cash reward points redemption to this account. */ InterFinancialAccountTransferActivityType["CASH_REDEEM_REWARD_POINTS"] = "CASH_REDEEM_REWARD_POINTS";
    /** `Transfer` of cash reward points redemption reversal to this account. */ InterFinancialAccountTransferActivityType["CASH_REDEEM_REWARD_POINTS_REVERSAL"] = "CASH_REDEEM_REWARD_POINTS_REVERSAL";
    /** Chargeback adjustments made to the account to revoke the Provisional Credit after the Chargeback has been decided against it. */ InterFinancialAccountTransferActivityType["CHARGEBACK_LOSS"] = "CHARGEBACK_LOSS";
    /** Provisional credit issued for a network chargeback. */ InterFinancialAccountTransferActivityType["CHARGEBACK_PROVISIONAL_CREDIT"] = "CHARGEBACK_PROVISIONAL_CREDIT";
    /** Chargeback adjustments made to the account to award the Provisional Credit after the Chargeback has been decided in its favor. */ InterFinancialAccountTransferActivityType["CHARGEBACK_WIN"] = "CHARGEBACK_WIN";
    /** Chargeback adjustments made to the account to award the Provisional Credit after the Chargeback has been decided in its favor. */ InterFinancialAccountTransferActivityType["CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT"] = "CHARGEBACK_WIN_WITHOUT_PROVISIONAL_CREDIT";
    /** Charge off an unrecoverable balance receivable on this account. */ InterFinancialAccountTransferActivityType["CHARGE_OFF"] = "CHARGE_OFF";
    /** Remove line of credit after an account closure. */ InterFinancialAccountTransferActivityType["CLOSE_LINE_OF_CREDIT"] = "CLOSE_LINE_OF_CREDIT";
    /** Decreasing the pseudo balance for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["DECREASE_PSEUDO_BALANCE"] = "DECREASE_PSEUDO_BALANCE";
    /** Decreasing an existing pseudo limit for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["DECREASE_PSEUDO_LIMIT"] = "DECREASE_PSEUDO_LIMIT";
    /** transfer for issuer-liable dispute adjustment. */ InterFinancialAccountTransferActivityType["DISPUTE_ADJUSTMENT_ISSUER_LIABLE"] = "DISPUTE_ADJUSTMENT_ISSUER_LIABLE";
    /** transfer for dispute adjustment reversal. */ InterFinancialAccountTransferActivityType["DISPUTE_ADJUSTMENT_REVERSAL"] = "DISPUTE_ADJUSTMENT_REVERSAL";
    /** A credit was issued for a transaction dispute that was not sent as a chargeback to the network. */ InterFinancialAccountTransferActivityType["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    /** transfer for issuer-liable dispute where the chargeback was lost. */ InterFinancialAccountTransferActivityType["DISPUTE_WON_CHARGEBACK_LOSS_ISSUER_LIABLE"] = "DISPUTE_WON_CHARGEBACK_LOSS_ISSUER_LIABLE";
    /** Transfer of earned credit to this account. */ InterFinancialAccountTransferActivityType["EARNED_CREDIT"] = "EARNED_CREDIT";
    /** Reversing transfer of earned credit to this account. */ InterFinancialAccountTransferActivityType["EARNED_CREDIT_REVERSAL"] = "EARNED_CREDIT_REVERSAL";
    /** This transfer is a generic transfer. */ InterFinancialAccountTransferActivityType["GENERAL"] = "GENERAL";
    /** `Transfer` of manual adjustment. */ InterFinancialAccountTransferActivityType["GENERAL_ADJUSTMENT"] = "GENERAL_ADJUSTMENT";
    /** Transfer of goods and services credit to this account. */ InterFinancialAccountTransferActivityType["GOODS_AND_SERVICES"] = "GOODS_AND_SERVICES";
    /** Increasing the pseudo balance for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["INCREASE_PSEUDO_BALANCE"] = "INCREASE_PSEUDO_BALANCE";
    /** Increasing an existing pseudo limit for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["INCREASE_PSEUDO_LIMIT"] = "INCREASE_PSEUDO_LIMIT";
    /** transfer for interchange sweep. */ InterFinancialAccountTransferActivityType["INTERCHANGE_SWEEP"] = "INTERCHANGE_SWEEP";
    /** Intra company transfer of credit to this account. */ InterFinancialAccountTransferActivityType["INTRA_COMPANY"] = "INTRA_COMPANY";
    /** transfer for issuer balance migration. */ InterFinancialAccountTransferActivityType["ISSUER_BALANCE_MIGRATION"] = "ISSUER_BALANCE_MIGRATION";
    /** This transfer funds a payment card `FinancialAccount` from a funding `FinancialAccount`. */ InterFinancialAccountTransferActivityType["LOAD_PAYMENT_CARD_ACCOUNT"] = "LOAD_PAYMENT_CARD_ACCOUNT";
    /** Transfer for merchant payout. */ InterFinancialAccountTransferActivityType["MERCHANT_PAYOUT"] = "MERCHANT_PAYOUT";
    /** `Transfer` for a requested routes. */ InterFinancialAccountTransferActivityType["PAYOUT"] = "PAYOUT";
    /** Transfer for payroll. */ InterFinancialAccountTransferActivityType["PAYROLL"] = "PAYROLL";
    /** Payroll advance funds to an employee financial account. */ InterFinancialAccountTransferActivityType["PAYROLL_ADVANCE"] = "PAYROLL_ADVANCE";
    /** This transfer resulted from an account charge off. */ InterFinancialAccountTransferActivityType["PAYROLL_ADVANCE_CHARGE_OFF"] = "PAYROLL_ADVANCE_CHARGE_OFF";
    /** Payroll advance repayment from an employee financial account. */ InterFinancialAccountTransferActivityType["PAYROLL_ADVANCE_REPAYMENT"] = "PAYROLL_ADVANCE_REPAYMENT";
    /** Transfer for payroll advance repayment reversal. */ InterFinancialAccountTransferActivityType["PAYROLL_ADVANCE_REPAYMENT_REVERSAL"] = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL";
    /** Transfer for payroll advance reversal. */ InterFinancialAccountTransferActivityType["PAYROLL_ADVANCE_REVERSAL"] = "PAYROLL_ADVANCE_REVERSAL";
    /** This transfer represents the remaining payroll deposit after advance repayment. */ InterFinancialAccountTransferActivityType["PAYROLL_DEPOSIT"] = "PAYROLL_DEPOSIT";
    /** Transfer for payroll reversal. */ InterFinancialAccountTransferActivityType["PAYROLL_REVERSAL"] = "PAYROLL_REVERSAL";
    /** transfer for peer to peer payment. */ InterFinancialAccountTransferActivityType["PEER_TO_PEER"] = "PEER_TO_PEER";
    /** transfer for peer to peer payment reversal. */ InterFinancialAccountTransferActivityType["PEER_TO_PEER_REVERSAL"] = "PEER_TO_PEER_REVERSAL";
    /** Receivables purchase agreement. Receivables were purchased from the bank. */ InterFinancialAccountTransferActivityType["RECEIVABLE_PURCHASE"] = "RECEIVABLE_PURCHASE";
    /** Receivables purchase interest. */ InterFinancialAccountTransferActivityType["RECEIVABLE_PURCHASE_INTEREST"] = "RECEIVABLE_PURCHASE_INTEREST";
    /** Reversal of a receivables purchase interest. */ InterFinancialAccountTransferActivityType["RECEIVABLE_PURCHASE_INTEREST_REVERSAL"] = "RECEIVABLE_PURCHASE_INTEREST_REVERSAL";
    /** Reversal of a receivables purchase agreement. */ InterFinancialAccountTransferActivityType["RECEIVABLE_PURCHASE_REVERSAL"] = "RECEIVABLE_PURCHASE_REVERSAL";
    /** Account Holder’s secured deposit used to cover an outstanding balance payable on the Financial Account. */ InterFinancialAccountTransferActivityType["RECOVER_SECURED_DEPOSIT"] = "RECOVER_SECURED_DEPOSIT";
    /** transfer for account repayment. */ InterFinancialAccountTransferActivityType["REPAYMENT"] = "REPAYMENT";
    /** `Transfer` for extra EWA repayment */ InterFinancialAccountTransferActivityType["REPAYMENT_ADJUSTMENT"] = "REPAYMENT_ADJUSTMENT";
    /** transfer for account repayment reversal. */ InterFinancialAccountTransferActivityType["REPAYMENT_REVERSAL"] = "REPAYMENT_REVERSAL";
    /** Resetting the pseudo balance for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["RESET_PSEUDO_BALANCE"] = "RESET_PSEUDO_BALANCE";
    /** Rewards earned for this account. */ InterFinancialAccountTransferActivityType["REWARD"] = "REWARD";
    /** Reversing rewards earned for this account. */ InterFinancialAccountTransferActivityType["REWARD_REVERSAL"] = "REWARD_REVERSAL";
    /** Transfer of secured deposit to this account. */ InterFinancialAccountTransferActivityType["SECURED_DEPOSIT"] = "SECURED_DEPOSIT";
    /** Transfer of secured deposit on this account being reversed. */ InterFinancialAccountTransferActivityType["SECURED_DEPOSIT_REVERSAL"] = "SECURED_DEPOSIT_REVERSAL";
    /**
   * Setting a limit on a financial account with a payment card.
   *
   * This isn't a transfer of funds, but a notification that a limit was set.
   */ InterFinancialAccountTransferActivityType["SET_LIMIT"] = "SET_LIMIT";
    /**
   * Setting a pseudo balance limit for this account.
   * This is only used for On-Demand Funding accounts.
   */ InterFinancialAccountTransferActivityType["SET_PSEUDO_BALANCE"] = "SET_PSEUDO_BALANCE";
    /** Setting a pseudo limit for a `FinancialAccount`. */ InterFinancialAccountTransferActivityType["SET_PSEUDO_LIMIT"] = "SET_PSEUDO_LIMIT";
    /** This transfer is a tip disbursement. */ InterFinancialAccountTransferActivityType["TIP_DISBURSEMENT"] = "TIP_DISBURSEMENT";
    /** This transfer is a tip disbursement reversal. */ InterFinancialAccountTransferActivityType["TIP_DISBURSEMENT_REVERSAL"] = "TIP_DISBURSEMENT_REVERSAL";
    return InterFinancialAccountTransferActivityType;
}({});
var $2f53fee15f29b056$export$e7b6cdc266b247b7 = /*#__PURE__*/ function(InterFinancialAccountTransferRuleResultStatus) {
    /** The rule had a unknown failure. */ InterFinancialAccountTransferRuleResultStatus["EXCEPTION"] = "EXCEPTION";
    /** The rule failed */ InterFinancialAccountTransferRuleResultStatus["FAILED"] = "FAILED";
    /** The rule was not ran. */ InterFinancialAccountTransferRuleResultStatus["NOT_RAN"] = "NOT_RAN";
    /** No decision was made for the rule */ InterFinancialAccountTransferRuleResultStatus["NO_DECISION"] = "NO_DECISION";
    /** The rule originally failed by was overridden to pass */ InterFinancialAccountTransferRuleResultStatus["OVERRIDDEN_TO_PASS"] = "OVERRIDDEN_TO_PASS";
    /** The rule passed */ InterFinancialAccountTransferRuleResultStatus["PASSED"] = "PASSED";
    /** The rule was flagged with a warning */ InterFinancialAccountTransferRuleResultStatus["WARNING"] = "WARNING";
    return InterFinancialAccountTransferRuleResultStatus;
}({});
var $2f53fee15f29b056$export$a6c236b08b6623d2 = /*#__PURE__*/ function(InterFinancialAccountTransferStatus) {
    /** The platform has completed the money movement. */ InterFinancialAccountTransferStatus["COMPLETED"] = "COMPLETED";
    /** The platform was not able to complete the money movement. See `statusReasonCode` for more information. */ InterFinancialAccountTransferStatus["FAILED"] = "FAILED";
    /** The platform is currently validating and executing the InterFinancialAccountTransfer. */ InterFinancialAccountTransferStatus["PENDING"] = "PENDING";
    /**
   * The platform has started processing the InterFinancialAccountTransfer.
   * @deprecated unused
   */ InterFinancialAccountTransferStatus["PROCESSING"] = "PROCESSING";
    return InterFinancialAccountTransferStatus;
}({});
var $2f53fee15f29b056$export$f68ee94041ae13e4 = /*#__PURE__*/ function(InterFinancialAccountTransferStatusReasonCode) {
    /** The accounts do not belong to the same product. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The source or receiving account is closed. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The receiving account holder is not an Organization. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION"] = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION";
    /** The account is not active. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The source or receiving account was not found. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The account was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["ACCOUNT_NOT_PROVIDED"] = "ACCOUNT_NOT_PROVIDED";
    /** ACH load is not allowed by the product configuration. */ InterFinancialAccountTransferStatusReasonCode["ACH_LOAD_NOT_ALLOWED_BY_PRODUCT"] = "ACH_LOAD_NOT_ALLOWED_BY_PRODUCT";
    /** The account does not have the `BankManagedBetaAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED"] = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Cash fund out is not supported on this product. */ InterFinancialAccountTransferStatusReasonCode["CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT"] = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT";
    /** The charge off amount exceeds the available balance. */ InterFinancialAccountTransferStatusReasonCode["CHARGE_OFF_EXCEEDS_BALANCE"] = "CHARGE_OFF_EXCEEDS_BALANCE";
    /** The account does not have the `CheckCapableAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED"] = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Check payment is not supported on this product. */ InterFinancialAccountTransferStatusReasonCode["CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT"] = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The account does not have the `CommercialCreditPayInFullFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** The account does not have the `CorporateBankAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The account does not have the `CreditCardFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** The credit limit is not set on the account. */ InterFinancialAccountTransferStatusReasonCode["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The source and receiving account have different currency. */ InterFinancialAccountTransferStatusReasonCode["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The account does not have the `DDAFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** The account does not have the `DebitCardFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** The account does not have the `DisputeChargebackFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["DISPUTE_CHARGEBACK_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_NOT_ENABLED";
    /** The account does not have the `DisputeChargebackProvisionalCreditFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED";
    /** External money movement is not supported on this product. */ InterFinancialAccountTransferStatusReasonCode["EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT"] = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The account does not have the `FleetFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** The account does not have the `FundingAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Funding card is not supported for this operation. */ InterFinancialAccountTransferStatusReasonCode["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** The account does not have the `HighnoteAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED"] = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The idempotency key was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The source account of the InterFinancialAccountTransfer did not have enough funds to cover the requested amount. */ InterFinancialAccountTransferStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** An internal server error occurred during the transfer. */ InterFinancialAccountTransferStatusReasonCode["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    /** Inter financial account transfer rules validation failed. */ InterFinancialAccountTransferStatusReasonCode["INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED";
    /** The disbursement amount is invalid. */ InterFinancialAccountTransferStatusReasonCode["INVALID_DISBURSEMENT_AMOUNT"] = "INVALID_DISBURSEMENT_AMOUNT";
    /** Issuer migration cannot set cash balance less than available cash. */ InterFinancialAccountTransferStatusReasonCode["ISSUER_MIGRATION_CANNOT_SET_CASH_BALANCE_LESS_THAN_AVAILABLE_CASH"] = "ISSUER_MIGRATION_CANNOT_SET_CASH_BALANCE_LESS_THAN_AVAILABLE_CASH";
    /** The account does not have the `JITFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["JIT_FEATURE_NOT_ENABLED"] = "JIT_FEATURE_NOT_ENABLED";
    /** The requested amount is more than max program limit. */ InterFinancialAccountTransferStatusReasonCode["LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "LIMIT_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** The account does not have the `MerchantFundingFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["MERCHANT_FUNDING_FEATURE_NOT_ENABLED"] = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED";
    /** The account does not have the `MerchantSettlementFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED"] = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED";
    /** There is not enough balance to reduce the credit limit. */ InterFinancialAccountTransferStatusReasonCode["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** The account does not have the `ODFFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["ODF_FEATURE_NOT_ENABLED"] = "ODF_FEATURE_NOT_ENABLED";
    /** The organization ID was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["ORGANIZATION_ID_NOT_PROVIDED"] = "ORGANIZATION_ID_NOT_PROVIDED";
    /** Originated ACH unload is not supported on this product. */ InterFinancialAccountTransferStatusReasonCode["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** The account does not have the `PartialFundingFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["PARTIAL_FUNDING_FEATURE_NOT_ENABLED"] = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED";
    /** The account does not have the required payroll advance feature enabled. */ InterFinancialAccountTransferStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** The employer account does not have the required payroll employer advance feature enabled. */ InterFinancialAccountTransferStatusReasonCode["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** The receiving account does not have PrepaidCardFeature or DebitCardFeature as enabled. */ InterFinancialAccountTransferStatusReasonCode["PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_OR_DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** The source account does not have ProductFundingFeature or CardFundingFeature as enabled. */ InterFinancialAccountTransferStatusReasonCode["PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_OR_CARD_FUNDING_FEATURE_NOT_ENABLED";
    /** The product does not have the `SecuredDepositAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** Pseudo balance is not enabled on the account. */ InterFinancialAccountTransferStatusReasonCode["PSEUDO_BALANCE_NOT_ENABLED"] = "PSEUDO_BALANCE_NOT_ENABLED";
    /** The account does not have the `ReceivablePurchaseFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["RECEIVABLE_PURCHASE_NOT_ENABLED"] = "RECEIVABLE_PURCHASE_NOT_ENABLED";
    /** The repayment account is not present on the product. */ InterFinancialAccountTransferStatusReasonCode["REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT"] = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT";
    /** The account does not have the `RewardPointFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    /** The account does not have the `SecuredDepositAccountFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The account does not have the `SecureCardFeature` enabled. */ InterFinancialAccountTransferStatusReasonCode["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** The tenant ID was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["TENANT_ID_NOT_PROVIDED"] = "TENANT_ID_NOT_PROVIDED";
    /** The transaction ID was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["TRANSACTION_ID_NOT_PROVIDED"] = "TRANSACTION_ID_NOT_PROVIDED";
    /** The transfer amount is below the minimum product reload limit. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_BELOW_MIN_PRODUCT_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PRODUCT_RELOAD_LIMIT";
    /** The requested amount exceeds the maximum aggregate credit distribution amount. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT";
    /** The transfer amount exceeds the maximum product card balance. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_CARD_BALANCE"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_CARD_BALANCE";
    /** The requested amount exceeds the maximum product reload limit. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PRODUCT_RELOAD_LIMIT";
    /** The transfer amount is negative. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_IS_NEGATIVE"] = "TRANSFER_AMOUNT_IS_NEGATIVE";
    /** The transfer amount is negative or zero. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** The transfer between different products is not allowed. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED"] = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED";
    /** The transfer condition requiring same primary account holder is not satisfied. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED"] = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED";
    /** The transfer is not supported on this product. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    /** The transfer orchestration ID was not provided in the request. */ InterFinancialAccountTransferStatusReasonCode["TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED"] = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED";
    return InterFinancialAccountTransferStatusReasonCode;
}({});
var $2f53fee15f29b056$export$22b5f5b9163d611c = /*#__PURE__*/ function(InterestAccrualMethod) {
    InterestAccrualMethod["FIRST_DAY_OF_BILLING_PERIOD"] = "FIRST_DAY_OF_BILLING_PERIOD";
    InterestAccrualMethod["PAYMENT_DUE_DATE"] = "PAYMENT_DUE_DATE";
    InterestAccrualMethod["TRANSACTION_POST_DATE"] = "TRANSACTION_POST_DATE";
    return InterestAccrualMethod;
}({});
var $2f53fee15f29b056$export$292fcee86de81c2f = /*#__PURE__*/ function(InterestAccrualType) {
    InterestAccrualType["COMPOUND"] = "COMPOUND";
    InterestAccrualType["SIMPLE"] = "SIMPLE";
    return InterestAccrualType;
}({});
var $2f53fee15f29b056$export$329d284a82fdf5ad = /*#__PURE__*/ function(InterestAssessmentSchedule) {
    InterestAssessmentSchedule["DAILY"] = "DAILY";
    InterestAssessmentSchedule["STATEMENT"] = "STATEMENT";
    return InterestAssessmentSchedule;
}({});
var $2f53fee15f29b056$export$951e1d66a89147de = /*#__PURE__*/ function(InterestRateIndex) {
    InterestRateIndex["LIBOR"] = "LIBOR";
    InterestRateIndex["PRIME"] = "PRIME";
    return InterestRateIndex;
}({});
var $2f53fee15f29b056$export$102071b5b3e0e423 = /*#__PURE__*/ function(InterestRateType) {
    InterestRateType["FIXED"] = "FIXED";
    InterestRateType["VARIABLE"] = "VARIABLE";
    return InterestRateType;
}({});
var $2f53fee15f29b056$export$a920f3ff6fd925 = /*#__PURE__*/ function(IssuePaymentCardForFinancialAccountResponseStatus) {
    /** The request completed with a failure, reference the `failureReason` on why the request failed. */ IssuePaymentCardForFinancialAccountResponseStatus["FAILURE"] = "FAILURE";
    /** The request is currently processing. */ IssuePaymentCardForFinancialAccountResponseStatus["PROCESSING"] = "PROCESSING";
    /** The request completed successfully, and the response is available. */ IssuePaymentCardForFinancialAccountResponseStatus["SUCCESS"] = "SUCCESS";
    /** The request status is unknown. Contact Highnote for more details. */ IssuePaymentCardForFinancialAccountResponseStatus["UNKNOWN"] = "UNKNOWN";
    return IssuePaymentCardForFinancialAccountResponseStatus;
}({});
var $2f53fee15f29b056$export$e216f617daec07af = /*#__PURE__*/ function(LedgerName) {
    /**
   * The name of a ledger that tracks account charge-offs on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["ACCOUNT_CHARGE_OFF"] = "ACCOUNT_CHARGE_OFF";
    /** The name of a ledger that tracks the credit limit for an Account Holder on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["ACCOUNT_HOLDER_CREDIT_LIMIT"] = "ACCOUNT_HOLDER_CREDIT_LIMIT";
    /** The name of a ledger that tracks an Account holder payment owed on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["ACCOUNT_HOLDER_PAYMENT_PAYABLE"] = "ACCOUNT_HOLDER_PAYMENT_PAYABLE";
    /** The name of a ledger that tracks an Account holder payment to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["ACCOUNT_HOLDER_PAYMENT_RECEIVABLE"] = "ACCOUNT_HOLDER_PAYMENT_RECEIVABLE";
    /** The name of a ledger that tracks the current account holder pseudo limit funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["ACCOUNT_HOLDER_PSEUDO_LIMIT"] = "ACCOUNT_HOLDER_PSEUDO_LIMIT";
    /** The name of a ledger that tracks the collateral in the form of a secured deposit associated to an Account Holder’s `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["ACCOUNT_HOLDER_SECURED_DEPOSIT"] = "ACCOUNT_HOLDER_SECURED_DEPOSIT";
    /** The name of a ledger that tracks pending ACH Debits owed on a withdrawal for a `FinancialAccount`. NormalBalanceType = CREDIT. */ LedgerName["ACH_DEBIT_PAYABLE"] = "ACH_DEBIT_PAYABLE";
    /** The name of a ledger that tracks pending ACH settlements on a `FinancialAccount` that have the `DirectDepositFinancialAccountFeature` enabled. NormalBalanceType = CREDIT. */ LedgerName["ACH_PENDING_SETTLEMENT"] = "ACH_PENDING_SETTLEMENT";
    /** The name of a ledger that tracks pending ACH settlements on a withdrawn for a `FinancialAccount`. NormalBalanceType = DEBIT. */ LedgerName["ACH_PENDING_SETTLEMENT_OUT"] = "ACH_PENDING_SETTLEMENT_OUT";
    /** The name of a ledger that tracks activity on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["ACTIVITY"] = "ACTIVITY";
    /** The name of a ledger that tracks amount of credit allocated to Account Holders on a Card Product `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["ALLOCATED_CREDIT_LIMIT"] = "ALLOCATED_CREDIT_LIMIT";
    /** The name of a ledger that tracks the current allocated pseudo limit funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = DEBIT. */ LedgerName["ALLOCATED_PSEUDO_LIMIT"] = "ALLOCATED_PSEUDO_LIMIT";
    /** The name of a ledger that tracks authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["AUTHORIZATION"] = "AUTHORIZATION";
    /** The name of a ledger that tracks the money available to spend for an account. NormalBalanceType = CREDIT. */ LedgerName["AVAILABLE_CASH"] = "AVAILABLE_CASH";
    /** The name of a ledger that tracks the available credit on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["AVAILABLE_CREDIT"] = "AVAILABLE_CREDIT";
    /** The name of a ledger that tracks the amount owed by `PaymentCard` account to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = CREDIT. */ LedgerName["CARD_PAYABLE"] = "CARD_PAYABLE";
    /** The name of a ledger that tracks the amount owed to a `PaymentCard` from a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */ LedgerName["CARD_RECEIVABLE"] = "CARD_RECEIVABLE";
    /** The name of a ledger that tracks card transaction credit holds on a `PaymentCard`. NormalBalanceType = DEBIT. */ LedgerName["CARD_TRANSACTION_CREDIT_HOLD"] = "CARD_TRANSACTION_CREDIT_HOLD";
    /** The name of a ledger that tracks the actual money in the account. The ledger can be impacted by any money movement, including cleared transactions and transfers. NormalBalanceType = DEBIT. */ LedgerName["CASH"] = "CASH";
    /** The name of a ledger that tracks cash expense on a `PaymentCard`. NormalBalanceType = DEBIT. */ LedgerName["CASH_EXPENSE"] = "CASH_EXPENSE";
    /**
   * The name of a ledger that tracks charge-off expenses on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["CHARGE_OFF_EXPENSE"] = "CHARGE_OFF_EXPENSE";
    /** The name of a ledger that tracks the initiation of a `CheckPayment` on a `FinancialAccount`. NormalBalanceType = CREDIT. */ LedgerName["CHECK_PAYABLE"] = "CHECK_PAYABLE";
    /** The name of a ledger that tracks the processing of a `CheckPayment`. NormalBalanceType = CREDIT. */ LedgerName["CHECK_PROCESSING"] = "CHECK_PROCESSING";
    /** The name of a ledger that tracks the settlement of `CheckPayment` funds. NormalBalanceType = DEBIT. */ LedgerName["CHECK_SETTLEMENT_DEPOSIT"] = "CHECK_SETTLEMENT_DEPOSIT";
    /** The name of a ledger that tracks cleared authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["CLEARED"] = "CLEARED";
    /** The name of a ledger that tracks credit authorizations on a `PaymentCard`. These are authorizations that are typically associated with a refund. NormalBalanceType = DEBIT. */ LedgerName["CREDIT_AUTHORIZATION"] = "CREDIT_AUTHORIZATION";
    /** The name of a ledger that tracks credit holds on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["CREDIT_HOLD"] = "CREDIT_HOLD";
    /** The name of a ledger that tracks the Credit Limit minus the outstanding balance on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["CREDIT_OUTSTANDING"] = "CREDIT_OUTSTANDING";
    /**
   * The name of a ledger that tracks the cryptocurrency funds that can be assigned from a crypto wallet or account.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["CRYPTO_AVAILABLE_CASH"] = "CRYPTO_AVAILABLE_CASH";
    /**
   * The name of a ledger that tracks the actual cryptocurrency in the wallet or account. The ledger can be impacted by any money movement, including cleared transactions and transfers.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["CRYPTO_CASH"] = "CRYPTO_CASH";
    /**
   * The name of a ledger that tracks the customer fee payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["CUSTOMER_FEE_PAYABLE"] = "CUSTOMER_FEE_PAYABLE";
    /** The name of a ledger that tracks deposit authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["DEPOSIT_AUTHORIZATION"] = "DEPOSIT_AUTHORIZATION";
    /** The name of a ledger that tracks deposit holds on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["DEPOSIT_HOLD"] = "DEPOSIT_HOLD";
    /** The name of a ledger that tracks deposits waiting to be received on a `FinancialAccount` that have the `DirectDepositFinancialAccountFeature` enabled. NormalBalanceType = DEBIT. */ LedgerName["DEPOSIT_RECEIVABLE"] = "DEPOSIT_RECEIVABLE";
    /**
   * The name of a ledger that tracks disbursement carry over payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["DISBURSEMENT_CARRY_OVER_PAYABLE"] = "DISBURSEMENT_CARRY_OVER_PAYABLE";
    /**
   * The name of a ledger that tracks disbursement carry over receivable on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["DISBURSEMENT_CARRY_OVER_RECEIVABLE"] = "DISBURSEMENT_CARRY_OVER_RECEIVABLE";
    /** The name of a ledger that tracks the amount issued to a `FinancialAccount` for a dispute. NormalBalanceType = CREDIT. */ LedgerName["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    /** The name of a ledger that tracks the amount owed by the issuer for a dispute on a `FinancialAccount`. NormalBalanceType = DEBIT. */ LedgerName["DISPUTE_EXPENSE"] = "DISPUTE_EXPENSE";
    /**
   * The name of a ledger that tracks external transfer payables on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["EXTERNAL_TRANSFER_PAYABLE"] = "EXTERNAL_TRANSFER_PAYABLE";
    /** The name of a ledger that tracks surcharge fee authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["FEE_AUTHORIZATION"] = "FEE_AUTHORIZATION";
    /** The name of a ledger that tracks cleared surcharge fee authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["FEE_CLEARED"] = "FEE_CLEARED";
    /** The name of a ledger that tracks funding hold on an account. NormalBalanceType = CREDIT. */ LedgerName["FUND_IN_HOLD"] = "FUND_IN_HOLD";
    /**
   * The name of a ledger that tracks interchange fee precision adjustment on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["INTERCHANGE_FEE_PRECISION_ADJUSTMENT"] = "INTERCHANGE_FEE_PRECISION_ADJUSTMENT";
    /** The name of a ledger that tracks interchange revenue from payment card transactions. NormalBalanceType = CREDIT. */ LedgerName["INTERCHANGE_REVENUE"] = "INTERCHANGE_REVENUE";
    /** The name of a ledger that tracks the amount owed to an account from a card network due to a refunds or adjustments. NormalBalanceType = DEBIT. */ LedgerName["NETWORK_CREDIT_RECEIVABLE"] = "NETWORK_CREDIT_RECEIVABLE";
    /** The name of a ledger that tracks the amount paid to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */ LedgerName["NETWORK_EXPENSE"] = "NETWORK_EXPENSE";
    /** The name of a ledger that tracks the amount owed to a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = CREDIT. */ LedgerName["NETWORK_PAYABLE"] = "NETWORK_PAYABLE";
    /** The name of a ledger that tracks the amount owed to an account from a card network (e.g., Mastercard, Visa, etc.). NormalBalanceType = DEBIT. */ LedgerName["NETWORK_RECEIVABLE"] = "NETWORK_RECEIVABLE";
    /** The name of a ledger that tracks outstanding balance owed on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["OUTSTANDING_BALANCE_PAYABLE"] = "OUTSTANDING_BALANCE_PAYABLE";
    /** The name of a ledger that tracks outstanding balance to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["OUTSTANDING_BALANCE_RECEIVABLE"] = "OUTSTANDING_BALANCE_RECEIVABLE";
    /**
   * The name of a ledger that tracks payment chargeback fees owed on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["PAYMENT_CHARGEBACK_FEE_PAYABLE"] = "PAYMENT_CHARGEBACK_FEE_PAYABLE";
    /** The name of a ledger that tracks the current payment interchange fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["PAYMENT_INTERCHANGE_FEE_PAYABLE"] = "PAYMENT_INTERCHANGE_FEE_PAYABLE";
    /** The name of a ledger that tracks the current payment network fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["PAYMENT_NETWORK_FEE_PAYABLE"] = "PAYMENT_NETWORK_FEE_PAYABLE";
    /** The name of a ledger that tracks the current payment payout payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["PAYMENT_PAYOUT_PAYABLE"] = "PAYMENT_PAYOUT_PAYABLE";
    /** The name of a ledger that tracks the current payment platform fee payable funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["PAYMENT_PLATFORM_FEE_PAYABLE"] = "PAYMENT_PLATFORM_FEE_PAYABLE";
    /** The name of a ledger that tracks Payroll Advance payable on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = CREDIT. */ LedgerName["PAYROLL_ADVANCE_PAYABLE"] = "PAYROLL_ADVANCE_PAYABLE";
    /** The name of a ledger that tracks Payroll Advance receivable on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = DEBIT. */ LedgerName["PAYROLL_ADVANCE_RECEIVABLE"] = "PAYROLL_ADVANCE_RECEIVABLE";
    /** The name of a ledger that tracks Payroll Advance write-off on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = CREDIT. */ LedgerName["PAYROLL_ADVANCE_WRITE_OFF"] = "PAYROLL_ADVANCE_WRITE_OFF";
    /** The name of a ledger that tracks Payroll Advance write-off expense on a `FinancialAccount` associated to an `EARNED_WAGE_ACCESS` Card Product. NormalBalanceType = DEBIT. */ LedgerName["PAYROLL_ADVANCE_WRITE_OFF_EXPENSE"] = "PAYROLL_ADVANCE_WRITE_OFF_EXPENSE";
    /** The name of a ledger that tracks pending payment to be received on a `FinancialAccount` associated to a credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["PENDING_PAYMENT_RECEIVABLE"] = "PENDING_PAYMENT_RECEIVABLE";
    /** The name of a ledger that tracks provisional credit owed on a `FinancialAccount` of an Account Holder associated to a `FinancialAccount` of a Card Product. NormalBalanceType = CREDIT. */ LedgerName["PROVISIONAL_CREDIT_PAYABLE"] = "PROVISIONAL_CREDIT_PAYABLE";
    /** The name of a ledger that tracks provisional credit to be received on a `FinancialAccount` of an Account Holder associated to a `FinancialAccount` of a Card Product. NormalBalanceType = DEBIT. */ LedgerName["PROVISIONAL_CREDIT_RECEIVABLE"] = "PROVISIONAL_CREDIT_RECEIVABLE";
    /** The name of a ledger that tracks the available pseudo cash that this `FinancialAccount` has available to spend. NormalBalanceType = CREDIT. */ LedgerName["PSEUDO_AVAILABLE_CASH"] = "PSEUDO_AVAILABLE_CASH";
    /**
   * The name of a ledger that tracks the available pseudo credit on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["PSEUDO_AVAILABLE_CREDIT"] = "PSEUDO_AVAILABLE_CREDIT";
    /** The name of a ledger that tracks the current pseudo cash that this `FinancialAccount` has spent. NormalBalanceType = DEBIT. */ LedgerName["PSEUDO_CASH"] = "PSEUDO_CASH";
    /**
   * The name of a ledger that tracks the outstanding pseudo credit on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["PSEUDO_CREDIT_OUTSTANDING"] = "PSEUDO_CREDIT_OUTSTANDING";
    /** The name of a ledger that tracks pull payment credit holds on a `FinancialAccount`. NormalBalanceType = CREDIT. */ LedgerName["PULL_PAYMENT_CREDIT_HOLD"] = "PULL_PAYMENT_CREDIT_HOLD";
    /** The name of a ledger that tracks pull payment fees payable on a `FinancialAccount`. NormalBalanceType = CREDIT. */ LedgerName["PULL_PAYMENT_FEE_PAYABLE"] = "PULL_PAYMENT_FEE_PAYABLE";
    /** The name of a ledger that tracks pull payment receivables on a `FinancialAccount`. NormalBalanceType = DEBIT. */ LedgerName["PULL_PAYMENT_RECEIVABLE"] = "PULL_PAYMENT_RECEIVABLE";
    /**
   * The name of a ledger that tracks the push payment fee payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT.
   */ LedgerName["PUSH_PAYMENT_FEE_PAYABLE"] = "PUSH_PAYMENT_FEE_PAYABLE";
    /**
   * The name of a ledger that tracks the push payment payable on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT.
   */ LedgerName["PUSH_PAYMENT_PAYABLE"] = "PUSH_PAYMENT_PAYABLE";
    /** The name of a ledger that tracks redeemable rewards points on a `FinancialAccount`. Only available if the `POINT_REWARDS` feature is available on the `FinancialAccount`. NormalBalanceType = CREDIT. */ LedgerName["REDEEMABLE_REWARDS_POINTS"] = "REDEEMABLE_REWARDS_POINTS";
    /** The name of a ledger that tracks refund authorizations on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["REFUND_AUTHORIZATION"] = "REFUND_AUTHORIZATION";
    /** The name of a ledger that tracks refund holds on a `PaymentCard`. NormalBalanceType = CREDIT. */ LedgerName["REFUND_HOLD"] = "REFUND_HOLD";
    /** The name of a ledger that tracks the reserve for an account. NormalBalanceType = DEBIT. */ LedgerName["RESERVE"] = "RESERVE";
    /** The name of a ledger that tracks rewards points on a `FinancialAccount`. Only available if the `POINT_REWARDS` feature is available on the `FinancialAccount`. NormalBalanceType = DEBIT. */ LedgerName["REWARDS_POINTS"] = "REWARDS_POINTS";
    /** The name of a ledger that tracks holds for an account that are associated with potential risk on the account. NormalBalanceType = CREDIT. */ LedgerName["RISK_HOLD"] = "RISK_HOLD";
    /**
   * The name of a ledger that tracks RTP (Real-Time Payments) debits owed on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["RTP_DEBIT_PAYABLE"] = "RTP_DEBIT_PAYABLE";
    /**
   * The name of a ledger that tracks pending RTP (Real-Time Payments) settlements on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["RTP_PENDING_SETTLEMENT"] = "RTP_PENDING_SETTLEMENT";
    /** The name of a ledger that tracks collateral in the form of a secured deposit Card Product Funding `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["SECURED_DEPOSIT_COLLATERAL"] = "SECURED_DEPOSIT_COLLATERAL";
    /** The name of a ledger that tracks secured deposit owed on a `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = CREDIT. */ LedgerName["SECURED_DEPOSIT_PAYABLE"] = "SECURED_DEPOSIT_PAYABLE";
    /** The name of a ledger that tracks secured deposit to be received on a `FinancialAccount` associated to a Secured Credit Card Product. NormalBalanceType = DEBIT. */ LedgerName["SECURED_DEPOSIT_RECEIVABLE"] = "SECURED_DEPOSIT_RECEIVABLE";
    /**
   * The name of a ledger that tracks self-payout shortages on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["SELF_PAYOUT_SHORTAGE"] = "SELF_PAYOUT_SHORTAGE";
    /**
   * The name of a ledger that tracks self-payout shortage expenses on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["SELF_PAYOUT_SHORTAGE_EXPENSE"] = "SELF_PAYOUT_SHORTAGE_EXPENSE";
    /** The name of a ledger that tracks the current settlement payable on a `FinancialAccount` that have the `PartialFundingFinancialAccountFeature` enabled. NormalBalanceType = CREDIT. */ LedgerName["SETTLEMENT_PAYABLE"] = "SETTLEMENT_PAYABLE";
    /**
   * The name of a ledger that tracks statement due payables on a `FinancialAccount`.
   *
   * NormalBalanceType = CREDIT
   */ LedgerName["STATEMENT_DUE_PAYABLE"] = "STATEMENT_DUE_PAYABLE";
    /**
   * The name of a ledger that tracks statement due receivables on a `FinancialAccount`.
   *
   * NormalBalanceType = DEBIT
   */ LedgerName["STATEMENT_DUE_RECEIVABLE"] = "STATEMENT_DUE_RECEIVABLE";
    /** The name of a ledger that tracks the current transfer payable on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["TRANSFER_PAYABLE"] = "TRANSFER_PAYABLE";
    /** The name of a ledger that tracks the current pending transfer settlement funds on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = CREDIT. */ LedgerName["TRANSFER_PENDING_SETTLEMENT"] = "TRANSFER_PENDING_SETTLEMENT";
    /** The name of a ledger that tracks the current transfer receivable on a `FinancialAccount` that is expecting internal transfer to complete. NormalBalanceType = DEBIT. */ LedgerName["TRANSFER_RECEIVABLE"] = "TRANSFER_RECEIVABLE";
    /** The name of a ledger that tracks all uncollected funds for an account. NormalBalanceType = DEBIT. */ LedgerName["UNCOLLECTED_FUNDS"] = "UNCOLLECTED_FUNDS";
    return LedgerName;
}({});
var $2f53fee15f29b056$export$2fd7a8939391a912 = /*#__PURE__*/ function(ManualAdjustmentActivityType) {
    /** This adjustment type is for account closure credit amount. */ ManualAdjustmentActivityType["ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT"] = "ACCOUNT_CLOSURE_CREDIT_AVAILABLE_CREDIT_SETTLEMENT";
    /** This adjustment type is for account closure credit amount. */ ManualAdjustmentActivityType["ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF"] = "ACCOUNT_CLOSURE_CREDIT_CHARGE_OFF";
    /** This adjustment type is for account closure secured amount. */ ManualAdjustmentActivityType["ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT"] = "ACCOUNT_CLOSURE_SECURED_DEPOSIT_SETTLEMENT";
    /** The adjustment type is for fee. */ ManualAdjustmentActivityType["ADJUST_FEE"] = "ADJUST_FEE";
    /** This adjustment type is for transaction amount. */ ManualAdjustmentActivityType["CARD_TRANSACTION_ADJUSTMENT"] = "CARD_TRANSACTION_ADJUSTMENT";
    /** This adjustment type is for chargeback. */ ManualAdjustmentActivityType["CHARGEBACK"] = "CHARGEBACK";
    /** This adjustment type is for chargeback provisional credit amount. */ ManualAdjustmentActivityType["CHARGEBACK_CREATE_PROVISIONAL_CREDIT"] = "CHARGEBACK_CREATE_PROVISIONAL_CREDIT";
    /** This adjustment type is for early wage account repayment amount. */ ManualAdjustmentActivityType["EWA_REPAYMENT"] = "EWA_REPAYMENT";
    /** This adjustment type is for general adjustment. */ ManualAdjustmentActivityType["GENERAL_ADJUSTMENT"] = "GENERAL_ADJUSTMENT";
    /** This adjustment type is for interest waive amount. */ ManualAdjustmentActivityType["INTEREST_CHARGED_ADJUSTMENT"] = "INTEREST_CHARGED_ADJUSTMENT";
    /** This adjustment type is for non-originating ACH amount. */ ManualAdjustmentActivityType["NON_ORIGINATING_ACH_PAYROLL_LOAD"] = "NON_ORIGINATING_ACH_PAYROLL_LOAD";
    /** This adjustment type is for ACH unload amount. */ ManualAdjustmentActivityType["NON_ORIGINATING_ACH_UNLOAD"] = "NON_ORIGINATING_ACH_UNLOAD";
    /** This adjustment type is for originating ACH payment. */ ManualAdjustmentActivityType["ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT"] = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_CARD_BALANCE_PAYMENT";
    /** This adjustment type is for originating ACH deposit. */ ManualAdjustmentActivityType["ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT"] = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT";
    /** This adjustment type is for originating ACH payment. */ ManualAdjustmentActivityType["ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT"] = "ORIGINATING_ACH_COMMERCIAL_SECURED_CREDIT_DEPOSIT_REPAYMENT";
    /** This adjustment type is for receivable purchase. */ ManualAdjustmentActivityType["RECEIVABLE_PURCHASE"] = "RECEIVABLE_PURCHASE";
    /** This adjustment type is for receivable purchase. */ ManualAdjustmentActivityType["RECEIVABLE_PURCHASE_INTEREST"] = "RECEIVABLE_PURCHASE_INTEREST";
    /** `Transfer` for adjusting an EWA repayment */ ManualAdjustmentActivityType["REPAYMENT_ADJUSTMENT"] = "REPAYMENT_ADJUSTMENT";
    /** This adjustment type is for risk hold amount. */ ManualAdjustmentActivityType["RISK_HOLD_CREDIT"] = "RISK_HOLD_CREDIT";
    /** This adjustment type is for wire transfer amount. */ ManualAdjustmentActivityType["WIRE_TRANSFER_ACCOUNT_LOAD"] = "WIRE_TRANSFER_ACCOUNT_LOAD";
    /** This adjustment type is for wire transfer amount. */ ManualAdjustmentActivityType["WIRE_TRANSFER_ACCOUNT_UNLOAD"] = "WIRE_TRANSFER_ACCOUNT_UNLOAD";
    return ManualAdjustmentActivityType;
}({});
var $2f53fee15f29b056$export$18723cd9499d4c09 = /*#__PURE__*/ function(MastercardAavResultCode) {
    /** The AAV for the 3DS verification failed validation. */ MastercardAavResultCode["AAV_FAILED_VALIDATION"] = "AAV_FAILED_VALIDATION";
    /** AAV was not validated due to improper formatting. */ MastercardAavResultCode["AAV_MISFORMATTED"] = "AAV_MISFORMATTED";
    /** AAV was not validated due to improper formatting, or due to the AAV being reused or expired. */ MastercardAavResultCode["AAV_NOT_VALIDATED"] = "AAV_NOT_VALIDATED";
    /** The AAV for the 3DS verification passed validation. */ MastercardAavResultCode["AAV_PASSED_VALIDATION"] = "AAV_PASSED_VALIDATION";
    /** The AAV for the 3DS verification was invalid. */ MastercardAavResultCode["INVALID_AAV"] = "INVALID_AAV";
    return MastercardAavResultCode;
}({});
var $2f53fee15f29b056$export$ed3ce3fd8dcb59de = /*#__PURE__*/ function(MastercardFleetCreditOrDebitIndicator) {
    /** Indicates that the amount is a credit */ MastercardFleetCreditOrDebitIndicator["CREDIT"] = "CREDIT";
    /** Indicates that the amount is a debit */ MastercardFleetCreditOrDebitIndicator["DEBIT"] = "DEBIT";
    return MastercardFleetCreditOrDebitIndicator;
}({});
var $2f53fee15f29b056$export$27325f677899492 = /*#__PURE__*/ function(MastercardFleetFuelBrand) {
    /** AAFES */ MastercardFleetFuelBrand["AAFES"] = "AAFES";
    /** Amoco Petroleum Products */ MastercardFleetFuelBrand["AMOCO"] = "AMOCO";
    /** Amoco Canada */ MastercardFleetFuelBrand["AMOCO_CA"] = "AMOCO_CA";
    /** Arco Products */ MastercardFleetFuelBrand["ARCO"] = "ARCO";
    /** Asda */ MastercardFleetFuelBrand["ASDA"] = "ASDA";
    /** Ashland Oil */ MastercardFleetFuelBrand["ASHLAND"] = "ASHLAND";
    /** BFL */ MastercardFleetFuelBrand["BFL"] = "BFL";
    /** BP Oil */ MastercardFleetFuelBrand["BP"] = "BP";
    /** BP/Mobil */ MastercardFleetFuelBrand["BP_MOBIL"] = "BP_MOBIL";
    /** Burrnah/Major */ MastercardFleetFuelBrand["BURNAH"] = "BURNAH";
    /** Butler/Arndale */ MastercardFleetFuelBrand["BUTLER"] = "BUTLER";
    /** Canadian Tire */ MastercardFleetFuelBrand["CANADIAN_TIRE"] = "CANADIAN_TIRE";
    /** Canadian Turbo */ MastercardFleetFuelBrand["CANADIAN_TURBO"] = "CANADIAN_TURBO";
    /** Casey’s General Store */ MastercardFleetFuelBrand["CASEYS"] = "CASEYS";
    /** Cenex */ MastercardFleetFuelBrand["CENEX"] = "CENEX";
    /** Chevron USA */ MastercardFleetFuelBrand["CHEVRON"] = "CHEVRON";
    /** Chevron Canada */ MastercardFleetFuelBrand["CHEVRON_CA"] = "CHEVRON_CA";
    /** Circle K Stores */ MastercardFleetFuelBrand["CIRCLE_K"] = "CIRCLE_K";
    /** Citgo Petroleum */ MastercardFleetFuelBrand["CITGO"] = "CITGO";
    /** Clark Brands */ MastercardFleetFuelBrand["CLARK"] = "CLARK";
    /** Conoco Inc. */ MastercardFleetFuelBrand["CONOCO"] = "CONOCO";
    /** Conoco Canada */ MastercardFleetFuelBrand["CONOCO_CA"] = "CONOCO_CA";
    /** Crown Central Petroleum */ MastercardFleetFuelBrand["CROWN_CENTRAL"] = "CROWN_CENTRAL";
    /** Diamond Shamrock Inc. */ MastercardFleetFuelBrand["DIAMOND_SHAMROCK"] = "DIAMOND_SHAMROCK";
    /** Discount Tire */ MastercardFleetFuelBrand["DISCOUNT_TIRE"] = "DISCOUNT_TIRE";
    /** Domo Gas */ MastercardFleetFuelBrand["DOMO"] = "DOMO";
    /** Elf */ MastercardFleetFuelBrand["ELF"] = "ELF";
    /** Erickson Oil */ MastercardFleetFuelBrand["ERICKSON"] = "ERICKSON";
    /** Esso Canada */ MastercardFleetFuelBrand["ESSO_CA"] = "ESSO_CA";
    /** Esso */ MastercardFleetFuelBrand["ESSO_EU"] = "ESSO_EU";
    /** Exxon */ MastercardFleetFuelBrand["EXXON"] = "EXXON";
    /** ExxonMobil */ MastercardFleetFuelBrand["EXXON_MOBIL"] = "EXXON_MOBIL";
    /** Family Express */ MastercardFleetFuelBrand["FAMILY"] = "FAMILY";
    /** Fas Gas Oil */ MastercardFleetFuelBrand["FAS"] = "FAS";
    /** Fina Inc. */ MastercardFleetFuelBrand["FINA"] = "FINA";
    /** Fina */ MastercardFleetFuelBrand["FINA_EU"] = "FINA_EU";
    /** FKG Oil */ MastercardFleetFuelBrand["FKG"] = "FKG";
    /** Flare */ MastercardFleetFuelBrand["FLARE"] = "FLARE";
    /** Flying J Inc. */ MastercardFleetFuelBrand["FLYING_J"] = "FLYING_J";
    /** Gas America */ MastercardFleetFuelBrand["GAS_AMERICA"] = "GAS_AMERICA";
    /** Gate Petroleum */ MastercardFleetFuelBrand["GATE"] = "GATE";
    /** Getty Petroleum */ MastercardFleetFuelBrand["GETTY"] = "GETTY";
    /** Giant Eagle */ MastercardFleetFuelBrand["GIANT_EAGLE"] = "GIANT_EAGLE";
    /** GrowMark, Inc. */ MastercardFleetFuelBrand["GROWMARK"] = "GROWMARK";
    /** Gulf */ MastercardFleetFuelBrand["GULF"] = "GULF";
    /** Gulf Canada */ MastercardFleetFuelBrand["GULF_CA"] = "GULF_CA";
    /** Gulf (Chevron) */ MastercardFleetFuelBrand["GULF_CHEVRON"] = "GULF_CHEVRON";
    /** Handy Way Food */ MastercardFleetFuelBrand["HANDY_WAY"] = "HANDY_WAY";
    /** Heron */ MastercardFleetFuelBrand["HERON"] = "HERON";
    /** Amerada Hess */ MastercardFleetFuelBrand["HESS"] = "HESS";
    /** Holiday Stores */ MastercardFleetFuelBrand["HOLIDAY"] = "HOLIDAY";
    /** Home Depot */ MastercardFleetFuelBrand["HOME_DEPOT"] = "HOME_DEPOT";
    /** Martin & Bailey Inc. (DBA Huck’s) */ MastercardFleetFuelBrand["HUCKS"] = "HUCKS";
    /** Husky */ MastercardFleetFuelBrand["HUSKY"] = "HUSKY";
    /** Hyvee’s */ MastercardFleetFuelBrand["HYVEES"] = "HYVEES";
    /** Irving Oil */ MastercardFleetFuelBrand["IRVING"] = "IRVING";
    /** Irving Canada */ MastercardFleetFuelBrand["IRVING_CA"] = "IRVING_CA";
    /** Jet (Conoco) */ MastercardFleetFuelBrand["JET"] = "JET";
    /** J. Sainsbury */ MastercardFleetFuelBrand["JSAINSBURY"] = "JSAINSBURY";
    /** Krogers */ MastercardFleetFuelBrand["KROGER"] = "KROGER";
    /** Kuwait */ MastercardFleetFuelBrand["KUWAIT"] = "KUWAIT";
    /** United Refining (Kwik Fill) */ MastercardFleetFuelBrand["KWIK_FILL"] = "KWIK_FILL";
    /** Kwik Trip Inc. */ MastercardFleetFuelBrand["KWIK_TRIP"] = "KWIK_TRIP";
    /** Lassus */ MastercardFleetFuelBrand["LASSUS"] = "LASSUS";
    /** Love’s Country Stores */ MastercardFleetFuelBrand["LOVES"] = "LOVES";
    /** Mapco Express Inc. */ MastercardFleetFuelBrand["MAPCO"] = "MAPCO";
    /** Marathon Oil */ MastercardFleetFuelBrand["MARATHON"] = "MARATHON";
    /** Maxol */ MastercardFleetFuelBrand["MAXOL"] = "MAXOL";
    /** Meineke */ MastercardFleetFuelBrand["MEINEKE"] = "MEINEKE";
    /** MFA */ MastercardFleetFuelBrand["MFA"] = "MFA";
    /** Mohawk */ MastercardFleetFuelBrand["MOHAWK"] = "MOHAWK";
    /** W M Morrison */ MastercardFleetFuelBrand["MORRISON"] = "MORRISON";
    /** Mr. Gas */ MastercardFleetFuelBrand["MR_GAS"] = "MR_GAS";
    /** Murco */ MastercardFleetFuelBrand["MURCO"] = "MURCO";
    /** Murphy Oil USA Inc. */ MastercardFleetFuelBrand["MURPHY"] = "MURPHY";
    /** Murphy Oil Canada */ MastercardFleetFuelBrand["MURPHY_CA"] = "MURPHY_CA";
    /** Nexcom */ MastercardFleetFuelBrand["NEXCOM"] = "NEXCOM";
    /** Nordstrom Oil */ MastercardFleetFuelBrand["NORDSTROM"] = "NORDSTROM";
    /** Olco */ MastercardFleetFuelBrand["OLCO"] = "OLCO";
    /** PDQ Store */ MastercardFleetFuelBrand["PDQ"] = "PDQ";
    /** Pennzoil Products Inc. */ MastercardFleetFuelBrand["PENNZOIL"] = "PENNZOIL";
    /** Petro */ MastercardFleetFuelBrand["PETRO"] = "PETRO";
    /** PetroCanada */ MastercardFleetFuelBrand["PETROCANADA"] = "PETROCANADA";
    /** Petro-T */ MastercardFleetFuelBrand["PETRO_T"] = "PETRO_T";
    /** Phillips */ MastercardFleetFuelBrand["PHILLIPS"] = "PHILLIPS";
    /** Pilot */ MastercardFleetFuelBrand["PILOT"] = "PILOT";
    /** Pioneer */ MastercardFleetFuelBrand["PIONEER"] = "PIONEER";
    /** Pioneer */ MastercardFleetFuelBrand["PIONEER_EU"] = "PIONEER_EU";
    /** Pure Oil */ MastercardFleetFuelBrand["PURE"] = "PURE";
    /** Quaker State */ MastercardFleetFuelBrand["QUAKER_STATE"] = "QUAKER_STATE";
    /** Quarles Oil */ MastercardFleetFuelBrand["QUARLES"] = "QUARLES";
    /** Quik Trip */ MastercardFleetFuelBrand["QUIK_TRIP"] = "QUIK_TRIP";
    /** RaceTrac Petroleum Inc. */ MastercardFleetFuelBrand["RACETRAC"] = "RACETRAC";
    /** Raceway Petroleum */ MastercardFleetFuelBrand["RACEWAY"] = "RACEWAY";
    /** Repsol */ MastercardFleetFuelBrand["REPSOL"] = "REPSOL";
    /** Rudy */ MastercardFleetFuelBrand["RUDY"] = "RUDY";
    /** Safeway */ MastercardFleetFuelBrand["SAFEWAY"] = "SAFEWAY";
    /** 7-Eleven */ MastercardFleetFuelBrand["SEVEN_ELEVEN"] = "SEVEN_ELEVEN";
    /** Seven-Eleven */ MastercardFleetFuelBrand["SEVEN_ELEVEN_CA"] = "SEVEN_ELEVEN_CA";
    /** Sheetz */ MastercardFleetFuelBrand["SHEETZ"] = "SHEETZ";
    /** Shell Oil */ MastercardFleetFuelBrand["SHELL"] = "SHELL";
    /** Shell Canada */ MastercardFleetFuelBrand["SHELL_CA"] = "SHELL_CA";
    /** Shell */ MastercardFleetFuelBrand["SHELL_EU"] = "SHELL_EU";
    /** Sinclair Oil */ MastercardFleetFuelBrand["SINCLAIR"] = "SINCLAIR";
    /** Federated Co-op (Sonic) */ MastercardFleetFuelBrand["SONIC"] = "SONIC";
    /** Southland Oil */ MastercardFleetFuelBrand["SOUTHLAND"] = "SOUTHLAND";
    /** SPAR */ MastercardFleetFuelBrand["SPAR"] = "SPAR";
    /** Speedway */ MastercardFleetFuelBrand["SPEEDWAY"] = "SPEEDWAY";
    /** Sun Company Inc. */ MastercardFleetFuelBrand["SUN"] = "SUN";
    /** Suncor (Sunoco Canada) */ MastercardFleetFuelBrand["SUNOCO_CA"] = "SUNOCO_CA";
    /** Travel Centers of America */ MastercardFleetFuelBrand["TA"] = "TA";
    /** Tempo */ MastercardFleetFuelBrand["TEMPO"] = "TEMPO";
    /** Tesco */ MastercardFleetFuelBrand["TESCO_EU"] = "TESCO_EU";
    /** Tesoro Alaska */ MastercardFleetFuelBrand["TESORO_AK"] = "TESORO_AK";
    /** Texaco */ MastercardFleetFuelBrand["TEXACO"] = "TEXACO";
    /** Texaco */ MastercardFleetFuelBrand["TEXACO_EU"] = "TEXACO_EU";
    /** The Pantry, Inc. */ MastercardFleetFuelBrand["THE_PANTRY"] = "THE_PANTRY";
    /** Thornton Oil */ MastercardFleetFuelBrand["THORNTON"] = "THORNTON";
    /** Tosco */ MastercardFleetFuelBrand["TOSCO"] = "TOSCO";
    /** Total */ MastercardFleetFuelBrand["TOTAL"] = "TOTAL";
    /** UK */ MastercardFleetFuelBrand["UK"] = "UK";
    /** Ultramar Canada */ MastercardFleetFuelBrand["ULTRAMAR"] = "ULTRAMAR";
    /** Unbranded/Unassigned */ MastercardFleetFuelBrand["UNBRANDED"] = "UNBRANDED";
    /** Union 76 */ MastercardFleetFuelBrand["UNION_76"] = "UNION_76";
    /** United Dairy Farmer */ MastercardFleetFuelBrand["UNITED_DAIRY"] = "UNITED_DAIRY";
    /** USA Petroleum */ MastercardFleetFuelBrand["USA_PETROLEUM"] = "USA_PETROLEUM";
    /** US Oil */ MastercardFleetFuelBrand["US_OIL"] = "US_OIL";
    /** Valvoline */ MastercardFleetFuelBrand["VALVOLINE"] = "VALVOLINE";
    /** VG */ MastercardFleetFuelBrand["VG"] = "VG";
    /** Warren Equities */ MastercardFleetFuelBrand["WARREN_EQUITIES"] = "WARREN_EQUITIES";
    /** Wawa */ MastercardFleetFuelBrand["WAWA"] = "WAWA";
    /** Western Energetix */ MastercardFleetFuelBrand["WESTERN_ENERGETIX"] = "WESTERN_ENERGETIX";
    /** Wilco */ MastercardFleetFuelBrand["WILCO"] = "WILCO";
    /** Zions */ MastercardFleetFuelBrand["ZIONS"] = "ZIONS";
    return MastercardFleetFuelBrand;
}({});
var $2f53fee15f29b056$export$7696771b2450bb82 = /*#__PURE__*/ function(MastercardFleetFuelProductCode) {
    /** Additive Dosage */ MastercardFleetFuelProductCode["ADDITIVE_DOSAGE"] = "ADDITIVE_DOSAGE";
    /** Additized Diesel #2 */ MastercardFleetFuelProductCode["ADDITIZED_DIESEL_2"] = "ADDITIZED_DIESEL_2";
    /** Additized Diesel #3 */ MastercardFleetFuelProductCode["ADDITIZED_DIESEL_3"] = "ADDITIZED_DIESEL_3";
    /** Aviation Biofuel (Gasoline) */ MastercardFleetFuelProductCode["AVIATION_BIOFUEL"] = "AVIATION_BIOFUEL";
    /** Aviation Fuel 4 */ MastercardFleetFuelProductCode["AVIATION_FUEL_4"] = "AVIATION_FUEL_4";
    /** Aviation Fuel 5 */ MastercardFleetFuelProductCode["AVIATION_FUEL_5"] = "AVIATION_FUEL_5";
    /** Aviation Fuel JP8 */ MastercardFleetFuelProductCode["AVIATION_FUEL_JP8"] = "AVIATION_FUEL_JP8";
    /** Aviation Fuel Premium */ MastercardFleetFuelProductCode["AVIATION_FUEL_PREMIUM"] = "AVIATION_FUEL_PREMIUM";
    /** Aviation Fuel Regular */ MastercardFleetFuelProductCode["AVIATION_FUEL_REGULAR"] = "AVIATION_FUEL_REGULAR";
    /** B1 Diesel Blend 1% Biodiesel */ MastercardFleetFuelProductCode["B1_DIESEL_BLEND"] = "B1_DIESEL_BLEND";
    /** B2 Diesel Blend 2% Biodiesel */ MastercardFleetFuelProductCode["B2_DIESEL_BLEND"] = "B2_DIESEL_BLEND";
    /** B5 Diesel Blend 5% Biodiesel */ MastercardFleetFuelProductCode["B5_DIESEL_BLEND"] = "B5_DIESEL_BLEND";
    /** B10 Diesel Blend 10% Biodiesel */ MastercardFleetFuelProductCode["B10_DIESEL_BLEND"] = "B10_DIESEL_BLEND";
    /** B11 Diesel Blend 11% Biodiesel */ MastercardFleetFuelProductCode["B11_DIESEL_BLEND"] = "B11_DIESEL_BLEND";
    /** B15 Diesel Blend 15% Biodiesel */ MastercardFleetFuelProductCode["B15_DIESEL_BLEND"] = "B15_DIESEL_BLEND";
    /** B20 Diesel Blend 20% Biodiesel */ MastercardFleetFuelProductCode["B20_DIESEL_BLEND"] = "B20_DIESEL_BLEND";
    /** B75 Diesel Blend 75% Biodiesel */ MastercardFleetFuelProductCode["B75_DIESEL_BLEND"] = "B75_DIESEL_BLEND";
    /** B99 Diesel Blend 99% Biodiesel */ MastercardFleetFuelProductCode["B99_DIESEL_BLEND"] = "B99_DIESEL_BLEND";
    /** B100 Diesel Blend 100% Biodiesel */ MastercardFleetFuelProductCode["B100_DIESEL_BLEND"] = "B100_DIESEL_BLEND";
    /** Biodiesel Blend 1% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_1_OFF_ROAD"] = "BIODIESEL_BLEND_1_OFF_ROAD";
    /** Biodiesel Blend 2% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_2_OFF_ROAD"] = "BIODIESEL_BLEND_2_OFF_ROAD";
    /** Biodiesel Blend 5% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_5_OFF_ROAD"] = "BIODIESEL_BLEND_5_OFF_ROAD";
    /** Biodiesel Blend 10% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_10_OFF_ROAD"] = "BIODIESEL_BLEND_10_OFF_ROAD";
    /** Biodiesel Blend 11% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_11_OFF_ROAD"] = "BIODIESEL_BLEND_11_OFF_ROAD";
    /** Biodiesel Blend 15% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_15_OFF_ROAD"] = "BIODIESEL_BLEND_15_OFF_ROAD";
    /** Biodiesel Blend 20% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_20_OFF_ROAD"] = "BIODIESEL_BLEND_20_OFF_ROAD";
    /** Biodiesel Blend 75% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_75_OFF_ROAD"] = "BIODIESEL_BLEND_75_OFF_ROAD";
    /** Biodiesel Blend 99% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_99_OFF_ROAD"] = "BIODIESEL_BLEND_99_OFF_ROAD";
    /** Biodiesel Blend 100% Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_100_OFF_ROAD"] = "BIODIESEL_BLEND_100_OFF_ROAD";
    /** Biodiesel Blend Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["BIODIESEL_BLEND_OFF_ROAD"] = "BIODIESEL_BLEND_OFF_ROAD";
    /** Biojet (Diesel) */ MastercardFleetFuelProductCode["BIOJET"] = "BIOJET";
    /** Blended Diesel (#1 and #2) */ MastercardFleetFuelProductCode["BLENDED_DIESEL"] = "BLENDED_DIESEL";
    /** Compressed Natural Gas */ MastercardFleetFuelProductCode["COMPRESSED_NATURAL_GAS"] = "COMPRESSED_NATURAL_GAS";
    /** DEF (Diesel Exhaust Fluid) */ MastercardFleetFuelProductCode["DEF"] = "DEF";
    /** Diesel #1 Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_1_OFF_ROAD"] = "DIESEL_1_OFF_ROAD";
    /** Diesel #1 Premium Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_1_PREMIUM_OFF_ROAD"] = "DIESEL_1_PREMIUM_OFF_ROAD";
    /** Diesel #2 Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_2_OFF_ROAD"] = "DIESEL_2_OFF_ROAD";
    /** Diesel #2 Premium Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_2_PREMIUM_OFF_ROAD"] = "DIESEL_2_PREMIUM_OFF_ROAD";
    /** Diesel Off-Road (#1 and #2 Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE"] = "DIESEL_OFF_ROAD_1_AND_2_NON_TAXABLE";
    /** Diesel Off-Road (Non-Taxable) */ MastercardFleetFuelProductCode["DIESEL_OFF_ROAD_NON_TAXABLE"] = "DIESEL_OFF_ROAD_NON_TAXABLE";
    /** <Deprecated> Ethanol (5.7% blend) */ MastercardFleetFuelProductCode["ETHANOL_5_7_BLEND"] = "ETHANOL_5_7_BLEND";
    /** <Deprecated> Ethanol (7.7% blend) */ MastercardFleetFuelProductCode["ETHANOL_7_7_BLEND"] = "ETHANOL_7_7_BLEND";
    /** Ethanol Blends E16-E84 */ MastercardFleetFuelProductCode["ETHANOL_BLENDS_E16_E84"] = "ETHANOL_BLENDS_E16_E84";
    /** EVC-1 – Level 1 charge = 110v 15 amp */ MastercardFleetFuelProductCode["EVC_LEVEL_1_CHARGE"] = "EVC_LEVEL_1_CHARGE";
    /** EVC-2 – Level 2 charge = 240v 15-40 amp */ MastercardFleetFuelProductCode["EVC_LEVEL_2_CHARGE"] = "EVC_LEVEL_2_CHARGE";
    /** EVC-3 – Level 3 charge = 480v 3 phase charge */ MastercardFleetFuelProductCode["EVC_LEVEL_3_CHARGE"] = "EVC_LEVEL_3_CHARGE";
    /** E-85 */ MastercardFleetFuelProductCode["E_85"] = "E_85";
    /** Green Gasoline Mid/Plus (Plant based not petroleum based) */ MastercardFleetFuelProductCode["GREEN_GASOLINE_MID_PLUS"] = "GREEN_GASOLINE_MID_PLUS";
    /** Green Gasoline Premium/Super (Plant based not petroleum based) */ MastercardFleetFuelProductCode["GREEN_GASOLINE_PREMIUM_SUPER"] = "GREEN_GASOLINE_PREMIUM_SUPER";
    /** Green Gasoline Regular (Plant based not petroleum based) */ MastercardFleetFuelProductCode["GREEN_GASOLINE_REGULAR"] = "GREEN_GASOLINE_REGULAR";
    /** Heating Oil */ MastercardFleetFuelProductCode["HEATING_OIL"] = "HEATING_OIL";
    /** Hydrogen H35 */ MastercardFleetFuelProductCode["HYDROGEN_H35"] = "HYDROGEN_H35";
    /** Hydrogen H70 */ MastercardFleetFuelProductCode["HYDROGEN_H70"] = "HYDROGEN_H70";
    /** Jet Fuel */ MastercardFleetFuelProductCode["JET_FUEL"] = "JET_FUEL";
    /** Kerosene – Low Sulfur */ MastercardFleetFuelProductCode["KEROSENE_LOW_SULFUR"] = "KEROSENE_LOW_SULFUR";
    /** Kerosene – Low Sulfur (Non-Taxable) */ MastercardFleetFuelProductCode["KEROSENE_LOW_SULFUR_NON_TAXABLE"] = "KEROSENE_LOW_SULFUR_NON_TAXABLE";
    /** Kerosene – Ultra Low Sulfur */ MastercardFleetFuelProductCode["KEROSENE_ULTRA_LOW_SULFUR"] = "KEROSENE_ULTRA_LOW_SULFUR";
    /** Kerosene – Ultra Low Sulfur (Non-Taxable) */ MastercardFleetFuelProductCode["KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE"] = "KEROSENE_ULTRA_LOW_SULFUR_NON_TAXABLE";
    /** Liquid Natural Gas */ MastercardFleetFuelProductCode["LIQUID_NATURAL_GAS"] = "LIQUID_NATURAL_GAS";
    /** Liquid Propane Gas */ MastercardFleetFuelProductCode["LIQUID_PROPANE_GAS"] = "LIQUID_PROPANE_GAS";
    /** Low Octane UNL */ MastercardFleetFuelProductCode["LOW_OCTANE_UNL"] = "LOW_OCTANE_UNL";
    /** Marine Diesel */ MastercardFleetFuelProductCode["MARINE_DIESEL"] = "MARINE_DIESEL";
    /** Marine Fuel 1 */ MastercardFleetFuelProductCode["MARINE_FUEL_1"] = "MARINE_FUEL_1";
    /** Marine Fuel 2 */ MastercardFleetFuelProductCode["MARINE_FUEL_2"] = "MARINE_FUEL_2";
    /** Marine Fuel 3 */ MastercardFleetFuelProductCode["MARINE_FUEL_3"] = "MARINE_FUEL_3";
    /** Marine Fuel 4 */ MastercardFleetFuelProductCode["MARINE_FUEL_4"] = "MARINE_FUEL_4";
    /** Marine Fuel 5 */ MastercardFleetFuelProductCode["MARINE_FUEL_5"] = "MARINE_FUEL_5";
    /** Marine - Other */ MastercardFleetFuelProductCode["MARINE_OTHER"] = "MARINE_OTHER";
    /** Mid/Plus */ MastercardFleetFuelProductCode["MID_PLUS"] = "MID_PLUS";
    /** Mid/Plus 2 */ MastercardFleetFuelProductCode["MID_PLUS_2"] = "MID_PLUS_2";
    /** Mid/Plus 2 (10% Blend) */ MastercardFleetFuelProductCode["MID_PLUS_2_10_PERCENT_BLEND"] = "MID_PLUS_2_10_PERCENT_BLEND";
    /** Mid/Plus Ethanol 2 (15% Blend) */ MastercardFleetFuelProductCode["MID_PLUS_ETHANOL_2_10_BLEND"] = "MID_PLUS_ETHANOL_2_10_BLEND";
    /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */ MastercardFleetFuelProductCode["MID_PLUS_ETHANOL_5_7_BLEND"] = "MID_PLUS_ETHANOL_5_7_BLEND";
    /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */ MastercardFleetFuelProductCode["MID_PLUS_ETHANOL_7_7_BLEND"] = "MID_PLUS_ETHANOL_7_7_BLEND";
    /** Mid/Plus Ethanol (10% Blend) */ MastercardFleetFuelProductCode["MID_PLUS_ETHANOL_10_BLEND"] = "MID_PLUS_ETHANOL_10_BLEND";
    /** Mid/Plus Ethanol (15% Blend) */ MastercardFleetFuelProductCode["MID_PLUS_ETHANOL_15_BLEND"] = "MID_PLUS_ETHANOL_15_BLEND";
    /** Miscellaneous Aviation Fuel */ MastercardFleetFuelProductCode["MISCELLANEOUS_AVIATION_FUEL"] = "MISCELLANEOUS_AVIATION_FUEL";
    /** Miscellaneous Fuel */ MastercardFleetFuelProductCode["MISCELLANEOUS_FUEL"] = "MISCELLANEOUS_FUEL";
    /** Miscellaneous Marine Fuel */ MastercardFleetFuelProductCode["MISCELLANEOUS_MARINE_FUEL"] = "MISCELLANEOUS_MARINE_FUEL";
    /** Miscellaneous Other Fuel */ MastercardFleetFuelProductCode["MISCELLANEOUS_OTHER_FUEL"] = "MISCELLANEOUS_OTHER_FUEL";
    /** Off-Road Mid/Plus (Non-Taxable) */ MastercardFleetFuelProductCode["OFF_ROAD_MID_PLUS"] = "OFF_ROAD_MID_PLUS";
    /** Off-Road Mid/Plus 2 (Non-Taxable) */ MastercardFleetFuelProductCode["OFF_ROAD_MID_PLUS_2"] = "OFF_ROAD_MID_PLUS_2";
    /** Off-Road Premium/Super (Non-Taxable) */ MastercardFleetFuelProductCode["OFF_ROAD_PREMIUM_SUPER"] = "OFF_ROAD_PREMIUM_SUPER";
    /** Off-Road Premium/Super 2 (Non-Taxable) */ MastercardFleetFuelProductCode["OFF_ROAD_PREMIUM_SUPER_2"] = "OFF_ROAD_PREMIUM_SUPER_2";
    /** Off-Road Regular (Non-Taxable) */ MastercardFleetFuelProductCode["OFF_ROAD_REGULAR"] = "OFF_ROAD_REGULAR";
    /** Other Fuel (Non-Taxable) */ MastercardFleetFuelProductCode["OTHER_FUEL"] = "OTHER_FUEL";
    /** Premium Diesel #1 */ MastercardFleetFuelProductCode["PREMIUM_DIESEL_1"] = "PREMIUM_DIESEL_1";
    /** Premium Diesel #2 */ MastercardFleetFuelProductCode["PREMIUM_DIESEL_2"] = "PREMIUM_DIESEL_2";
    /** Premium Diesel Blend <20% Biodiesel */ MastercardFleetFuelProductCode["PREMIUM_DIESEL_BLEND_1"] = "PREMIUM_DIESEL_BLEND_1";
    /** Premium Diesel Blend >= 20% Biodiesel */ MastercardFleetFuelProductCode["PREMIUM_DIESEL_BLEND_2"] = "PREMIUM_DIESEL_BLEND_2";
    /** Premium/Super */ MastercardFleetFuelProductCode["PREMIUM_SUPER"] = "PREMIUM_SUPER";
    /** Premium/Super 2 */ MastercardFleetFuelProductCode["PREMIUM_SUPER_2"] = "PREMIUM_SUPER_2";
    /** Premium/Super 2 (10% Blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_2_10_BLEND"] = "PREMIUM_SUPER_2_10_BLEND";
    /** Premium/Super Ethanol 2 (15% Blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_ETHANOL_2_10_BLEND"] = "PREMIUM_SUPER_ETHANOL_2_10_BLEND";
    /** <Deprecated> Premium/Super Ethanol (5.7% blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_ETHANOL_5_7_BLEND"] = "PREMIUM_SUPER_ETHANOL_5_7_BLEND";
    /** <Deprecated> Premium/Super Ethanol (7.7% Blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_ETHANOL_7_7_BLEND"] = "PREMIUM_SUPER_ETHANOL_7_7_BLEND";
    /** Premium/Super Ethanol (10% Blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_ETHANOL_10_BLEND"] = "PREMIUM_SUPER_ETHANOL_10_BLEND";
    /** Premium/Super Ethanol (15% Blend) */ MastercardFleetFuelProductCode["PREMIUM_SUPER_ETHANOL_15_BLEND"] = "PREMIUM_SUPER_ETHANOL_15_BLEND";
    /** Racing Fuel */ MastercardFleetFuelProductCode["RACING_FUEL"] = "RACING_FUEL";
    /** Recreational Fuel (90 Octane) */ MastercardFleetFuelProductCode["RECREATIONAL_FUEL"] = "RECREATIONAL_FUEL";
    /** Reformulated 1 */ MastercardFleetFuelProductCode["REFORMULATED_1"] = "REFORMULATED_1";
    /** Reformulated 2 */ MastercardFleetFuelProductCode["REFORMULATED_2"] = "REFORMULATED_2";
    /** Reformulated 3 */ MastercardFleetFuelProductCode["REFORMULATED_3"] = "REFORMULATED_3";
    /** Reformulated 4 */ MastercardFleetFuelProductCode["REFORMULATED_4"] = "REFORMULATED_4";
    /** Reformulated 5 */ MastercardFleetFuelProductCode["REFORMULATED_5"] = "REFORMULATED_5";
    /** Regular */ MastercardFleetFuelProductCode["REGULAR"] = "REGULAR";
    /** Regular Diesel #1 */ MastercardFleetFuelProductCode["REGULAR_DIESEL_1"] = "REGULAR_DIESEL_1";
    /** Regular Diesel #2 */ MastercardFleetFuelProductCode["REGULAR_DIESEL_2"] = "REGULAR_DIESEL_2";
    /** Regular Ethanol (10% Blend) */ MastercardFleetFuelProductCode["REGULAR_ETHANOL_10_BLEND"] = "REGULAR_ETHANOL_10_BLEND";
    /** Regular Ethanol (15% Blend) */ MastercardFleetFuelProductCode["REGULAR_ETHANOL_15_BLEND"] = "REGULAR_ETHANOL_15_BLEND";
    /** Renewable Diesel (>=R95) (meets ASTM D975 in US / EN 590 in Europe) */ MastercardFleetFuelProductCode["RENEWABLE_DIESEL"] = "RENEWABLE_DIESEL";
    /** Renewable Diesel (Biodiesel 6%-20%) (meets ASTM D7467 in US) */ MastercardFleetFuelProductCode["RENEWABLE_DIESEL_BIODIESEL"] = "RENEWABLE_DIESEL_BIODIESEL";
    /** Renewable Diesel (Biodiesel 6%-20%) Off-Road (Non-taxable) (meets ASTM D7467 in US) */ MastercardFleetFuelProductCode["RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD"] = "RENEWABLE_DIESEL_BIODIESEL_OFF_ROAD";
    /** Renewable Diesel (>=R95) Off-Road (Non-Taxable) (meets ASTM D975 in US / EN 590 in Europe) */ MastercardFleetFuelProductCode["RENEWABLE_DIESEL_OFF_ROAD"] = "RENEWABLE_DIESEL_OFF_ROAD";
    /** Undefined Fuel - Reserved for Conexxus Future */ MastercardFleetFuelProductCode["UNDEFINED_FUEL"] = "UNDEFINED_FUEL";
    /** White Gas */ MastercardFleetFuelProductCode["WHITE_GAS"] = "WHITE_GAS";
    return MastercardFleetFuelProductCode;
}({});
var $2f53fee15f29b056$export$7a012b019d3a82ef = /*#__PURE__*/ function(MastercardFleetFuelServiceType) {
    /** Full service */ MastercardFleetFuelServiceType["FULL_SERVICE"] = "FULL_SERVICE";
    /** Only non-fuel products being purchased */ MastercardFleetFuelServiceType["ONLY_NON_FUEL_PRODUCTS"] = "ONLY_NON_FUEL_PRODUCTS";
    /** Self-service */ MastercardFleetFuelServiceType["SELF_SERVICE"] = "SELF_SERVICE";
    /** Undefined */ MastercardFleetFuelServiceType["UNDEFINED"] = "UNDEFINED";
    return MastercardFleetFuelServiceType;
}({});
var $2f53fee15f29b056$export$2f55741d9be3956e = /*#__PURE__*/ function(MastercardFleetNonFuelProductCode) {
    /** AC Parts */ MastercardFleetNonFuelProductCode["AC_PARTS"] = "AC_PARTS";
    /** Aircraft Accessories */ MastercardFleetNonFuelProductCode["AIRCRAFT_ACCESSORIES"] = "AIRCRAFT_ACCESSORIES";
    /** Aircraft Cleaning */ MastercardFleetNonFuelProductCode["AIRCRAFT_CLEANING"] = "AIRCRAFT_CLEANING";
    /** Aircraft Fuel Additive */ MastercardFleetNonFuelProductCode["AIRCRAFT_FUEL_ADDITIVE"] = "AIRCRAFT_FUEL_ADDITIVE";
    /** Aircraft Ground Handling */ MastercardFleetNonFuelProductCode["AIRCRAFT_GROUND_HANDLING"] = "AIRCRAFT_GROUND_HANDLING";
    /** Aircraft Ground Power Unit */ MastercardFleetNonFuelProductCode["AIRCRAFT_GROUND_POWER_UNIT"] = "AIRCRAFT_GROUND_POWER_UNIT";
    /** Aircraft Labor */ MastercardFleetNonFuelProductCode["AIRCRAFT_LABOR"] = "AIRCRAFT_LABOR";
    /** Aircraft Maintenance */ MastercardFleetNonFuelProductCode["AIRCRAFT_MAINTENANCE"] = "AIRCRAFT_MAINTENANCE";
    /** Aircraft Parking Fees */ MastercardFleetNonFuelProductCode["AIRCRAFT_PARKING_FEES"] = "AIRCRAFT_PARKING_FEES";
    /** Aircraft Rental */ MastercardFleetNonFuelProductCode["AIRCRAFT_RENTAL"] = "AIRCRAFT_RENTAL";
    /** Aircraft Sanitation Fees */ MastercardFleetNonFuelProductCode["AIRCRAFT_SANITATION_FEES"] = "AIRCRAFT_SANITATION_FEES";
    /** Aircraft Service */ MastercardFleetNonFuelProductCode["AIRCRAFT_SERVICE"] = "AIRCRAFT_SERVICE";
    /** Aircraft Tie Down Fees */ MastercardFleetNonFuelProductCode["AIRCRAFT_TIE_DOWN_FEES"] = "AIRCRAFT_TIE_DOWN_FEES";
    /** Aircraft Work Order */ MastercardFleetNonFuelProductCode["AIRCRAFT_WORK_ORDER"] = "AIRCRAFT_WORK_ORDER";
    /** Airport Fees */ MastercardFleetNonFuelProductCode["AIRPORT_FEES"] = "AIRPORT_FEES";
    /** Air Conditioning Service */ MastercardFleetNonFuelProductCode["AIR_CONDITIONING_SERVICE"] = "AIR_CONDITIONING_SERVICE";
    /** Air Filter */ MastercardFleetNonFuelProductCode["AIR_FILTER"] = "AIR_FILTER";
    /** Alternative Snacks */ MastercardFleetNonFuelProductCode["ALTERNATIVE_SNACKS"] = "ALTERNATIVE_SNACKS";
    /** Anti-Freeze */ MastercardFleetNonFuelProductCode["ANTI_FREEZE"] = "ANTI_FREEZE";
    /** AvGas Federal Excise Tax */ MastercardFleetNonFuelProductCode["AVGAS_FEDERAL_EXCISE_TAX"] = "AVGAS_FEDERAL_EXCISE_TAX";
    /** Batteries */ MastercardFleetNonFuelProductCode["BATTERIES"] = "BATTERIES";
    /** Beer - Alcoholic */ MastercardFleetNonFuelProductCode["BEER_ALCOHOLIC"] = "BEER_ALCOHOLIC";
    /** Beer - Non-Alcoholic */ MastercardFleetNonFuelProductCode["BEER_NON_ALCOHOLIC"] = "BEER_NON_ALCOHOLIC";
    /** Body Work */ MastercardFleetNonFuelProductCode["BODY_WORK"] = "BODY_WORK";
    /** Brake Fluid */ MastercardFleetNonFuelProductCode["BRAKE_FLUID"] = "BRAKE_FLUID";
    /** Brake Service */ MastercardFleetNonFuelProductCode["BRAKE_SERVICE"] = "BRAKE_SERVICE";
    /** Bread - Packaged */ MastercardFleetNonFuelProductCode["BREAD_PACKAGED"] = "BREAD_PACKAGED";
    /** Call Out Fee */ MastercardFleetNonFuelProductCode["CALL_OUT_FEE"] = "CALL_OUT_FEE";
    /** Cannabidiol (CBD) */ MastercardFleetNonFuelProductCode["CANNABIDIOL"] = "CANNABIDIOL";
    /** Cargo Handling */ MastercardFleetNonFuelProductCode["CARGO_HANDLING"] = "CARGO_HANDLING";
    /** Car Wash */ MastercardFleetNonFuelProductCode["CAR_WASH"] = "CAR_WASH";
    /** Cash Back */ MastercardFleetNonFuelProductCode["CASH_BACK"] = "CASH_BACK";
    /** Cash Back Fee */ MastercardFleetNonFuelProductCode["CASH_BACK_FEE"] = "CASH_BACK_FEE";
    /** Catering */ MastercardFleetNonFuelProductCode["CATERING"] = "CATERING";
    /** Charity */ MastercardFleetNonFuelProductCode["CHARITY"] = "CHARITY";
    /** Charter Fee */ MastercardFleetNonFuelProductCode["CHARTER_FEE"] = "CHARTER_FEE";
    /** Cigarettes */ MastercardFleetNonFuelProductCode["CIGARETTES"] = "CIGARETTES";
    /** Cold Dispensed Beverages */ MastercardFleetNonFuelProductCode["COLD_DISPENSED_BEVERAGES"] = "COLD_DISPENSED_BEVERAGES";
    /** Communication Fee */ MastercardFleetNonFuelProductCode["COMMUNICATION_FEE"] = "COMMUNICATION_FEE";
    /** Corrosion Inhibitor */ MastercardFleetNonFuelProductCode["CORROSION_INHIBITOR"] = "CORROSION_INHIBITOR";
    /** Coupon 1 */ MastercardFleetNonFuelProductCode["COUPON_1"] = "COUPON_1";
    /** Coupon 2 */ MastercardFleetNonFuelProductCode["COUPON_2"] = "COUPON_2";
    /** Coupon 3 */ MastercardFleetNonFuelProductCode["COUPON_3"] = "COUPON_3";
    /** Coupon 4 */ MastercardFleetNonFuelProductCode["COUPON_4"] = "COUPON_4";
    /** Coupon 5 */ MastercardFleetNonFuelProductCode["COUPON_5"] = "COUPON_5";
    /** Deli Items */ MastercardFleetNonFuelProductCode["DELI_ITEMS"] = "DELI_ITEMS";
    /** De-fuel */ MastercardFleetNonFuelProductCode["DE_FUEL"] = "DE_FUEL";
    /** De-icing */ MastercardFleetNonFuelProductCode["DE_ICING"] = "DE_ICING";
    /** Disable Device/Handset Lock */ MastercardFleetNonFuelProductCode["DISABLE_DEVICE_HANDSET_LOCK"] = "DISABLE_DEVICE_HANDSET_LOCK";
    /** Discount 1 */ MastercardFleetNonFuelProductCode["DISCOUNT_1"] = "DISCOUNT_1";
    /** Discount 2 */ MastercardFleetNonFuelProductCode["DISCOUNT_2"] = "DISCOUNT_2";
    /** Discount 3 */ MastercardFleetNonFuelProductCode["DISCOUNT_3"] = "DISCOUNT_3";
    /** Discount 4 */ MastercardFleetNonFuelProductCode["DISCOUNT_4"] = "DISCOUNT_4";
    /** Discount 5 */ MastercardFleetNonFuelProductCode["DISCOUNT_5"] = "DISCOUNT_5";
    /** Enable Device/Handset Unlock */ MastercardFleetNonFuelProductCode["ENABLE_DEVICE_HANDSET_UNLOCK"] = "ENABLE_DEVICE_HANDSET_UNLOCK";
    /** Engine Service */ MastercardFleetNonFuelProductCode["ENGINE_SERVICE"] = "ENGINE_SERVICE";
    /** EV Battery Exchanges */ MastercardFleetNonFuelProductCode["EV_BATTERY_EXCHANGES"] = "EV_BATTERY_EXCHANGES";
    /** EV Charging Fee */ MastercardFleetNonFuelProductCode["EV_CHARGING_FEE"] = "EV_CHARGING_FEE";
    /** Exhaust Service */ MastercardFleetNonFuelProductCode["EXHAUST_SERVICE"] = "EXHAUST_SERVICE";
    /** Federal Excise Tax (Tires) */ MastercardFleetNonFuelProductCode["FEDERAL_EXCISE_TAX_TIRES"] = "FEDERAL_EXCISE_TAX_TIRES";
    /** Fee 1 */ MastercardFleetNonFuelProductCode["FEE_1"] = "FEE_1";
    /** Fee 2 */ MastercardFleetNonFuelProductCode["FEE_2"] = "FEE_2";
    /** Fee 3 */ MastercardFleetNonFuelProductCode["FEE_3"] = "FEE_3";
    /** Fee 4 */ MastercardFleetNonFuelProductCode["FEE_4"] = "FEE_4";
    /** Fee 5 */ MastercardFleetNonFuelProductCode["FEE_5"] = "FEE_5";
    /** Financial Prepaid Card Activate */ MastercardFleetNonFuelProductCode["FINANCIAL_PREPAID_CARD_ACTIVATE"] = "FINANCIAL_PREPAID_CARD_ACTIVATE";
    /** Financial Prepaid Card Reload */ MastercardFleetNonFuelProductCode["FINANCIAL_PREPAID_CARD_RELOAD"] = "FINANCIAL_PREPAID_CARD_RELOAD";
    /** Flight Plans / Weather Brief */ MastercardFleetNonFuelProductCode["FLIGHT_PLANS_WEATHER_BRIEF"] = "FLIGHT_PLANS_WEATHER_BRIEF";
    /** Flow Fee */ MastercardFleetNonFuelProductCode["FLOW_FEE"] = "FLOW_FEE";
    /** Fluid Milk Products */ MastercardFleetNonFuelProductCode["FLUID_MILK_PRODUCTS"] = "FLUID_MILK_PRODUCTS";
    /** Frozen Dispensed Beverages */ MastercardFleetNonFuelProductCode["FROZEN_DISPENSED_BEVERAGES"] = "FROZEN_DISPENSED_BEVERAGES";
    /** Frozen Foods */ MastercardFleetNonFuelProductCode["FROZEN_FOODS"] = "FROZEN_FOODS";
    /** Fuel System */ MastercardFleetNonFuelProductCode["FUEL_SYSTEM"] = "FUEL_SYSTEM";
    /** General Alcohol */ MastercardFleetNonFuelProductCode["GENERAL_ALCOHOL"] = "GENERAL_ALCOHOL";
    /** General Automotive Merchandise */ MastercardFleetNonFuelProductCode["GENERAL_AUTOMOTIVE_MERCHANDISE"] = "GENERAL_AUTOMOTIVE_MERCHANDISE";
    /** General Candy */ MastercardFleetNonFuelProductCode["GENERAL_CANDY"] = "GENERAL_CANDY";
    /** General Dairy */ MastercardFleetNonFuelProductCode["GENERAL_DAIRY"] = "GENERAL_DAIRY";
    /** General Deli */ MastercardFleetNonFuelProductCode["GENERAL_DELI"] = "GENERAL_DELI";
    /** General Dispensed Beverage */ MastercardFleetNonFuelProductCode["GENERAL_DISPENSED_BEVERAGE"] = "GENERAL_DISPENSED_BEVERAGE";
    /** General Food service */ MastercardFleetNonFuelProductCode["GENERAL_FOOD_SERVICE"] = "GENERAL_FOOD_SERVICE";
    /** General Grocery */ MastercardFleetNonFuelProductCode["GENERAL_GROCERY"] = "GENERAL_GROCERY";
    /** General Health & Beauty Care */ MastercardFleetNonFuelProductCode["GENERAL_HEALTH_BEAUTY_CARE"] = "GENERAL_HEALTH_BEAUTY_CARE";
    /** General Ice */ MastercardFleetNonFuelProductCode["GENERAL_ICE"] = "GENERAL_ICE";
    /** General Lottery */ MastercardFleetNonFuelProductCode["GENERAL_LOTTERY"] = "GENERAL_LOTTERY";
    /** General Merchandise */ MastercardFleetNonFuelProductCode["GENERAL_MERCHANDISE"] = "GENERAL_MERCHANDISE";
    /** General Money Order */ MastercardFleetNonFuelProductCode["GENERAL_MONEY_ORDER"] = "GENERAL_MONEY_ORDER";
    /** General Packaged Beverage */ MastercardFleetNonFuelProductCode["GENERAL_PACKAGED_BEVERAGE"] = "GENERAL_PACKAGED_BEVERAGE";
    /** General Publications */ MastercardFleetNonFuelProductCode["GENERAL_PUBLICATIONS"] = "GENERAL_PUBLICATIONS";
    /** General Purpose Activate */ MastercardFleetNonFuelProductCode["GENERAL_PURPOSE_ACTIVATE"] = "GENERAL_PURPOSE_ACTIVATE";
    /** General Purpose Reload */ MastercardFleetNonFuelProductCode["GENERAL_PURPOSE_RELOAD"] = "GENERAL_PURPOSE_RELOAD";
    /** General Snacks */ MastercardFleetNonFuelProductCode["GENERAL_SNACKS"] = "GENERAL_SNACKS";
    /** General Store Service */ MastercardFleetNonFuelProductCode["GENERAL_STORE_SERVICE"] = "GENERAL_STORE_SERVICE";
    /** General Tobacco */ MastercardFleetNonFuelProductCode["GENERAL_TOBACCO"] = "GENERAL_TOBACCO";
    /** Gratuity */ MastercardFleetNonFuelProductCode["GRATUITY"] = "GRATUITY";
    /** Groceries - Edible */ MastercardFleetNonFuelProductCode["GROCERIES_EDIBLE"] = "GROCERIES_EDIBLE";
    /** Groceries - Non-Edible */ MastercardFleetNonFuelProductCode["GROCERIES_NON_EDIBLE"] = "GROCERIES_NON_EDIBLE";
    /** Groceries - Perishable */ MastercardFleetNonFuelProductCode["GROCERIES_PERISHABLE"] = "GROCERIES_PERISHABLE";
    /** Ground Equipment Service Fees */ MastercardFleetNonFuelProductCode["GROUND_EQUIPMENT_SERVICE_FEES"] = "GROUND_EQUIPMENT_SERVICE_FEES";
    /** GST/HST (Canadian)/VAT 1 */ MastercardFleetNonFuelProductCode["GST_HST_CANADIAN_VAT_1"] = "GST_HST_CANADIAN_VAT_1";
    /** Hangar Fee */ MastercardFleetNonFuelProductCode["HANGAR_FEE"] = "HANGAR_FEE";
    /** Home Delivery */ MastercardFleetNonFuelProductCode["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** Hoses */ MastercardFleetNonFuelProductCode["HOSES"] = "HOSES";
    /** Hot Dispensed Beverages */ MastercardFleetNonFuelProductCode["HOT_DISPENSED_BEVERAGES"] = "HOT_DISPENSED_BEVERAGES";
    /** Inspection */ MastercardFleetNonFuelProductCode["INSPECTION"] = "INSPECTION";
    /** Instruction Fee */ MastercardFleetNonFuelProductCode["INSTRUCTION_FEE"] = "INSTRUCTION_FEE";
    /** IT/Bladder */ MastercardFleetNonFuelProductCode["IT_BLADDER"] = "IT_BLADDER";
    /** Jet Federal Excise Tax */ MastercardFleetNonFuelProductCode["JET_FEDERAL_EXCISE_TAX"] = "JET_FEDERAL_EXCISE_TAX";
    /** Labor */ MastercardFleetNonFuelProductCode["LABOR"] = "LABOR";
    /** Lamps */ MastercardFleetNonFuelProductCode["LAMPS"] = "LAMPS";
    /** Landing Fee */ MastercardFleetNonFuelProductCode["LANDING_FEE"] = "LANDING_FEE";
    /** Launch Fee */ MastercardFleetNonFuelProductCode["LAUNCH_FEE"] = "LAUNCH_FEE";
    /** Liquor */ MastercardFleetNonFuelProductCode["LIQUOR"] = "LIQUOR";
    /** Local Discount 1 */ MastercardFleetNonFuelProductCode["LOCAL_DISCOUNT_1"] = "LOCAL_DISCOUNT_1";
    /** Local Discount 2 */ MastercardFleetNonFuelProductCode["LOCAL_DISCOUNT_2"] = "LOCAL_DISCOUNT_2";
    /** Local Discount 3 */ MastercardFleetNonFuelProductCode["LOCAL_DISCOUNT_3"] = "LOCAL_DISCOUNT_3";
    /** Local Discount 4 */ MastercardFleetNonFuelProductCode["LOCAL_DISCOUNT_4"] = "LOCAL_DISCOUNT_4";
    /** Local Discount 5 */ MastercardFleetNonFuelProductCode["LOCAL_DISCOUNT_5"] = "LOCAL_DISCOUNT_5";
    /** Lodging */ MastercardFleetNonFuelProductCode["LODGING"] = "LODGING";
    /** Lottery - Instant */ MastercardFleetNonFuelProductCode["LOTTERY_INSTANT"] = "LOTTERY_INSTANT";
    /** Lottery - Online */ MastercardFleetNonFuelProductCode["LOTTERY_ONLINE"] = "LOTTERY_ONLINE";
    /** Lottery - Other */ MastercardFleetNonFuelProductCode["LOTTERY_OTHER"] = "LOTTERY_OTHER";
    /** Lottery Pay Out - Instant */ MastercardFleetNonFuelProductCode["LOTTERY_PAY_OUT_INSTANT"] = "LOTTERY_PAY_OUT_INSTANT";
    /** Lottery Pay Out - Online */ MastercardFleetNonFuelProductCode["LOTTERY_PAY_OUT_ONLINE"] = "LOTTERY_PAY_OUT_ONLINE";
    /** Lottery Pay Out - Other */ MastercardFleetNonFuelProductCode["LOTTERY_PAY_OUT_OTHER"] = "LOTTERY_PAY_OUT_OTHER";
    /** Lube */ MastercardFleetNonFuelProductCode["LUBE"] = "LUBE";
    /** Marine Labor */ MastercardFleetNonFuelProductCode["MARINE_LABOR"] = "MARINE_LABOR";
    /** Marine Service */ MastercardFleetNonFuelProductCode["MARINE_SERVICE"] = "MARINE_SERVICE";
    /** Marine Work Order */ MastercardFleetNonFuelProductCode["MARINE_WORK_ORDER"] = "MARINE_WORK_ORDER";
    /** Membership/Loyalty */ MastercardFleetNonFuelProductCode["MEMBERSHIP_LOYALTY"] = "MEMBERSHIP_LOYALTY";
    /** Miscellaneous Administrative */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_ADMINISTRATIVE"] = "MISCELLANEOUS_ADMINISTRATIVE";
    /** Miscellaneous Aviation Products/Services */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES"] = "MISCELLANEOUS_AVIATION_PRODUCTS_SERVICES";
    /** Miscellaneous Aviation Tax */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_AVIATION_TAX"] = "MISCELLANEOUS_AVIATION_TAX";
    /** Miscellaneous Marine Products/Services */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_MARINE_PRODUCTS_SERVICES"] = "MISCELLANEOUS_MARINE_PRODUCTS_SERVICES";
    /** Miscellaneous Negative Administrative */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE"] = "MISCELLANEOUS_NEGATIVE_ADMINISTRATIVE";
    /** Miscellaneous Packaged Fuels */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_PACKAGED_FUELS"] = "MISCELLANEOUS_PACKAGED_FUELS";
    /** Miscellaneous Vehicle Products / Services */ MastercardFleetNonFuelProductCode["MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES"] = "MISCELLANEOUS_VEHICLE_PRODUCTS_SERVICES";
    /** Money Order - Dividend Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_DIVIDEND_CHECK"] = "MONEY_ORDER_DIVIDEND_CHECK";
    /** Money Order - Gift Certificate */ MastercardFleetNonFuelProductCode["MONEY_ORDER_GIFT_CERTIFICATE"] = "MONEY_ORDER_GIFT_CERTIFICATE";
    /** Money Order - Official Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_OFFICIAL_CHECK"] = "MONEY_ORDER_OFFICIAL_CHECK";
    /** Money Order - Payroll Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_PAYROLL_CHECK"] = "MONEY_ORDER_PAYROLL_CHECK";
    /** Money Order - Rebate Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_REBATE_CHECK"] = "MONEY_ORDER_REBATE_CHECK";
    /** Money Order - Refund Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_REFUND_CHECK"] = "MONEY_ORDER_REFUND_CHECK";
    /** Money Order - Utility Check */ MastercardFleetNonFuelProductCode["MONEY_ORDER_UTILITY_CHECK"] = "MONEY_ORDER_UTILITY_CHECK";
    /** Money Order - Vendor Payment */ MastercardFleetNonFuelProductCode["MONEY_ORDER_VENDOR_PAYMENT"] = "MONEY_ORDER_VENDOR_PAYMENT";
    /** Motor Oil */ MastercardFleetNonFuelProductCode["MOTOR_OIL"] = "MOTOR_OIL";
    /** Multiple Payee Bill Pay */ MastercardFleetNonFuelProductCode["MULTIPLE_PAYEE_BILL_PAY"] = "MULTIPLE_PAYEE_BILL_PAY";
    /** Oil Change */ MastercardFleetNonFuelProductCode["OIL_CHANGE"] = "OIL_CHANGE";
    /** Oil Filter */ MastercardFleetNonFuelProductCode["OIL_FILTER"] = "OIL_FILTER";
    /** Other Dairy */ MastercardFleetNonFuelProductCode["OTHER_DAIRY"] = "OTHER_DAIRY";
    /** Other Dispensed Beverages */ MastercardFleetNonFuelProductCode["OTHER_DISPENSED_BEVERAGES"] = "OTHER_DISPENSED_BEVERAGES";
    /** Other Lubricants */ MastercardFleetNonFuelProductCode["OTHER_LUBRICANTS"] = "OTHER_LUBRICANTS";
    /** Other Packaged Beverages */ MastercardFleetNonFuelProductCode["OTHER_PACKAGED_BEVERAGES"] = "OTHER_PACKAGED_BEVERAGES";
    /** Overtime Fees */ MastercardFleetNonFuelProductCode["OVERTIME_FEES"] = "OVERTIME_FEES";
    /** Oxygen */ MastercardFleetNonFuelProductCode["OXYGEN"] = "OXYGEN";
    /** Packaged Additive */ MastercardFleetNonFuelProductCode["PACKAGED_ADDITIVE"] = "PACKAGED_ADDITIVE";
    /** Packaged B99 */ MastercardFleetNonFuelProductCode["PACKAGED_B99"] = "PACKAGED_B99";
    /** Packaged B100 */ MastercardFleetNonFuelProductCode["PACKAGED_B100"] = "PACKAGED_B100";
    /** Packaged Beverages (non-alcoholic) */ MastercardFleetNonFuelProductCode["PACKAGED_BEVERAGES_NON_ALCOHOLIC"] = "PACKAGED_BEVERAGES_NON_ALCOHOLIC";
    /** Packaged DEF (Diesel Exhaust Fluid) */ MastercardFleetNonFuelProductCode["PACKAGED_DEF"] = "PACKAGED_DEF";
    /** Packaged Ice Cream/Novelties */ MastercardFleetNonFuelProductCode["PACKAGED_ICE_CREAM_NOVELTIES"] = "PACKAGED_ICE_CREAM_NOVELTIES";
    /** Packaged Juice */ MastercardFleetNonFuelProductCode["PACKAGED_JUICE"] = "PACKAGED_JUICE";
    /** Packaged Kerosene */ MastercardFleetNonFuelProductCode["PACKAGED_KEROSENE"] = "PACKAGED_KEROSENE";
    /** Packaged Propane */ MastercardFleetNonFuelProductCode["PACKAGED_PROPANE"] = "PACKAGED_PROPANE";
    /** Packaged Sandwiches/Deli Products */ MastercardFleetNonFuelProductCode["PACKAGED_SANDWICHES_DELI_PRODUCTS"] = "PACKAGED_SANDWICHES_DELI_PRODUCTS";
    /** Pilot Supplies */ MastercardFleetNonFuelProductCode["PILOT_SUPPLIES"] = "PILOT_SUPPLIES";
    /** PIN Activate Prepaid Card */ MastercardFleetNonFuelProductCode["PIN_ACTIVATE_PREPAID_CARD"] = "PIN_ACTIVATE_PREPAID_CARD";
    /** PIN Return Prepaid Card */ MastercardFleetNonFuelProductCode["PIN_RETURN_PREPAID_CARD"] = "PIN_RETURN_PREPAID_CARD";
    /** POS/Loyalty Reserved Discount 1 */ MastercardFleetNonFuelProductCode["POS_LOYALTY_RESERVED_DISCOUNT_1"] = "POS_LOYALTY_RESERVED_DISCOUNT_1";
    /** POS/Loyalty Reserved Discount 2 */ MastercardFleetNonFuelProductCode["POS_LOYALTY_RESERVED_DISCOUNT_2"] = "POS_LOYALTY_RESERVED_DISCOUNT_2";
    /** POS/Loyalty Reserved Discount 3 */ MastercardFleetNonFuelProductCode["POS_LOYALTY_RESERVED_DISCOUNT_3"] = "POS_LOYALTY_RESERVED_DISCOUNT_3";
    /** POS/Loyalty Reserved Discount 4 */ MastercardFleetNonFuelProductCode["POS_LOYALTY_RESERVED_DISCOUNT_4"] = "POS_LOYALTY_RESERVED_DISCOUNT_4";
    /** POS/Loyalty Reserved Discount 5 */ MastercardFleetNonFuelProductCode["POS_LOYALTY_RESERVED_DISCOUNT_5"] = "POS_LOYALTY_RESERVED_DISCOUNT_5";
    /** Prepaid Cards - Activation/Recharge */ MastercardFleetNonFuelProductCode["PREPAID_CARDS_ACTIVATION_RECHARGE"] = "PREPAID_CARDS_ACTIVATION_RECHARGE";
    /** Prepaid Cards - Purchase */ MastercardFleetNonFuelProductCode["PREPAID_CARDS_PURCHASE"] = "PREPAID_CARDS_PURCHASE";
    /** Prepared Foods */ MastercardFleetNonFuelProductCode["PREPARED_FOODS"] = "PREPARED_FOODS";
    /** Preventative Maintenance */ MastercardFleetNonFuelProductCode["PREVENTATIVE_MAINTENANCE"] = "PREVENTATIVE_MAINTENANCE";
    /** Proprietary Prepaid Card Activate */ MastercardFleetNonFuelProductCode["PROPRIETARY_PREPAID_CARD_ACTIVATE"] = "PROPRIETARY_PREPAID_CARD_ACTIVATE";
    /** Proprietary Prepaid Card Reload */ MastercardFleetNonFuelProductCode["PROPRIETARY_PREPAID_CARD_RELOAD"] = "PROPRIETARY_PREPAID_CARD_RELOAD";
    /** PST/QST (Canadian) VAT 2 */ MastercardFleetNonFuelProductCode["PST_QST_CANADIAN_VAT_2"] = "PST_QST_CANADIAN_VAT_2";
    /** Ramp Fees */ MastercardFleetNonFuelProductCode["RAMP_FEES"] = "RAMP_FEES";
    /** Real Time Recharge */ MastercardFleetNonFuelProductCode["REAL_TIME_RECHARGE"] = "REAL_TIME_RECHARGE";
    /** Repairs */ MastercardFleetNonFuelProductCode["REPAIRS"] = "REPAIRS";
    /** Re-service */ MastercardFleetNonFuelProductCode["RE_SERVICE"] = "RE_SERVICE";
    /** Road Service */ MastercardFleetNonFuelProductCode["ROAD_SERVICE"] = "ROAD_SERVICE";
    /** RV Dump Fee */ MastercardFleetNonFuelProductCode["RV_DUMP_FEE"] = "RV_DUMP_FEE";
    /** Salty Snacks */ MastercardFleetNonFuelProductCode["SALTY_SNACKS"] = "SALTY_SNACKS";
    /** Scales */ MastercardFleetNonFuelProductCode["SCALES"] = "SCALES";
    /** Secure Fees */ MastercardFleetNonFuelProductCode["SECURE_FEES"] = "SECURE_FEES";
    /** Service Package */ MastercardFleetNonFuelProductCode["SERVICE_PACKAGE"] = "SERVICE_PACKAGE";
    /** Shower */ MastercardFleetNonFuelProductCode["SHOWER"] = "SHOWER";
    /** Single Payee Bill Pay */ MastercardFleetNonFuelProductCode["SINGLE_PAYEE_BILL_PAY"] = "SINGLE_PAYEE_BILL_PAY";
    /** Slip Rental */ MastercardFleetNonFuelProductCode["SLIP_RENTAL"] = "SLIP_RENTAL";
    /** Split Tender */ MastercardFleetNonFuelProductCode["SPLIT_TENDER"] = "SPLIT_TENDER";
    /** Static Dissipater Additive */ MastercardFleetNonFuelProductCode["STATIC_DISSIPATER_ADDITIVE"] = "STATIC_DISSIPATER_ADDITIVE";
    /** Storage */ MastercardFleetNonFuelProductCode["STORAGE"] = "STORAGE";
    /** Sweet Snacks - Packaged */ MastercardFleetNonFuelProductCode["SWEET_SNACKS_PACKAGED"] = "SWEET_SNACKS_PACKAGED";
    /** SWT Rate (Canadian) */ MastercardFleetNonFuelProductCode["SWT_RATE_CANADIAN"] = "SWT_RATE_CANADIAN";
    /** Synthetic Oil */ MastercardFleetNonFuelProductCode["SYNTHETIC_OIL"] = "SYNTHETIC_OIL";
    /** Tax 1 */ MastercardFleetNonFuelProductCode["TAX_1"] = "TAX_1";
    /** Tax 2 */ MastercardFleetNonFuelProductCode["TAX_2"] = "TAX_2";
    /** Tax 3 */ MastercardFleetNonFuelProductCode["TAX_3"] = "TAX_3";
    /** Tax 4 */ MastercardFleetNonFuelProductCode["TAX_4"] = "TAX_4";
    /** Tax 5 */ MastercardFleetNonFuelProductCode["TAX_5"] = "TAX_5";
    /** Tax 6 */ MastercardFleetNonFuelProductCode["TAX_6"] = "TAX_6";
    /** Tax 7 */ MastercardFleetNonFuelProductCode["TAX_7"] = "TAX_7";
    /** Tax 8 */ MastercardFleetNonFuelProductCode["TAX_8"] = "TAX_8";
    /** Tax Discount/Forgiven */ MastercardFleetNonFuelProductCode["TAX_DISCOUNT_FORGIVEN"] = "TAX_DISCOUNT_FORGIVEN";
    /** 3rd Party Prepaid Card Activate */ MastercardFleetNonFuelProductCode["THIRD_PARTY_PREPAID_CARD_ACTIVATE"] = "THIRD_PARTY_PREPAID_CARD_ACTIVATE";
    /** 3rd Party Prepaid Card Reload */ MastercardFleetNonFuelProductCode["THIRD_PARTY_PREPAID_CARD_RELOAD"] = "THIRD_PARTY_PREPAID_CARD_RELOAD";
    /** Tires */ MastercardFleetNonFuelProductCode["TIRES"] = "TIRES";
    /** Tire-related (Wheel Balance, Valve Stem) */ MastercardFleetNonFuelProductCode["TIRE_RELATED"] = "TIRE_RELATED";
    /** Tire Repair */ MastercardFleetNonFuelProductCode["TIRE_REPAIR"] = "TIRE_REPAIR";
    /** Tire Rotation */ MastercardFleetNonFuelProductCode["TIRE_ROTATION"] = "TIRE_ROTATION";
    /** Tobacco - Other */ MastercardFleetNonFuelProductCode["TOBACCO_OTHER"] = "TOBACCO_OTHER";
    /** Toll Payments */ MastercardFleetNonFuelProductCode["TOLL_PAYMENTS"] = "TOLL_PAYMENTS";
    /** Towing */ MastercardFleetNonFuelProductCode["TOWING"] = "TOWING";
    /** Trailer Wash */ MastercardFleetNonFuelProductCode["TRAILER_WASH"] = "TRAILER_WASH";
    /** Transmission Service */ MastercardFleetNonFuelProductCode["TRANSMISSION_SERVICE"] = "TRANSMISSION_SERVICE";
    /** Transportation */ MastercardFleetNonFuelProductCode["TRANSPORTATION"] = "TRANSPORTATION";
    /** Truck Tank Cleaning */ MastercardFleetNonFuelProductCode["TRUCK_TANK_CLEANING"] = "TRUCK_TANK_CLEANING";
    /** Vehicle Accessories */ MastercardFleetNonFuelProductCode["VEHICLE_ACCESSORIES"] = "VEHICLE_ACCESSORIES";
    /** Vehicle Fuel Additives/Treatment (Injected) */ MastercardFleetNonFuelProductCode["VEHICLE_FUEL_ADDITIVES_TREATMENT"] = "VEHICLE_FUEL_ADDITIVES_TREATMENT";
    /** Vehicle Glass */ MastercardFleetNonFuelProductCode["VEHICLE_GLASS"] = "VEHICLE_GLASS";
    /** Vehicle Parking */ MastercardFleetNonFuelProductCode["VEHICLE_PARKING"] = "VEHICLE_PARKING";
    /** Vehicle Parts */ MastercardFleetNonFuelProductCode["VEHICLE_PARTS"] = "VEHICLE_PARTS";
    /** Vehicle Prep */ MastercardFleetNonFuelProductCode["VEHICLE_PREP"] = "VEHICLE_PREP";
    /** Vehicle Rental */ MastercardFleetNonFuelProductCode["VEHICLE_RENTAL"] = "VEHICLE_RENTAL";
    /** Washer Fluid */ MastercardFleetNonFuelProductCode["WASHER_FLUID"] = "WASHER_FLUID";
    /** Wash Out */ MastercardFleetNonFuelProductCode["WASH_OUT"] = "WASH_OUT";
    /** Wine */ MastercardFleetNonFuelProductCode["WINE"] = "WINE";
    /** Wipers */ MastercardFleetNonFuelProductCode["WIPERS"] = "WIPERS";
    /** Wireless Real Time Recharge */ MastercardFleetNonFuelProductCode["WIRELESS_REAL_TIME_RECHARGE"] = "WIRELESS_REAL_TIME_RECHARGE";
    /** Work Order */ MastercardFleetNonFuelProductCode["WORK_ORDER"] = "WORK_ORDER";
    return MastercardFleetNonFuelProductCode;
}({});
var $2f53fee15f29b056$export$7bf9da9352f2f3f1 = /*#__PURE__*/ function(MastercardFleetProductCode) {
    /** Aviation Accessories */ MastercardFleetProductCode["AC_ACC"] = "AC_ACC";
    /** Aircraft Cleaning */ MastercardFleetProductCode["AIRCRAFT_CLEANING"] = "AIRCRAFT_CLEANING";
    /** APU or Aircraft Jump Start */ MastercardFleetProductCode["APU"] = "APU";
    /** Automotive Accessories */ MastercardFleetProductCode["AUTO_ACC"] = "AUTO_ACC";
    /** Automotive Glass */ MastercardFleetProductCode["AUTO_GLASS"] = "AUTO_GLASS";
    /** Aviation CAtering */ MastercardFleetProductCode["AV_CATERING"] = "AV_CATERING";
    /** Aviation Fuel */ MastercardFleetProductCode["AV_FUEL"] = "AV_FUEL";
    /** Aviation 100 Octane */ MastercardFleetProductCode["AV_FUEL_100"] = "AV_FUEL_100";
    /** Aviation Maintenance */ MastercardFleetProductCode["AV_MAINTENANCE"] = "AV_MAINTENANCE";
    /** Batteries */ MastercardFleetProductCode["BATTERIES"] = "BATTERIES";
    /** Beer/Wine */ MastercardFleetProductCode["BEER_WINE"] = "BEER_WINE";
    /** Biodiesel */ MastercardFleetProductCode["BIODIESEL"] = "BIODIESEL";
    /** Biodiesel (Non-Taxable) */ MastercardFleetProductCode["BIODIESEL_NON_TAXABLE"] = "BIODIESEL_NON_TAXABLE";
    /** Boat Service */ MastercardFleetProductCode["BOAT_SERVICE"] = "BOAT_SERVICE";
    /** Brake Fluid */ MastercardFleetProductCode["BRAKE_FLUID"] = "BRAKE_FLUID";
    /** Brake Service */ MastercardFleetProductCode["BRAKE_SERVICE"] = "BRAKE_SERVICE";
    /** Call Out Fee */ MastercardFleetProductCode["CALL_OUT_FEE"] = "CALL_OUT_FEE";
    /** Cargo Handling */ MastercardFleetProductCode["CARGO_HANDLING"] = "CARGO_HANDLING";
    /** Car Wash */ MastercardFleetProductCode["CAR_WASH"] = "CAR_WASH";
    /** Charter Fees */ MastercardFleetProductCode["CHARTER_FEE"] = "CHARTER_FEE";
    /** Cigarettes/Tobacco */ MastercardFleetProductCode["CIGARETTES"] = "CIGARETTES";
    /** Compressed Natural Gas */ MastercardFleetProductCode["CNG"] = "CNG";
    /** Communication Fees */ MastercardFleetProductCode["COMM_FEE"] = "COMM_FEE";
    /** Diesel Exhaust Fluid (DEF) */ MastercardFleetProductCode["DEF"] = "DEF";
    /** De-icing */ MastercardFleetProductCode["DE_ICING"] = "DE_ICING";
    /** Diesel */ MastercardFleetProductCode["DIESEL"] = "DIESEL";
    /** Diesel Exhaust Fluid: Dispensed */ MastercardFleetProductCode["DIESEL_EXHAUST_FLUID_DISPENSED"] = "DIESEL_EXHAUST_FLUID_DISPENSED";
    /** Diesel (Non-Taxable) */ MastercardFleetProductCode["DIESEL_NON_TAXABLE"] = "DIESEL_NON_TAXABLE";
    /** Diesel Premium */ MastercardFleetProductCode["DIESEL_PREMIUM"] = "DIESEL_PREMIUM";
    /** Dyed Diesel */ MastercardFleetProductCode["DYED_DIESEL"] = "DYED_DIESEL";
    /** E85 (Ethanol 85%) */ MastercardFleetProductCode["E85"] = "E85";
    /** Engine Service */ MastercardFleetProductCode["ENGINE_SERVICE"] = "ENGINE_SERVICE";
    /** Electric Vehicle Charge Level 1: 110v */ MastercardFleetProductCode["EV_LEVEL_1_CHARGE"] = "EV_LEVEL_1_CHARGE";
    /** Electric Vehicle Charge Level 2: 240v */ MastercardFleetProductCode["EV_LEVEL_2_CHARGE"] = "EV_LEVEL_2_CHARGE";
    /** Electric Vehicle Charge Level 3: 480v */ MastercardFleetProductCode["EV_LEVEL_3_CHARGE"] = "EV_LEVEL_3_CHARGE";
    /** Flight Planning/Weather Fees */ MastercardFleetProductCode["FLIGHT_PLAN_FEE"] = "FLIGHT_PLAN_FEE";
    /** Gasohol */ MastercardFleetProductCode["GASOHOL"] = "GASOHOL";
    /** Ground Handling */ MastercardFleetProductCode["GROUND_HANDLING"] = "GROUND_HANDLING";
    /** Health/Beauty Aid */ MastercardFleetProductCode["HEALTH_BEAUTY"] = "HEALTH_BEAUTY";
    /** Instruction Fee */ MastercardFleetProductCode["INSTRUCTION_FEE"] = "INSTRUCTION_FEE";
    /** Jet Fuel */ MastercardFleetProductCode["JET_FUEL"] = "JET_FUEL";
    /** Kerosene */ MastercardFleetProductCode["KEROSENE"] = "KEROSENE";
    /** Landing Fee */ MastercardFleetProductCode["LANDING_FEE"] = "LANDING_FEE";
    /** Ethanol Regular Leaded */ MastercardFleetProductCode["LEADED_ETHANOL"] = "LEADED_ETHANOL";
    /** Methanol Regular Leaded */ MastercardFleetProductCode["LEADED_METHANOL"] = "LEADED_METHANOL";
    /** Liquid Natural Gas */ MastercardFleetProductCode["LNG"] = "LNG";
    /** Liquid Propane gas (LPG) */ MastercardFleetProductCode["LPG"] = "LPG";
    /** M85 (Methanol 85%) */ MastercardFleetProductCode["M85"] = "M85";
    /** Marine Fuel */ MastercardFleetProductCode["MARINE_FUEL"] = "MARINE_FUEL";
    /** Unleaded Mid Grade (88 or 89 octane) */ MastercardFleetProductCode["MID"] = "MID";
    /** Ethanol Unleaded Mid Grade (88 or 89 octane) */ MastercardFleetProductCode["MID_ETHANOL"] = "MID_ETHANOL";
    /** Methanol Unleaded Mid Grade (88 or 89 octane) */ MastercardFleetProductCode["MID_METHANOL"] = "MID_METHANOL";
    /** Milk/Juice */ MastercardFleetProductCode["MILK_JUICE"] = "MILK_JUICE";
    /** Miscellaneous Aviation */ MastercardFleetProductCode["MISC_AV"] = "MISC_AV";
    /** Miscellaneous Beverage */ MastercardFleetProductCode["MISC_BEV"] = "MISC_BEV";
    /** Miscellaneous Food/Grocery */ MastercardFleetProductCode["MISC_FOOD"] = "MISC_FOOD";
    /** Miscellaneous Fuel */ MastercardFleetProductCode["MISC_FUEL"] = "MISC_FUEL";
    /** Miscellaneous Labor */ MastercardFleetProductCode["MISC_LABOR"] = "MISC_LABOR";
    /** Miscellaneous Other */ MastercardFleetProductCode["MISC_OTHER_FUEL"] = "MISC_OTHER_FUEL";
    /** Miscellaneous Parts */ MastercardFleetProductCode["MISC_PARTS"] = "MISC_PARTS";
    /** Miscellaneous Repairs */ MastercardFleetProductCode["MISC_REPAIRS"] = "MISC_REPAIRS";
    /** Motor Oil */ MastercardFleetProductCode["MOTOR_OIL"] = "MOTOR_OIL";
    /** Oil Change */ MastercardFleetProductCode["OIL_CHANGE"] = "OIL_CHANGE";
    /** Plane Rental */ MastercardFleetProductCode["PLANE_RENTAL"] = "PLANE_RENTAL";
    /** Unleaded Premium (90 or 91 octane) */ MastercardFleetProductCode["PREMIUM"] = "PREMIUM";
    /** Ethanol Unleaded Premium (90 or 91 octane) */ MastercardFleetProductCode["PREMIUM_ETHANOL"] = "PREMIUM_ETHANOL";
    /** Methanol Unleaded Premium (90 or 91 octane) */ MastercardFleetProductCode["PREMIUM_METHANOL"] = "PREMIUM_METHANOL";
    /** Racing Fuel */ MastercardFleetProductCode["RACING_FUEL"] = "RACING_FUEL";
    /** Ramp Fee */ MastercardFleetProductCode["RAMP_FEE"] = "RAMP_FEE";
    /** Unleaded Regular (85 to 87 octane) */ MastercardFleetProductCode["REGULAR"] = "REGULAR";
    /** Ethanol Unleaded Regular (86 or 87 octane) */ MastercardFleetProductCode["REGULAR_ETHANOL"] = "REGULAR_ETHANOL";
    /** Regular Leaded Gasoline */ MastercardFleetProductCode["REGULAR_LEADED"] = "REGULAR_LEADED";
    /** Methanol Unleaded Regular (86 or 87 octane) */ MastercardFleetProductCode["REGULAR_METHANOL"] = "REGULAR_METHANOL";
    /** Restaurant */ MastercardFleetProductCode["RESTAURANT"] = "RESTAURANT";
    /** Soda */ MastercardFleetProductCode["SODA"] = "SODA";
    /** Solvent */ MastercardFleetProductCode["SOLVENT"] = "SOLVENT";
    /** Unleaded Super (92 to 94 octane) */ MastercardFleetProductCode["SUPER"] = "SUPER";
    /** Ethanol Unleaded Super (92 to 94 octane) */ MastercardFleetProductCode["SUPER_ETHANOL"] = "SUPER_ETHANOL";
    /** Methanol Unleaded Super (92 to 94 octane) */ MastercardFleetProductCode["SUPER_METHANOL"] = "SUPER_METHANOL";
    /** Tiedown or Hangar */ MastercardFleetProductCode["TIEDOWN_HANGAR"] = "TIEDOWN_HANGAR";
    /** Tires */ MastercardFleetProductCode["TIRES"] = "TIRES";
    /** TBA (tires, batteries, accessories) */ MastercardFleetProductCode["TIRES_BATTERIES_ACCESSORIES"] = "TIRES_BATTERIES_ACCESSORIES";
    /** Towing */ MastercardFleetProductCode["TOWING"] = "TOWING";
    /** Transmission Service */ MastercardFleetProductCode["TRANSMISSION_SERVICE"] = "TRANSMISSION_SERVICE";
    /** Ultralow Sulfur Diesel (ULSD) */ MastercardFleetProductCode["ULSD"] = "ULSD";
    /** Unleaded Mid Grade Reformulated (88 or 89 octane) */ MastercardFleetProductCode["UNLEADED_MID_REFORMULATED"] = "UNLEADED_MID_REFORMULATED";
    /** Unleaded Reformulated (86 or 87 octane) */ MastercardFleetProductCode["UNLEADED_REFORMULATED"] = "UNLEADED_REFORMULATED";
    /** White Gas */ MastercardFleetProductCode["WHITE_GAS"] = "WHITE_GAS";
    return MastercardFleetProductCode;
}({});
var $2f53fee15f29b056$export$5897a8c35edfafbf = /*#__PURE__*/ function(MastercardFleetProductType) {
    /** No prompts issued */ MastercardFleetProductType["NO_PROMPTS_ISSUED"] = "NO_PROMPTS_ISSUED";
    /** Prompts for driver number and odometer reading */ MastercardFleetProductType["PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER"] = "PROMPT_FOR_DRIVER_NUMBER_AND_ODOMETER";
    /** Prompts for ID number and odometer reading */ MastercardFleetProductType["PROMPT_FOR_ID_AND_ODOMETER"] = "PROMPT_FOR_ID_AND_ODOMETER";
    /** Prompts for odometer reading only */ MastercardFleetProductType["PROMPT_FOR_ODOMETER_ONLY"] = "PROMPT_FOR_ODOMETER_ONLY";
    /** Prompts for vehicle number and odometer reading */ MastercardFleetProductType["PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER"] = "PROMPT_FOR_VEHICLE_NUMBER_AND_ODOMETER";
    return MastercardFleetProductType;
}({});
var $2f53fee15f29b056$export$d557c154d37d6544 = /*#__PURE__*/ function(MastercardFleetPromptType) {
    /** Additional Card Data */ MastercardFleetPromptType["ADDITIONAL_CARD_DATA"] = "ADDITIONAL_CARD_DATA";
    /** Additional Vehicle Data */ MastercardFleetPromptType["ADDITIONAL_VEHICLE_DATA"] = "ADDITIONAL_VEHICLE_DATA";
    /** Battery Voltage */ MastercardFleetPromptType["BATTERY_VOLTAGE"] = "BATTERY_VOLTAGE";
    /** Billing ID */ MastercardFleetPromptType["BILLING_ID"] = "BILLING_ID";
    /** Check Engine Status */ MastercardFleetPromptType["CHECK_ENGINE_STATUS"] = "CHECK_ENGINE_STATUS";
    /** Control Number */ MastercardFleetPromptType["CONTROL_NUMBER"] = "CONTROL_NUMBER";
    /** Coolant Temperature */ MastercardFleetPromptType["COOLANT_TEMPERATURE"] = "COOLANT_TEMPERATURE";
    /** Customer Number */ MastercardFleetPromptType["CUSTOMER_NUMBER"] = "CUSTOMER_NUMBER";
    /** Delivery Ticket Number */ MastercardFleetPromptType["DELIVERY_TICKET_NUMBER"] = "DELIVERY_TICKET_NUMBER";
    /** Department Number */ MastercardFleetPromptType["DEPARTMENT_NUMBER"] = "DEPARTMENT_NUMBER";
    /** Driver ID */ MastercardFleetPromptType["DRIVER_ID"] = "DRIVER_ID";
    /** Driver or Vehicle Card */ MastercardFleetPromptType["DRIVER_OR_VEHICLE_CARD"] = "DRIVER_OR_VEHICLE_CARD";
    /** Engine Hours */ MastercardFleetPromptType["ENGINE_HOURS"] = "ENGINE_HOURS";
    /** Engine Load */ MastercardFleetPromptType["ENGINE_LOAD"] = "ENGINE_LOAD";
    /** Engine Oil Life */ MastercardFleetPromptType["ENGINE_OIL_LIFE"] = "ENGINE_OIL_LIFE";
    /** Engine Oil Pressure */ MastercardFleetPromptType["ENGINE_OIL_PRESSURE"] = "ENGINE_OIL_PRESSURE";
    /** Engine Oil Temperature */ MastercardFleetPromptType["ENGINE_OIL_TEMPERATURE"] = "ENGINE_OIL_TEMPERATURE";
    /** Engine RPM */ MastercardFleetPromptType["ENGINE_RPM"] = "ENGINE_RPM";
    /** Engine Time Total */ MastercardFleetPromptType["ENGINE_TIME_TOTAL"] = "ENGINE_TIME_TOTAL";
    /** Entered Data Alpha */ MastercardFleetPromptType["ENTERED_DATA_ALPHA"] = "ENTERED_DATA_ALPHA";
    /** Entered Data Num */ MastercardFleetPromptType["ENTERED_DATA_NUM"] = "ENTERED_DATA_NUM";
    /** Fuel Economy */ MastercardFleetPromptType["FUEL_ECONOMY"] = "FUEL_ECONOMY";
    /** Fuel Gauge Level */ MastercardFleetPromptType["FUEL_GAUGE_LEVEL"] = "FUEL_GAUGE_LEVEL";
    /** Hard Acceleration */ MastercardFleetPromptType["HARD_ACCELERATION"] = "HARD_ACCELERATION";
    /** Hard Breaking */ MastercardFleetPromptType["HARD_BREAKING"] = "HARD_BREAKING";
    /** Hubometer */ MastercardFleetPromptType["HUBOMETER"] = "HUBOMETER";
    /** Idle Time */ MastercardFleetPromptType["IDLE_TIME"] = "IDLE_TIME";
    /** Invoice Number */ MastercardFleetPromptType["INVOICE_NUMBER"] = "INVOICE_NUMBER";
    /** Job Number */ MastercardFleetPromptType["JOB_NUMBER"] = "JOB_NUMBER";
    /** Maintenance ID */ MastercardFleetPromptType["MAINTENANCE_ID"] = "MAINTENANCE_ID";
    /** Odometer */ MastercardFleetPromptType["ODOMETER"] = "ODOMETER";
    /** Reefer Hours */ MastercardFleetPromptType["REEFER_HOURS"] = "REEFER_HOURS";
    /** Reefer Temperature */ MastercardFleetPromptType["REEFER_TEMPERATURE"] = "REEFER_TEMPERATURE";
    /** Replacement Car */ MastercardFleetPromptType["REPLACEMENT_CAR"] = "REPLACEMENT_CAR";
    /** Sub Fleet Number */ MastercardFleetPromptType["SUB_FLEET_NUMBER"] = "SUB_FLEET_NUMBER";
    /** Tank Level Start */ MastercardFleetPromptType["TANK_LEVEL_START"] = "TANK_LEVEL_START";
    /** Total Idle Time */ MastercardFleetPromptType["TOTAL_IDLE_TIME"] = "TOTAL_IDLE_TIME";
    /** Trailer Number */ MastercardFleetPromptType["TRAILER_NUMBER"] = "TRAILER_NUMBER";
    /** Transaction Number */ MastercardFleetPromptType["TRANSACTION_NUMBER"] = "TRANSACTION_NUMBER";
    /** Trip Number */ MastercardFleetPromptType["TRIP_NUMBER"] = "TRIP_NUMBER";
    /** Unit Number */ MastercardFleetPromptType["UNIT_NUMBER"] = "UNIT_NUMBER";
    /** User ID */ MastercardFleetPromptType["USER_ID"] = "USER_ID";
    /** Vehicle Number */ MastercardFleetPromptType["VEHICLE_NUMBER"] = "VEHICLE_NUMBER";
    /** Vehicle Tag */ MastercardFleetPromptType["VEHICLE_TAG"] = "VEHICLE_TAG";
    /** Web Portal Data */ MastercardFleetPromptType["WEB_PORTAL_DATA"] = "WEB_PORTAL_DATA";
    /** Work Order / P.O. Number */ MastercardFleetPromptType["WORK_ORDER_OR_PO_NUMBER"] = "WORK_ORDER_OR_PO_NUMBER";
    /** ZIP Code / Postal Code */ MastercardFleetPromptType["ZIP_OR_POSTAL_CODE"] = "ZIP_OR_POSTAL_CODE";
    return MastercardFleetPromptType;
}({});
var $2f53fee15f29b056$export$26f12522e2bba324 = /*#__PURE__*/ function(MastercardFleetUnitOfMeasure) {
    /** Gallons */ MastercardFleetUnitOfMeasure["GALLONS"] = "GALLONS";
    /** Hours */ MastercardFleetUnitOfMeasure["HOURS"] = "HOURS";
    /** Imperial Gallons */ MastercardFleetUnitOfMeasure["IMPERIAL_GALLONS"] = "IMPERIAL_GALLONS";
    /** Kilograms */ MastercardFleetUnitOfMeasure["KILOS"] = "KILOS";
    /** Kilowatt Hours */ MastercardFleetUnitOfMeasure["KILOWATT_HOURS"] = "KILOWATT_HOURS";
    /** Liters */ MastercardFleetUnitOfMeasure["LITERS"] = "LITERS";
    /** Minutes */ MastercardFleetUnitOfMeasure["MINUTES"] = "MINUTES";
    /** Not Applicable */ MastercardFleetUnitOfMeasure["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** Pounds */ MastercardFleetUnitOfMeasure["POUNDS"] = "POUNDS";
    return MastercardFleetUnitOfMeasure;
}({});
var $2f53fee15f29b056$export$74f9e7af3ab00058 = /*#__PURE__*/ function(MastercardThreeDSecureCardholderAuthentication) {
    /** Channel encryption was used instead of a cardholder certificate. This is the preferred value. */ MastercardThreeDSecureCardholderAuthentication["CARDHOLDER_CERTIFICATE_NOT_USED"] = "CARDHOLDER_CERTIFICATE_NOT_USED";
    /** Processed through Masterpass. */ MastercardThreeDSecureCardholderAuthentication["MASTERPASS_PROCESSED"] = "MASTERPASS_PROCESSED";
    /** Tokenized payment. */ MastercardThreeDSecureCardholderAuthentication["TOKENIZED_PAYMENT"] = "TOKENIZED_PAYMENT";
    return MastercardThreeDSecureCardholderAuthentication;
}({});
var $2f53fee15f29b056$export$d9868fcabe8803e9 = /*#__PURE__*/ function(MastercardUcafCollectionIndicator) {
    /** Issuer risk-based decisioning. */ MastercardUcafCollectionIndicator["ISSUER_RISK_DECISIONING"] = "ISSUER_RISK_DECISIONING";
    /** Merchant risk-based decisioning. */ MastercardUcafCollectionIndicator["MERCHANT_RISK_DECISIONING"] = "MERCHANT_RISK_DECISIONING";
    /** The 3DS verification method is not supported. */ MastercardUcafCollectionIndicator["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    /** Partial shipment or recurring payment (UCAF not required). Liability depends on the original UCAF values provided and matching with the initial transaction. */ MastercardUcafCollectionIndicator["PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT"] = "PARTIAL_SHIPMENT_OR_RECURRING_PAYMENT";
    /** UCAF data collection is not supported by the Merchant. */ MastercardUcafCollectionIndicator["UCAF_DATA_NOT_SUPPORTED"] = "UCAF_DATA_NOT_SUPPORTED";
    /** UCAF data collection is supported by the Merchant and must be present. */ MastercardUcafCollectionIndicator["UCAF_DATA_REQUIRED"] = "UCAF_DATA_REQUIRED";
    /** UCAF data collection is supported by the Merchant and contains static AAV data. */ MastercardUcafCollectionIndicator["UCAF_DATA_STATIC"] = "UCAF_DATA_STATIC";
    /** UCAF data collection is supported by the Merchant. */ MastercardUcafCollectionIndicator["UCAF_DATA_SUPPORTED"] = "UCAF_DATA_SUPPORTED";
    return MastercardUcafCollectionIndicator;
}({});
var $2f53fee15f29b056$export$766a2ac02dc19912 = /*#__PURE__*/ function(MerchantCategory) {
    /**
   * The category for A1 Rent A Car
   *
   * Numeric Code: '3412'
   */ MerchantCategory["A1_RENT_A_CAR"] = "A1_RENT_A_CAR";
    /**
   * The category for AB Hotel
   *
   * Numeric code: '3861'
   */ MerchantCategory["AB_HOTEL"] = "AB_HOTEL";
    /**
   * The category for Accent Rent A Car
   *
   * Numeric Code: '3374'
   */ MerchantCategory["ACCENT_RENT_A_CAR"] = "ACCENT_RENT_A_CAR";
    /**
   * The category for Accounting/Bookkeeping Services.
   *
   * Numeric code: '8931'
   */ MerchantCategory["ACCOUNTING_BOOKKEEPING_SERVICES"] = "ACCOUNTING_BOOKKEEPING_SERVICES";
    /**
   * The category for Action Auto Rental
   *
   * Numeric Code: '3354'
   */ MerchantCategory["ACTION_AUTO_RENTAL"] = "ACTION_AUTO_RENTAL";
    /**
   * The category for AC Hotels
   *
   * Numeric code: '3844'
   */ MerchantCategory["AC_HOTELS"] = "AC_HOTELS";
    /**
   * The category for "A/C, Refrigeration Repair".
   *
   * Numeric code: '7623'
   */ MerchantCategory["AC_REFRIGERATION_REPAIR"] = "AC_REFRIGERATION_REPAIR";
    /**
   * The category for Adams Mark
   *
   * Numeric Code: '3681'
   */ MerchantCategory["ADAMS_MARK"] = "ADAMS_MARK";
    /**
   * The category for Adria Airways
   *
   * Numeric Code: '3064'
   */ MerchantCategory["ADRIA_AIR"] = "ADRIA_AIR";
    /**
   * The category for Advantage Rent A Car
   *
   * Numeric Code: '3441'
   */ MerchantCategory["ADVANTAGE_RENT_A_CAR"] = "ADVANTAGE_RENT_A_CAR";
    /**
   * The category for Advertising Services.
   *
   * Numeric code: '7311'
   */ MerchantCategory["ADVERTISING_SERVICES"] = "ADVERTISING_SERVICES";
    /**
   * The category for Aeorflot
   *
   * Numeric Code: '3011'
   */ MerchantCategory["AEORFLOT"] = "AEORFLOT";
    /**
   * The category for Aeorlineas Argentinas
   *
   * Numeric Code: '3030'
   */ MerchantCategory["AEROLINEAS_ARGENTINAS"] = "AEROLINEAS_ARGENTINAS";
    /**
   * The category for Aeromexico
   *
   * Numeric Code: '3076'
   */ MerchantCategory["AEROMEXICO"] = "AEROMEXICO";
    /**
   * The category for Aero Coach Aviation
   *
   * Numeric Code: '3287'
   */ MerchantCategory["AERO_COACH_AVIATION"] = "AERO_COACH_AVIATION";
    /**
   * The category for Aero Continente
   *
   * Numeric Code: '3167'
   */ MerchantCategory["AERO_CONTINENTE"] = "AERO_CONTINENTE";
    /**
   * The category for Aero Nicaraguensis
   *
   * Numeric Code: '3286'
   */ MerchantCategory["AERO_NICARAGUENSIS"] = "AERO_NICARAGUENSIS";
    /**
   * The category for Aero Peru
   *
   * Numeric Code: '3285'
   */ MerchantCategory["AERO_PERU"] = "AERO_PERU";
    /**
   * The category for Aero Virgin Islands
   *
   * Numeric Code: '3284'
   */ MerchantCategory["AERO_VIRGIN_ISLANDS"] = "AERO_VIRGIN_ISLANDS";
    /**
   * The category for Aer Lingus
   *
   * Numeric Code: '3043'
   */ MerchantCategory["AER_LINGUS"] = "AER_LINGUS";
    /**
   * The category for Affiliated Auto Rental
   *
   * Numeric Code: '3351'
   */ MerchantCategory["AFFILIATED_AUTO_RENTAL"] = "AFFILIATED_AUTO_RENTAL";
    /**
   * The category for Affinia
   *
   * Numeric Code: '3817'
   */ MerchantCategory["AFFINIA"] = "AFFINIA";
    /**
   * The category for Agency Rent A Car
   *
   * Numeric Code: '3364'
   */ MerchantCategory["AGENCY_RENT_A_CAR"] = "AGENCY_RENT_A_CAR";
    /**
   * The category for Agricultural Cooperative.
   *
   * Numeric code: '0763'
   */ MerchantCategory["AGRICULTURAL_COOPERATIVE"] = "AGRICULTURAL_COOPERATIVE";
    /**
   * The category for Airinter
   *
   * Numeric Code: '3065'
   */ MerchantCategory["AIRINTER"] = "AIRINTER";
    /**
   * The category for "Airlines, Air Carriers".
   *
   * Numeric codes: ['3003','3019','3070','3073','3074','3080','3091','3092','3093','3095','3101','3104','3105','3107','3108','3109','3113','3114','3116','3119','3120','3121','3122','3123','3124','3128','3134','3139','3140','3141','3142','3147','3149','3150','3152','3153','3155','3157','3158','3160','3162','3163','3166','3173','3179','3189','3192','3194','3195','3198','3199','3201','3202','3205','3207','3208','3209','3210','3214','3224','3225','3227','3230','3232','3237','3244','3249','3250','3255','3257','3258','3264','3265','3268','3269','3270','3271','3272','3273','3274','3275','3276','3277','3278','3279','3281','3283','3288','3289','3290','3291','4511']
   */ MerchantCategory["AIRLINES_AIR_CARRIERS"] = "AIRLINES_AIR_CARRIERS";
    /**
   * The category for "Airports, Flying Fields".
   *
   * Numeric code: '4582'
   */ MerchantCategory["AIRPORTS_FLYING_FIELDS"] = "AIRPORTS_FLYING_FIELDS";
    /**
   * The category for AirTran Airways
   *
   * Numeric Code: '3177'
   */ MerchantCategory["AIRTRAN_AIRWAYS"] = "AIRTRAN_AIRWAYS";
    /**
   * The category for Airways
   *
   * Numeric Code: '3361'
   */ MerchantCategory["AIRWAYS"] = "AIRWAYS";
    /**
   * The category for Air Afrique
   *
   * Numeric Code: '3083'
   */ MerchantCategory["AIR_AFRIQUE"] = "AIR_AFRIQUE";
    /**
   * The category for Air Algerie
   *
   * Numeric Code: '3021'
   */ MerchantCategory["AIR_ALGERIE"] = "AIR_ALGERIE";
    /**
   * The category for Air Arabia Airline
   *
   * Numeric Code: '3236'
   */ MerchantCategory["AIR_ARABIA"] = "AIR_ARABIA";
    /**
   * The category for Air Astana
   *
   * Numeric Code: '3068'
   */ MerchantCategory["AIR_ASTANA"] = "AIR_ASTANA";
    /**
   * The category for Air Baltic
   *
   * Numeric code: '3304'
   */ MerchantCategory["AIR_BALTIC"] = "AIR_BALTIC";
    /**
   * The category for Air Berlin
   *
   * Numeric Code: '3296'
   */ MerchantCategory["AIR_BERLIN"] = "AIR_BERLIN";
    /**
   * The category for Air British Columbia
   *
   * Numeric Code: '3071'
   */ MerchantCategory["AIR_BRITISH_COLUMBIA"] = "AIR_BRITISH_COLUMBIA";
    /**
   * The category for Air Canada
   *
   * Numeric Code: '3009'
   */ MerchantCategory["AIR_CANADA"] = "AIR_CANADA";
    /**
   * The category for Air China
   *
   * Numeric Code: '3261'
   */ MerchantCategory["AIR_CHINA"] = "AIR_CHINA";
    /**
   * The category for Air Djibouti
   *
   * Numeric Code: '3282'
   */ MerchantCategory["AIR_DJIBOUTI"] = "AIR_DJIBOUTI";
    /**
   * The category for Air France
   *
   * Numeric Code: '3007'
   */ MerchantCategory["AIR_FRANCE"] = "AIR_FRANCE";
    /**
   * The category for Air India
   *
   * Numeric Code: '3020'
   */ MerchantCategory["AIR_INDIA"] = "AIR_INDIA";
    /**
   * The category for Air Jamaica
   *
   * Numeric Code: '3280'
   */ MerchantCategory["AIR_JAMAICA"] = "AIR_JAMAICA";
    /**
   * The category for Air Lanka
   *
   * Numeric Code: '3044'
   */ MerchantCategory["AIR_LANKA"] = "AIR_LANKA";
    /**
   * The category for Air Littoral S.A.
   *
   * Numeric Code: '3148'
   */ MerchantCategory["AIR_LITTORAL"] = "AIR_LITTORAL";
    /**
   * The category for Air Malta
   *
   * Numeric Code: '3028'
   */ MerchantCategory["AIR_MALTA"] = "AIR_MALTA";
    /**
   * The category for Royal Air Maroc
   *
   * Numeric Code: '3048'
   */ MerchantCategory["AIR_MAROC"] = "AIR_MAROC";
    /**
   * The category for Air Mauritius
   *
   * Numeric Code: '3298'
   */ MerchantCategory["AIR_MAURITIUS"] = "AIR_MAURITIUS";
    /**
   * The category for Air New Zealand
   *
   * Numeric Code: '3025'
   */ MerchantCategory["AIR_NEW_ZEALAND"] = "AIR_NEW_ZEALAND";
    /**
   * The category for Air Panama International
   *
   * Numeric Code: '3267'
   */ MerchantCategory["AIR_PANAMA"] = "AIR_PANAMA";
    /**
   * The category for Air Seychelles
   *
   * Numeric Code: '3266'
   */ MerchantCategory["AIR_SEYCHELLES"] = "AIR_SEYCHELLES";
    /**
   * The category for Air Transat
   *
   * Numeric code: '3305'
   */ MerchantCategory["AIR_TRANSAT"] = "AIR_TRANSAT";
    /**
   * The category for Air Zaire
   *
   * Numeric Code: '3151'
   */ MerchantCategory["AIR_ZAIRE"] = "AIR_ZAIRE";
    /**
   * The category for Air Zimbabwe Corp
   *
   * Numeric Code: '3096'
   */ MerchantCategory["AIR_ZIMBABWE_CORP"] = "AIR_ZIMBABWE_CORP";
    /**
   * The category for Ajax Rent A Car
   *
   * Numeric Code: '3376'
   */ MerchantCategory["AJAX_RENT_A_CAR"] = "AJAX_RENT_A_CAR";
    /**
   * The category for Aladdin Resort And Casino
   *
   * Numeric Code: '3560'
   */ MerchantCategory["ALADDIN_RESORT_AND_CASINO"] = "ALADDIN_RESORT_AND_CASINO";
    /**
   * The category for Alamo Rent A Car
   *
   * Numeric Code: '3387'
   */ MerchantCategory["ALAMO_RENT_A_CAR"] = "ALAMO_RENT_A_CAR";
    /**
   * The category for Alaska Airlines Inc.
   *
   * Numeric Code: '3256'
   */ MerchantCategory["ALASKA_AIR"] = "ALASKA_AIR";
    /**
   * The category for Ala Moana Hotel
   *
   * Numeric Code: '3788'
   */ MerchantCategory["ALA_MOANA_HOTEL"] = "ALA_MOANA_HOTEL";
    /**
   * The category for Alitalia
   *
   * Numeric Code: '3013'
   */ MerchantCategory["ALITALIA"] = "ALITALIA";
    /**
   * The category for Allstate
   *
   * Numeric Code: '3421'
   */ MerchantCategory["ALLSTATE"] = "ALLSTATE";
    /**
   * The category for Antilean Airlines (ALM)
   *
   * Numeric Code: '3252'
   */ MerchantCategory["ALM_AIRLINE"] = "ALM_AIRLINE";
    /**
   * The category for Aloft
   *
   * Numeric Code: '3619'
   */ MerchantCategory["ALOFT"] = "ALOFT";
    /**
   * The category for Aloha Airlines
   *
   * Numeric Code: '3251'
   */ MerchantCategory["ALOHA_AIRLINES"] = "ALOHA_AIRLINES";
    /**
   * The category for Altra Auto Rental
   *
   * Numeric Code: '3362'
   */ MerchantCategory["ALTRA_AUTO_RENTAL"] = "ALTRA_AUTO_RENTAL";
    /**
   * The category for Ambulance Services.
   *
   * Numeric code: '4119'
   */ MerchantCategory["AMBULANCE_SERVICES"] = "AMBULANCE_SERVICES";
    /**
   * The category for Amelia Island Plantation
   *
   * Numeric Code: '3754'
   */ MerchantCategory["AMELIA_ISLAND_PLANTATION"] = "AMELIA_ISLAND_PLANTATION";
    /**
   * The category for Americana Hotels Corporation
   *
   * Numeric Code: '3517'
   */ MerchantCategory["AMERICANA_HOTELS_CORPORATION"] = "AMERICANA_HOTELS_CORPORATION";
    /**
   * The category for American Airlines
   *
   * Numeric Code: '3001'
   */ MerchantCategory["AMERICAN_AIRLINES"] = "AMERICAN_AIRLINES";
    /**
   * The category for American International
   *
   * Numeric Code: '3352'
   */ MerchantCategory["AMERICAN_INTERNATIONAL"] = "AMERICAN_INTERNATIONAL";
    /**
   * The category for America’S Best Value Inn
   *
   * Numeric Code: '3617'
   */ MerchantCategory["AMERICAS_BEST_VALUE_INN"] = "AMERICAS_BEST_VALUE_INN";
    /**
   * The category for America West
   *
   * Numeric Code: '3253'
   */ MerchantCategory["AMERICA_WEST"] = "AMERICA_WEST";
    /**
   * The category for Americinn
   *
   * Numeric Code: '3614'
   */ MerchantCategory["AMERICINN"] = "AMERICINN";
    /**
   * The category for Amerisuites
   *
   * Numeric Code: '3514'
   */ MerchantCategory["AMERISUITES"] = "AMERISUITES";
    /**
   * The category for Amfac Hotels
   *
   * Numeric Code: '3536'
   */ MerchantCategory["AMFAC_HOTELS"] = "AMFAC_HOTELS";
    /**
   * The category for Amusement Parks/Carnivals.
   *
   * Numeric code: '7996'
   */ MerchantCategory["AMUSEMENT_PARKS_CARNIVALS"] = "AMUSEMENT_PARKS_CARNIVALS";
    /**
   * The category for All Nipon Airways
   *
   * Numeric Code: '3161'
   */ MerchantCategory["ANA_AIR"] = "ANA_AIR";
    /**
   * The category for Ana Hotels
   *
   * Numeric Code: '3537'
   */ MerchantCategory["ANA_HOTELS"] = "ANA_HOTELS";
    /**
   * The category for Ansa International
   *
   * Numeric Code: '3420'
   */ MerchantCategory["ANSA_INTERNATIONAL"] = "ANSA_INTERNATIONAL";
    /**
   * The category for Ansett Airlines
   *
   * Numeric Code: '3033'
   */ MerchantCategory["ANSETT_AIRLINES"] = "ANSETT_AIRLINES";
    /**
   * The category for Antique Reproductions.
   *
   * Numeric code: '5937'
   */ MerchantCategory["ANTIQUE_REPRODUCTIONS"] = "ANTIQUE_REPRODUCTIONS";
    /**
   * The category for Antique Shops.
   *
   * Numeric code: ['5932', '5832']
   */ MerchantCategory["ANTIQUE_SHOPS"] = "ANTIQUE_SHOPS";
    /**
   * The category for Aquariums.
   *
   * Numeric code: '7998'
   */ MerchantCategory["AQUARIUMS"] = "AQUARIUMS";
    /**
   * The category for Arabella Hotels
   *
   * Numeric Code: '3511'
   */ MerchantCategory["ARABELLA_HOTELS"] = "ARABELLA_HOTELS";
    /**
   * The category for Arcade
   *
   * Numeric Code: '3670'
   */ MerchantCategory["ARCADE"] = "ARCADE";
    /**
   * The category for Architectural/Surveying Services.
   *
   * Numeric code: '8911'
   */ MerchantCategory["ARCHITECTURAL_SURVEYING_SERVICES"] = "ARCHITECTURAL_SURVEYING_SERVICES";
    /**
   * The category for Arctia
   *
   * Numeric Code: '3671'
   */ MerchantCategory["ARCTIA"] = "ARCTIA";
    /**
   * The category for Aria
   *
   * Numeric Code: '3824'
   */ MerchantCategory["ARIA"] = "ARIA";
    /**
   * The category for Arizona Biltmore
   *
   * Numeric Code: '3594'
   */ MerchantCategory["ARIZONA_BILTMORE"] = "ARIZONA_BILTMORE";
    /**
   * The category for Artists Supply and Craft Shops.
   *
   * Numeric code: '5970'
   */ MerchantCategory["ARTISTS_SUPPLY_AND_CRAFT_SHOPS"] = "ARTISTS_SUPPLY_AND_CRAFT_SHOPS";
    /**
   * The category for Art Dealers and Galleries.
   *
   * Numeric code: '5971'
   */ MerchantCategory["ART_DEALERS_AND_GALLERIES"] = "ART_DEALERS_AND_GALLERIES";
    /**
   * The category for Aero Servicio Carabobo
   *
   * Numeric Code: '3263'
   */ MerchantCategory["ASC_AIRLINE"] = "ASC_AIRLINE";
    /**
   * The category for Asiana Airlines
   *
   * Numeric Code: '3098'
   */ MerchantCategory["ASIANA_AIRLINES"] = "ASIANA_AIRLINES";
    /**
   * The category for American Trans Air
   *
   * Numeric Code: '3259'
   */ MerchantCategory["ATA_AIR"] = "ATA_AIR";
    /**
   * The category for Atlantic City Hilton
   *
   * Numeric Code: '3797'
   */ MerchantCategory["ATLANTIC_CITY_HILTON"] = "ATLANTIC_CITY_HILTON";
    /**
   * The category for Auberge Des Governeurs
   *
   * Numeric Code: '3549'
   */ MerchantCategory["AUBERGE_DES_GOVERNEURS"] = "AUBERGE_DES_GOVERNEURS";
    /**
   * The category for Austrian Airlines
   *
   * Numeric Code: '3051'
   */ MerchantCategory["AUSTRIAN_AIR"] = "AUSTRIAN_AIR";
    /**
   * The category for Austrian Air Service
   *
   * Numeric Code: '3243'
   */ MerchantCategory["AUSTRIAN_AIR_SERVICE"] = "AUSTRIAN_AIR_SERVICE";
    /**
   * The category for Autograph
   *
   * Numeric Code: '3826'
   */ MerchantCategory["AUTOGRAPH"] = "AUTOGRAPH";
    /**
   * The category for Autohansa
   *
   * Numeric Code: '3436'
   */ MerchantCategory["AUTOHANSA"] = "AUTOHANSA";
    /**
   * The category for Automate
   *
   * Numeric Code: '3425'
   */ MerchantCategory["AUTOMATE"] = "AUTOMATE";
    /**
   * The category for Automated Cash Disburse.
   *
   * Numeric code: '6011'
   */ MerchantCategory["AUTOMATED_CASH_DISBURSE"] = "AUTOMATED_CASH_DISBURSE";
    /**
   * The category for Automated Fuel Dispensers.
   *
   * Numeric code: '5542'
   */ MerchantCategory["AUTOMATED_FUEL_DISPENSERS"] = "AUTOMATED_FUEL_DISPENSERS";
    /**
   * The category for Automobile Associations.
   *
   * Numeric code: '8675'
   */ MerchantCategory["AUTOMOBILE_ASSOCIATIONS"] = "AUTOMOBILE_ASSOCIATIONS";
    /**
   * The category for Automotive Parts and Accessories Stores.
   *
   * Numeric code: '5533'
   */ MerchantCategory["AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES"] = "AUTOMOTIVE_PARTS_AND_ACCESSORIES_STORES";
    /**
   * The category for Automotive Tire Stores.
   *
   * Numeric code: '5532'
   */ MerchantCategory["AUTOMOTIVE_TIRE_STORES"] = "AUTOMOTIVE_TIRE_STORES";
    /**
   * The category for Auto and Home Supply Stores.
   *
   * Numeric code: '5531'
   */ MerchantCategory["AUTO_AND_HOME_SUPPLY_STORES"] = "AUTO_AND_HOME_SUPPLY_STORES";
    /**
   * The category for Auto Body Repair Shops.
   *
   * Numeric code: '7531'
   */ MerchantCategory["AUTO_BODY_REPAIR_SHOPS"] = "AUTO_BODY_REPAIR_SHOPS";
    /**
   * The category for Auto Host Rental Cars
   *
   * Numeric Code: '3400'
   */ MerchantCategory["AUTO_HOST_RENTAL_CARS"] = "AUTO_HOST_RENTAL_CARS";
    /**
   * The category for Auto Paint Shops.
   *
   * Numeric code: '7535'
   */ MerchantCategory["AUTO_PAINT_SHOPS"] = "AUTO_PAINT_SHOPS";
    /**
   * The category for Auto Service Shops.
   *
   * Numeric code: '7538'
   */ MerchantCategory["AUTO_SERVICE_SHOPS"] = "AUTO_SERVICE_SHOPS";
    /**
   * The category for Avcar
   *
   * Numeric Code: '3423'
   */ MerchantCategory["AVCAR"] = "AVCAR";
    /**
   * The category for Avensa
   *
   * Numeric Code: '3242'
   */ MerchantCategory["AVENSA_AIR"] = "AVENSA_AIR";
    /**
   * The category for Aviacion Y Comercio (AVIACO)
   *
   * Numeric Code: '3053'
   */ MerchantCategory["AVIACO_AIR"] = "AVIACO_AIR";
    /**
   * The category for Avianca
   *
   * Numeric Code: '3039'
   */ MerchantCategory["AVIANCA"] = "AVIANCA";
    /**
   * The category for Aviateca
   *
   * Numeric Code: '3241'
   */ MerchantCategory["AVIATECA_AIR"] = "AVIATECA_AIR";
    /**
   * The category for Avis Rent A Car
   *
   * Numeric Code: '3389'
   */ MerchantCategory["AVIS_RENT_A_CAR"] = "AVIS_RENT_A_CAR";
    /**
   * The category for Avon Rent A Car
   *
   * Numeric Code: '3427'
   */ MerchantCategory["AVON_RENT_A_CAR"] = "AVON_RENT_A_CAR";
    /**
   * The category for Azul Brazilian Airlines
   *
   * Numeric Code: '3300'
   */ MerchantCategory["AZUL_BRAZILIAN_AIRLINES"] = "AZUL_BRAZILIAN_AIRLINES";
    /**
   * The category for Bahamasair
   *
   * Numeric Code: '3240'
   */ MerchantCategory["BAHAMAS_AIR"] = "BAHAMAS_AIR";
    /**
   * The category for "Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government agency)".
   *
   * Numeric code: '9223'
   */ MerchantCategory["BAIL_AND_BOND_PAYMENTS"] = "BAIL_AND_BOND_PAYMENTS";
    /**
   * The category for Bakeries.
   *
   * Numeric code: '5462'
   */ MerchantCategory["BAKERIES"] = "BAKERIES";
    /**
   * The category for Balkan-Bulgarian Airlines
   *
   * Numeric Code: '3041'
   */ MerchantCategory["BALKAN_AIR"] = "BALKAN_AIR";
    /**
   * The category for Ballys Hotel And Casino
   *
   * Numeric Code: '3728'
   */ MerchantCategory["BALLYS_HOTEL_AND_CASINO"] = "BALLYS_HOTEL_AND_CASINO";
    /**
   * The category for "Bands, Orchestras".
   *
   * Numeric code: '7929'
   */ MerchantCategory["BANDS_ORCHESTRAS"] = "BANDS_ORCHESTRAS";
    /**
   * The category for Banyan Tree Hotels and Resorts
   *
   * Numeric code: '3856'
   */ MerchantCategory["BANYAN_TREE_HOTELS_AND_RESORTS"] = "BANYAN_TREE_HOTELS_AND_RESORTS";
    /**
   * The category for Barber and Beauty Shops.
   *
   * Numeric code: '7230'
   */ MerchantCategory["BARBER_AND_BEAUTY_SHOPS"] = "BARBER_AND_BEAUTY_SHOPS";
    /**
   * The category for Barton Creek Resort
   *
   * Numeric Code: '3556'
   */ MerchantCategory["BARTON_CREEK_RESORT"] = "BARTON_CREEK_RESORT";
    /**
   * The category for Bar Harbor Airlines
   *
   * Numeric Code: '3239'
   */ MerchantCategory["BAR_HARBOR_AIRLINES"] = "BAR_HARBOR_AIRLINES";
    /**
   * The category for Baymont Inn & Suites
   *
   * Numeric Code: '3834'
   */ MerchantCategory["BAYMONT_INN_SUITES"] = "BAYMONT_INN_SUITES";
    /**
   * The category for Beau Rivage Hotel And Casino
   *
   * Numeric Code: '3764'
   */ MerchantCategory["BEAU_RIVAGE_HOTEL_AND_CASINO"] = "BEAU_RIVAGE_HOTEL_AND_CASINO";
    /**
   * The category for Bellagio
   *
   * Numeric Code: '3765'
   */ MerchantCategory["BELLAGIO"] = "BELLAGIO";
    /**
   * The category for Bemidji Aviation
   *
   * Numeric Code: '3238'
   */ MerchantCategory["BEMIDJI_AIR"] = "BEMIDJI_AIR";
    /**
   * The category for Best Western
   *
   * Numeric Code: '3502'
   */ MerchantCategory["BEST_WESTERN"] = "BEST_WESTERN";
    /**
   * The category for Betting/Casino Gambling.
   *
   * Numeric code: '7995'
   */ MerchantCategory["BETTING_CASINO_GAMBLING"] = "BETTING_CASINO_GAMBLING";
    /**
   * The category for Beverly Hills Hotel
   *
   * Numeric Code: '3749'
   */ MerchantCategory["BEVERLY_HILLS_HOTEL"] = "BEVERLY_HILLS_HOTEL";
    /**
   * The category for Bicycle Shops.
   *
   * Numeric code: '5940'
   */ MerchantCategory["BICYCLE_SHOPS"] = "BICYCLE_SHOPS";
    /**
   * The category for Billiard/Pool Establishments.
   *
   * Numeric code: '7932'
   */ MerchantCategory["BILLIARD_POOL_ESTABLISHMENTS"] = "BILLIARD_POOL_ESTABLISHMENTS";
    /**
   * The category for Biltmore Hotel And Suites
   *
   * Numeric Code: '3743'
   */ MerchantCategory["BILTMORE_HOTEL_AND_SUITES"] = "BILTMORE_HOTEL_AND_SUITES";
    /**
   * The category for Binions Horseshoe Club
   *
   * Numeric Code: '3620'
   */ MerchantCategory["BINIONS_HORSESHOE_CLUB"] = "BINIONS_HORSESHOE_CLUB";
    /**
   * The category for Blueprinting and Photocopying Services
   *
   * Numeric Code: '7332'
   */ MerchantCategory["BLUEPRINTING_AND_PHOTOCOPYING_SERVICES"] = "BLUEPRINTING_AND_PHOTOCOPYING_SERVICES";
    /**
   * The category for Boat Dealers.
   *
   * Numeric code: '5551'
   */ MerchantCategory["BOAT_DEALERS"] = "BOAT_DEALERS";
    /**
   * The category for Boat Rentals and Leases.
   *
   * Numeric code: '4457'
   */ MerchantCategory["BOAT_RENTALS_AND_LEASES"] = "BOAT_RENTALS_AND_LEASES";
    /**
   * The category for Boca Raton Resort
   *
   * Numeric Code: '3733'
   */ MerchantCategory["BOCA_RATON_RESORT"] = "BOCA_RATON_RESORT";
    /**
   * The category for "Books, Periodicals, and Newspapers".
   *
   * Numeric code: '5192'
   */ MerchantCategory["BOOKS_PERIODICALS_AND_NEWSPAPERS"] = "BOOKS_PERIODICALS_AND_NEWSPAPERS";
    /**
   * The category for Book Stores.
   *
   * Numeric code: '5942'
   */ MerchantCategory["BOOK_STORES"] = "BOOK_STORES";
    /**
   * The category for Bowling Alleys.
   *
   * Numeric code: '7933'
   */ MerchantCategory["BOWLING_ALLEYS"] = "BOWLING_ALLEYS";
    /**
   * The category for Braathens S.A.F.E
   *
   * Numeric Code: '3106'
   */ MerchantCategory["BRAATHENS"] = "BRAATHENS";
    /**
   * The category for Bradbury Suites
   *
   * Numeric Code: '3683'
   */ MerchantCategory["BRADBURY_SUITES"] = "BRADBURY_SUITES";
    /**
   * The category for Breakers Resort
   *
   * Numeric Code: '3547'
   */ MerchantCategory["BREAKERS_RESORT"] = "BREAKERS_RESORT";
    /**
   * The category for Breezbay Group
   *
   * Numeric code: '3850'
   */ MerchantCategory["BREEZBAY_HOTEL_GROUP"] = "BREEZBAY_HOTEL_GROUP";
    /**
   * The category for British Airways
   *
   * Numeric Code: '3005'
   */ MerchantCategory["BRITISH_AIRWAYS"] = "BRITISH_AIRWAYS";
    /**
   * The category for British Midland Air
   *
   * Numeric Code: '3111'
   */ MerchantCategory["BRITISH_MIDLAND_AIR"] = "BRITISH_MIDLAND_AIR";
    /**
   * The category for Broadmoor Hotel
   *
   * Numeric Code: '3727'
   */ MerchantCategory["BROADMOOR_HOTEL"] = "BROADMOOR_HOTEL";
    /**
   * The category for Brockway Air
   *
   * Numeric Code: '3235'
   */ MerchantCategory["BROCKWAY_AIR"] = "BROCKWAY_AIR";
    /**
   * The category for Brooks Rent A Car
   *
   * Numeric Code: '3353'
   */ MerchantCategory["BROOKS_RENT_A_CAR"] = "BROOKS_RENT_A_CAR";
    /**
   * The category for Budgetel
   *
   * Numeric Code: '3685'
   */ MerchantCategory["BUDGETEL"] = "BUDGETEL";
    /**
   * The category for Budget Host Inns
   *
   * Numeric Code: '3684'
   */ MerchantCategory["BUDGET_HOST_INNS"] = "BUDGET_HOST_INNS";
    /**
   * The category for Budget Rent A Car
   *
   * Numeric Code: '3366'
   */ MerchantCategory["BUDGET_RENT_A_CAR"] = "BUDGET_RENT_A_CAR";
    /**
   * The category for Buffalo Bills Hotel And Casino
   *
   * Numeric Code: '3712'
   */ MerchantCategory["BUFFALO_BILLS_HOTEL_AND_CASINO"] = "BUFFALO_BILLS_HOTEL_AND_CASINO";
    /**
   * The category for Bulgari
   *
   * Numeric code: '3845'
   */ MerchantCategory["BULGARI"] = "BULGARI";
    /**
   * The category for Business/Secretarial Schools.
   *
   * Numeric code: '8244'
   */ MerchantCategory["BUSINESS_SECRETARIAL_SCHOOLS"] = "BUSINESS_SECRETARIAL_SCHOOLS";
    /**
   * The category for Bus Lines.
   *
   * Numeric code: '4131'
   */ MerchantCategory["BUS_LINES"] = "BUS_LINES";
    /**
   * The category for Buying/Shopping Services.
   *
   * Numeric code: '7278'
   */ MerchantCategory["BUYING_SHOPPING_SERVICES"] = "BUYING_SHOPPING_SERVICES";
    /**
   * The category for "Cable, Satellite, and Other Pay Television and Radio".
   *
   * Numeric code: '4899'
   */ MerchantCategory["CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO"] = "CABLE_SATELLITE_AND_OTHER_PAY_TELEVISION_AND_RADIO";
    /**
   * The category for Caesars Hotel And Casino
   *
   * Numeric Code: '3771'
   */ MerchantCategory["CAESARS_HOTEL_AND_CASINO"] = "CAESARS_HOTEL_AND_CASINO";
    /**
   * The category for California Hotel And Casino
   *
   * Numeric Code: '3582'
   */ MerchantCategory["CALIFORNIA_HOTEL_AND_CASINO"] = "CALIFORNIA_HOTEL_AND_CASINO";
    /**
   * The category for Camera and Photographic Supply Stores.
   *
   * Numeric code: '5946'
   */ MerchantCategory["CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES"] = "CAMERA_AND_PHOTOGRAPHIC_SUPPLY_STORES";
    /**
   * The category for Campanile
   *
   * Numeric Code: '3672'
   */ MerchantCategory["CAMPANILE"] = "CAMPANILE";
    /**
   * The category for Canadian Airlines International
   *
   * Numeric Code: '3171'
   */ MerchantCategory["CANADIAN_AIR"] = "CANADIAN_AIR";
    /**
   * The category for Canadian Pacific
   *
   * Numeric Code: '3529'
   */ MerchantCategory["CANADIAN_PACIFIC"] = "CANADIAN_PACIFIC";
    /**
   * The category for Candeo Hotels
   *
   * Numeric code: '3851'
   */ MerchantCategory["CANDEO_HOTELS"] = "CANDEO_HOTELS";
    /**
   * The category for Candlewood Suites
   *
   * Numeric Code: '3559'
   */ MerchantCategory["CANDLEWOOD_SUITES"] = "CANDLEWOOD_SUITES";
    /**
   * The category for "Candy, Nut, and Confectionery Stores".
   *
   * Numeric code: '5441'
   */ MerchantCategory["CANDY_NUT_AND_CONFECTIONERY_STORES"] = "CANDY_NUT_AND_CONFECTIONERY_STORES";
    /**
   * The category for Canyon Ranch
   *
   * Numeric Code: '3757'
   */ MerchantCategory["CANYON_RANCH"] = "CANYON_RANCH";
    /**
   * The category for Capitol Air
   *
   * Numeric Code: '3233'
   */ MerchantCategory["CAPITOL_AIR"] = "CAPITOL_AIR";
    /**
   * The category for Carefree Resorts
   *
   * Numeric Code: '3744'
   */ MerchantCategory["CAREFREE_RESORTS"] = "CAREFREE_RESORTS";
    /**
   * The category for Carey
   *
   * Numeric Code: '3428'
   */ MerchantCategory["CAREY"] = "CAREY";
    /**
   * The category for Caribbean Airlines
   *
   * Numeric Code: '3234'
   */ MerchantCategory["CARIBBEAN_AIRLINES"] = "CARIBBEAN_AIRLINES";
    /**
   * The category for Caribe Royal
   *
   * Numeric Code: '3821'
   */ MerchantCategory["CARIBE_ROYAL"] = "CARIBE_ROYAL";
    /**
   * The category for Caribe Royal Resort Suite And Villas
   *
   * Numeric Code: '3787'
   */ MerchantCategory["CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS"] = "CARIBE_ROYAL_RESORT_SUITE_AND_VILLAS";
    /**
   * The category for Carlton Hotels
   *
   * Numeric Code: '3716'
   */ MerchantCategory["CARLTON_HOTELS"] = "CARLTON_HOTELS";
    /**
   * The category for Carnival Airlines
   *
   * Numeric Code: '3086'
   */ MerchantCategory["CARNIVAL_AIRLINES"] = "CARNIVAL_AIRLINES";
    /**
   * The category for Carpentry Services.
   *
   * Numeric code: '1750'
   */ MerchantCategory["CARPENTRY_SERVICES"] = "CARPENTRY_SERVICES";
    /**
   * The category for Carpet/Upholstery Cleaning.
   *
   * Numeric code: '7217'
   */ MerchantCategory["CARPET_UPHOLSTERY_CLEANING"] = "CARPET_UPHOLSTERY_CLEANING";
    /**
   * The category for "Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing".
   *
   * Numeric code: '5511'
   */ MerchantCategory["CAR_AND_TRUCK_DEALERS_NEW_USED"] = "CAR_AND_TRUCK_DEALERS_NEW_USED";
    /**
   * The category for "Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing".
   *
   * Numeric code: '5521'
   */ MerchantCategory["CAR_AND_TRUCK_DEALERS_USED_ONLY"] = "CAR_AND_TRUCK_DEALERS_USED_ONLY";
    /**
   * The category for Car Rentals.
   *
   * Numeric Codes: ['3356','3358','3363','3365','3367','3369','3371','3372','3373','3375','3377','3378','3379','3382','3383','3384','3392','3397','3399','3401','3402','3403','3404','3406','3407','3408','3410','3411','3413','3415','3416','3417','3418','3419','3422','3424','3426','3440']
   */ MerchantCategory["CAR_RENTAL"] = "CAR_RENTAL";
    /**
   * The category for Car Rental Agencies.
   *
   * Numeric code: '7512'
   */ MerchantCategory["CAR_RENTAL_AGENCIES"] = "CAR_RENTAL_AGENCIES";
    /**
   * The category for Car Washes.
   *
   * Numeric code: '7542'
   */ MerchantCategory["CAR_WASHES"] = "CAR_WASHES";
    /**
   * The category for Caterers.
   *
   * Numeric code: '5811'
   */ MerchantCategory["CATERERS"] = "CATERERS";
    /**
   * The category for Cathay Pacific
   *
   * Numeric Code: '3099'
   */ MerchantCategory["CATHAY_PACIFIC"] = "CATHAY_PACIFIC";
    /**
   * The category for Cayman Airways
   *
   * Numeric Code: '3228'
   */ MerchantCategory["CAYMAN_AIRWAYS"] = "CAYMAN_AIRWAYS";
    /**
   * The category for Cebu Pacific Airlines
   *
   * Numeric Code: '3072'
   */ MerchantCategory["CEBU_PACIFIC_AIRLINES"] = "CEBU_PACIFIC_AIRLINES";
    /**
   * The category for Centurion Hotels
   *
   * Numeric code: '3882'
   */ MerchantCategory["CENTURION_HOTELS"] = "CENTURION_HOTELS";
    /**
   * The category for C'est La Vie Resort Izumigo
   *
   * Numeric code: '3855'
   */ MerchantCategory["CEST_LA_VIE_RESORT_IZUMIGO"] = "CEST_LA_VIE_RESORT_IZUMIGO";
    /**
   * The category for Champagne Producers.
   *
   * Numeric code: '0744'
   */ MerchantCategory["CHAMPAGNE_PRODUCERS"] = "CHAMPAGNE_PRODUCERS";
    /**
   * The category for Charitable and Social Service Organizations - Fundraising.
   *
   * Numeric code: '8398'
   */ MerchantCategory["CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING"] = "CHARITABLE_AND_SOCIAL_SERVICE_ORGANIZATIONS_FUNDRAISING";
    /**
   * The category for Chateau Elan Winery And Resort
   *
   * Numeric Code: '3763'
   */ MerchantCategory["CHATEAU_ELAN_WINERY_AND_RESORT"] = "CHATEAU_ELAN_WINERY_AND_RESORT";
    /**
   * The category for Chemicals and Allied Products (Not Elsewhere Classified).
   *
   * Numeric code: '5169'
   */ MerchantCategory["CHEMICALS_AND_ALLIED_PRODUCTS"] = "CHEMICALS_AND_ALLIED_PRODUCTS";
    /**
   * The category for Children's and Infants Wear Stores.
   *
   * Numeric code: '5641'
   */ MerchantCategory["CHILDRENS_AND_INFANTS_WEAR_STORES"] = "CHILDRENS_AND_INFANTS_WEAR_STORES";
    /**
   * The category for Child Care Services.
   *
   * Numeric code: '8351'
   */ MerchantCategory["CHILD_CARE_SERVICES"] = "CHILD_CARE_SERVICES";
    /**
   * The category for China Airlines
   *
   * Numeric Code: '3078'
   */ MerchantCategory["CHINA_AIRLINES"] = "CHINA_AIRLINES";
    /**
   * The category for China Eastern Airlines
   *
   * Numeric Code: '3206'
   */ MerchantCategory["CHINA_EASTERN_AIRLINES"] = "CHINA_EASTERN_AIRLINES";
    /**
   * The category for China Southern Airlines
   *
   * Numeric Code: '3308'
   */ MerchantCategory["CHINA_SOUTHERN_AIRLINES"] = "CHINA_SOUTHERN_AIRLINES";
    /**
   * The category for "Chiropodists, Podiatrists".
   *
   * Numeric code: '8049'
   */ MerchantCategory["CHIROPODISTS_PODIATRISTS"] = "CHIROPODISTS_PODIATRISTS";
    /**
   * The category for Chiropractors.
   *
   * Numeric code: '8041'
   */ MerchantCategory["CHIROPRACTORS"] = "CHIROPRACTORS";
    /**
   * The category for Chisun Hotels
   *
   * Numeric code: '3862'
   */ MerchantCategory["CHISUN_HOTELS"] = "CHISUN_HOTELS";
    /**
   * The category for Cigahotels
   *
   * Numeric Code: '3544'
   */ MerchantCategory["CIGAHOTELS"] = "CIGAHOTELS";
    /**
   * The category for Cigar Stores and Stands.
   *
   * Numeric code: '5993'
   */ MerchantCategory["CIGAR_STORES_AND_STANDS"] = "CIGAR_STORES_AND_STANDS";
    /**
   * The category for Circus Circus Hotel And Casino
   *
   * Numeric Code: '3662'
   */ MerchantCategory["CIRCUS_CIRCUS_HOTEL_AND_CASINO"] = "CIRCUS_CIRCUS_HOTEL_AND_CASINO";
    /**
   * The category for Cite
   *
   * Numeric Code: '3437'
   */ MerchantCategory["CITE"] = "CITE";
    /**
   * The category for City Lodge Hotels
   *
   * Numeric Code: '3717'
   */ MerchantCategory["CITY_LODGE_HOTELS"] = "CITY_LODGE_HOTELS";
    /**
   * The category for "Civic, Social, Fraternal Associations".
   *
   * Numeric code: '8641'
   */ MerchantCategory["CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS"] = "CIVIC_SOCIAL_FRATERNAL_ASSOCIATIONS";
    /**
   * The category for Claridge Casino Hotel
   *
   * Numeric Code: '3792'
   */ MerchantCategory["CLARIDGE_CASINO_HOTEL"] = "CLARIDGE_CASINO_HOTEL";
    /**
   * The category for Clarion Hotel
   *
   * Numeric Code: '3687'
   */ MerchantCategory["CLARION_HOTEL"] = "CLARION_HOTEL";
    /**
   * The category for Cleaning and Maintenance.
   *
   * Numeric code: '7349'
   */ MerchantCategory["CLEANING_AND_MAINTENANCE"] = "CLEANING_AND_MAINTENANCE";
    /**
   * The category for Climat De France
   *
   * Numeric Code: '3677'
   */ MerchantCategory["CLIMAT_DE_FRANCE"] = "CLIMAT_DE_FRANCE";
    /**
   * The category for Clothing Rental.
   *
   * Numeric code: '7296'
   */ MerchantCategory["CLOTHING_RENTAL"] = "CLOTHING_RENTAL";
    /**
   * The category for Club Corporation Club Resorts
   *
   * Numeric Code: '3747'
   */ MerchantCategory["CLUB_CORPORATION_CLUB_RESORTS"] = "CLUB_CORPORATION_CLUB_RESORTS";
    /**
   * The category for Club Med
   *
   * Numeric Code: '3742'
   */ MerchantCategory["CLUB_MED"] = "CLUB_MED";
    /**
   * The category for Coast Hotels
   *
   * Numeric Code: '3552'
   */ MerchantCategory["COAST_HOTELS"] = "COAST_HOTELS";
    /**
   * The category for "Colleges, Universities".
   *
   * Numeric code: '8220'
   */ MerchantCategory["COLLEGES_UNIVERSITIES"] = "COLLEGES_UNIVERSITIES";
    /**
   * The category for Colorado Belle Edgewater Resort
   *
   * Numeric Code: '3736'
   */ MerchantCategory["COLORADO_BELLE_EDGEWATER_RESORT"] = "COLORADO_BELLE_EDGEWATER_RESORT";
    /**
   * The category for Comair
   *
   * Numeric Code: '3223'
   */ MerchantCategory["COMAIR"] = "COMAIR";
    /**
   * The category for Comfort Hotel International
   *
   * Numeric Code: '3562'
   */ MerchantCategory["COMFORT_HOTEL_INTERNATIONAL"] = "COMFORT_HOTEL_INTERNATIONAL";
    /**
   * The category for Command Airways
   *
   * Numeric Code: '3222'
   */ MerchantCategory["COMMAND_AIR"] = "COMMAND_AIR";
    /**
   * The category for Commercial Equipment (Not Elsewhere Classified).
   *
   * Numeric code: '5046'
   */ MerchantCategory["COMMERCIAL_EQUIPMENT"] = "COMMERCIAL_EQUIPMENT";
    /**
   * The category for Commercial Footwear.
   *
   * Numeric code: '5139'
   */ MerchantCategory["COMMERCIAL_FOOTWEAR"] = "COMMERCIAL_FOOTWEAR";
    /**
   * The category for "Commercial Photography, Art and Graphics".
   *
   * Numeric code: '7333'
   */ MerchantCategory["COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS"] = "COMMERCIAL_PHOTOGRAPHY_ART_AND_GRAPHICS";
    /**
   * The category for "Commuter Transport, Ferries".
   *
   * Numeric code: '4111'
   */ MerchantCategory["COMMUTER_TRANSPORT_AND_FERRIES"] = "COMMUTER_TRANSPORT_AND_FERRIES";
    /**
   * The category for Compri Hotel
   *
   * Numeric Code: '3688'
   */ MerchantCategory["COMPRI_HOTEL"] = "COMPRI_HOTEL";
    /**
   * The category for "Computers, Peripherals, and Software".
   *
   * Numeric code: '5045'
   */ MerchantCategory["COMPUTERS_PERIPHERALS_AND_SOFTWARE"] = "COMPUTERS_PERIPHERALS_AND_SOFTWARE";
    /**
   * The category for Computer Network Services.
   *
   * Numeric code: '4816'
   */ MerchantCategory["COMPUTER_NETWORK_SERVICES"] = "COMPUTER_NETWORK_SERVICES";
    /**
   * The category for Computer Programming.
   *
   * Numeric code: '7372'
   */ MerchantCategory["COMPUTER_PROGRAMMING"] = "COMPUTER_PROGRAMMING";
    /**
   * The category for Computer Repair.
   *
   * Numeric code: '7379'
   */ MerchantCategory["COMPUTER_REPAIR"] = "COMPUTER_REPAIR";
    /**
   * The category for Computer Software Stores.
   *
   * Numeric code: '5734'
   */ MerchantCategory["COMPUTER_SOFTWARE_STORES"] = "COMPUTER_SOFTWARE_STORES";
    /**
   * The category for Compania Faucett
   *
   * Numeric Code: '3220'
   */ MerchantCategory["COMP_FAU_AIR"] = "COMP_FAU_AIR";
    /**
   * The category for Concession.
   *
   * Numeric code: '1003'
   */ MerchantCategory["CONCESSION"] = "CONCESSION";
    /**
   * The category for Concorde Hotels
   *
   * Numeric Code: '3538'
   */ MerchantCategory["CONCORDE_HOTELS"] = "CONCORDE_HOTELS";
    /**
   * The category for Concrete Work Services.
   *
   * Numeric code: '1771'
   */ MerchantCategory["CONCRETE_WORK_SERVICES"] = "CONCRETE_WORK_SERVICES";
    /**
   * The category for Conrad Hotels
   *
   * Numeric Code: '3721'
   */ MerchantCategory["CONRAD_HOTELS"] = "CONRAD_HOTELS";
    /**
   * The category for Consort
   *
   * Numeric Code: '3689'
   */ MerchantCategory["CONSORT"] = "CONSORT";
    /**
   * The category for Construction Materials (Not Elsewhere Classified).
   *
   * Numeric code: '5039'
   */ MerchantCategory["CONSTRUCTION_MATERIALS"] = "CONSTRUCTION_MATERIALS";
    /**
   * The category for "Consulting, Public Relations".
   *
   * Numeric code: '7392'
   */ MerchantCategory["CONSULTING_PUBLIC_RELATIONS"] = "CONSULTING_PUBLIC_RELATIONS";
    /**
   * The category for Continental Airlines
   *
   * Numeric Code: '3061'
   */ MerchantCategory["CONTINENTAL_AIRLINES"] = "CONTINENTAL_AIRLINES";
    /**
   * The category for Compania Panamena De Aviacion (COPA)
   *
   * Numeric Code: '3219'
   */ MerchantCategory["COPA_AIR"] = "COPA_AIR";
    /**
   * The category for Core Global Management Hotels and Resorts
   *
   * Numeric code: '3852'
   */ MerchantCategory["CORE_GLOBAL_MANAGEMENT_HOTELS_AND_RESORTS"] = "CORE_GLOBAL_MANAGEMENT_HOTELS_AND_RESORTS";
    /**
   * The category for Correspondence Schools.
   *
   * Numeric code: '8241'
   */ MerchantCategory["CORRESPONDENCE_SCHOOLS"] = "CORRESPONDENCE_SCHOOLS";
    /**
   * The category for Cosmetic Stores.
   *
   * Numeric code: '5977'
   */ MerchantCategory["COSMETIC_STORES"] = "COSMETIC_STORES";
    /**
   * The category for Cosmopolitan Of Las Vegas
   *
   * Numeric Code: '3828'
   */ MerchantCategory["COSMOPOLITAN_OF_LAS_VEGAS"] = "COSMOPOLITAN_OF_LAS_VEGAS";
    /**
   * The category for Counseling Services.
   *
   * Numeric code: '7277'
   */ MerchantCategory["COUNSELING_SERVICES"] = "COUNSELING_SERVICES";
    /**
   * The category for Country Clubs.
   *
   * Numeric code: '7997'
   */ MerchantCategory["COUNTRY_CLUBS"] = "COUNTRY_CLUBS";
    /**
   * The category for Country Inn By Carlson
   *
   * Numeric Code: '3829'
   */ MerchantCategory["COUNTRY_INN_BY_CARLSON"] = "COUNTRY_INN_BY_CARLSON";
    /**
   * The category for Courier Services.
   *
   * Numeric code: '4215'
   */ MerchantCategory["COURIER_SERVICES"] = "COURIER_SERVICES";
    /**
   * The category for Courtyard By Marriott
   *
   * Numeric Code: '3690'
   */ MerchantCategory["COURTYARD_BY_MARRIOTT"] = "COURTYARD_BY_MARRIOTT";
    /**
   * The category for "Court Costs, Including Alimony and Child Support - Courts of Law".
   *
   * Numeric code: '9211'
   */ MerchantCategory["COURT_COSTS"] = "COURT_COSTS";
    /**
   * The category for Credit Reporting Agencies.
   *
   * Numeric code: '7321'
   */ MerchantCategory["CREDIT_REPORTING_AGENCIES"] = "CREDIT_REPORTING_AGENCIES";
    /**
   * The category for Crest Hotels
   *
   * Numeric Code: '3521'
   */ MerchantCategory["CREST_HOTELS"] = "CREST_HOTELS";
    /**
   * The category for Croatia Air
   *
   * Numeric Code: '3088'
   */ MerchantCategory["CROATIA_AIR"] = "CROATIA_AIR";
    /**
   * The category for Crossland
   *
   * Numeric Code: '3822'
   */ MerchantCategory["CROSSLAND"] = "CROSSLAND";
    /**
   * The category for Crowne Plaza Hotels
   *
   * Numeric Code: '3750'
   */ MerchantCategory["CROWNE_PLAZA_HOTELS"] = "CROWNE_PLAZA_HOTELS";
    /**
   * The category for Crown Air
   *
   * Numeric Code: '3218'
   */ MerchantCategory["CROWN_AIR"] = "CROWN_AIR";
    /**
   * The category for Cruise Lines.
   *
   * Numeric code: '4411'
   */ MerchantCategory["CRUISE_LINES"] = "CRUISE_LINES";
    /**
   * The category for Cruzeiro Do Sul
   *
   * Numeric Code: '3046'
   */ MerchantCategory["CRUZIERO_AIR"] = "CRUZIERO_AIR";
    /**
   * The category for Ceskoslovenske Aerolinie (CSA)
   *
   * Numeric Code: '3217'
   */ MerchantCategory["CSA_AIRLINE"] = "CSA_AIRLINE";
    /**
   * The category for Cumberland Airlines
   *
   * Numeric Code: '3216'
   */ MerchantCategory["CUMBERLAND_AIRLINES"] = "CUMBERLAND_AIRLINES";
    /**
   * The category for Cumulus Hotels
   *
   * Numeric Code: '3678'
   */ MerchantCategory["CUMULUS_HOTELS"] = "CUMULUS_HOTELS";
    /**
   * The category for Cunard Hotels
   *
   * Numeric Code: '3593'
   */ MerchantCategory["CUNARD_HOTELS"] = "CUNARD_HOTELS";
    /**
   * The category for Curio - A Collection by Hilton
   *
   * Numeric Code: '3832'
   */ MerchantCategory["CURIO_HOTELS"] = "CURIO_HOTELS";
    /**
   * The category for Cyprus Airways
   *
   * Numeric Code: '3292'
   */ MerchantCategory["CYPRUS_AIRWAYS"] = "CYPRUS_AIRWAYS";
    /**
   * The category for C Mon Inn
   *
   * Numeric Code: '3611'
   */ MerchantCategory["C_MON_INN"] = "C_MON_INN";
    /**
   * The category for Dairy Products Stores.
   *
   * Numeric code: '5451'
   */ MerchantCategory["DAIRY_PRODUCTS_STORES"] = "DAIRY_PRODUCTS_STORES";
    /**
   * The category for "Dance Hall, Studios, Schools".
   *
   * Numeric code: '7911'
   */ MerchantCategory["DANCE_HALL_STUDIOS_SCHOOLS"] = "DANCE_HALL_STUDIOS_SCHOOLS";
    /**
   * The category for Dan Air Services
   *
   * Numeric Code: '3215'
   */ MerchantCategory["DAN_AIR_SERVICES"] = "DAN_AIR_SERVICES";
    /**
   * The category for Dan Hotels
   *
   * Numeric Code: '3629'
   */ MerchantCategory["DAN_HOTELS"] = "DAN_HOTELS";
    /**
   * The category for Dating/Escort Services.
   *
   * Numeric code: '7273'
   */ MerchantCategory["DATING_ESCORT_SERVICES"] = "DATING_ESCORT_SERVICES";
    /**
   * The category for Days Inns Of America
   *
   * Numeric Code: '3510'
   */ MerchantCategory["DAYS_INNS_OF_AMERICA"] = "DAYS_INNS_OF_AMERICA";
    /**
   * The category for DBA Airlines
   *
   * Numeric Code: '3059'
   */ MerchantCategory["DBA_AIR"] = "DBA_AIR";
    /**
   * The category for Debt Collection Agencies
   *
   * Numeric code: '7322'
   */ MerchantCategory["DEBT_COLLECTION_AGENCIES"] = "DEBT_COLLECTION_AGENCIES";
    /**
   * The category for Delta Airlines
   *
   * Numeric Code: '3058'
   */ MerchantCategory["DELTA_AIRLINES"] = "DELTA_AIRLINES";
    /**
   * The category for Delta Hotels
   *
   * Numeric Code: '3581'
   */ MerchantCategory["DELTA_HOTELS"] = "DELTA_HOTELS";
    /**
   * The category for "Dentists, Orthodontists".
   *
   * Numeric code: '8021'
   */ MerchantCategory["DENTISTS_ORTHODONTISTS"] = "DENTISTS_ORTHODONTISTS";
    /**
   * The category for Department Stores.
   *
   * Numeric code: '5311'
   */ MerchantCategory["DEPARTMENT_STORES"] = "DEPARTMENT_STORES";
    /**
   * The category for Detective Agencies.
   *
   * Numeric code: '7393'
   */ MerchantCategory["DETECTIVE_AGENCIES"] = "DETECTIVE_AGENCIES";
    /**
   * The category for De Vere Hotels
   *
   * Numeric Code: '3648'
   */ MerchantCategory["DE_VERE_HOTELS"] = "DE_VERE_HOTELS";
    /**
   * The category for Digital Goods – Applications (Excludes Games).
   *
   * Numeric code: '5817'
   */ MerchantCategory["DIGITAL_GOODS_APPLICATIONS"] = "DIGITAL_GOODS_APPLICATIONS";
    /**
   * The category for Digital Goods – Games.
   *
   * Numeric code: '5816'
   */ MerchantCategory["DIGITAL_GOODS_GAMES"] = "DIGITAL_GOODS_GAMES";
    /**
   * The category for Digital Goods – Large Digital Goods Merchant.
   *
   * Numeric code: '5818'
   */ MerchantCategory["DIGITAL_GOODS_LARGE_VOLUME"] = "DIGITAL_GOODS_LARGE_VOLUME";
    /**
   * The category for "Digital Goods Media – Books, Movies, Music".
   *
   * Numeric code: '5815'
   */ MerchantCategory["DIGITAL_GOODS_MEDIA"] = "DIGITAL_GOODS_MEDIA";
    /**
   * The category for Dillon Inn
   *
   * Numeric Code: '3691'
   */ MerchantCategory["DILLON_INN"] = "DILLON_INN";
    /**
   * The category for Direct Marketing - Catalog Merchant.
   *
   * Numeric code: '5964'
   */ MerchantCategory["DIRECT_MARKETING_CATALOG_MERCHANT"] = "DIRECT_MARKETING_CATALOG_MERCHANT";
    /**
   * The category for Direct Marketing - Combination Catalog and Retail Merchant.
   *
   * Numeric code: '5965'
   */ MerchantCategory["DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT"] = "DIRECT_MARKETING_COMBINATION_CATALOG_AND_RETAIL_MERCHANT";
    /**
   * The category for Direct Marketing - Inbound Telemarketing.
   *
   * Numeric code: '5967'
   */ MerchantCategory["DIRECT_MARKETING_INBOUND_TELEMARKETING"] = "DIRECT_MARKETING_INBOUND_TELEMARKETING";
    /**
   * The category for Direct Marketing - Insurance Services.
   *
   * Numeric code: '5960'
   */ MerchantCategory["DIRECT_MARKETING_INSURANCE_SERVICES"] = "DIRECT_MARKETING_INSURANCE_SERVICES";
    /**
   * The category for Direct Marketing - Other.
   *
   * Numeric code: '5969'
   */ MerchantCategory["DIRECT_MARKETING_OTHER"] = "DIRECT_MARKETING_OTHER";
    /**
   * The category for Direct Marketing - Outbound Telemarketing.
   *
   * Numeric code: '5966'
   */ MerchantCategory["DIRECT_MARKETING_OUTBOUND_TELEMARKETING"] = "DIRECT_MARKETING_OUTBOUND_TELEMARKETING";
    /**
   * The category for Direct Marketing - Subscription.
   *
   * Numeric code: '5968'
   */ MerchantCategory["DIRECT_MARKETING_SUBSCRIPTION"] = "DIRECT_MARKETING_SUBSCRIPTION";
    /**
   * The category for Direct Marketing - Travel.
   *
   * Numeric code: '5962'
   */ MerchantCategory["DIRECT_MARKETING_TRAVEL"] = "DIRECT_MARKETING_TRAVEL";
    /**
   * The category for Discount Stores.
   *
   * Numeric code: '5310'
   */ MerchantCategory["DISCOUNT_STORES"] = "DISCOUNT_STORES";
    /**
   * The category for Disneyland Resorts
   *
   * Numeric Code: '3780'
   */ MerchantCategory["DISNEYLAND_RESORTS"] = "DISNEYLAND_RESORTS";
    /**
   * The category for Doctors.
   *
   * Numeric code: '8011'
   */ MerchantCategory["DOCTORS"] = "DOCTORS";
    /**
   * The category for Dollar Rent A Car
   *
   * Numeric Code: '3390'
   */ MerchantCategory["DOLLAR_RENT_A_CAR"] = "DOLLAR_RENT_A_CAR";
    /**
   * The category for Dominicana De Aviacion
   *
   * Numeric Code: '3212'
   */ MerchantCategory["DOMINICA_AIR"] = "DOMINICA_AIR";
    /**
   * The category for Door-To-Door Sales.
   *
   * Numeric code: '5963'
   */ MerchantCategory["DOOR_TO_DOOR_SALES"] = "DOOR_TO_DOOR_SALES";
    /**
   * The category for Doral Golf Resort
   *
   * Numeric Code: '3589'
   */ MerchantCategory["DORAL_GOLF_RESORT"] = "DORAL_GOLF_RESORT";
    /**
   * The category for Doral Hotels
   *
   * Numeric Code: '3587'
   */ MerchantCategory["DORAL_HOTELS"] = "DORAL_HOTELS";
    /**
   * The category for Dorint Hotels
   *
   * Numeric Code: '3623'
   */ MerchantCategory["DORINT_HOTELS"] = "DORINT_HOTELS";
    /**
   * The category for Doubletree
   *
   * Numeric Code: '3692'
   */ MerchantCategory["DOUBLETREE"] = "DOUBLETREE";
    /**
   * The category for Downtowner Passport
   *
   * Numeric Code: '3527'
   */ MerchantCategory["DOWNTOWNER_PASSPORT"] = "DOWNTOWNER_PASSPORT";
    /**
   * The category for "Drapery, Window Covering, and Upholstery Stores".
   *
   * Numeric code: '5714'
   */ MerchantCategory["DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES"] = "DRAPERY_WINDOW_COVERING_AND_UPHOLSTERY_STORES";
    /**
   * The category for Drinking Places.
   *
   * Numeric code: '5813'
   */ MerchantCategory["DRINKING_PLACES"] = "DRINKING_PLACES";
    /**
   * The category for "Drugs, Drug Proprietaries, and Druggist Sundries".
   *
   * Numeric code: '5122'
   */ MerchantCategory["DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES"] = "DRUGS_DRUG_PROPRIETARIES_AND_DRUGGIST_SUNDRIES";
    /**
   * The category for Drug Stores and Pharmacies.
   *
   * Numeric code: '5912'
   */ MerchantCategory["DRUG_STORES_AND_PHARMACIES"] = "DRUG_STORES_AND_PHARMACIES";
    /**
   * The category for Drury Inn
   *
   * Numeric Code: '3693'
   */ MerchantCategory["DRURY_INN"] = "DRURY_INN";
    /**
   * The category for Dry Cleaners.
   *
   * Numeric code: '7216'
   */ MerchantCategory["DRY_CLEANERS"] = "DRY_CLEANERS";
    /**
   * The category for Dunfey Hotels
   *
   * Numeric Code: '3525'
   */ MerchantCategory["DUNFEY_HOTELS"] = "DUNFEY_HOTELS";
    /**
   * The category for Durable Goods (Not Elsewhere Classified).
   *
   * Numeric code: '5099'
   */ MerchantCategory["DURABLE_GOODS"] = "DURABLE_GOODS";
    /**
   * The category for Duty Free Stores.
   *
   * Numeric code: '5309'
   */ MerchantCategory["DUTY_FREE_STORES"] = "DUTY_FREE_STORES";
    /**
   * The category for Easyjet Air
   *
   * Numeric Code: '3245'
   */ MerchantCategory["EASYJET_AIR"] = "EASYJET_AIR";
    /**
   * The category for "Eating Places, Restaurants".
   *
   * Numeric code: '5812'
   */ MerchantCategory["EATING_PLACES_RESTAURANTS"] = "EATING_PLACES_RESTAURANTS";
    /**
   * The category for Economy Inns Of America
   *
   * Numeric Code: '3694'
   */ MerchantCategory["ECONOMY_INNS_OF_AMERICA"] = "ECONOMY_INNS_OF_AMERICA";
    /**
   * The category for Econo Car Rent A Car
   *
   * Numeric Code: '3398'
   */ MerchantCategory["ECONO_CAR_RENT_A_CAR"] = "ECONO_CAR_RENT_A_CAR";
    /**
   * The category for Econo Travel Motor Hotel
   *
   * Numeric Code: '3644'
   */ MerchantCategory["ECONO_TRAVEL_MOTOR_HOTEL"] = "ECONO_TRAVEL_MOTOR_HOTEL";
    /**
   * The category for Ecuatoriana
   *
   * Numeric Code: '3293'
   */ MerchantCategory["ECUATORIANA"] = "ECUATORIANA";
    /**
   * The category for Edition
   *
   * Numeric code: '3848'
   */ MerchantCategory["EDITION"] = "EDITION";
    /**
   * The category for Educational Services.
   *
   * Numeric code: '8299'
   */ MerchantCategory["EDUCATIONAL_SERVICES"] = "EDUCATIONAL_SERVICES";
    /**
   * The category for Egyptair
   *
   * Numeric Code: '3037'
   */ MerchantCategory["EGYPT_AIR"] = "EGYPT_AIR";
    /**
   * The category for Eldorado Hotel And Casino
   *
   * Numeric Code: '3669'
   */ MerchantCategory["ELDORADO_HOTEL_AND_CASINO"] = "ELDORADO_HOTEL_AND_CASINO";
    /**
   * The category for Electrical Parts and Equipment.
   *
   * Numeric code: '5065'
   */ MerchantCategory["ELECTRICAL_PARTS_AND_EQUIPMENT"] = "ELECTRICAL_PARTS_AND_EQUIPMENT";
    /**
   * The category for Electrical Services.
   *
   * Numeric code: '1731'
   */ MerchantCategory["ELECTRICAL_SERVICES"] = "ELECTRICAL_SERVICES";
    /**
   * The category for Electric Razor Stores.
   *
   * Numeric code: '5997'
   */ MerchantCategory["ELECTRIC_RAZOR_STORES"] = "ELECTRIC_RAZOR_STORES";
    /**
   * The category for Electric Vehicle Charging.
   *
   * Numeric code: '5552'
   */ MerchantCategory["ELECTRIC_VEHICLE_CHARGING"] = "ELECTRIC_VEHICLE_CHARGING";
    /**
   * The category for Electronics Repair Shops.
   *
   * Numeric code: '7622'
   */ MerchantCategory["ELECTRONICS_REPAIR_SHOPS"] = "ELECTRONICS_REPAIR_SHOPS";
    /**
   * The category for Electronics Stores.
   *
   * Numeric code: '5732'
   */ MerchantCategory["ELECTRONICS_STORES"] = "ELECTRONICS_STORES";
    /**
   * The category for Element
   *
   * Numeric Code: '3807'
   */ MerchantCategory["ELEMENT"] = "ELEMENT";
    /**
   * The category for "Elementary, Secondary Schools".
   *
   * Numeric code: '8211'
   */ MerchantCategory["ELEMENTARY_SECONDARY_SCHOOLS"] = "ELEMENTARY_SECONDARY_SCHOOLS";
    /**
   * The category for El Al Airlines
   *
   * Numeric Code: '3032'
   */ MerchantCategory["EL_AL_AIRLINES"] = "EL_AL_AIRLINES";
    /**
   * The category for Embassy Hotels
   *
   * Numeric Code: '3652'
   */ MerchantCategory["EMBASSY_HOTELS"] = "EMBASSY_HOTELS";
    /**
   * The category for Embassy Suites
   *
   * Numeric Code: '3695'
   */ MerchantCategory["EMBASSY_SUITES"] = "EMBASSY_SUITES";
    /**
   * The category for Embassy Vacation Resort
   *
   * Numeric Code: '3798'
   */ MerchantCategory["EMBASSY_VACATION_RESORT"] = "EMBASSY_VACATION_RESORT";
    /**
   * The category for Emirates
   *
   * Numeric Code: '3026'
   */ MerchantCategory["EMIRATES"] = "EMIRATES";
    /**
   * The category for Employment/Temp Agencies.
   *
   * Numeric code: '7361'
   */ MerchantCategory["EMPLOYMENT_TEMP_AGENCIES"] = "EMPLOYMENT_TEMP_AGENCIES";
    /**
   * The category for Enterprise Rent A Car
   *
   * Numeric Code: '3405'
   */ MerchantCategory["ENTERPRISE_RENT_A_CAR"] = "ENTERPRISE_RENT_A_CAR";
    /**
   * The category for Equipment Rental.
   *
   * Numeric code: '7394'
   */ MerchantCategory["EQUIPMENT_RENTAL"] = "EQUIPMENT_RENTAL";
    /**
   * The category for Ethiopian Airlines
   *
   * Numeric Code: '3294'
   */ MerchantCategory["ETHIOPIAN_AIRLINES"] = "ETHIOPIAN_AIRLINES";
    /**
   * The category for Etihad Air
   *
   * Numeric Code: '3034'
   */ MerchantCategory["ETIHAD_AIR"] = "ETIHAD_AIR";
    /**
   * The category for Europcar
   *
   * Numeric Code: '3381'
   */ MerchantCategory["EUROPCAR"] = "EUROPCAR";
    /**
   * The category for Europe By Car
   *
   * Numeric Code: '3391'
   */ MerchantCategory["EUROPE_BY_CAR"] = "EUROPE_BY_CAR";
    /**
   * The category for Eva Airways
   *
   * Numeric Code: '3084'
   */ MerchantCategory["EVA_AIRWAYS"] = "EVA_AIRWAYS";
    /**
   * The category for Excalibur Hotel And Casino
   *
   * Numeric Code: '3628'
   */ MerchantCategory["EXCALIBUR_HOTEL_AND_CASINO"] = "EXCALIBUR_HOTEL_AND_CASINO";
    /**
   * The category for Excel Inn
   *
   * Numeric Code: '3696'
   */ MerchantCategory["EXCEL_INN"] = "EXCEL_INN";
    /**
   * The category for Extended Stay
   *
   * Numeric Code: '3621'
   */ MerchantCategory["EXTENDED_STAY"] = "EXTENDED_STAY";
    /**
   * The category for Extended Stay America
   *
   * Numeric Code: '3627'
   */ MerchantCategory["EXTENDED_STAY_AMERICA"] = "EXTENDED_STAY_AMERICA";
    /**
   * The category for Extended Stay Deluxe
   *
   * Numeric Code: '3630'
   */ MerchantCategory["EXTENDED_STAY_DELUXE"] = "EXTENDED_STAY_DELUXE";
    /**
   * The category for Exterminating Services.
   *
   * Numeric code: '7342'
   */ MerchantCategory["EXTERMINATING_SERVICES"] = "EXTERMINATING_SERVICES";
    /**
   * The category for Fairfield Hotel
   *
   * Numeric Code: '3697'
   */ MerchantCategory["FAIRFIELD_HOTEL"] = "FAIRFIELD_HOTEL";
    /**
   * The category for Fairfield Inn
   *
   * Numeric Code: '3715'
   */ MerchantCategory["FAIRFIELD_INN"] = "FAIRFIELD_INN";
    /**
   * The category for Fairmont Hotels Corporation
   *
   * Numeric Code: '3590'
   */ MerchantCategory["FAIRMONT_HOTELS_CORPORATION"] = "FAIRMONT_HOTELS_CORPORATION";
    /**
   * The category for Family Clothing Stores.
   *
   * Numeric code: '5651'
   */ MerchantCategory["FAMILY_CLOTHING_STORES"] = "FAMILY_CLOTHING_STORES";
    /**
   * The category for "Food Served in a Hospital, Hotel, Cruise Ship, or Similar Location".
   *
   * Numeric code: '2002'
   */ MerchantCategory["FAST_FOOD"] = "FAST_FOOD";
    /**
   * The category for Fast Food Restaurants.
   *
   * Numeric code: '5814'
   */ MerchantCategory["FAST_FOOD_RESTAURANTS"] = "FAST_FOOD_RESTAURANTS";
    /**
   * The category for Financial Institutions.
   *
   * Numeric code: '6012'
   */ MerchantCategory["FINANCIAL_INSTITUTIONS"] = "FINANCIAL_INSTITUTIONS";
    /**
   * The category for Fines - Government Administrative Entities.
   *
   * Numeric code: '9222'
   */ MerchantCategory["FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES"] = "FINES_GOVERNMENT_ADMINISTRATIVE_ENTITIES";
    /**
   * The category for Finnair
   *
   * Numeric Code: '3042'
   */ MerchantCategory["FINNAIR"] = "FINNAIR";
    /**
   * The category for "Fireplace, Fireplace Screens, and Accessories Stores".
   *
   * Numeric code: '5718'
   */ MerchantCategory["FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES"] = "FIREPLACE_FIREPLACE_SCREENS_AND_ACCESSORIES_STORES";
    /**
   * The category for First Hospitality Hotels
   *
   * Numeric Code: '3784'
   */ MerchantCategory["FIRST_HOSPITALITY_HOTELS"] = "FIRST_HOSPITALITY_HOTELS";
    /**
   * The category for Flag Inns
   *
   * Numeric Code: '3664'
   */ MerchantCategory["FLAG_INNS"] = "FLAG_INNS";
    /**
   * The category for Flag Inns Australia
   *
   * Numeric Code: '3711'
   */ MerchantCategory["FLAG_INNS_AUSTRALIA"] = "FLAG_INNS_AUSTRALIA";
    /**
   * The category for Floor Covering Stores.
   *
   * Numeric code: '5713'
   */ MerchantCategory["FLOOR_COVERING_STORES"] = "FLOOR_COVERING_STORES";
    /**
   * The category for Florists.
   *
   * Numeric code: '5992'
   */ MerchantCategory["FLORISTS"] = "FLORISTS";
    /**
   * The category for "Florists Supplies, Nursery Stock, and Flowers".
   *
   * Numeric code: '5193'
   */ MerchantCategory["FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS"] = "FLORISTS_SUPPLIES_NURSERY_STOCK_AND_FLOWERS";
    /**
   * The category for Flybe
   *
   * Numeric Code: '3302'
   */ MerchantCategory["FLYBE"] = "FLYBE";
    /**
   * The category for Fontainebleau Resort
   *
   * Numeric Code: '3607'
   */ MerchantCategory["FONTAINEBLEAU_RESORT"] = "FONTAINEBLEAU_RESORT";
    /**
   * The category for Four Points Hotels
   *
   * Numeric Code: '3778'
   */ MerchantCategory["FOUR_POINTS_HOTELS"] = "FOUR_POINTS_HOTELS";
    /**
   * The category for Four Seasons
   *
   * Numeric Code: '3543'
   */ MerchantCategory["FOUR_SEASONS"] = "FOUR_SEASONS";
    /**
   * The category for Four Seasons Australia
   *
   * Numeric Code: '3714'
   */ MerchantCategory["FOUR_SEASONS_AUSTRALIA"] = "FOUR_SEASONS_AUSTRALIA";
    /**
   * The category for Frankenmuth Bavarian
   *
   * Numeric Code: '3578'
   */ MerchantCategory["FRANKENMUTH_BAVARIAN"] = "FRANKENMUTH_BAVARIAN";
    /**
   * The category for Freedom Airlines
   *
   * Numeric Code: '3204'
   */ MerchantCategory["FREEDOM_AIRLINES"] = "FREEDOM_AIRLINES";
    /**
   * The category for Freezer and Locker Meat Provisioners.
   *
   * Numeric code: '5422'
   */ MerchantCategory["FREEZER_AND_LOCKER_MEAT_PROVISIONERS"] = "FREEZER_AND_LOCKER_MEAT_PROVISIONERS";
    /**
   * The category for Fremont Hotel And Casino
   *
   * Numeric Code: '3766'
   */ MerchantCategory["FREMONT_HOTEL_AND_CASINO"] = "FREMONT_HOTEL_AND_CASINO";
    /**
   * The category for Friendship Inns International
   *
   * Numeric Code: '3507'
   */ MerchantCategory["FRIENDSHIP_INNS_INTERNATIONAL"] = "FRIENDSHIP_INNS_INTERNATIONAL";
    /**
   * The category for Frontier Airlines
   *
   * Numeric Code: '3132'
   */ MerchantCategory["FRONTIER_AIRLINES"] = "FRONTIER_AIRLINES";
    /**
   * The category for Fuel Dealers (Non Automotive).
   *
   * Numeric code: '5983'
   */ MerchantCategory["FUEL_DEALERS_NON_AUTOMOTIVE"] = "FUEL_DEALERS_NON_AUTOMOTIVE";
    /**
   * The category for Fufu Japan
   *
   * Numeric code: '3875'
   */ MerchantCategory["FUFU_JAPAN"] = "FUFU_JAPAN";
    /**
   * The category for Funding Transactions excluding MoneySend.
   *
   * Numeric code: '6539'
   */ MerchantCategory["FUNDING_TRANSACTION"] = "FUNDING_TRANSACTION";
    /**
   * The category for "Funeral Services, Crematories".
   *
   * Numeric code: '7261'
   */ MerchantCategory["FUNERAL_SERVICES_CREMATORIES"] = "FUNERAL_SERVICES_CREMATORIES";
    /**
   * The category for "Furniture, Home Furnishings, and Equipment Stores, Except Appliances".
   *
   * Numeric code: '5712'
   */ MerchantCategory["FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES"] = "FURNITURE_HOME_FURNISHINGS_AND_EQUIPMENT_STORES_EXCEPT_APPLIANCES";
    /**
   * The category for "Furniture Repair, Refinishing".
   *
   * Numeric code: '7641'
   */ MerchantCategory["FURNITURE_REPAIR_REFINISHING"] = "FURNITURE_REPAIR_REFINISHING";
    /**
   * The category for Furriers and Fur Shops.
   *
   * Numeric code: '5681'
   */ MerchantCategory["FURRIERS_AND_FUR_SHOPS"] = "FURRIERS_AND_FUR_SHOPS";
    /**
   * The category for Galt House
   *
   * Numeric Code: '3827'
   */ MerchantCategory["GALT_HOUSE"] = "GALT_HOUSE";
    /**
   * The category for Garden Place Hotel
   *
   * Numeric Code: '3566'
   */ MerchantCategory["GARDEN_PLACE_HOTEL"] = "GARDEN_PLACE_HOTEL";
    /**
   * The category for Garuda
   *
   * Numeric Code: '3103'
   */ MerchantCategory["GARUDA"] = "GARUDA";
    /**
   * The category for Gaylord Opryland
   *
   * Numeric Code: '3608'
   */ MerchantCategory["GAYLORD_OPRYLAND"] = "GAYLORD_OPRYLAND";
    /**
   * The category for Gaylord Palms
   *
   * Numeric Code: '3609'
   */ MerchantCategory["GAYLORD_PALMS"] = "GAYLORD_PALMS";
    /**
   * The category for Gaylord Texan
   *
   * Numeric Code: '3610'
   */ MerchantCategory["GAYLORD_TEXAN"] = "GAYLORD_TEXAN";
    /**
   * The category for General Rent A Car
   *
   * Numeric Code: '3409'
   */ MerchantCategory["GENERAL_RENT_A_CAR"] = "GENERAL_RENT_A_CAR";
    /**
   * The category for General Services.
   *
   * Numeric code: '1520'
   */ MerchantCategory["GENERAL_SERVICES"] = "GENERAL_SERVICES";
    /**
   * The category for "Gift, Card, Novelty, and Souvenir Shops".
   *
   * Numeric code: '5947'
   */ MerchantCategory["GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS"] = "GIFT_CARD_NOVELTY_AND_SOUVENIR_SHOPS";
    /**
   * The category for "Glassware, Crystal Stores".
   *
   * Numeric code: '5950'
   */ MerchantCategory["GLASSWARE_CRYSTAL_STORES"] = "GLASSWARE_CRYSTAL_STORES";
    /**
   * The category for "Glass, Paint, and Wallpaper Stores".
   *
   * Numeric code: '5231'
   */ MerchantCategory["GLASS_PAINT_AND_WALLPAPER_STORES"] = "GLASS_PAINT_AND_WALLPAPER_STORES";
    /**
   * The category for Godfrey National
   *
   * Numeric Code: '3414'
   */ MerchantCategory["GODFREY_NATIONAL"] = "GODFREY_NATIONAL";
    /**
   * The category for GOFLY
   *
   * Numeric Code: '3156'
   */ MerchantCategory["GOFLY"] = "GOFLY";
    /**
   * The category for Golden Nugget
   *
   * Numeric Code: '3561'
   */ MerchantCategory["GOLDEN_NUGGET"] = "GOLDEN_NUGGET";
    /**
   * The category for Golden Pacific Air
   *
   * Numeric Code: '3203'
   */ MerchantCategory["GOLDEN_PACIFIC_AIR"] = "GOLDEN_PACIFIC_AIR";
    /**
   * The category for Golden Tulip
   *
   * Numeric Code: '3506'
   */ MerchantCategory["GOLDEN_TULIP"] = "GOLDEN_TULIP";
    /**
   * The category for Golf Courses - Public.
   *
   * Numeric code: '7992'
   */ MerchantCategory["GOLF_COURSES_PUBLIC"] = "GOLF_COURSES_PUBLIC";
    /**
   * The category for Gol Airlines
   *
   * Numeric Code: '3247'
   */ MerchantCategory["GOL_AIRLINES"] = "GOL_AIRLINES";
    /**
   * The category for Government Licensed On-Line Casinos
   *
   * Numeric Code: '7802'
   */ MerchantCategory["GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING"] = "GOVERNMENT_LICENSED_HORSE_OR_DOG_RACING";
    /**
   * The category for Government Licensed On-Line Casinos
   *
   * Numeric Code: '7801'
   */ MerchantCategory["GOVERNMENT_LICENSED_ON_LINE_CASINO"] = "GOVERNMENT_LICENSED_ON_LINE_CASINO";
    /**
   * The category for Government Owned Lotteries
   *
   * Numeric Code: '7800'
   */ MerchantCategory["GOVERNMENT_OWNED_LOTTERY"] = "GOVERNMENT_OWNED_LOTTERY";
    /**
   * The category for "Government Owned Lottery (Global, Excluding U.S. Region)"
   *
   * Numeric code: '9406'
   */ MerchantCategory["GOVERNMENT_OWNED_LOTTERY_GLOBAL"] = "GOVERNMENT_OWNED_LOTTERY_GLOBAL";
    /**
   * The category for Government Services (Not Elsewhere Classified).
   *
   * Numeric code: '9399'
   */ MerchantCategory["GOVERNMENT_SERVICES"] = "GOVERNMENT_SERVICES";
    /**
   * The category for Granbell Hotels and Resorts
   *
   * Numeric code: '3853'
   */ MerchantCategory["GRANBELL_HOTELS_AND_RESORT"] = "GRANBELL_HOTELS_AND_RESORT";
    /**
   * The category for Grand Casino Hotels
   *
   * Numeric Code: '3794'
   */ MerchantCategory["GRAND_CASINO_HOTELS"] = "GRAND_CASINO_HOTELS";
    /**
   * The category for Grand Met Forum Hotels
   *
   * Numeric Code: '3570'
   */ MerchantCategory["GRAND_MET_FORUM_HOTELS"] = "GRAND_MET_FORUM_HOTELS";
    /**
   * The category for Grand Sierra Resort
   *
   * Numeric Code: '3823'
   */ MerchantCategory["GRAND_SIERRA_RESORT"] = "GRAND_SIERRA_RESORT";
    /**
   * The category for Grand Wailea Resort
   *
   * Numeric Code: '3571'
   */ MerchantCategory["GRAND_WAILEA_RESORT"] = "GRAND_WAILEA_RESORT";
    /**
   * The category for Great Wolf
   *
   * Numeric Code: '3618'
   */ MerchantCategory["GREAT_WOLF"] = "GREAT_WOLF";
    /**
   * The category for Greenbriar Resorts
   *
   * Numeric Code: '3753'
   */ MerchantCategory["GREENBRIAR_RESORTS"] = "GREENBRIAR_RESORTS";
    /**
   * The category for "Grocery Stores, Supermarkets".
   *
   * Numeric code: '5411'
   */ MerchantCategory["GROCERY_STORES_SUPERMARKETS"] = "GROCERY_STORES_SUPERMARKETS";
    /**
   * The category for Grupo Hotels Husa Sa
   *
   * Numeric Code: '3647'
   */ MerchantCategory["GRUPO_HOTELS_HUSA_SA"] = "GRUPO_HOTELS_HUSA_SA";
    /**
   * The category for Gulf Air (Bahrain)
   *
   * Numeric Code: '3040'
   */ MerchantCategory["GULF_AIR"] = "GULF_AIR";
    /**
   * The category for guns and ammunition
   *
   * Numeric code: 5723
   */ MerchantCategory["GUNS_AMMO"] = "GUNS_AMMO";
    /**
   * The category for Guyana Airways
   *
   * Numeric Code: '3200'
   */ MerchantCategory["GUYANA_AIRWAYS"] = "GUYANA_AIRWAYS";
    /**
   * The category for Hainan Airlines
   *
   * Numeric code: ‘3168’
   */ MerchantCategory["HAINAN_AIRLINES"] = "HAINAN_AIRLINES";
    /**
   * The category for Halekulani Hotel Waikiki Parc
   *
   * Numeric Code: '3760'
   */ MerchantCategory["HALEKULANI_HOTEL_WAIKIKI_PARC"] = "HALEKULANI_HOTEL_WAIKIKI_PARC";
    /**
   * The category for Hale Koa Hotel
   *
   * Numeric Code: '3799'
   */ MerchantCategory["HALE_KOA_HOTEL"] = "HALE_KOA_HOTEL";
    /**
   * The category for Hampton Inns
   *
   * Numeric Code: '3665'
   */ MerchantCategory["HAMPTON_INNS"] = "HAMPTON_INNS";
    /**
   * The category for "Hardware, Equipment, and Supplies".
   *
   * Numeric code: '5072'
   */ MerchantCategory["HARDWARE_EQUIPMENT_AND_SUPPLIES"] = "HARDWARE_EQUIPMENT_AND_SUPPLIES";
    /**
   * The category for Hardware Stores.
   *
   * Numeric code: '5251'
   */ MerchantCategory["HARDWARE_STORES"] = "HARDWARE_STORES";
    /**
   * The category for Harley Hotel
   *
   * Numeric Code: '3698'
   */ MerchantCategory["HARLEY_HOTEL"] = "HARLEY_HOTEL";
    /**
   * The category for Harrahs Hotels And Casinos
   *
   * Numeric Code: '3731'
   */ MerchantCategory["HARRAHS_HOTELS_AND_CASINOS"] = "HARRAHS_HOTELS_AND_CASINOS";
    /**
   * The category for Harvey Bristol Hotels
   *
   * Numeric Code: '3734'
   */ MerchantCategory["HARVEY_BRISTOL_HOTELS"] = "HARVEY_BRISTOL_HOTELS";
    /**
   * The category for Havasu Airlines
   *
   * Numeric Code: '3197'
   */ MerchantCategory["HAVASU_AIRLINES"] = "HAVASU_AIRLINES";
    /**
   * The category for Hawaiian Air
   *
   * Numeric Code: '3196'
   */ MerchantCategory["HAWAIIAN_AIR"] = "HAWAIIAN_AIR";
    /**
   * The category for Health and Beauty Spas.
   *
   * Numeric code: '7298'
   */ MerchantCategory["HEALTH_AND_BEAUTY_SPAS"] = "HEALTH_AND_BEAUTY_SPAS";
    /**
   * The category for Hearing Aids Sales and Supplies.
   *
   * Numeric code: '5975'
   */ MerchantCategory["HEARING_AIDS_SALES_AND_SUPPLIES"] = "HEARING_AIDS_SALES_AND_SUPPLIES";
    /**
   * The category for "Heating, Plumbing, A/C".
   *
   * Numeric code: '1711'
   */ MerchantCategory["HEATING_PLUMBING_A_C"] = "HEATING_PLUMBING_A_C";
    /**
   * The category for Helmsley Hotels
   *
   * Numeric Code: '3588'
   */ MerchantCategory["HELMSLEY_HOTELS"] = "HELMSLEY_HOTELS";
    /**
   * The category for Hermitage Hotels
   *
   * Numeric Code: '3616'
   */ MerchantCategory["HERMITAGE_HOTELS"] = "HERMITAGE_HOTELS";
    /**
   * The category for Hertz
   *
   * Numeric Code: '3357'
   */ MerchantCategory["HERTZ"] = "HERTZ";
    /**
   * The category for Hilton
   *
   * Numeric Code: '3504'
   */ MerchantCategory["HILTON"] = "HILTON";
    /**
   * The category for Hilton Garden Inn
   *
   * Numeric Code: '3604'
   */ MerchantCategory["HILTON_GARDEN_INN"] = "HILTON_GARDEN_INN";
    /**
   * The category for Hilton International
   *
   * Numeric Code: '3535'
   */ MerchantCategory["HILTON_INTERNATIONAL"] = "HILTON_INTERNATIONAL";
    /**
   * The category for Hapag-Lloyd Express
   *
   * Numeric Code: '3062'
   */ MerchantCategory["HLX_AIR"] = "HLX_AIR";
    /**
   * The category for HMI Hotel Group
   *
   * Numeric code: '3876'
   */ MerchantCategory["HMI_HOTEL_GROUP"] = "HMI_HOTEL_GROUP";
    /**
   * The category for "Hobby, Toy, and Game Shops".
   *
   * Numeric code: '5945'
   */ MerchantCategory["HOBBY_TOY_AND_GAME_SHOPS"] = "HOBBY_TOY_AND_GAME_SHOPS";
    /**
   * The category for Holiday Inns
   *
   * Numeric Code: '3501'
   */ MerchantCategory["HOLIDAY_INNS"] = "HOLIDAY_INNS";
    /**
   * The category for Holiday Rent A Car
   *
   * Numeric Code: '3368'
   */ MerchantCategory["HOLIDAY_RENT_A_CAR"] = "HOLIDAY_RENT_A_CAR";
    /**
   * The category for Home2Suites
   *
   * Numeric Code: '3816'
   */ MerchantCategory["HOME2SUITES"] = "HOME2SUITES";
    /**
   * The category for Homestead
   *
   * Numeric Code: '3755'
   */ MerchantCategory["HOMESTEAD"] = "HOMESTEAD";
    /**
   * The category for Homestead Suites
   *
   * Numeric Code: '3800'
   */ MerchantCategory["HOMESTEAD_SUITES"] = "HOMESTEAD_SUITES";
    /**
   * The category for Homewood Suites
   *
   * Numeric Code: '3751'
   */ MerchantCategory["HOMEWOOD_SUITES"] = "HOMEWOOD_SUITES";
    /**
   * The category for Home2Suites
   *
   * Numeric Code: '3816'
   */ MerchantCategory["HOME_2_SUITES"] = "HOME_2_SUITES";
    /**
   * The category for Home Supply Warehouse Stores.
   *
   * Numeric code: '5200'
   */ MerchantCategory["HOME_SUPPLY_WAREHOUSE_STORES"] = "HOME_SUPPLY_WAREHOUSE_STORES";
    /**
   * The category for Hospitality Inns
   *
   * Numeric Code: '3595'
   */ MerchantCategory["HOSPITALITY_INNS"] = "HOSPITALITY_INNS";
    /**
   * The category for Hospitals.
   *
   * Numeric code: '8062'
   */ MerchantCategory["HOSPITALS"] = "HOSPITALS";
    /**
   * The category for Hoteis Othan
   *
   * Numeric Code: '3680'
   */ MerchantCategory["HOTEIS_OTHAN"] = "HOTEIS_OTHAN";
    /**
   * The category for Hoteles El Presidente
   *
   * Numeric Code: '3663'
   */ MerchantCategory["HOTELES_EL_PRESIDENTE"] = "HOTELES_EL_PRESIDENTE";
    /**
   * The category for Hotels Melia
   *
   * Numeric Code: '3548'
   */ MerchantCategory["HOTELS_MELIA"] = "HOTELS_MELIA";
    /**
   * The category for "Hotels, Motels, and Resorts".
   *
   * Numeric codes: ['3501','3502','3503','3504','3505','3506','3507','3508','3509','3510','3511','3512','3513','3514','3515','3516','3517','3518','3519','3520','3521','3522','3523','3524','3525','3526','3527','3528','3529','3530','3531','3532','3533','3534','3535','3536','3537','3538','3539','3540','3541','3542','3543','3544','3545','3546','3547','3548','3549','3550','3551','3552','3553','3554','3555','3556','3557','3558','3559','3560','3561','3562','3563','3564','3565','3566','3567','3568','3569','3570','3571','3572','3573','3574','3575','3576','3577','3578','3579','3580','3581','3582','3583','3584','3585','3586','3587','3588','3589','3590','3591','3592','3593','3594','3595','3596','3597','3598','3599','3600','3601','3602','3603','3604','3605','3606','3607','3608','3609','3610','3611','3612','3613','3614','3615','3616','3617','3618','3619','3620','3621','3622','3623','3624','3625','3626','3627','3628','3629','3630','3631','3632','3633','3634','3635','3636','3637','3638','3639','3640','3641','3642','3643','3644','3645','3646','3647','3648','3649','3650','3651','3652','3653','3654','3655','3656','3657','3658','3659','3660','3661','3662','3663','3664','3665','3666','3667','3668','3669','3670','3671','3672','3673','3674','3675','3676','3677','3678','3679','3680','3681','3682','3683','3684','3685','3686','3687','3688','3689','3690','3691','3692','3693','3694','3695','3696','3697','3698','3699','3700','3701','3702','3703','3704','3705','3706','3707','3708','3709','3710','3711','3712','3713','3714','3715','3716','3717','3718','3719','3720','3721','3722','3723','3724','3725','3726','3727','3728','3729','3730','3731','3732','3733','3734','3735','3736','3737','3738','3739','3740','3741','3742','3743','3744','3745','3746','3747','3748','3749','3750','3751','3752','3753','3754','3755','3756','3757','3758','3759','3760','3761','3762','3763','3764','3765','3766','3767','3768','3769','3770','3771','3772','3773','3774','3775','3776','3777','3778','3779','3780','3781','3782','3783','3784','3785','3786','3787','3788','3789','3790','7011']
   */ MerchantCategory["HOTELS_MOTELS_AND_RESORTS"] = "HOTELS_MOTELS_AND_RESORTS";
    /**
   * The category for Hotel Alpha-1
   *
   * Numeric code: '3867'
   */ MerchantCategory["HOTEL_ALPHA_1"] = "HOTEL_ALPHA_1";
    /**
   * The category for Hotel Del Coronado
   *
   * Numeric Code: '3580'
   */ MerchantCategory["HOTEL_DEL_CORONADO"] = "HOTEL_DEL_CORONADO";
    /**
   * The category for Hotel Indigo
   *
   * Numeric Code: '3813'
   */ MerchantCategory["HOTEL_INDIGO"] = "HOTEL_INDIGO";
    /**
   * The category for Hotel Livemax
   *
   * Numeric code: '3874'
   */ MerchantCategory["HOTEL_LIVEMAX"] = "HOTEL_LIVEMAX";
    /**
   * The category for Hotel Mercure
   *
   * Numeric Code: '3579'
   */ MerchantCategory["HOTEL_MERCURE"] = "HOTEL_MERCURE";
    /**
   * The category for Hotel Metropolitan
   *
   * Numeric code: '3881'
   */ MerchantCategory["HOTEL_METROPOLITAN"] = "HOTEL_METROPOLITAN";
    /**
   * The category for Hotel Okura
   *
   * Numeric Code: '3541'
   */ MerchantCategory["HOTEL_OKURA"] = "HOTEL_OKURA";
    /**
   * The category for Hotel Sierra
   *
   * Numeric Code: '3546'
   */ MerchantCategory["HOTEL_SIERRA"] = "HOTEL_SIERRA";
    /**
   * The category for Hotel Sunroute
   *
   * Numeric code: '3857'
   */ MerchantCategory["HOTEL_SUNROUTE"] = "HOTEL_SUNROUTE";
    /**
   * The category for Hotel Universal
   *
   * Numeric Code: '3625'
   */ MerchantCategory["HOTEL_UNIVERSAL"] = "HOTEL_UNIVERSAL";
    /**
   * The category for Hotel Unizo
   *
   * Numeric code: '3880'
   */ MerchantCategory["HOTEL_UNIZO"] = "HOTEL_UNIZO";
    /**
   * The category for Household Appliance Stores.
   *
   * Numeric code: '5722'
   */ MerchantCategory["HOUSEHOLD_APPLIANCE_STORES"] = "HOUSEHOLD_APPLIANCE_STORES";
    /**
   * The category for Howard Johnson
   *
   * Numeric Code: '3638'
   */ MerchantCategory["HOWARD_JOHNSON"] = "HOWARD_JOHNSON";
    /**
   * The category for Hudson Hotel
   *
   * Numeric Code: '3602'
   */ MerchantCategory["HUDSON_HOTEL"] = "HUDSON_HOTEL";
    /**
   * The category for Hungar Hotels
   *
   * Numeric Code: '3585'
   */ MerchantCategory["HUNGAR_HOTELS"] = "HUNGAR_HOTELS";
    /**
   * The category for Hyatt Hotels/International
   *
   * Numeric Code: '3640'
   */ MerchantCategory["HYATT_HOTELS_INTERNATIONAL"] = "HYATT_HOTELS_INTERNATIONAL";
    /**
   * The category for Hyatt Place
   *
   * Numeric Code: '3812'
   */ MerchantCategory["HYATT_PLACE"] = "HYATT_PLACE";
    /**
   * The category for Iberia
   *
   * Numeric Code: '3102'
   */ MerchantCategory["IBERIA"] = "IBERIA";
    /**
   * The category for Iberotel
   *
   * Numeric Code: '3540'
   */ MerchantCategory["IBEROTEL"] = "IBEROTEL";
    /**
   * The category for Ibusz Hotels
   *
   * Numeric Code: '3673'
   */ MerchantCategory["IBUSZ_HOTELS"] = "IBUSZ_HOTELS";
    /**
   * The category for Icelandair
   *
   * Numeric Code: '3050'
   */ MerchantCategory["ICELAND_AIR"] = "ICELAND_AIR";
    /**
   * The category for Imperial London Hotels
   *
   * Numeric Code: '3651'
   */ MerchantCategory["IMPERIAL_LONDON_HOTELS"] = "IMPERIAL_LONDON_HOTELS";
    /**
   * The category for Indian Airlines
   *
   * Numeric Code: '3193'
   */ MerchantCategory["INDIAN_AIRLINES"] = "INDIAN_AIRLINES";
    /**
   * The category for Industrial Supplies (Not Elsewhere Classified).
   *
   * Numeric code: '5085'
   */ MerchantCategory["INDUSTRIAL_SUPPLIES"] = "INDUSTRIAL_SUPPLIES";
    /**
   * The category for Information Retrieval Services.
   *
   * Numeric code: '7375'
   */ MerchantCategory["INFORMATION_RETRIEVAL_SERVICES"] = "INFORMATION_RETRIEVAL_SERVICES";
    /**
   * The category for Insurance Agents, Brokers & Service
   *
   * Numeric code: '6411'
   */ MerchantCategory["INSURANCE_AGENTS_BROKERS_SERVICE"] = "INSURANCE_AGENTS_BROKERS_SERVICE";
    /**
   * The category for Insurance - Default.
   *
   * Numeric code: '6399'
   */ MerchantCategory["INSURANCE_DEFAULT"] = "INSURANCE_DEFAULT";
    /**
   * The category for Insurance Premiums
   *
   * Numeric Code: '6381'
   */ MerchantCategory["INSURANCE_PREMIUMS"] = "INSURANCE_PREMIUMS";
    /**
   * The category for Insurance Rent A Car
   *
   * Numeric Code: '3429'
   */ MerchantCategory["INSURANCE_RENT_A_CAR"] = "INSURANCE_RENT_A_CAR";
    /**
   * The category for "Insurance Underwriting, Premiums".
   *
   * Numeric code: '6300'
   */ MerchantCategory["INSURANCE_UNDERWRITING_PREMIUMS"] = "INSURANCE_UNDERWRITING_PREMIUMS";
    /**
   * The category for Intercontinental
   *
   * Numeric Code: '3512'
   */ MerchantCategory["INTERCONTINENTAL"] = "INTERCONTINENTAL";
    /**
   * The category for Interent
   *
   * Numeric Code: '3438'
   */ MerchantCategory["INTERENT"] = "INTERENT";
    /**
   * The category for Interhotel Cedok
   *
   * Numeric Code: '3675'
   */ MerchantCategory["INTERHOTEL_CEDOK"] = "INTERHOTEL_CEDOK";
    /**
   * The category for Inter Nor Hotels
   *
   * Numeric Code: '3724'
   */ MerchantCategory["INTER_NOR_HOTELS"] = "INTER_NOR_HOTELS";
    /**
   * The category for Intra-Company Purchases.
   *
   * Numeric code: '9950'
   */ MerchantCategory["INTRA_COMPANY_PURCHASES"] = "INTRA_COMPANY_PURCHASES";
    /**
   * The category for Island Airlines
   *
   * Numeric Code: '3191'
   */ MerchantCategory["ISLAND_AIRLINES"] = "ISLAND_AIRLINES";
    /**
   * The category for Itoen Hotel
   *
   * Numeric code: '3864'
   */ MerchantCategory["ITOEN_HOTEL"] = "ITOEN_HOTEL";
    /**
   * The category for Japan Airlines
   *
   * Numeric Code: '3006'
   */ MerchantCategory["JAPAN_AIRLINES"] = "JAPAN_AIRLINES";
    /**
   * The category for Jefferson Hotel
   *
   * Numeric Code: '3606'
   */ MerchantCategory["JEFFERSON_HOTEL"] = "JEFFERSON_HOTEL";
    /**
   * The category for Jetblue Airways
   *
   * Numeric Code: '3174'
   */ MerchantCategory["JETBLUE_AIRWAYS"] = "JETBLUE_AIRWAYS";
    /**
   * The category for Jetstar Airways
   *
   * Numeric Code: '3079'
   */ MerchantCategory["JETSTAR_AIRWAYS"] = "JETSTAR_AIRWAYS";
    /**
   * The category for Jet Airways
   *
   * Numeric Code: '3056'
   */ MerchantCategory["JET_AIRWAYS"] = "JET_AIRWAYS";
    /**
   * The category for "Jewelry Stores, Watches, Clocks, and Silverware Stores".
   *
   * Numeric code: '5944'
   */ MerchantCategory["JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES"] = "JEWELRY_STORES_WATCHES_CLOCKS_AND_SILVERWARE_STORES";
    /**
   * The category for JHAT
   *
   * Numeric code: '3854'
   */ MerchantCategory["JHAT"] = "JHAT";
    /**
   * The category for John Ascuagas Nugget
   *
   * Numeric Code: '3729'
   */ MerchantCategory["JOHN_ASCUAGAS_NUGGET"] = "JOHN_ASCUAGAS_NUGGET";
    /**
   * The category for Jolly Hotels
   *
   * Numeric Code: '3558'
   */ MerchantCategory["JOLLY_HOTELS"] = "JOLLY_HOTELS";
    /**
   * The category for Journeys End Motels
   *
   * Numeric Code: '3563'
   */ MerchantCategory["JOURNEYS_END_MOTELS"] = "JOURNEYS_END_MOTELS";
    /**
   * The category for JR East Hotel Mets
   *
   * Numeric code: '3860'
   */ MerchantCategory["JR_EAST_HOTEL_METS"] = "JR_EAST_HOTEL_METS";
    /**
   * The category for Jugoslav Air
   *
   * Numeric Code: '3190'
   */ MerchantCategory["JUGOSLAV_AIR"] = "JUGOSLAV_AIR";
    /**
   * The category for Jumeirah Essex House
   *
   * Numeric Code: '3820'
   */ MerchantCategory["JUMEIRAH_ESSEX_HOUSE"] = "JUMEIRAH_ESSEX_HOUSE";
    /**
   * The category for Jurys Doyle Hotel Group
   *
   * Numeric Code: '3605'
   */ MerchantCategory["JURYS_DOYLE_HOTEL_GROUP"] = "JURYS_DOYLE_HOTEL_GROUP";
    /**
   * The category for JW Marriott
   *
   * Numeric code: '3847'
   */ MerchantCategory["JW_MARRIOTT"] = "JW_MARRIOTT";
    /**
   * The category for Kahala Mandarin Oriental Hotel
   *
   * Numeric Code: '3758'
   */ MerchantCategory["KAHALA_MANDARIN_ORIENTAL_HOTEL"] = "KAHALA_MANDARIN_ORIENTAL_HOTEL";
    /**
   * The category for Karos Hotels
   *
   * Numeric Code: '3718'
   */ MerchantCategory["KAROS_HOTELS"] = "KAROS_HOTELS";
    /**
   * The category for Kauai Coconut Beach Resort
   *
   * Numeric Code: '3531'
   */ MerchantCategory["KAUAI_COCONUT_BEACH_RESORT"] = "KAUAI_COCONUT_BEACH_RESORT";
    /**
   * The category for Keio Presso Inn
   *
   * Numeric code: '3870'
   */ MerchantCategory["KEIO_PRESSO_INN"] = "KEIO_PRESSO_INN";
    /**
   * The category for Kemwell Group
   *
   * Numeric Code: '3394'
   */ MerchantCategory["KEMWELL_GROUP"] = "KEMWELL_GROUP";
    /**
   * The category for Kenya Airways
   *
   * Numeric Code: '3295'
   */ MerchantCategory["KENYA_AIRWAYS"] = "KENYA_AIRWAYS";
    /**
   * The category for KLM (Royal Dutch Airlines)
   *
   * Numeric Code: '3010'
   */ MerchantCategory["KLM_ROYAL_DUTCH_AIRLINES"] = "KLM_ROYAL_DUTCH_AIRLINES";
    /**
   * The category for Knights Inn
   *
   * Numeric Code: '3660'
   */ MerchantCategory["KNIGHTS_INN"] = "KNIGHTS_INN";
    /**
   * The category for Korean Airlines
   *
   * Numeric Code: '3082'
   */ MerchantCategory["KOREAN_AIRLINES"] = "KOREAN_AIRLINES";
    /**
   * The category for Kuwait Air
   *
   * Numeric Code: '3038'
   */ MerchantCategory["KUWAIT_AIR"] = "KUWAIT_AIR";
    /**
   * The category for Kyoritsu Hotels.
   *
   * Numeric code: '3839'
   */ MerchantCategory["KYORITSUHOTELS"] = "KYORITSUHOTELS";
    /**
   * The category for Lloyd Aero Boliviano (LAB)
   *
   * Numeric Code: '3055'
   */ MerchantCategory["LAB_AIR"] = "LAB_AIR";
    /**
   * The category for LACSA (Costa Rica)
   *
   * Numeric Code: '3187'
   */ MerchantCategory["LACSA_AIR"] = "LACSA_AIR";
    /**
   * The category for Ladbroke Hotels
   *
   * Numeric Code: '3568'
   */ MerchantCategory["LADBROKE_HOTELS"] = "LADBROKE_HOTELS";
    /**
   * The category for Linea Aerea Del Cobre (LADECO)
   *
   * Numeric Code: '3054'
   */ MerchantCategory["LADECO_AIR"] = "LADECO_AIR";
    /**
   * The category for Lady Luck Hotel And Casino
   *
   * Numeric Code: '3624'
   */ MerchantCategory["LADY_LUCK_HOTEL_AND_CASINO"] = "LADY_LUCK_HOTEL_AND_CASINO";
    /**
   * The category for Landscaping Services.
   *
   * Numeric code: '0780'
   */ MerchantCategory["LANDSCAPING_SERVICES"] = "LANDSCAPING_SERVICES";
    /**
   * The category for LAN Airlines
   *
   * Numeric Code: '3052'
   */ MerchantCategory["LAN_AIR"] = "LAN_AIR";
    /**
   * The category for Lineas Aereas Paraguayas (LAP)
   *
   * Numeric Code: '3186'
   */ MerchantCategory["LAP_AIR"] = "LAP_AIR";
    /**
   * The category for Laundries.
   *
   * Numeric code: '7211'
   */ MerchantCategory["LAUNDRIES"] = "LAUNDRIES";
    /**
   * The category for "Laundry, Cleaning Services".
   *
   * Numeric code: '7210'
   */ MerchantCategory["LAUNDRY_CLEANING_SERVICES"] = "LAUNDRY_CLEANING_SERVICES";
    /**
   * The category for Linea Aeropostal Venezolana (LAV)
   *
   * Numeric Code: '3185'
   */ MerchantCategory["LAV_AIR"] = "LAV_AIR";
    /**
   * The category for La Costa Resort
   *
   * Numeric Code: '3810'
   */ MerchantCategory["LA_COSTA_RESORT"] = "LA_COSTA_RESORT";
    /**
   * The category for La Mansion Del Rio
   *
   * Numeric Code: '3701'
   */ MerchantCategory["LA_MANSION_DEL_RIO"] = "LA_MANSION_DEL_RIO";
    /**
   * The category for La Quinta Motor Inns
   *
   * Numeric Code: '3516'
   */ MerchantCategory["LA_QUINTA_MOTOR_INNS"] = "LA_QUINTA_MOTOR_INNS";
    /**
   * The category for La Quinta Resort
   *
   * Numeric Code: '3576'
   */ MerchantCategory["LA_QUINTA_RESORT"] = "LA_QUINTA_RESORT";
    /**
   * The category for La Vista
   *
   * Numeric code: '3859'
   */ MerchantCategory["LA_VISTA"] = "LA_VISTA";
    /**
   * The category for "Legal Services, Attorneys".
   *
   * Numeric code: '8111'
   */ MerchantCategory["LEGAL_SERVICES_ATTORNEYS"] = "LEGAL_SERVICES_ATTORNEYS";
    /**
   * The category for Liat Airline
   *
   * Numeric Code: '3184'
   */ MerchantCategory["LIAT_AIRLINE"] = "LIAT_AIRLINE";
    /**
   * The category for Loews Hotels
   *
   * Numeric Code: '3654'
   */ MerchantCategory["LOEWS_HOTELS"] = "LOEWS_HOTELS";
    /**
   * The category for LOT (Polish Airlines)
   *
   * Numeric Code: '3182'
   */ MerchantCategory["LOT_AIR"] = "LOT_AIR";
    /**
   * The category for Lufthansa
   *
   * Numeric Code: '3008'
   */ MerchantCategory["LUFTHANSA"] = "LUFTHANSA";
    /**
   * The category for Luggage and Leather Goods Stores.
   *
   * Numeric code: '5948'
   */ MerchantCategory["LUGGAGE_AND_LEATHER_GOODS_STORES"] = "LUGGAGE_AND_LEATHER_GOODS_STORES";
    /**
   * The category for "Lumber, Building Materials Stores".
   *
   * Numeric code: '5211'
   */ MerchantCategory["LUMBER_BUILDING_MATERIALS_STORES"] = "LUMBER_BUILDING_MATERIALS_STORES";
    /**
   * The category for Luxair
   *
   * Numeric Code: '3146'
   */ MerchantCategory["LUXAIR"] = "LUXAIR";
    /**
   * The category for Luxor Hotel And Casino
   *
   * Numeric Code: '3667'
   */ MerchantCategory["LUXOR_HOTEL_AND_CASINO"] = "LUXOR_HOTEL_AND_CASINO";
    /**
   * The category for Luxury Resorts
   *
   * Numeric Code: '3808'
   */ MerchantCategory["LUXURY_RESORTS"] = "LUXURY_RESORTS";
    /**
   * The category for Mainstay Suites
   *
   * Numeric Code: '3818'
   */ MerchantCategory["MAINSTAY_SUITES"] = "MAINSTAY_SUITES";
    /**
   * The category for Main Street Station Hotel And Casino
   *
   * Numeric Code: '3767'
   */ MerchantCategory["MAIN_STREET_STATION_HOTEL_AND_CASINO"] = "MAIN_STREET_STATION_HOTEL_AND_CASINO";
    /**
   * The category for Major Rent A Car
   *
   * Numeric Code: '3430'
   */ MerchantCategory["MAJOR_RENT_A_CAR"] = "MAJOR_RENT_A_CAR";
    /**
   * The category for Malaysian Airline System
   *
   * Numeric Code: '3100'
   */ MerchantCategory["MALAYSIAN_AIRLINE_SYSTEM"] = "MALAYSIAN_AIRLINE_SYSTEM";
    /**
   * The category for Malev
   *
   * Numeric Code: '3181'
   */ MerchantCategory["MALEV"] = "MALEV";
    /**
   * The category for Malmo Aviation
   *
   * Numeric Code: '3213'
   */ MerchantCategory["MALMO_AIR"] = "MALMO_AIR";
    /**
   * The category for Mandalay Bay Resort
   *
   * Numeric Code: '3777'
   */ MerchantCategory["MANDALAY_BAY_RESORT"] = "MANDALAY_BAY_RESORT";
    /**
   * The category for Mandarin International
   *
   * Numeric Code: '3577'
   */ MerchantCategory["MANDARIN_INTERNATIONAL"] = "MANDARIN_INTERNATIONAL";
    /**
   * The category for Manhattan East Suite Hotels
   *
   * Numeric Code: '3557'
   */ MerchantCategory["MANHATTAN_EAST_SUITE_HOTELS"] = "MANHATTAN_EAST_SUITE_HOTELS";
    /**
   * The category for Manual Cash Disburse.
   *
   * Numeric code: '6010'
   */ MerchantCategory["MANUAL_CASH_DISBURSE"] = "MANUAL_CASH_DISBURSE";
    /**
   * The category for "Marinas, Service and Supplies".
   *
   * Numeric code: '4468'
   */ MerchantCategory["MARINAS_SERVICE_AND_SUPPLIES"] = "MARINAS_SERVICE_AND_SUPPLIES";
    /**
   * The category for Maritim
   *
   * Numeric Code: '3668'
   */ MerchantCategory["MARITIM"] = "MARITIM";
    /**
   * The category for Marriott
   *
   * Numeric Code: '3509'
   */ MerchantCategory["MARRIOTT"] = "MARRIOTT";
    /**
   * The category for Marriott Executive Apartments
   *
   * Numeric code: '3842'
   */ MerchantCategory["MARRIOTT_EXECUTIVE_APARTMENTS"] = "MARRIOTT_EXECUTIVE_APARTMENTS";
    /**
   * The category for "Masonry, Stonework, and Plaster".
   *
   * Numeric code: '1740'
   */ MerchantCategory["MASONRY_STONEWORK_AND_PLASTER"] = "MASONRY_STONEWORK_AND_PLASTER";
    /**
   * The category for Massage Parlors.
   *
   * Numeric code: '7297'
   */ MerchantCategory["MASSAGE_PARLORS"] = "MASSAGE_PARLORS";
    /**
   * The category for Masters Economy Inns
   *
   * Numeric Code: '3835'
   */ MerchantCategory["MASTERS_ECONOMY_INNS"] = "MASTERS_ECONOMY_INNS";
    /**
   * The category for Medical and Dental Labs.
   *
   * Numeric code: '8071'
   */ MerchantCategory["MEDICAL_AND_DENTAL_LABS"] = "MEDICAL_AND_DENTAL_LABS";
    /**
   * The category for "Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies".
   *
   * Numeric code: '5047'
   */ MerchantCategory["MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES"] = "MEDICAL_DENTAL_OPHTHALMIC_AND_HOSPITAL_EQUIPMENT_AND_SUPPLIES";
    /**
   * The category for Medical Services.
   *
   * Numeric code: '8099'
   */ MerchantCategory["MEDICAL_SERVICES"] = "MEDICAL_SERVICES";
    /**
   * The category for Meitetsu Inn
   *
   * Numeric code: '3872'
   */ MerchantCategory["MEITETSU_INN"] = "MEITETSU_INN";
    /**
   * The category for Membership Organizations.
   *
   * Numeric code: '8699'
   */ MerchantCategory["MEMBERSHIP_ORGANIZATIONS"] = "MEMBERSHIP_ORGANIZATIONS";
    /**
   * The category for Mens and Boys Clothing and Accessories Stores.
   *
   * Numeric code: '5611'
   */ MerchantCategory["MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES"] = "MENS_AND_BOYS_CLOTHING_AND_ACCESSORIES_STORES";
    /**
   * The category for "Mens, Women's Clothing Stores".
   *
   * Numeric code: '5691'
   */ MerchantCategory["MENS_WOMENS_CLOTHING_STORES"] = "MENS_WOMENS_CLOTHING_STORES";
    /**
   * The category for Merchants Rent A Car
   *
   * Numeric Code: '3388'
   */ MerchantCategory["MERCHANTS_RENT_A_CAR"] = "MERCHANTS_RENT_A_CAR";
    /**
   * The category for Meridien
   *
   * Numeric Code: '3520'
   */ MerchantCategory["MERIDIEN"] = "MERIDIEN";
    /**
   * The category for Merlin Hotel Perth
   *
   * Numeric Code: '3622'
   */ MerchantCategory["MERLIN_HOTEL_PERTH"] = "MERLIN_HOTEL_PERTH";
    /**
   * The category for Mesa Air
   *
   * Numeric Code: '3178'
   */ MerchantCategory["MESA_AIR"] = "MESA_AIR";
    /**
   * The category for Metal Service Centers.
   *
   * Numeric code: '5051'
   */ MerchantCategory["METAL_SERVICE_CENTERS"] = "METAL_SERVICE_CENTERS";
    /**
   * The category for Metroflight Airlines
   *
   * Numeric Code: '3176'
   */ MerchantCategory["METROFLIGHT_AIRLINES"] = "METROFLIGHT_AIRLINES";
    /**
   * The category for Metropole Hotels
   *
   * Numeric Code: '3661'
   */ MerchantCategory["METROPOLE_HOTELS"] = "METROPOLE_HOTELS";
    /**
   * The category for Metro Airlines
   *
   * Numeric Code: '3087'
   */ MerchantCategory["METRO_AIRLINES"] = "METRO_AIRLINES";
    /**
   * The category for Mexicana Airlines
   *
   * Numeric Code: '3023'
   */ MerchantCategory["MEXICANA_AIRLINES"] = "MEXICANA_AIRLINES";
    /**
   * The category for Mgm Grand Hotel
   *
   * Numeric Code: '3730'
   */ MerchantCategory["MGM_GRAND_HOTEL"] = "MGM_GRAND_HOTEL";
    /**
   * The category for Microtel Inn And Suites
   *
   * Numeric Code: '3613'
   */ MerchantCategory["MICROTEL_INN_AND_SUITES"] = "MICROTEL_INN_AND_SUITES";
    /**
   * The category for Middle East Air
   *
   * Numeric Code: '3175'
   */ MerchantCategory["MIDDLE_EAST_AIR"] = "MIDDLE_EAST_AIR";
    /**
   * The category for Midway Motor Lodge
   *
   * Numeric Code: '3699'
   */ MerchantCategory["MIDWAY_MOTOR_LODGE"] = "MIDWAY_MOTOR_LODGE";
    /**
   * The category for Midwest Express Airlines
   *
   * Numeric Code: '3085'
   */ MerchantCategory["MIDWEST_EXPRESS_AIRLINES"] = "MIDWEST_EXPRESS_AIRLINES";
    /**
   * The category for Millennium Broadway Hotel
   *
   * Numeric Code: '3741'
   */ MerchantCategory["MILLENNIUM_BROADWAY_HOTEL"] = "MILLENNIUM_BROADWAY_HOTEL";
    /**
   * The category for Milleville
   *
   * Numeric Code: '3439'
   */ MerchantCategory["MILLEVILLE"] = "MILLEVILLE";
    /**
   * The category for Minacia
   *
   * Numeric code: '3849'
   */ MerchantCategory["MINACIA"] = "MINACIA";
    /**
   * The category for Mirage Hotel And Casino
   *
   * Numeric Code: '3551'
   */ MerchantCategory["MIRAGE_HOTEL_AND_CASINO"] = "MIRAGE_HOTEL_AND_CASINO";
    /**
   * The category for Miscellaneous Apparel and Accessory Shops.
   *
   * Numeric code: '5699'
   */ MerchantCategory["MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS"] = "MISCELLANEOUS_APPAREL_AND_ACCESSORY_SHOPS";
    /**
   * The category for Miscellaneous Auto Dealers.
   *
   * Numeric code: '5599'
   */ MerchantCategory["MISCELLANEOUS_AUTO_DEALERS"] = "MISCELLANEOUS_AUTO_DEALERS";
    /**
   * The category for Miscellaneous Business Services.
   *
   * Numeric code: '7399'
   */ MerchantCategory["MISCELLANEOUS_BUSINESS_SERVICES"] = "MISCELLANEOUS_BUSINESS_SERVICES";
    /**
   * The category for Miscellaneous Food Stores - Convenience Stores and Specialty Markets.
   *
   * Numeric code: '5499'
   */ MerchantCategory["MISCELLANEOUS_FOOD_STORES"] = "MISCELLANEOUS_FOOD_STORES";
    /**
   * The category for Miscellaneous General Merchandise.
   *
   * Numeric code: '5399'
   */ MerchantCategory["MISCELLANEOUS_GENERAL_MERCHANDISE"] = "MISCELLANEOUS_GENERAL_MERCHANDISE";
    /**
   * The category for Miscellaneous General Services.
   *
   * Numeric code: '7299'
   */ MerchantCategory["MISCELLANEOUS_GENERAL_SERVICES"] = "MISCELLANEOUS_GENERAL_SERVICES";
    /**
   * The category for Miscellaneous Home Furnishing Specialty Stores.
   *
   * Numeric code: '5719'
   */ MerchantCategory["MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES"] = "MISCELLANEOUS_HOME_FURNISHING_SPECIALTY_STORES";
    /**
   * The category for Miscellaneous Publishing and Printing.
   *
   * Numeric code: '2741'
   */ MerchantCategory["MISCELLANEOUS_PUBLISHING_AND_PRINTING"] = "MISCELLANEOUS_PUBLISHING_AND_PRINTING";
    /**
   * The category for Miscellaneous Recreation Services.
   *
   * Numeric code: '7999'
   */ MerchantCategory["MISCELLANEOUS_RECREATION_SERVICES"] = "MISCELLANEOUS_RECREATION_SERVICES";
    /**
   * The category for Miscellaneous Repair Shops.
   *
   * Numeric code: '7699'
   */ MerchantCategory["MISCELLANEOUS_REPAIR_SHOPS"] = "MISCELLANEOUS_REPAIR_SHOPS";
    /**
   * The category for Miscellaneous Specialty Retail.
   *
   * Numeric code: '5999'
   */ MerchantCategory["MISCELLANEOUS_SPECIALTY_RETAIL"] = "MISCELLANEOUS_SPECIALTY_RETAIL";
    /**
   * The category for Miyako Hotel/Kintetsu
   *
   * Numeric Code: '3572'
   */ MerchantCategory["MIYAKO_HOTEL_KINTETSU"] = "MIYAKO_HOTEL_KINTETSU";
    /**
   * The category for Mobile Home Dealers.
   *
   * Numeric code: '5271'
   */ MerchantCategory["MOBILE_HOME_DEALERS"] = "MOBILE_HOME_DEALERS";
    /**
   * The category for Moevenpick
   *
   * Numeric Code: '3612'
   */ MerchantCategory["MOEVENPICK"] = "MOEVENPICK";
    /**
   * The category for MoneySend Funding.
   *
   * Numeric code: '6538'
   */ MerchantCategory["MONEYSEND_FUNDING"] = "MONEYSEND_FUNDING";
    /**
   * The category for MoneySend Intercountry.
   *
   * Numeric code: '6537'
   */ MerchantCategory["MONEYSEND_INTERCOUNTRY"] = "MONEYSEND_INTERCOUNTRY";
    /**
   * The category for MoneySend Intracountry.
   *
   * Numeric code: '6536'
   */ MerchantCategory["MONEYSEND_INTRACOUNTRY"] = "MONEYSEND_INTRACOUNTRY";
    /**
   * The category for money transfer - Member Financial Institution
   *
   * Numeric code: '6534'
   */ MerchantCategory["MONEY_TRANSFER_FINANCIAL_INSTITUTION"] = "MONEY_TRANSFER_FINANCIAL_INSTITUTION";
    /**
   * The category for Monte Carlo Hotel And Casino
   *
   * Numeric Code: '3676'
   */ MerchantCategory["MONTE_CARLO_HOTEL_AND_CASINO"] = "MONTE_CARLO_HOTEL_AND_CASINO";
    /**
   * The category for Mortgage Bankers & Loan Correspondents
   *
   * Numeric code: '6162'
   */ MerchantCategory["MORTGAGE_BANKERS_LOAN_CORRESPONDENTS"] = "MORTGAGE_BANKERS_LOAN_CORRESPONDENTS";
    /**
   * The category for Motel 6
   *
   * Numeric Code: '3700'
   */ MerchantCategory["MOTEL_6"] = "MOTEL_6";
    /**
   * The category for Motion Picture Theaters.
   *
   * Numeric code: '7832'
   */ MerchantCategory["MOTION_PICTURE_THEATERS"] = "MOTION_PICTURE_THEATERS";
    /**
   * The category for Motorcycle Shops and Dealers.
   *
   * Numeric code: '5571'
   */ MerchantCategory["MOTORCYCLE_SHOPS_AND_DEALERS"] = "MOTORCYCLE_SHOPS_AND_DEALERS";
    /**
   * The category for "Motorcycle Shops, Dealers".
   *
   * Numeric code: '5561'
   */ MerchantCategory["MOTORCYCLE_SHOPS_DEALERS"] = "MOTORCYCLE_SHOPS_DEALERS";
    /**
   * The category for "Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services".
   *
   * Numeric code: '4214'
   */ MerchantCategory["MOTOR_FREIGHT_CARRIERS_AND_TRUCKING"] = "MOTOR_FREIGHT_CARRIERS_AND_TRUCKING";
    /**
   * The category for Motor Homes Dealers.
   *
   * Numeric code: '5592'
   */ MerchantCategory["MOTOR_HOMES_DEALERS"] = "MOTOR_HOMES_DEALERS";
    /**
   * The category for Motor Vehicle Supplies and New Parts.
   *
   * Numeric code: '5013'
   */ MerchantCategory["MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS"] = "MOTOR_VEHICLE_SUPPLIES_AND_NEW_PARTS";
    /**
   * The category for Mount Charlotte Hotels
   *
   * Numeric Code: '3639'
   */ MerchantCategory["MOUNT_CHARLOTTE_HOTELS"] = "MOUNT_CHARLOTTE_HOTELS";
    /**
   * The category for Mount Cook
   *
   * Numeric Code: '3170'
   */ MerchantCategory["MOUNT_COOK"] = "MOUNT_COOK";
    /**
   * The category for Moxy
   *
   * Numeric code: '3843'
   */ MerchantCategory["MOXY"] = "MOXY";
    /**
   * The category for "Music Stores-Musical Instruments, Pianos, and Sheet Music".
   *
   * Numeric code: '5733'
   */ MerchantCategory["MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC"] = "MUSIC_STORES_MUSICAL_INSTRUMENTS_PIANOS_AND_SHEET_MUSIC";
    /**
   * The category for Nationair
   *
   * Numeric Code: '3172'
   */ MerchantCategory["NATIONAIR"] = "NATIONAIR";
    /**
   * The category for National Car Rental
   *
   * Numeric Code: '3393'
   */ MerchantCategory["NATIONAL_CAR_RENTAL"] = "NATIONAL_CAR_RENTAL";
    /**
   * The category for Nemacolin Woodlands
   *
   * Numeric Code: '3772'
   */ MerchantCategory["NEMACOLIN_WOODLANDS"] = "NEMACOLIN_WOODLANDS";
    /**
   * The category for Nest Hotel
   *
   * Numeric code: '3883'
   */ MerchantCategory["NEST_HOTEL"] = "NEST_HOTEL";
    /**
   * The category for Nevele Grande Resort And Country Club
   *
   * Numeric Code: '3776'
   */ MerchantCategory["NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB"] = "NEVELE_GRANDE_RESORT_AND_COUNTRY_CLUB";
    /**
   * The category for News Dealers and Newsstands.
   *
   * Numeric code: '5994'
   */ MerchantCategory["NEWS_DEALERS_AND_NEWSSTANDS"] = "NEWS_DEALERS_AND_NEWSSTANDS";
    /**
   * The category for New Otani Hotels
   *
   * Numeric Code: '3658'
   */ MerchantCategory["NEW_OTANI_HOTELS"] = "NEW_OTANI_HOTELS";
    /**
   * The category for New York New York Hotel And Casino
   *
   * Numeric Code: '3774'
   */ MerchantCategory["NEW_YORK_NEW_YORK_HOTEL_AND_CASINO"] = "NEW_YORK_NEW_YORK_HOTEL_AND_CASINO";
    /**
   * The category for Nickelodeon Family Suites By Holiday Inn
   *
   * Numeric Code: '3815'
   */ MerchantCategory["NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN"] = "NICKELODEON_FAMILY_SUITES_BY_HOLIDAY_INN";
    /**
   * The category for Nigeria Airways
   *
   * Numeric Code: '3045'
   */ MerchantCategory["NIGERIA_AIR"] = "NIGERIA_AIR";
    /**
   * The category for Noahs Hotel Melbourne
   *
   * Numeric Code: '3603'
   */ MerchantCategory["NOAHS_HOTEL_MELBOURNE"] = "NOAHS_HOTEL_MELBOURNE";
    /**
   * The category for Nondurable Goods (Not Elsewhere Classified).
   *
   * Numeric code: '5199'
   */ MerchantCategory["NONDURABLE_GOODS"] = "NONDURABLE_GOODS";
    /**
   * The category for "Non-FI, Money Orders".
   *
   * Numeric code: '6051'
   */ MerchantCategory["NON_FI_MONEY_ORDERS"] = "NON_FI_MONEY_ORDERS";
    /**
   * The category for "Non-FI, Stored Value Card Purchase/Load".
   *
   * Numeric code: '6540'
   */ MerchantCategory["NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD"] = "NON_FI_STORED_VALUE_CARD_PURCHASE_LOAD";
    /**
   * The category for NordAir
   *
   * Numeric Code: '3081'
   */ MerchantCategory["NORD_AIR"] = "NORD_AIR";
    /**
   * The category for Norontair
   *
   * Numeric Code: '3164'
   */ MerchantCategory["NORONTAIR"] = "NORONTAIR";
    /**
   * The category for Norwegian Air Shuttle
   *
   * Numeric Code: '3211'
   */ MerchantCategory["NORWEGIAN_AIR_SHUTTLE"] = "NORWEGIAN_AIR_SHUTTLE";
    /**
   * The category for Novotel Sieh Accor
   *
   * Numeric Code: '3642'
   */ MerchantCategory["NOVOTEL_SIEH_ACCOR"] = "NOVOTEL_SIEH_ACCOR";
    /**
   * The category for "Nurseries, Lawn and Garden Supply Stores".
   *
   * Numeric code: '5261'
   */ MerchantCategory["NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES"] = "NURSERIES_LAWN_AND_GARDEN_SUPPLY_STORES";
    /**
   * The category for Nursing/Personal Care.
   *
   * Numeric code: '8050'
   */ MerchantCategory["NURSING_PERSONAL_CARE"] = "NURSING_PERSONAL_CARE";
    /**
   * The category for Northwest Airlines
   *
   * Numeric Code: '3060'
   */ MerchantCategory["NWA_AIR"] = "NWA_AIR";
    /**
   * The category for New York Helicopter
   *
   * Numeric Code: '3165'
   */ MerchantCategory["NY_HELI"] = "NY_HELI";
    /**
   * The category for Oberoi Hotels
   *
   * Numeric Code: '3657'
   */ MerchantCategory["OBEROI_HOTELS"] = "OBEROI_HOTELS";
    /**
   * The category for Office and Commercial Furniture.
   *
   * Numeric code: '5021'
   */ MerchantCategory["OFFICE_AND_COMMERCIAL_FURNITURE"] = "OFFICE_AND_COMMERCIAL_FURNITURE";
    /**
   * The category for Ohana Hotels Of Hawaii
   *
   * Numeric Code: '3786'
   */ MerchantCategory["OHANA_HOTELS_OF_HAWAII"] = "OHANA_HOTELS_OF_HAWAII";
    /**
   * The category for Olympic Airways
   *
   * Numeric Code: '3031'
   */ MerchantCategory["OLYMPIC_AIRWAYS"] = "OLYMPIC_AIRWAYS";
    /**
   * The category for Oman Air
   *
   * Numeric Code: '3183'
   */ MerchantCategory["OMAN_AIR"] = "OMAN_AIR";
    /**
   * The category for Omni International
   *
   * Numeric Code: '3592'
   */ MerchantCategory["OMNI_INTERNATIONAL"] = "OMNI_INTERNATIONAL";
    /**
   * The category for Online Marketplaces.
   *
   * Numeric code: '5262'
   */ MerchantCategory["ONLINE_MARKETPLACES"] = "ONLINE_MARKETPLACES";
    /**
   * The category for Opryland Hotel
   *
   * Numeric Code: '3732'
   */ MerchantCategory["OPRYLAND_HOTEL"] = "OPRYLAND_HOTEL";
    /**
   * The category for "Opticians, Eyeglasses".
   *
   * Numeric code: '8043'
   */ MerchantCategory["OPTICIANS_EYEGLASSES"] = "OPTICIANS_EYEGLASSES";
    /**
   * The category for "Optometrists, Ophthalmologist".
   *
   * Numeric code: '8042'
   */ MerchantCategory["OPTOMETRISTS_OPHTHALMOLOGIST"] = "OPTOMETRISTS_OPHTHALMOLOGIST";
    /**
   * The category for Orchid At Mauna Lai
   *
   * Numeric Code: '3759'
   */ MerchantCategory["ORCHID_AT_MAUNA_LAI"] = "ORCHID_AT_MAUNA_LAI";
    /**
   * The category for Orix Hotels and Resorts
   *
   * Numeric code: '3877'
   */ MerchantCategory["ORIX_HOTELS_AND_RESORTS"] = "ORIX_HOTELS_AND_RESORTS";
    /**
   * The category for Orthopedic Goods - Prosthetic Devices.
   *
   * Numeric code: '5976'
   */ MerchantCategory["ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES"] = "ORTHOPEDIC_GOODS_PROSTHETIC_DEVICES";
    /**
   * The category for Osteopaths.
   *
   * Numeric code: '8031'
   */ MerchantCategory["OSTEOPATHS"] = "OSTEOPATHS";
    /**
   * The category for Outrigger Hotels And Resorts
   *
   * Numeric Code: '3785'
   */ MerchantCategory["OUTRIGGER_HOTELS_AND_RESORTS"] = "OUTRIGGER_HOTELS_AND_RESORTS";
    /**
   * The category for Overpayments
   *
   * Numeric code: '6611'
   */ MerchantCategory["OVERPAYMENT_TRANSACTIONS"] = "OVERPAYMENT_TRANSACTIONS";
    /**
   * The category for Oxford Suites
   *
   * Numeric Code: '3819'
   */ MerchantCategory["OXFORD_SUITES"] = "OXFORD_SUITES";
    /**
   * The category for "Package Stores-Beer, Wine, and Liquor".
   *
   * Numeric code: '5921'
   */ MerchantCategory["PACKAGE_STORES_BEER_WINE_AND_LIQUOR"] = "PACKAGE_STORES_BEER_WINE_AND_LIQUOR";
    /**
   * The category for "Paints, Varnishes, and Supplies".
   *
   * Numeric code: '5198'
   */ MerchantCategory["PAINTS_VARNISHES_AND_SUPPLIES"] = "PAINTS_VARNISHES_AND_SUPPLIES";
    /**
   * The category for Pakistan International
   *
   * Numeric Code: '3024'
   */ MerchantCategory["PAKISTAN_INTERNATIONAL"] = "PAKISTAN_INTERNATIONAL";
    /**
   * The category for Pannonia Hotels
   *
   * Numeric Code: '3599'
   */ MerchantCategory["PANNONIA_HOTELS"] = "PANNONIA_HOTELS";
    /**
   * The category for Pan American
   *
   * Numeric Code: '3002'
   */ MerchantCategory["PAN_AMERICAN"] = "PAN_AMERICAN";
    /**
   * The category for Paris Las Vegas Hotel
   *
   * Numeric Code: '3795'
   */ MerchantCategory["PARIS_LAS_VEGAS_HOTEL"] = "PARIS_LAS_VEGAS_HOTEL";
    /**
   * The category for "Parking Lots, Garages".
   *
   * Numeric code: '7523'
   */ MerchantCategory["PARKING_LOTS_GARAGES"] = "PARKING_LOTS_GARAGES";
    /**
   * The category for Parks Inns International
   *
   * Numeric Code: '3553'
   */ MerchantCategory["PARKS_INNS_INTERNATIONAL"] = "PARKS_INNS_INTERNATIONAL";
    /**
   * The category for Park Inn By Radisson
   *
   * Numeric Code: '3533'
   */ MerchantCategory["PARK_INN_BY_RADISSON"] = "PARK_INN_BY_RADISSON";
    /**
   * The category for Park Plaza Hotel
   *
   * Numeric Code: '3830'
   */ MerchantCategory["PARK_PLAZA_HOTEL"] = "PARK_PLAZA_HOTEL";
    /**
   * The category for Passenger Railways.
   *
   * Numeric code: '4112'
   */ MerchantCategory["PASSENGER_RAILWAYS"] = "PASSENGER_RAILWAYS";
    /**
   * The category for Patricia Grand Resort Hotels
   *
   * Numeric Code: '3781'
   */ MerchantCategory["PATRICIA_GRAND_RESORT_HOTELS"] = "PATRICIA_GRAND_RESORT_HOTELS";
    /**
   * The category for Pawn Shops.
   *
   * Numeric code: '5933'
   */ MerchantCategory["PAWN_SHOPS"] = "PAWN_SHOPS";
    /**
   * The category for Payless Car Rental
   *
   * Numeric Code: '3359'
   */ MerchantCategory["PAYLESS_CAR_RENTAL"] = "PAYLESS_CAR_RENTAL";
    /**
   * The category for Payment Service Provider - money transfer for a purchase
   *
   * Numeric code: '6531'
   */ MerchantCategory["PAYMENT_SERVICE_PROVIDER_MONEY_TRANSFER"] = "PAYMENT_SERVICE_PROVIDER_MONEY_TRANSFER";
    /**
   * The category for Provincetown-Boston Airways
   *
   * Numeric Code: '3159'
   */ MerchantCategory["PBA_AIRLINE"] = "PBA_AIRLINE";
    /**
   * The category for Peabody Hotels
   *
   * Numeric Code: '3752'
   */ MerchantCategory["PEABODY_HOTELS"] = "PEABODY_HOTELS";
    /**
   * The category for Peninsula Hotels
   *
   * Numeric Code: '3523'
   */ MerchantCategory["PENINSULA_HOTELS"] = "PENINSULA_HOTELS";
    /**
   * The category for Penta Hotels
   *
   * Numeric Code: '3653'
   */ MerchantCategory["PENTA_HOTELS"] = "PENTA_HOTELS";
    /**
   * The category for Peppermill Hotel Casino
   *
   * Numeric Code: '3796'
   */ MerchantCategory["PEPPERMILL_HOTEL_CASINO"] = "PEPPERMILL_HOTEL_CASINO";
    /**
   * The category for companies which provide loans to individuals
   *
   * Numeric Code: ‘6141’
   */ MerchantCategory["PERSONAL_CREDIT_INSTITUTIONS"] = "PERSONAL_CREDIT_INSTITUTIONS";
    /**
   * The category for Petroleum and Petroleum Products.
   *
   * Numeric code: '5172'
   */ MerchantCategory["PETROLEUM_AND_PETROLEUM_PRODUCTS"] = "PETROLEUM_AND_PETROLEUM_PRODUCTS";
    /**
   * The category for "Pet Shops, Pet Food, and Supplies".
   *
   * Numeric code: '5995'
   */ MerchantCategory["PET_SHOPS_PET_FOOD_AND_SUPPLIES"] = "PET_SHOPS_PET_FOOD_AND_SUPPLIES";
    /**
   * The category for Philippine Airlines
   *
   * Numeric Code: '3022'
   */ MerchantCategory["PHILIPPINE_AIRLINES"] = "PHILIPPINE_AIRLINES";
    /**
   * The category for "Photographic, Photocopy, Microfilm Equipment, and Supplies".
   *
   * Numeric code: '5044'
   */ MerchantCategory["PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES"] = "PHOTOGRAPHIC_PHOTOCOPY_MICROFILM_EQUIPMENT_AND_SUPPLIES";
    /**
   * The category for Photographic Studios.
   *
   * Numeric code: '7221'
   */ MerchantCategory["PHOTOGRAPHIC_STUDIOS"] = "PHOTOGRAPHIC_STUDIOS";
    /**
   * The category for Photo Developing.
   *
   * Numeric code: '7395'
   */ MerchantCategory["PHOTO_DEVELOPING"] = "PHOTO_DEVELOPING";
    /**
   * The category for Picture/Video Production.
   *
   * Numeric code: '7829'
   */ MerchantCategory["PICTURE_VIDEO_PRODUCTION"] = "PICTURE_VIDEO_PRODUCTION";
    /**
   * The category for "Piece Goods, Notions, and Other Dry Goods".
   *
   * Numeric code: '5131'
   */ MerchantCategory["PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS"] = "PIECE_GOODS_NOTIONS_AND_OTHER_DRY_GOODS";
    /**
   * The category for Pinehurst Resort
   *
   * Numeric Code: '3554'
   */ MerchantCategory["PINEHURST_RESORT"] = "PINEHURST_RESORT";
    /**
   * The category for PINless Debit BillPay Tier 2 (Tel, Cable, TV, Radio, Insurance)
   *
   * Numeric Code: '6321'
   */ MerchantCategory["PINLESS_DEBIT_BILLPAY_TIER_2"] = "PINLESS_DEBIT_BILLPAY_TIER_2";
    /**
   * The category for Plm/Etap International
   *
   * Numeric Code: '3519'
   */ MerchantCategory["PLM_ETAP_INTERNATIONAL"] = "PLM_ETAP_INTERNATIONAL";
    /**
   * The category for "Plumbing, Heating Equipment, and Supplies".
   *
   * Numeric code: '5074'
   */ MerchantCategory["PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES"] = "PLUMBING_HEATING_EQUIPMENT_AND_SUPPLIES";
    /**
   * The category for Political Organizations.
   *
   * Numeric code: '8651'
   */ MerchantCategory["POLITICAL_ORGANIZATIONS"] = "POLITICAL_ORGANIZATIONS";
    /**
   * The category for Postal Services - Government Only.
   *
   * Numeric code: '9402'
   */ MerchantCategory["POSTAL_SERVICES_GOVERNMENT_ONLY"] = "POSTAL_SERVICES_GOVERNMENT_ONLY";
    /**
   * The category for "Precious Stones and Metals, Watches and Jewelry".
   *
   * Numeric code: '5094'
   */ MerchantCategory["PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY"] = "PRECIOUS_STONES_AND_METALS_WATCHES_AND_JEWELRY";
    /**
   * The category for Premier Travel Inns
   *
   * Numeric Code: '3811'
   */ MerchantCategory["PREMIER_TRAVEL_INNS"] = "PREMIER_TRAVEL_INNS";
    /**
   * The category for Primadonna Hotel And Casino
   *
   * Numeric Code: '3761'
   */ MerchantCategory["PRIMADONNA_HOTEL_AND_CASINO"] = "PRIMADONNA_HOTEL_AND_CASINO";
    /**
   * The category for Princess Hotels International
   *
   * Numeric Code: '3584'
   */ MerchantCategory["PRINCESS_HOTELS_INTERNATIONAL"] = "PRINCESS_HOTELS_INTERNATIONAL";
    /**
   * The category for Princeville Air
   *
   * Numeric Code: '3154'
   */ MerchantCategory["PRINCEVILLE_AIR"] = "PRINCEVILLE_AIR";
    /**
   * The category for Princeville Resort
   *
   * Numeric Code: '3806'
   */ MerchantCategory["PRINCEVILLE_RESORT"] = "PRINCEVILLE_RESORT";
    /**
   * The category for Prince Hotels
   *
   * Numeric Code: '3526'
   */ MerchantCategory["PRINCE_HOTELS"] = "PRINCE_HOTELS";
    /**
   * The category for Professional Services.
   *
   * Numeric code: '8999'
   */ MerchantCategory["PROFESSIONAL_SERVICES"] = "PROFESSIONAL_SERVICES";
    /**
   * The category for Protea Hotels
   *
   * Numeric Code: '3719'
   */ MerchantCategory["PROTEA_HOTELS"] = "PROTEA_HOTELS";
    /**
   * The category for "Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage".
   *
   * Numeric code: '4225'
   */ MerchantCategory["PUBLIC_WAREHOUSING_AND_STORAGE"] = "PUBLIC_WAREHOUSING_AND_STORAGE";
    /**
   * The category for Qatar Airways
   *
   * Numeric Code: '3136'
   */ MerchantCategory["QATAR_AIRWAYS"] = "QATAR_AIRWAYS";
    /**
   * The category for Quality International
   *
   * Numeric Code: '3508'
   */ MerchantCategory["QUALITY_INTERNATIONAL"] = "QUALITY_INTERNATIONAL";
    /**
   * The category for Quality Pacific Hotel
   *
   * Numeric Code: '3713'
   */ MerchantCategory["QUALITY_PACIFIC_HOTEL"] = "QUALITY_PACIFIC_HOTEL";
    /**
   * The category for Quantas
   *
   * Numeric Code: '3012'
   */ MerchantCategory["QUANTAS"] = "QUANTAS";
    /**
   * The category for Quasi Cash - Customer Financial Institutions.
   *
   * Numeric code: '6050'
   */ MerchantCategory["QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS"] = "QUASI_CASH_CUSTOMER_FINANCIAL_INSTITUTIONS";
    /**
   * The category for Queens Moat Houses
   *
   * Numeric Code: '3645'
   */ MerchantCategory["QUEENS_MOAT_HOUSES"] = "QUEENS_MOAT_HOUSES";
    /**
   * The category for "Quick Copy, Repro, and Blueprint".
   *
   * Numeric code: '7338'
   */ MerchantCategory["QUICK_COPY_REPRO_AND_BLUEPRINT"] = "QUICK_COPY_REPRO_AND_BLUEPRINT";
    /**
   * The category for Quintessa Hotel
   *
   * Numeric code: '3865'
   */ MerchantCategory["QUINTESSA_HOTEL"] = "QUINTESSA_HOTEL";
    /**
   * The category for Radisson
   *
   * Numeric Code: '3649'
   */ MerchantCategory["RADISSON"] = "RADISSON";
    /**
   * The category for Radisson Blu
   *
   * Numeric Code: '3583'
   */ MerchantCategory["RADISSON_BLU"] = "RADISSON_BLU";
    /**
   * The category for Raffles Hotels
   *
   * Numeric Code: '3790'
   */ MerchantCategory["RAFFLES_HOTELS"] = "RAFFLES_HOTELS";
    /**
   * The category for Railroads.
   *
   * Numeric code: '4011'
   */ MerchantCategory["RAILROADS"] = "RAILROADS";
    /**
   * The category for Ramada Inns
   *
   * Numeric Code: '3637'
   */ MerchantCategory["RAMADA_INNS"] = "RAMADA_INNS";
    /**
   * The category for Rank Hotels
   *
   * Numeric Code: '3633'
   */ MerchantCategory["RANK_HOTELS"] = "RANK_HOTELS";
    /**
   * The category for Rantasipi Hotels
   *
   * Numeric Code: '3674'
   */ MerchantCategory["RANTASIPI_HOTELS"] = "RANTASIPI_HOTELS";
    /**
   * The category for Real Estate Agents and Managers - Rentals.
   *
   * Numeric code: '6513'
   */ MerchantCategory["REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS"] = "REAL_ESTATE_AGENTS_AND_MANAGERS_RENTALS";
    /**
   * The category for Record Stores.
   *
   * Numeric code: '5735'
   */ MerchantCategory["RECORD_STORES"] = "RECORD_STORES";
    /**
   * The category for Recreational Vehicle Rentals.
   *
   * Numeric code: '7519'
   */ MerchantCategory["RECREATIONAL_VEHICLE_RENTALS"] = "RECREATIONAL_VEHICLE_RENTALS";
    /**
   * The category for Red Roof Inns
   *
   * Numeric Code: '3650'
   */ MerchantCategory["RED_ROOF_INNS"] = "RED_ROOF_INNS";
    /**
   * The category for Regal 8 Inns
   *
   * Numeric Code: '3550'
   */ MerchantCategory["REGAL_8_INNS"] = "REGAL_8_INNS";
    /**
   * The category for Regent Hotels
   *
   * Numeric Code: '3598'
   */ MerchantCategory["REGENT_HOTELS"] = "REGENT_HOTELS";
    /**
   * The category for Registry Hotels
   *
   * Numeric Code: '3702'
   */ MerchantCategory["REGISTRY_HOTELS"] = "REGISTRY_HOTELS";
    /**
   * The category for Relax Inns
   *
   * Numeric Code: '3565'
   */ MerchantCategory["RELAX_INNS"] = "RELAX_INNS";
    /**
   * The category for Religious Goods Stores.
   *
   * Numeric code: '5973'
   */ MerchantCategory["RELIGIOUS_GOODS_STORES"] = "RELIGIOUS_GOODS_STORES";
    /**
   * The category for Religious Organizations.
   *
   * Numeric code: '8661'
   */ MerchantCategory["RELIGIOUS_ORGANIZATIONS"] = "RELIGIOUS_ORGANIZATIONS";
    /**
   * The category for Relo Vacations
   *
   * Numeric code: '3868'
   */ MerchantCategory["RELO_VACATIONS"] = "RELO_VACATIONS";
    /**
   * The category for Remote Stored Value Load - Member Financial Institution
   *
   * Numeric code: '6529'
   */ MerchantCategory["REMOTE_STORED_VALUE_LOAD_FINANCIAL_INSTITUTION"] = "REMOTE_STORED_VALUE_LOAD_FINANCIAL_INSTITUTION";
    /**
   * The category for Remote Stored Value Load - Merchant
   *
   * Numeric code: '6530'
   */ MerchantCategory["REMOTE_STORED_VALUE_LOAD_MERCHANT"] = "REMOTE_STORED_VALUE_LOAD_MERCHANT";
    /**
   * The category for Renaissance Hotels
   *
   * Numeric Code: '3530'
   */ MerchantCategory["RENAISSANCE_HOTELS"] = "RENAISSANCE_HOTELS";
    /**
   * The category for Reno Air
   *
   * Numeric Code: '3262'
   */ MerchantCategory["RENO_AIR"] = "RENO_AIR";
    /**
   * The category for Rent A Wreck
   *
   * Numeric Code: '3370'
   */ MerchantCategory["RENT_A_WRECK"] = "RENT_A_WRECK";
    /**
   * The category for Replacement Rent A Car
   *
   * Numeric Code: '3431'
   */ MerchantCategory["REPLACEMENT_RENT_A_CAR"] = "REPLACEMENT_RENT_A_CAR";
    /**
   * The category for Reserve Rent A Car
   *
   * Numeric Code: '3432'
   */ MerchantCategory["RESERVE_RENT_A_CAR"] = "RESERVE_RENT_A_CAR";
    /**
   * The category for Residence Inn
   *
   * Numeric Code: '3703'
   */ MerchantCategory["RESIDENCE_INN"] = "RESIDENCE_INN";
    /**
   * The category for Reso Hotels
   *
   * Numeric Code: '3635'
   */ MerchantCategory["RESO_HOTELS"] = "RESO_HOTELS";
    /**
   * The category for Rica Hotels
   *
   * Numeric Code: '3723'
   */ MerchantCategory["RICA_HOTELS"] = "RICA_HOTELS";
    /**
   * The category for Rio Hotels
   *
   * Numeric code: '3840'
   */ MerchantCategory["RIO_HOTELS"] = "RIO_HOTELS";
    /**
   * The category for Rio Suites
   *
   * Numeric Code: '3726'
   */ MerchantCategory["RIO_SUITES"] = "RIO_SUITES";
    /**
   * The category for Ritz Carlton
   *
   * Numeric Code: '3710'
   */ MerchantCategory["RITZ_CARLTON"] = "RITZ_CARLTON";
    /**
   * The category for Riverside Resort And Casino
   *
   * Numeric Code: '3597'
   */ MerchantCategory["RIVERSIDE_RESORT_AND_CASINO"] = "RIVERSIDE_RESORT_AND_CASINO";
    /**
   * The category for Riviera Hotel And Casino
   *
   * Numeric Code: '3737'
   */ MerchantCategory["RIVIERA_HOTEL_AND_CASINO"] = "RIVIERA_HOTEL_AND_CASINO";
    /**
   * The category for Riyadh Air
   *
   * Numeric code: ‘3169'
   */ MerchantCategory["RIYADH_AIR"] = "RIYADH_AIR";
    /**
   * The category for Rodeway Inns International
   *
   * Numeric Code: '3515'
   */ MerchantCategory["RODEWAY_INNS_INTERNATIONAL"] = "RODEWAY_INNS_INTERNATIONAL";
    /**
   * The category for "Roofing/Siding, Sheet Metal".
   *
   * Numeric code: '1761'
   */ MerchantCategory["ROOFING_SIDING_SHEET_METAL"] = "ROOFING_SIDING_SHEET_METAL";
    /**
   * The category for Rosen Hotel And Resorts
   *
   * Numeric Code: '3782'
   */ MerchantCategory["ROSEN_HOTEL_AND_RESORTS"] = "ROSEN_HOTEL_AND_RESORTS";
    /**
   * The category for Royal Hotels
   *
   * Numeric Code: '3542'
   */ MerchantCategory["ROYAL_HOTELS"] = "ROYAL_HOTELS";
    /**
   * The category for Royal Kona Resort
   *
   * Numeric Code: '3532'
   */ MerchantCategory["ROYAL_KONA_RESORT"] = "ROYAL_KONA_RESORT";
    /**
   * The category for Royce Hotel
   *
   * Numeric Code: '3704'
   */ MerchantCategory["ROYCE_HOTEL"] = "ROYCE_HOTEL";
    /**
   * The category for Ryanair
   *
   * Numeric Code: '3246'
   */ MerchantCategory["RYANAIR"] = "RYANAIR";
    /**
   * The category for Sabena
   *
   * Numeric Code: '3029'
   */ MerchantCategory["SABENA"] = "SABENA";
    /**
   * The category for Saddlebrook Resort–Tampa
   *
   * Numeric Code: '3600'
   */ MerchantCategory["SADDLEBROOK_RESORT_TAMPA"] = "SADDLEBROOK_RESORT_TAMPA";
    /**
   * The category for SAETA (Sociedad Ecuatorianos De Transportes Aereos)
   *
   * Numeric Code: '3229'
   */ MerchantCategory["SAETA_AIR"] = "SAETA_AIR";
    /**
   * The category for Sahara Hotel And Casino
   *
   * Numeric Code: '3682'
   */ MerchantCategory["SAHARA_HOTEL_AND_CASINO"] = "SAHARA_HOTEL_AND_CASINO";
    /**
   * The category for SAHSA (Servicio Aero De Honduras)
   *
   * Numeric Code: '3231'
   */ MerchantCategory["SAHSA_AIR"] = "SAHSA_AIR";
    /**
   * The category for Sams Town Hotel And Casino
   *
   * Numeric Code: '3564'
   */ MerchantCategory["SAMS_TOWN_HOTEL_AND_CASINO"] = "SAMS_TOWN_HOTEL_AND_CASINO";
    /**
   * The category for Sanco Inn
   *
   * Numeric code: '3879'
   */ MerchantCategory["SANCO_INN"] = "SANCO_INN";
    /**
   * The category for Sandman Hotels
   *
   * Numeric Code: '3573'
   */ MerchantCategory["SANDMAN_HOTELS"] = "SANDMAN_HOTELS";
    /**
   * The category for Sandman Inn
   *
   * Numeric Code: '3705'
   */ MerchantCategory["SANDMAN_INN"] = "SANDMAN_INN";
    /**
   * The category for Sands Resort
   *
   * Numeric Code: '3775'
   */ MerchantCategory["SANDS_RESORT"] = "SANDS_RESORT";
    /**
   * The category for San Juan Air
   *
   * Numeric Code: '3145'
   */ MerchantCategory["SAN_JUAN_AIR"] = "SAN_JUAN_AIR";
    /**
   * The category for Sara Hotels
   *
   * Numeric Code: '3656'
   */ MerchantCategory["SARA_HOTELS"] = "SARA_HOTELS";
    /**
   * The category for Sarova Hotels
   *
   * Numeric Code: '3636'
   */ MerchantCategory["SAROVA_HOTELS"] = "SAROVA_HOTELS";
    /**
   * The category for Saudia Arabian Airlines
   *
   * Numeric Code: '3014'
   */ MerchantCategory["SAUDIA_ARABIAN_AIRLINES"] = "SAUDIA_ARABIAN_AIRLINES";
    /**
   * The category for Scandic Hotels
   *
   * Numeric Code: '3655'
   */ MerchantCategory["SCANDIC_HOTELS"] = "SCANDIC_HOTELS";
    /**
   * The category for Scandinavian Airline System
   *
   * Numeric Code: '3016'
   */ MerchantCategory["SCANDINAVIAN_AIRLINE_SYSTEM"] = "SCANDINAVIAN_AIRLINE_SYSTEM";
    /**
   * The category for Scenic Airlines
   *
   * Numeric Code: '3143'
   */ MerchantCategory["SCENIC_AIRLINES"] = "SCENIC_AIRLINES";
    /**
   * The category for Sea Pines Resort
   *
   * Numeric Code: '3725'
   */ MerchantCategory["SEA_PINES_RESORT"] = "SEA_PINES_RESORT";
    /**
   * The category for Secretarial Support Services.
   *
   * Numeric code: '7339'
   */ MerchantCategory["SECRETARIAL_SUPPORT_SERVICES"] = "SECRETARIAL_SUPPORT_SERVICES";
    /**
   * The category for Security Brokers/Dealers.
   *
   * Numeric code: '6211'
   */ MerchantCategory["SECURITY_BROKERS_DEALERS"] = "SECURITY_BROKERS_DEALERS";
    /**
   * The category for Service Stations.
   *
   * Numeric code: '5541'
   */ MerchantCategory["SERVICE_STATIONS"] = "SERVICE_STATIONS";
    /**
   * The category for Settle Inn
   *
   * Numeric Code: '3809'
   */ MerchantCategory["SETTLE_INN"] = "SETTLE_INN";
    /**
   * The category for "Sewing, Needlework, Fabric, and Piece Goods Stores".
   *
   * Numeric code: '5949'
   */ MerchantCategory["SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES"] = "SEWING_NEEDLEWORK_FABRIC_AND_PIECE_GOODS_STORES";
    /**
   * The category for Shangri La International
   *
   * Numeric Code: '3545'
   */ MerchantCategory["SHANGRI_LA_INTERNATIONAL"] = "SHANGRI_LA_INTERNATIONAL";
    /**
   * The category for Sheraton
   *
   * Numeric Code: '3503'
   */ MerchantCategory["SHERATON"] = "SHERATON";
    /**
   * The category for Shilo Inn
   *
   * Numeric Code: '3706'
   */ MerchantCategory["SHILO_INN"] = "SHILO_INN";
    /**
   * The category for Shoe Repair/Hat Cleaning.
   *
   * Numeric code: '7251'
   */ MerchantCategory["SHOE_REPAIR_HAT_CLEANING"] = "SHOE_REPAIR_HAT_CLEANING";
    /**
   * The category for Shoe Stores.
   *
   * Numeric code: '5661'
   */ MerchantCategory["SHOE_STORES"] = "SHOE_STORES";
    /**
   * The category for Shoneys Inn
   *
   * Numeric Code: '3707'
   */ MerchantCategory["SHONEYS_INN"] = "SHONEYS_INN";
    /**
   * The category for Showcase Rental Cars
   *
   * Numeric Code: '3386'
   */ MerchantCategory["SHOWCASE_RENTAL_CARS"] = "SHOWCASE_RENTAL_CARS";
    /**
   * The category for Silver Legacy Hotel And Casino
   *
   * Numeric Code: '3679'
   */ MerchantCategory["SILVER_LEGACY_HOTEL_AND_CASINO"] = "SILVER_LEGACY_HOTEL_AND_CASINO";
    /**
   * The category for Silver Star Hotel And Casino
   *
   * Numeric Code: '3768'
   */ MerchantCategory["SILVER_STAR_HOTEL_AND_CASINO"] = "SILVER_STAR_HOTEL_AND_CASINO";
    /**
   * The category for Simmons Airlines
   *
   * Numeric Code: '3138'
   */ MerchantCategory["SIMMONS_AIRLINES"] = "SIMMONS_AIRLINES";
    /**
   * The category for Singapore Airlines
   *
   * Numeric Code: '3075'
   */ MerchantCategory["SINGAPORE_AIRLINES"] = "SINGAPORE_AIRLINES";
    /**
   * The category for Singleton Air
   *
   * Numeric Code: '3137'
   */ MerchantCategory["SINGLETON_AIR"] = "SINGLETON_AIR";
    /**
   * The category for Sixt Car Rental
   *
   * Numeric Code: '3355'
   */ MerchantCategory["SIXT_CAR_RENTAL"] = "SIXT_CAR_RENTAL";
    /**
   * The category for Skyways
   *
   * Numeric Code: '3226'
   */ MerchantCategory["SKYWAYS_AIR"] = "SKYWAYS_AIR";
    /**
   * The category for Sleep Inn
   *
   * Numeric Code: '3631'
   */ MerchantCategory["SLEEP_INN"] = "SLEEP_INN";
    /**
   * The category for Small Appliance Repair.
   *
   * Numeric code: '7629'
   */ MerchantCategory["SMALL_APPLIANCE_REPAIR"] = "SMALL_APPLIANCE_REPAIR";
    /**
   * The category for Smile Hotel
   *
   * Numeric code: '3866'
   */ MerchantCategory["SMILE_HOTEL"] = "SMILE_HOTEL";
    /**
   * The category for Smugglers Notch Resort
   *
   * Numeric Code: '3789'
   */ MerchantCategory["SMUGGLERS_NOTCH_RESORT"] = "SMUGGLERS_NOTCH_RESORT";
    /**
   * The category for Snappy Car Rental
   *
   * Numeric Code: '3360'
   */ MerchantCategory["SNAPPY_CAR_RENTAL"] = "SNAPPY_CAR_RENTAL";
    /**
   * The category for Snowmobile Dealers.
   *
   * Numeric code: '5598'
   */ MerchantCategory["SNOWMOBILE_DEALERS"] = "SNOWMOBILE_DEALERS";
    /**
   * The category for Sofitel Hotels
   *
   * Numeric Code: '3641'
   */ MerchantCategory["SOFITEL_HOTELS"] = "SOFITEL_HOTELS";
    /**
   * The category for Soho Grand Hotel
   *
   * Numeric Code: '3567'
   */ MerchantCategory["SOHO_GRAND_HOTEL"] = "SOHO_GRAND_HOTEL";
    /**
   * The category for Sokos Hotel
   *
   * Numeric Code: '3586'
   */ MerchantCategory["SOKOS_HOTEL"] = "SOKOS_HOTEL";
    /**
   * The category for Sol Hotels
   *
   * Numeric Code: '3518'
   */ MerchantCategory["SOL_HOTELS"] = "SOL_HOTELS";
    /**
   * The category for Sonesta International Hotels
   *
   * Numeric Code: '3591'
   */ MerchantCategory["SONESTA_INTERNATIONAL_HOTELS"] = "SONESTA_INTERNATIONAL_HOTELS";
    /**
   * The category for Sotetsu Fresa Inn
   *
   * Numeric code: '3858'
   */ MerchantCategory["SOTETSU_FRESA_INN"] = "SOTETSU_FRESA_INN";
    /**
   * The category for Southern Pacific Hotel
   *
   * Numeric Code: '3534'
   */ MerchantCategory["SOUTHERN_PACIFIC_HOTEL"] = "SOUTHERN_PACIFIC_HOTEL";
    /**
   * The category for Southern Sun Hotels
   *
   * Numeric Code: '3720'
   */ MerchantCategory["SOUTHERN_SUN_HOTELS"] = "SOUTHERN_SUN_HOTELS";
    /**
   * The category for Southwest Airlines
   *
   * Numeric Code: '3066'
   */ MerchantCategory["SOUTHWEST_AIRLINES"] = "SOUTHWEST_AIRLINES";
    /**
   * The category for South African Airways
   *
   * Numeric Code: '3017'
   */ MerchantCategory["SOUTH_AFRICAN_AIRWAYS"] = "SOUTH_AFRICAN_AIRWAYS";
    /**
   * The category for Spanair
   *
   * Numeric Code: '3097'
   */ MerchantCategory["SPANAIR"] = "SPANAIR";
    /**
   * The category for Specialty Cleaning.
   *
   * Numeric code: '2842'
   */ MerchantCategory["SPECIALTY_CLEANING"] = "SPECIALTY_CLEANING";
    /**
   * The category for Special Trade Services.
   *
   * Numeric code: '1799'
   */ MerchantCategory["SPECIAL_TRADE_SERVICES"] = "SPECIAL_TRADE_SERVICES";
    /**
   * The category for Spirit Airlines
   *
   * Numeric Code: '3260'
   */ MerchantCategory["SPIRIT_AIRLINES"] = "SPIRIT_AIRLINES";
    /**
   * The category for Sporting Goods Stores.
   *
   * Numeric code: '5941'
   */ MerchantCategory["SPORTING_GOODS_STORES"] = "SPORTING_GOODS_STORES";
    /**
   * The category for Sporting/Recreation Camps.
   *
   * Numeric code: '7032'
   */ MerchantCategory["SPORTING_RECREATION_CAMPS"] = "SPORTING_RECREATION_CAMPS";
    /**
   * The category for Sports and Riding Apparel Stores.
   *
   * Numeric code: '5655'
   */ MerchantCategory["SPORTS_AND_RIDING_APPAREL_STORES"] = "SPORTS_AND_RIDING_APPAREL_STORES";
    /**
   * The category for Sports Clubs/Fields.
   *
   * Numeric code: '7941'
   */ MerchantCategory["SPORTS_CLUBS_FIELDS"] = "SPORTS_CLUBS_FIELDS";
    /**
   * The category for Springhill Suites
   *
   * Numeric Code: '3770'
   */ MerchantCategory["SPRINGHILL_SUITES"] = "SPRINGHILL_SUITES";
    /**
   * The category for Stakis Hotels
   *
   * Numeric Code: '3666'
   */ MerchantCategory["STAKIS_HOTELS"] = "STAKIS_HOTELS";
    /**
   * The category for Stamp and Coin Stores.
   *
   * Numeric code: '5972'
   */ MerchantCategory["STAMP_AND_COIN_STORES"] = "STAMP_AND_COIN_STORES";
    /**
   * The category for "Stationary, Office Supplies, Printing and Writing Paper".
   *
   * Numeric code: '5111'
   */ MerchantCategory["STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER"] = "STATIONARY_OFFICE_SUPPLIES_PRINTING_AND_WRITING_PAPER";
    /**
   * The category for "Stationery Stores, Office, and School Supply Stores".
   *
   * Numeric code: '5943'
   */ MerchantCategory["STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES"] = "STATIONERY_STORES_OFFICE_AND_SCHOOL_SUPPLY_STORES";
    /**
   * The category for Staybridge Suites
   *
   * Numeric Code: '3791'
   */ MerchantCategory["STAYBRIDGE_SUITES"] = "STAYBRIDGE_SUITES";
    /**
   * The category for Steigenberger
   *
   * Numeric Code: '3643'
   */ MerchantCategory["STEIGENBERGER"] = "STEIGENBERGER";
    /**
   * The category for Stratosphere Hotel And Casino
   *
   * Numeric Code: '3769'
   */ MerchantCategory["STRATOSPHERE_HOTEL_AND_CASINO"] = "STRATOSPHERE_HOTEL_AND_CASINO";
    /**
   * The category for Studio Plus
   *
   * Numeric Code: '3626'
   */ MerchantCategory["STUDIO_PLUS"] = "STUDIO_PLUS";
    /**
   * The category for St Regis Hotel
   *
   * Numeric Code: '3745'
   */ MerchantCategory["ST_REGIS_HOTEL"] = "ST_REGIS_HOTEL";
    /**
   * The category for Sudan Airways
   *
   * Numeric Code: '3135'
   */ MerchantCategory["SUDAN_AIRWAYS"] = "SUDAN_AIRWAYS";
    /**
   * The category for Suisse Chalet
   *
   * Numeric Code: '3686'
   */ MerchantCategory["SUISSE_CHALET"] = "SUISSE_CHALET";
    /**
   * The category for Summerfield Suites Hotel
   *
   * Numeric Code: '3539'
   */ MerchantCategory["SUMMERFIELD_SUITES_HOTEL"] = "SUMMERFIELD_SUITES_HOTEL";
    /**
   * The category for Sunbelt Airlines
   *
   * Numeric Code: '3133'
   */ MerchantCategory["SUNBELT_AIRLINES"] = "SUNBELT_AIRLINES";
    /**
   * The category for Sunworld International
   *
   * Numeric Code: '3130'
   */ MerchantCategory["SUNWORLD_AIR"] = "SUNWORLD_AIR";
    /**
   * The category for Sun Country Airlines
   *
   * Numeric Code: '3069'
   */ MerchantCategory["SUN_COUNTRY_AIRLINES"] = "SUN_COUNTRY_AIRLINES";
    /**
   * The category for Super 8 Motel
   *
   * Numeric Code: '3709'
   */ MerchantCategory["SUPER_8_MOTEL"] = "SUPER_8_MOTEL";
    /**
   * The category for Super Hotel
   *
   * Numeric code: '3863'
   */ MerchantCategory["SUPER_HOTEL"] = "SUPER_HOTEL";
    /**
   * The category for Surinam Airways
   *
   * Numeric Code: '3129'
   */ MerchantCategory["SURINAM_AIRWAYS"] = "SURINAM_AIRWAYS";
    /**
   * The category for Swallow Hotels
   *
   * Numeric Code: '3646'
   */ MerchantCategory["SWALLOW_HOTELS"] = "SWALLOW_HOTELS";
    /**
   * The category for Swimming Pools Sales.
   *
   * Numeric code: '5996'
   */ MerchantCategory["SWIMMING_POOLS_SALES"] = "SWIMMING_POOLS_SALES";
    /**
   * The category for Swissotel
   *
   * Numeric Code: '3634'
   */ MerchantCategory["SWISSOTEL"] = "SWISSOTEL";
    /**
   * The category for Swiss Air
   *
   * Numeric Code: '3015'
   */ MerchantCategory["SWISS_AIR"] = "SWISS_AIR";
    /**
   * The category for Taca International
   *
   * Numeric Code: '3127'
   */ MerchantCategory["TACA_INTERNATIONAL_AIR"] = "TACA_INTERNATIONAL_AIR";
    /**
   * The category for "Tailors, Alterations".
   *
   * Numeric code: '5697'
   */ MerchantCategory["TAILORS_ALTERATIONS"] = "TAILORS_ALTERATIONS";
    /**
   * The category for Taj Hotels Intl
   *
   * Numeric Code: '3659'
   */ MerchantCategory["TAJ_HOTELS_INTL"] = "TAJ_HOTELS_INTL";
    /**
   * The category for Tal Air
   *
   * Numeric Code: '3126'
   */ MerchantCategory["TAL_AIR"] = "TAL_AIR";
    /**
   * The category for Transportes Aeros Militares
   *
   * Numeric Code: '3221'
   */ MerchantCategory["TAME_AIR"] = "TAME_AIR";
    /**
   * The category for Tam Airlines
   *
   * Numeric Code: '3248'
   */ MerchantCategory["TAM_AIRLINES"] = "TAM_AIRLINES";
    /**
   * The category for Tan Sahsa (Tan Air)
   *
   * Numeric Code: '3125'
   */ MerchantCategory["TAN_AIR"] = "TAN_AIR";
    /**
   * The category for TAP Air Portugal
   *
   * Numeric Code: '3035'
   */ MerchantCategory["TAP_AIR_PORTUGAL"] = "TAP_AIR_PORTUGAL";
    /**
   * The category for Tarom Romanian Air Transport
   *
   * Numeric Code: '3297'
   */ MerchantCategory["TAROM_AIR"] = "TAROM_AIR";
    /**
   * The category for Taxicabs/Limousines.
   *
   * Numeric code: '4121'
   */ MerchantCategory["TAXICABS_LIMOUSINES"] = "TAXICABS_LIMOUSINES";
    /**
   * The category for Tax Payments - Government Agencies.
   *
   * Numeric code: '9311'
   */ MerchantCategory["TAX_PAYMENTS_GOVERNMENT_AGENCIES"] = "TAX_PAYMENTS_GOVERNMENT_AGENCIES";
    /**
   * The category for Tax Preparation Services.
   *
   * Numeric code: '7276'
   */ MerchantCategory["TAX_PREPARATION_SERVICES"] = "TAX_PREPARATION_SERVICES";
    /**
   * The category for Telecommunication Equipment and Telephone Sales.
   *
   * Numeric code: '4812'
   */ MerchantCategory["TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES"] = "TELECOMMUNICATION_EQUIPMENT_AND_TELEPHONE_SALES";
    /**
   * The category for Telecommunication Services.
   *
   * Numeric code: '4814'
   */ MerchantCategory["TELECOMMUNICATION_SERVICES"] = "TELECOMMUNICATION_SERVICES";
    /**
   * The category for Telegraph Services.
   *
   * Numeric code: '4821'
   */ MerchantCategory["TELEGRAPH_SERVICES"] = "TELEGRAPH_SERVICES";
    /**
   * The category for Tent and Awning Shops.
   *
   * Numeric code: '5998'
   */ MerchantCategory["TENT_AND_AWNING_SHOPS"] = "TENT_AND_AWNING_SHOPS";
    /**
   * The category for Testing Laboratories.
   *
   * Numeric code: '8734'
   */ MerchantCategory["TESTING_LABORATORIES"] = "TESTING_LABORATORIES";
    /**
   * The category for Thai Airways
   *
   * Numeric Code: '3077'
   */ MerchantCategory["THAI_AIRWAYS"] = "THAI_AIRWAYS";
    /**
   * The category for Theatrical Ticket Agencies.
   *
   * Numeric code: '7922'
   */ MerchantCategory["THEATRICAL_TICKET_AGENCIES"] = "THEATRICAL_TICKET_AGENCIES";
    /**
   * The category for The Atlantic
   *
   * Numeric Code: '3805'
   */ MerchantCategory["THE_ATLANTIC"] = "THE_ATLANTIC";
    /**
   * The category for The Diplomat Country Club And Spa
   *
   * Numeric Code: '3804'
   */ MerchantCategory["THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA"] = "THE_DIPLOMAT_COUNTRY_CLUB_AND_SPA";
    /**
   * The category for The Eliot Hotel
   *
   * Numeric Code: '3746'
   */ MerchantCategory["THE_ELIOT_HOTEL"] = "THE_ELIOT_HOTEL";
    /**
   * The category for The Flamingo Hotels
   *
   * Numeric Code: '3793'
   */ MerchantCategory["THE_FLAMINGO_HOTELS"] = "THE_FLAMINGO_HOTELS";
    /**
   * The category for The Luxury Collection
   *
   * Numeric code: '3846'
   */ MerchantCategory["THE_LUXURY_COLLECTION"] = "THE_LUXURY_COLLECTION";
    /**
   * The category for The Palace Hotel
   *
   * Numeric Code: '3802'
   */ MerchantCategory["THE_PALACE_HOTEL"] = "THE_PALACE_HOTEL";
    /**
   * The category for The Phoenician
   *
   * Numeric Code: '3632'
   */ MerchantCategory["THE_PHOENICIAN"] = "THE_PHOENICIAN";
    /**
   * The category for The Roosevelt Hotel Ny
   *
   * Numeric Code: '3814'
   */ MerchantCategory["THE_ROOSEVELT_HOTEL_NY"] = "THE_ROOSEVELT_HOTEL_NY";
    /**
   * The category for The Wigwam Golf Resort And Spa
   *
   * Numeric Code: '3803'
   */ MerchantCategory["THE_WIGWAM_GOLF_RESORT_AND_SPA"] = "THE_WIGWAM_GOLF_RESORT_AND_SPA";
    /**
   * The category for Thrifty Car Rental
   *
   * Numeric Code: '3395'
   */ MerchantCategory["THRIFTY_CAR_RENTAL"] = "THRIFTY_CAR_RENTAL";
    /**
   * The category for Thunderbird/Red Lion
   *
   * Numeric Code: '3528'
   */ MerchantCategory["THUNDERBIRD_RED_LION"] = "THUNDERBIRD_RED_LION";
    /**
   * The category for "Turk Hava Yollar (Thy Airline)"
   *
   * Numeric Code: '3047'
   */ MerchantCategory["THY_AIRLINE"] = "THY_AIRLINE";
    /**
   * The category for Tigerair
   *
   * Numeric Code: '3303'
   */ MerchantCategory["TIGERAIR"] = "TIGERAIR";
    /**
   * The category for Tilden Rent A Car
   *
   * Numeric Code: '3396'
   */ MerchantCategory["TILDEN_RENT_A_CAR"] = "TILDEN_RENT_A_CAR";
    /**
   * The category for Timeshares.
   *
   * Numeric code: '7012'
   */ MerchantCategory["TIMESHARES"] = "TIMESHARES";
    /**
   * The category for Tire Retreading and Repair.
   *
   * Numeric code: '7534'
   */ MerchantCategory["TIRE_RETREADING_AND_REPAIR"] = "TIRE_RETREADING_AND_REPAIR";
    /**
   * The category for Tokyo Group
   *
   * Numeric Code: '3522'
   */ MerchantCategory["TOKYO_GROUP"] = "TOKYO_GROUP";
    /**
   * The category for Tokyu Harvestclub
   *
   * Numeric code: '3873'
   */ MerchantCategory["TOKYU_HARVESTCLUB"] = "TOKYU_HARVESTCLUB";
    /**
   * The category for Tolls/Bridge Fees.
   *
   * Numeric code: '4784'
   */ MerchantCategory["TOLLS_BRIDGE_FEES"] = "TOLLS_BRIDGE_FEES";
    /**
   * The category for Tourist Attractions and Exhibits.
   *
   * Numeric code: '7991'
   */ MerchantCategory["TOURIST_ATTRACTIONS_AND_EXHIBITS"] = "TOURIST_ATTRACTIONS_AND_EXHIBITS";
    /**
   * The category for Tower Air
   *
   * Numeric Code: '3115'
   */ MerchantCategory["TOWER_AIR"] = "TOWER_AIR";
    /**
   * The category for Towing Services.
   *
   * Numeric code: '7549'
   */ MerchantCategory["TOWING_SERVICES"] = "TOWING_SERVICES";
    /**
   * The category for Towneplace Suites
   *
   * Numeric Code: '3740'
   */ MerchantCategory["TOWNEPLACE_SUITES"] = "TOWNEPLACE_SUITES";
    /**
   * The category for Town And Country Resort And Convention Center
   *
   * Numeric Code: '3783'
   */ MerchantCategory["TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER"] = "TOWN_AND_COUNTRY_RESORT_AND_CONVENTION_CENTER";
    /**
   * The category for Tradewinds Resort
   *
   * Numeric Code: '3601'
   */ MerchantCategory["TRADEWINDS_RESORT"] = "TRADEWINDS_RESORT";
    /**
   * The category for "Trailer Parks, Campgrounds".
   *
   * Numeric code: '7033'
   */ MerchantCategory["TRAILER_PARKS_CAMPGROUNDS"] = "TRAILER_PARKS_CAMPGROUNDS";
    /**
   * The category for Transaero
   *
   * Numeric Code: '3089'
   */ MerchantCategory["TRANSAERO"] = "TRANSAERO";
    /**
   * The category for Transportation Services (Not Elsewhere Classified).
   *
   * Numeric code: '4789'
   */ MerchantCategory["TRANSPORTATION_SERVICES"] = "TRANSPORTATION_SERVICES";
    /**
   * The category for Trans World Airlines
   *
   * Numeric Code: '3004'
   */ MerchantCategory["TRANS_WORLD_AIRLINES"] = "TRANS_WORLD_AIRLINES";
    /**
   * The category for Travelodge Motels
   *
   * Numeric Code: '3615'
   */ MerchantCategory["TRAVELODGE_MOTELS"] = "TRAVELODGE_MOTELS";
    /**
   * The category for "Travel Agencies, Tour Operators".
   *
   * Numeric code: '4722'
   */ MerchantCategory["TRAVEL_AGENCIES_TOUR_OPERATORS"] = "TRAVEL_AGENCIES_TOUR_OPERATORS";
    /**
   * The category for Treasure Island Hotel And Casino
   *
   * Numeric Code: '3555'
   */ MerchantCategory["TREASURE_ISLAND_HOTEL_AND_CASINO"] = "TREASURE_ISLAND_HOTEL_AND_CASINO";
    /**
   * The category for Triangle Rent A Car
   *
   * Numeric Code: '3380'
   */ MerchantCategory["TRIANGLE_RENT_A_CAR"] = "TRIANGLE_RENT_A_CAR";
    /**
   * The category for Tribeca Grand Hotel
   *
   * Numeric Code: '3569'
   */ MerchantCategory["TRIBECA_GRAND_HOTEL"] = "TRIBECA_GRAND_HOTEL";
    /**
   * The category for Tribute Portfolio
   *
   * Numeric code: '3841'
   */ MerchantCategory["TRIBUTE_PORTFOLIO"] = "TRIBUTE_PORTFOLIO";
    /**
   * The category for Tropical Rent A Car
   *
   * Numeric Code: '3385'
   */ MerchantCategory["TROPICAL_RENT_A_CAR"] = "TROPICAL_RENT_A_CAR";
    /**
   * The category for Tropicana Resort And Casino
   *
   * Numeric Code: '3738'
   */ MerchantCategory["TROPICANA_RESORT_AND_CASINO"] = "TROPICANA_RESORT_AND_CASINO";
    /**
   * The category for Truck StopIteration.
   *
   * Numeric code: '7511'
   */ MerchantCategory["TRUCK_STOP_ITERATION"] = "TRUCK_STOP_ITERATION";
    /**
   * The category for Truck/Utility Trailer Rentals.
   *
   * Numeric code: '7513'
   */ MerchantCategory["TRUCK_UTILITY_TRAILER_RENTALS"] = "TRUCK_UTILITY_TRAILER_RENTALS";
    /**
   * The category for Trusthouse Forte
   *
   * Numeric Code: '3505'
   */ MerchantCategory["TRUSTHOUSE_FORTE"] = "TRUSTHOUSE_FORTE";
    /**
   * The category for Tunis Air
   *
   * Numeric Code: '3049'
   */ MerchantCategory["TUNIS_AIR"] = "TUNIS_AIR";
    /**
   * The category for "Typesetting, Plate Making, and Related Services".
   *
   * Numeric code: '2791'
   */ MerchantCategory["TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES"] = "TYPESETTING_PLATE_MAKING_AND_RELATED_SERVICES";
    /**
   * The category for Typewriter Stores.
   *
   * Numeric code: '5978'
   */ MerchantCategory["TYPEWRITER_STORES"] = "TYPEWRITER_STORES";
    /**
   * The category for TUI Travel - Germany.
   *
   * Numeric code: '4723'
   */ MerchantCategory["T_UI_TRAVEL_GERMANY"] = "T_UI_TRAVEL_GERMANY";
    /**
   * The category for Ugly Duckling Rent A Car
   *
   * Numeric Code: '3433'
   */ MerchantCategory["UGLY_DUCKLING_RENT_A_CAR"] = "UGLY_DUCKLING_RENT_A_CAR";
    /**
   * The category for "Uniforms, Commercial Clothing".
   *
   * Numeric code: '5137'
   */ MerchantCategory["UNIFORMS_COMMERCIAL_CLOTHING"] = "UNIFORMS_COMMERCIAL_CLOTHING";
    /**
   * The category for United Airlines
   *
   * Numeric Code: '3000'
   */ MerchantCategory["UNITED_AIRLINES"] = "UNITED_AIRLINES";
    /**
   * The category for Uni Airways Corporation
   *
   * Numeric Code: '3090'
   */ MerchantCategory["UNI_AIRWAYS_CORPORATION"] = "UNI_AIRWAYS_CORPORATION";
    /**
   * The category for Usa Rental
   *
   * Numeric Code: '3434'
   */ MerchantCategory["USA_RENTAL"] = "USA_RENTAL";
    /**
   * The category for Used Merchandise and Secondhand Stores.
   *
   * Numeric code: '5931'
   */ MerchantCategory["USED_MERCHANDISE_AND_SECONDHAND_STORES"] = "USED_MERCHANDISE_AND_SECONDHAND_STORES";
    /**
   * The category for US Airways
   *
   * Numeric Code: '3063'
   */ MerchantCategory["US_AIRWAYS"] = "US_AIRWAYS";
    /**
   * The category for U.S. Air Shuttle
   *
   * Numeric Code: '3254'
   */ MerchantCategory["US_AIR_SHUTTLE"] = "US_AIR_SHUTTLE";
    /**
   * The category for U.S. Federal Government Agencies or Departments.
   *
   * Numeric code: '9405'
   */ MerchantCategory["US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS"] = "US_FEDERAL_GOVERNMENT_AGENCIES_OR_DEPARTMENTS";
    /**
   * The category for UTA/Interair
   *
   * Numeric Code: '3027'
   */ MerchantCategory["UTA_INTERAIR"] = "UTA_INTERAIR";
    /**
   * The category for Utilities.
   *
   * Numeric code: '4900'
   */ MerchantCategory["UTILITIES"] = "UTILITIES";
    /**
   * The category for Vagabond Hotels
   *
   * Numeric Code: '3575'
   */ MerchantCategory["VAGABOND_HOTELS"] = "VAGABOND_HOTELS";
    /**
   * The category for Valley Airlines
   *
   * Numeric Code: '3118'
   */ MerchantCategory["VALLEY_AIRLINES"] = "VALLEY_AIRLINES";
    /**
   * The category for Value Rent A Car
   *
   * Numeric Code: '3435'
   */ MerchantCategory["VALUE_RENT_A_CAR"] = "VALUE_RENT_A_CAR";
    /**
   * The category for Vanguard Airlines
   *
   * Numeric Code: '3067'
   */ MerchantCategory["VANGUARD_AIR"] = "VANGUARD_AIR";
    /**
   * The category for Variety Stores.
   *
   * Numeric code: '5331'
   */ MerchantCategory["VARIETY_STORES"] = "VARIETY_STORES";
    /**
   * The category for Varig
   *
   * Numeric Code: '3018'
   */ MerchantCategory["VARIG"] = "VARIG";
    /**
   * The category for Viacao Aerea Sao Pãulo (VASP)
   *
   * Numeric Code: '3036'
   */ MerchantCategory["VASP_AIR"] = "VASP_AIR";
    /**
   * The category for Vdara
   *
   * Numeric Code: '3825'
   */ MerchantCategory["VDARA"] = "VDARA";
    /**
   * The category for Venetian Resort Hotel And Casino
   *
   * Numeric Code: '3773'
   */ MerchantCategory["VENETIAN_RESORT_HOTEL_AND_CASINO"] = "VENETIAN_RESORT_HOTEL_AND_CASINO";
    /**
   * The category for Venture Inn
   *
   * Numeric Code: '3574'
   */ MerchantCategory["VENTURE_INN"] = "VENTURE_INN";
    /**
   * The category for Veterinary Services.
   *
   * Numeric code: '0742'
   */ MerchantCategory["VETERINARY_SERVICES"] = "VETERINARY_SERVICES";
    /**
   * The category for Venezolana International De Aviacion
   *
   * Numeric Code: '3117'
   */ MerchantCategory["VIASA_AIR"] = "VIASA_AIR";
    /**
   * The category for Video Amusement Game Supplies.
   *
   * Numeric code: '7993'
   */ MerchantCategory["VIDEO_AMUSEMENT_GAME_SUPPLIES"] = "VIDEO_AMUSEMENT_GAME_SUPPLIES";
    /**
   * The category for Video Game Arcades.
   *
   * Numeric code: '7994'
   */ MerchantCategory["VIDEO_GAME_ARCADES"] = "VIDEO_GAME_ARCADES";
    /**
   * The category for Video Tape Rental Stores.
   *
   * Numeric code: '7841'
   */ MerchantCategory["VIDEO_TAPE_RENTAL_STORES"] = "VIDEO_TAPE_RENTAL_STORES";
    /**
   * The category for Villa Fontaine
   *
   * Numeric code: '3871'
   */ MerchantCategory["VILLA_FONTAINE"] = "VILLA_FONTAINE";
    /**
   * The category for Virgin America
   *
   * Numeric Code: '3057'
   */ MerchantCategory["VIRGIN_AMERICA"] = "VIRGIN_AMERICA";
    /**
   * The category for Virgin Atlantic
   *
   * Numeric Code: '3144'
   */ MerchantCategory["VIRGIN_ATLANTIC"] = "VIRGIN_ATLANTIC";
    /**
   * The category for Virgin Express Air
   *
   * Numeric Code: '3188'
   */ MerchantCategory["VIRGIN_EXPRESS_AIR"] = "VIRGIN_EXPRESS_AIR";
    /**
   * The category for Virgin River Hotel And Casino
   *
   * Numeric Code: '3708'
   */ MerchantCategory["VIRGIN_RIVER_HOTEL_AND_CASINO"] = "VIRGIN_RIVER_HOTEL_AND_CASINO";
    /**
   * The category for VLM Airlines
   *
   * Numeric Code: '3131'
   */ MerchantCategory["VLM_AIRLINES"] = "VLM_AIRLINES";
    /**
   * The category for Vocational/Trade Schools.
   *
   * Numeric code: '8249'
   */ MerchantCategory["VOCATIONAL_TRADE_SCHOOLS"] = "VOCATIONAL_TRADE_SCHOOLS";
    /**
   * The category for Waldorf
   *
   * Numeric Code: '3831'
   */ MerchantCategory["WALDORF"] = "WALDORF";
    /**
   * The category for Washington Hotel
   *
   * Numeric code: '3878'
   */ MerchantCategory["WASHINGTON_HOTEL"] = "WASHINGTON_HOTEL";
    /**
   * The category for Watch/Jewelry Repair.
   *
   * Numeric code: '7631'
   */ MerchantCategory["WATCH_JEWELRY_REPAIR"] = "WATCH_JEWELRY_REPAIR";
    /**
   * The category for Welcomgroup
   *
   * Numeric Code: '3524'
   */ MerchantCategory["WELCOMGROUP"] = "WELCOMGROUP";
    /**
   * The category for Welding Repair.
   *
   * Numeric code: '7692'
   */ MerchantCategory["WELDING_REPAIR"] = "WELDING_REPAIR";
    /**
   * The category for Wellesley Inns
   *
   * Numeric Code: '3748'
   */ MerchantCategory["WELLESLEY_INNS"] = "WELLESLEY_INNS";
    /**
   * The category for Westin Hotels
   *
   * Numeric Code: '3513'
   */ MerchantCategory["WESTIN_HOTELS"] = "WESTIN_HOTELS";
    /**
   * The category for Westjet Airlines
   *
   * Numeric Code: '3180'
   */ MerchantCategory["WESTJET_AIRLINES"] = "WESTJET_AIRLINES";
    /**
   * The category for Whiskey Pete’S Hotel And Casino
   *
   * Numeric Code: '3762'
   */ MerchantCategory["WHISKEY_PETES_HOTEL_AND_CASINO"] = "WHISKEY_PETES_HOTEL_AND_CASINO";
    /**
   * The category for Wholesale.
   *
   * Numeric code: '1002'
   */ MerchantCategory["WHOLESALE"] = "WHOLESALE";
    /**
   * The category for Wholesale Clubs.
   *
   * Numeric code: '5300'
   */ MerchantCategory["WHOLESALE_CLUBS"] = "WHOLESALE_CLUBS";
    /**
   * The category for Wideroes Flyveselskap
   *
   * Numeric Code: '3299'
   */ MerchantCategory["WIDEROES"] = "WIDEROES";
    /**
   * The category for Wig and Toupee Stores.
   *
   * Numeric code: '5698'
   */ MerchantCategory["WIG_AND_TOUPEE_STORES"] = "WIG_AND_TOUPEE_STORES";
    /**
   * The category for Wilderness Hotel And Resort
   *
   * Numeric Code: '3801'
   */ MerchantCategory["WILDERNESS_HOTEL_AND_RESORT"] = "WILDERNESS_HOTEL_AND_RESORT";
    /**
   * The category for Windward Island Air
   *
   * Numeric Code: '3112'
   */ MerchantCategory["WINDWARD_ISLAND_AIR"] = "WINDWARD_ISLAND_AIR";
    /**
   * The category for Wine Producers.
   *
   * Numeric code: '0743'
   */ MerchantCategory["WINE_PRODUCERS"] = "WINE_PRODUCERS";
    /**
   * The category for Wings Airways
   *
   * Numeric Code: '3110'
   */ MerchantCategory["WINGS_AIRWAYS"] = "WINGS_AIRWAYS";
    /**
   * The category for "Wires, Money Orders".
   *
   * Numeric code: '4829'
   */ MerchantCategory["WIRES_MONEY_ORDERS"] = "WIRES_MONEY_ORDERS";
    /**
   * The category for Wizz Air
   *
   * Numeric Code: '3301'
   */ MerchantCategory["WIZZ_AIR"] = "WIZZ_AIR";
    /**
   * The category for Women's Accessory and Specialty Shops.
   *
   * Numeric code: '5631'
   */ MerchantCategory["WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS"] = "WOMENS_ACCESSORY_AND_SPECIALTY_SHOPS";
    /**
   * The category for Women's Ready-To-Wear Stores.
   *
   * Numeric code: '5621'
   */ MerchantCategory["WOMENS_READY_TO_WEAR_STORES"] = "WOMENS_READY_TO_WEAR_STORES";
    /**
   * The category for Woodside Hotels And Resorts
   *
   * Numeric Code: '3739'
   */ MerchantCategory["WOODSIDE_HOTELS_AND_RESORTS"] = "WOODSIDE_HOTELS_AND_RESORTS";
    /**
   * The category for Wrecking and Salvage Yards.
   *
   * Numeric code: '5935'
   */ MerchantCategory["WRECKING_AND_SALVAGE_YARDS"] = "WRECKING_AND_SALVAGE_YARDS";
    /**
   * The category for Wyndham
   *
   * Numeric Code: '3722'
   */ MerchantCategory["WYNDHAM"] = "WYNDHAM";
    /**
   * The category for Wynn Las Vegas
   *
   * Numeric Code: '3596'
   */ MerchantCategory["WYNN_LAS_VEGAS"] = "WYNN_LAS_VEGAS";
    /**
   * The category for W Hotels
   *
   * Numeric Code: '3779'
   */ MerchantCategory["W_HOTELS"] = "W_HOTELS";
    /**
   * The category for Yutorelo
   *
   * Numeric code: '3869'
   */ MerchantCategory["YUTORELO"] = "YUTORELO";
    /**
   * The category for Zambia Airways
   *
   * Numeric Code: '3094'
   */ MerchantCategory["ZAMBIA_AIRWAYS"] = "ZAMBIA_AIRWAYS";
    return MerchantCategory;
}({});
var $2f53fee15f29b056$export$951c8378cdfec6e6 = /*#__PURE__*/ function(Month) {
    /**
   * The month of April
   *
   * Represented numerically as `04`
   */ Month["APRIL"] = "APRIL";
    /**
   * The month of August
   *
   * Represented numerically as `08`
   */ Month["AUGUST"] = "AUGUST";
    /**
   * The month of December
   *
   * Represented numerically as `12`
   */ Month["DECEMBER"] = "DECEMBER";
    /**
   * The month of February
   *
   * Represented numerically as `02`
   */ Month["FEBRUARY"] = "FEBRUARY";
    /**
   * The month of January
   *
   * Represented numerically as `01`
   */ Month["JANUARY"] = "JANUARY";
    /**
   * The month of July
   *
   * Represented numerically as `07`
   */ Month["JULY"] = "JULY";
    /**
   * The month of June
   *
   * Represented numerically as `06`
   */ Month["JUNE"] = "JUNE";
    /**
   * The month of March
   *
   * Represented numerically as `03`
   */ Month["MARCH"] = "MARCH";
    /**
   * The month of May
   *
   * Represented numerically as `05`
   */ Month["MAY"] = "MAY";
    /**
   * The month of November
   *
   * Represented numerically as `11`
   */ Month["NOVEMBER"] = "NOVEMBER";
    /**
   * The month of October
   *
   * Represented numerically as `10`
   */ Month["OCTOBER"] = "OCTOBER";
    /**
   * The month of September
   *
   * Represented numerically as `09`
   */ Month["SEPTEMBER"] = "SEPTEMBER";
    return Month;
}({});
var $2f53fee15f29b056$export$662321932f3265d8 = /*#__PURE__*/ function(NationalIdentificationNumberType) {
    /**
   * Employer Identification Number (EIN) for the United States.
   * A 9-digit number assigned to business entities operating in the U.S. for tax purposes.
   */ NationalIdentificationNumberType["EMPLOYER_IDENTIFICATION_NUMBER"] = "EMPLOYER_IDENTIFICATION_NUMBER";
    /**
   * Individual Taxpayer Identification Number (ITIN) for the United States.
   * A 9-digit tax processing number issued by the IRS for those ineligible for an SSN.
   */ NationalIdentificationNumberType["INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER"] = "INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER";
    /**
   * Identity Number (Mispar Zehut) for Israel.
   * A 9-digit number assigned to Israeli citizens and permanent residents.
   */ NationalIdentificationNumberType["ISRAELI_IDENTITY_NUMBER"] = "ISRAELI_IDENTITY_NUMBER";
    /**
   * National Insurance Number (NINO) for the United Kingdom.
   * Used for tax and national insurance purposes in the United Kingdom.
   * Format: 2 letters, 6 digits, 1 letter (for example, AB123456C).
   * Certain prefix combinations are invalid (BG, GB, NK, KN, TN, NT, ZZ).
   */ NationalIdentificationNumberType["NATIONAL_INSURANCE_NUMBER"] = "NATIONAL_INSURANCE_NUMBER";
    /**
   * Social Insurance Number (SIN) for Canada.
   * A 9-digit number used for tax and government benefits purposes.
   */ NationalIdentificationNumberType["SOCIAL_INSURANCE_NUMBER"] = "SOCIAL_INSURANCE_NUMBER";
    /**
   * Social Security Number (SSN) for the United States.
   * A 9-digit identifier issued to U.S. citizens, permanent residents, and temporary residents.
   */ NationalIdentificationNumberType["SOCIAL_SECURITY_NUMBER"] = "SOCIAL_SECURITY_NUMBER";
    return NationalIdentificationNumberType;
}({});
var $2f53fee15f29b056$export$e0756c08817fa7a5 = /*#__PURE__*/ function(NonOriginatedAchTransferStatus) {
    /** The transfer has been canceled by Highnote. This status is rare and typically indicates the transfer was received in error. */ NonOriginatedAchTransferStatus["CANCELED"] = "CANCELED";
    /** The transfer failed but has not yet been returned to the external financial institution that initiated it. More details are available in `AchTransferStatusFailureReason`. */ NonOriginatedAchTransferStatus["FAILED"] = "FAILED";
    /** The transfer has been processed by Highnote. */ NonOriginatedAchTransferStatus["PROCESSED"] = "PROCESSED";
    /** The transfer has been received by Highnote, but has not been processed yet, e.g. the settlement date is in the future. */ NonOriginatedAchTransferStatus["RECEIVED"] = "RECEIVED";
    /** The transfer has been returned to the external financial institution that initiated it. More details are available in `AchTransferStatusFailureReason`. */ NonOriginatedAchTransferStatus["RETURNED"] = "RETURNED";
    return NonOriginatedAchTransferStatus;
}({});
var $2f53fee15f29b056$export$f6b79c531c399c57 = /*#__PURE__*/ function(NormalBalance) {
    /** The value when a Ledger is expected to have a credit balance. */ NormalBalance["CREDIT"] = "CREDIT";
    /** The value when a Ledger is expected to have a debit balance. */ NormalBalance["DEBIT"] = "DEBIT";
    return NormalBalance;
}({});
var $2f53fee15f29b056$export$87ab885a053b668f = /*#__PURE__*/ function(NotificationEventName) {
    /** The name of the Notification Event when a Financial Account enters the ACTIVE status. */ NotificationEventName["ACCOUNT_STATUS_ACTIVE"] = "ACCOUNT_STATUS_ACTIVE";
    /** The name of the Notification Event when a Financial Account has been CLOSED. */ NotificationEventName["ACCOUNT_STATUS_CLOSED"] = "ACCOUNT_STATUS_CLOSED";
    /** The name of the Notification Event when a Financial Account enters the PENDING_CLOSURE status. */ NotificationEventName["ACCOUNT_STATUS_PENDING_CLOSURE"] = "ACCOUNT_STATUS_PENDING_CLOSURE";
    /** The name of the Notification Event when a Financial Account enters the SUSPENDED status. */ NotificationEventName["ACCOUNT_STATUS_SUSPENDED"] = "ACCOUNT_STATUS_SUSPENDED";
    /** The name of the Notification Event when a Financial Account enters the UNDER_REVIEW status. */ NotificationEventName["ACCOUNT_STATUS_UNDER_REVIEW"] = "ACCOUNT_STATUS_UNDER_REVIEW";
    /** The name of the Notification Event when externally initiated ACH deposits have failed */ NotificationEventName["ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED"] = "ACH_EXTERNALLY_INITIATED_DEPOSIT_FAILED";
    /** The name of the Notification Event when externally initiated ACH deposits are processed */ NotificationEventName["ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED"] = "ACH_EXTERNALLY_INITIATED_DEPOSIT_PROCESSED";
    /** The name of the Notification Event when externally initiated ACH deposits are received */ NotificationEventName["ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED"] = "ACH_EXTERNALLY_INITIATED_DEPOSIT_RECEIVED";
    /** The name of the Notification Event when externally initiated ACH withdrawals have failed */ NotificationEventName["ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED"] = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_FAILED";
    /** The name of the Notification Event when externally initiated ACH withdrawals are processed */ NotificationEventName["ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED"] = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_PROCESSED";
    /** The name of the Notification Event when externally initiated ACH withdrawals are received */ NotificationEventName["ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED"] = "ACH_EXTERNALLY_INITIATED_WITHDRAWAL_RECEIVED";
    /** The name of the Notification Event when ACH funds deposits are canceled */ NotificationEventName["ACH_FUNDS_DEPOSIT_CANCELED"] = "ACH_FUNDS_DEPOSIT_CANCELED";
    /** The name of the Notification Event when ACH funds deposits have failed */ NotificationEventName["ACH_FUNDS_DEPOSIT_FAILED"] = "ACH_FUNDS_DEPOSIT_FAILED";
    /** The name of the Notification Event when ACH funds withdrawals are initiated */ NotificationEventName["ACH_FUNDS_DEPOSIT_INITIATED"] = "ACH_FUNDS_DEPOSIT_INITIATED";
    /** The name of the Notification Event when ACH funds deposits are processed */ NotificationEventName["ACH_FUNDS_DEPOSIT_PROCESSED"] = "ACH_FUNDS_DEPOSIT_PROCESSED";
    /** The name of the Notification Event when ACH funds deposits are processing */ NotificationEventName["ACH_FUNDS_DEPOSIT_PROCESSING"] = "ACH_FUNDS_DEPOSIT_PROCESSING";
    /** The name of the Notification Event when ACH funds deposits are returned */ NotificationEventName["ACH_FUNDS_DEPOSIT_RETURNED"] = "ACH_FUNDS_DEPOSIT_RETURNED";
    /** The name of the Notification Event when ACH funds withdrawals are canceled */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_CANCELED"] = "ACH_FUNDS_WITHDRAWAL_CANCELED";
    /** The name of the Notification Event when ACH funds withdrawals have failed */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_FAILED"] = "ACH_FUNDS_WITHDRAWAL_FAILED";
    /** The name of the Notification Event when ACH funds withdrawals are initiated */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_INITIATED"] = "ACH_FUNDS_WITHDRAWAL_INITIATED";
    /** The name of the Notification Event when ACH funds withdrawals are processed */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_PROCESSED"] = "ACH_FUNDS_WITHDRAWAL_PROCESSED";
    /** The name of the Notification Event when ACH funds withdrawals are processing */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_PROCESSING"] = "ACH_FUNDS_WITHDRAWAL_PROCESSING";
    /** The name of the Notification Event when ACH funds withdrawals are returned */ NotificationEventName["ACH_FUNDS_WITHDRAWAL_RETURNED"] = "ACH_FUNDS_WITHDRAWAL_RETURNED";
    /** The name of the Notification Event when an ACH is put on hold. */ NotificationEventName["ACH_HOLD_ADDED"] = "ACH_HOLD_ADDED";
    /** The name of the Notification Event when an ACH hold is removed. */ NotificationEventName["ACH_HOLD_REMOVED"] = "ACH_HOLD_REMOVED";
    /** The name of the Notification Event when ACH repayments have failed */ NotificationEventName["ACH_REPAYMENT_FAILED"] = "ACH_REPAYMENT_FAILED";
    /** The name of the Notification Event when ACH repayments are processed */ NotificationEventName["ACH_REPAYMENT_PROCESSED"] = "ACH_REPAYMENT_PROCESSED";
    /** The name of the Notification Event when ACH repayments are processing */ NotificationEventName["ACH_REPAYMENT_PROCESSING"] = "ACH_REPAYMENT_PROCESSING";
    /** The name of the Notification Event when ACH repayments are returned */ NotificationEventName["ACH_REPAYMENT_RETURNED"] = "ACH_REPAYMENT_RETURNED";
    /** The name of the Notification Event when ACH secure deposits are canceled */ NotificationEventName["ACH_SECURE_DEPOSIT_CANCELED"] = "ACH_SECURE_DEPOSIT_CANCELED";
    /** The name of the Notification Event when ACH secure deposits have failed */ NotificationEventName["ACH_SECURE_DEPOSIT_FAILED"] = "ACH_SECURE_DEPOSIT_FAILED";
    /** The name of the Notification Event when ACH secure deposits are initiated */ NotificationEventName["ACH_SECURE_DEPOSIT_INITIATED"] = "ACH_SECURE_DEPOSIT_INITIATED";
    /** The name of the Notification Event when ACH secure deposits are processed */ NotificationEventName["ACH_SECURE_DEPOSIT_PROCESSED"] = "ACH_SECURE_DEPOSIT_PROCESSED";
    /** The name of the Notification Event when ACH secure deposits are processing */ NotificationEventName["ACH_SECURE_DEPOSIT_PROCESSING"] = "ACH_SECURE_DEPOSIT_PROCESSING";
    /** The name of the Notification Event when ACH secure deposits are returned */ NotificationEventName["ACH_SECURE_DEPOSIT_RETURNED"] = "ACH_SECURE_DEPOSIT_RETURNED";
    /** Triggered when an ACH transfer hold is added. */ NotificationEventName["ACH_TRANSFER_HOLD_ADDED"] = "ACH_TRANSFER_HOLD_ADDED";
    /** Triggered when an ACH transfer hold is removed. */ NotificationEventName["ACH_TRANSFER_HOLD_REMOVED"] = "ACH_TRANSFER_HOLD_REMOVED";
    /**
   * `DEPRECATED`
   *
   * The name of the Notification Event when an authorization is created.
   * @deprecated No longer supported
   */ NotificationEventName["AUTHORIZATION_CREATED"] = "AUTHORIZATION_CREATED";
    /** The name of the Notification Event when an authorized user application is approved */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_APPROVED";
    /** The name of the Notification Event when an authorized user application is closed */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_CLOSED";
    /** The name of the Notification Event when an authorized user application is denied */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DENIED";
    /** The name of the Notification Event when `DocumentUploadSessions` have been requested for an authorized user application. */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED";
    /**
   * The name of the Notification Event when an authorized user application is in review
   * @deprecated Deprecated for more specific action notification event types.
   */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_IN_REVIEW";
    /** The name of the Notification Event when an authorized user application requires manual review */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_MANUAL_REVIEW";
    /** The name of the Notification Event when an authorized user application requires an underwriting decision. */ NotificationEventName["AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED"] = "AUTHORIZED_USER_CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED";
    /** Triggered when identity verification documents are requested for a `BusinessAccountHolder`. */ NotificationEventName["BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED"] = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED";
    /** Triggered when a `BusinessAccountHolder` is updated. */ NotificationEventName["BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED"] = "BUSINESS_ACCOUNT_HOLDER_IDENTITY_UPDATED";
    /** Triggered when identity verification documents are requested for an `AuthorizedPerson`. */ NotificationEventName["BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED"] = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_DOCUMENTS_REQUESTED";
    /** Triggered when an `AuthorizedPerson` is updated. */ NotificationEventName["BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED"] = "BUSINESS_AUTHORIZED_PERSON_IDENTITY_UPDATED";
    /** Triggered when identity verification documents are requested for a `USBusinessUltimateBeneficialOwner`. */ NotificationEventName["BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED"] = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_DOCUMENTS_REQUESTED";
    /** Triggered when a `USBusinessUltimateBeneficialOwner` is updated. */ NotificationEventName["BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED"] = "BUSINESS_ULTIMATE_BENEFICIAL_OWNER_IDENTITY_UPDATED";
    /** The name of the Notification Event when a `CardDigitalWalletToken` has been activated. */ NotificationEventName["CARD_DIGITAL_WALLET_TOKEN_ACTIVATED"] = "CARD_DIGITAL_WALLET_TOKEN_ACTIVATED";
    /** The name of the Notification Event when a `CardDigitalWalletToken` has been suspended. */ NotificationEventName["CARD_DIGITAL_WALLET_TOKEN_SUSPENDED"] = "CARD_DIGITAL_WALLET_TOKEN_SUSPENDED";
    /** The name of the Notification Event when a `CardDigitalWalletToken` has been terminated. */ NotificationEventName["CARD_DIGITAL_WALLET_TOKEN_TERMINATED"] = "CARD_DIGITAL_WALLET_TOKEN_TERMINATED";
    /** Triggered when a `PaymentTransaction` receives a authorization declined event. */ NotificationEventName["CARD_PAYMENT_AUTHORIZATION_DECLINED_EVENT"] = "CARD_PAYMENT_AUTHORIZATION_DECLINED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a authorized event. */ NotificationEventName["CARD_PAYMENT_AUTHORIZED_EVENT"] = "CARD_PAYMENT_AUTHORIZED_EVENT";
    /**
   * Deprecated: Use `CARD_PAYMENT_AUTHORIZED_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_AUTHORIZED_EVENT` instead.
   */ NotificationEventName["CARD_PAYMENT_AUTHORIZING_EVENT"] = "CARD_PAYMENT_AUTHORIZING_EVENT";
    /**
   * Deprecated: Use `CARD_PAYMENT_CAPTURING_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_CAPTURING_EVENT` instead.
   */ NotificationEventName["CARD_PAYMENT_CAPTURED_EVENT"] = "CARD_PAYMENT_CAPTURED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a capture declined event. */ NotificationEventName["CARD_PAYMENT_CAPTURE_DECLINED_EVENT"] = "CARD_PAYMENT_CAPTURE_DECLINED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a capture processing event. */ NotificationEventName["CARD_PAYMENT_CAPTURE_PROCESSING_EVENT"] = "CARD_PAYMENT_CAPTURE_PROCESSING_EVENT";
    /** Triggered when a `PaymentTransaction` receives a capturing event. */ NotificationEventName["CARD_PAYMENT_CAPTURING_EVENT"] = "CARD_PAYMENT_CAPTURING_EVENT";
    /** Triggered when a `PaymentTransaction` receives a cleared event. */ NotificationEventName["CARD_PAYMENT_CLEARED_EVENT"] = "CARD_PAYMENT_CLEARED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a clearing failed event. */ NotificationEventName["CARD_PAYMENT_CLEARING_FAILED_EVENT"] = "CARD_PAYMENT_CLEARING_FAILED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a disbursed event. */ NotificationEventName["CARD_PAYMENT_DISBURSED_EVENT"] = "CARD_PAYMENT_DISBURSED_EVENT";
    /** Triggered when a `CardPaymentDispute` requires action from the merchant. */ NotificationEventName["CARD_PAYMENT_DISPUTE_ACTION_REQUIRED"] = "CARD_PAYMENT_DISPUTE_ACTION_REQUIRED";
    /** Triggered when a `PaymentTransaction` receives a incremental authorization declined event. */ NotificationEventName["CARD_PAYMENT_INCREMENTAL_AUTHORIZATION_DECLINED_EVENT"] = "CARD_PAYMENT_INCREMENTAL_AUTHORIZATION_DECLINED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a incremental authorized event. */ NotificationEventName["CARD_PAYMENT_INCREMENTAL_AUTHORIZED_EVENT"] = "CARD_PAYMENT_INCREMENTAL_AUTHORIZED_EVENT";
    /**
   * Deprecated: Use `CARD_PAYMENT_REVERSED_EVENT` instead.
   * @deprecated Use `CARD_PAYMENT_REVERSED_EVENT` instead.
   */ NotificationEventName["CARD_PAYMENT_PARTIAL_REVERSED_EVENT"] = "CARD_PAYMENT_PARTIAL_REVERSED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a payout event. */ NotificationEventName["CARD_PAYMENT_PAYOUT_EVENT"] = "CARD_PAYMENT_PAYOUT_EVENT";
    /** Triggered when a `PaymentTransaction` receives a reversal declined event. */ NotificationEventName["CARD_PAYMENT_REVERSAL_DECLINED_EVENT"] = "CARD_PAYMENT_REVERSAL_DECLINED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a reversed event. */ NotificationEventName["CARD_PAYMENT_REVERSED_EVENT"] = "CARD_PAYMENT_REVERSED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a settled event. */ NotificationEventName["CARD_PAYMENT_SETTLED_EVENT"] = "CARD_PAYMENT_SETTLED_EVENT";
    /** Triggered when a `PaymentTransaction` receives a verification declined event. */ NotificationEventName["CARD_PAYMENT_VERIFICATION_DECLINED_EVENT"] = "CARD_PAYMENT_VERIFICATION_DECLINED_EVENT";
    /**
   * Triggered when a `PaymentTransaction` receives a verification pending event.
   * @deprecated Use `CARD_PAYMENT_VERIFIED_EVENT` or `CARD_PAYMENT_VERIFICATION_DECLINED_EVENT` instead.
   */ NotificationEventName["CARD_PAYMENT_VERIFICATION_PENDING_EVENT"] = "CARD_PAYMENT_VERIFICATION_PENDING_EVENT";
    /** Triggered when a `PaymentTransaction` receives a verified event. */ NotificationEventName["CARD_PAYMENT_VERIFIED_EVENT"] = "CARD_PAYMENT_VERIFIED_EVENT";
    /** The name of the Notification Event when an application is approved */ NotificationEventName["CARD_PRODUCT_APPLICATION_APPROVED"] = "CARD_PRODUCT_APPLICATION_APPROVED";
    /** The name of the Notification Event when an application is closed */ NotificationEventName["CARD_PRODUCT_APPLICATION_CLOSED"] = "CARD_PRODUCT_APPLICATION_CLOSED";
    /** The name of the Notification Event when an application requires an account holder to verify if they are the one who are applying for the application. */ NotificationEventName["CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT"] = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FRAUD_ALERT";
    /** The name of the Notification Event when an application requires an account holder to take action to unfreeze credit bureau. */ NotificationEventName["CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE"] = "CARD_PRODUCT_APPLICATION_CREDIT_REPORT_FREEZE";
    /** The name of the Notification Event when an application is denied */ NotificationEventName["CARD_PRODUCT_APPLICATION_DENIED"] = "CARD_PRODUCT_APPLICATION_DENIED";
    /** The name of the Notification Event when `DocumentUploadSessions` have been requested for an application. */ NotificationEventName["CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED"] = "CARD_PRODUCT_APPLICATION_DOCUMENT_UPLOAD_REQUESTED";
    /** The name of the Notification Event when `IdentityUpdateSessions` have been requested for an application. */ NotificationEventName["CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED"] = "CARD_PRODUCT_APPLICATION_IDENTITY_UPDATE_REQUESTED";
    /**
   * The name of the Notification Event when an application is in review
   * @deprecated Deprecated for more specific action notification event types.
   */ NotificationEventName["CARD_PRODUCT_APPLICATION_IN_REVIEW"] = "CARD_PRODUCT_APPLICATION_IN_REVIEW";
    /** The name of the Notification Event when an application requires manual review */ NotificationEventName["CARD_PRODUCT_APPLICATION_MANUAL_REVIEW"] = "CARD_PRODUCT_APPLICATION_MANUAL_REVIEW";
    /** The name of the Notification Event when offer(s) on an application need to be decisioned. */ NotificationEventName["CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED"] = "CARD_PRODUCT_APPLICATION_OFFER_MANAGEMENT_REQUESTED";
    /** The name of the Notification Event when an application requires an underwriting decision. */ NotificationEventName["CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED"] = "CARD_PRODUCT_APPLICATION_UNDERWRITING_DECISION_REQUESTED";
    /** The check has been delivered, and cashed or deposited. */ NotificationEventName["CHECK_PAYMENT_EVENT_COMPLETED"] = "CHECK_PAYMENT_EVENT_COMPLETED";
    /** The check has failed. The reason for the failure is included in the event. */ NotificationEventName["CHECK_PAYMENT_EVENT_FAILED"] = "CHECK_PAYMENT_EVENT_FAILED";
    /** The check has been funded and is pending disbursement. */ NotificationEventName["CHECK_PAYMENT_EVENT_FUNDING_COMPLETED"] = "CHECK_PAYMENT_EVENT_FUNDING_COMPLETED";
    /** The funds have been disbursed to external accounts. */ NotificationEventName["CHECK_PAYMENT_EVENT_FUNDING_DISBURSED"] = "CHECK_PAYMENT_EVENT_FUNDING_DISBURSED";
    /** The check has been initiated and is pending funding. */ NotificationEventName["CHECK_PAYMENT_EVENT_FUNDING_PENDING"] = "CHECK_PAYMENT_EVENT_FUNDING_PENDING";
    /** The check funding has been initiated. */ NotificationEventName["CHECK_PAYMENT_EVENT_FUNDING_STARTED"] = "CHECK_PAYMENT_EVENT_FUNDING_STARTED";
    /** The check has been put on hold for risk assessment */ NotificationEventName["CHECK_PAYMENT_EVENT_ON_RISK_HOLD"] = "CHECK_PAYMENT_EVENT_ON_RISK_HOLD";
    /** The check has been paid out. */ NotificationEventName["CHECK_PAYMENT_EVENT_PAID"] = "CHECK_PAYMENT_EVENT_PAID";
    /** The check is pending processing by Highnote. */ NotificationEventName["CHECK_PAYMENT_EVENT_PENDING_PROCESSING_BY_HIGHNOTE"] = "CHECK_PAYMENT_EVENT_PENDING_PROCESSING_BY_HIGHNOTE";
    /** The check has been printed and is pending shipment. */ NotificationEventName["CHECK_PAYMENT_EVENT_PENDING_SHIPMENT"] = "CHECK_PAYMENT_EVENT_PENDING_SHIPMENT";
    /** The check has been printed. */ NotificationEventName["CHECK_PAYMENT_EVENT_PRINTED"] = "CHECK_PAYMENT_EVENT_PRINTED";
    /** The check has been processed by Highnote. */ NotificationEventName["CHECK_PAYMENT_EVENT_PROCESSED_BY_HIGHNOTE"] = "CHECK_PAYMENT_EVENT_PROCESSED_BY_HIGHNOTE";
    /** The check is processing by Highnote. */ NotificationEventName["CHECK_PAYMENT_EVENT_PROCESSING_BY_HIGHNOTE"] = "CHECK_PAYMENT_EVENT_PROCESSING_BY_HIGHNOTE";
    /** The check reversal has been completed. */ NotificationEventName["CHECK_PAYMENT_EVENT_REVERSAL_COMPLETED"] = "CHECK_PAYMENT_EVENT_REVERSAL_COMPLETED";
    /** The check has been reversed due to voiding or failure. */ NotificationEventName["CHECK_PAYMENT_EVENT_REVERSAL_INITIATED"] = "CHECK_PAYMENT_EVENT_REVERSAL_INITIATED";
    /** The check has been shipped. */ NotificationEventName["CHECK_PAYMENT_EVENT_SHIPPED"] = "CHECK_PAYMENT_EVENT_SHIPPED";
    /** The check has been voided. */ NotificationEventName["CHECK_PAYMENT_EVENT_VOIDED"] = "CHECK_PAYMENT_EVENT_VOIDED";
    /** Triggered when a `CreditLimitChangeRequest` has a status change. */ NotificationEventName["CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED"] = "CREDIT_LIMIT_CHANGE_REQUEST_STATUS_CHANGED";
    /** Triggered when a `ManuallyRequestedDocumentUploadSession` is created. */ NotificationEventName["DOCUMENT_UPLOAD_REQUESTED_EVENT"] = "DOCUMENT_UPLOAD_REQUESTED_EVENT";
    /** Triggered when a `DocumentUploadSession` has moved into a terminal state. */ NotificationEventName["DOCUMENT_UPLOAD_SESSION_COMPLETE_EVENT"] = "DOCUMENT_UPLOAD_SESSION_COMPLETE_EVENT";
    /** The name of the Notification Event when a `Verified External Financial Account` is created */ NotificationEventName["EXTERNAL_BANK_ACCOUNT_ADDED"] = "EXTERNAL_BANK_ACCOUNT_ADDED";
    /** The name of the Notification Event when a `Verified External Financial Account` is disconnected */ NotificationEventName["EXTERNAL_BANK_ACCOUNT_REMOVED"] = "EXTERNAL_BANK_ACCOUNT_REMOVED";
    /** Triggered when a Fee has been charged. */ NotificationEventName["FEE_CHARGE_EVENT"] = "FEE_CHARGE_EVENT";
    /** Triggered when a Fee has been reversed. */ NotificationEventName["FEE_REVERSAL_EVENT"] = "FEE_REVERSAL_EVENT";
    /** Triggered when a `DocumentUploadLink` has completed upload. */ NotificationEventName["FILE_UPLOAD_COMPLETE_EVENT"] = "FILE_UPLOAD_COMPLETE_EVENT";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is added as CHARGE_OFF. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CHARGE_OFF";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is added as `CLOSED_WITH_BALANCE`. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_CLOSED_WITH_BALANCE";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is added as DELINQUENT. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is added as DELINQUENT_SUSPENDED. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_DELINQUENT_SUSPENDED";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is added as PROGRAM_OWNER_INITIATED_SUSPENSION. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_ADDED_PROGRAM_OWNER_INITIATED_SUSPENSION";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as CHARGE_OFF. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CHARGE_OFF";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as `CLOSED_WITH_BALANCE`. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_CLOSED_WITH_BALANCE";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as DELINQUENT. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as DELINQUENT_SUSPENDED. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_DELINQUENT_SUSPENDED";
    /** The name of the Notification Event when a `FinancialAccountAttribute` is removed as PROGRAM_OWNER_INITIATED_SUSPENSION. */ NotificationEventName["FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION"] = "FINANCIAL_ACCOUNT_ATTRIBUTE_REMOVED_PROGRAM_OWNER_INITIATED_SUSPENSION";
    /** The name of the Notification Event when a statement is ready */ NotificationEventName["FINANCIAL_ACCOUNT_STATEMENT_READY"] = "FINANCIAL_ACCOUNT_STATEMENT_READY";
    /** Triggered when the `InstantNetworkTransfer` has completed. */ NotificationEventName["INSTANT_NETWORK_TRANSFER_COMPLETED_EVENT"] = "INSTANT_NETWORK_TRANSFER_COMPLETED_EVENT";
    /** Triggered when the `InstantNetworkTransfer` has failed. */ NotificationEventName["INSTANT_NETWORK_TRANSFER_FAILED_EVENT"] = "INSTANT_NETWORK_TRANSFER_FAILED_EVENT";
    /** Triggered when the `InstantNetworkTransfer` has been initiated. */ NotificationEventName["INSTANT_NETWORK_TRANSFER_INITIATED_EVENT"] = "INSTANT_NETWORK_TRANSFER_INITIATED_EVENT";
    /** Triggered when money movement between `FinancialAccount`s has complete. */ NotificationEventName["INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED"] = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_COMPLETED";
    /** Triggered when money movement between `FinancialAccount`s has failed. */ NotificationEventName["INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED"] = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_FAILED";
    /** Triggered when money movement between `FinancialAccount`s is pending. */ NotificationEventName["INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING"] = "INTERNAL_TRANSFER_BETWEEN_FINANCIAL_ACCOUNTS_PENDING";
    /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account has completed */ NotificationEventName["INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED"] = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_COMPLETED";
    /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account has failed */ NotificationEventName["INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED"] = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_FAILED";
    /** The name of the Notification Event when an internal transfer from Funding Financial Account to Payment Card Financial Account is pending */ NotificationEventName["INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING"] = "INTERNAL_TRANSFER_FROM_FUNDING_FINANCIAL_ACCOUNT_TO_PAYMENT_CARD_FINANCIAL_ACCOUNT_PENDING";
    /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account has completed */ NotificationEventName["INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED"] = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_COMPLETED";
    /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account has failed */ NotificationEventName["INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED"] = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_FAILED";
    /** The name of the Notification Event when an internal transfer from Payment Card Financial Account to Funding Financial Account is pending */ NotificationEventName["INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING"] = "INTERNAL_TRANSFER_FROM_PAYMENT_CARD_FINANCIAL_ACCOUNT_TO_FUNDING_FINANCIAL_ACCOUNT_PENDING";
    /** The name of the Notification Event when a `Verified External Financial Account` creation fails */ NotificationEventName["LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT_FAILED"] = "LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT_FAILED";
    /** Triggered when a non-originated ACH transfer has failed before it is sent to the external financial institution. */ NotificationEventName["NON_ORIGINATED_ACH_TRANSFER_FAILED"] = "NON_ORIGINATED_ACH_TRANSFER_FAILED";
    /** Triggered when a non-originated ACH transfer is processed by Highnote. */ NotificationEventName["NON_ORIGINATED_ACH_TRANSFER_PROCESSED"] = "NON_ORIGINATED_ACH_TRANSFER_PROCESSED";
    /** Triggered when a non-originated ACH transfer is received from an external financial institution. */ NotificationEventName["NON_ORIGINATED_ACH_TRANSFER_RECEIVED"] = "NON_ORIGINATED_ACH_TRANSFER_RECEIVED";
    /** Triggered when a non-originated ACH transfer has been returned by the external financial institution. */ NotificationEventName["NON_ORIGINATED_ACH_TRANSFER_RETURNED"] = "NON_ORIGINATED_ACH_TRANSFER_RETURNED";
    /**
   * The name of the Notification Event when a notification target is being activated.
   *
   * **Note:** This field will be ignored if provided as an event name when adding a notification target.
   */ NotificationEventName["NOTIFICATION_ACTIVATION"] = "NOTIFICATION_ACTIVATION";
    /** Triggered when an originated ACH transfer is canceled before it is sent to the external financial institution. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_CANCELED"] = "ORIGINATED_ACH_TRANSFER_CANCELED";
    /** Triggered when an originated ACH transfer has failed before it is sent to the external financial institution. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_FAILED"] = "ORIGINATED_ACH_TRANSFER_FAILED";
    /** Triggered when an originated ACH transfer is initiated. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_INITIATED"] = "ORIGINATED_ACH_TRANSFER_INITIATED";
    /** Triggered when an originated ACH transfer is processed by Highnote, pending send to the external financial institution for processing. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_PENDING"] = "ORIGINATED_ACH_TRANSFER_PENDING";
    /** Triggered when an originated ACH transfer is finalized and the funds are available or withdrawn. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_PROCESSED"] = "ORIGINATED_ACH_TRANSFER_PROCESSED";
    /** Triggered when an originated ACH transfer is sent to the external financial institution for processing. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_PROCESSING"] = "ORIGINATED_ACH_TRANSFER_PROCESSING";
    /** Triggered when an originated ACH transfer has been returned by the external financial institution. */ NotificationEventName["ORIGINATED_ACH_TRANSFER_RETURNED"] = "ORIGINATED_ACH_TRANSFER_RETURNED";
    /** The name of the Notification Event when a payment card has been activated */ NotificationEventName["PAYMENT_CARD_ACTIVATED"] = "PAYMENT_CARD_ACTIVATED";
    /** The name of the Notification Event when a payment card transaction authorization has been adjusted */ NotificationEventName["PAYMENT_CARD_ADJUSTMENT"] = "PAYMENT_CARD_ADJUSTMENT";
    /** The name of the Notification Event when a payment card transaction authorization and clear happens together and has been approved */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED"] = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_APPROVED";
    /** The name of the Notification Event when a payment card transaction authorization and clear happens together and has been declined */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED"] = "PAYMENT_CARD_AUTHORIZATION_AND_CLEAR_DECLINED";
    /** The name of the Notification Event when a payment card transaction authorization has been approved */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_APPROVED"] = "PAYMENT_CARD_AUTHORIZATION_APPROVED";
    /**
   * `DEPRECATED`
   *
   * The name of the Notification Event when a payment card transaction authorization has been created
   * @deprecated No longer supported
   */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_CREATED"] = "PAYMENT_CARD_AUTHORIZATION_CREATED";
    /** The name of the Notification Event when a payment card transaction authorization has been declined */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_DECLINED"] = "PAYMENT_CARD_AUTHORIZATION_DECLINED";
    /** The name of the Notification Event when a payment card transaction authorization has been reversed */ NotificationEventName["PAYMENT_CARD_AUTHORIZATION_REVERSED"] = "PAYMENT_CARD_AUTHORIZATION_REVERSED";
    /** The name of the Notification Event when a payment card transaction has been cleared */ NotificationEventName["PAYMENT_CARD_CLEARED"] = "PAYMENT_CARD_CLEARED";
    /** The name of the Notification Event when a payment card has been closed */ NotificationEventName["PAYMENT_CARD_CLOSED"] = "PAYMENT_CARD_CLOSED";
    /** The name of the Notification Event when enhanced data for a payment card transaction has been received */ NotificationEventName["PAYMENT_CARD_ENHANCED_DATA_RECEIVED"] = "PAYMENT_CARD_ENHANCED_DATA_RECEIVED";
    /** The name of the Notification Event when a payment card has been issued. */ NotificationEventName["PAYMENT_CARD_ISSUED"] = "PAYMENT_CARD_ISSUED";
    /** The name of the Notification Event when a payment card has been suspended */ NotificationEventName["PAYMENT_CARD_SUSPENDED"] = "PAYMENT_CARD_SUSPENDED";
    /** Triggered when a Provisional Credit has been issued for a  `PaymentCardTransactionChargeback`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED"] = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_ISSUED";
    /** Triggered when a Provisional Credit has been revoked for a `PaymentCardTransactionChargeback`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED"] = "PAYMENT_CARD_TRANSACTION_CHARGEBACK_PROVISIONAL_CREDIT_REVOKED";
    /** Triggered when a `PaymentCardTransactionDispute` has been canceled. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CANCELLED";
    /** Triggered when a `PaymentCardTransactionDispute` has been resolved as a cardholder loss. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_LOST";
    /** Triggered when a `PaymentCardTransactionDispute` has been resolved as a cardholder win. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_CASE_CARDHOLDER_WON";
    /** Triggered when a `PaymentCardTransactionDispute` has been initiated. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_INITIATED";
    /** Triggered when a `PaymentCardTransactionDispute` has been rejected by the issuer or network. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_REJECTED";
    /** Triggered when a `PaymentCardTransactionDispute` has been resolved by issuing a dispute credit. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CASE_STATUS_RESOLVED_WITH_DISPUTE_CREDIT";
    /** Triggered when a Dispute Credit has been issued for a `PaymentCardTransactionDispute`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_ISSUED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_ISSUED";
    /** Triggered when a Dispute Credit has been reversed for a `PaymentCardTransactionDispute`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_REVERSED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_CREDIT_REVERSED";
    /** Triggered when a Provisional Credit has been issued for a `PaymentCardTransactionDispute`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_ISSUED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_ISSUED";
    /** Triggered when a Provisional Credit has been revoked for a `PaymentCardTransactionDispute`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_REVOKED"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_REVOKED";
    /** Triggered when a Provisional Credit has been won for a `PaymentCardTransactionDispute`. */ NotificationEventName["PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_WON"] = "PAYMENT_CARD_TRANSACTION_DISPUTE_PROVISIONAL_CREDIT_WON";
    /** The name of the Notification Event when a payment card has been unsuspended */ NotificationEventName["PAYMENT_CARD_UNSUSPENDED"] = "PAYMENT_CARD_UNSUSPENDED";
    /** The name of the Notification Event when a payment card verification has been approved */ NotificationEventName["PAYMENT_CARD_VERIFICATION_APPROVED"] = "PAYMENT_CARD_VERIFICATION_APPROVED";
    /** The name of the Notification Event when a payment card verification has been declined */ NotificationEventName["PAYMENT_CARD_VERIFICATION_DECLINED"] = "PAYMENT_CARD_VERIFICATION_DECLINED";
    /** Triggered when a `PaymentTransaction` receives a payout transfer completed event. */ NotificationEventName["PAYOUT_TRANSFER_COMPLETED_EVENT"] = "PAYOUT_TRANSFER_COMPLETED_EVENT";
    /** The name of the Notification Event when a payroll advance repayment has completed */ NotificationEventName["PAYROLL_ADVANCE_REPAYMENT_COMPLETED"] = "PAYROLL_ADVANCE_REPAYMENT_COMPLETED";
    /** The name of the Notification Event when a payroll advance repayment has been written off */ NotificationEventName["PAYROLL_ADVANCE_WRITE_OFF_COMPLETED"] = "PAYROLL_ADVANCE_WRITE_OFF_COMPLETED";
    /** Triggered when identity verification documents are requested for a `PersonAccountHolder`. */ NotificationEventName["PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED"] = "PERSON_ACCOUNT_HOLDER_IDENTITY_DOCUMENTS_REQUESTED";
    /** Triggered when a `PersonAccountHolder` is updated. */ NotificationEventName["PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED"] = "PERSON_ACCOUNT_HOLDER_IDENTITY_UPDATED";
    /** The name of the Notification Event when a physical payment card group order has shipped */ NotificationEventName["PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED"] = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIPPED";
    /** The name of the Notification Event when a physical payment card group order has failed to ship */ NotificationEventName["PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED"] = "PHYSICAL_PAYMENT_CARD_GROUP_ORDER_SHIP_FAILED";
    /** The name of the Notification Event when a physical payment card has shipped */ NotificationEventName["PHYSICAL_PAYMENT_CARD_SHIPPED"] = "PHYSICAL_PAYMENT_CARD_SHIPPED";
    /** The name of the Notification Event when a physical payment card has failed to ship */ NotificationEventName["PHYSICAL_PAYMENT_CARD_SHIP_FAILED"] = "PHYSICAL_PAYMENT_CARD_SHIP_FAILED";
    /** The provision account holder workflow has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_COMPLETED";
    /** The provision account holder CREATE_APPLICATION action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_COMPLETED";
    /** The provision account holder CREATE_APPLICATION action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_ERROR"] = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_ERROR";
    /** The provision account holder CREATE_APPLICATION action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_INITIATED";
    /** The provision account holder CREATE_APPLICATION action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_IN_PROGRESS";
    /** The provision account holder CREATE_APPLICATION action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_CREATE_APPLICATION_NOT_COMPLETED";
    /** The provision account holder workflow has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ERROR"] = "PROVISION_ACCOUNT_HOLDER_ERROR";
    /** The provision account holder workflow has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_INITIATED";
    /** The provision account holder workflow has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_IN_PROGRESS";
    /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_COMPLETED";
    /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_ERROR"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_ERROR";
    /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_INITIATED";
    /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_IN_PROGRESS";
    /** The provision account holder ISSUE_FINANCIAL_ACCOUNT action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_FINANCIAL_ACCOUNT_NOT_COMPLETED";
    /** The provision account holder ISSUE_PAYMENT_CARD action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_COMPLETED";
    /** The provision account holder ISSUE_PAYMENT_CARD action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_ERROR"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_ERROR";
    /** The provision account holder ISSUE_PAYMENT_CARD action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_INITIATED";
    /** The provision account holder ISSUE_PAYMENT_CARD action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_IN_PROGRESS";
    /** The provision account holder ISSUE_PAYMENT_CARD action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_ISSUE_PAYMENT_CARD_NOT_COMPLETED";
    /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_COMPLETED";
    /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_ERROR"] = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_ERROR";
    /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_INITIATED";
    /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_IN_PROGRESS";
    /** The provision account holder LINK_EXTERNAL_BANK_ACCOUNT action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_LINK_EXTERNAL_BANK_ACCOUNT_NOT_COMPLETED";
    /** The provision account holder NOTIFY_PROVIDER action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_COMPLETED";
    /** The provision account holder NOTIFY_PROVIDER action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_ERROR"] = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_ERROR";
    /** The provision account holder NOTIFY_PROVIDER action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_INITIATED";
    /** The provision account holder NOTIFY_PROVIDER action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_IN_PROGRESS";
    /** The provision account holder NOTIFY_PROVIDER action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_NOTIFY_PROVIDER_NOT_COMPLETED";
    /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_COMPLETED";
    /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_ERROR"] = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_ERROR";
    /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_INITIATED";
    /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_IN_PROGRESS";
    /** The provision account holder REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT_NOT_COMPLETED";
    /** The provision account holder workflow has terminated due to a rejection. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_REJECTED"] = "PROVISION_ACCOUNT_HOLDER_REJECTED";
    /** The provision account holder SET_CREDIT_LIMIT action has completed. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_COMPLETED";
    /** The provision account holder SET_CREDIT_LIMIT action has encountered an error. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_ERROR"] = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_ERROR";
    /** The provision account holder SET_CREDIT_LIMIT action has been initiated. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_INITIATED"] = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_INITIATED";
    /** The provision account holder SET_CREDIT_LIMIT action has started processing. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_IN_PROGRESS"] = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_IN_PROGRESS";
    /** The provision account holder SET_CREDIT_LIMIT action will not be completed due to the workflow exiting early. */ NotificationEventName["PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_NOT_COMPLETED"] = "PROVISION_ACCOUNT_HOLDER_SET_CREDIT_LIMIT_NOT_COMPLETED";
    /** The name of the Notification Event when a report has completed. */ NotificationEventName["REPORT_COMPLETED"] = "REPORT_COMPLETED";
    /** The name of the Notification Event when a report has failed. */ NotificationEventName["REPORT_FAILED"] = "REPORT_FAILED";
    /** Triggered when the `UnifiedFundsTransfer` has completed. */ NotificationEventName["UNIFIED_FUNDS_TRANSFER_COMPLETED_EVENT"] = "UNIFIED_FUNDS_TRANSFER_COMPLETED_EVENT";
    /** Triggered when the `UnifiedFundsTransfer` has failed. */ NotificationEventName["UNIFIED_FUNDS_TRANSFER_FAILED_EVENT"] = "UNIFIED_FUNDS_TRANSFER_FAILED_EVENT";
    /** Triggered when the `UnifiedFundsTransfer` has been initiated. */ NotificationEventName["UNIFIED_FUNDS_TRANSFER_INITIATED_EVENT"] = "UNIFIED_FUNDS_TRANSFER_INITIATED_EVENT";
    /** Triggered when a `FinancialAccountStatement` has an upcoming payment due date. The number of days in advance of the due date to trigger this notification is configurable at the `CardProduct` level. */ NotificationEventName["UPCOMING_STATEMENT_DUE_DATE"] = "UPCOMING_STATEMENT_DUE_DATE";
    return NotificationEventName;
}({});
var $2f53fee15f29b056$export$41ae450f109f984 = /*#__PURE__*/ function(NotificationTargetStatus) {
    /** The target was unable to be verified. */ NotificationTargetStatus["ACTIVATION_FAILED"] = "ACTIVATION_FAILED";
    /** The target has been verified and events are being delivered. */ NotificationTargetStatus["ACTIVE"] = "ACTIVE";
    /** The target has been manually deactivated or Highnote has detected an error delivering events. */ NotificationTargetStatus["DEACTIVATED"] = "DEACTIVATED";
    /** The target has not yet been verified. Events will not be delivered. */ NotificationTargetStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    return NotificationTargetStatus;
}({});
var $2f53fee15f29b056$export$313a3836a2141b44 = /*#__PURE__*/ function(OnBoardingBusinessGlobalRegion) {
    /** Asia Pacific */ OnBoardingBusinessGlobalRegion["APAC"] = "APAC";
    /** Canada */ OnBoardingBusinessGlobalRegion["CANADA"] = "CANADA";
    /** Europe */ OnBoardingBusinessGlobalRegion["EUROPE"] = "EUROPE";
    /** Latin America */ OnBoardingBusinessGlobalRegion["LATIN_AMERICA"] = "LATIN_AMERICA";
    /** Other Region */ OnBoardingBusinessGlobalRegion["OTHER"] = "OTHER";
    /** United States */ OnBoardingBusinessGlobalRegion["UNITED_STATES"] = "UNITED_STATES";
    return OnBoardingBusinessGlobalRegion;
}({});
var $2f53fee15f29b056$export$7ff3775fee9c889b = /*#__PURE__*/ function(OnboardingApplicationStepStatus) {
    /** No data has yet been received */ OnboardingApplicationStepStatus["NOT_STARTED"] = "NOT_STARTED";
    /** Data has been entered and saved */ OnboardingApplicationStepStatus["SUBMITTED"] = "SUBMITTED";
    return OnboardingApplicationStepStatus;
}({});
var $2f53fee15f29b056$export$863e6abdd3f9d8b4 = /*#__PURE__*/ function(OnboardingAverageMonthlyPaymentVolumeRange) {
    /** Between $1,000,000 and $5,000,000 USD average monthly volume */ OnboardingAverageMonthlyPaymentVolumeRange["BETWEEN_1_000_000_AND_5_000_000"] = "BETWEEN_1_000_000_AND_5_000_000";
    /** Between $5,000,000 and $25,000,000 USD average monthly volume */ OnboardingAverageMonthlyPaymentVolumeRange["BETWEEN_5_000_000_AND_25_000_000"] = "BETWEEN_5_000_000_AND_25_000_000";
    /** Between $500,000 and $1,000,000 USD average monthly volume */ OnboardingAverageMonthlyPaymentVolumeRange["BETWEEN_500_000_AND_1_000_000"] = "BETWEEN_500_000_AND_1_000_000";
    /** Over $25,000,000 USD average monthly volume */ OnboardingAverageMonthlyPaymentVolumeRange["OVER_25_000_000"] = "OVER_25_000_000";
    /** Under $500,000 USD average monthly volume */ OnboardingAverageMonthlyPaymentVolumeRange["UNDER_500_000"] = "UNDER_500_000";
    return OnboardingAverageMonthlyPaymentVolumeRange;
}({});
var $2f53fee15f29b056$export$a9d67afbb22844b6 = /*#__PURE__*/ function(OnboardingAverageMonthlyVolumeRange) {
    /** Between $1,000,000 and $5,000,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["BETWEEN_1_000_000_AND_5_000_000"] = "BETWEEN_1_000_000_AND_5_000_000";
    /** Between $5,000,000 and $10,000,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["BETWEEN_5_000_000_AND_10_000_000"] = "BETWEEN_5_000_000_AND_10_000_000";
    /** Between $10,000,000 and $50,000,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["BETWEEN_10_000_000_AND_50_000_000"] = "BETWEEN_10_000_000_AND_50_000_000";
    /** Between $500,000 and $1,000,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["BETWEEN_500_000_AND_1_000_000"] = "BETWEEN_500_000_AND_1_000_000";
    /** Over $50,000,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["OVER_50_000_000"] = "OVER_50_000_000";
    /** Under $500,000 USD average monthly volume */ OnboardingAverageMonthlyVolumeRange["UNDER_500_000"] = "UNDER_500_000";
    return OnboardingAverageMonthlyVolumeRange;
}({});
var $2f53fee15f29b056$export$e8c39851be495c7d = /*#__PURE__*/ function(OnboardingBusinessOrganizationInformationStatus) {
    /** Processing the merchant information within BusinessOrganizationInformation has been started */ OnboardingBusinessOrganizationInformationStatus["PROCESSING_STARTED"] = "PROCESSING_STARTED";
    /** Updates to the BusinessOrganizationInformation have been completed */ OnboardingBusinessOrganizationInformationStatus["UPDATE_COMPLETE"] = "UPDATE_COMPLETE";
    /** Update of the BusinessOrganizationInformation is still in progress */ OnboardingBusinessOrganizationInformationStatus["UPDATE_IN_PROGRESS"] = "UPDATE_IN_PROGRESS";
    return OnboardingBusinessOrganizationInformationStatus;
}({});
var $2f53fee15f29b056$export$939ba41559f55801 = /*#__PURE__*/ function(OnboardingBusinessPaymentSolution) {
    /** Accept payments as a marketplace or platform */ OnboardingBusinessPaymentSolution["ACCEPT_PAYMENTS_AS_MARKETPLACE"] = "ACCEPT_PAYMENTS_AS_MARKETPLACE";
    /** Accept payments online */ OnboardingBusinessPaymentSolution["ACCEPT_PAYMENTS_ONLINE"] = "ACCEPT_PAYMENTS_ONLINE";
    /** Accept payments online and swiped payments at point-of-sale */ OnboardingBusinessPaymentSolution["ACCEPT_PAYMENTS_ONLINE_AND_SWIPED"] = "ACCEPT_PAYMENTS_ONLINE_AND_SWIPED";
    /** Accept swiped payments at point-of-sale, kiosk, etc */ OnboardingBusinessPaymentSolution["ACCEPT_SWIPED_PAYMENTS"] = "ACCEPT_SWIPED_PAYMENTS";
    /** Issue virtual cards or physical cards */ OnboardingBusinessPaymentSolution["ISSUE_VIRTUAL_CARDS"] = "ISSUE_VIRTUAL_CARDS";
    return OnboardingBusinessPaymentSolution;
}({});
var $2f53fee15f29b056$export$bbb1491600ef24ae = /*#__PURE__*/ function(OnboardingBusinessTitle) {
    /** Authorized Signatory */ OnboardingBusinessTitle["AUTHORIZED_SIGNATORY"] = "AUTHORIZED_SIGNATORY";
    /** CEO */ OnboardingBusinessTitle["CEO"] = "CEO";
    /** CFO */ OnboardingBusinessTitle["CFO"] = "CFO";
    /** COO */ OnboardingBusinessTitle["COO"] = "COO";
    /** Owner */ OnboardingBusinessTitle["OWNER"] = "OWNER";
    /** President */ OnboardingBusinessTitle["PRESIDENT"] = "PRESIDENT";
    /** Treasurer */ OnboardingBusinessTitle["TREASURER"] = "TREASURER";
    /** Vice President */ OnboardingBusinessTitle["VICE_PRESIDENT"] = "VICE_PRESIDENT";
    return OnboardingBusinessTitle;
}({});
var $2f53fee15f29b056$export$c15efcc5b35830ea = /*#__PURE__*/ function(OnboardingCustomerLocation) {
    /** 50% are based in the United States */ OnboardingCustomerLocation["HALF_UNITED_STATES"] = "HALF_UNITED_STATES";
    /** Majority are based outside of the United States */ OnboardingCustomerLocation["MAJORITY_OUTSIDE_UNITED_STATES"] = "MAJORITY_OUTSIDE_UNITED_STATES";
    /** Majority are based in the Unided States */ OnboardingCustomerLocation["MAJORITY_UNITED_STATES"] = "MAJORITY_UNITED_STATES";
    /** 100% of customers are based in the United States */ OnboardingCustomerLocation["UNITED_STATES"] = "UNITED_STATES";
    return OnboardingCustomerLocation;
}({});
var $2f53fee15f29b056$export$2f58b04c8f5a9b28 = /*#__PURE__*/ function(OnboardingDesiredPaymentSolution) {
    /** Accept in-person payments at point-of-sale, kiosk, etc */ OnboardingDesiredPaymentSolution["ACCEPT_IN_PERSON_PAYMENTS"] = "ACCEPT_IN_PERSON_PAYMENTS";
    /** Accept payments online */ OnboardingDesiredPaymentSolution["ACCEPT_PAYMENTS_ONLINE"] = "ACCEPT_PAYMENTS_ONLINE";
    /** Issue virtual cards or physical cards */ OnboardingDesiredPaymentSolution["ISSUE_PAYMENT_CARDS"] = "ISSUE_PAYMENT_CARDS";
    return OnboardingDesiredPaymentSolution;
}({});
var $2f53fee15f29b056$export$42463a219b84402c = /*#__PURE__*/ function(OnboardingPaymentCardBrand) {
    /** American Express card brand. */ OnboardingPaymentCardBrand["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    /** Diners card brand. */ OnboardingPaymentCardBrand["DINERS_CLUB"] = "DINERS_CLUB";
    /** Discover card brand. */ OnboardingPaymentCardBrand["DISCOVER"] = "DISCOVER";
    /** JCB card brand. */ OnboardingPaymentCardBrand["JCB"] = "JCB";
    /** Maestro card brand. */ OnboardingPaymentCardBrand["MAESTRO"] = "MAESTRO";
    /** Mastercard card brand. */ OnboardingPaymentCardBrand["MASTERCARD"] = "MASTERCARD";
    /** Visa card brand. */ OnboardingPaymentCardBrand["VISA"] = "VISA";
    return OnboardingPaymentCardBrand;
}({});
var $2f53fee15f29b056$export$7e2f1535dcc7f5ba = /*#__PURE__*/ function(OnboardingPreApprovalStatus) {
    /** Approved to move forward */ OnboardingPreApprovalStatus["APPROVED"] = "APPROVED";
    /** Approved to move forward, but outreach should also be done to confirm needs of new business */ OnboardingPreApprovalStatus["APPROVED_WITH_OUTREACH"] = "APPROVED_WITH_OUTREACH";
    /** Denied from moving forward in the onboarding process */ OnboardingPreApprovalStatus["DENIED"] = "DENIED";
    /** No decision yet made */ OnboardingPreApprovalStatus["NOT_DECISIONED"] = "NOT_DECISIONED";
    /** Redirect the request to issuing product */ OnboardingPreApprovalStatus["REDIRECT_TO_ISSUING"] = "REDIRECT_TO_ISSUING";
    return OnboardingPreApprovalStatus;
}({});
var $2f53fee15f29b056$export$be28b5537e9b6bcf = /*#__PURE__*/ function(OrganizationBusinessRelationshipStatus) {
    /** The relationship is currently active and valid. */ OrganizationBusinessRelationshipStatus["ACTIVE"] = "ACTIVE";
    /** The relationship is inactive or has been revoked. */ OrganizationBusinessRelationshipStatus["INACTIVE"] = "INACTIVE";
    return OrganizationBusinessRelationshipStatus;
}({});
var $2f53fee15f29b056$export$ea0800cbd49b962f = /*#__PURE__*/ function(OrganizationBusinessRelationshipType) {
    /** The relationship is with a customer. */ OrganizationBusinessRelationshipType["CUSTOMER"] = "CUSTOMER";
    /** The relationship is with a partner. */ OrganizationBusinessRelationshipType["PARTNER"] = "PARTNER";
    return OrganizationBusinessRelationshipType;
}({});
var $2f53fee15f29b056$export$f234fb36d4d66273 = /*#__PURE__*/ function(OrganizationReportType) {
    /** This report contains all ACH event activities across all financial accounts for the organization. */ OrganizationReportType["ACH_EVENT_ACTIVITY"] = "ACH_EVENT_ACTIVITY";
    /** This report contains card interchange and transaction settlement activity across all financial accounts for the organization. */ OrganizationReportType["CARD_INTERCHANGE_ACTIVITY"] = "CARD_INTERCHANGE_ACTIVITY";
    /** This report contains all card transaction event activities across all financial accounts for the organization. */ OrganizationReportType["CARD_TRANSACTION_ACTIVITY"] = "CARD_TRANSACTION_ACTIVITY";
    /** This is the credit loan tape report across all financial accounts for the organization. */ OrganizationReportType["CREDIT_LOAN_TAPE"] = "CREDIT_LOAN_TAPE";
    /** Metro2 file formatted for credit report furnishing with Experian. */ OrganizationReportType["EXPERIAN_CREDIT_REPORT"] = "EXPERIAN_CREDIT_REPORT";
    /** This report contains all the enhanced data (level 2/3) sent by the payment networks for cleared fleet transactions for a specific time period */ OrganizationReportType["FLEET_ENHANCED_DATA_SUMMARY"] = "FLEET_ENHANCED_DATA_SUMMARY";
    /** This report contains ledger entries across all financial accounts for the organization. */ OrganizationReportType["LEDGER_ENTRY"] = "LEDGER_ENTRY";
    /** This is the negative balance report across all financial accounts for the organization. */ OrganizationReportType["NEGATIVE_ACCOUNT_BALANCE"] = "NEGATIVE_ACCOUNT_BALANCE";
    /** This report contains the breakdown of each financial account’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */ OrganizationReportType["RECEIVABLE_ACCOUNTS_SALE"] = "RECEIVABLE_ACCOUNTS_SALE";
    /** This report contains the overall amount(s) being sold on a given business day */ OrganizationReportType["RECEIVABLE_SALE"] = "RECEIVABLE_SALE";
    /** This is the RPA purchase agreement for a given day */ OrganizationReportType["RECEIVABLE_SALE_AGREEMENT"] = "RECEIVABLE_SALE_AGREEMENT";
    /** This report contains the breakdown of each transaction’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */ OrganizationReportType["RECEIVABLE_SALE_TRANSACTIONS"] = "RECEIVABLE_SALE_TRANSACTIONS";
    /** This report contains all transfer event activities across all financial accounts for the organization. */ OrganizationReportType["TRANSFER_EVENT_ACTIVITY"] = "TRANSFER_EVENT_ACTIVITY";
    return OrganizationReportType;
}({});
var $2f53fee15f29b056$export$eb18cf14f0d0f018 = /*#__PURE__*/ function(OriginatedAchTransferStatus) {
    /** The transfer has been cancelled before it was sent to the external financial institution. */ OriginatedAchTransferStatus["CANCELED"] = "CANCELED";
    /** The transfer failed by Highnote before it was sent to the external financial institution. Additional details are available in `AchTransferStatusFailureReason`. */ OriginatedAchTransferStatus["FAILED"] = "FAILED";
    /** A transfer request has been initiated. */ OriginatedAchTransferStatus["INITIATED"] = "INITIATED";
    /** The transfer has been processed by Highnote, pending submittal to the external financial institution. */ OriginatedAchTransferStatus["PENDING"] = "PENDING";
    /** The transfer has successfully been processed by the external financial institution and funds are available. */ OriginatedAchTransferStatus["PROCESSED"] = "PROCESSED";
    /** The transfer is processing at the external financial institution, but funds are not available yet. */ OriginatedAchTransferStatus["PROCESSING"] = "PROCESSING";
    /** The transfer has been returned by the external financial institution. Additional details are available in `AchTransferStatusFailureReason`. */ OriginatedAchTransferStatus["RETURNED"] = "RETURNED";
    return OriginatedAchTransferStatus;
}({});
var $2f53fee15f29b056$export$ef36721dfda38e85 = /*#__PURE__*/ function(PanEntryMode) {
    /** Bar code or QR Code. */ PanEntryMode["BAR_CODE_OR_QR_CODE"] = "BAR_CODE_OR_QR_CODE";
    /**
   * Chip card or chip-capable terminal was unable to process the transaction using the data on the chip, the PAN was entered via magnetic stripe.
   * The full track data was read from the data encoded on the card and transmitted within the authorization request on Track 2 Data
   * or Track 1 Data without alteration or truncation.
   */ PanEntryMode["CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE"] = "CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE";
    /**
   * Chip card or chip-capable terminal was unable to process the transaction using the data on the chip or magnetic stripe,
   * the PAN was entered manually, or the Acquirer is not certified to process the value CC_UNABLE_TO_PROCESS_ENTERED_VIA_MAGNETIC_STRIPE.
   */ PanEntryMode["CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY"] = "CHIP_CARD_UNABLE_TO_PROCESS_ENTERED_MANUALLY";
    /** Contactless via Chip rules. */ PanEntryMode["CONTACTLESS_VIA_CHIP_RULES"] = "CONTACTLESS_VIA_CHIP_RULES";
    /** Contactless via magnetic stripe rules. */ PanEntryMode["CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES"] = "CONTACTLESS_VIA_MAGNETIC_STRIPE_RULES";
    /** From file; credentials on file */ PanEntryMode["CREDENTIALS_ON_FILE"] = "CREDENTIALS_ON_FILE";
    /** Full magnetic stripe read (full magnetic stripe data will be present). */ PanEntryMode["FULL_MAGNETIC_STRIPE_READ"] = "FULL_MAGNETIC_STRIPE_READ";
    /** Integrated circuit card, CVV data may be unreliable. */ PanEntryMode["ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE"] = "ICC_CARD_CVV_DATA_MAY_BE_UNRELIABLE";
    /** Integrated circuit card (contact chip). */ PanEntryMode["INTEGRATED_CIRCUIT_CARD"] = "INTEGRATED_CIRCUIT_CARD";
    /** Magnetic stripe (full magnetic stripe data may not be present). */ PanEntryMode["MAGNETIC_STRIPE"] = "MAGNETIC_STRIPE";
    /** Manual. */ PanEntryMode["MANUAL"] = "MANUAL";
    /** Manual (key-entered). */ PanEntryMode["MANUAL_KEY_ENTERED"] = "MANUAL_KEY_ENTERED";
    /** Optical Character Reader (OCR) */ PanEntryMode["OPTICAL_CHARACTER_READER"] = "OPTICAL_CHARACTER_READER";
    /** PAN Auto Entry via Server (issuer, acquirer, or third party vendor system). */ PanEntryMode["PAN_AUTO_ENTRY_VIA_SERVER"] = "PAN_AUTO_ENTRY_VIA_SERVER";
    /** Reserved for ISO, national, or private use. */ PanEntryMode["RESERVED"] = "RESERVED";
    /** Secure cardless entry. */ PanEntryMode["SECURE_CARD_LESS_ENTRY"] = "SECURE_CARD_LESS_ENTRY";
    /**
   * PAN entry via electronic commerce, including remote chip for which data must be passed by the acquirer
   * (although such remote chip data may not be present in transactions received by the issuer if cryptographic
   * validation is being performed by a network or other entity on behalf of the issuer).
   */ PanEntryMode["VIA_ELECTRONIC_COMMERCE"] = "VIA_ELECTRONIC_COMMERCE";
    return PanEntryMode;
}({});
var $2f53fee15f29b056$export$3068c81d689ebca2 = /*#__PURE__*/ function(PartnerBankName) {
    /** The value representing Bancorp. */ PartnerBankName["BANCORP"] = "BANCORP";
    /** The value representing BNY. */ PartnerBankName["BNY"] = "BNY";
    /** The value representing Cass Bank. */ PartnerBankName["CASS_BANK"] = "CASS_BANK";
    /** The value representing Celtic. */ PartnerBankName["CELTIC"] = "CELTIC";
    /** The value representing CFSB. */ PartnerBankName["CFSB"] = "CFSB";
    /** The value representing Cross River. */ PartnerBankName["CROSS_RIVER"] = "CROSS_RIVER";
    /** The value representing FinWise Bank. */ PartnerBankName["FINWISE_BANK"] = "FINWISE_BANK";
    /** The value representing Highnote. */ PartnerBankName["HIGHNOTE"] = "HIGHNOTE";
    /** The value representing Sutton. */ PartnerBankName["SUTTON"] = "SUTTON";
    /** The value representing Silicon Valley Bank. */ PartnerBankName["SVB_BANK"] = "SVB_BANK";
    /** The value representing Transpecos Bank. */ PartnerBankName["TRANSPECOS_BANK"] = "TRANSPECOS_BANK";
    /** The value representing Veritex Bank. */ PartnerBankName["VERITEX_BANK"] = "VERITEX_BANK";
    return PartnerBankName;
}({});
var $2f53fee15f29b056$export$d0cb3feccfba716a = /*#__PURE__*/ function(PayOffType) {
    /** Estimated Total payment and time it takes with minimum payment amount of the statement. */ PayOffType["MINIMUM_PAY_OFF"] = "MINIMUM_PAY_OFF";
    /** Estimated Total payment and minimum required to pay it within 3 years fix time. */ PayOffType["THREE_YEAR_PAY_OFF"] = "THREE_YEAR_PAY_OFF";
    return PayOffType;
}({});
var $2f53fee15f29b056$export$f9c318d1b9daa26 = /*#__PURE__*/ function(PaymentAdvanceStatus) {
    /** The full amount of the `PaymentAdvance` has been repaid. */ PaymentAdvanceStatus["FULLY_REPAID"] = "FULLY_REPAID";
    /** The full amount of the `PaymentAdvance` has not been repaid. */ PaymentAdvanceStatus["NOT_REPAID"] = "NOT_REPAID";
    /** A partial amount of the `PaymentAdvance` has been repaid. */ PaymentAdvanceStatus["PARTIALLY_REPAID"] = "PARTIALLY_REPAID";
    /** The `PaymentAdvance` line item is written off because repaymentAttemptCount has reached 3. */ PaymentAdvanceStatus["WRITTEN_OFF"] = "WRITTEN_OFF";
    return PaymentAdvanceStatus;
}({});
var $2f53fee15f29b056$export$15cc4eb2ce4d8ebb = /*#__PURE__*/ function(PaymentAdvanceWriteOffReason) {
    /** Payment Advance will be written off because repaymentAttemptCount has reached 3. */ PaymentAdvanceWriteOffReason["EXCEED_MAX_ATTEMPT_COUNT"] = "EXCEED_MAX_ATTEMPT_COUNT";
    return PaymentAdvanceWriteOffReason;
}({});
var $2f53fee15f29b056$export$59cbb72b7730025 = /*#__PURE__*/ function(PaymentCardBinClassification) {
    /** Business bin. */ PaymentCardBinClassification["BUSINESS"] = "BUSINESS";
    /** Commercial bin. */ PaymentCardBinClassification["COMMERCIAL"] = "COMMERCIAL";
    /** Consumer bin. */ PaymentCardBinClassification["CONSUMER"] = "CONSUMER";
    /** Fleet bin. */ PaymentCardBinClassification["FLEET"] = "FLEET";
    /** Government bin. */ PaymentCardBinClassification["GOVERNMENT"] = "GOVERNMENT";
    return PaymentCardBinClassification;
}({});
var $2f53fee15f29b056$export$b0f6d7b49b57efdc = /*#__PURE__*/ function(PaymentCardBinFundingModel) {
    /** Credit funding model. */ PaymentCardBinFundingModel["CREDIT"] = "CREDIT";
    /** Debit funding model. */ PaymentCardBinFundingModel["DEBIT"] = "DEBIT";
    /** Prepaid funding model. */ PaymentCardBinFundingModel["PREPAID"] = "PREPAID";
    return PaymentCardBinFundingModel;
}({});
var $2f53fee15f29b056$export$9d2fafe1f1a93357 = /*#__PURE__*/ function(PaymentCardBinProductCode) {
    /** Mastercard Corporate Fleet Card. */ PaymentCardBinProductCode["MASTERCARD_MCF"] = "MASTERCARD_MCF";
    /** Mastercard Corporate Card. */ PaymentCardBinProductCode["MASTERCARD_MCO"] = "MASTERCARD_MCO";
    /** Debit Mastercard BusinessCard Card. */ PaymentCardBinProductCode["MASTERCARD_MDB"] = "MASTERCARD_MDB";
    /** Debit Mastercard BusinessCard Card. */ PaymentCardBinProductCode["MASTERCARD_MDJ"] = "MASTERCARD_MDJ";
    /** Prepaid Mastercard Payroll Card. */ PaymentCardBinProductCode["MASTERCARD_MPA"] = "MASTERCARD_MPA";
    /** Prepaid Mastercard General Spend Card. */ PaymentCardBinProductCode["MASTERCARD_MPG"] = "MASTERCARD_MPG";
    /** Mastercard Platinum. */ PaymentCardBinProductCode["MASTERCARD_MPL"] = "MASTERCARD_MPL";
    /** Prepaid Mastercard Consumer Incentive Card. */ PaymentCardBinProductCode["MASTERCARD_MPM"] = "MASTERCARD_MPM";
    /** Prepaid Mastercard Workplace B2B Solutions. */ PaymentCardBinProductCode["MASTERCARD_MPW"] = "MASTERCARD_MPW";
    /** Mastercard Humanitarian Prepaid. */ PaymentCardBinProductCode["MASTERCARD_MWF"] = "MASTERCARD_MWF";
    /** Visa Traditional. */ PaymentCardBinProductCode["VISA_A"] = "VISA_A";
    /** Visa Rewards. */ PaymentCardBinProductCode["VISA_B"] = "VISA_B";
    /** Visa Signature. */ PaymentCardBinProductCode["VISA_C"] = "VISA_C";
    /** Visa Classic */ PaymentCardBinProductCode["VISA_F"] = "VISA_F";
    /** Visa Business. */ PaymentCardBinProductCode["VISA_G"] = "VISA_G";
    /** Visa Signature Business. */ PaymentCardBinProductCode["VISA_G1"] = "VISA_G1";
    /** Visa Infinite Business. */ PaymentCardBinProductCode["VISA_G4"] = "VISA_G4";
    /** Visa Infinite. */ PaymentCardBinProductCode["VISA_I"] = "VISA_I";
    /** Visa Healthcare. */ PaymentCardBinProductCode["VISA_J3"] = "VISA_J3";
    /** Visa Corporate T&E. */ PaymentCardBinProductCode["VISA_K"] = "VISA_K";
    /** Visa Government Corporate T&E. */ PaymentCardBinProductCode["VISA_K1"] = "VISA_K1";
    /** Visa Private Label. */ PaymentCardBinProductCode["VISA_Q"] = "VISA_Q";
    /** Visa Private Label Basic. */ PaymentCardBinProductCode["VISA_Q2"] = "VISA_Q2";
    /** Visa Private Label Standard. */ PaymentCardBinProductCode["VISA_Q3"] = "VISA_Q3";
    /** Visa Private Label Enhanced. */ PaymentCardBinProductCode["VISA_Q4"] = "VISA_Q4";
    /** Visa Private Label Specialized. */ PaymentCardBinProductCode["VISA_Q5"] = "VISA_Q5";
    /** Visa Private Label Premium. */ PaymentCardBinProductCode["VISA_Q6"] = "VISA_Q6";
    /** Visa Proprietary. */ PaymentCardBinProductCode["VISA_R"] = "VISA_R";
    /** Visa Purchasing. */ PaymentCardBinProductCode["VISA_S"] = "VISA_S";
    /** Visa Purchasing with Fleet. */ PaymentCardBinProductCode["VISA_S1"] = "VISA_S1";
    /** Visa Government Purchasing. */ PaymentCardBinProductCode["VISA_S2"] = "VISA_S2";
    /** Visa B2B Virtual Payments. */ PaymentCardBinProductCode["VISA_X"] = "VISA_X";
    return PaymentCardBinProductCode;
}({});
var $2f53fee15f29b056$export$74b18da5abda6c86 = /*#__PURE__*/ function(PaymentCardBinSubProductCode) {
    /** Visa Youth/College. */ PaymentCardBinSubProductCode["VISA_BX"] = "VISA_BX";
    /** Visa Cross Border Remittance. */ PaymentCardBinSubProductCode["VISA_CB"] = "VISA_CB";
    /** Visa Healthcare - FSA/HRA. */ PaymentCardBinSubProductCode["VISA_FS"] = "VISA_FS";
    /** Visa Cosumer Gift. */ PaymentCardBinSubProductCode["VISA_GI"] = "VISA_GI";
    /** Visa General Purpose. */ PaymentCardBinSubProductCode["VISA_GP"] = "VISA_GP";
    /** Visa Government Disbursement. */ PaymentCardBinSubProductCode["VISA_GV"] = "VISA_GV";
    /** Visa Employee Benefits. */ PaymentCardBinSubProductCode["VISA_HS"] = "VISA_HS";
    /** Visa Corporate Disbursement. */ PaymentCardBinSubProductCode["VISA_IC"] = "VISA_IC";
    /** Visa Insurance. */ PaymentCardBinSubProductCode["VISA_IP"] = "VISA_IP";
    /** Visa Multi-Currency Solution. */ PaymentCardBinSubProductCode["VISA_MS"] = "VISA_MS";
    /** Visa Other. */ PaymentCardBinSubProductCode["VISA_OT"] = "VISA_OT";
    /** Visa Payroll/Salary. */ PaymentCardBinSubProductCode["VISA_PP"] = "VISA_PP";
    /** Visa Campus/University. */ PaymentCardBinSubProductCode["VISA_ST"] = "VISA_ST";
    /** Visa Travel/Visa Travel Money. */ PaymentCardBinSubProductCode["VISA_TP"] = "VISA_TP";
    return PaymentCardBinSubProductCode;
}({});
var $2f53fee15f29b056$export$6604985e6d1fe2a3 = /*#__PURE__*/ function(PaymentCardBrand) {
    /** American Express card brand. */ PaymentCardBrand["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
    /** Dankort card brand. */ PaymentCardBrand["DANKORT"] = "DANKORT";
    /** Diners card brand. */ PaymentCardBrand["DINERS"] = "DINERS";
    /** Discover card brand. */ PaymentCardBrand["DISCOVER"] = "DISCOVER";
    /** Electron card brand. */ PaymentCardBrand["ELECTRON"] = "ELECTRON";
    /** JCB card brand. */ PaymentCardBrand["JCB"] = "JCB";
    /** Maestro card brand. */ PaymentCardBrand["MAESTRO"] = "MAESTRO";
    /** Mastercard card brand. */ PaymentCardBrand["MASTERCARD"] = "MASTERCARD";
    /** Payment card brand. */ PaymentCardBrand["PAYMENT"] = "PAYMENT";
    /** Union Pay card brand. */ PaymentCardBrand["UNION_PAY"] = "UNION_PAY";
    /** Visa card brand. */ PaymentCardBrand["VISA"] = "VISA";
    return PaymentCardBrand;
}({});
var $2f53fee15f29b056$export$482948f43506873f = /*#__PURE__*/ function(PaymentCardChargebackCreditStatus) {
    /** A chargeback credit has not been issued. */ PaymentCardChargebackCreditStatus["CREDIT_NOT_ISSUED"] = "CREDIT_NOT_ISSUED";
    /** The chargeback credit has been partially awarded following the partial win of the chargeback. */ PaymentCardChargebackCreditStatus["CREDIT_PARTIALLY_WON"] = "CREDIT_PARTIALLY_WON";
    /** The chargeback credit is pending partial award following the partial win of the chargeback. */ PaymentCardChargebackCreditStatus["CREDIT_PENDING_PARTIAL_WIN"] = "CREDIT_PENDING_PARTIAL_WIN";
    /** The chargeback credit is pending award following the win of the chargeback. */ PaymentCardChargebackCreditStatus["CREDIT_PENDING_WIN"] = "CREDIT_PENDING_WIN";
    /** The chargeback credit has been awarded following the win of the chargeback. */ PaymentCardChargebackCreditStatus["CREDIT_WON"] = "CREDIT_WON";
    /** The Provisional Credit for the chargeback has been issued. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_ISSUED"] = "PROVISIONAL_CREDIT_ISSUED";
    /** The Provisional Credit for the chargeback has been partially awarded following the partial win of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_PARTIALLY_WON"] = "PROVISIONAL_CREDIT_PARTIALLY_WON";
    /** The chargeback provisional credit is pending issued. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_PENDING_ISSUE"] = "PROVISIONAL_CREDIT_PENDING_ISSUE";
    /** The Provisional Credit for the chargeback is pending partial award following the partial win of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN"] = "PROVISIONAL_CREDIT_PENDING_PARTIAL_WIN";
    /** The Provisional Credit for the chargeback is pending revocation following the loss of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_PENDING_REVOCATION"] = "PROVISIONAL_CREDIT_PENDING_REVOCATION";
    /** The Provisional Credit for the chargeback is pending award following the win of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_PENDING_WIN"] = "PROVISIONAL_CREDIT_PENDING_WIN";
    /** The Provisional Credit for the chargeback has been revoked following the loss of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_REVOKED"] = "PROVISIONAL_CREDIT_REVOKED";
    /** The Provisional Credit for the chargeback has been awarded following the win of the chargeback. */ PaymentCardChargebackCreditStatus["PROVISIONAL_CREDIT_WON"] = "PROVISIONAL_CREDIT_WON";
    return PaymentCardChargebackCreditStatus;
}({});
var $2f53fee15f29b056$export$5bcfe2de5626eb5a = /*#__PURE__*/ function(PaymentCardChargebackNetworkReasonCode) {
    /** The issuing bank can’t find an account with the number used. */ PaymentCardChargebackNetworkReasonCode["ACCOUNT_NUMBER_NOT_ON_FILE"] = "ACCOUNT_NUMBER_NOT_ON_FILE";
    /** A Cardholder Dispute for Dual Message System transactions and Mainland China domestic transactions. */ PaymentCardChargebackNetworkReasonCode["AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM"] = "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM";
    /** Cardholder claims the merchant continued to bill the card after a recurring transaction was cancelled, or without explicit consent from the cardholder. */ PaymentCardChargebackNetworkReasonCode["CANCELLED_RECURRING_TRANSACTION"] = "CANCELLED_RECURRING_TRANSACTION";
    /** A Cardholder Dispute. */ PaymentCardChargebackNetworkReasonCode["CARDHOLDER_DISPUTE"] = "CARDHOLDER_DISPUTE";
    /** A Cardholder Dispute, not elsewhere classified (U.S. Region Only). */ PaymentCardChargebackNetworkReasonCode["CARDHOLDER_DISPUTE_US_ONLY"] = "CARDHOLDER_DISPUTE_US_ONLY";
    /** A fraudulent transaction was processed using a counterfeit EMV chip card, but the chip was not used, which allowed fraud. */ PaymentCardChargebackNetworkReasonCode["CHIP_LIABILITY_SHIFT"] = "CHIP_LIABILITY_SHIFT";
    /** A fraudulent transaction was processed using a lost, stolen, or never received EMV chip card, but the chip was not used, which allowed the fraud. */ PaymentCardChargebackNetworkReasonCode["CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN"] = "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN";
    /** The transaction was not deposited within 30 days of the date a valid authorization code was obtained. */ PaymentCardChargebackNetworkReasonCode["CHIP_READ_POS_LATE_PRESENTMENT"] = "CHIP_READ_POS_LATE_PRESENTMENT";
    /** The Cardholder did not receive an expected credit. */ PaymentCardChargebackNetworkReasonCode["CREDIT_NOT_PROCESSED"] = "CREDIT_NOT_PROCESSED";
    /** The Cardholder contacted the issuer claiming a travel service has not, or will not, be provided, and the merchant is seeking protection from creditors, insolvent, bankrupt or in liquidation. */ PaymentCardChargebackNetworkReasonCode["DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE"] = "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE";
    /** The merchant failed to provide adequate currency information or properly process a credit. */ PaymentCardChargebackNetworkReasonCode["INCORRECT_CURRENCY"] = "INCORRECT_CURRENCY";
    /** The merchant failed to provide adequate currency information or properly process a credit or processed a transaction using the wrong transaction code. */ PaymentCardChargebackNetworkReasonCode["INCORRECT_CURRENCY_OR_TRANSACTION_CODE"] = "INCORRECT_CURRENCY_OR_TRANSACTION_CODE";
    /** The amount the Cardholder was charged doesn’t match what’s on the receipt. */ PaymentCardChargebackNetworkReasonCode["INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER"] = "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER";
    /** the merchant processed a transaction using the wrong transaction code. */ PaymentCardChargebackNetworkReasonCode["INCORRECT_TRANSACTION_CODE"] = "INCORRECT_TRANSACTION_CODE";
    /** The Cardholder claims an installment charge made to their account was incorrect. */ PaymentCardChargebackNetworkReasonCode["INSTALLMENT_BILLING_DISPUTE"] = "INSTALLMENT_BILLING_DISPUTE";
    /** The transaction was not deposited within 30 days of the date a valid authorization code was obtained. */ PaymentCardChargebackNetworkReasonCode["LATE_PRESENTMENT"] = "LATE_PRESENTMENT";
    /** A Cardholder Dispute with non-receipt of cash at an ATM. */ PaymentCardChargebackNetworkReasonCode["NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM"] = "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM";
    /** The cardholder claims the merchandise received (or service provided) differs greatly from the description provided at the time of purchase. */ PaymentCardChargebackNetworkReasonCode["NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE"] = "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE";
    /** A Cardholder is claiming that they did not authorize or participate in a card-not-present transaction, and therefore it must be fraudulent. */ PaymentCardChargebackNetworkReasonCode["NOT_AUTHORIZED_CARD_ABSENT"] = "NOT_AUTHORIZED_CARD_ABSENT";
    /** A Cardholder disputes a credit card charge made in a card-not-present environment. */ PaymentCardChargebackNetworkReasonCode["NOT_AUTHORIZED_CARD_PRESENT"] = "NOT_AUTHORIZED_CARD_PRESENT";
    /** The Cardholder claims he or she did not authorize the transaction. */ PaymentCardChargebackNetworkReasonCode["NO_AUTHORIZATION"] = "NO_AUTHORIZATION";
    /**
   * The Cardholder claims to have been charged a no-show fee when they cancelled with a hotel participating in the Mastercard Guaranteed Reservation Service
   * or this is a ATM dispute.
   */ PaymentCardChargebackNetworkReasonCode["NO_SHOW_ADDENDUM_OR_ATM_DISPUTE"] = "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE";
    /** A single transaction was processed more than one time. */ PaymentCardChargebackNetworkReasonCode["POINT_OF_INTERACTION_ERRORS"] = "POINT_OF_INTERACTION_ERRORS";
    /** This transaction violates Mastercard’s rules or the merchant was on a Mastercard security list. */ PaymentCardChargebackNetworkReasonCode["QUESTIONABLE_MERCHANT_ACTIVITY"] = "QUESTIONABLE_MERCHANT_ACTIVITY";
    /** The product never arrived, or the service wasn’t completed. */ PaymentCardChargebackNetworkReasonCode["SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED"] = "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED";
    /** Issuer is unable to verify that an authorization code was obtained at the time of the transaction. */ PaymentCardChargebackNetworkReasonCode["WARNING_BULLETIN_FILE"] = "WARNING_BULLETIN_FILE";
    return PaymentCardChargebackNetworkReasonCode;
}({});
var $2f53fee15f29b056$export$99693bfdbab26ae9 = /*#__PURE__*/ function(PaymentCardChargebackStatus) {
    /** The chargeback has been cancelled. */ PaymentCardChargebackStatus["CANCELLED"] = "CANCELLED";
    /** The chargeback has been lost. */ PaymentCardChargebackStatus["LOST"] = "LOST";
    /** The chargeback is partially won. */ PaymentCardChargebackStatus["PARTIALLY_WON"] = "PARTIALLY_WON";
    /** The chargeback has been received by the network. */ PaymentCardChargebackStatus["RECEIVED"] = "RECEIVED";
    /** The chargeback has been rejected. */ PaymentCardChargebackStatus["REJECTED"] = "REJECTED";
    /** The chargeback has been resolved by the network. */ PaymentCardChargebackStatus["RESOLVED"] = "RESOLVED";
    /** The chargeback has been submitted to the network. */ PaymentCardChargebackStatus["SUBMITTED"] = "SUBMITTED";
    /** The chargeback has been won. */ PaymentCardChargebackStatus["WON"] = "WON";
    return PaymentCardChargebackStatus;
}({});
var $2f53fee15f29b056$export$bb6df256939ebfd8 = /*#__PURE__*/ function(PaymentCardClientTokenPermission) {
    /** Setting this permission allow initiating and managing of a card fulfillment. */ PaymentCardClientTokenPermission["MANAGE_CARD_FULFILLMENT"] = "MANAGE_CARD_FULFILLMENT";
    /** Setting this permission will allow managing states for a Payment Card. */ PaymentCardClientTokenPermission["MANAGE_PAYMENT_CARD"] = "MANAGE_PAYMENT_CARD";
    /**
   * Read the card fulfillment details.
   *
   * Setting this permission will allow querying for fulfillment details.
   */ PaymentCardClientTokenPermission["READ_FULFILLMENT_DETAILS"] = "READ_FULFILLMENT_DETAILS";
    /**
   * Read `number` and `cvv` for Payment Card.
   *
   * Setting this permission will allow using the token to query for a Payment Card and read its `restrictedDetails` property.
   */ PaymentCardClientTokenPermission["READ_RESTRICTED_DETAILS"] = "READ_RESTRICTED_DETAILS";
    /** Setting this permission will allow using the token to set the PIN number for a Payment Card. */ PaymentCardClientTokenPermission["SET_PAYMENT_CARD_PIN"] = "SET_PAYMENT_CARD_PIN";
    return PaymentCardClientTokenPermission;
}({});
var $2f53fee15f29b056$export$f265d46538829773 = /*#__PURE__*/ function(PaymentCardDigitalWalletDeviceType) {
    /** A Mobile Device. Examples include an iPhone, Samsung Galaxy, or Google Pixel. */ PaymentCardDigitalWalletDeviceType["MOBILE"] = "MOBILE";
    /** A wireless, portable personal computer with a touchscreen interface. Examples include an iPad, Samsung Galaxy Tablet, or Amazon Fire HD. */ PaymentCardDigitalWalletDeviceType["TABLET"] = "TABLET";
    /** A Digital Watch. Examples include an iWatch, Samsung Galaxy Watch4, or Fitbit. */ PaymentCardDigitalWalletDeviceType["WATCH"] = "WATCH";
    return PaymentCardDigitalWalletDeviceType;
}({});
var $2f53fee15f29b056$export$41c31e8745d8d37a = /*#__PURE__*/ function(PaymentCardDisputeCategoryType) {
    /** The Program attempted to collect money that the Account Holder has spent (e.g. clearing transaction without an authorization). */ PaymentCardDisputeCategoryType["AUTHORIZATION"] = "AUTHORIZATION";
    /** The Account Holder claims they did not receive the goods and services they paid for from the Merchant. */ PaymentCardDisputeCategoryType["CUSTOMER_DISPUTE"] = "CUSTOMER_DISPUTE";
    /** The Account Holder has claimed a transaction to be fraudulent on their Account. */ PaymentCardDisputeCategoryType["FRAUD"] = "FRAUD";
    /**
   * The Account Holder claims they did not receive the goods and services they paid for from the Merchant.
   * @deprecated Use CUSTOMER_DISPUTE instead.
   */ PaymentCardDisputeCategoryType["MERCHANT_DISPUTE"] = "MERCHANT_DISPUTE";
    /** The transaction data is incorrect. */ PaymentCardDisputeCategoryType["PROCESSING_ERROR"] = "PROCESSING_ERROR";
    return PaymentCardDisputeCategoryType;
}({});
var $2f53fee15f29b056$export$2ef702b7c08632ca = /*#__PURE__*/ function(PaymentCardDisputeCreditStatus) {
    /** The dispute credit is issued. */ PaymentCardDisputeCreditStatus["ISSUED"] = "ISSUED";
    /** A dispute credit has not been issued. */ PaymentCardDisputeCreditStatus["NOT_ISSUED"] = "NOT_ISSUED";
    /** The dispute credit is pending issuing. */ PaymentCardDisputeCreditStatus["PENDING_ISSUE"] = "PENDING_ISSUE";
    /** The dispute credit is pending reversal. */ PaymentCardDisputeCreditStatus["PENDING_REVERSAL"] = "PENDING_REVERSAL";
    /** The dispute credit is reversed. */ PaymentCardDisputeCreditStatus["REVERSED"] = "REVERSED";
    return PaymentCardDisputeCreditStatus;
}({});
var $2f53fee15f29b056$export$1dae0259c1d20c4b = /*#__PURE__*/ function(PaymentCardDisputeCustomerClaimType) {
    /** Customer submitted a dispute verbally. */ PaymentCardDisputeCustomerClaimType["VERBAL"] = "VERBAL";
    /** Customer submitted a dispute with written documentation. */ PaymentCardDisputeCustomerClaimType["WRITTEN"] = "WRITTEN";
    return PaymentCardDisputeCustomerClaimType;
}({});
var $2f53fee15f29b056$export$8348a6ae8f4ce64 = /*#__PURE__*/ function(PaymentCardDisputeLiability) {
    /** The Issuer is liable for the dispute. */ PaymentCardDisputeLiability["ISSUER_LIABLE"] = "ISSUER_LIABLE";
    /** The Merchant is liable for the dispute. */ PaymentCardDisputeLiability["MERCHANT_LIABLE"] = "MERCHANT_LIABLE";
    return PaymentCardDisputeLiability;
}({});
var $2f53fee15f29b056$export$9e3055807f6f1049 = /*#__PURE__*/ function(PaymentCardDisputeStatus) {
    /** The dispute has been cancelled. */ PaymentCardDisputeStatus["CANCELLED"] = "CANCELLED";
    /** The dispute has been initiated. */ PaymentCardDisputeStatus["INITIATED"] = "INITIATED";
    /** The dispute is in progress. */ PaymentCardDisputeStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The dispute has been lost. */ PaymentCardDisputeStatus["LOST"] = "LOST";
    /** The dispute is pending resolution without a chargeback to the network by issuing credit. */ PaymentCardDisputeStatus["PENDING_RESOLUTION"] = "PENDING_RESOLUTION";
    /** The dispute has been rejected. */ PaymentCardDisputeStatus["REJECTED"] = "REJECTED";
    /** The dispute has been resolved without a chargeback to the network by issuing credit. */ PaymentCardDisputeStatus["RESOLVED"] = "RESOLVED";
    /** The dispute has been won. */ PaymentCardDisputeStatus["WON"] = "WON";
    return PaymentCardDisputeStatus;
}({});
var $2f53fee15f29b056$export$f49f369df610d9cf = /*#__PURE__*/ function(PaymentCardEmvType) {
    /** Contact EMV type. */ PaymentCardEmvType["CONTACT"] = "CONTACT";
    /** Contactless EMV type. */ PaymentCardEmvType["CONTACTLESS"] = "CONTACTLESS";
    /** No EMV type configured. */ PaymentCardEmvType["NONE"] = "NONE";
    return PaymentCardEmvType;
}({});
var $2f53fee15f29b056$export$bb5b28a571311ca3 = /*#__PURE__*/ function(PaymentCardGroupOrderStatus) {
    /** Vendor approved the fulfillment request but has not yet shipped. */ PaymentCardGroupOrderStatus["APPROVED"] = "APPROVED";
    /** Group order was canceled by the client. */ PaymentCardGroupOrderStatus["CANCELED"] = "CANCELED";
    /** Group order was created but is not yet ready to ship. */ PaymentCardGroupOrderStatus["NEW"] = "NEW";
    /** Group order is ready to ship but has not yet been sent to the vendor. */ PaymentCardGroupOrderStatus["PENDING"] = "PENDING";
    /** Group order was sent to the vendor but the vendor has not yet approved. */ PaymentCardGroupOrderStatus["SENT_TO_PRINTER"] = "SENT_TO_PRINTER";
    /** The vendor shipped the card to the delivery address. */ PaymentCardGroupOrderStatus["SHIPPED"] = "SHIPPED";
    /** The vendor was not able to ship the card. */ PaymentCardGroupOrderStatus["SHIP_FAILED"] = "SHIP_FAILED";
    return PaymentCardGroupOrderStatus;
}({});
var $2f53fee15f29b056$export$a85dc722a2ea1344 = /*#__PURE__*/ function(PaymentCardNetwork) {
    /** MASTERCARD */ PaymentCardNetwork["MASTERCARD"] = "MASTERCARD";
    /** VISA */ PaymentCardNetwork["VISA"] = "VISA";
    return PaymentCardNetwork;
}({});
var $2f53fee15f29b056$export$bbec69ee255fff8d = /*#__PURE__*/ function(PaymentCardOrderStatus) {
    /** Printer approved the fulfillment request but has not yet shipped. */ PaymentCardOrderStatus["APPROVED"] = "APPROVED";
    /** Fulfillment was canceled by client. */ PaymentCardOrderStatus["CANCELED"] = "CANCELED";
    /** External physical payment card order is complete. */ PaymentCardOrderStatus["COMPLETED"] = "COMPLETED";
    /** Fulfillment was created but not yet sent to printer. */ PaymentCardOrderStatus["NEW"] = "NEW";
    /** Fulfillment was sent to printer but printer has not yet approved. */ PaymentCardOrderStatus["SENT_TO_PRINTER"] = "SENT_TO_PRINTER";
    /** Vendor shipped the card to the delivery address. */ PaymentCardOrderStatus["SHIPPED"] = "SHIPPED";
    /** Printer was not able to ship the card. */ PaymentCardOrderStatus["SHIP_FAILED"] = "SHIP_FAILED";
    return PaymentCardOrderStatus;
}({});
var $2f53fee15f29b056$export$7b9f9ad674c131c1 = /*#__PURE__*/ function(PaymentCardProvisionalCreditStatus) {
    /** The Provisional Credit for is not finalized */ PaymentCardProvisionalCreditStatus["FINALIZATION_FAILED"] = "FINALIZATION_FAILED";
    /** The Provisional Credit for is finalized */ PaymentCardProvisionalCreditStatus["FINALIZED"] = "FINALIZED";
    /** The Provisional Credit for the chargeback has been issued. */ PaymentCardProvisionalCreditStatus["ISSUED"] = "ISSUED";
    /** A chargeback credit has not been issued. */ PaymentCardProvisionalCreditStatus["NOT_ISSUED"] = "NOT_ISSUED";
    /** The chargeback provisional credit is pending finalized. */ PaymentCardProvisionalCreditStatus["PENDING_FINALIZATION"] = "PENDING_FINALIZATION";
    /** The chargeback provisional credit is pending issued. */ PaymentCardProvisionalCreditStatus["PENDING_ISSUE"] = "PENDING_ISSUE";
    return PaymentCardProvisionalCreditStatus;
}({});
var $2f53fee15f29b056$export$f6ca3aa3106e5512 = /*#__PURE__*/ function(PaymentCardShippingMethod) {
    /** FedEx 2 Day. */ PaymentCardShippingMethod["FEDEX_2_DAY"] = "FEDEX_2_DAY";
    /** FedEx Ground. */ PaymentCardShippingMethod["FEDEX_GROUND"] = "FEDEX_GROUND";
    /** FedEx International Priority. */ PaymentCardShippingMethod["FEDEX_INTERNATIONAL_PRIORITY"] = "FEDEX_INTERNATIONAL_PRIORITY";
    /**
   * FedEx One Rate.
   *
   * Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["FEDEX_ONE_RATE"] = "FEDEX_ONE_RATE";
    /**
   * FedEx Standard Overnight.
   *
   * Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["FEDEX_OVERNIGHT"] = "FEDEX_OVERNIGHT";
    /** FedEx Priority Overnight. */ PaymentCardShippingMethod["FEDEX_PRIORITY_OVERNIGHT"] = "FEDEX_PRIORITY_OVERNIGHT";
    /**
   * FedEx 1 Day - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_FEDEX_1_DAY"] = "SAME_DAY_FEDEX_1_DAY";
    /**
   * FedEx Ground - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_FEDEX_GROUND"] = "SAME_DAY_FEDEX_GROUND";
    /**
   * UPS Ground Shipping - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_UPS_GROUND"] = "SAME_DAY_UPS_GROUND";
    /**
   * UPS Next Day Air Shipping - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_UPS_NEXT_DAY"] = "SAME_DAY_UPS_NEXT_DAY";
    /**
   * UPS 2nd Day Air - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_UPS_SECOND_DAY"] = "SAME_DAY_UPS_SECOND_DAY";
    /**
   * USPS Retail Ground ® - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_USPS_GROUND"] = "SAME_DAY_USPS_GROUND";
    /**
   * USPS Priority Mail ® - Processed Same Day.
   *
   * Additional fees apply to Same Day options. Please contact Highnote support to find out if this option is available to your program.
   */ PaymentCardShippingMethod["SAME_DAY_USPS_PRIORITY"] = "SAME_DAY_USPS_PRIORITY";
    /** UPS Ground Shipping. */ PaymentCardShippingMethod["UPS_GROUND"] = "UPS_GROUND";
    /** UPS Next Day Air Shipping. */ PaymentCardShippingMethod["UPS_NEXT_DAY"] = "UPS_NEXT_DAY";
    /** UPS 2nd Day Air. */ PaymentCardShippingMethod["UPS_SECOND_DAY"] = "UPS_SECOND_DAY";
    /**
   * USPS Priority Mail Express ®.
   *
   * USPS Priority Mail Express ®. Includes Signature Confirmation at no extra charge. If you wish to ship your order without signature confirmation, we recommend using a different shipping method.
   */ PaymentCardShippingMethod["USPS_EXPRESS"] = "USPS_EXPRESS";
    /** USPS Retail Ground ®. */ PaymentCardShippingMethod["USPS_GROUND"] = "USPS_GROUND";
    /** USPS Priority Mail ®. */ PaymentCardShippingMethod["USPS_PRIORITY"] = "USPS_PRIORITY";
    return PaymentCardShippingMethod;
}({});
var $2f53fee15f29b056$export$90f1299d92ee2fb = /*#__PURE__*/ function(PaymentCardStatus) {
    /** The Payment Card needs activation before it can be used successfully. */ PaymentCardStatus["ACTIVATION_REQUIRED"] = "ACTIVATION_REQUIRED";
    /** The Payment Card is active and ready for use. */ PaymentCardStatus["ACTIVE"] = "ACTIVE";
    /** The Payment Card has been closed and all future authorizations will fail. */ PaymentCardStatus["CLOSED"] = "CLOSED";
    /** The Payment Card has been suspended and authorizations will fail until the Payment Card is `ACTIVE` again. */ PaymentCardStatus["SUSPENDED"] = "SUSPENDED";
    return PaymentCardStatus;
}({});
var $2f53fee15f29b056$export$e077371ae44be27 = /*#__PURE__*/ function(PaymentCardStatusChangeReason) {
    /** The `PaymentCard` created. */ PaymentCardStatusChangeReason["CREATED"] = "CREATED";
    /** The `PaymentCard` expired. */ PaymentCardStatusChangeReason["EXPIRED"] = "EXPIRED";
    /** The `PaymentCard` was lost. */ PaymentCardStatusChangeReason["LOST"] = "LOST";
    /** The `PaymentCard` state was changed for another reason. */ PaymentCardStatusChangeReason["OTHER"] = "OTHER";
    /** The `PaymentCard` was stolen. */ PaymentCardStatusChangeReason["STOLEN"] = "STOLEN";
    /** The `PaymentCard` state was changed for unknown reason. */ PaymentCardStatusChangeReason["UNSPECIFIED"] = "UNSPECIFIED";
    return PaymentCardStatusChangeReason;
}({});
var $2f53fee15f29b056$export$26e20fc38995c129 = /*#__PURE__*/ function(PaymentCardSuspensionFlag) {
    /** The `PaymentCard` has been suspended by the issuer i.e. Highnote. This suspension can only be lifed by the issuer i.e. Highnote. */ PaymentCardSuspensionFlag["ISSUER_INITIATED_SUSPENSION"] = "ISSUER_INITIATED_SUSPENSION";
    /** The `PaymentCard` has been suspended by Highnote customer or account holder. This suspension can be lifted by Highnote customer or account holder. */ PaymentCardSuspensionFlag["PROGRAM_OWNER_INITIATED_SUSPENSION"] = "PROGRAM_OWNER_INITIATED_SUSPENSION";
    return PaymentCardSuspensionFlag;
}({});
var $2f53fee15f29b056$export$d71e7d4a9411eb27 = /*#__PURE__*/ function(PaymentCreditTransactionRefundReason) {
    /** The transaction was refunded at the behest of the customer. */ PaymentCreditTransactionRefundReason["CUSTOMER_REQUESTED"] = "CUSTOMER_REQUESTED";
    /** The transaction was refunded since it was a duplicate of a previous transaction. */ PaymentCreditTransactionRefundReason["DUPLICATE_TRANSACTION"] = "DUPLICATE_TRANSACTION";
    /** The transaction was refunded due the determination that the payment was fraudulent. */ PaymentCreditTransactionRefundReason["FRAUD"] = "FRAUD";
    /** The transaction was refunded as the payment was directed to the wrong recipient. */ PaymentCreditTransactionRefundReason["INCORRECT_RECIPIENT"] = "INCORRECT_RECIPIENT";
    /** The transaction was refunded for another reason. */ PaymentCreditTransactionRefundReason["OTHER"] = "OTHER";
    return PaymentCreditTransactionRefundReason;
}({});
var $2f53fee15f29b056$export$34b52ce9cfcb0a39 = /*#__PURE__*/ function(PaymentMethod) {
    /** Pay by credit or debit card */ PaymentMethod["CARD"] = "CARD";
    return PaymentMethod;
}({});
var $2f53fee15f29b056$export$6d5483baf79ae433 = /*#__PURE__*/ function(PaymentMethodTokenUsage) {
    /** This `PaymentMethodToken` can be used multiple times. */ PaymentMethodTokenUsage["REUSABLE"] = "REUSABLE";
    /** This `PaymentMethodToken` can only be used once and then becomes invalid. */ PaymentMethodTokenUsage["SINGLE_USE"] = "SINGLE_USE";
    return PaymentMethodTokenUsage;
}({});
var $2f53fee15f29b056$export$b4560687faa076cb = /*#__PURE__*/ function(PaymentMethodType) {
    /** Payment card based payment method. */ PaymentMethodType["PAYMENT_CARD"] = "PAYMENT_CARD";
    return PaymentMethodType;
}({});
var $2f53fee15f29b056$export$220bf455ddc912aa = /*#__PURE__*/ function(PaymentTransactionAccountNameVerificationResponseCode) {
    /** The name does match the processor's records. */ PaymentTransactionAccountNameVerificationResponseCode["MATCHED"] = "MATCHED";
    /** The name verification was not applicable for this transaction. */ PaymentTransactionAccountNameVerificationResponseCode["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** The name does not match the processor's records. */ PaymentTransactionAccountNameVerificationResponseCode["NOT_MATCHED"] = "NOT_MATCHED";
    /** The name was not provided for verification. */ PaymentTransactionAccountNameVerificationResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The name partially matches the processor's records. */ PaymentTransactionAccountNameVerificationResponseCode["PARTIALLY_MATCHED"] = "PARTIALLY_MATCHED";
    return PaymentTransactionAccountNameVerificationResponseCode;
}({});
var $2f53fee15f29b056$export$e3e366434fcdd3db = /*#__PURE__*/ function(PaymentTransactionAddressCodeResponseCode) {
    /** The address does match the processor's records. */ PaymentTransactionAddressCodeResponseCode["MATCHED"] = "MATCHED";
    /** The address does not match the processor's records. */ PaymentTransactionAddressCodeResponseCode["NOT_MATCHED"] = "NOT_MATCHED";
    /** The address was not provided at the time of the transaction. */ PaymentTransactionAddressCodeResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The address check was not verified by the processor. */ PaymentTransactionAddressCodeResponseCode["NOT_VERIFIED"] = "NOT_VERIFIED";
    /** The check was requested to be skipped in the API. */ PaymentTransactionAddressCodeResponseCode["SKIPPED"] = "SKIPPED";
    /** The address was provided but the processor was unable to verify it. */ PaymentTransactionAddressCodeResponseCode["UNKNOWN"] = "UNKNOWN";
    return PaymentTransactionAddressCodeResponseCode;
}({});
var $2f53fee15f29b056$export$9e9b92a5cc1c92a9 = /*#__PURE__*/ function(PaymentTransactionLifecycleStepStatus) {
    /** The step has completed. No further events are expected for this step. */ PaymentTransactionLifecycleStepStatus["COMPLETED"] = "COMPLETED";
    /** The step has been declined. An event has returned for this step that prevents the step from continuing. */ PaymentTransactionLifecycleStepStatus["DECLINED"] = "DECLINED";
    /** The step has not completed yet. Further events are expected for this step. */ PaymentTransactionLifecycleStepStatus["PENDING"] = "PENDING";
    /** The step status does not match any of the other statuses. */ PaymentTransactionLifecycleStepStatus["UNKNOWN"] = "UNKNOWN";
    return PaymentTransactionLifecycleStepStatus;
}({});
var $2f53fee15f29b056$export$7d0f66c351c5959f = /*#__PURE__*/ function(PaymentTransactionPostalCodeResponseCode) {
    /** The postal code does match the processor's records. */ PaymentTransactionPostalCodeResponseCode["MATCHED"] = "MATCHED";
    /** The postal code does not match the processor's records. */ PaymentTransactionPostalCodeResponseCode["NOT_MATCHED"] = "NOT_MATCHED";
    /** The postal code was not provided at the time of the transaction. */ PaymentTransactionPostalCodeResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The postal code check was not verified by the processor. */ PaymentTransactionPostalCodeResponseCode["NOT_VERIFIED"] = "NOT_VERIFIED";
    /** The check was requested to be skipped in the API. */ PaymentTransactionPostalCodeResponseCode["SKIPPED"] = "SKIPPED";
    /** The postal code was provided but the processor was unable to verify it. */ PaymentTransactionPostalCodeResponseCode["UNKNOWN"] = "UNKNOWN";
    return PaymentTransactionPostalCodeResponseCode;
}({});
var $2f53fee15f29b056$export$a3ad86e42ac03eb4 = /*#__PURE__*/ function(PaymentTransactionResponseCodeProcessorResponseCode) {
    /** The authorization was approved. */ PaymentTransactionResponseCodeProcessorResponseCode["APPROVED"] = "APPROVED";
    /** The authorization was declined due to an incorrect CVC3 or DCVV. */ PaymentTransactionResponseCodeProcessorResponseCode["BAD_CVC3_DCVV"] = "BAD_CVC3_DCVV";
    /** The authorization was declined due to a security code mismatch. */ PaymentTransactionResponseCodeProcessorResponseCode["BAD_CVV"] = "BAD_CVV";
    /** The authorization was declined due to a security code mismatch. */ PaymentTransactionResponseCodeProcessorResponseCode["BAD_CVV2"] = "BAD_CVV2";
    /** The authorization was declined due to the card being blocked from transacting. */ PaymentTransactionResponseCodeProcessorResponseCode["BLOCKED_CARD"] = "BLOCKED_CARD";
    /** The authorization was declined due to a chip card ARQC validation failure. */ PaymentTransactionResponseCodeProcessorResponseCode["CHIP_CARD_ARQC_VALIDATION_FAILURE"] = "CHIP_CARD_ARQC_VALIDATION_FAILURE";
    /** The authorization was declined due to the card being closed. */ PaymentTransactionResponseCodeProcessorResponseCode["CLOSED_ACCOUNT"] = "CLOSED_ACCOUNT";
    /**
   * The authorization was declined. The customer should contact their
   * bank for more information on the decline.
   */ PaymentTransactionResponseCodeProcessorResponseCode["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    /** The authorization was declined due to the approval amount being over the limit. */ PaymentTransactionResponseCodeProcessorResponseCode["EXCEEDS_APPROVAL_AMOUNT_LIMIT"] = "EXCEEDS_APPROVAL_AMOUNT_LIMIT";
    /** The authorization was declined because number of transaction exceeded the issuer or approved limit over a set period of time. */ PaymentTransactionResponseCodeProcessorResponseCode["EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT"] = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT";
    /** The authorization was declined due to the card being expired. */ PaymentTransactionResponseCodeProcessorResponseCode["EXPIRED_CARD"] = "EXPIRED_CARD";
    /** The authorization was declined due to the card being inactive. */ PaymentTransactionResponseCodeProcessorResponseCode["INACTIVE_CARD"] = "INACTIVE_CARD";
    /** The authorization was declined due to an incorrect expiration date. */ PaymentTransactionResponseCodeProcessorResponseCode["INCORRECT_EXPIRATION_DATE"] = "INCORRECT_EXPIRATION_DATE";
    /** The authorization was declined because instant network pull capability is not enabled. */ PaymentTransactionResponseCodeProcessorResponseCode["INSTANT_NETWORK_PULL_CAPABILITY_NOT_ENABLED"] = "INSTANT_NETWORK_PULL_CAPABILITY_NOT_ENABLED";
    /** The authorization was declined because instant network push capability is not enabled. */ PaymentTransactionResponseCodeProcessorResponseCode["INSTANT_NETWORK_PUSH_CAPABILITY_NOT_ENABLED"] = "INSTANT_NETWORK_PUSH_CAPABILITY_NOT_ENABLED";
    /** The authorization was declined due to the insufficient funds in the account. */ PaymentTransactionResponseCodeProcessorResponseCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The authorization was declined due to the authorization expiration being invalid. */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_AUTHORIZATION_EXPIRATION"] = "INVALID_AUTHORIZATION_EXPIRATION";
    /** The authorization was declined due to the card number being invalid. */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    /** The authorization was declined due to the merchant not being authorized to process the transaction. */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    /** The authorization was declined due to an invalid payment credential. */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_PAYMENT_CREDENTIAL"] = "INVALID_PAYMENT_CREDENTIAL";
    /** The authorization was declined due to invalid track data. */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_TRACK_DATA"] = "INVALID_TRACK_DATA";
    /**
   * The authorization was declined due to incorrect information being provided, or attempting a faulty operation such as refunding a refund.
   * This is a generic catch-all response code for a transaction that cannot be declined under other specific response codes.
   */ PaymentTransactionResponseCodeProcessorResponseCode["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
    /** The authorization was declined because the processor network is not available. */ PaymentTransactionResponseCodeProcessorResponseCode["PROCESSOR_NETWORK_NOT_AVAILABLE"] = "PROCESSOR_NETWORK_NOT_AVAILABLE";
    /** The authorization was declined due to the card being restricted from transacting in this region or country. */ PaymentTransactionResponseCodeProcessorResponseCode["RESTRICTED_LOCATION"] = "RESTRICTED_LOCATION";
    /** The authorization was declined due to the card's address verification failing. */ PaymentTransactionResponseCodeProcessorResponseCode["RE_ENTER_TRANSACTION"] = "RE_ENTER_TRANSACTION";
    /**
   * The authorization was declined because of a special condition on the card.
   * This could be due to the card being temporarily suspended or having an issue with the financial account.
   */ PaymentTransactionResponseCodeProcessorResponseCode["SPECIAL_CONDITION_NO_PICK_UP"] = "SPECIAL_CONDITION_NO_PICK_UP";
    /** The authorization was declined due to the card being suspended. */ PaymentTransactionResponseCodeProcessorResponseCode["SUSPENDED_CARD"] = "SUSPENDED_CARD";
    /** The authorization was declined due to the card being terminated. */ PaymentTransactionResponseCodeProcessorResponseCode["TERMINATED_CARD"] = "TERMINATED_CARD";
    /** The authorization was declined due to the card being restricted. */ PaymentTransactionResponseCodeProcessorResponseCode["TRANSACTION_NOT_PERMITTED"] = "TRANSACTION_NOT_PERMITTED";
    /** The authorization was declined because the transaction type is not supported. */ PaymentTransactionResponseCodeProcessorResponseCode["TRANSACTION_NOT_SUPPORTED"] = "TRANSACTION_NOT_SUPPORTED";
    /** The authorization was declined due to the card not being activiated. */ PaymentTransactionResponseCodeProcessorResponseCode["UNACTIVATED_CARD"] = "UNACTIVATED_CARD";
    /** The authorization response code did not match any of the other codes. */ PaymentTransactionResponseCodeProcessorResponseCode["UNKNOWN"] = "UNKNOWN";
    return PaymentTransactionResponseCodeProcessorResponseCode;
}({});
var $2f53fee15f29b056$export$cebde3cf4516888b = /*#__PURE__*/ function(PaymentTransactionSecurityCodeResponseCode) {
    /** The security code does match the processor's records. */ PaymentTransactionSecurityCodeResponseCode["MATCHED"] = "MATCHED";
    /** The security code does not match the processor's records. */ PaymentTransactionSecurityCodeResponseCode["NOT_MATCHED"] = "NOT_MATCHED";
    /** The security code was not provided at the time of the transaction. */ PaymentTransactionSecurityCodeResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The security code check was not verified by the processor. */ PaymentTransactionSecurityCodeResponseCode["NOT_VERIFIED"] = "NOT_VERIFIED";
    /** The check was requested to be skipped in the API. */ PaymentTransactionSecurityCodeResponseCode["SKIPPED"] = "SKIPPED";
    /** The security code was provided but the processor was unable to verify it. */ PaymentTransactionSecurityCodeResponseCode["UNKNOWN"] = "UNKNOWN";
    return PaymentTransactionSecurityCodeResponseCode;
}({});
var $2f53fee15f29b056$export$c94ee599ab9fd42e = /*#__PURE__*/ function(PaymentTransactionStatus) {
    /** COMPLETED indicates that the `PaymentTransactionLifecycleStep` has finished with required states and disbursed the funds. */ PaymentTransactionStatus["COMPLETED"] = "COMPLETED";
    /** DECLINED indicates that the `PaymentTransaction` was declined. This can happen if the payment method was invalid, or the payment method has insufficient funds. */ PaymentTransactionStatus["DECLINED"] = "DECLINED";
    /** DISPUTED indicates that the `PaymentTransaction` has a dispute. */ PaymentTransactionStatus["DISPUTED"] = "DISPUTED";
    /** PENDING indicates that there are required `PaymentTransactionLifecycleStep`s that have not yet been completed. Once all the required steps are completed, this state will transition. */ PaymentTransactionStatus["PENDING"] = "PENDING";
    /** PENDING_DISPUTE indicates that the `PaymentTransaction` has a pending dispute. */ PaymentTransactionStatus["PENDING_DISPUTE"] = "PENDING_DISPUTE";
    /** REVERSED indicates that all remaining authorized amounts on this `PaymentTransaction` have been reversed. */ PaymentTransactionStatus["REVERSED"] = "REVERSED";
    return PaymentTransactionStatus;
}({});
var $2f53fee15f29b056$export$11996a484805b535 = /*#__PURE__*/ function(PersonAccountHolderClientTokenPermission) {
    /**
   * Read the person account holder information.
   *
   * Setting this permission will allow visibility to the account holder's information.
   */ PersonAccountHolderClientTokenPermission["READ_PERSON_ACCOUNT_HOLDER_DETAILS"] = "READ_PERSON_ACCOUNT_HOLDER_DETAILS";
    return PersonAccountHolderClientTokenPermission;
}({});
var $2f53fee15f29b056$export$66ba8b3e3207874d = /*#__PURE__*/ function(PersonAccountHolderIdentityUpdateType) {
    /** The billing address was modified. */ PersonAccountHolderIdentityUpdateType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    /** The current debt obligations were modified. */ PersonAccountHolderIdentityUpdateType["CURRENT_DEBT_OBLIGATIONS"] = "CURRENT_DEBT_OBLIGATIONS";
    /** The date of birth was modified. */ PersonAccountHolderIdentityUpdateType["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    /** The employment status was modified. */ PersonAccountHolderIdentityUpdateType["EMPLOYMENT_STATUS"] = "EMPLOYMENT_STATUS";
    /** The full legal name was modified. */ PersonAccountHolderIdentityUpdateType["FULL_LEGAL_NAME"] = "FULL_LEGAL_NAME";
    /** The social security number was modified. */ PersonAccountHolderIdentityUpdateType["SOCIAL_SECURITY_NUMBER"] = "SOCIAL_SECURITY_NUMBER";
    /** The total annual income was modified. */ PersonAccountHolderIdentityUpdateType["TOTAL_ANNUAL_INCOME"] = "TOTAL_ANNUAL_INCOME";
    return PersonAccountHolderIdentityUpdateType;
}({});
var $2f53fee15f29b056$export$3125fbd2773f76c7 = /*#__PURE__*/ function(PersonAuthorizedUserClientTokenPermission) {
    /**
   * Read the person authorized user information.
   *
   * Setting this permission will allow visibility to the authorized user's information.
   */ PersonAuthorizedUserClientTokenPermission["READ_PERSON_AUTHORIZED_USER_DETAILS"] = "READ_PERSON_AUTHORIZED_USER_DETAILS";
    return PersonAuthorizedUserClientTokenPermission;
}({});
var $2f53fee15f29b056$export$d99ede31038d7766 = /*#__PURE__*/ function(PhoneLabel) {
    /** The phone number is attached to a residence. */ PhoneLabel["HOME"] = "HOME";
    /** The phone number is attached to a mobile or cellular device. */ PhoneLabel["MOBILE"] = "MOBILE";
    /** The phone number represents a support number */ PhoneLabel["SUPPORT"] = "SUPPORT";
    /** The phone number is attached to a place of business. */ PhoneLabel["WORK"] = "WORK";
    return PhoneLabel;
}({});
var $2f53fee15f29b056$export$867702041ab3df7c = /*#__PURE__*/ function(PhysicalCardMaterial) {
    /** Metal */ PhysicalCardMaterial["METAL"] = "METAL";
    /** Plastic */ PhysicalCardMaterial["PLASTIC"] = "PLASTIC";
    return PhysicalCardMaterial;
}({});
var $2f53fee15f29b056$export$3aca89417fa619bf = /*#__PURE__*/ function(PhysicalCardPersonalizationFormat) {
    /** Embossed */ PhysicalCardPersonalizationFormat["EMBOSSED"] = "EMBOSSED";
    /** Printed */ PhysicalCardPersonalizationFormat["PRINTED"] = "PRINTED";
    return PhysicalCardPersonalizationFormat;
}({});
var $2f53fee15f29b056$export$82b55f5e04a35d6d = /*#__PURE__*/ function(PhysicalCardPersonalizationLineType) {
    /** The physical card profile is track has default Cardholder Name */ PhysicalCardPersonalizationLineType["ACCOUNT_HOLDER_NAME"] = "ACCOUNT_HOLDER_NAME";
    /** The physical card profile is track has default Business Name */ PhysicalCardPersonalizationLineType["BUSINESS_NAME"] = "BUSINESS_NAME";
    /** The physical card profile track has Custom Name */ PhysicalCardPersonalizationLineType["CUSTOM"] = "CUSTOM";
    return PhysicalCardPersonalizationLineType;
}({});
var $2f53fee15f29b056$export$dc6258e797c0fea = /*#__PURE__*/ function(PhysicalCardType) {
    /** Contactless Only */ PhysicalCardType["CONTACTLESS_ONLY"] = "CONTACTLESS_ONLY";
    /** EMV Chip Contactless */ PhysicalCardType["EMV_CHIP_CONTACTLESS"] = "EMV_CHIP_CONTACTLESS";
    /** EMV Chip Contact Only */ PhysicalCardType["EMV_CHIP_CONTACT_ONLY"] = "EMV_CHIP_CONTACT_ONLY";
    /** Magnetic Stripe Only */ PhysicalCardType["MAGNETIC_STRIPE_ONLY"] = "MAGNETIC_STRIPE_ONLY";
    return PhysicalCardType;
}({});
var $2f53fee15f29b056$export$54645fbe5f3b1496 = /*#__PURE__*/ function(PhysicalCardVendorName) {
    /** ARROW_EYE */ PhysicalCardVendorName["ARROW_EYE"] = "ARROW_EYE";
    /** DIGISEQ */ PhysicalCardVendorName["DIGISEQ"] = "DIGISEQ";
    /** TAG */ PhysicalCardVendorName["TAG"] = "TAG";
    return PhysicalCardVendorName;
}({});
var $2f53fee15f29b056$export$39c0066fdcfd476e = /*#__PURE__*/ function(PinEntryMode) {
    /** No PIN entry capability */ PinEntryMode["NO_PIN_ENTRY_CAPABILITY"] = "NO_PIN_ENTRY_CAPABILITY";
    /** PIN entry capability */ PinEntryMode["PIN_ENTRY_CAPABILITY"] = "PIN_ENTRY_CAPABILITY";
    /** PIN pad inoperative */ PinEntryMode["PIN_PAD_INOPERATIVE"] = "PIN_PAD_INOPERATIVE";
    /** PIN verified by terminal device */ PinEntryMode["PIN_VERIFIED_BY_TERMINAL_DEVICE"] = "PIN_VERIFIED_BY_TERMINAL_DEVICE";
    /** Reserved for ISO, national, or private use */ PinEntryMode["RESERVED"] = "RESERVED";
    return PinEntryMode;
}({});
var $2f53fee15f29b056$export$ac6c3f61394f6151 = /*#__PURE__*/ function(PinResponseCode) {
    /** PIN Validation failed due to temporary network connectivity issues. */ PinResponseCode["DECRYPTION_ISSUE"] = "DECRYPTION_ISSUE";
    /** The cardholder-provided PIN was correct. */ PinResponseCode["MATCH"] = "MATCH";
    /** PIN validation not performed since transaction was declined for another reason. */ PinResponseCode["NOT_PERFORMED"] = "NOT_PERFORMED";
    /** The cardholder did not enter a PIN. */ PinResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The cardholder-provided PIN was incorrect. */ PinResponseCode["NO_MATCH"] = "NO_MATCH";
    return PinResponseCode;
}({});
var $2f53fee15f29b056$export$2a1770396fde2c9a = /*#__PURE__*/ function(PointOfServiceCategory) {
    /** A terminal used for administrative purposes. */ PointOfServiceCategory["ADMINISTRATIVE_TERMINAL"] = "ADMINISTRATIVE_TERMINAL";
    /** The initial step in a card payment which defines whether the card payment may continue. */ PointOfServiceCategory["AUTHORIZATION"] = "AUTHORIZATION";
    /** A terminal used for self-service fuel purchases. */ PointOfServiceCategory["AUTOMATED_FUEL_DISPENSER"] = "AUTOMATED_FUEL_DISPENSER";
    /** A machine that dispenses cash or performs other banking services. */ PointOfServiceCategory["AUTOMATED_TELLER_MACHINE"] = "AUTOMATED_TELLER_MACHINE";
    /** A terminal which produces or processes coupons. */ PointOfServiceCategory["COUPON_MACHINE"] = "COUPON_MACHINE";
    /** A terminal that processes payment card transactions over a standard phone line. */ PointOfServiceCategory["DIAL_TERMINAL"] = "DIAL_TERMINAL";
    /** A commercial transaction conducted electronically online. */ PointOfServiceCategory["ECOMMERCE"] = "ECOMMERCE";
    /** A device used to process cash and payment card transactions. */ PointOfServiceCategory["ELECTRONIC_CASH_REGISTER"] = "ELECTRONIC_CASH_REGISTER";
    /** A device used by franchised financial instititions' bank branches to handle with customer transactions. */ PointOfServiceCategory["FRANCHISE_TELLER"] = "FRANCHISE_TELLER";
    /** A terminal used at a home rather than a business location. */ PointOfServiceCategory["HOME_TERMINAL"] = "HOME_TERMINAL";
    /** A television that accepts input from account holders for card payments. */ PointOfServiceCategory["INTERACTIVE_TELEVISION"] = "INTERACTIVE_TELEVISION";
    /** A device used to convert an electronic check for deposits. */ PointOfServiceCategory["MICR_TERMINAL"] = "MICR_TERMINAL";
    /** A mobile devices utilized to process card payments (Mobile Point of Sale). */ PointOfServiceCategory["MPOS"] = "MPOS";
    /** A transaction in which funds are transferred for goods and/or services. */ PointOfServiceCategory["PAYMENT"] = "PAYMENT";
    /** A terminal utilized for general banking processing such as ATM withdrawals. */ PointOfServiceCategory["PERSONAL_BANKING"] = "PERSONAL_BANKING";
    /** A mobile device utilized for a variety of functions including card payments. */ PointOfServiceCategory["PERSONAL_DIGITAL_ASSISTANCE"] = "PERSONAL_DIGITAL_ASSISTANCE";
    /** A device presented at a teller where an account holder inserts their card for verification and authorization. */ PointOfServiceCategory["POINT_OF_BANKING_TERMINAL"] = "POINT_OF_BANKING_TERMINAL";
    /** A terminal used for making a sale. */ PointOfServiceCategory["POS_TERMINAL"] = "POS_TERMINAL";
    /** A terminal used by a public utility to process card payments. */ PointOfServiceCategory["PUBLIC_UTILITY"] = "PUBLIC_UTILITY";
    /** A phone with a digital display. */ PointOfServiceCategory["SCREEN_PHONE"] = "SCREEN_PHONE";
    /** A terminal which produces or processes scrips. */ PointOfServiceCategory["SCRIP_MACHINE"] = "SCRIP_MACHINE";
    /** A terminal operated by the account holder to process a card payment. */ PointOfServiceCategory["SELF_SERVICE"] = "SELF_SERVICE";
    /** A mobile phone that performs many functions of a personal computer. */ PointOfServiceCategory["SMART_PHONE"] = "SMART_PHONE";
    /** A device that provides telephone functions. */ PointOfServiceCategory["TELEPHONE_DEVICE"] = "TELEPHONE_DEVICE";
    /** A device used by financial instititions' bank branches to handle with customer transactions. */ PointOfServiceCategory["TELLER"] = "TELLER";
    /** A terminal which produces or processes tickets. */ PointOfServiceCategory["TICKET_MACHINE"] = "TICKET_MACHINE";
    /** A terminal that processes travelers' checks. */ PointOfServiceCategory["TRAVELERS_CHECK_MACHINE"] = "TRAVELERS_CHECK_MACHINE";
    /** A terminal activated by an account holder for a card payment that requires authorization. */ PointOfServiceCategory["UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED"] = "UNATTENDED_CARDHOLDER_ACTIVATED_AUTHORIZED";
    /** A terminal activated by an account holder for a card payment that does not require authorization. */ PointOfServiceCategory["UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION"] = "UNATTENDED_CARDHOLDER_ACTIVATED_NO_AUTHORIZATION";
    /** A terminal used for unattended chip and PIN transactions. */ PointOfServiceCategory["UNATTENDED_CHIP_PIN_TERMINAL"] = "UNATTENDED_CHIP_PIN_TERMINAL";
    /** A terminal activated by an account holder for a card payment. */ PointOfServiceCategory["UNATTENDED_CUSTOMER_TERMINAL"] = "UNATTENDED_CUSTOMER_TERMINAL";
    /** A machine that dispenses small goods, such as food and drinks. */ PointOfServiceCategory["VENDING"] = "VENDING";
    /** A Voice Response Unit that interacts with account holders. */ PointOfServiceCategory["VRU"] = "VRU";
    return PointOfServiceCategory;
}({});
var $2f53fee15f29b056$export$c9df00082c4dbd49 = /*#__PURE__*/ function(PointOfServiceCategoryCondition) {
    /** A terminal used for administrative purposes. */ PointOfServiceCategoryCondition["ADMINISTRATIVE_TERMINAL"] = "ADMINISTRATIVE_TERMINAL";
    /** A device which allows account holders to pay for their gas and pump it themselves. */ PointOfServiceCategoryCondition["AUTOMATED_FUEL_DISPENSER"] = "AUTOMATED_FUEL_DISPENSER";
    /** A machine that dispenses cash or performs other banking services when an account holder inserts a bank card. */ PointOfServiceCategoryCondition["AUTOMATED_TELLER_MACHINE"] = "AUTOMATED_TELLER_MACHINE";
    /** A commercial transaction conducted electronically on the internet. */ PointOfServiceCategoryCondition["ECOMMERCE"] = "ECOMMERCE";
    /** A device that enables a person employed at franchised financial institition to deal with customers' transactions. */ PointOfServiceCategoryCondition["FRANCHISE_TELLER"] = "FRANCHISE_TELLER";
    /** A device used to convert an electronic check for deposits. */ PointOfServiceCategoryCondition["MICR_TERMINAL"] = "MICR_TERMINAL";
    /** A device presented at a teller where an account holder inserts their card for verification and authorization. */ PointOfServiceCategoryCondition["POINT_OF_BANKING_TERMINAL"] = "POINT_OF_BANKING_TERMINAL";
    /** A terminal used for making a sale. */ PointOfServiceCategoryCondition["POS_TERMINAL"] = "POS_TERMINAL";
    /** A device that enables a person employed at financial institition to deal with customers' transactions. */ PointOfServiceCategoryCondition["TELLER"] = "TELLER";
    /** A machine that dispenses small articles such as food, drinks, or cigarettes when a coin, bill, or token is inserted. */ PointOfServiceCategoryCondition["VENDING"] = "VENDING";
    return PointOfServiceCategoryCondition;
}({});
var $2f53fee15f29b056$export$d77380a1699a4cec = /*#__PURE__*/ function(PostalCodeResponseCode) {
    /** The postal code provided on the authorization matched a postal code on file for the Cardholder. */ PostalCodeResponseCode["MATCH"] = "MATCH";
    /**
   * The postal code was not checked for verification.
   *
   * This typically occurs when a postal code is provided during authorization but we were unable to locate the same value in our vault.
   */ PostalCodeResponseCode["NOT_PERFORMED"] = "NOT_PERFORMED";
    /** The postal code was not provided on the authorization. */ PostalCodeResponseCode["NOT_PROVIDED"] = "NOT_PROVIDED";
    /** The postal code provided on the authorization did not match a postal code on file for the Cardholder. */ PostalCodeResponseCode["NO_MATCH"] = "NO_MATCH";
    /** The 5-digit zip code provided on the authorization matched the zip code on file for the Cardholder. */ PostalCodeResponseCode["ZIP5_MATCH"] = "ZIP5_MATCH";
    /** The 9-digit zip code provided on the authorization matched the zip code on file for the Cardholder. */ PostalCodeResponseCode["ZIP9_MATCH"] = "ZIP9_MATCH";
    return PostalCodeResponseCode;
}({});
var $2f53fee15f29b056$export$62118dbb35cb8215 = /*#__PURE__*/ function(PricingPlanStatus) {
    /** Plan is no longer in use and preserved for historical records. */ PricingPlanStatus["ARCHIVED"] = "ARCHIVED";
    /** Plan is being drafted or modified. Rules can only be changed in this state. */ PricingPlanStatus["DRAFT"] = "DRAFT";
    /** Plan is currently live and applied to transactions. */ PricingPlanStatus["PUBLISHED"] = "PUBLISHED";
    return PricingPlanStatus;
}({});
var $2f53fee15f29b056$export$c6e1eae4765553c5 = /*#__PURE__*/ function(PricingRuleFrequency) {
    /** Rule is evaluated per transaction. */ PricingRuleFrequency["TRANSACTIONAL"] = "TRANSACTIONAL";
    return PricingRuleFrequency;
}({});
var $2f53fee15f29b056$export$8e072be22fa7999b = /*#__PURE__*/ function(PricingRuleTrigger) {
    /** Rule is triggered for batch processing. */ PricingRuleTrigger["BATCH"] = "BATCH";
    /** Rule is triggered for each individual transaction. */ PricingRuleTrigger["TRANSACTION"] = "TRANSACTION";
    return PricingRuleTrigger;
}({});
var $2f53fee15f29b056$export$ff19467342022672 = /*#__PURE__*/ function(ProcessingCapabilityStatus) {
    /** The `CardProcessingCapability` is active. */ ProcessingCapabilityStatus["ACTIVE"] = "ACTIVE";
    /** The `CardProcessingCapability` is deactivated. */ ProcessingCapabilityStatus["DEACTIVATED"] = "DEACTIVATED";
    /** The `CardProcessingCapability` is pending. */ ProcessingCapabilityStatus["PENDING"] = "PENDING";
    /** The `CardProcessingCapability` is rejected. */ ProcessingCapabilityStatus["REJECTED"] = "REJECTED";
    return ProcessingCapabilityStatus;
}({});
var $2f53fee15f29b056$export$81db7db602255559 = /*#__PURE__*/ function(ProductApplicationStatusCode) {
    /** The application was approved. */ ProductApplicationStatusCode["APPROVED"] = "APPROVED";
    /** The application was closed. */ ProductApplicationStatusCode["CLOSED"] = "CLOSED";
    /** The application was denied. */ ProductApplicationStatusCode["DENIED"] = "DENIED";
    /** The application requires further review. */ ProductApplicationStatusCode["IN_REVIEW"] = "IN_REVIEW";
    /** The application is currently being processed. */ ProductApplicationStatusCode["PENDING"] = "PENDING";
    return ProductApplicationStatusCode;
}({});
var $2f53fee15f29b056$export$5720395b91e868da = /*#__PURE__*/ function(ProductApplicationWorkflowStatus) {
    /** The workflow has completed processing */ ProductApplicationWorkflowStatus["COMPLETED"] = "COMPLETED";
    /** The workflow is currently being processed */ ProductApplicationWorkflowStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** The workflow has yet to begin execution */ ProductApplicationWorkflowStatus["PENDING"] = "PENDING";
    return ProductApplicationWorkflowStatus;
}({});
var $2f53fee15f29b056$export$cd659dfb817c814e = /*#__PURE__*/ function(ProductApplicationWorkflowType) {
    /** The workflow that evaluates business rules associated with the application */ ProductApplicationWorkflowType["BUSINESS_RULE_VALIDATION"] = "BUSINESS_RULE_VALIDATION";
    /** The workflow for provisioning a VPA buyer in the Visa system */ ProductApplicationWorkflowType["CREATE_VPA_BUYER"] = "CREATE_VPA_BUYER";
    /** A workflow for performing credit underwriting */ ProductApplicationWorkflowType["CREDIT_UNDERWRITING"] = "CREDIT_UNDERWRITING";
    /** The workflow that performs provisioning actions within the external bank associated with the application */ ProductApplicationWorkflowType["EXTERNAL_BANK_ONBOARDING"] = "EXTERNAL_BANK_ONBOARDING";
    /** A workflow for verifying identity information associated with the application */ ProductApplicationWorkflowType["IDENTITY"] = "IDENTITY";
    /** The workflow for managing offers associated with the application */ ProductApplicationWorkflowType["OFFER_MANAGEMENT"] = "OFFER_MANAGEMENT";
    /** A workflow for performing risk-assesment related activities */ ProductApplicationWorkflowType["RISK"] = "RISK";
    return ProductApplicationWorkflowType;
}({});
var $2f53fee15f29b056$export$976ef6e3f3eb2447 = /*#__PURE__*/ function(ProvisionAccountHolderAction) {
    /** Creates an application for an Account Holder. This action starts the application process. */ ProvisionAccountHolderAction["CREATE_APPLICATION"] = "CREATE_APPLICATION";
    /** Issues an account based on an application. When used in conjunction with `CREATE_APPLICATION`, this action will use the provided `AccountHolderCardProductApplication` to issue the account. */ ProvisionAccountHolderAction["ISSUE_FINANCIAL_ACCOUNT"] = "ISSUE_FINANCIAL_ACCOUNT";
    /** Issues a Payment Card for a `FinancialAccount`. When used with `ISSUE_FINANCIAL_ACCOUNT`, this action will issue the `PaymentCard` to the specified `FinancialAccount` */ ProvisionAccountHolderAction["ISSUE_PAYMENT_CARD"] = "ISSUE_PAYMENT_CARD";
    /** Link verified external bank account with a `FinancialAccount` */ ProvisionAccountHolderAction["LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT"] = "LINK_VERIFIED_EXTERNAL_BANK_ACCOUNT";
    /**
   * Notifies the configured provider that the workflow has been completed. Provider configurations are determined as part of the technical solution.
   *
   * Note: This action will only be executed upon approval of the technical solution.
   */ ProvisionAccountHolderAction["NOTIFY_PROVIDER"] = "NOTIFY_PROVIDER";
    /** Registers the Account Holder with Visa's Payable Automation solution, facilitating integration with Visa's payment systems. */ ProvisionAccountHolderAction["REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT"] = "REGISTER_VISA_PAYABLE_FUNDING_ACCOUNT";
    /** Sets a credit limit on a `FinancialAccount`. When used with `ISSUE_FINANCIAL_ACCOUNT`, this action will apply the credit limit to the specified `FinancialAccount`. */ ProvisionAccountHolderAction["SET_CREDIT_LIMIT"] = "SET_CREDIT_LIMIT";
    return ProvisionAccountHolderAction;
}({});
var $2f53fee15f29b056$export$ac22b23fa68eddf4 = /*#__PURE__*/ function(ProvisionWorkflowProvider) {
    /** Bottom Line: A provider that may offer services related to provisioning, such as payment solutions or account management. */ ProvisionWorkflowProvider["BOTTOM_LINE"] = "BOTTOM_LINE";
    return ProvisionWorkflowProvider;
}({});
var $2f53fee15f29b056$export$8ced6c4bebc1019f = /*#__PURE__*/ function(PseudoBalanceAmountSign) {
    /**
   * Subtracts the specified amount from the current pseudo balance.
   * Decreases the balance (less spending or lower limit).
   */ PseudoBalanceAmountSign["NEGATIVE"] = "NEGATIVE";
    /**
   * Adds the specified amount to the current pseudo balance.
   * Increases the balance (more spending or higher limit).
   */ PseudoBalanceAmountSign["POSITIVE"] = "POSITIVE";
    return PseudoBalanceAmountSign;
}({});
var $2f53fee15f29b056$export$6888e92552b8af4 = /*#__PURE__*/ function(PseudoBalanceCadence) {
    /**
   * Resets daily at the time specified in resetTime.
   * Example: "2000-01-15T08:30:00Z" → resets every day at 8:30 AM UTC
   *
   * Default resetTime would be midnight UTC.
   */ PseudoBalanceCadence["DAILY"] = "DAILY";
    /**
   * Never resets automatically - resetTime is ignored.
   * Manual reset via resetPseudoBalance mutation required.
   *
   * This is the default `PseudoBalanceCadence`.
   *
   * Default resetTime would be undefined, since there is no reset time for LIFETIME.
   */ PseudoBalanceCadence["LIFETIME"] = "LIFETIME";
    /**
   * Resets monthly on the same day-of-month and time as resetTime.
   * Example: "2000-01-15T09:00:00Z" → resets on the 15th of every month at 9:00 AM UTC
   * Note: For months without the specified day (e.g., Feb 30th), resets on the last day of the month
   *
   * Default resetTime would be midnight on the 1st of the month UTC.
   */ PseudoBalanceCadence["MONTHLY"] = "MONTHLY";
    /**
   * Resets every 90 calendar days from the resetTime date and time.
   * Example: "2000-01-15T12:00:00Z" → next reset on "2000-04-14T12:00:00Z" (90 days later)
   *
   * Default resetTime would be midnight on the 91st day UTC.
   */ PseudoBalanceCadence["NINETY_DAYS"] = "NINETY_DAYS";
    /**
   * Resets quarterly (every 3 months) on the same day and time as resetTime.
   * Example: "2000-01-15T10:00:00Z" → resets Apr 15th, Jul 15th, Oct 15th at 10:00 AM UTC
   * Note: For Feb 29th, non-leap years reset on Mar 1st
   *
   * Default resetTime would be at the start of the quarter UTC.
   */ PseudoBalanceCadence["QUARTERLY"] = "QUARTERLY";
    /**
   * Resets weekly on the same weekday and time as resetTime.
   * Example: "2000-01-17T14:00:00Z" (Monday) → resets every Monday at 2:00 PM UTC
   *
   * Default resetTime would be midnight on Sunday UTC.
   */ PseudoBalanceCadence["WEEKLY"] = "WEEKLY";
    /**
   * Resets annually on the same date and time as resetTime.
   * Example: "2000-01-15T16:00:00Z" → resets Jan 15th every year at 4:00 PM UTC
   *
   * Default resetTime would be at the start of the year UTC.
   */ PseudoBalanceCadence["YEARLY"] = "YEARLY";
    return PseudoBalanceCadence;
}({});
var $2f53fee15f29b056$export$6bc74d755faa4272 = /*#__PURE__*/ function(RecurringAchTransferFrequencyCode) {
    /** A monthly recurring transfer */ RecurringAchTransferFrequencyCode["MONTHLY"] = "MONTHLY";
    return RecurringAchTransferFrequencyCode;
}({});
var $2f53fee15f29b056$export$1274f3f57947b042 = /*#__PURE__*/ function(RedemptionConfigurationType) {
    /** Redeem points for statement credit. */ RedemptionConfigurationType["STATEMENT_CREDIT"] = "STATEMENT_CREDIT";
    return RedemptionConfigurationType;
}({});
var $2f53fee15f29b056$export$d2e3163f430e6800 = /*#__PURE__*/ function(ReissueReason) {
    /** The `PaymentCard` expired and needs to be reissued */ ReissueReason["EXPIRED"] = "EXPIRED";
    /** The `PaymentCard` was lost and needs to be reissued */ ReissueReason["LOST"] = "LOST";
    /** The `PaymentCard` needs to be reissued for another reason */ ReissueReason["OTHER"] = "OTHER";
    /**
   * The `PaymentCard` was stolen and needs to be reissued
   * @deprecated If card is stolen, terminate the old card and issue a new card to establish a new card lineage.
   */ ReissueReason["STOLEN"] = "STOLEN";
    return ReissueReason;
}({});
var $2f53fee15f29b056$export$950576fd230b7d2 = /*#__PURE__*/ function(RepaymentCategory) {
    RepaymentCategory["FEES"] = "FEES";
    RepaymentCategory["INTEREST"] = "INTEREST";
    RepaymentCategory["PURCHASE"] = "PURCHASE";
    return RepaymentCategory;
}({});
var $2f53fee15f29b056$export$8133a9c5bfc78dc = /*#__PURE__*/ function(ReportStatus) {
    /** Indicates the report has been generated and is ready to be downloaded. */ ReportStatus["COMPLETED"] = "COMPLETED";
    /** Indicates the report failed to generate. */ ReportStatus["FAILED"] = "FAILED";
    /** Indicates the report is still being generated. */ ReportStatus["IN_PROGRESS"] = "IN_PROGRESS";
    return ReportStatus;
}({});
var $2f53fee15f29b056$export$59adc39451e8173b = /*#__PURE__*/ function(ReportType) {
    /** This report contains all ACH event activities across all financial accounts for the organization. */ ReportType["ACH_EVENT_ACTIVITY"] = "ACH_EVENT_ACTIVITY";
    /** This report contains card interchange and transaction settlement activity across all financial accounts for the organization. */ ReportType["CARD_INTERCHANGE_ACTIVITY"] = "CARD_INTERCHANGE_ACTIVITY";
    /** This report contains all card transaction event activities across all financial accounts for the organization. */ ReportType["CARD_TRANSACTION_ACTIVITY"] = "CARD_TRANSACTION_ACTIVITY";
    /** This is the credit loan tape report across all financial accounts for the organization. */ ReportType["CREDIT_LOAN_TAPE"] = "CREDIT_LOAN_TAPE";
    /** Metro2 file formatted for credit report furnishing with Experian. */ ReportType["EXPERIAN_CREDIT_REPORT"] = "EXPERIAN_CREDIT_REPORT";
    /** This report contains all the enhanced data (level 2/3) sent by the payment networks for cleared fleet transactions for a specific time period */ ReportType["FLEET_ENHANCED_DATA_SUMMARY"] = "FLEET_ENHANCED_DATA_SUMMARY";
    /** This report contains ledger entries across all financial accounts for the organization. */ ReportType["LEDGER_ENTRY"] = "LEDGER_ENTRY";
    /** This is the negative balance report across all financial accounts for the organization. */ ReportType["NEGATIVE_ACCOUNT_BALANCE"] = "NEGATIVE_ACCOUNT_BALANCE";
    /** This report contains the breakdown of each financial account’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */ ReportType["RECEIVABLE_ACCOUNTS_SALE"] = "RECEIVABLE_ACCOUNTS_SALE";
    /** This report contains the overall amount(s) being sold on a given business day */ ReportType["RECEIVABLE_SALE"] = "RECEIVABLE_SALE";
    /** This is the RPA purchase agreement for a given day */ ReportType["RECEIVABLE_SALE_AGREEMENT"] = "RECEIVABLE_SALE_AGREEMENT";
    /** This report contains the breakdown of each transaction’s receivable being sold on a given business day (sum to the amount in the Receivable Sale report) */ ReportType["RECEIVABLE_SALE_TRANSACTIONS"] = "RECEIVABLE_SALE_TRANSACTIONS";
    /** This report contains all transfer event activities across all financial accounts for the organization. */ ReportType["TRANSFER_EVENT_ACTIVITY"] = "TRANSFER_EVENT_ACTIVITY";
    return ReportType;
}({});
var $2f53fee15f29b056$export$92e2d960f8bf19d = /*#__PURE__*/ function(RequestedIdentityUpdateStatus) {
    /** The requested update is canceled, indicating that no updates were supplied even though requested. */ RequestedIdentityUpdateStatus["CANCELED"] = "CANCELED";
    /** The requested update is confirmed, and the individual or business has acknowledged the accuracy and correctness of the supplied information. */ RequestedIdentityUpdateStatus["CONFIRMED"] = "CONFIRMED";
    /** The requested update is `INITIATED` and has received input. */ RequestedIdentityUpdateStatus["INITIATED"] = "INITIATED";
    /** The requested update is `OPEN` and awaiting input. */ RequestedIdentityUpdateStatus["OPEN"] = "OPEN";
    return RequestedIdentityUpdateStatus;
}({});
var $2f53fee15f29b056$export$5cfe3995fe69c485 = /*#__PURE__*/ function(RequestedIdentityUpdateType) {
    /** Request to update the billing address. */ RequestedIdentityUpdateType["BILLING_ADDRESS"] = "BILLING_ADDRESS";
    /** Request to update the date of birth. */ RequestedIdentityUpdateType["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    /** Request to update the email address. */ RequestedIdentityUpdateType["EMAIL"] = "EMAIL";
    /** Request to update the employer identification number. */ RequestedIdentityUpdateType["EMPLOYER_IDENTIFICATION_NUMBER"] = "EMPLOYER_IDENTIFICATION_NUMBER";
    /** Request to update the full legal name. */ RequestedIdentityUpdateType["FULL_LEGAL_NAME"] = "FULL_LEGAL_NAME";
    /** Request to update the home address. */ RequestedIdentityUpdateType["HOME_ADDRESS"] = "HOME_ADDRESS";
    /** Request to update the legal business name. */ RequestedIdentityUpdateType["LEGAL_BUSINESS_NAME"] = "LEGAL_BUSINESS_NAME";
    /** Request to add new Ultimate Beneficial Owner to the business */ RequestedIdentityUpdateType["NEW_ULTIMATE_BENEFICIAL_OWNER"] = "NEW_ULTIMATE_BENEFICIAL_OWNER";
    /** Request to update the ownership percentage. */ RequestedIdentityUpdateType["OWNERSHIP_PERCENTAGE"] = "OWNERSHIP_PERCENTAGE";
    /** Request to update the phone number. */ RequestedIdentityUpdateType["PHONE"] = "PHONE";
    /** Request to update the social security number. */ RequestedIdentityUpdateType["SOCIAL_SECURITY_NUMBER"] = "SOCIAL_SECURITY_NUMBER";
    return RequestedIdentityUpdateType;
}({});
var $2f53fee15f29b056$export$c04ad31c5dd093ff = /*#__PURE__*/ function(ReviewWorkflowEventStatus) {
    /** The event under review, e.g. wire transfer has been approved. */ ReviewWorkflowEventStatus["APPROVED"] = "APPROVED";
    /** The event under review, e.g. wire transfer was canceled. */ ReviewWorkflowEventStatus["CANCELED"] = "CANCELED";
    /** The event under review, e.g. wire transfer has completed. */ ReviewWorkflowEventStatus["COMPLETED"] = "COMPLETED";
    /** The event under review, e.g. wire transfer has failed. */ ReviewWorkflowEventStatus["FAILED"] = "FAILED";
    /** The event for review, e.g. wire transfer has been initiated. */ ReviewWorkflowEventStatus["PENDING"] = "PENDING";
    /** The event under review, e.g. wire transfer has been rejected. */ ReviewWorkflowEventStatus["REJECTED"] = "REJECTED";
    /** The event under review, e.g. wire transfer is in an unspecified state. */ ReviewWorkflowEventStatus["UNSPECIFIED"] = "UNSPECIFIED";
    return ReviewWorkflowEventStatus;
}({});
var $2f53fee15f29b056$export$21615dad30d7cb8 = /*#__PURE__*/ function(RewardPointsActivityType) {
    /** Adds reward point(s) to a financial account that has this enabled. */ RewardPointsActivityType["AWARD"] = "AWARD";
    /** Deducts reward point(s) to a financial account that has this enabled. */ RewardPointsActivityType["DEDUCT"] = "DEDUCT";
    /** Redeems reward point(s) to a financial account that has this enabled. */ RewardPointsActivityType["REDEEM"] = "REDEEM";
    /** Refunds reward point(s) to a financial account that has this enabled. */ RewardPointsActivityType["REFUND"] = "REFUND";
    return RewardPointsActivityType;
}({});
var $2f53fee15f29b056$export$8ce0d491e6e114a6 = /*#__PURE__*/ function(RewardPointsActivityTypeInput) {
    /** Add reward points to an enabled `FinancialAccount`. */ RewardPointsActivityTypeInput["AWARD"] = "AWARD";
    /** Deduct reward points from an enabled `FinancialAccount`. */ RewardPointsActivityTypeInput["DEDUCT"] = "DEDUCT";
    return RewardPointsActivityTypeInput;
}({});
var $2f53fee15f29b056$export$c1847d655db69d1b = /*#__PURE__*/ function(RewardPointsTransferFailureReasonCode) {
    /** The receiving account has been closed. */ RewardPointsTransferFailureReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The amount of the transfer does not match the currency of the receiving account. */ RewardPointsTransferFailureReasonCode["ACCOUNT_CURRENCY_MISMATCH"] = "ACCOUNT_CURRENCY_MISMATCH";
    /** No matching account was found for the receiving account. */ RewardPointsTransferFailureReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The account the money was coming from did not have enough funds. */ RewardPointsTransferFailureReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The receiving account does not have the reward point feature enabled. */ RewardPointsTransferFailureReasonCode["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    return RewardPointsTransferFailureReasonCode;
}({});
var $2f53fee15f29b056$export$36e0813576484609 = /*#__PURE__*/ function(RewardPointsTransferSource) {
    /**
   * A transfer request has been initiated using api
   * @deprecated `API` is deprecated in favor of `MANUAL_ADJUSTMENT`
   */ RewardPointsTransferSource["API"] = "API";
    /** The transfer was initiated for a card transaction */ RewardPointsTransferSource["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    /** The transfer was manually created using API. */ RewardPointsTransferSource["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
    return RewardPointsTransferSource;
}({});
var $2f53fee15f29b056$export$1849418e7195d886 = /*#__PURE__*/ function(RewardPointsTransferStatus) {
    /** The transfer has successfully completed. */ RewardPointsTransferStatus["COMPLETED"] = "COMPLETED";
    /** The transfer failed. Additional details are available in `RewardPointsTransferFailureReasonCode`. */ RewardPointsTransferStatus["FAILED"] = "FAILED";
    /** A transfer request has been initiated. */ RewardPointsTransferStatus["PENDING"] = "PENDING";
    return RewardPointsTransferStatus;
}({});
var $2f53fee15f29b056$export$508e740cff552b73 = /*#__PURE__*/ function(RiskPeriodicityType) {
    /** Group data on a monthly basis. */ RiskPeriodicityType["MONTHLY"] = "MONTHLY";
    /** Group data on a weekly basis. */ RiskPeriodicityType["WEEKLY"] = "WEEKLY";
    return RiskPeriodicityType;
}({});
var $2f53fee15f29b056$export$bdfc7590bce48cca = /*#__PURE__*/ function(RoundingStrategy) {
    /** The value is rounded down to the nearest minor unit. */ RoundingStrategy["ROUND_DOWN"] = "ROUND_DOWN";
    /** The value is rounded up to the nearest minor unit. */ RoundingStrategy["ROUND_UP"] = "ROUND_UP";
    return RoundingStrategy;
}({});
var $2f53fee15f29b056$export$d136d0e876002281 = /*#__PURE__*/ function(RtpTransferFailureReason) {
    /** The `RtpTransfer` failed because the account is closed. */ RtpTransferFailureReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The `RtpTransfer` failed because the account is frozen. */ RtpTransferFailureReason["ACCOUNT_FROZEN"] = "ACCOUNT_FROZEN";
    /** The `RtpTransfer` failed because the account is not active. */ RtpTransferFailureReason["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The `RtpTransfer` failed because the account was not found. */ RtpTransferFailureReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The `RtpTransfer` failed due to a configuration error. */ RtpTransferFailureReason["CONFIGURATION_ERROR"] = "CONFIGURATION_ERROR";
    /** The `RtpTransfer` failed because of a currency mismatch. */ RtpTransferFailureReason["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The `RtpTransfer` failed because there were insufficient funds. */ RtpTransferFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The `RtpTransfer` failed because the amount is invalid. */ RtpTransferFailureReason["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    /** The `RtpTransfer` failed due to a network error. */ RtpTransferFailureReason["NETWORK_ERROR"] = "NETWORK_ERROR";
    /** The `RtpTransfer` failed because the network is not supported. */ RtpTransferFailureReason["NETWORK_NOT_SUPPORTED"] = "NETWORK_NOT_SUPPORTED";
    /** The `RtpTransfer` failed due to a timeout. */ RtpTransferFailureReason["TIMEOUT"] = "TIMEOUT";
    /** The `RtpTransfer` failed because the transfer is not permitted. */ RtpTransferFailureReason["TRANSFER_NOT_PERMITTED"] = "TRANSFER_NOT_PERMITTED";
    /** The `RtpTransfer` failed for an unspecified reason. */ RtpTransferFailureReason["UNSPECIFIED"] = "UNSPECIFIED";
    return RtpTransferFailureReason;
}({});
var $2f53fee15f29b056$export$db5cd9d819cb784b = /*#__PURE__*/ function(RtpTransferStatus) {
    /** The `RtpTransfer` has been cancelled. */ RtpTransferStatus["CANCELLED"] = "CANCELLED";
    /** The `RtpTransfer` has completed successfully. */ RtpTransferStatus["COMPLETED"] = "COMPLETED";
    /** The `RtpTransfer` has failed. */ RtpTransferStatus["FAILED"] = "FAILED";
    /** The `RtpTransfer` is on hold. */ RtpTransferStatus["HOLD"] = "HOLD";
    /** The `RtpTransfer` has been initiated. */ RtpTransferStatus["INITIATED"] = "INITIATED";
    /** The `RtpTransfer` is pending. */ RtpTransferStatus["PENDING"] = "PENDING";
    /** The `RtpTransfer` is processing. */ RtpTransferStatus["PROCESSING"] = "PROCESSING";
    return RtpTransferStatus;
}({});
var $2f53fee15f29b056$export$b88b757bf139ed3 = /*#__PURE__*/ function(ScheduledTransferClientTokenPermission) {
    /** Setting this permission will enable management of the lifecycle of a scheduled transfer. */ ScheduledTransferClientTokenPermission["MANAGE_SCHEDULED_TRANSFER"] = "MANAGE_SCHEDULED_TRANSFER";
    return ScheduledTransferClientTokenPermission;
}({});
var $2f53fee15f29b056$export$65da5892cb2dff6d = /*#__PURE__*/ function(ScheduledTransferEventStatusCode) {
    /** The scheduled transfer event has completed successfully. */ ScheduledTransferEventStatusCode["COMPLETED"] = "COMPLETED";
    /** The scheduled transfer event has been failed by Highnote. Please look into the `transfer` object to determine the root cause of the failure. */ ScheduledTransferEventStatusCode["FAILED"] = "FAILED";
    /** The scheduled transfer event has been inititated */ ScheduledTransferEventStatusCode["INITIATED"] = "INITIATED";
    /** The scheduled transfer event did not execute a transfer. A `NOT_EXECUTED` status can occur if the calculated amount to transfer is `0`. */ ScheduledTransferEventStatusCode["NOT_EXECUTED"] = "NOT_EXECUTED";
    /** The scheduled transfer event has been rejected. Please look into the `transfer` object to determine the root cause of the failure. */ ScheduledTransferEventStatusCode["REJECTED"] = "REJECTED";
    return ScheduledTransferEventStatusCode;
}({});
var $2f53fee15f29b056$export$2d4770d91dfc19e6 = /*#__PURE__*/ function(ScheduledTransferStatusCode) {
    /** The scheduled transfer is active. A scheduled transfer moves from `SCHEDULED` to `ACTIVE` once the first transfer is initiated. */ ScheduledTransferStatusCode["ACTIVE"] = "ACTIVE";
    /** The scheduled transfer is canceled. Once a scheduled transfer is canceled, any payments in the future will not be executed. */ ScheduledTransferStatusCode["CANCELED"] = "CANCELED";
    /** The scheduled transfer is closed. Once a scheduled transfer is `CLOSED`, all payments requested to be executed have been executed and any payments in the future will not be executed. */ ScheduledTransferStatusCode["CLOSED"] = "CLOSED";
    /** The scheduled transfer has been created and scheduled. `SCHEDULED` state indicates a transfer has yet to be initiated. */ ScheduledTransferStatusCode["SCHEDULED"] = "SCHEDULED";
    return ScheduledTransferStatusCode;
}({});
var $2f53fee15f29b056$export$127dd0ca17a25528 = /*#__PURE__*/ function(SchemaChangeCriticalityLevel) {
    SchemaChangeCriticalityLevel["BREAKING"] = "BREAKING";
    SchemaChangeCriticalityLevel["DANGEROUS"] = "DANGEROUS";
    SchemaChangeCriticalityLevel["NON_BREAKING"] = "NON_BREAKING";
    return SchemaChangeCriticalityLevel;
}({});
var $2f53fee15f29b056$export$43a022b07ee1cdca = /*#__PURE__*/ function(SearchQueryLanguageVersion) {
    /** Version 1 */ SearchQueryLanguageVersion["VERSION_1"] = "VERSION_1";
    return SearchQueryLanguageVersion;
}({});
var $2f53fee15f29b056$export$34447b3cd4e8bae0 = /*#__PURE__*/ function(SecondaryAtmNetwork) {
    /** Maestro ATM network. */ SecondaryAtmNetwork["MAESTRO"] = "MAESTRO";
    /** Plus ATM network. */ SecondaryAtmNetwork["PLUS"] = "PLUS";
    /** Pulse ATM network. */ SecondaryAtmNetwork["PULSE"] = "PULSE";
    return SecondaryAtmNetwork;
}({});
var $2f53fee15f29b056$export$7f790d3f7c0ff9a = /*#__PURE__*/ function(SecondaryPointOfSaleNetwork) {
    /** Interlink network. */ SecondaryPointOfSaleNetwork["INTERLINK"] = "INTERLINK";
    /** NYCE network. */ SecondaryPointOfSaleNetwork["NYCE"] = "NYCE";
    /** Pulse network. */ SecondaryPointOfSaleNetwork["PULSE"] = "PULSE";
    return SecondaryPointOfSaleNetwork;
}({});
var $2f53fee15f29b056$export$d5fd73b62c0ca4e8 = /*#__PURE__*/ function(SecondarySurchargeFreeAtmNetwork) {
    /** Allpoint Free Surcharge ATM network. */ SecondarySurchargeFreeAtmNetwork["ALL_POINT"] = "ALL_POINT";
    /** MoneyPass Free Surcharge ATM network. */ SecondarySurchargeFreeAtmNetwork["MONEY_PASS"] = "MONEY_PASS";
    /** SUM Free Surcharge ATM network. */ SecondarySurchargeFreeAtmNetwork["SUM"] = "SUM";
    return SecondarySurchargeFreeAtmNetwork;
}({});
var $2f53fee15f29b056$export$a4c4d3bb7ca985ee = /*#__PURE__*/ function(SecureDepositClientTokenPermission) {
    /** Setting this permission will enable management of the lifecycle of a secure deposit. */ SecureDepositClientTokenPermission["MANAGE_SECURE_DEPOSIT"] = "MANAGE_SECURE_DEPOSIT";
    return SecureDepositClientTokenPermission;
}({});
var $2f53fee15f29b056$export$512d022e34f22255 = /*#__PURE__*/ function(ServiceCode) {
    /** International use EMV chip card. */ ServiceCode["INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION"] = "INTERNATIONAL_ICC_NORMAL_NO_RESTRICTION";
    /** International use magnetic stripe card. */ ServiceCode["INTERNATIONAL_NORMAL_NO_RESTRICTION"] = "INTERNATIONAL_NORMAL_NO_RESTRICTION";
    /** Magnetic stripe only card. */ ServiceCode["NATIONAL_NORMAL_NO_RESTRICTION"] = "NATIONAL_NORMAL_NO_RESTRICTION";
    return ServiceCode;
}({});
var $2f53fee15f29b056$export$8f85d26cf5a9c461 = /*#__PURE__*/ function(ServicemembersCivilReliefActStatus) {
    ServicemembersCivilReliefActStatus["APPROVED"] = "APPROVED";
    ServicemembersCivilReliefActStatus["PENDING"] = "PENDING";
    ServicemembersCivilReliefActStatus["REJECTED"] = "REJECTED";
    return ServicemembersCivilReliefActStatus;
}({});
var $2f53fee15f29b056$export$888e05b680409cc4 = /*#__PURE__*/ function(SpendRuleRecommendation) {
    /** Allow the event. */ SpendRuleRecommendation["ALLOW"] = "ALLOW";
    /** Block the event. */ SpendRuleRecommendation["BLOCK"] = "BLOCK";
    /** A recommendation could not be determined. */ SpendRuleRecommendation["NONE"] = "NONE";
    return SpendRuleRecommendation;
}({});
var $2f53fee15f29b056$export$19b690df7b5f1edc = /*#__PURE__*/ function(StockExchange) {
    /** Nasdaq (National Association of Securities Dealers Automated Quotation System) */ StockExchange["NASDAQ"] = "NASDAQ";
    /** New York Stock Exchange */ StockExchange["NYSE"] = "NYSE";
    return StockExchange;
}({});
var $2f53fee15f29b056$export$a4d3d6c01bd48c8e = /*#__PURE__*/ function(SuspendCardDigitalWalletTokenReason) {
    /** Device is reported as lost. */ SuspendCardDigitalWalletTokenReason["DEVICE_LOST"] = "DEVICE_LOST";
    /** Device is reported as stolen. */ SuspendCardDigitalWalletTokenReason["DEVICE_STOLEN"] = "DEVICE_STOLEN";
    /** Fraudulent transactions have been reported by `Highnote` or the account holder. */ SuspendCardDigitalWalletTokenReason["FRAUDULENT_TRANSACTIONS"] = "FRAUDULENT_TRANSACTIONS";
    /** Any other reason for suspending the card digital wallet token. */ SuspendCardDigitalWalletTokenReason["OTHER"] = "OTHER";
    return SuspendCardDigitalWalletTokenReason;
}({});
var $2f53fee15f29b056$export$14a1cb2fb73861b9 = /*#__PURE__*/ function(TaxIdentificationNumberType) {
    /**
   * Employer Identification Number
   * @deprecated Use EMPLOYER_IDENTIFICATION_NUMBER instead
   */ TaxIdentificationNumberType["EIN"] = "EIN";
    /** Employer Identification Number */ TaxIdentificationNumberType["EMPLOYER_IDENTIFICATION_NUMBER"] = "EMPLOYER_IDENTIFICATION_NUMBER";
    /** Individual Taxpayer Identification Number */ TaxIdentificationNumberType["INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER"] = "INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER";
    /**
   * Individual Taxpayer Identification Number
   * @deprecated Use INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER instead
   */ TaxIdentificationNumberType["ITIN"] = "ITIN";
    /** Social Security Number */ TaxIdentificationNumberType["SOCIAL_SECURITY_NUMBER"] = "SOCIAL_SECURITY_NUMBER";
    /**
   * Social Security Number
   * @deprecated Use SOCIAL_SECURITY_NUMBER instead
   */ TaxIdentificationNumberType["SSN"] = "SSN";
    return TaxIdentificationNumberType;
}({});
var $2f53fee15f29b056$export$d420a6130b116398 = /*#__PURE__*/ function(TerminalAttendance) {
    /** The terminal was attended */ TerminalAttendance["ATTENDED"] = "ATTENDED";
    /** The terminal was unattended */ TerminalAttendance["UNATTENDED"] = "UNATTENDED";
    return TerminalAttendance;
}({});
var $2f53fee15f29b056$export$9b62ec8d76cf14aa = /*#__PURE__*/ function(TerminateCardDigitalWalletTokenReason) {
    /** Account holder has been deleted. */ TerminateCardDigitalWalletTokenReason["ACCOUNT_HOLDER_DELETED"] = "ACCOUNT_HOLDER_DELETED";
    /** Device is reported as lost. */ TerminateCardDigitalWalletTokenReason["DEVICE_LOST"] = "DEVICE_LOST";
    /** Device is reported as stolen. */ TerminateCardDigitalWalletTokenReason["DEVICE_STOLEN"] = "DEVICE_STOLEN";
    /** Fraudulent transactions have been reported by `Highnote` or the account holder. */ TerminateCardDigitalWalletTokenReason["FRAUDULENT_TRANSACTIONS"] = "FRAUDULENT_TRANSACTIONS";
    /** Any other reason for terminating the card digital wallet token. */ TerminateCardDigitalWalletTokenReason["OTHER"] = "OTHER";
    return TerminateCardDigitalWalletTokenReason;
}({});
var $2f53fee15f29b056$export$97cd743cbe864a98 = /*#__PURE__*/ function(TokenScope) {
    /** E-Commerce scope. */ TokenScope["ECOMMERCE"] = "ECOMMERCE";
    return TokenScope;
}({});
var $2f53fee15f29b056$export$c5827bdd7b4f79c = /*#__PURE__*/ function(TokenUserApplicationType) {
    /** Token provisioned for use with biometric authentication. */ TokenUserApplicationType["BIOMETRIC_APPLICATION"] = "BIOMETRIC_APPLICATION";
    /** Token provisioned for use in a marketplace or third-party application. */ TokenUserApplicationType["MARKETPLACE_APPLICATION"] = "MARKETPLACE_APPLICATION";
    /** Token provisioned for use in a native mobile application (iOS/Android). */ TokenUserApplicationType["MOBILE_APPLICATION"] = "MOBILE_APPLICATION";
    /** Token provisioned for use in a mobile web browser application. */ TokenUserApplicationType["MOBILE_WEB"] = "MOBILE_WEB";
    /** Token provisioned for use in a voice-activated application. */ TokenUserApplicationType["VOICE_APPLICATION"] = "VOICE_APPLICATION";
    /** Token provisioned for use in a web browser application. */ TokenUserApplicationType["WEB"] = "WEB";
    return TokenUserApplicationType;
}({});
var $2f53fee15f29b056$export$13d9b4dd10624711 = /*#__PURE__*/ function(TransactionAdviceEventResponseCode) {
    /** The event was approved. */ TransactionAdviceEventResponseCode["APPROVED"] = "APPROVED";
    /** The event was declined. */ TransactionAdviceEventResponseCode["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    /** The event was declined for suspected fraud. */ TransactionAdviceEventResponseCode["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    return TransactionAdviceEventResponseCode;
}({});
var $2f53fee15f29b056$export$df732aa015bdd111 = /*#__PURE__*/ function(TransactionEventFilter) {
    /** Scope the results to contain `AdjustmentEvent`. */ TransactionEventFilter["ADJUSTMENT_EVENT"] = "ADJUSTMENT_EVENT";
    /** Scope the results to contain `AuthorizationAndClearEvent`. */ TransactionEventFilter["AUTHORIZATION_AND_CLEAR_EVENT"] = "AUTHORIZATION_AND_CLEAR_EVENT";
    /** Scope the results to contain `AuthorizationEvent`. */ TransactionEventFilter["AUTHORIZATION_EVENT"] = "AUTHORIZATION_EVENT";
    /** Scope the results to contain `BalanceInquiryEvent`. */ TransactionEventFilter["BALANCE_INQUIRY_EVENT"] = "BALANCE_INQUIRY_EVENT";
    /** Scope the results to contain `ClearingEvent`. */ TransactionEventFilter["CLEARING_EVENT"] = "CLEARING_EVENT";
    /** Scope the results to contain `EnhancedDataEvent`. */ TransactionEventFilter["ENHANCED_DATA_EVENT"] = "ENHANCED_DATA_EVENT";
    /** Scope the results to contain `IssuerPreliminaryAuthorizationEvent`. */ TransactionEventFilter["ISSUER_PRELIMINARY_AUTHORIZATION_EVENT"] = "ISSUER_PRELIMINARY_AUTHORIZATION_EVENT";
    /** Scope the results to contain `ReversalEvent`. */ TransactionEventFilter["REVERSAL_EVENT"] = "REVERSAL_EVENT";
    /** Scope the results to contain `VerificationEvent`. */ TransactionEventFilter["VERIFICATION_EVENT"] = "VERIFICATION_EVENT";
    return TransactionEventFilter;
}({});
var $2f53fee15f29b056$export$9cadc20cbde1d054 = /*#__PURE__*/ function(TransactionEventResponseCode) {
    /** A catchall for all approved `TransactionEventResponseCode` values */ TransactionEventResponseCode["ALL_APPROVED_CODES"] = "ALL_APPROVED_CODES";
    /** A catchall for all issuer declined `TransactionEventResponseCode` values */ TransactionEventResponseCode["ALL_ISSUER_DECLINED_CODES"] = "ALL_ISSUER_DECLINED_CODES";
    /** The event was approved. */ TransactionEventResponseCode["APPROVED"] = "APPROVED";
    /** The event was approved for only part of the requested amount. */ TransactionEventResponseCode["APPROVED_FOR_PARTIAL_AMOUNT"] = "APPROVED_FOR_PARTIAL_AMOUNT";
    /** The event was approved for only the purchase portion of requested amount. */ TransactionEventResponseCode["APPROVED_FOR_PURCHASE_AMOUNT_ONLY"] = "APPROVED_FOR_PURCHASE_AMOUNT_ONLY";
    /** The event was declined because the provided CVC3 code was not valid. */ TransactionEventResponseCode["BAD_CVC3"] = "BAD_CVC3";
    /** The event was declined because the provided CVV code was not valid. */ TransactionEventResponseCode["BAD_CVV"] = "BAD_CVV";
    /** The event was declined because the provided CVV2 code was not valid. */ TransactionEventResponseCode["BAD_CVV2"] = "BAD_CVV2";
    /** The event was declined because the `PaymentCard` is blocked from transacting. */ TransactionEventResponseCode["BLOCKED_CARD"] = "BLOCKED_CARD";
    /** Cash request exceeded issuer or approved limit. */ TransactionEventResponseCode["CASH_BACK_LIMIT_EXCEEDED"] = "CASH_BACK_LIMIT_EXCEEDED";
    /** The event was declined by the Collaborative Authorization Partner */ TransactionEventResponseCode["CA_DECLINED"] = "CA_DECLINED";
    /** The Authorization Request Cryptogram (ARQC) validation failed for a chip card transaction. */ TransactionEventResponseCode["CHIP_CARD_ARQC_VALIDATION_FAILURE"] = "CHIP_CARD_ARQC_VALIDATION_FAILURE";
    /** The account was closed at the time of event. */ TransactionEventResponseCode["CLOSED_ACCOUNT"] = "CLOSED_ACCOUNT";
    /**
   * The event was declined due to enforcement of internal rules such as spend controls.
   * The `Amount` on this event will not be applied to the balance of the card and any clearing event will not move money.
   */ TransactionEventResponseCode["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    /** Purchase or withdrawal amount exceeded issuer or approved limit over a set period of time. */ TransactionEventResponseCode["EXCEEDS_APPROVAL_AMOUNT_LIMIT"] = "EXCEEDS_APPROVAL_AMOUNT_LIMIT";
    /** The event was declined because number of transaction exceeded the issuer or approved limit over a set period of time. */ TransactionEventResponseCode["EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT"] = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT";
    /** The card was expired at the time of event. */ TransactionEventResponseCode["EXPIRED_CARD"] = "EXPIRED_CARD";
    /** The expiration date provided does not match the expiration date assigned to the Payment Card. */ TransactionEventResponseCode["INCORRECT_EXPIRATION_DATE"] = "INCORRECT_EXPIRATION_DATE";
    /** The pin provided for this event was incorrect */ TransactionEventResponseCode["INCORRECT_PIN"] = "INCORRECT_PIN";
    /** The card had insufficient funds at the time of event. */ TransactionEventResponseCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The event was declined because the 3-D Secure (3DS) Authentication failed. */ TransactionEventResponseCode["INVALID_3DS_VERIFICATION"] = "INVALID_3DS_VERIFICATION";
    /** The event was declined because the provided authorization expiration is invalid. */ TransactionEventResponseCode["INVALID_AUTHORIZATION_EXPIRATION"] = "INVALID_AUTHORIZATION_EXPIRATION";
    /** The card number provided for this event was invalid. */ TransactionEventResponseCode["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    /** The event was declined because the merchant is not authorized for this card. */ TransactionEventResponseCode["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    /** The verification data for a payment card is invalid. */ TransactionEventResponseCode["INVALID_TRACK_DATA"] = "INVALID_TRACK_DATA";
    /**
   * The event was declined because of incorrect information or faulty operation, including trying to refund a refund.
   * A generic catch-all response code for a transaction that cannot be declined under other specific response codes.
   */ TransactionEventResponseCode["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
    /** The card provided was not on file with Highnote. */ TransactionEventResponseCode["NO_CARD_RECORD"] = "NO_CARD_RECORD";
    /** The event was declined because the PIN decryption failed due to technical error. */ TransactionEventResponseCode["PIN_DECRYPTION_ERROR"] = "PIN_DECRYPTION_ERROR";
    /** The pre-authorization expiration date for a transaction passed. */ TransactionEventResponseCode["PRE_AUTHORIZATION_EXPIRED"] = "PRE_AUTHORIZATION_EXPIRED";
    /** Indicates the transaction was declined based on a real-time risk assessment decision. */ TransactionEventResponseCode["REAL_TIME_RISK_DECISION_DECLINE"] = "REAL_TIME_RISK_DECISION_DECLINE";
    /** The card is restricted in the region or country. */ TransactionEventResponseCode["RESTRICTED_LOCATION"] = "RESTRICTED_LOCATION";
    /** The event was declined because the transaction temporarily cannot be processed due to Address Verification failure or enforcement of internal rules such as spend controls. */ TransactionEventResponseCode["RE_ENTER_TRANSACTION"] = "RE_ENTER_TRANSACTION";
    /** The event was declined due to special condition - new card not activated or card is temporarily blocked. */ TransactionEventResponseCode["SPECIAL_CONDITION_NO_PICK_UP"] = "SPECIAL_CONDITION_NO_PICK_UP";
    /** The event was declined because the card provided has been suspended. */ TransactionEventResponseCode["SUSPENDED_CARD"] = "SUSPENDED_CARD";
    /** The event was declined because the digital wallet token for the `PaymentCard` is suspended. */ TransactionEventResponseCode["SUSPENDED_DIGITAL_WALLET_TOKEN"] = "SUSPENDED_DIGITAL_WALLET_TOKEN";
    /** The event was declined because the card provided has been terminated. */ TransactionEventResponseCode["TERMINATED_CARD"] = "TERMINATED_CARD";
    /** The event was declined because the digital wallet token for the `PaymentCard` is terminated. */ TransactionEventResponseCode["TERMINATED_DIGITAL_WALLET_TOKEN"] = "TERMINATED_DIGITAL_WALLET_TOKEN";
    /** The event was declined due to a permanent restriction placed at the program or account level. This may be due to enforcement of internal rules such as spend controls. */ TransactionEventResponseCode["TRANSACTION_NOT_PERMITTED"] = "TRANSACTION_NOT_PERMITTED";
    /** The event was declined because it is not supported by the `PaymentCard`’s Program. */ TransactionEventResponseCode["TRANSACTION_NOT_SUPPORTED"] = "TRANSACTION_NOT_SUPPORTED";
    /** The event was declined because the card provided has not been activated. */ TransactionEventResponseCode["UNACTIVATED_CARD"] = "UNACTIVATED_CARD";
    /** The event was declined because the digital wallet token for the `PaymentCard` is not activated. */ TransactionEventResponseCode["UNACTIVATED_DIGITAL_WALLET_TOKEN"] = "UNACTIVATED_DIGITAL_WALLET_TOKEN";
    /** The account is valid but had insufficient funds for the anticipated amount. */ TransactionEventResponseCode["VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED"] = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED";
    return TransactionEventResponseCode;
}({});
var $2f53fee15f29b056$export$ce641a9f16f6dccc = /*#__PURE__*/ function(TransactionFeeType) {
    /** A surcharge fee applied to a transaction such as an ATM network charge for a cash withdrawal or balance inquiry. */ TransactionFeeType["SURCHARGE"] = "SURCHARGE";
    return TransactionFeeType;
}({});
var $2f53fee15f29b056$export$b9f4ad41ed0a0cfe = /*#__PURE__*/ function(TransactionSearchObjectType) {
    TransactionSearchObjectType["ACH_TRANSFER"] = "ACH_TRANSFER";
    TransactionSearchObjectType["CARD_TRANSACTION"] = "CARD_TRANSACTION";
    TransactionSearchObjectType["CHECK_PAYMENT"] = "CHECK_PAYMENT";
    TransactionSearchObjectType["DISBURSEMENT"] = "DISBURSEMENT";
    TransactionSearchObjectType["INSTANT_NETWORK_TRANSFER"] = "INSTANT_NETWORK_TRANSFER";
    TransactionSearchObjectType["INSTANT_SETTLEMENT_TRANSACTION"] = "INSTANT_SETTLEMENT_TRANSACTION";
    /** @deprecated Use INTER_FINANCIAL_ACCOUNT_TRANSFER instead. */ TransactionSearchObjectType["INTERNAL_ACCOUNT_TRANSFER"] = "INTERNAL_ACCOUNT_TRANSFER";
    TransactionSearchObjectType["INTER_FINANCIAL_ACCOUNT_TRANSFER"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER";
    TransactionSearchObjectType["MANUAL_ADJUSTMENT"] = "MANUAL_ADJUSTMENT";
    TransactionSearchObjectType["RTP_TRANSFER"] = "RTP_TRANSFER";
    TransactionSearchObjectType["WIRE_TRANSFER"] = "WIRE_TRANSFER";
    return TransactionSearchObjectType;
}({});
var $2f53fee15f29b056$export$29646fb87015d863 = /*#__PURE__*/ function(TransactionSearchStatus) {
    TransactionSearchStatus["COMPLETED"] = "COMPLETED";
    TransactionSearchStatus["FAILED"] = "FAILED";
    TransactionSearchStatus["PENDING"] = "PENDING";
    return TransactionSearchStatus;
}({});
var $2f53fee15f29b056$export$185da073cb0c74cc = /*#__PURE__*/ function(TransactionSearchType) {
    TransactionSearchType["ACTIVITY"] = "ACTIVITY";
    TransactionSearchType["EVENT"] = "EVENT";
    TransactionSearchType["TRANSACTION"] = "TRANSACTION";
    return TransactionSearchType;
}({});
var $2f53fee15f29b056$export$f45f2d0dffe91d32 = /*#__PURE__*/ function(TransactionTypeFilter) {
    /** Scope the results to contain types related to `CreditTransaction`. */ TransactionTypeFilter["CREDIT"] = "CREDIT";
    /** Scope the results to contain types related to `DebitTransaction`. */ TransactionTypeFilter["DEBIT"] = "DEBIT";
    return TransactionTypeFilter;
}({});
var $2f53fee15f29b056$export$7f4de5172cd7b254 = /*#__PURE__*/ function(TransferBalanceAmountCode) {
    /** The minimum payment due from the latest statement billing period */ TransferBalanceAmountCode["MINIMUM_PAYMENT"] = "MINIMUM_PAYMENT";
    /** The outstanding balance on the account */ TransferBalanceAmountCode["OUTSTANDING_BALANCE"] = "OUTSTANDING_BALANCE";
    /** The remaining balance due from the latest statement billing period */ TransferBalanceAmountCode["OUTSTANDING_STATEMENT_BALANCE"] = "OUTSTANDING_STATEMENT_BALANCE";
    return TransferBalanceAmountCode;
}({});
var $2f53fee15f29b056$export$3982f32805d9af = /*#__PURE__*/ function(TransferDateCode) {
    /**
   * The payment due date. This represents the payment due date of the next available statement. For accounts that have closed statements,
   * this will be the latest closed statement; for other accounts, it will be the current open statement.
   */ TransferDateCode["PAYMENT_DUE_DATE"] = "PAYMENT_DUE_DATE";
    return TransferDateCode;
}({});
var $2f53fee15f29b056$export$9f2a8cdb82d818cb = /*#__PURE__*/ function(TransferFundsPaymentPreference) {
    /** Instant Network Transfer - fast push-to-card payments via card networks. */ TransferFundsPaymentPreference["INSTANT_NETWORK_TRANSFER"] = "INSTANT_NETWORK_TRANSFER";
    /** Real-Time Payments - fastest, typically seconds. */ TransferFundsPaymentPreference["RTP"] = "RTP";
    return TransferFundsPaymentPreference;
}({});
var $2f53fee15f29b056$export$7451617c9b5aa93e = /*#__PURE__*/ function(TransferPurpose) {
    /** Transfer for adjustment. */ TransferPurpose["ADJUSTMENT"] = "ADJUSTMENT";
    /** Decreasing the pseudo balance for a `FinancialAccount`. */ TransferPurpose["DECREASE_PSEUDO_BALANCE"] = "DECREASE_PSEUDO_BALANCE";
    /** Decreasing an existing pseudo limit for a `FinancialAccount`. */ TransferPurpose["DECREASE_PSEUDO_LIMIT"] = "DECREASE_PSEUDO_LIMIT";
    /** Transfer for earned credits. */ TransferPurpose["EARNED_CREDIT"] = "EARNED_CREDIT";
    /** Reverse earned credit transfer. */ TransferPurpose["EARNED_CREDIT_REVERSAL"] = "EARNED_CREDIT_REVERSAL";
    /** Transfer for general purpose. */ TransferPurpose["GENERAL"] = "GENERAL";
    /** Transfer for goods and services. */ TransferPurpose["GOODS_AND_SERVICES"] = "GOODS_AND_SERVICES";
    /** Increasing the pseudo balance for a `FinancialAccount`. */ TransferPurpose["INCREASE_PSEUDO_BALANCE"] = "INCREASE_PSEUDO_BALANCE";
    /** Increasing an existing pseudo limit for a `FinancialAccount`. */ TransferPurpose["INCREASE_PSEUDO_LIMIT"] = "INCREASE_PSEUDO_LIMIT";
    /** Intra company transfer */ TransferPurpose["INTRA_COMPANY"] = "INTRA_COMPANY";
    /** transfer for issuer balance migration. */ TransferPurpose["ISSUER_BALANCE_MIGRATION"] = "ISSUER_BALANCE_MIGRATION";
    /** Transfer for merchant payout. */ TransferPurpose["MERCHANT_PAYOUT"] = "MERCHANT_PAYOUT";
    /** Transfer for payout. */ TransferPurpose["PAYOUT"] = "PAYOUT";
    /** Transfer for payroll. */ TransferPurpose["PAYROLL"] = "PAYROLL";
    /** Transfer for payroll advance. */ TransferPurpose["PAYROLL_ADVANCE"] = "PAYROLL_ADVANCE";
    /** Transfer for payroll advance repayment. */ TransferPurpose["PAYROLL_ADVANCE_REPAYMENT"] = "PAYROLL_ADVANCE_REPAYMENT";
    /** Transfer for payroll advance repayment reversal. */ TransferPurpose["PAYROLL_ADVANCE_REPAYMENT_REVERSAL"] = "PAYROLL_ADVANCE_REPAYMENT_REVERSAL";
    /** Transfer for payroll advance reversal. */ TransferPurpose["PAYROLL_ADVANCE_REVERSAL"] = "PAYROLL_ADVANCE_REVERSAL";
    /** Transfer for payroll reversal. */ TransferPurpose["PAYROLL_REVERSAL"] = "PAYROLL_REVERSAL";
    /** transfer for peer to peer payment. */ TransferPurpose["PEER_TO_PEER"] = "PEER_TO_PEER";
    /** transfer for peer to peer payment reversal. */ TransferPurpose["PEER_TO_PEER_REVERSAL"] = "PEER_TO_PEER_REVERSAL";
    /** transfer for account repayment. */ TransferPurpose["REPAYMENT"] = "REPAYMENT";
    /** transfer for account repayment reversal. */ TransferPurpose["REPAYMENT_REVERSAL"] = "REPAYMENT_REVERSAL";
    /** Resetting the pseudo balance for a `FinancialAccount`. */ TransferPurpose["RESET_PSEUDO_BALANCE"] = "RESET_PSEUDO_BALANCE";
    /** Transfer for earned rewards. */ TransferPurpose["REWARD"] = "REWARD";
    /** Reverse earned rewards transfer. */ TransferPurpose["REWARD_REVERSAL"] = "REWARD_REVERSAL";
    /** Transfer for secured deposit. */ TransferPurpose["SECURED_DEPOSIT"] = "SECURED_DEPOSIT";
    /** Transfer for secured deposit reversal. */ TransferPurpose["SECURED_DEPOSIT_REVERSAL"] = "SECURED_DEPOSIT_REVERSAL";
    /** Setting a pseudo limit for a `FinancialAccount`. */ TransferPurpose["SET_PSEUDO_LIMIT"] = "SET_PSEUDO_LIMIT";
    /** Transfer for earned tips. */ TransferPurpose["TIP_DISBURSEMENT"] = "TIP_DISBURSEMENT";
    /** Reverse earned tips transfer. */ TransferPurpose["TIP_DISBURSEMENT_REVERSAL"] = "TIP_DISBURSEMENT_REVERSAL";
    return TransferPurpose;
}({});
var $2f53fee15f29b056$export$91301ebb6ad45fab = /*#__PURE__*/ function(TransferStatus) {
    /** The platform has completed the money movement. */ TransferStatus["COMPLETED"] = "COMPLETED";
    /** The platform was not able to complete the money movement. See `statusReasonCode` for more information. */ TransferStatus["FAILED"] = "FAILED";
    /** The platform has started processing the Transfer. */ TransferStatus["PENDING"] = "PENDING";
    /** The platform is currently validating and executing the Transfer. */ TransferStatus["PROCESSING"] = "PROCESSING";
    return TransferStatus;
}({});
var $2f53fee15f29b056$export$9be7fe5f59f6d260 = /*#__PURE__*/ function(TransferStatusReasonCode) {
    /** The source or receiving account is closed. */ TransferStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The receiving account holder is not an Organization. */ TransferStatusReasonCode["ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION"] = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION";
    /** The source or receiving account was not found. */ TransferStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The source and receiving account have different currency. */ TransferStatusReasonCode["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The source account of the Transfer did not have enough funds to cover the requested amount. */ TransferStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The receiving account does not have PayrollAdvanceFinancialAccountFeature as enabled. */ TransferStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    return TransferStatusReasonCode;
}({});
var $2f53fee15f29b056$export$1b5eb083c754a86b = /*#__PURE__*/ function(TransferType) {
    /**
   * The transfer will result in a credit to the internal account.
   *
   * The `amount` from `SimulateExternallyInitiatedACHTransferInput` will be added to the `FinancialAccount`.
   */ TransferType["CREDIT"] = "CREDIT";
    /**
   * The transfer will result in a debit to the internal account.
   *
   * The `amount` from `SimulateExternallyInitiatedACHTransferInput` will be removed from the `FinancialAccount`.
   */ TransferType["DEBIT"] = "DEBIT";
    /**
   * This is a transfer of funds into an internal account for the purposes of payroll.
   *
   * the `amount` from `SimulateExternallyInitiatedACHTransferInput` will be added to the `FinancialAccount`.
   */ TransferType["PAYROLL"] = "PAYROLL";
    /** This is a transfer of funds into an internal account for the purpose of funding individual accounts */ TransferType["SECURE_DEPOSIT"] = "SECURE_DEPOSIT";
    return TransferType;
}({});
var $2f53fee15f29b056$export$47b2d8e56f5a87b4 = /*#__PURE__*/ function(UsBankAccountType) {
    /** A checking account. */ UsBankAccountType["CHECKING"] = "CHECKING";
    /** A savings account. */ UsBankAccountType["SAVINGS"] = "SAVINGS";
    return UsBankAccountType;
}({});
var $2f53fee15f29b056$export$f7b944ad4261dd52 = /*#__PURE__*/ function(UnderwriterVerificationStatusCode) {
    /** The account holder was denied. See the results of the underwriter verification for more details. */ UnderwriterVerificationStatusCode["DENIED"] = "DENIED";
    /** The account holder is currently being reviewed by underwriter. */ UnderwriterVerificationStatusCode["IN_REVIEW"] = "IN_REVIEW";
    /** The account holder passed the underwriter verification requirements. */ UnderwriterVerificationStatusCode["PASSED"] = "PASSED";
    /** The account holder is currently being verified by underwriter. */ UnderwriterVerificationStatusCode["PENDING"] = "PENDING";
    return UnderwriterVerificationStatusCode;
}({});
var $2f53fee15f29b056$export$9b103978210e9b0f = /*#__PURE__*/ function(UnifiedFundsTransferFailureReason) {
    /** The `UnifiedFundsTransfer` failed because the source and destination accounts do not belong to the same product. */ UnifiedFundsTransferFailureReason["ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT"] = "ACCOUNTS_DO_NOT_BELONG_TO_SAME_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because the account is closed. */ UnifiedFundsTransferFailureReason["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The `UnifiedFundsTransfer` failed because the account is frozen. */ UnifiedFundsTransferFailureReason["ACCOUNT_FROZEN"] = "ACCOUNT_FROZEN";
    /** The `UnifiedFundsTransfer` failed because the account is not active. */ UnifiedFundsTransferFailureReason["ACCOUNT_NOT_ACTIVE"] = "ACCOUNT_NOT_ACTIVE";
    /** The `UnifiedFundsTransfer` failed because the account could not be found. */ UnifiedFundsTransferFailureReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The `UnifiedFundsTransfer` failed because the account was not provided. */ UnifiedFundsTransferFailureReason["ACCOUNT_NOT_PROVIDED"] = "ACCOUNT_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because ACH loads are not allowed by the program. */ UnifiedFundsTransferFailureReason["ACH_LOAD_NOT_ALLOWED_BY_PROGRAM"] = "ACH_LOAD_NOT_ALLOWED_BY_PROGRAM";
    /** The `UnifiedFundsTransfer` failed because compliance verification failed. */ UnifiedFundsTransferFailureReason["ANI_VERIFICATION_FAILED"] = "ANI_VERIFICATION_FAILED";
    /** The `UnifiedFundsTransfer` failed because the CVC3/DCVV is invalid. */ UnifiedFundsTransferFailureReason["BAD_CVC3_DCVV"] = "BAD_CVC3_DCVV";
    /** The `UnifiedFundsTransfer` failed because the CVV is invalid. */ UnifiedFundsTransferFailureReason["BAD_CVV"] = "BAD_CVV";
    /** The `UnifiedFundsTransfer` failed because the CVV2 is invalid. */ UnifiedFundsTransferFailureReason["BAD_CVV2"] = "BAD_CVV2";
    /** The `UnifiedFundsTransfer` failed because the bank-managed beta account feature is not enabled. */ UnifiedFundsTransferFailureReason["BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED"] = "BANK_MANAGED_BETA_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the card has been blocked. */ UnifiedFundsTransferFailureReason["BLOCKED_CARD"] = "BLOCKED_CARD";
    /** The `UnifiedFundsTransfer` failed because the card funding feature is not enabled. */ UnifiedFundsTransferFailureReason["CARD_FUNDING_FEATURE_NOT_ENABLED"] = "CARD_FUNDING_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the cash back limit has been exceeded. */ UnifiedFundsTransferFailureReason["CASH_BACK_LIMIT_EXCEEDED"] = "CASH_BACK_LIMIT_EXCEEDED";
    /** The `UnifiedFundsTransfer` failed because cash fund-out is not supported on this product. */ UnifiedFundsTransferFailureReason["CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT"] = "CASH_FUND_OUT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because the charge-off amount exceeds the account balance. */ UnifiedFundsTransferFailureReason["CHARGE_OFF_EXCEEDS_BALANCE"] = "CHARGE_OFF_EXCEEDS_BALANCE";
    /** The `UnifiedFundsTransfer` failed because the check-capable account feature is not enabled. */ UnifiedFundsTransferFailureReason["CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED"] = "CHECK_CAPABLE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because check payments are not supported on this product. */ UnifiedFundsTransferFailureReason["CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT"] = "CHECK_PAYMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because of chip card ARQC validation failure. */ UnifiedFundsTransferFailureReason["CHIP_CARD_ARQC_VALIDATION_FAILURE"] = "CHIP_CARD_ARQC_VALIDATION_FAILURE";
    /** The `UnifiedFundsTransfer` failed because the commercial credit (pay-in-full) feature is not enabled. */ UnifiedFundsTransferFailureReason["COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED"] = "COMMERCIAL_CREDIT_PAY_IN_FULL_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because compliance verification failed. */ UnifiedFundsTransferFailureReason["COMPLIANCE_VERIFICATION_FAILED"] = "COMPLIANCE_VERIFICATION_FAILED";
    /** The `UnifiedFundsTransfer` failed because the corporate bank account feature is not enabled. */ UnifiedFundsTransferFailureReason["CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED"] = "CORPORATE_BANK_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the credit card feature is not enabled. */ UnifiedFundsTransferFailureReason["CREDIT_CARD_FEATURE_NOT_ENABLED"] = "CREDIT_CARD_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because a credit limit has not been set on the account. */ UnifiedFundsTransferFailureReason["CREDIT_LIMIT_NOT_SET_ON_ACCOUNT"] = "CREDIT_LIMIT_NOT_SET_ON_ACCOUNT";
    /** The `UnifiedFundsTransfer` failed because the source and destination accounts use different currencies. */ UnifiedFundsTransferFailureReason["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The `UnifiedFundsTransfer` failed because the DDA feature is not enabled. */ UnifiedFundsTransferFailureReason["DDA_FEATURE_NOT_ENABLED"] = "DDA_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the debit card feature is not enabled. */ UnifiedFundsTransferFailureReason["DEBIT_CARD_FEATURE_NOT_ENABLED"] = "DEBIT_CARD_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the dispute chargeback feature is not enabled. */ UnifiedFundsTransferFailureReason["DISPUTE_CHARGEBACK_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because provisional credit for chargebacks is not enabled. */ UnifiedFundsTransferFailureReason["DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED"] = "DISPUTE_CHARGEBACK_PROVISIONAL_CREDIT_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the transaction was declined with 'Do not honor' response. */ UnifiedFundsTransferFailureReason["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    /** The `UnifiedFundsTransfer` failed because the transaction exceeds the approval amount limit. */ UnifiedFundsTransferFailureReason["EXCEEDS_APPROVAL_AMOUNT_LIMIT"] = "EXCEEDS_APPROVAL_AMOUNT_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the transaction exceeds the withdrawal frequency limit. */ UnifiedFundsTransferFailureReason["EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT"] = "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the card has expired. */ UnifiedFundsTransferFailureReason["EXPIRED_CARD"] = "EXPIRED_CARD";
    /** The `UnifiedFundsTransfer` failed because external money movement is not supported on this product. */ UnifiedFundsTransferFailureReason["EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT"] = "EXTERNAL_MONEY_MOVEMENT_NOT_SUPPORTED_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because fee collection failed. */ UnifiedFundsTransferFailureReason["FEE_COLLECTION_FAILED"] = "FEE_COLLECTION_FAILED";
    /** The `UnifiedFundsTransfer` failed because fee reversal failed. */ UnifiedFundsTransferFailureReason["FEE_REVERSAL_FAILED"] = "FEE_REVERSAL_FAILED";
    /** The `UnifiedFundsTransfer` fee was reversed. */ UnifiedFundsTransferFailureReason["FEE_REVERSED"] = "FEE_REVERSED";
    /** The `UnifiedFundsTransfer` failed because the fleet feature is not enabled. */ UnifiedFundsTransferFailureReason["FLEET_FEATURE_NOT_ENABLED"] = "FLEET_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the funding account feature is not enabled. */ UnifiedFundsTransferFailureReason["FUNDING_ACCOUNT_FEATURE_NOT_ENABLED"] = "FUNDING_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the funding card is not supported. */ UnifiedFundsTransferFailureReason["FUNDING_CARD_NOT_SUPPORTED"] = "FUNDING_CARD_NOT_SUPPORTED";
    /** The `UnifiedFundsTransfer` failed because the Highnote account feature is not enabled. */ UnifiedFundsTransferFailureReason["HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED"] = "HIGHNOTE_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the idempotency key was not provided. */ UnifiedFundsTransferFailureReason["IDEMPOTENCY_KEY_NOT_PROVIDED"] = "IDEMPOTENCY_KEY_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because the source account has insufficient funds. */ UnifiedFundsTransferFailureReason["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The `UnifiedFundsTransfer` failed because of an internal server error. */ UnifiedFundsTransferFailureReason["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    /** The `UnifiedFundsTransfer` failed because inter-financial account transfer rules were not satisfied. */ UnifiedFundsTransferFailureReason["INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED"] = "INTER_FINANCIAL_ACCOUNT_TRANSFER_RULES_NOT_PASSED";
    /** The `UnifiedFundsTransfer` failed because the amount is invalid. */ UnifiedFundsTransferFailureReason["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    /** The `UnifiedFundsTransfer` failed because the authorization has an invalid expiration. */ UnifiedFundsTransferFailureReason["INVALID_AUTHORIZATION_EXPIRATION"] = "INVALID_AUTHORIZATION_EXPIRATION";
    /** The `UnifiedFundsTransfer` failed because the card number is invalid. */ UnifiedFundsTransferFailureReason["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    /** The `UnifiedFundsTransfer` failed because the disbursement amount is invalid. */ UnifiedFundsTransferFailureReason["INVALID_DISBURSEMENT_AMOUNT"] = "INVALID_DISBURSEMENT_AMOUNT";
    /** The `UnifiedFundsTransfer` failed because the merchant is invalid. */ UnifiedFundsTransferFailureReason["INVALID_MERCHANT"] = "INVALID_MERCHANT";
    /** The `UnifiedFundsTransfer` failed because the track data is invalid. */ UnifiedFundsTransferFailureReason["INVALID_TRACK_DATA"] = "INVALID_TRACK_DATA";
    /** The `UnifiedFundsTransfer` failed because the transaction is invalid. */ UnifiedFundsTransferFailureReason["INVALID_TRANSACTION"] = "INVALID_TRANSACTION";
    /** The `UnifiedFundsTransfer` failed because the JIT (Just-In-Time) feature is not enabled. */ UnifiedFundsTransferFailureReason["JIT_FEATURE_NOT_ENABLED"] = "JIT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the merchant funding feature is not enabled. */ UnifiedFundsTransferFailureReason["MERCHANT_FUNDING_FEATURE_NOT_ENABLED"] = "MERCHANT_FUNDING_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the merchant settlement feature is not enabled. */ UnifiedFundsTransferFailureReason["MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED"] = "MERCHANT_SETTLEMENT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed due to a network error. */ UnifiedFundsTransferFailureReason["NETWORK_ERROR"] = "NETWORK_ERROR";
    /** The `UnifiedFundsTransfer` failed because the network is not supported. */ UnifiedFundsTransferFailureReason["NETWORK_NOT_SUPPORTED"] = "NETWORK_NOT_SUPPORTED";
    /** The `UnifiedFundsTransfer` failed because the account is not organization-owned as required. */ UnifiedFundsTransferFailureReason["NOT_AN_ORGANIZATION_OWNED_ACCOUNT"] = "NOT_AN_ORGANIZATION_OWNED_ACCOUNT";
    /** The `UnifiedFundsTransfer` failed because the balance is insufficient to reduce the credit limit. */ UnifiedFundsTransferFailureReason["NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT"] = "NOT_ENOUGH_BALANCE_TO_REDUCE_CREDIT_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the ODF feature is not enabled. */ UnifiedFundsTransferFailureReason["ODF_FEATURE_NOT_ENABLED"] = "ODF_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the organization ID was not provided. */ UnifiedFundsTransferFailureReason["ORGANIZATION_ID_NOT_PROVIDED"] = "ORGANIZATION_ID_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because originated ACH unloads are not supported on this product. */ UnifiedFundsTransferFailureReason["ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT"] = "ORIGINATED_ACH_UNLOAD_NOT_SUPPORTED_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because the partial funding feature is not enabled. */ UnifiedFundsTransferFailureReason["PARTIAL_FUNDING_FEATURE_NOT_ENABLED"] = "PARTIAL_FUNDING_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the payroll advance feature is not enabled on the account. */ UnifiedFundsTransferFailureReason["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the payroll employer advance feature is not enabled on the account. */ UnifiedFundsTransferFailureReason["PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_EMPLOYER_ADVANCE_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the prepaid card feature is not enabled. */ UnifiedFundsTransferFailureReason["PREPAID_CARD_FEATURE_NOT_ENABLED"] = "PREPAID_CARD_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the pre-authorization has expired. */ UnifiedFundsTransferFailureReason["PRE_AUTHORIZATION_EXPIRED"] = "PRE_AUTHORIZATION_EXPIRED";
    /** The `UnifiedFundsTransfer` failed because the product funding feature is not enabled. */ UnifiedFundsTransferFailureReason["PRODUCT_FUNDING_FEATURE_NOT_ENABLED"] = "PRODUCT_FUNDING_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the product-secured deposit account feature is not enabled. */ UnifiedFundsTransferFailureReason["PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "PRODUCT_SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the pseudo balance feature is not enabled. */ UnifiedFundsTransferFailureReason["PSEUDO_BALANCE_NOT_ENABLED"] = "PSEUDO_BALANCE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the pull payment did not succeed. */ UnifiedFundsTransferFailureReason["PULL_PAYMENT_FAILED"] = "PULL_PAYMENT_FAILED";
    /** The `UnifiedFundsTransfer` failed because the push payment did not succeed. */ UnifiedFundsTransferFailureReason["PUSH_PAYMENT_FAILED"] = "PUSH_PAYMENT_FAILED";
    /** The `UnifiedFundsTransfer` failed because the receivable purchase feature is not enabled. */ UnifiedFundsTransferFailureReason["RECEIVABLE_PURCHASE_NOT_ENABLED"] = "RECEIVABLE_PURCHASE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the repayment account is not present on the product. */ UnifiedFundsTransferFailureReason["REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT"] = "REPAYMENT_ACCOUNT_NOT_PRESENT_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because the transaction is from a restricted location. */ UnifiedFundsTransferFailureReason["RESTRICTED_LOCATION"] = "RESTRICTED_LOCATION";
    /** The `UnifiedFundsTransfer` failed because the reward point feature is not enabled. */ UnifiedFundsTransferFailureReason["REWARD_POINT_FEATURE_NOT_ENABLED"] = "REWARD_POINT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the transaction needs to be re-entered. */ UnifiedFundsTransferFailureReason["RE_ENTER_TRANSACTION"] = "RE_ENTER_TRANSACTION";
    /** The `UnifiedFundsTransfer` failed because the transaction was declined due to risk assessment. */ UnifiedFundsTransferFailureReason["RISK_DECLINE"] = "RISK_DECLINE";
    /** The `UnifiedFundsTransfer` failed because the secured deposit account feature is not enabled. */ UnifiedFundsTransferFailureReason["SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED"] = "SECURED_DEPOSIT_ACCOUNT_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because the secure card feature is not enabled. */ UnifiedFundsTransferFailureReason["SECURE_CARD_FEATURE_NOT_ENABLED"] = "SECURE_CARD_FEATURE_NOT_ENABLED";
    /** The `UnifiedFundsTransfer` failed because of special conditions that do not require card pickup. */ UnifiedFundsTransferFailureReason["SPECIAL_CONDITION_NO_PICK_UP"] = "SPECIAL_CONDITION_NO_PICK_UP";
    /** The `UnifiedFundsTransfer` failed because the card has been suspended. */ UnifiedFundsTransferFailureReason["SUSPENDED_CARD"] = "SUSPENDED_CARD";
    /** The `UnifiedFundsTransfer` failed because the tenant ID was not provided. */ UnifiedFundsTransferFailureReason["TENANT_ID_NOT_PROVIDED"] = "TENANT_ID_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because the card has been terminated. */ UnifiedFundsTransferFailureReason["TERMINATED_CARD"] = "TERMINATED_CARD";
    /** The `UnifiedFundsTransfer` failed due to a timeout. */ UnifiedFundsTransferFailureReason["TIMEOUT"] = "TIMEOUT";
    /** The `UnifiedFundsTransfer` failed because the transaction ID was not provided. */ UnifiedFundsTransferFailureReason["TRANSACTION_ID_NOT_PROVIDED"] = "TRANSACTION_ID_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because the transaction type is not permitted. */ UnifiedFundsTransferFailureReason["TRANSACTION_NOT_PERMITTED"] = "TRANSACTION_NOT_PERMITTED";
    /** The `UnifiedFundsTransfer` failed because the transfer amount is below the program’s minimum reload limit. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_BELOW_MIN_PROGRAM_RELOAD_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the maximum allowed for credit distribution. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_AGGREGATE_CREDIT_DISTRIBUTION_AMOUNT";
    /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum card balance. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_CARD_BALANCE";
    /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum load limit. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_LOAD_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the transfer amount exceeds the program’s maximum reload limit. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT"] = "TRANSFER_AMOUNT_EXCEEDING_MAX_PROGRAM_RELOAD_LIMIT";
    /** The `UnifiedFundsTransfer` failed because the transfer amount is negative or zero. */ UnifiedFundsTransferFailureReason["TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO"] = "TRANSFER_AMOUNT_IS_NEGATIVE_OR_ZERO";
    /** The `UnifiedFundsTransfer` failed because transfers between different products are not allowed. */ UnifiedFundsTransferFailureReason["TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED"] = "TRANSFER_BETWEEN_PRODUCTS_NOT_ALLOWED";
    /** The `UnifiedFundsTransfer` failed because the accounts do not have the same primary account holder. */ UnifiedFundsTransferFailureReason["TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED"] = "TRANSFER_CONDITION_SAME_PRIMARY_ACCOUNT_HOLDER_NOT_SATISFIED";
    /** The `UnifiedFundsTransfer` failed because the transfer is not permitted. */ UnifiedFundsTransferFailureReason["TRANSFER_NOT_PERMITTED"] = "TRANSFER_NOT_PERMITTED";
    /** The `UnifiedFundsTransfer` failed because transfers between the source and destination accounts are not supported. */ UnifiedFundsTransferFailureReason["TRANSFER_NOT_SUPPORTED"] = "TRANSFER_NOT_SUPPORTED";
    /** The `UnifiedFundsTransfer` failed because this product does not support this type of transfer. */ UnifiedFundsTransferFailureReason["TRANSFER_NOT_SUPPORTED_ON_PRODUCT"] = "TRANSFER_NOT_SUPPORTED_ON_PRODUCT";
    /** The `UnifiedFundsTransfer` failed because the transfer orchestration ID was not provided. */ UnifiedFundsTransferFailureReason["TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED"] = "TRANSFER_ORCHESTRATION_ID_NOT_PROVIDED";
    /** The `UnifiedFundsTransfer` failed because the card has not been activated. */ UnifiedFundsTransferFailureReason["UNACTIVATED_CARD"] = "UNACTIVATED_CARD";
    /** The `UnifiedFundsTransfer` failed because the valid account amount is not supported. */ UnifiedFundsTransferFailureReason["VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED"] = "VALID_ACCOUNT_AMOUNT_NOT_SUPPORTED";
    return UnifiedFundsTransferFailureReason;
}({});
var $2f53fee15f29b056$export$b41a4b10f14728b9 = /*#__PURE__*/ function(UnifiedFundsTransferStatus) {
    /** The `UnifiedFundsTransfer` has been completed. */ UnifiedFundsTransferStatus["COMPLETED"] = "COMPLETED";
    /** The `UnifiedFundsTransfer` has failed. */ UnifiedFundsTransferStatus["FAILED"] = "FAILED";
    /** The `UnifiedFundsTransfer` has been initiated and is being processed. */ UnifiedFundsTransferStatus["PROCESSING"] = "PROCESSING";
    return UnifiedFundsTransferStatus;
}({});
var $2f53fee15f29b056$export$10e13e1ba9a65b3f = /*#__PURE__*/ function(UnsuspendCardDigitalWalletTokenReason) {
    /** A lost or stolen device has been found or recovered. */ UnsuspendCardDigitalWalletTokenReason["DEVICE_FOUND"] = "DEVICE_FOUND";
    /**
   * After reviewing transaction history,
   * the account holder or `Highnote` confirmed that there were no fraudulent transactions.
   */ UnsuspendCardDigitalWalletTokenReason["NON_FRAUDULENT_TRANSACTIONS"] = "NON_FRAUDULENT_TRANSACTIONS";
    /** Any other reason for reactivating the card digital wallet token. */ UnsuspendCardDigitalWalletTokenReason["OTHER"] = "OTHER";
    return UnsuspendCardDigitalWalletTokenReason;
}({});
var $2f53fee15f29b056$export$485e0261fd59014b = /*#__PURE__*/ function(UserDefinedFieldDefinitionDataType) {
    /** A boolean */ UserDefinedFieldDefinitionDataType["BOOLEAN"] = "BOOLEAN";
    /** An integer */ UserDefinedFieldDefinitionDataType["INTEGER"] = "INTEGER";
    /** A string */ UserDefinedFieldDefinitionDataType["STRING"] = "STRING";
    return UserDefinedFieldDefinitionDataType;
}({});
var $2f53fee15f29b056$export$8913f439a58ec48 = /*#__PURE__*/ function(UserDefinedFieldDefinitionRelationshipType) {
    /** The `FinancialAccount` type. */ UserDefinedFieldDefinitionRelationshipType["FINANCIAL_ACCOUNT"] = "FINANCIAL_ACCOUNT";
    /** The `PaymentCard` type. */ UserDefinedFieldDefinitionRelationshipType["PAYMENT_CARD"] = "PAYMENT_CARD";
    /** The `WireTransfer` type. */ UserDefinedFieldDefinitionRelationshipType["WIRE_TRANSFER"] = "WIRE_TRANSFER";
    return UserDefinedFieldDefinitionRelationshipType;
}({});
var $2f53fee15f29b056$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    /** Admin role. This role gives the user all permissions available */ UserRole["ADMIN"] = "ADMIN";
    /** A role given to an individual who is a developer in your organization. Similar to admin without organization settings permission. */ UserRole["DEVELOPER"] = "DEVELOPER";
    /** Finance role. This role gives the user all permissions except developer settings and organization settings. */ UserRole["FINANCE"] = "FINANCE";
    /** Support role. This role gives the user permissions for cards, transactions, applications, financial accounts, and account holders. */ UserRole["SUPPORT"] = "SUPPORT";
    /** Unspecified role for users with no role */ UserRole["UNSPECIFIED"] = "UNSPECIFIED";
    /** User role. This is a generic role that should be applied to all users. */ UserRole["USER"] = "USER";
    return UserRole;
}({});
var $2f53fee15f29b056$export$a523f15c55668f08 = /*#__PURE__*/ function(ValidatedAddressLabel) {
    /** Business address. */ ValidatedAddressLabel["BUSINESS"] = "BUSINESS";
    /** Commercial Mail Receiving Agency address. */ ValidatedAddressLabel["CMRA"] = "CMRA";
    /** Inactive address. */ ValidatedAddressLabel["INACTIVE"] = "INACTIVE";
    /** PO Box. */ ValidatedAddressLabel["PO_BOX"] = "PO_BOX";
    /** Residential address. */ ValidatedAddressLabel["RESIDENTIAL"] = "RESIDENTIAL";
    /** Extended portion of the address is unconfirmed. */ ValidatedAddressLabel["UNCONFIRMED_EXTENDED_ADDRESS"] = "UNCONFIRMED_EXTENDED_ADDRESS";
    /** Unsecured location address. */ ValidatedAddressLabel["UNSECURED_LOCATION"] = "UNSECURED_LOCATION";
    /** Vacant address. */ ValidatedAddressLabel["VACANT"] = "VACANT";
    return ValidatedAddressLabel;
}({});
var $2f53fee15f29b056$export$bdc24651525e5413 = /*#__PURE__*/ function(VelocityConstraintLevel) {
    /** This constraint level will evaluate the associated cumulative rule at the account level. */ VelocityConstraintLevel["ACCOUNT"] = "ACCOUNT";
    /** This constraint level will evaluate the associated cumulative rule at the account holder level. */ VelocityConstraintLevel["ACCOUNT_HOLDER"] = "ACCOUNT_HOLDER";
    /** This constraint level will evaluate the associated cumulative rule at the card level. */ VelocityConstraintLevel["CARD"] = "CARD";
    /**
   * This constraint level will evaluate the associated cumulative rule at the card level.
   * If the card is reissued all balances will transfer to new card
   */ VelocityConstraintLevel["CARD_LINEAGE"] = "CARD_LINEAGE";
    /** This constraint level will evaluate the associated cumulative rule at the platform level. */ VelocityConstraintLevel["PLATFORM"] = "PLATFORM";
    /** This constraint level will evaluate the associated cumulative rule at the product level. */ VelocityConstraintLevel["PRODUCT"] = "PRODUCT";
    return VelocityConstraintLevel;
}({});
var $2f53fee15f29b056$export$c927c776de337d75 = /*#__PURE__*/ function(VelocityRuleWindow) {
    /**
   * A cooldown period of one hour. The associated velocity rule will only allow transactions that comply with a
   * one-hour cooldown window. For example, with a count rule of 1, the cardholder must wait one hour between
   * transactions.
   */ VelocityRuleWindow["COOLDOWN_HOUR"] = "COOLDOWN_HOUR";
    /**
   * A cooldown period of one minute. The associated velocity rule will only allow transactions that comply with a
   * one-minute cooldown window. For example, with a count rule of 1, the cardholder must wait one minute between
   * transactions.
   */ VelocityRuleWindow["COOLDOWN_MINUTE"] = "COOLDOWN_MINUTE";
    /** A single calendar day. UTC start to UTC end 00:00:00 UTC to 11:59.59:00 UTC */ VelocityRuleWindow["DAILY"] = "DAILY";
    /** A calendar month. UTC start of month to UTC end of month. */ VelocityRuleWindow["MONTHLY"] = "MONTHLY";
    /** 90 calendar days moving window. One calendar day is from UTC start of day to UTC end of day. */ VelocityRuleWindow["NINETY_DAYS"] = "NINETY_DAYS";
    /** Per transaction (associated velocity rule is evaluated on every transaction individually). */ VelocityRuleWindow["PER_TRANSACTION"] = "PER_TRANSACTION";
    /**
   * A calendar quarter. UTC start of quarter to UTC end of quarter.
   * Q1: January, February, March
   * Q2: April, May, June
   * Q3: July, August September
   * Q4: October, November, December
   */ VelocityRuleWindow["QUARTERLY"] = "QUARTERLY";
    /** A calendar week. UTC start of week to UTC end of week. */ VelocityRuleWindow["WEEKLY"] = "WEEKLY";
    /** A calendar year. UTC start of year to UTC end of year. */ VelocityRuleWindow["YEARLY"] = "YEARLY";
    return VelocityRuleWindow;
}({});
var $2f53fee15f29b056$export$a0d894ccb95d3220 = /*#__PURE__*/ function(VerifiedExternalBankAccountLinkExperienceFlow) {
    /** Used to support link experience on Android device. */ VerifiedExternalBankAccountLinkExperienceFlow["ANDROID_SDK"] = "ANDROID_SDK";
    /** Used to support hosted link experience on an Android device. */ VerifiedExternalBankAccountLinkExperienceFlow["ANDROID_WEB_HOSTED"] = "ANDROID_WEB_HOSTED";
    /** Used to support link experience on IOS device. */ VerifiedExternalBankAccountLinkExperienceFlow["IOS_SDK"] = "IOS_SDK";
    /** Used to support hosted link experience on an IOS device. */ VerifiedExternalBankAccountLinkExperienceFlow["IOS_WEB_HOSTED"] = "IOS_WEB_HOSTED";
    /** Used to support hosted link experience in the browser. */ VerifiedExternalBankAccountLinkExperienceFlow["WEB_HOSTED"] = "WEB_HOSTED";
    /** Used to support link experience in the browser. */ VerifiedExternalBankAccountLinkExperienceFlow["WEB_SDK"] = "WEB_SDK";
    return VerifiedExternalBankAccountLinkExperienceFlow;
}({});
var $2f53fee15f29b056$export$3b2534b238024892 = /*#__PURE__*/ function(VirtualCardPersonalizationType) {
    /** The virtual card profile track has business authorized person Name */ VirtualCardPersonalizationType["BUSINESS_AUTHORIZED_PERSON_NAME"] = "BUSINESS_AUTHORIZED_PERSON_NAME";
    /** The virtual card profile track has default Business Name */ VirtualCardPersonalizationType["BUSINESS_NAME"] = "BUSINESS_NAME";
    /** The virtual card profile track has default person Name */ VirtualCardPersonalizationType["PERSON_NAME"] = "PERSON_NAME";
    return VirtualCardPersonalizationType;
}({});
var $2f53fee15f29b056$export$6abda5f96374cb01 = /*#__PURE__*/ function(VisaAmountSignage) {
    /** A refund on the invoice */ VisaAmountSignage["CREDIT"] = "CREDIT";
    /** A charge on the invoice */ VisaAmountSignage["DEBIT"] = "DEBIT";
    /** Not implemented */ VisaAmountSignage["NULL"] = "NULL";
    return VisaAmountSignage;
}({});
var $2f53fee15f29b056$export$ca46a52c5b93c91a = /*#__PURE__*/ function(VisaCavvResultCode) {
    /** The CAVV for the 3DS verification failed validation. */ VisaCavvResultCode["FAILED"] = "FAILED";
    /** The CAVV for the 3DS verification failed an issuer validation attempt. */ VisaCavvResultCode["FAILED_ISSUER_ATTEMPT"] = "FAILED_ISSUER_ATTEMPT";
    /** The CAVV for the 3DS verification failed a Visa validation attempt. */ VisaCavvResultCode["FAILED_VISA_ATTEMPT"] = "FAILED_VISA_ATTEMPT";
    /** The CAVV for the 3DS verification failed a Visa validation attempt while the issuer's Access Control Server was unavailable. */ VisaCavvResultCode["FAILED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE"] = "FAILED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE";
    /** The CAVV for the 3DS verification was not validated. */ VisaCavvResultCode["NOT_VERIFIED"] = "NOT_VERIFIED";
    /** The CAVV for the 3DS verification was not validated but authentication was attempted. */ VisaCavvResultCode["NOT_VERIFIED_ATTEMPT"] = "NOT_VERIFIED_ATTEMPT";
    /** The CAVV for the 3DS verification was not validated because the issuer is not participating in 3DS. */ VisaCavvResultCode["NOT_VERIFIED_ISSUER_NOT_PARTICIPATING"] = "NOT_VERIFIED_ISSUER_NOT_PARTICIPATING";
    /** The CAVV for the 3DS verification was not validated but authentication was successful. */ VisaCavvResultCode["NOT_VERIFIED_SUCCESS"] = "NOT_VERIFIED_SUCCESS";
    /** The CAVV for the 3DS verification passed validation. */ VisaCavvResultCode["PASSED"] = "PASSED";
    /** The CAVV for the 3DS verification passed an issuer validation attempt. */ VisaCavvResultCode["PASSED_ISSUER_ATTEMPT"] = "PASSED_ISSUER_ATTEMPT";
    /** The CAVV for the 3DS verification passed validation, but liability shift does not apply. */ VisaCavvResultCode["PASSED_NO_LIABILITY_SHIFT"] = "PASSED_NO_LIABILITY_SHIFT";
    /** The CAVV for the 3DS verification passed a Visa validation attempt. */ VisaCavvResultCode["PASSED_VISA_ATTEMPT"] = "PASSED_VISA_ATTEMPT";
    /** The CAVV for the 3DS verification passed a Visa validation attempt while the issuer's Access Control Server was unavailable. */ VisaCavvResultCode["PASSED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE"] = "PASSED_VISA_ATTEMPT_ISSUER_ACS_UNAVAILABLE";
    return VisaCavvResultCode;
}({});
var $2f53fee15f29b056$export$1906004621edd832 = /*#__PURE__*/ function(VisaDiscountTreatment) {
    /** No invoice-level discounts apply */ VisaDiscountTreatment["NO_DISCOUNT"] = "NO_DISCOUNT";
    /** Tax was calculated on post-discount total */ VisaDiscountTreatment["POST_DISCOUNT"] = "POST_DISCOUNT";
    /** Tax was calculated on pre-discount total */ VisaDiscountTreatment["PRE_DISCOUNT"] = "PRE_DISCOUNT";
    return VisaDiscountTreatment;
}({});
var $2f53fee15f29b056$export$90a6933c8000e07e = /*#__PURE__*/ function(VisaEvChargingReasonCode) {
    /** Failure to lock or unlock connector */ VisaEvChargingReasonCode["CONNECTOR_LOCK_FAILURE"] = "CONNECTOR_LOCK_FAILURE";
    /** Communication failure with the vehicle */ VisaEvChargingReasonCode["EV_COMMUNICATION_ERROR"] = "EV_COMMUNICATION_ERROR";
    /** Ground fault circuit interrupter has been activated */ VisaEvChargingReasonCode["GROUND_FAILURE"] = "GROUND_FAILURE";
    /** Temperature inside charge point is too high */ VisaEvChargingReasonCode["HIGH_TEMPERATURE"] = "HIGH_TEMPERATURE";
    /** Error in internal hardware orsoftware component */ VisaEvChargingReasonCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    /** No error to report */ VisaEvChargingReasonCode["NO_ERROR"] = "NO_ERROR";
    /** Abnormal completion of charging */ VisaEvChargingReasonCode["OTHER_ERROR"] = "OTHER_ERROR";
    /** Over current protection device has tripped */ VisaEvChargingReasonCode["OVER_CURRENT_FAILURE"] = "OVER_CURRENT_FAILURE";
    /** Voltage has risen above an acceptable level */ VisaEvChargingReasonCode["OVER_VOLTAGE"] = "OVER_VOLTAGE";
    /** Abnormal completion of charging related to payment */ VisaEvChargingReasonCode["PAYMENT_RELATED_ERROR"] = "PAYMENT_RELATED_ERROR";
    /** Failure to read power meter */ VisaEvChargingReasonCode["POWER_METER_FAILURE"] = "POWER_METER_FAILURE";
    /** Failure to control power switch */ VisaEvChargingReasonCode["POWER_SWITCH_FAILURE"] = "POWER_SWITCH_FAILURE";
    /** Failure with idTag reader */ VisaEvChargingReasonCode["READER_FAILURE"] = "READER_FAILURE";
    /** Unable to perform a reset */ VisaEvChargingReasonCode["RESET_FAILURE"] = "RESET_FAILURE";
    /** Voltage has dropped below an acceptable level */ VisaEvChargingReasonCode["UNDER_VOLTAGE"] = "UNDER_VOLTAGE";
    /** Wireless communication device reports a weak signal */ VisaEvChargingReasonCode["WEAK_SIGNAL"] = "WEAK_SIGNAL";
    return VisaEvChargingReasonCode;
}({});
var $2f53fee15f29b056$export$8283f995ba889fed = /*#__PURE__*/ function(VisaEvConnectorType) {
    /** AC - GB/T */ VisaEvConnectorType["AC_GBT"] = "AC_GBT";
    /** AC - J1772 Type 1 */ VisaEvConnectorType["AC_J1772"] = "AC_J1772";
    /** AC - Mennekes - Type 2 */ VisaEvConnectorType["AC_MENNEKES"] = "AC_MENNEKES";
    /** DC - CCS1 */ VisaEvConnectorType["DC_CCS1"] = "DC_CCS1";
    /** DC - CCS2 */ VisaEvConnectorType["DC_CCS2"] = "DC_CCS2";
    /** DC - CHAdeMO */ VisaEvConnectorType["DC_CHADEMO"] = "DC_CHADEMO";
    /** DC - GB/T */ VisaEvConnectorType["DC_GBT"] = "DC_GBT";
    /** North American Charging Standard. Also known as the Tesla charging standard */ VisaEvConnectorType["NACS"] = "NACS";
    return VisaEvConnectorType;
}({});
var $2f53fee15f29b056$export$a69f5af29b1c59c2 = /*#__PURE__*/ function(VisaFleetDiscountAgent) {
    /** Discount was calculated by the Merchant */ VisaFleetDiscountAgent["MERCHANT"] = "MERCHANT";
    /** Discount was calculated by Visa */ VisaFleetDiscountAgent["VISA"] = "VISA";
    return VisaFleetDiscountAgent;
}({});
var $2f53fee15f29b056$export$61bb633bb583dbb4 = /*#__PURE__*/ function(VisaFleetDiscountMethod) {
    /** Best of retail minus or cost plus discount method */ VisaFleetDiscountMethod["BEST_OF_RETAIL_MINUS_OR_COST_PLUS"] = "BEST_OF_RETAIL_MINUS_OR_COST_PLUS";
    /** Cost plus discount method */ VisaFleetDiscountMethod["COST_PLUS"] = "COST_PLUS";
    /** Retail minus discount method */ VisaFleetDiscountMethod["RETAIL_MINUS"] = "RETAIL_MINUS";
    return VisaFleetDiscountMethod;
}({});
var $2f53fee15f29b056$export$415a0d5a98c1292c = /*#__PURE__*/ function(VisaFleetPurchaseIdentifierFormat) {
    /** The Purchase Identifier represents an Invoice Number */ VisaFleetPurchaseIdentifierFormat["INVOICE"] = "INVOICE";
    /** The Purchase Identifier represents an Order Number */ VisaFleetPurchaseIdentifierFormat["ORDER"] = "ORDER";
    return VisaFleetPurchaseIdentifierFormat;
}({});
var $2f53fee15f29b056$export$be232b43b24b7b7e = /*#__PURE__*/ function(VisaFuelPurchaseType) {
    /** Purchase includes only fuel */ VisaFuelPurchaseType["FUEL_PURCHASE"] = "FUEL_PURCHASE";
    /** Purchase includes fuel and non-fuel items */ VisaFuelPurchaseType["MIXED"] = "MIXED";
    /** Purchase includes only non-fuel items */ VisaFuelPurchaseType["NON_FUEL_PURCHASE"] = "NON_FUEL_PURCHASE";
    return VisaFuelPurchaseType;
}({});
var $2f53fee15f29b056$export$8e0882cbe909e9ee = /*#__PURE__*/ function(VisaFuelServiceType) {
    /** Transaction occurred at a full-service fuel station */ VisaFuelServiceType["FULL_SERVICE"] = "FULL_SERVICE";
    /** Transaction occurred at a high speed dispense fuel station */ VisaFuelServiceType["HIGH_SPEED_DISPENSE"] = "HIGH_SPEED_DISPENSE";
    /** Transaction occurred at a self-service fuel station */ VisaFuelServiceType["SELF_SERVICE"] = "SELF_SERVICE";
    return VisaFuelServiceType;
}({});
var $2f53fee15f29b056$export$f0abeec415f20a4c = /*#__PURE__*/ function(VisaFuelType) {
    /** Additive Dosage */ VisaFuelType["ADDITIVE_DOSAGE"] = "ADDITIVE_DOSAGE";
    /** Aviation Biofuel (Gasoline) */ VisaFuelType["AV_BIOFUEL"] = "AV_BIOFUEL";
    /** Aviation Fuel 4 */ VisaFuelType["AV_FUEL_4"] = "AV_FUEL_4";
    /** Aviation Fuel 5 */ VisaFuelType["AV_FUEL_5"] = "AV_FUEL_5";
    /** Aviation Fuel JP8 */ VisaFuelType["AV_FUEL_JP8"] = "AV_FUEL_JP8";
    /** Aviation Fuel Premium */ VisaFuelType["AV_FUEL_PREMIUM"] = "AV_FUEL_PREMIUM";
    /** Aviation Fuel Regular */ VisaFuelType["AV_FUEL_REGULAR"] = "AV_FUEL_REGULAR";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_1"] = "AV_FUEL_UNDEFINED_1";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_2"] = "AV_FUEL_UNDEFINED_2";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_3"] = "AV_FUEL_UNDEFINED_3";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_4"] = "AV_FUEL_UNDEFINED_4";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_5"] = "AV_FUEL_UNDEFINED_5";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_6"] = "AV_FUEL_UNDEFINED_6";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_7"] = "AV_FUEL_UNDEFINED_7";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_8"] = "AV_FUEL_UNDEFINED_8";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_9"] = "AV_FUEL_UNDEFINED_9";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_10"] = "AV_FUEL_UNDEFINED_10";
    /** Undefined Aviation Fuel */ VisaFuelType["AV_FUEL_UNDEFINED_11"] = "AV_FUEL_UNDEFINED_11";
    /** B2 Diesel Blend 2% Biodiesel */ VisaFuelType["B2_DIESEL"] = "B2_DIESEL";
    /** B5 Diesel Blend 5% Biodiesel */ VisaFuelType["B5_DIESEL"] = "B5_DIESEL";
    /** B10 Diesel Blend 10% Biodiesel */ VisaFuelType["B10_DIESEL"] = "B10_DIESEL";
    /** B11 Diesel Blend 11% Biodiesel */ VisaFuelType["B11_DIESEL"] = "B11_DIESEL";
    /** B15 Diesel Blend 15% Biodiesel */ VisaFuelType["B15_DIESEL"] = "B15_DIESEL";
    /** B20 Diesel Blend 20% Biodiesel */ VisaFuelType["B20_DIESEL"] = "B20_DIESEL";
    /** B75 Diesel Blend 75% Biodiesel */ VisaFuelType["B75_DIESEL"] = "B75_DIESEL";
    /** B99 Diesel Blend 99% Biodiesel */ VisaFuelType["B99_DIESEL"] = "B99_DIESEL";
    /** B100 Diesel Blend 100% Biodiesel */ VisaFuelType["B100_DIESEL"] = "B100_DIESEL";
    /** Biodiesel Blend 2% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_2_OR_NT"] = "BIODIESEL_BLEND_2_OR_NT";
    /** Biodiesel Blend 5% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_5_OR_NT"] = "BIODIESEL_BLEND_5_OR_NT";
    /** Biodiesel Blend 10% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_10_OR_NT"] = "BIODIESEL_BLEND_10_OR_NT";
    /** Biodiesel Blend 11% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_11_OR_NT"] = "BIODIESEL_BLEND_11_OR_NT";
    /** Biodiesel Blend 15% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_15_OR_NT"] = "BIODIESEL_BLEND_15_OR_NT";
    /** Biodiesel Blend 20% Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_BLEND_20_OR_NT"] = "BIODIESEL_BLEND_20_OR_NT";
    /** Biodiesel Blend Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_OFF_ROAD_NON_TAXABLE"] = "BIODIESEL_OFF_ROAD_NON_TAXABLE";
    /** <Deprecated> Biodiesel Blend Off-Road (Non-Taxable) */ VisaFuelType["BIODIESEL_OFF_ROAD_NON_TAXABLE_35"] = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35";
    /** Biojet (Diesel) */ VisaFuelType["BIOJET"] = "BIOJET";
    /** Blended Diesel (#1 and #2) */ VisaFuelType["BLENDED_DIESEL_1_2"] = "BLENDED_DIESEL_1_2";
    /** <Deprecated> Bottled Propane */ VisaFuelType["BOTTLED_PROPANE"] = "BOTTLED_PROPANE";
    /** Compressed Natural Gas */ VisaFuelType["COMPRESSED_NAT_GAS"] = "COMPRESSED_NAT_GAS";
    /** DEF (Diesel Exhaust Fluid) */ VisaFuelType["DEF"] = "DEF";
    /** Diesel #1 Off-Road (Non-Taxable) */ VisaFuelType["DIESEL_1_OR_NT"] = "DIESEL_1_OR_NT";
    /** Diesel #1 Premium Off-Road (Non-Taxable) */ VisaFuelType["DIESEL_1_PREMIUM_OR_NT"] = "DIESEL_1_PREMIUM_OR_NT";
    /** Diesel #2 Off-Road (Non-Taxable) */ VisaFuelType["DIESEL_2_OR_NT"] = "DIESEL_2_OR_NT";
    /** Diesel #2 Premium Off-Road (Non-Taxable) */ VisaFuelType["DIESEL_2_PREMIUM_OR_NT"] = "DIESEL_2_PREMIUM_OR_NT";
    /** Diesel Off-Road (Non-Taxable)* */ VisaFuelType["DIESEL_OFF_ROAD_NON_TAXABLE"] = "DIESEL_OFF_ROAD_NON_TAXABLE";
    /** Diesel Off-Road (#1 and #2 Non-Taxable)* */ VisaFuelType["DIESEL_OFF_ROAD_TAXABLE"] = "DIESEL_OFF_ROAD_TAXABLE";
    /** Ethanol Blends E16-E84 */ VisaFuelType["E16_E84"] = "E16_E84";
    /** E-85 */ VisaFuelType["E85"] = "E85";
    /** <Deprecated> Ethanol (5.7% blend) */ VisaFuelType["ETHANOL_57"] = "ETHANOL_57";
    /** <Deprecated> Ethanol (7.7% blend) */ VisaFuelType["ETHANOL_77"] = "ETHANOL_77";
    /** EVC-1 – Level 1 charge = 110v 15 amp */ VisaFuelType["EVC_1"] = "EVC_1";
    /** EVC-2 – Level 2 charge = 240v 15-40 amp */ VisaFuelType["EVC_2"] = "EVC_2";
    /** EVC-3 – Level 3 charge = 480v 3 phase charge */ VisaFuelType["EVC_3"] = "EVC_3";
    /** Green Gasoline Mid/Plus (Plant based not petroleum based) */ VisaFuelType["GREEN_GAS_PLUS"] = "GREEN_GAS_PLUS";
    /** Green Gasoline Regular (Plant based not petroleum based) */ VisaFuelType["GREEN_GAS_REGULAR"] = "GREEN_GAS_REGULAR";
    /** Green Gasoline Premium/Super (Plant based not petroleum based) */ VisaFuelType["GREEN_GAS_SUPER"] = "GREEN_GAS_SUPER";
    /** Hydrogen H35 */ VisaFuelType["H35"] = "H35";
    /** Hydrogen H70 */ VisaFuelType["H70"] = "H70";
    /** Heating Oil */ VisaFuelType["HEATING_OIL"] = "HEATING_OIL";
    /** Jet Fuel */ VisaFuelType["JET_FUEL"] = "JET_FUEL";
    /** Kerosene – Low Sulfur */ VisaFuelType["KEROSENE"] = "KEROSENE";
    /** Kerosene – Low Sulfur (Non-Taxable) */ VisaFuelType["KEROSENE_LS_NT"] = "KEROSENE_LS_NT";
    /** Kerosene – Ultra Low Sulfur */ VisaFuelType["KEROSENE_ULS"] = "KEROSENE_ULS";
    /** Kerosene – Ultra Low Sulfur (Non-Taxable) */ VisaFuelType["KEROSENE_ULS_NT"] = "KEROSENE_ULS_NT";
    /** Liquid Natural Gas */ VisaFuelType["LNG"] = "LNG";
    /** Low Octane UNL */ VisaFuelType["LO_UNL"] = "LO_UNL";
    /** Liquid Propane Gas */ VisaFuelType["LPG"] = "LPG";
    /** <Deprecated> M-85 */ VisaFuelType["M85"] = "M85";
    /** Marine Diesel */ VisaFuelType["MARINE_DIESEL"] = "MARINE_DIESEL";
    /** Marine Fuel 1 */ VisaFuelType["MARINE_FUEL_1"] = "MARINE_FUEL_1";
    /** Marine Fuel 2 */ VisaFuelType["MARINE_FUEL_2"] = "MARINE_FUEL_2";
    /** Marine Fuel 3 */ VisaFuelType["MARINE_FUEL_3"] = "MARINE_FUEL_3";
    /** Marine Fuel 4 */ VisaFuelType["MARINE_FUEL_4"] = "MARINE_FUEL_4";
    /** Marine Fuel 5 */ VisaFuelType["MARINE_FUEL_5"] = "MARINE_FUEL_5";
    /** Marine – Other */ VisaFuelType["MARINE_FUEL_OTHER"] = "MARINE_FUEL_OTHER";
    /** Mid/Plus Gasoline */ VisaFuelType["MID_PLUS"] = "MID_PLUS";
    /** Mid/Plus 2 Gasoline */ VisaFuelType["MID_PLUS_2"] = "MID_PLUS_2";
    /** Mid/Plus 2 (10% Blend) */ VisaFuelType["MID_PLUS_2_10"] = "MID_PLUS_2_10";
    /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */ VisaFuelType["MID_PLUS_ETHANOL_57"] = "MID_PLUS_ETHANOL_57";
    /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */ VisaFuelType["MID_PLUS_ETHANOL_77"] = "MID_PLUS_ETHANOL_77";
    /** Miscellaneous Aviation Fuel */ VisaFuelType["MISC_AV_FUEL"] = "MISC_AV_FUEL";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL"] = "MISC_FUEL";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL_1"] = "MISC_FUEL_1";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL_2"] = "MISC_FUEL_2";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL_3"] = "MISC_FUEL_3";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL_4"] = "MISC_FUEL_4";
    /** Miscellaneous Fuel */ VisaFuelType["MISC_FUEL_5"] = "MISC_FUEL_5";
    /** Miscellaneous Marine Fuel */ VisaFuelType["MISC_MARINE_FUEL"] = "MISC_MARINE_FUEL";
    /** Miscellaneous Other Fuel */ VisaFuelType["MISC_OTHER_FUEL"] = "MISC_OTHER_FUEL";
    /** Miscellaneous Packaged Fuels */ VisaFuelType["MISC_PACKAGED_FUEL"] = "MISC_PACKAGED_FUEL";
    /** Other Fuel (Non-Taxable) */ VisaFuelType["OTHER_FUEL_NT"] = "OTHER_FUEL_NT";
    /** Packaged Additive */ VisaFuelType["PACKAGED_ADDITIVE"] = "PACKAGED_ADDITIVE";
    /** Packaged B99 */ VisaFuelType["PACKAGED_B99"] = "PACKAGED_B99";
    /** Packaged B100 */ VisaFuelType["PACKAGED_B100"] = "PACKAGED_B100";
    /** Packaged DEF (Diesel Exhaust Fluid) */ VisaFuelType["PACKAGED_DEF"] = "PACKAGED_DEF";
    /** Packaged Kerosene */ VisaFuelType["PACKAGED_KEROSENE"] = "PACKAGED_KEROSENE";
    /** Packaged Propane */ VisaFuelType["PACKAGED_PROPANE"] = "PACKAGED_PROPANE";
    /** Off-Road Mid/Plus 2 (Non-Taxable) */ VisaFuelType["PLUS_2_OR_NT"] = "PLUS_2_OR_NT";
    /** Mid/Plus Ethanol 2 (15% Blend) */ VisaFuelType["PLUS_ETHANOL_2_15"] = "PLUS_ETHANOL_2_15";
    /** Mid/Plus Ethanol (10% Blend) */ VisaFuelType["PLUS_ETHANOL_10"] = "PLUS_ETHANOL_10";
    /** Mid/Plus Ethanol (15% Blend) */ VisaFuelType["PLUS_ETHANOL_15"] = "PLUS_ETHANOL_15";
    /** Off-Road Mid/Plus (Non-Taxable) */ VisaFuelType["PLUS_OR_NT"] = "PLUS_OR_NT";
    /** Premium Diesel Blend >= 20% Biodiesel */ VisaFuelType["PREMIUM_BIODIESEL_BLEND_OVER_20"] = "PREMIUM_BIODIESEL_BLEND_OVER_20";
    /** Premium Diesel Blend <20% Biodiesel */ VisaFuelType["PREMIUM_BIODIESEL_BLEND_UNDER_20"] = "PREMIUM_BIODIESEL_BLEND_UNDER_20";
    /** Premium Diesel #1 */ VisaFuelType["PREMIUM_DIESEL_1"] = "PREMIUM_DIESEL_1";
    /** Premium Diesel #2 */ VisaFuelType["PREMIUM_DIESEL_2"] = "PREMIUM_DIESEL_2";
    /** Premium/Super Gasoline */ VisaFuelType["PREMIUM_SUPER"] = "PREMIUM_SUPER";
    /** Premium/Super 2 Gasoline */ VisaFuelType["PREMIUM_SUPER_2"] = "PREMIUM_SUPER_2";
    /** Premium/Super 2 (10% Blend) */ VisaFuelType["PREMIUM_SUPER_2_10"] = "PREMIUM_SUPER_2_10";
    /** <Deprecated> Premium/Super Ethanol (5.7% blend) */ VisaFuelType["PREMIUM_SUPER_ETHANOL_57"] = "PREMIUM_SUPER_ETHANOL_57";
    /** Racing Fuel */ VisaFuelType["RACING_FUEL"] = "RACING_FUEL";
    /** Recreational Fuel (90 Octane) */ VisaFuelType["RECREATIONAL_FUEL"] = "RECREATIONAL_FUEL";
    /** Reformulated 1 */ VisaFuelType["REFORMULATED_1"] = "REFORMULATED_1";
    /** Reformulated 2 */ VisaFuelType["REFORMULATED_2"] = "REFORMULATED_2";
    /** Reformulated 3 */ VisaFuelType["REFORMULATED_3"] = "REFORMULATED_3";
    /** Reformulated 4 */ VisaFuelType["REFORMULATED_4"] = "REFORMULATED_4";
    /** Reformulated 5 */ VisaFuelType["REFORMULATED_5"] = "REFORMULATED_5";
    /** Regular Gasoline */ VisaFuelType["REGULAR"] = "REGULAR";
    /** Regular Diesel #1 */ VisaFuelType["REGULAR_DIESEL_1"] = "REGULAR_DIESEL_1";
    /** Regular Diesel #2 */ VisaFuelType["REGULAR_DIESEL_2"] = "REGULAR_DIESEL_2";
    /** Regular Ethanol (10% Blend) */ VisaFuelType["REGULAR_ETHANOL_10"] = "REGULAR_ETHANOL_10";
    /** Regular Ethanol (15% Blend) */ VisaFuelType["REGULAR_ETHANOL_15"] = "REGULAR_ETHANOL_15";
    /** Off-Road Regular (Non-Taxable) */ VisaFuelType["REGULAR_OR_NT"] = "REGULAR_OR_NT";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_1"] = "RESERVED_1";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_2"] = "RESERVED_2";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_3"] = "RESERVED_3";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_4"] = "RESERVED_4";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_5"] = "RESERVED_5";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_6"] = "RESERVED_6";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_7"] = "RESERVED_7";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_8"] = "RESERVED_8";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_9"] = "RESERVED_9";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_10"] = "RESERVED_10";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_11"] = "RESERVED_11";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_12"] = "RESERVED_12";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_13"] = "RESERVED_13";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_14"] = "RESERVED_14";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_15"] = "RESERVED_15";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_16"] = "RESERVED_16";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_17"] = "RESERVED_17";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_18"] = "RESERVED_18";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_19"] = "RESERVED_19";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_20"] = "RESERVED_20";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_21"] = "RESERVED_21";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_22"] = "RESERVED_22";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_23"] = "RESERVED_23";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_24"] = "RESERVED_24";
    /** Reserved For Future Use */ VisaFuelType["RESERVED_25"] = "RESERVED_25";
    /** Off-Road Premium/Super 2 (Non-Taxable) */ VisaFuelType["SUPER_2_OR_NT"] = "SUPER_2_OR_NT";
    /** Premium/Super Ethanol 2 (15% Blend) */ VisaFuelType["SUPER_ETHANOL_2_15"] = "SUPER_ETHANOL_2_15";
    /** Premium/Super Ethanol (10% Blend) */ VisaFuelType["SUPER_ETHANOL_10"] = "SUPER_ETHANOL_10";
    /** Premium/Super Ethanol (15% Blend) */ VisaFuelType["SUPER_ETHANOL_15"] = "SUPER_ETHANOL_15";
    /** Off-Road Premium/Super (Non-Taxable) */ VisaFuelType["SUPER_OR_NT"] = "SUPER_OR_NT";
    /** <Deprecated> Ultra Low Sulfur #1 */ VisaFuelType["ULTRA_LOW_SULFUR_1"] = "ULTRA_LOW_SULFUR_1";
    /** <Deprecated> Ultra Low Sulfur #2 */ VisaFuelType["ULTRA_LOW_SULFUR_2"] = "ULTRA_LOW_SULFUR_2";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 2% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 5% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 10% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 11% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 15% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 20% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 100% */ VisaFuelType["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100";
    /** <Deprecated> Ultra Low Sulfur Premium Diesel #2 */ VisaFuelType["ULTRA_LOW_SULFUR_PREMIUM_1"] = "ULTRA_LOW_SULFUR_PREMIUM_1";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_1"] = "UNDEFINED_FUEL_1";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_2"] = "UNDEFINED_FUEL_2";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_3"] = "UNDEFINED_FUEL_3";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_4"] = "UNDEFINED_FUEL_4";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_5"] = "UNDEFINED_FUEL_5";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_6"] = "UNDEFINED_FUEL_6";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_7"] = "UNDEFINED_FUEL_7";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_8"] = "UNDEFINED_FUEL_8";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_9"] = "UNDEFINED_FUEL_9";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_10"] = "UNDEFINED_FUEL_10";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_11"] = "UNDEFINED_FUEL_11";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_12"] = "UNDEFINED_FUEL_12";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_13"] = "UNDEFINED_FUEL_13";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_14"] = "UNDEFINED_FUEL_14";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_15"] = "UNDEFINED_FUEL_15";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_16"] = "UNDEFINED_FUEL_16";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_17"] = "UNDEFINED_FUEL_17";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_18"] = "UNDEFINED_FUEL_18";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_19"] = "UNDEFINED_FUEL_19";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_20"] = "UNDEFINED_FUEL_20";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_21"] = "UNDEFINED_FUEL_21";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_22"] = "UNDEFINED_FUEL_22";
    /** Undefined Fuel – Reserved for Proprietary Use */ VisaFuelType["UNDEFINED_FUEL_23"] = "UNDEFINED_FUEL_23";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_1"] = "UNDEFINED_OTHER_FUEL_1";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_2"] = "UNDEFINED_OTHER_FUEL_2";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_3"] = "UNDEFINED_OTHER_FUEL_3";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_4"] = "UNDEFINED_OTHER_FUEL_4";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_5"] = "UNDEFINED_OTHER_FUEL_5";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_6"] = "UNDEFINED_OTHER_FUEL_6";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_7"] = "UNDEFINED_OTHER_FUEL_7";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_8"] = "UNDEFINED_OTHER_FUEL_8";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_9"] = "UNDEFINED_OTHER_FUEL_9";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_10"] = "UNDEFINED_OTHER_FUEL_10";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_11"] = "UNDEFINED_OTHER_FUEL_11";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_12"] = "UNDEFINED_OTHER_FUEL_12";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_13"] = "UNDEFINED_OTHER_FUEL_13";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_14"] = "UNDEFINED_OTHER_FUEL_14";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_15"] = "UNDEFINED_OTHER_FUEL_15";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_16"] = "UNDEFINED_OTHER_FUEL_16";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_17"] = "UNDEFINED_OTHER_FUEL_17";
    /** Undefined Other Fuel */ VisaFuelType["UNDEFINED_OTHER_FUEL_18"] = "UNDEFINED_OTHER_FUEL_18";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_1"] = "UNDEFINED_PACKAGED_FUEL_1";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_2"] = "UNDEFINED_PACKAGED_FUEL_2";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_3"] = "UNDEFINED_PACKAGED_FUEL_3";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_4"] = "UNDEFINED_PACKAGED_FUEL_4";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_5"] = "UNDEFINED_PACKAGED_FUEL_5";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_6"] = "UNDEFINED_PACKAGED_FUEL_6";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_7"] = "UNDEFINED_PACKAGED_FUEL_7";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_8"] = "UNDEFINED_PACKAGED_FUEL_8";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_9"] = "UNDEFINED_PACKAGED_FUEL_9";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_10"] = "UNDEFINED_PACKAGED_FUEL_10";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_11"] = "UNDEFINED_PACKAGED_FUEL_11";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_12"] = "UNDEFINED_PACKAGED_FUEL_12";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_13"] = "UNDEFINED_PACKAGED_FUEL_13";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_14"] = "UNDEFINED_PACKAGED_FUEL_14";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_15"] = "UNDEFINED_PACKAGED_FUEL_15";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_16"] = "UNDEFINED_PACKAGED_FUEL_16";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_17"] = "UNDEFINED_PACKAGED_FUEL_17";
    /** Undefined Packaged Fuels */ VisaFuelType["UNDEFINED_PACKAGED_FUEL_18"] = "UNDEFINED_PACKAGED_FUEL_18";
    /** Unknown/Undefined */ VisaFuelType["UNKNOWN"] = "UNKNOWN";
    /** <Deprecated> Unleaded Methanol (5.7% blend) */ VisaFuelType["UNLEADED_METHANOL_57"] = "UNLEADED_METHANOL_57";
    /** <Deprecated> Unleaded Methanol (7.7% blend) */ VisaFuelType["UNLEADED_METHANOL_77"] = "UNLEADED_METHANOL_77";
    /** <Deprecated> Unleaded Plus Methanol (5.7% blend) */ VisaFuelType["UNLEADED_PLUS_METHANOL_57"] = "UNLEADED_PLUS_METHANOL_57";
    /** <Deprecated> Unleaded Plus Methanol (7.7% blend) */ VisaFuelType["UNLEADED_PLUS_METHANOL_77"] = "UNLEADED_PLUS_METHANOL_77";
    /** <Deprecated> Super Unleaded Methanol (5.7% blend) */ VisaFuelType["UNLEADED_SUPER_METHANOL_57"] = "UNLEADED_SUPER_METHANOL_57";
    /** White Gas */ VisaFuelType["WHITE_GAS"] = "WHITE_GAS";
    return VisaFuelType;
}({});
var $2f53fee15f29b056$export$be531b7f9e1f1f65 = /*#__PURE__*/ function(VisaFuelUnitOfMeasure) {
    /** Charging Minutes */ VisaFuelUnitOfMeasure["CHARGING_MINUTES"] = "CHARGING_MINUTES";
    /** U.S. Gallon */ VisaFuelUnitOfMeasure["GALLON"] = "GALLON";
    /** Imperial Gallon */ VisaFuelUnitOfMeasure["IMPERIAL"] = "IMPERIAL";
    /** Kilo */ VisaFuelUnitOfMeasure["KILO"] = "KILO";
    /** Kilowatt Hour */ VisaFuelUnitOfMeasure["KILOWATT_HOUR"] = "KILOWATT_HOUR";
    /** Liter */ VisaFuelUnitOfMeasure["LITER"] = "LITER";
    /** Pound */ VisaFuelUnitOfMeasure["POUND"] = "POUND";
    return VisaFuelUnitOfMeasure;
}({});
var $2f53fee15f29b056$export$55cdafe97430a4bf = /*#__PURE__*/ function(VisaItemCommodityCode) {
    /** AC Parts 052-061 */ VisaItemCommodityCode["AC_PARTS"] = "AC_PARTS";
    /** Air Conditioning Service */ VisaItemCommodityCode["AC_SERVICE"] = "AC_SERVICE";
    /** Additive Dosage */ VisaItemCommodityCode["ADDITIVE_DOSAGE"] = "ADDITIVE_DOSAGE";
    /** Aircraft Accessories */ VisaItemCommodityCode["AIRCRAFT_ACC"] = "AIRCRAFT_ACC";
    /** Aircraft Cleaning */ VisaItemCommodityCode["AIRCRAFT_CLEANING"] = "AIRCRAFT_CLEANING";
    /** Aircraft Fuel Additive */ VisaItemCommodityCode["AIRCRAFT_FUEL_ADDITIVE"] = "AIRCRAFT_FUEL_ADDITIVE";
    /** Aircraft Ground Hauling */ VisaItemCommodityCode["AIRCRAFT_GROUND_HAULING"] = "AIRCRAFT_GROUND_HAULING";
    /** Aircraft Ground Power Unit */ VisaItemCommodityCode["AIRCRAFT_GROUND_PU"] = "AIRCRAFT_GROUND_PU";
    /** Aircraft Labor */ VisaItemCommodityCode["AIRCRAFT_LABOR"] = "AIRCRAFT_LABOR";
    /** Aircraft Maintenance */ VisaItemCommodityCode["AIRCRAFT_MAINTENANCE"] = "AIRCRAFT_MAINTENANCE";
    /** Aircraft Parking Fees */ VisaItemCommodityCode["AIRCRAFT_PARKING_FEE"] = "AIRCRAFT_PARKING_FEE";
    /** Aircraft Rental */ VisaItemCommodityCode["AIRCRAFT_RENTAL"] = "AIRCRAFT_RENTAL";
    /** Aircraft Sanitation Fees */ VisaItemCommodityCode["AIRCRAFT_SANITATION"] = "AIRCRAFT_SANITATION";
    /** Aircraft Service */ VisaItemCommodityCode["AIRCRAFT_SERVICE"] = "AIRCRAFT_SERVICE";
    /** Aircraft Tie Down Fees */ VisaItemCommodityCode["AIRCRAFT_TIE_DOWN_FEE"] = "AIRCRAFT_TIE_DOWN_FEE";
    /** Aircraft Work Order */ VisaItemCommodityCode["AIRCRAFT_WO"] = "AIRCRAFT_WO";
    /** Airport Fees */ VisaItemCommodityCode["AIRPORT_FEE"] = "AIRPORT_FEE";
    /** Air Filter */ VisaItemCommodityCode["AIR_FILTER"] = "AIR_FILTER";
    /** Alternative Snacks */ VisaItemCommodityCode["ALT_SNACKS"] = "ALT_SNACKS";
    /** Anti-Freeze */ VisaItemCommodityCode["ANTI_FREEZE"] = "ANTI_FREEZE";
    /** <Deprecated> APU or Aircraft Jump Seat */ VisaItemCommodityCode["APU"] = "APU";
    /** <Deprecated> Avionics */ VisaItemCommodityCode["AVIONICS"] = "AVIONICS";
    /** Aviation Biofuel (Gasoline) */ VisaItemCommodityCode["AV_BIOFUEL"] = "AV_BIOFUEL";
    /** Aviation Fuel 4 */ VisaItemCommodityCode["AV_FUEL_4"] = "AV_FUEL_4";
    /** Aviation Fuel 5 */ VisaItemCommodityCode["AV_FUEL_5"] = "AV_FUEL_5";
    /** Aviation Fuel JP8 */ VisaItemCommodityCode["AV_FUEL_JP8"] = "AV_FUEL_JP8";
    /** Aviation Fuel Premium */ VisaItemCommodityCode["AV_FUEL_PREMIUM"] = "AV_FUEL_PREMIUM";
    /** Aviation Fuel Regular */ VisaItemCommodityCode["AV_FUEL_REGULAR"] = "AV_FUEL_REGULAR";
    /** AvGas Federal Excise Tax */ VisaItemCommodityCode["AV_GAS_FED_E_TAX"] = "AV_GAS_FED_E_TAX";
    /** B2 Diesel Blend 2% Biodiesel */ VisaItemCommodityCode["B2_DIESEL"] = "B2_DIESEL";
    /** B5 Diesel Blend 5% Biodiesel */ VisaItemCommodityCode["B5_DIESEL"] = "B5_DIESEL";
    /** B10 Diesel Blend 10% Biodiesel */ VisaItemCommodityCode["B10_DIESEL"] = "B10_DIESEL";
    /** B11 Diesel Blend 11% Biodiesel */ VisaItemCommodityCode["B11_DIESEL"] = "B11_DIESEL";
    /** B15 Diesel Blend 15% Biodiesel */ VisaItemCommodityCode["B15_DIESEL"] = "B15_DIESEL";
    /** B20 Diesel Blend 20% Biodiesel */ VisaItemCommodityCode["B20_DIESEL"] = "B20_DIESEL";
    /** B75 Diesel Blend 75% Biodiesel */ VisaItemCommodityCode["B75_DIESEL"] = "B75_DIESEL";
    /** B99 Diesel Blend 99% Biodiesel */ VisaItemCommodityCode["B99_DIESEL"] = "B99_DIESEL";
    /** B100 Diesel Blend 100% Biodiesel */ VisaItemCommodityCode["B100_DIESEL"] = "B100_DIESEL";
    /** Batteries */ VisaItemCommodityCode["BATTERIES"] = "BATTERIES";
    /** Beer - Alcoholic */ VisaItemCommodityCode["BEER"] = "BEER";
    /** Beer - Non-Alcoholic */ VisaItemCommodityCode["BEER_NA"] = "BEER_NA";
    /** Biodiesel Blend 2% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_2_OR_NT"] = "BIODIESEL_BLEND_2_OR_NT";
    /** Biodiesel Blend 5% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_5_OR_NT"] = "BIODIESEL_BLEND_5_OR_NT";
    /** Biodiesel Blend 10% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_10_OR_NT"] = "BIODIESEL_BLEND_10_OR_NT";
    /** Biodiesel Blend 11% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_11_OR_NT"] = "BIODIESEL_BLEND_11_OR_NT";
    /** Biodiesel Blend 15% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_15_OR_NT"] = "BIODIESEL_BLEND_15_OR_NT";
    /** Biodiesel Blend 20% Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_BLEND_20_OR_NT"] = "BIODIESEL_BLEND_20_OR_NT";
    /** Biodiesel Blend Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_OFF_ROAD_NON_TAXABLE"] = "BIODIESEL_OFF_ROAD_NON_TAXABLE";
    /** <Deprecated> Biodiesel Blend Off-Road (Non-Taxable) */ VisaItemCommodityCode["BIODIESEL_OFF_ROAD_NON_TAXABLE_35"] = "BIODIESEL_OFF_ROAD_NON_TAXABLE_35";
    /** Biojet (Diesel) */ VisaItemCommodityCode["BIOJET"] = "BIOJET";
    /** Blended Diesel (#1 and #2) */ VisaItemCommodityCode["BLENDED_DIESEL_1_2"] = "BLENDED_DIESEL_1_2";
    /** Body Work */ VisaItemCommodityCode["BODY_WORK"] = "BODY_WORK";
    /** <Deprecated> Bottled Propane */ VisaItemCommodityCode["BOTTLED_PROPANE"] = "BOTTLED_PROPANE";
    /** Brake Fluid */ VisaItemCommodityCode["BRAKE_FLUID"] = "BRAKE_FLUID";
    /** Brake Service */ VisaItemCommodityCode["BRAKE_SERVICE"] = "BRAKE_SERVICE";
    /** Call Out Fee */ VisaItemCommodityCode["CALL_OUT_FEE"] = "CALL_OUT_FEE";
    /** Cargo Handling */ VisaItemCommodityCode["CARGO_HANDLING"] = "CARGO_HANDLING";
    /** Car Wash */ VisaItemCommodityCode["CAR_WASH"] = "CAR_WASH";
    /** Cash Back */ VisaItemCommodityCode["CASH_BACK"] = "CASH_BACK";
    /** Cash Back Fee */ VisaItemCommodityCode["CASH_BACK_FEE"] = "CASH_BACK_FEE";
    /** Catering */ VisaItemCommodityCode["CATERING"] = "CATERING";
    /** Cannabidiol (CBD) */ VisaItemCommodityCode["CBD"] = "CBD";
    /** Charity */ VisaItemCommodityCode["CHARITY"] = "CHARITY";
    /** Charter Fee */ VisaItemCommodityCode["CHARTER_FEE"] = "CHARTER_FEE";
    /** Cigarettes */ VisaItemCommodityCode["CIGARETTES"] = "CIGARETTES";
    /** Cold Dispensed Beverages */ VisaItemCommodityCode["COLD_DISPENSED_BEV"] = "COLD_DISPENSED_BEV";
    /** Communication Fee */ VisaItemCommodityCode["COMMUNICATION_FEE"] = "COMMUNICATION_FEE";
    /** Compressed Natural Gas */ VisaItemCommodityCode["COMPRESSED_NAT_GAS"] = "COMPRESSED_NAT_GAS";
    /** Corrosion Inhibitor */ VisaItemCommodityCode["CORROSION_INHIBITOR"] = "CORROSION_INHIBITOR";
    /** Coupon 1 */ VisaItemCommodityCode["COUPON_1"] = "COUPON_1";
    /** Coupon 2 */ VisaItemCommodityCode["COUPON_2"] = "COUPON_2";
    /** Coupon 3 */ VisaItemCommodityCode["COUPON_3"] = "COUPON_3";
    /** Coupon 4 */ VisaItemCommodityCode["COUPON_4"] = "COUPON_4";
    /** Coupon 5 */ VisaItemCommodityCode["COUPON_5"] = "COUPON_5";
    /** DEF (Diesel Exhaust Fluid) */ VisaItemCommodityCode["DEF"] = "DEF";
    /** Deli Items */ VisaItemCommodityCode["DELI_ITEMS"] = "DELI_ITEMS";
    /** De-fuel */ VisaItemCommodityCode["DE_FUEL"] = "DE_FUEL";
    /** De-icing */ VisaItemCommodityCode["DE_ICING"] = "DE_ICING";
    /** Diesel #1 Off-Road (Non-Taxable) */ VisaItemCommodityCode["DIESEL_1_OR_NT"] = "DIESEL_1_OR_NT";
    /** Diesel #1 Premium Off-Road (Non-Taxable) */ VisaItemCommodityCode["DIESEL_1_PREMIUM_OR_NT"] = "DIESEL_1_PREMIUM_OR_NT";
    /** Diesel #2 Off-Road (Non-Taxable) */ VisaItemCommodityCode["DIESEL_2_OR_NT"] = "DIESEL_2_OR_NT";
    /** Diesel #2 Premium Off-Road (Non-Taxable) */ VisaItemCommodityCode["DIESEL_2_PREMIUM_OR_NT"] = "DIESEL_2_PREMIUM_OR_NT";
    /** Diesel Off-Road (Non-Taxable)* */ VisaItemCommodityCode["DIESEL_OFF_ROAD_NON_TAXABLE"] = "DIESEL_OFF_ROAD_NON_TAXABLE";
    /** Diesel Off-Road (#1 and #2 Non-Taxable)* */ VisaItemCommodityCode["DIESEL_OFF_ROAD_TAXABLE"] = "DIESEL_OFF_ROAD_TAXABLE";
    /** Disable Device/Handset Lock */ VisaItemCommodityCode["DISABLE_HANDSET"] = "DISABLE_HANDSET";
    /** Discount 1 */ VisaItemCommodityCode["DISCOUNT_1"] = "DISCOUNT_1";
    /** Discount 2 */ VisaItemCommodityCode["DISCOUNT_2"] = "DISCOUNT_2";
    /** Discount 3 */ VisaItemCommodityCode["DISCOUNT_3"] = "DISCOUNT_3";
    /** Discount 4 */ VisaItemCommodityCode["DISCOUNT_4"] = "DISCOUNT_4";
    /** Discount 5 */ VisaItemCommodityCode["DISCOUNT_5"] = "DISCOUNT_5";
    /** Ethanol Blends E16-E84 */ VisaItemCommodityCode["E16_E84"] = "E16_E84";
    /** E-85 */ VisaItemCommodityCode["E85"] = "E85";
    /** Enable Device/Handset Unlock */ VisaItemCommodityCode["ENABLE_HANDSET"] = "ENABLE_HANDSET";
    /** Engine Service */ VisaItemCommodityCode["ENGINE_SERVICE"] = "ENGINE_SERVICE";
    /** <Deprecated> Ethanol (5.7% blend) */ VisaItemCommodityCode["ETHANOL_57"] = "ETHANOL_57";
    /** <Deprecated> Ethanol (7.7% blend) */ VisaItemCommodityCode["ETHANOL_77"] = "ETHANOL_77";
    /** EVC-1 – Level 1 charge = 110v 15 amp */ VisaItemCommodityCode["EVC_1"] = "EVC_1";
    /** EVC-2 – Level 2 charge = 240v 15-40 amp */ VisaItemCommodityCode["EVC_2"] = "EVC_2";
    /** EVC-3 – Level 3 charge = 480v 3 phase charge */ VisaItemCommodityCode["EVC_3"] = "EVC_3";
    /** EV Battery Exchanges */ VisaItemCommodityCode["EV_BATTERY_ECH"] = "EV_BATTERY_ECH";
    /** EV Charging Fee */ VisaItemCommodityCode["EV_CHARGE"] = "EV_CHARGE";
    /** Exhaust Service */ VisaItemCommodityCode["EXHAUST_SERVICE"] = "EXHAUST_SERVICE";
    /** Fee 1 */ VisaItemCommodityCode["FEE_1"] = "FEE_1";
    /** Fee 2 */ VisaItemCommodityCode["FEE_2"] = "FEE_2";
    /** Fee 3 */ VisaItemCommodityCode["FEE_3"] = "FEE_3";
    /** Fee 4 */ VisaItemCommodityCode["FEE_4"] = "FEE_4";
    /** Fee 5 */ VisaItemCommodityCode["FEE_5"] = "FEE_5";
    /** Financial Prepaid Card Activate */ VisaItemCommodityCode["FIN_PREPAID_ACT"] = "FIN_PREPAID_ACT";
    /** Financial Prepaid Card Reload */ VisaItemCommodityCode["FIN_PREPAID_REL"] = "FIN_PREPAID_REL";
    /** <Deprecated> Flight Planning Fees */ VisaItemCommodityCode["FLIGHT_PLANNING_FEES"] = "FLIGHT_PLANNING_FEES";
    /** Flight Plans/Weather Brief */ VisaItemCommodityCode["FLIGHT_PLANS"] = "FLIGHT_PLANS";
    /** Flow Fee */ VisaItemCommodityCode["FLOW_FEE"] = "FLOW_FEE";
    /** Fluid Milk Products */ VisaItemCommodityCode["FLUID_MILK"] = "FLUID_MILK";
    /** Frozen Dispensed Beverages */ VisaItemCommodityCode["FROZEN_DISPENSED_BEV"] = "FROZEN_DISPENSED_BEV";
    /** Frozen Foods */ VisaItemCommodityCode["FROZEN_FOOD"] = "FROZEN_FOOD";
    /** Fuel System */ VisaItemCommodityCode["FUEL_SYSTEM"] = "FUEL_SYSTEM";
    /** General Alcohol */ VisaItemCommodityCode["GEN_ALCOHOL"] = "GEN_ALCOHOL";
    /** General Automotive Merchandise */ VisaItemCommodityCode["GEN_AUTO_MERCH"] = "GEN_AUTO_MERCH";
    /** General Candy */ VisaItemCommodityCode["GEN_CANDY"] = "GEN_CANDY";
    /** General Dairy */ VisaItemCommodityCode["GEN_DAIRY"] = "GEN_DAIRY";
    /** General Deli */ VisaItemCommodityCode["GEN_DELI"] = "GEN_DELI";
    /** General Dispensed Beverage */ VisaItemCommodityCode["GEN_DISPENSED_BEV"] = "GEN_DISPENSED_BEV";
    /** General Foodservice */ VisaItemCommodityCode["GEN_FOODSERVICE"] = "GEN_FOODSERVICE";
    /** General Grocery */ VisaItemCommodityCode["GEN_GROCERY"] = "GEN_GROCERY";
    /** General Health & Beauty Care */ VisaItemCommodityCode["GEN_HEALTH"] = "GEN_HEALTH";
    /** General Ice */ VisaItemCommodityCode["GEN_ICE"] = "GEN_ICE";
    /** General Lottery */ VisaItemCommodityCode["GEN_LOTTERY"] = "GEN_LOTTERY";
    /** General Merchandise */ VisaItemCommodityCode["GEN_MERCH"] = "GEN_MERCH";
    /** General Money Order */ VisaItemCommodityCode["GEN_MONEY_ORDER"] = "GEN_MONEY_ORDER";
    /** General Packaged Beverage */ VisaItemCommodityCode["GEN_PACKAGED_BEV"] = "GEN_PACKAGED_BEV";
    /** General Publications */ VisaItemCommodityCode["GEN_PUBLICATIONS"] = "GEN_PUBLICATIONS";
    /** General Purpose Activate */ VisaItemCommodityCode["GEN_PURPOSE_ACT"] = "GEN_PURPOSE_ACT";
    /** General Purpose Reload */ VisaItemCommodityCode["GEN_PURPOSE_REL"] = "GEN_PURPOSE_REL";
    /** General Snacks */ VisaItemCommodityCode["GEN_SNACKS"] = "GEN_SNACKS";
    /** General Store Service */ VisaItemCommodityCode["GEN_STORE_SERVICE"] = "GEN_STORE_SERVICE";
    /** General Tobacco */ VisaItemCommodityCode["GEN_TOBACCO"] = "GEN_TOBACCO";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_1"] = "GEN_UNDEFINED_1";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_2"] = "GEN_UNDEFINED_2";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_3"] = "GEN_UNDEFINED_3";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_4"] = "GEN_UNDEFINED_4";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_5"] = "GEN_UNDEFINED_5";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_6"] = "GEN_UNDEFINED_6";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_7"] = "GEN_UNDEFINED_7";
    /** General Undefined – Reserved for Future Use. */ VisaItemCommodityCode["GEN_UNDEFINED_8"] = "GEN_UNDEFINED_8";
    /** Ground Equipment Service Fees */ VisaItemCommodityCode["GES_FEE"] = "GES_FEE";
    /** Gratuity */ VisaItemCommodityCode["GRATUITY"] = "GRATUITY";
    /** Green Gasoline Mid/Plus (Plant based not petroleum based) */ VisaItemCommodityCode["GREEN_GAS_PLUS"] = "GREEN_GAS_PLUS";
    /** Green Gasoline Regular (Plant based not petroleum based) */ VisaItemCommodityCode["GREEN_GAS_REGULAR"] = "GREEN_GAS_REGULAR";
    /** Green Gasoline Premium/Super (Plant based not petroleum based) */ VisaItemCommodityCode["GREEN_GAS_SUPER"] = "GREEN_GAS_SUPER";
    /** Groceries - Edible */ VisaItemCommodityCode["GROCERY_EDIBLE"] = "GROCERY_EDIBLE";
    /** Groceries - Non-Edible */ VisaItemCommodityCode["GROCERY_NON_EDIBLE"] = "GROCERY_NON_EDIBLE";
    /** Groceries - Perishable */ VisaItemCommodityCode["GROCERY_PERISHABLE"] = "GROCERY_PERISHABLE";
    /** GST/HST (Canadian)/VAT 1 */ VisaItemCommodityCode["GST_HST_VAT_1"] = "GST_HST_VAT_1";
    /** Hydrogen H35 */ VisaItemCommodityCode["H35"] = "H35";
    /** Hydrogen H70 */ VisaItemCommodityCode["H70"] = "H70";
    /** Hangar Fee */ VisaItemCommodityCode["HANGAR_FEE"] = "HANGAR_FEE";
    /** Heating Oil */ VisaItemCommodityCode["HEATING_OIL"] = "HEATING_OIL";
    /** Home Delivery */ VisaItemCommodityCode["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** Hoses */ VisaItemCommodityCode["HOSES"] = "HOSES";
    /** Hot Dispensed Beverages */ VisaItemCommodityCode["HOT_DISPENSED_BEV"] = "HOT_DISPENSED_BEV";
    /** Inspection */ VisaItemCommodityCode["INSPECTION"] = "INSPECTION";
    /** Instruction Fee */ VisaItemCommodityCode["INSTRUCTION_FEE"] = "INSTRUCTION_FEE";
    /** IT/Bladder */ VisaItemCommodityCode["IT_BLADDER"] = "IT_BLADDER";
    /** Jet Federal Excise Tax */ VisaItemCommodityCode["JET_FD_E_TAX"] = "JET_FD_E_TAX";
    /** Jet Fuel */ VisaItemCommodityCode["JET_FUEL"] = "JET_FUEL";
    /** Kerosene – Low Sulfur */ VisaItemCommodityCode["KEROSENE"] = "KEROSENE";
    /** Kerosene – Low Sulfur (Non-Taxable) */ VisaItemCommodityCode["KEROSENE_LS_NT"] = "KEROSENE_LS_NT";
    /** Kerosene – Ultra Low Sulfur */ VisaItemCommodityCode["KEROSENE_ULS"] = "KEROSENE_ULS";
    /** Kerosene – Ultra Low Sulfur (Non-Taxable) */ VisaItemCommodityCode["KEROSENE_ULS_NT"] = "KEROSENE_ULS_NT";
    /** Labor */ VisaItemCommodityCode["LABOR"] = "LABOR";
    /** Lamps */ VisaItemCommodityCode["LAMPS"] = "LAMPS";
    /** Landing Fee */ VisaItemCommodityCode["LANDING_FEE"] = "LANDING_FEE";
    /** Launch Fee */ VisaItemCommodityCode["LAUNCH_FEE"] = "LAUNCH_FEE";
    /** Liquor */ VisaItemCommodityCode["LIQUOR"] = "LIQUOR";
    /** Liquid Natural Gas */ VisaItemCommodityCode["LNG"] = "LNG";
    /** Local Discount 1 */ VisaItemCommodityCode["LOCAL_DISCOUNT_1"] = "LOCAL_DISCOUNT_1";
    /** Local Discount 2 */ VisaItemCommodityCode["LOCAL_DISCOUNT_2"] = "LOCAL_DISCOUNT_2";
    /** Local Discount 3 */ VisaItemCommodityCode["LOCAL_DISCOUNT_3"] = "LOCAL_DISCOUNT_3";
    /** Local Discount 4 */ VisaItemCommodityCode["LOCAL_DISCOUNT_4"] = "LOCAL_DISCOUNT_4";
    /** Local Discount 5 */ VisaItemCommodityCode["LOCAL_DISCOUNT_5"] = "LOCAL_DISCOUNT_5";
    /** Lodging */ VisaItemCommodityCode["LODGING"] = "LODGING";
    /** Lottery - Instant */ VisaItemCommodityCode["LOTTERY_IN"] = "LOTTERY_IN";
    /** Lottery - Online */ VisaItemCommodityCode["LOTTERY_ON"] = "LOTTERY_ON";
    /** Lottery - Other */ VisaItemCommodityCode["LOTTERY_OTHER"] = "LOTTERY_OTHER";
    /** Lottery Pay Out - Instant */ VisaItemCommodityCode["LOTTERY_PO_IN"] = "LOTTERY_PO_IN";
    /** Lottery Pay Out - Online */ VisaItemCommodityCode["LOTTERY_PO_ON"] = "LOTTERY_PO_ON";
    /** Lottery Pay Out - Other */ VisaItemCommodityCode["LOTTERY_PO_OT"] = "LOTTERY_PO_OT";
    /** Low Octane UNL */ VisaItemCommodityCode["LO_UNL"] = "LO_UNL";
    /** Liquid Propane Gas */ VisaItemCommodityCode["LPG"] = "LPG";
    /** Lube */ VisaItemCommodityCode["LUBE"] = "LUBE";
    /** <Deprecated> M-85 */ VisaItemCommodityCode["M85"] = "M85";
    /** Marine Diesel */ VisaItemCommodityCode["MARINE_DIESEL"] = "MARINE_DIESEL";
    /** Marine Fuel 1 */ VisaItemCommodityCode["MARINE_FUEL_1"] = "MARINE_FUEL_1";
    /** Marine Fuel 2 */ VisaItemCommodityCode["MARINE_FUEL_2"] = "MARINE_FUEL_2";
    /** Marine Fuel 3 */ VisaItemCommodityCode["MARINE_FUEL_3"] = "MARINE_FUEL_3";
    /** Marine Fuel 4 */ VisaItemCommodityCode["MARINE_FUEL_4"] = "MARINE_FUEL_4";
    /** Marine Fuel 5 */ VisaItemCommodityCode["MARINE_FUEL_5"] = "MARINE_FUEL_5";
    /** Marine – Other */ VisaItemCommodityCode["MARINE_FUEL_OTHER"] = "MARINE_FUEL_OTHER";
    /** Marine Labor */ VisaItemCommodityCode["MARINE_LABOR"] = "MARINE_LABOR";
    /** Marine Service */ VisaItemCommodityCode["MARINE_SERVICE"] = "MARINE_SERVICE";
    /** Marine Work Order */ VisaItemCommodityCode["MARINE_WO"] = "MARINE_WO";
    /** Membership/Loyalty */ VisaItemCommodityCode["MEMBERSHIP"] = "MEMBERSHIP";
    /** Mid/Plus Gasoline */ VisaItemCommodityCode["MID_PLUS"] = "MID_PLUS";
    /** Mid/Plus 2 Gasoline */ VisaItemCommodityCode["MID_PLUS_2"] = "MID_PLUS_2";
    /** Mid/Plus 2 (10% Blend) */ VisaItemCommodityCode["MID_PLUS_2_10"] = "MID_PLUS_2_10";
    /** <Deprecated> Mid/Plus Ethanol (5.7% blend) */ VisaItemCommodityCode["MID_PLUS_ETHANOL_57"] = "MID_PLUS_ETHANOL_57";
    /** <Deprecated> Mid/Plus Ethanol (7.7% blend) */ VisaItemCommodityCode["MID_PLUS_ETHANOL_77"] = "MID_PLUS_ETHANOL_77";
    /** <Deprecated> Miscellaneous */ VisaItemCommodityCode["MISC"] = "MISC";
    /** Miscellaneous Administrative */ VisaItemCommodityCode["MISC_ADMIN"] = "MISC_ADMIN";
    /** Miscellaneous Aviation Fuel */ VisaItemCommodityCode["MISC_AV_FUEL"] = "MISC_AV_FUEL";
    /** Miscellaneous Aviation Products/Services */ VisaItemCommodityCode["MISC_AV_PS"] = "MISC_AV_PS";
    /** Miscellaneous Aviation Tax */ VisaItemCommodityCode["MISC_AV_TAX"] = "MISC_AV_TAX";
    /** Miscellaneous Fuel */ VisaItemCommodityCode["MISC_FUEL"] = "MISC_FUEL";
    /** Miscellaneous Marine Fuel */ VisaItemCommodityCode["MISC_MARINE_FUEL"] = "MISC_MARINE_FUEL";
    /** Miscellaneous Marine Products/Services */ VisaItemCommodityCode["MISC_MARINE_PS"] = "MISC_MARINE_PS";
    /** Miscellaneous Negative Administrative */ VisaItemCommodityCode["MISC_NEG_ADMIN"] = "MISC_NEG_ADMIN";
    /** Miscellaneous Other Fuel */ VisaItemCommodityCode["MISC_OTHER_FUEL"] = "MISC_OTHER_FUEL";
    /** Miscellaneous Packaged Fuels */ VisaItemCommodityCode["MISC_PACKAGED_FUEL"] = "MISC_PACKAGED_FUEL";
    /** Miscellaneous Vehicle Products / Services */ VisaItemCommodityCode["MISC_VEHICLE_PS"] = "MISC_VEHICLE_PS";
    /** Money Order - Dividend Check */ VisaItemCommodityCode["MONEY_ORDER_DC"] = "MONEY_ORDER_DC";
    /** Money Order - Gift Certificate */ VisaItemCommodityCode["MONEY_ORDER_GC"] = "MONEY_ORDER_GC";
    /** Money Order - Official Check */ VisaItemCommodityCode["MONEY_ORDER_OC"] = "MONEY_ORDER_OC";
    /** Money Order - Payroll Check */ VisaItemCommodityCode["MONEY_ORDER_PC"] = "MONEY_ORDER_PC";
    /** Money Order - Rebate Check */ VisaItemCommodityCode["MONEY_ORDER_REBC"] = "MONEY_ORDER_REBC";
    /** Money Order - Refund Check */ VisaItemCommodityCode["MONEY_ORDER_REFC"] = "MONEY_ORDER_REFC";
    /** Money Order - Utility Check */ VisaItemCommodityCode["MONEY_ORDER_UC"] = "MONEY_ORDER_UC";
    /** Money Order - Vendor Payment */ VisaItemCommodityCode["MONEY_ORDER_VP"] = "MONEY_ORDER_VP";
    /** Motor Oil */ VisaItemCommodityCode["MOTOR_OIL"] = "MOTOR_OIL";
    /** Multiple Payee Bill Pay */ VisaItemCommodityCode["MULTI_BILL_PAY"] = "MULTI_BILL_PAY";
    /** Oil Change */ VisaItemCommodityCode["OIL_CHANGE"] = "OIL_CHANGE";
    /** Oil Filter */ VisaItemCommodityCode["OIL_FILTER"] = "OIL_FILTER";
    /** Other Dairy */ VisaItemCommodityCode["OTHER_DAIRY"] = "OTHER_DAIRY";
    /** Other Dispensed Beverages */ VisaItemCommodityCode["OTHER_DISPENSED_BEV"] = "OTHER_DISPENSED_BEV";
    /** Other Fuel (Non-Taxable) */ VisaItemCommodityCode["OTHER_FUEL_NT"] = "OTHER_FUEL_NT";
    /** Other Lubricants */ VisaItemCommodityCode["OTHER_LUBE"] = "OTHER_LUBE";
    /** Other Packaged Beverages */ VisaItemCommodityCode["OTHER_PACKAGED_BEV"] = "OTHER_PACKAGED_BEV";
    /** Overtime Fees */ VisaItemCommodityCode["OVERTIME_FEE"] = "OVERTIME_FEE";
    /** Oxygen */ VisaItemCommodityCode["OXYGEN"] = "OXYGEN";
    /** Packaged Additive */ VisaItemCommodityCode["PACKAGED_ADDITIVE"] = "PACKAGED_ADDITIVE";
    /** Packaged B99 */ VisaItemCommodityCode["PACKAGED_B99"] = "PACKAGED_B99";
    /** Packaged B100 */ VisaItemCommodityCode["PACKAGED_B100"] = "PACKAGED_B100";
    /** Packaged Beverages (non-alcoholic) */ VisaItemCommodityCode["PACKAGED_BEV_NA"] = "PACKAGED_BEV_NA";
    /** Bread - Packaged */ VisaItemCommodityCode["PACKAGED_BREAD"] = "PACKAGED_BREAD";
    /** Packaged DEF (Diesel Exhaust Fluid) */ VisaItemCommodityCode["PACKAGED_DEF"] = "PACKAGED_DEF";
    /** Packaged Sandwiches/Deli Products */ VisaItemCommodityCode["PACKAGED_DELI"] = "PACKAGED_DELI";
    /** Packaged Ice Cream/Novelties */ VisaItemCommodityCode["PACKAGED_ICE_CREAM"] = "PACKAGED_ICE_CREAM";
    /** Packaged Juice */ VisaItemCommodityCode["PACKAGED_JUICE"] = "PACKAGED_JUICE";
    /** Packaged Kerosene */ VisaItemCommodityCode["PACKAGED_KEROSENE"] = "PACKAGED_KEROSENE";
    /** Packaged Propane */ VisaItemCommodityCode["PACKAGED_PROPANE"] = "PACKAGED_PROPANE";
    /** Pilot Supplies */ VisaItemCommodityCode["PILOT_SUPPLIES"] = "PILOT_SUPPLIES";
    /** PIN Activate Prepaid Card */ VisaItemCommodityCode["PIN_PREPAID_ACT"] = "PIN_PREPAID_ACT";
    /** PIN Return Prepaid Card */ VisaItemCommodityCode["PIN_PREPAID_RET"] = "PIN_PREPAID_RET";
    /** Off-Road Mid/Plus 2 (Non-Taxable) */ VisaItemCommodityCode["PLUS_2_OR_NT"] = "PLUS_2_OR_NT";
    /** Mid/Plus Ethanol 2 (15% Blend) */ VisaItemCommodityCode["PLUS_ETHANOL_2_15"] = "PLUS_ETHANOL_2_15";
    /** Mid/Plus Ethanol (10% Blend) */ VisaItemCommodityCode["PLUS_ETHANOL_10"] = "PLUS_ETHANOL_10";
    /** Mid/Plus Ethanol (15% Blend) */ VisaItemCommodityCode["PLUS_ETHANOL_15"] = "PLUS_ETHANOL_15";
    /** Off-Road Mid/Plus (Non-Taxable) */ VisaItemCommodityCode["PLUS_OR_NT"] = "PLUS_OR_NT";
    /** POS/Loyalty Reserved Discount 1 */ VisaItemCommodityCode["POS_RES_DISCOUNT_1"] = "POS_RES_DISCOUNT_1";
    /** POS/Loyalty Reserved Discount 2 */ VisaItemCommodityCode["POS_RES_DISCOUNT_2"] = "POS_RES_DISCOUNT_2";
    /** POS/Loyalty Reserved Discount 3 */ VisaItemCommodityCode["POS_RES_DISCOUNT_3"] = "POS_RES_DISCOUNT_3";
    /** POS/Loyalty Reserved Discount 4 */ VisaItemCommodityCode["POS_RES_DISCOUNT_4"] = "POS_RES_DISCOUNT_4";
    /** POS/Loyalty Reserved Discount 5 */ VisaItemCommodityCode["POS_RES_DISCOUNT_5"] = "POS_RES_DISCOUNT_5";
    /** Premium Diesel Blend >= 20% Biodiesel */ VisaItemCommodityCode["PREMIUM_BIODIESEL_BLEND_OVER_20"] = "PREMIUM_BIODIESEL_BLEND_OVER_20";
    /** Premium Diesel Blend <20% Biodiesel */ VisaItemCommodityCode["PREMIUM_BIODIESEL_BLEND_UNDER_20"] = "PREMIUM_BIODIESEL_BLEND_UNDER_20";
    /** Premium Diesel #1 */ VisaItemCommodityCode["PREMIUM_DIESEL_1"] = "PREMIUM_DIESEL_1";
    /** Premium Diesel #2 */ VisaItemCommodityCode["PREMIUM_DIESEL_2"] = "PREMIUM_DIESEL_2";
    /** Premium/Super Gasoline */ VisaItemCommodityCode["PREMIUM_SUPER"] = "PREMIUM_SUPER";
    /** Premium/Super 2 Gasoline */ VisaItemCommodityCode["PREMIUM_SUPER_2"] = "PREMIUM_SUPER_2";
    /** Premium/Super 2 (10% Blend) */ VisaItemCommodityCode["PREMIUM_SUPER_2_10"] = "PREMIUM_SUPER_2_10";
    /** <Deprecated> Premium/Super Ethanol (5.7% blend) */ VisaItemCommodityCode["PREMIUM_SUPER_ETHANOL_57"] = "PREMIUM_SUPER_ETHANOL_57";
    /** Prepaid Cards - Activation/Recharge */ VisaItemCommodityCode["PREPAID_ACT"] = "PREPAID_ACT";
    /** Prepaid Cards - Purchase */ VisaItemCommodityCode["PREPAID_PURCHASE"] = "PREPAID_PURCHASE";
    /** Prepared Foods */ VisaItemCommodityCode["PREPARED_FOOD"] = "PREPARED_FOOD";
    /** Preventative Maintenance */ VisaItemCommodityCode["PREV_MAINTENANCE"] = "PREV_MAINTENANCE";
    /** Proprietary Prepaid Card Activate */ VisaItemCommodityCode["PROP_PREPAID_ACT"] = "PROP_PREPAID_ACT";
    /** Proprietary Prepaid Card Reload */ VisaItemCommodityCode["PROP_PREPAID_REL"] = "PROP_PREPAID_REL";
    /** PST/QST (Canadian) VAT 2 */ VisaItemCommodityCode["PST_HST_VAT_2"] = "PST_HST_VAT_2";
    /** Racing Fuel */ VisaItemCommodityCode["RACING_FUEL"] = "RACING_FUEL";
    /** Ramp Fees */ VisaItemCommodityCode["RAMP_FEES"] = "RAMP_FEES";
    /** Real Time Recharge */ VisaItemCommodityCode["REAL_TIME_RECHARGE"] = "REAL_TIME_RECHARGE";
    /** Recreational Fuel (90 Octane) */ VisaItemCommodityCode["RECREATIONAL_FUEL"] = "RECREATIONAL_FUEL";
    /** Reformulated 1 */ VisaItemCommodityCode["REFORMULATED_1"] = "REFORMULATED_1";
    /** Reformulated 2 */ VisaItemCommodityCode["REFORMULATED_2"] = "REFORMULATED_2";
    /** Reformulated 3 */ VisaItemCommodityCode["REFORMULATED_3"] = "REFORMULATED_3";
    /** Reformulated 4 */ VisaItemCommodityCode["REFORMULATED_4"] = "REFORMULATED_4";
    /** Reformulated 5 */ VisaItemCommodityCode["REFORMULATED_5"] = "REFORMULATED_5";
    /** Regular Gasoline */ VisaItemCommodityCode["REGULAR"] = "REGULAR";
    /** Regular Diesel #1 */ VisaItemCommodityCode["REGULAR_DIESEL_1"] = "REGULAR_DIESEL_1";
    /** Regular Diesel #2 */ VisaItemCommodityCode["REGULAR_DIESEL_2"] = "REGULAR_DIESEL_2";
    /** Regular Ethanol (10% Blend) */ VisaItemCommodityCode["REGULAR_ETHANOL_10"] = "REGULAR_ETHANOL_10";
    /** Regular Ethanol (15% Blend) */ VisaItemCommodityCode["REGULAR_ETHANOL_15"] = "REGULAR_ETHANOL_15";
    /** Off-Road Regular (Non-Taxable) */ VisaItemCommodityCode["REGULAR_OR_NT"] = "REGULAR_OR_NT";
    /** Repairs */ VisaItemCommodityCode["REPAIRS"] = "REPAIRS";
    /** Re-service */ VisaItemCommodityCode["RE_SERVICE"] = "RE_SERVICE";
    /** Road Service */ VisaItemCommodityCode["ROAD_SERVICE"] = "ROAD_SERVICE";
    /** RV Dump Fee */ VisaItemCommodityCode["RV_DUMP_FEE"] = "RV_DUMP_FEE";
    /** <Deprecated> Sales Tax as Shown for Non-Fuel Products */ VisaItemCommodityCode["SALES_TAX_NON_FUEL"] = "SALES_TAX_NON_FUEL";
    /** Salty Snacks */ VisaItemCommodityCode["SALTY_SNACKS"] = "SALTY_SNACKS";
    /** Scales */ VisaItemCommodityCode["SCALES"] = "SCALES";
    /** Secure Fees */ VisaItemCommodityCode["SECURE_FEE"] = "SECURE_FEE";
    /** Service Package */ VisaItemCommodityCode["SERVICE_PACKAGE"] = "SERVICE_PACKAGE";
    /** Shower */ VisaItemCommodityCode["SHOWER"] = "SHOWER";
    /** Single Payee Bill Pay */ VisaItemCommodityCode["SINGLE_BILL_PAY"] = "SINGLE_BILL_PAY";
    /** Slip Rental */ VisaItemCommodityCode["SLIP_RENTAL"] = "SLIP_RENTAL";
    /** Soda */ VisaItemCommodityCode["SODA"] = "SODA";
    /** Split Tender */ VisaItemCommodityCode["SPLIT_TENDER"] = "SPLIT_TENDER";
    /** Static Dissipater Additive */ VisaItemCommodityCode["STATIC_DISSIPATER_ADDITIVE"] = "STATIC_DISSIPATER_ADDITIVE";
    /** Storage */ VisaItemCommodityCode["STORAGE"] = "STORAGE";
    /** Off-Road Premium/Super 2 (Non-Taxable) */ VisaItemCommodityCode["SUPER_2_OR_NT"] = "SUPER_2_OR_NT";
    /** Premium/Super Ethanol 2 (15% Blend) */ VisaItemCommodityCode["SUPER_ETHANOL_2_15"] = "SUPER_ETHANOL_2_15";
    /** Premium/Super Ethanol (10% Blend) */ VisaItemCommodityCode["SUPER_ETHANOL_10"] = "SUPER_ETHANOL_10";
    /** Premium/Super Ethanol (15% Blend) */ VisaItemCommodityCode["SUPER_ETHANOL_15"] = "SUPER_ETHANOL_15";
    /** Off-Road Premium/Super (Non-Taxable) */ VisaItemCommodityCode["SUPER_OR_NT"] = "SUPER_OR_NT";
    /** Sweet Snacks - Packaged */ VisaItemCommodityCode["SWEET_SNACKS"] = "SWEET_SNACKS";
    /** SWT Rate (Canadian) */ VisaItemCommodityCode["SWT_RATE"] = "SWT_RATE";
    /** Synthetic Oil */ VisaItemCommodityCode["SYNTHETIC_OIL"] = "SYNTHETIC_OIL";
    /** Tax 1 */ VisaItemCommodityCode["TAX_1"] = "TAX_1";
    /** Tax 2 */ VisaItemCommodityCode["TAX_2"] = "TAX_2";
    /** Tax 3 */ VisaItemCommodityCode["TAX_3"] = "TAX_3";
    /** Tax 4 */ VisaItemCommodityCode["TAX_4"] = "TAX_4";
    /** Tax 5 */ VisaItemCommodityCode["TAX_5"] = "TAX_5";
    /** Tax 6 */ VisaItemCommodityCode["TAX_6"] = "TAX_6";
    /** Tax 7 */ VisaItemCommodityCode["TAX_7"] = "TAX_7";
    /** Tax 8 */ VisaItemCommodityCode["TAX_8"] = "TAX_8";
    /** Tax Discount/Forgiven */ VisaItemCommodityCode["TAX_DISCOUNT_F"] = "TAX_DISCOUNT_F";
    /** 3rd Party Prepaid Card Activate */ VisaItemCommodityCode["THIRD_PARTY_PREPAID_ACT"] = "THIRD_PARTY_PREPAID_ACT";
    /** 3rd Party Prepaid Card Reload */ VisaItemCommodityCode["THIRD_PARTY_PREPAID_REL"] = "THIRD_PARTY_PREPAID_REL";
    /** Tires */ VisaItemCommodityCode["TIRES"] = "TIRES";
    /** <Deprecated> Tires, Batteries, and Accessories */ VisaItemCommodityCode["TIRES_BATTERIES_ACCESSORIES"] = "TIRES_BATTERIES_ACCESSORIES";
    /** Federal Excise Tax (Tires) */ VisaItemCommodityCode["TIRES_FET"] = "TIRES_FET";
    /** Tire-related (Wheel Balance, Valve Stem) */ VisaItemCommodityCode["TIRE_RELATED"] = "TIRE_RELATED";
    /** Tire Repair */ VisaItemCommodityCode["TIRE_REPAIR"] = "TIRE_REPAIR";
    /** Tire Rotation */ VisaItemCommodityCode["TIRE_ROTATION"] = "TIRE_ROTATION";
    /** Tobacco - Other */ VisaItemCommodityCode["TOBACCO_OTHER"] = "TOBACCO_OTHER";
    /** Toll Payments */ VisaItemCommodityCode["TOLL"] = "TOLL";
    /** Towing */ VisaItemCommodityCode["TOWING"] = "TOWING";
    /** Trailer Wash */ VisaItemCommodityCode["TRAILER_WASH"] = "TRAILER_WASH";
    /** Transmission Service */ VisaItemCommodityCode["TRANSMISSION_SERVICE"] = "TRANSMISSION_SERVICE";
    /** Transportation */ VisaItemCommodityCode["TRANSPORTATION"] = "TRANSPORTATION";
    /** Truck Tank Cleaning */ VisaItemCommodityCode["TRUNK_TANK_CLEANING"] = "TRUNK_TANK_CLEANING";
    /** <Deprecated> Ultra Low Sulfur #1 */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_1"] = "ULTRA_LOW_SULFUR_1";
    /** <Deprecated> Ultra Low Sulfur #2 */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_2"] = "ULTRA_LOW_SULFUR_2";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 2% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_2";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 5% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_5";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 10% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_10";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 11% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_11";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 15% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_15";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 20% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_20";
    /** <Deprecated> Ultra Low Sulfur Biodiesel Blend 100% */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100"] = "ULTRA_LOW_SULFUR_BIODIESEL_BLEND_100";
    /** <Deprecated> Ultra Low Sulfur Premium Diesel #2 */ VisaItemCommodityCode["ULTRA_LOW_SULFUR_PREMIUM_1"] = "ULTRA_LOW_SULFUR_PREMIUM_1";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_1"] = "UNASSIGNED_1";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_2"] = "UNASSIGNED_2";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_3"] = "UNASSIGNED_3";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_4"] = "UNASSIGNED_4";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_5"] = "UNASSIGNED_5";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_6"] = "UNASSIGNED_6";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_7"] = "UNASSIGNED_7";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_8"] = "UNASSIGNED_8";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_9"] = "UNASSIGNED_9";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_10"] = "UNASSIGNED_10";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_11"] = "UNASSIGNED_11";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_12"] = "UNASSIGNED_12";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_13"] = "UNASSIGNED_13";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_14"] = "UNASSIGNED_14";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_15"] = "UNASSIGNED_15";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_16"] = "UNASSIGNED_16";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_17"] = "UNASSIGNED_17";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_18"] = "UNASSIGNED_18";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_19"] = "UNASSIGNED_19";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_20"] = "UNASSIGNED_20";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_21"] = "UNASSIGNED_21";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_22"] = "UNASSIGNED_22";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_23"] = "UNASSIGNED_23";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_24"] = "UNASSIGNED_24";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_25"] = "UNASSIGNED_25";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_26"] = "UNASSIGNED_26";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_27"] = "UNASSIGNED_27";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_28"] = "UNASSIGNED_28";
    /** Unassigned. Reserved for Future Use. */ VisaItemCommodityCode["UNASSIGNED_29"] = "UNASSIGNED_29";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_30"] = "UNASSIGNED_30";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_31"] = "UNASSIGNED_31";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_32"] = "UNASSIGNED_32";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_33"] = "UNASSIGNED_33";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_34"] = "UNASSIGNED_34";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_35"] = "UNASSIGNED_35";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_36"] = "UNASSIGNED_36";
    /** Unassigned. Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_37"] = "UNASSIGNED_37";
    /** Unassigned Automotive Products and Services */ VisaItemCommodityCode["UNASSIGNED_AUTO_PS_1"] = "UNASSIGNED_AUTO_PS_1";
    /** Unassigned Automotive Products and Services */ VisaItemCommodityCode["UNASSIGNED_AUTO_PS_2"] = "UNASSIGNED_AUTO_PS_2";
    /** Unassigned Automotive Products and Services */ VisaItemCommodityCode["UNASSIGNED_AUTO_PS_3"] = "UNASSIGNED_AUTO_PS_3";
    /** Unassigned Automotive Products and Services */ VisaItemCommodityCode["UNASSIGNED_AUTO_PS_4"] = "UNASSIGNED_AUTO_PS_4";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_1"] = "UNASSIGNED_BEV_1";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_2"] = "UNASSIGNED_BEV_2";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_3"] = "UNASSIGNED_BEV_3";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_4"] = "UNASSIGNED_BEV_4";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_5"] = "UNASSIGNED_BEV_5";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_6"] = "UNASSIGNED_BEV_6";
    /** Unassigned Beverage Items - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_BEV_7"] = "UNASSIGNED_BEV_7";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_1"] = "UNASSIGNED_GROCERY_1";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_2"] = "UNASSIGNED_GROCERY_2";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_3"] = "UNASSIGNED_GROCERY_3";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_4"] = "UNASSIGNED_GROCERY_4";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_5"] = "UNASSIGNED_GROCERY_5";
    /** Unassigned Food and Grocery Items */ VisaItemCommodityCode["UNASSIGNED_GROCERY_6"] = "UNASSIGNED_GROCERY_6";
    /** Unassigned Repair Value - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_REPAIR_1"] = "UNASSIGNED_REPAIR_1";
    /** Unassigned Repair Value - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_REPAIR_2"] = "UNASSIGNED_REPAIR_2";
    /** Unassigned Repair Value - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_REPAIR_3"] = "UNASSIGNED_REPAIR_3";
    /** Unassigned Repair Value - Reserved for Future Use */ VisaItemCommodityCode["UNASSIGNED_REPAIR_4"] = "UNASSIGNED_REPAIR_4";
    /** Undefined Alcohol - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_ALCOHOL_1"] = "UNDEFINED_ALCOHOL_1";
    /** Undefined Alcohol - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_ALCOHOL_2"] = "UNDEFINED_ALCOHOL_2";
    /** Undefined Alcohol - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_ALCOHOL_3"] = "UNDEFINED_ALCOHOL_3";
    /** Undefined Alcohol - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_ALCOHOL_4"] = "UNDEFINED_ALCOHOL_4";
    /** Undefined Alcohol - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_ALCOHOL_5"] = "UNDEFINED_ALCOHOL_5";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_1"] = "UNDEFINED_AMIN_1";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_2"] = "UNDEFINED_AMIN_2";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_3"] = "UNDEFINED_AMIN_3";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_4"] = "UNDEFINED_AMIN_4";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_5"] = "UNDEFINED_AMIN_5";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_6"] = "UNDEFINED_AMIN_6";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_7"] = "UNDEFINED_AMIN_7";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_8"] = "UNDEFINED_AMIN_8";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_9"] = "UNDEFINED_AMIN_9";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_10"] = "UNDEFINED_AMIN_10";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_11"] = "UNDEFINED_AMIN_11";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_12"] = "UNDEFINED_AMIN_12";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_13"] = "UNDEFINED_AMIN_13";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_14"] = "UNDEFINED_AMIN_14";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_15"] = "UNDEFINED_AMIN_15";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_16"] = "UNDEFINED_AMIN_16";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_17"] = "UNDEFINED_AMIN_17";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_18"] = "UNDEFINED_AMIN_18";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_19"] = "UNDEFINED_AMIN_19";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_20"] = "UNDEFINED_AMIN_20";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_21"] = "UNDEFINED_AMIN_21";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_22"] = "UNDEFINED_AMIN_22";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_23"] = "UNDEFINED_AMIN_23";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_24"] = "UNDEFINED_AMIN_24";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_25"] = "UNDEFINED_AMIN_25";
    /** Undefined Administrative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AMIN_26"] = "UNDEFINED_AMIN_26";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_1"] = "UNDEFINED_AVIATION_1";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_2"] = "UNDEFINED_AVIATION_2";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_3"] = "UNDEFINED_AVIATION_3";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_4"] = "UNDEFINED_AVIATION_4";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_5"] = "UNDEFINED_AVIATION_5";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_6"] = "UNDEFINED_AVIATION_6";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_7"] = "UNDEFINED_AVIATION_7";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_8"] = "UNDEFINED_AVIATION_8";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_9"] = "UNDEFINED_AVIATION_9";
    /** Undefined Aviation - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_AVIATION_10"] = "UNDEFINED_AVIATION_10";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_1"] = "UNDEFINED_BILL_PAY_1";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_2"] = "UNDEFINED_BILL_PAY_2";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_3"] = "UNDEFINED_BILL_PAY_3";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_4"] = "UNDEFINED_BILL_PAY_4";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_5"] = "UNDEFINED_BILL_PAY_5";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_6"] = "UNDEFINED_BILL_PAY_6";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_7"] = "UNDEFINED_BILL_PAY_7";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_8"] = "UNDEFINED_BILL_PAY_8";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_9"] = "UNDEFINED_BILL_PAY_9";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_10"] = "UNDEFINED_BILL_PAY_10";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_11"] = "UNDEFINED_BILL_PAY_11";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_12"] = "UNDEFINED_BILL_PAY_12";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_13"] = "UNDEFINED_BILL_PAY_13";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_14"] = "UNDEFINED_BILL_PAY_14";
    /** Undefined Prepaid and Bill Pay – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_BILL_PAY_15"] = "UNDEFINED_BILL_PAY_15";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_1"] = "UNDEFINED_CANDY_1";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_2"] = "UNDEFINED_CANDY_2";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_3"] = "UNDEFINED_CANDY_3";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_4"] = "UNDEFINED_CANDY_4";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_5"] = "UNDEFINED_CANDY_5";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_6"] = "UNDEFINED_CANDY_6";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_7"] = "UNDEFINED_CANDY_7";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_8"] = "UNDEFINED_CANDY_8";
    /** Undefined Candy - Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CANDY_9"] = "UNDEFINED_CANDY_9";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_1"] = "UNDEFINED_CBD_1";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_2"] = "UNDEFINED_CBD_2";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_3"] = "UNDEFINED_CBD_3";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_4"] = "UNDEFINED_CBD_4";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_5"] = "UNDEFINED_CBD_5";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_6"] = "UNDEFINED_CBD_6";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_7"] = "UNDEFINED_CBD_7";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_8"] = "UNDEFINED_CBD_8";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_9"] = "UNDEFINED_CBD_9";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_10"] = "UNDEFINED_CBD_10";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_11"] = "UNDEFINED_CBD_11";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_12"] = "UNDEFINED_CBD_12";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_13"] = "UNDEFINED_CBD_13";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_14"] = "UNDEFINED_CBD_14";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_15"] = "UNDEFINED_CBD_15";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_16"] = "UNDEFINED_CBD_16";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_17"] = "UNDEFINED_CBD_17";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_18"] = "UNDEFINED_CBD_18";
    /** Undefined Cannabinoid – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_CBD_19"] = "UNDEFINED_CBD_19";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_1"] = "UNDEFINED_DAIRY_1";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_2"] = "UNDEFINED_DAIRY_2";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_3"] = "UNDEFINED_DAIRY_3";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_4"] = "UNDEFINED_DAIRY_4";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_5"] = "UNDEFINED_DAIRY_5";
    /** Undefined Dairy - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DAIRY_6"] = "UNDEFINED_DAIRY_6";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_1"] = "UNDEFINED_DELI_1";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_2"] = "UNDEFINED_DELI_2";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_3"] = "UNDEFINED_DELI_3";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_4"] = "UNDEFINED_DELI_4";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_5"] = "UNDEFINED_DELI_5";
    /** Undefined Deli - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DELI_6"] = "UNDEFINED_DELI_6";
    /** Undefined Dispensed Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DISPENSED_BEV_1"] = "UNDEFINED_DISPENSED_BEV_1";
    /** Undefined Dispensed Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DISPENSED_BEV_2"] = "UNDEFINED_DISPENSED_BEV_2";
    /** Undefined Dispensed Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DISPENSED_BEV_3"] = "UNDEFINED_DISPENSED_BEV_3";
    /** Undefined Dispensed Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DISPENSED_BEV_4"] = "UNDEFINED_DISPENSED_BEV_4";
    /** Undefined Dispensed Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_DISPENSED_BEV_5"] = "UNDEFINED_DISPENSED_BEV_5";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_1"] = "UNDEFINED_FOODSERVICE_1";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_2"] = "UNDEFINED_FOODSERVICE_2";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_3"] = "UNDEFINED_FOODSERVICE_3";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_4"] = "UNDEFINED_FOODSERVICE_4";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_5"] = "UNDEFINED_FOODSERVICE_5";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_6"] = "UNDEFINED_FOODSERVICE_6";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_7"] = "UNDEFINED_FOODSERVICE_7";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_8"] = "UNDEFINED_FOODSERVICE_8";
    /** Undefined Foodservice – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_FOODSERVICE_9"] = "UNDEFINED_FOODSERVICE_9";
    /** Undefined Grocery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_GROCERY_1"] = "UNDEFINED_GROCERY_1";
    /** Undefined Grocery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_GROCERY_2"] = "UNDEFINED_GROCERY_2";
    /** Undefined Grocery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_GROCERY_3"] = "UNDEFINED_GROCERY_3";
    /** Undefined Grocery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_GROCERY_4"] = "UNDEFINED_GROCERY_4";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_1"] = "UNDEFINED_HEALTH_1";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_2"] = "UNDEFINED_HEALTH_2";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_3"] = "UNDEFINED_HEALTH_3";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_4"] = "UNDEFINED_HEALTH_4";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_5"] = "UNDEFINED_HEALTH_5";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_6"] = "UNDEFINED_HEALTH_6";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_7"] = "UNDEFINED_HEALTH_7";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_8"] = "UNDEFINED_HEALTH_8";
    /** Undefined Health & Beauty Care – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_HEALTH_9"] = "UNDEFINED_HEALTH_9";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_1"] = "UNDEFINED_LOTTERY_1";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_2"] = "UNDEFINED_LOTTERY_2";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_3"] = "UNDEFINED_LOTTERY_3";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_4"] = "UNDEFINED_LOTTERY_4";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_5"] = "UNDEFINED_LOTTERY_5";
    /** Undefined Lottery - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_LOTTERY_6"] = "UNDEFINED_LOTTERY_6";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_1"] = "UNDEFINED_MARINE_SERVICES_1";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_2"] = "UNDEFINED_MARINE_SERVICES_2";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_3"] = "UNDEFINED_MARINE_SERVICES_3";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_4"] = "UNDEFINED_MARINE_SERVICES_4";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_5"] = "UNDEFINED_MARINE_SERVICES_5";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_6"] = "UNDEFINED_MARINE_SERVICES_6";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_7"] = "UNDEFINED_MARINE_SERVICES_7";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_8"] = "UNDEFINED_MARINE_SERVICES_8";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_9"] = "UNDEFINED_MARINE_SERVICES_9";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_10"] = "UNDEFINED_MARINE_SERVICES_10";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_11"] = "UNDEFINED_MARINE_SERVICES_11";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_12"] = "UNDEFINED_MARINE_SERVICES_12";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_13"] = "UNDEFINED_MARINE_SERVICES_13";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_14"] = "UNDEFINED_MARINE_SERVICES_14";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_15"] = "UNDEFINED_MARINE_SERVICES_15";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_16"] = "UNDEFINED_MARINE_SERVICES_16";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_17"] = "UNDEFINED_MARINE_SERVICES_17";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_18"] = "UNDEFINED_MARINE_SERVICES_18";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_19"] = "UNDEFINED_MARINE_SERVICES_19";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_20"] = "UNDEFINED_MARINE_SERVICES_20";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_21"] = "UNDEFINED_MARINE_SERVICES_21";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_22"] = "UNDEFINED_MARINE_SERVICES_22";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_23"] = "UNDEFINED_MARINE_SERVICES_23";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_24"] = "UNDEFINED_MARINE_SERVICES_24";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_25"] = "UNDEFINED_MARINE_SERVICES_25";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_26"] = "UNDEFINED_MARINE_SERVICES_26";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_27"] = "UNDEFINED_MARINE_SERVICES_27";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_28"] = "UNDEFINED_MARINE_SERVICES_28";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_29"] = "UNDEFINED_MARINE_SERVICES_29";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_30"] = "UNDEFINED_MARINE_SERVICES_30";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_31"] = "UNDEFINED_MARINE_SERVICES_31";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_32"] = "UNDEFINED_MARINE_SERVICES_32";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_33"] = "UNDEFINED_MARINE_SERVICES_33";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_34"] = "UNDEFINED_MARINE_SERVICES_34";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_35"] = "UNDEFINED_MARINE_SERVICES_35";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_36"] = "UNDEFINED_MARINE_SERVICES_36";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_37"] = "UNDEFINED_MARINE_SERVICES_37";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_38"] = "UNDEFINED_MARINE_SERVICES_38";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_39"] = "UNDEFINED_MARINE_SERVICES_39";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_40"] = "UNDEFINED_MARINE_SERVICES_40";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_41"] = "UNDEFINED_MARINE_SERVICES_41";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_42"] = "UNDEFINED_MARINE_SERVICES_42";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_43"] = "UNDEFINED_MARINE_SERVICES_43";
    /** Undefined Marine Services – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MARINE_SERVICES_44"] = "UNDEFINED_MARINE_SERVICES_44";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_1"] = "UNDEFINED_MERCHANDISE_1";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_2"] = "UNDEFINED_MERCHANDISE_2";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_3"] = "UNDEFINED_MERCHANDISE_3";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_4"] = "UNDEFINED_MERCHANDISE_4";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_5"] = "UNDEFINED_MERCHANDISE_5";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_6"] = "UNDEFINED_MERCHANDISE_6";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_7"] = "UNDEFINED_MERCHANDISE_7";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_8"] = "UNDEFINED_MERCHANDISE_8";
    /** Undefined Merchandise – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_MERCHANDISE_9"] = "UNDEFINED_MERCHANDISE_9";
    /** Undefined Money Order - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_MONEY_ORDER"] = "UNDEFINED_MONEY_ORDER";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_1"] = "UNDEFINED_NEG_1";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_2"] = "UNDEFINED_NEG_2";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_3"] = "UNDEFINED_NEG_3";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_4"] = "UNDEFINED_NEG_4";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_5"] = "UNDEFINED_NEG_5";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_6"] = "UNDEFINED_NEG_6";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_7"] = "UNDEFINED_NEG_7";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_8"] = "UNDEFINED_NEG_8";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_9"] = "UNDEFINED_NEG_9";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_10"] = "UNDEFINED_NEG_10";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_11"] = "UNDEFINED_NEG_11";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_12"] = "UNDEFINED_NEG_12";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_13"] = "UNDEFINED_NEG_13";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_14"] = "UNDEFINED_NEG_14";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_15"] = "UNDEFINED_NEG_15";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_16"] = "UNDEFINED_NEG_16";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_17"] = "UNDEFINED_NEG_17";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_18"] = "UNDEFINED_NEG_18";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_19"] = "UNDEFINED_NEG_19";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_20"] = "UNDEFINED_NEG_20";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_21"] = "UNDEFINED_NEG_21";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_22"] = "UNDEFINED_NEG_22";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_23"] = "UNDEFINED_NEG_23";
    /** Undefined Negative – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_NEG_24"] = "UNDEFINED_NEG_24";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_1"] = "UNDEFINED_PACKAGED_BEV_1";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_2"] = "UNDEFINED_PACKAGED_BEV_2";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_3"] = "UNDEFINED_PACKAGED_BEV_3";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_4"] = "UNDEFINED_PACKAGED_BEV_4";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_5"] = "UNDEFINED_PACKAGED_BEV_5";
    /** Undefined Packaged Beverages - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_PACKAGED_BEV_6"] = "UNDEFINED_PACKAGED_BEV_6";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_1"] = "UNDEFINED_PUBLICATIONS_1";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_2"] = "UNDEFINED_PUBLICATIONS_2";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_3"] = "UNDEFINED_PUBLICATIONS_3";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_4"] = "UNDEFINED_PUBLICATIONS_4";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_5"] = "UNDEFINED_PUBLICATIONS_5";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_6"] = "UNDEFINED_PUBLICATIONS_6";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_7"] = "UNDEFINED_PUBLICATIONS_7";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_8"] = "UNDEFINED_PUBLICATIONS_8";
    /** Undefined General Publications – Reserved for Future Use. */ VisaItemCommodityCode["UNDEFINED_PUBLICATIONS_9"] = "UNDEFINED_PUBLICATIONS_9";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_1"] = "UNDEFINED_SNACKS_1";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_2"] = "UNDEFINED_SNACKS_2";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_3"] = "UNDEFINED_SNACKS_3";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_4"] = "UNDEFINED_SNACKS_4";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_5"] = "UNDEFINED_SNACKS_5";
    /** Undefined Snacks - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_SNACKS_6"] = "UNDEFINED_SNACKS_6";
    /** Undefined Store Services - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_STORE_SERVICES_1"] = "UNDEFINED_STORE_SERVICES_1";
    /** Undefined Store Services - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_STORE_SERVICES_2"] = "UNDEFINED_STORE_SERVICES_2";
    /** Undefined Store Services - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_STORE_SERVICES_3"] = "UNDEFINED_STORE_SERVICES_3";
    /** Undefined Store Services - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_STORE_SERVICES_4"] = "UNDEFINED_STORE_SERVICES_4";
    /** Undefined Store Services - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_STORE_SERVICES_5"] = "UNDEFINED_STORE_SERVICES_5";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_1"] = "UNDEFINED_TOBACCO_1";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_2"] = "UNDEFINED_TOBACCO_2";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_3"] = "UNDEFINED_TOBACCO_3";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_4"] = "UNDEFINED_TOBACCO_4";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_5"] = "UNDEFINED_TOBACCO_5";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_6"] = "UNDEFINED_TOBACCO_6";
    /** Undefined Tobacco - Reserved for Future Use */ VisaItemCommodityCode["UNDEFINED_TOBACCO_7"] = "UNDEFINED_TOBACCO_7";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_1"] = "UNDEFINED_VEHICLE_PS_1";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_2"] = "UNDEFINED_VEHICLE_PS_2";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_3"] = "UNDEFINED_VEHICLE_PS_3";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_4"] = "UNDEFINED_VEHICLE_PS_4";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_5"] = "UNDEFINED_VEHICLE_PS_5";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_6"] = "UNDEFINED_VEHICLE_PS_6";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_7"] = "UNDEFINED_VEHICLE_PS_7";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_8"] = "UNDEFINED_VEHICLE_PS_8";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_9"] = "UNDEFINED_VEHICLE_PS_9";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_10"] = "UNDEFINED_VEHICLE_PS_10";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_11"] = "UNDEFINED_VEHICLE_PS_11";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_12"] = "UNDEFINED_VEHICLE_PS_12";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_13"] = "UNDEFINED_VEHICLE_PS_13";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_14"] = "UNDEFINED_VEHICLE_PS_14";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_15"] = "UNDEFINED_VEHICLE_PS_15";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_16"] = "UNDEFINED_VEHICLE_PS_16";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_17"] = "UNDEFINED_VEHICLE_PS_17";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_18"] = "UNDEFINED_VEHICLE_PS_18";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_19"] = "UNDEFINED_VEHICLE_PS_19";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_20"] = "UNDEFINED_VEHICLE_PS_20";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_21"] = "UNDEFINED_VEHICLE_PS_21";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_22"] = "UNDEFINED_VEHICLE_PS_22";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_23"] = "UNDEFINED_VEHICLE_PS_23";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_24"] = "UNDEFINED_VEHICLE_PS_24";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_25"] = "UNDEFINED_VEHICLE_PS_25";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_26"] = "UNDEFINED_VEHICLE_PS_26";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_27"] = "UNDEFINED_VEHICLE_PS_27";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_28"] = "UNDEFINED_VEHICLE_PS_28";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_29"] = "UNDEFINED_VEHICLE_PS_29";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_30"] = "UNDEFINED_VEHICLE_PS_30";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_31"] = "UNDEFINED_VEHICLE_PS_31";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_32"] = "UNDEFINED_VEHICLE_PS_32";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_33"] = "UNDEFINED_VEHICLE_PS_33";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_34"] = "UNDEFINED_VEHICLE_PS_34";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_35"] = "UNDEFINED_VEHICLE_PS_35";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_36"] = "UNDEFINED_VEHICLE_PS_36";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_37"] = "UNDEFINED_VEHICLE_PS_37";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_38"] = "UNDEFINED_VEHICLE_PS_38";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_39"] = "UNDEFINED_VEHICLE_PS_39";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_40"] = "UNDEFINED_VEHICLE_PS_40";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_41"] = "UNDEFINED_VEHICLE_PS_41";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_42"] = "UNDEFINED_VEHICLE_PS_42";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_43"] = "UNDEFINED_VEHICLE_PS_43";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_44"] = "UNDEFINED_VEHICLE_PS_44";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_45"] = "UNDEFINED_VEHICLE_PS_45";
    /** Undefined Vehicle Products / Services */ VisaItemCommodityCode["UNDEFINED_VEHICLE_PS_46"] = "UNDEFINED_VEHICLE_PS_46";
    /** Unknown/Undefined */ VisaItemCommodityCode["UNKNOWN"] = "UNKNOWN";
    /** <Deprecated> Unleaded Methanol (5.7% blend) */ VisaItemCommodityCode["UNLEADED_METHANOL_57"] = "UNLEADED_METHANOL_57";
    /** <Deprecated> Unleaded Methanol (7.7% blend) */ VisaItemCommodityCode["UNLEADED_METHANOL_77"] = "UNLEADED_METHANOL_77";
    /** <Deprecated> Unleaded Plus Methanol (5.7% blend) */ VisaItemCommodityCode["UNLEADED_PLUS_METHANOL_57"] = "UNLEADED_PLUS_METHANOL_57";
    /** <Deprecated> Unleaded Plus Methanol (7.7% blend) */ VisaItemCommodityCode["UNLEADED_PLUS_METHANOL_77"] = "UNLEADED_PLUS_METHANOL_77";
    /** <Deprecated> Super Unleaded Methanol (5.7% blend) */ VisaItemCommodityCode["UNLEADED_SUPER_METHANOL_57"] = "UNLEADED_SUPER_METHANOL_57";
    /** Vehicle Accessories */ VisaItemCommodityCode["VEHICLE_ACC"] = "VEHICLE_ACC";
    /** Vehicle Fuel Additives/Treatment (Injected) */ VisaItemCommodityCode["VEHICLE_FUEL_ADDITIVES"] = "VEHICLE_FUEL_ADDITIVES";
    /** Vehicle Glass */ VisaItemCommodityCode["VEHICLE_GLASS"] = "VEHICLE_GLASS";
    /** Vehicle Parking */ VisaItemCommodityCode["VEHICLE_PARKING"] = "VEHICLE_PARKING";
    /** Vehicle Parts */ VisaItemCommodityCode["VEHICLE_PARTS"] = "VEHICLE_PARTS";
    /** Vehicle Prep */ VisaItemCommodityCode["VEHICLE_PREP"] = "VEHICLE_PREP";
    /** Vehicle Rental */ VisaItemCommodityCode["VEHICLE_RENTAL"] = "VEHICLE_RENTAL";
    /** Washer Fluid */ VisaItemCommodityCode["WASHER_FLUID"] = "WASHER_FLUID";
    /** Wash Out */ VisaItemCommodityCode["WASH_OUT"] = "WASH_OUT";
    /** <Deprecated> Weather Fees */ VisaItemCommodityCode["WEATHER_FEES"] = "WEATHER_FEES";
    /** White Gas */ VisaItemCommodityCode["WHITE_GAS"] = "WHITE_GAS";
    /** Wine */ VisaItemCommodityCode["WINE"] = "WINE";
    /** Wipers */ VisaItemCommodityCode["WIPERS"] = "WIPERS";
    /** Wireless Real Time Recharge */ VisaItemCommodityCode["WL_REAL_TIME_RECHARGE"] = "WL_REAL_TIME_RECHARGE";
    /** Work Order */ VisaItemCommodityCode["WORK_ORDER"] = "WORK_ORDER";
    return VisaItemCommodityCode;
}({});
var $2f53fee15f29b056$export$4004e6e4a61b290 = /*#__PURE__*/ function(VisaLineItemDetailIndicator) {
    /** Credit line item */ VisaLineItemDetailIndicator["CREDIT"] = "CREDIT";
    /** Normal line item */ VisaLineItemDetailIndicator["NORMAL"] = "NORMAL";
    /** Payment line item */ VisaLineItemDetailIndicator["PAYMENT"] = "PAYMENT";
    return VisaLineItemDetailIndicator;
}({});
var $2f53fee15f29b056$export$f2ac255feff8aba4 = /*#__PURE__*/ function(VisaMotoAndElectronicCommerceIndicator) {
    /** Installment-multiple payments for a specified term, usually until payment has been satisfied. */ VisaMotoAndElectronicCommerceIndicator["INSTALLMENT_PAYMENT"] = "INSTALLMENT_PAYMENT";
    /** Non-authenticated security transaction. */ VisaMotoAndElectronicCommerceIndicator["NON_AUTHENTICATED_SECURITY_TRANSACTION"] = "NON_AUTHENTICATED_SECURITY_TRANSACTION";
    /** Non-authenticated security transaction at a 3-D secure-capable merchant, and merchant attempted to authenticate the cardholder using 3-D secure. */ VisaMotoAndElectronicCommerceIndicator["NON_AUTHENTICATED_SECURITY_TRANSACTION_WITH_3D_SECURE"] = "NON_AUTHENTICATED_SECURITY_TRANSACTION_WITH_3D_SECURE";
    /** Non-secure transaction. */ VisaMotoAndElectronicCommerceIndicator["NON_SECURE_TRANSACTION"] = "NON_SECURE_TRANSACTION";
    /** The transaction type does not support classification. */ VisaMotoAndElectronicCommerceIndicator["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    /** Recurring-multiple, ongoing payments for an indefinite term, until the cardholder or biller cancels the recurring payment arrangement. */ VisaMotoAndElectronicCommerceIndicator["RECURRING_TRANSACTION"] = "RECURRING_TRANSACTION";
    /** Secure electronic commerce transaction. */ VisaMotoAndElectronicCommerceIndicator["SECURE_ELECTRONIC_COMMERCE_TRANSACTION"] = "SECURE_ELECTRONIC_COMMERCE_TRANSACTION";
    /** Manual-one-time, single payment initiated by the cardholder. */ VisaMotoAndElectronicCommerceIndicator["SINGLE_TRANSACTION_OF_MAIL_OR_PHONE_ORDER"] = "SINGLE_TRANSACTION_OF_MAIL_OR_PHONE_ORDER";
    /** The transaction could not be classified. */ VisaMotoAndElectronicCommerceIndicator["UNKNOWN_CLASSIFICATION"] = "UNKNOWN_CLASSIFICATION";
    return VisaMotoAndElectronicCommerceIndicator;
}({});
var $2f53fee15f29b056$export$f2dacb054dd8b275 = /*#__PURE__*/ function(VisaNonFuelProductCode) {
    /** AC Parts 052-061 */ VisaNonFuelProductCode["AC_PARTS"] = "AC_PARTS";
    /** Air Conditioning Service */ VisaNonFuelProductCode["AC_SERVICE"] = "AC_SERVICE";
    /** Aircraft Accessories */ VisaNonFuelProductCode["AIRCRAFT_ACC"] = "AIRCRAFT_ACC";
    /** Aircraft Cleaning */ VisaNonFuelProductCode["AIRCRAFT_CLEANING"] = "AIRCRAFT_CLEANING";
    /** Aircraft Fuel Additive */ VisaNonFuelProductCode["AIRCRAFT_FUEL_ADDITIVE"] = "AIRCRAFT_FUEL_ADDITIVE";
    /** Aircraft Ground Hauling */ VisaNonFuelProductCode["AIRCRAFT_GROUND_HAULING"] = "AIRCRAFT_GROUND_HAULING";
    /** Aircraft Ground Power Unit */ VisaNonFuelProductCode["AIRCRAFT_GROUND_PU"] = "AIRCRAFT_GROUND_PU";
    /** Aircraft Labor */ VisaNonFuelProductCode["AIRCRAFT_LABOR"] = "AIRCRAFT_LABOR";
    /** Aircraft Maintenance */ VisaNonFuelProductCode["AIRCRAFT_MAINTENANCE"] = "AIRCRAFT_MAINTENANCE";
    /** Aircraft Parking Fees */ VisaNonFuelProductCode["AIRCRAFT_PARKING_FEE"] = "AIRCRAFT_PARKING_FEE";
    /** Aircraft Rental */ VisaNonFuelProductCode["AIRCRAFT_RENTAL"] = "AIRCRAFT_RENTAL";
    /** Aircraft Sanitation Fees */ VisaNonFuelProductCode["AIRCRAFT_SANITATION"] = "AIRCRAFT_SANITATION";
    /** Aircraft Service */ VisaNonFuelProductCode["AIRCRAFT_SERVICE"] = "AIRCRAFT_SERVICE";
    /** Aircraft Tie Down Fees */ VisaNonFuelProductCode["AIRCRAFT_TIE_DOWN_FEE"] = "AIRCRAFT_TIE_DOWN_FEE";
    /** Aircraft Work Order */ VisaNonFuelProductCode["AIRCRAFT_WO"] = "AIRCRAFT_WO";
    /** Airport Fees */ VisaNonFuelProductCode["AIRPORT_FEE"] = "AIRPORT_FEE";
    /** Air Filter */ VisaNonFuelProductCode["AIR_FILTER"] = "AIR_FILTER";
    /** Alternative Snacks */ VisaNonFuelProductCode["ALT_SNACKS"] = "ALT_SNACKS";
    /** Anti-Freeze */ VisaNonFuelProductCode["ANTI_FREEZE"] = "ANTI_FREEZE";
    /** <Deprecated> APU or Aircraft Jump Seat */ VisaNonFuelProductCode["APU"] = "APU";
    /** <Deprecated> Avionics */ VisaNonFuelProductCode["AVIONICS"] = "AVIONICS";
    /** AvGas Federal Excise Tax */ VisaNonFuelProductCode["AV_GAS_FED_E_TAX"] = "AV_GAS_FED_E_TAX";
    /** Batteries */ VisaNonFuelProductCode["BATTERIES"] = "BATTERIES";
    /** Beer - Alcoholic */ VisaNonFuelProductCode["BEER"] = "BEER";
    /** Beer - Non-Alcoholic */ VisaNonFuelProductCode["BEER_NA"] = "BEER_NA";
    /** Body Work */ VisaNonFuelProductCode["BODY_WORK"] = "BODY_WORK";
    /** Brake Fluid */ VisaNonFuelProductCode["BRAKE_FLUID"] = "BRAKE_FLUID";
    /** Brake Service */ VisaNonFuelProductCode["BRAKE_SERVICE"] = "BRAKE_SERVICE";
    /** Call Out Fee */ VisaNonFuelProductCode["CALL_OUT_FEE"] = "CALL_OUT_FEE";
    /** Cargo Handling */ VisaNonFuelProductCode["CARGO_HANDLING"] = "CARGO_HANDLING";
    /** Car Wash */ VisaNonFuelProductCode["CAR_WASH"] = "CAR_WASH";
    /** Cash Back */ VisaNonFuelProductCode["CASH_BACK"] = "CASH_BACK";
    /** Cash Back Fee */ VisaNonFuelProductCode["CASH_BACK_FEE"] = "CASH_BACK_FEE";
    /** Catering */ VisaNonFuelProductCode["CATERING"] = "CATERING";
    /** Cannabidiol (CBD) */ VisaNonFuelProductCode["CBD"] = "CBD";
    /** Charity */ VisaNonFuelProductCode["CHARITY"] = "CHARITY";
    /** Charter Fee */ VisaNonFuelProductCode["CHARTER_FEE"] = "CHARTER_FEE";
    /** Cigarettes */ VisaNonFuelProductCode["CIGARETTES"] = "CIGARETTES";
    /** Cold Dispensed Beverages */ VisaNonFuelProductCode["COLD_DISPENSED_BEV"] = "COLD_DISPENSED_BEV";
    /** Communication Fee */ VisaNonFuelProductCode["COMMUNICATION_FEE"] = "COMMUNICATION_FEE";
    /** Corrosion Inhibitor */ VisaNonFuelProductCode["CORROSION_INHIBITOR"] = "CORROSION_INHIBITOR";
    /** Coupon 1 */ VisaNonFuelProductCode["COUPON_1"] = "COUPON_1";
    /** Coupon 2 */ VisaNonFuelProductCode["COUPON_2"] = "COUPON_2";
    /** Coupon 3 */ VisaNonFuelProductCode["COUPON_3"] = "COUPON_3";
    /** Coupon 4 */ VisaNonFuelProductCode["COUPON_4"] = "COUPON_4";
    /** Coupon 5 */ VisaNonFuelProductCode["COUPON_5"] = "COUPON_5";
    /** Deli Items */ VisaNonFuelProductCode["DELI_ITEMS"] = "DELI_ITEMS";
    /** De-fuel */ VisaNonFuelProductCode["DE_FUEL"] = "DE_FUEL";
    /** De-icing */ VisaNonFuelProductCode["DE_ICING"] = "DE_ICING";
    /** Disable Device/Handset Lock */ VisaNonFuelProductCode["DISABLE_HANDSET"] = "DISABLE_HANDSET";
    /** Discount 1 */ VisaNonFuelProductCode["DISCOUNT_1"] = "DISCOUNT_1";
    /** Discount 2 */ VisaNonFuelProductCode["DISCOUNT_2"] = "DISCOUNT_2";
    /** Discount 3 */ VisaNonFuelProductCode["DISCOUNT_3"] = "DISCOUNT_3";
    /** Discount 4 */ VisaNonFuelProductCode["DISCOUNT_4"] = "DISCOUNT_4";
    /** Discount 5 */ VisaNonFuelProductCode["DISCOUNT_5"] = "DISCOUNT_5";
    /** Enable Device/Handset Unlock */ VisaNonFuelProductCode["ENABLE_HANDSET"] = "ENABLE_HANDSET";
    /** Engine Service */ VisaNonFuelProductCode["ENGINE_SERVICE"] = "ENGINE_SERVICE";
    /** EV Battery Exchanges */ VisaNonFuelProductCode["EV_BATTERY_ECH"] = "EV_BATTERY_ECH";
    /** EV Charging Fee */ VisaNonFuelProductCode["EV_CHARGE"] = "EV_CHARGE";
    /** Exhaust Service */ VisaNonFuelProductCode["EXHAUST_SERVICE"] = "EXHAUST_SERVICE";
    /** Fee 1 */ VisaNonFuelProductCode["FEE_1"] = "FEE_1";
    /** Fee 2 */ VisaNonFuelProductCode["FEE_2"] = "FEE_2";
    /** Fee 3 */ VisaNonFuelProductCode["FEE_3"] = "FEE_3";
    /** Fee 4 */ VisaNonFuelProductCode["FEE_4"] = "FEE_4";
    /** Fee 5 */ VisaNonFuelProductCode["FEE_5"] = "FEE_5";
    /** Financial Prepaid Card Activate */ VisaNonFuelProductCode["FIN_PREPAID_ACT"] = "FIN_PREPAID_ACT";
    /** Financial Prepaid Card Reload */ VisaNonFuelProductCode["FIN_PREPAID_REL"] = "FIN_PREPAID_REL";
    /** <Deprecated> Flight Planning Fees */ VisaNonFuelProductCode["FLIGHT_PLANNING_FEES"] = "FLIGHT_PLANNING_FEES";
    /** Flight Plans/Weather Brief */ VisaNonFuelProductCode["FLIGHT_PLANS"] = "FLIGHT_PLANS";
    /** Flow Fee */ VisaNonFuelProductCode["FLOW_FEE"] = "FLOW_FEE";
    /** Fluid Milk Products */ VisaNonFuelProductCode["FLUID_MILK"] = "FLUID_MILK";
    /** Frozen Dispensed Beverages */ VisaNonFuelProductCode["FROZEN_DISPENSED_BEV"] = "FROZEN_DISPENSED_BEV";
    /** Frozen Foods */ VisaNonFuelProductCode["FROZEN_FOOD"] = "FROZEN_FOOD";
    /** Fuel System */ VisaNonFuelProductCode["FUEL_SYSTEM"] = "FUEL_SYSTEM";
    /** General Alcohol */ VisaNonFuelProductCode["GEN_ALCOHOL"] = "GEN_ALCOHOL";
    /** General Automotive Merchandise */ VisaNonFuelProductCode["GEN_AUTO_MERCH"] = "GEN_AUTO_MERCH";
    /** General Candy */ VisaNonFuelProductCode["GEN_CANDY"] = "GEN_CANDY";
    /** General Dairy */ VisaNonFuelProductCode["GEN_DAIRY"] = "GEN_DAIRY";
    /** General Deli */ VisaNonFuelProductCode["GEN_DELI"] = "GEN_DELI";
    /** General Dispensed Beverage */ VisaNonFuelProductCode["GEN_DISPENSED_BEV"] = "GEN_DISPENSED_BEV";
    /** General Foodservice */ VisaNonFuelProductCode["GEN_FOODSERVICE"] = "GEN_FOODSERVICE";
    /** General Grocery */ VisaNonFuelProductCode["GEN_GROCERY"] = "GEN_GROCERY";
    /** General Health & Beauty Care */ VisaNonFuelProductCode["GEN_HEALTH"] = "GEN_HEALTH";
    /** General Ice */ VisaNonFuelProductCode["GEN_ICE"] = "GEN_ICE";
    /** General Lottery */ VisaNonFuelProductCode["GEN_LOTTERY"] = "GEN_LOTTERY";
    /** General Merchandise */ VisaNonFuelProductCode["GEN_MERCH"] = "GEN_MERCH";
    /** General Money Order */ VisaNonFuelProductCode["GEN_MONEY_ORDER"] = "GEN_MONEY_ORDER";
    /** General Packaged Beverage */ VisaNonFuelProductCode["GEN_PACKAGED_BEV"] = "GEN_PACKAGED_BEV";
    /** General Publications */ VisaNonFuelProductCode["GEN_PUBLICATIONS"] = "GEN_PUBLICATIONS";
    /** General Purpose Activate */ VisaNonFuelProductCode["GEN_PURPOSE_ACT"] = "GEN_PURPOSE_ACT";
    /** General Purpose Reload */ VisaNonFuelProductCode["GEN_PURPOSE_REL"] = "GEN_PURPOSE_REL";
    /** General Snacks */ VisaNonFuelProductCode["GEN_SNACKS"] = "GEN_SNACKS";
    /** General Store Service */ VisaNonFuelProductCode["GEN_STORE_SERVICE"] = "GEN_STORE_SERVICE";
    /** General Tobacco */ VisaNonFuelProductCode["GEN_TOBACCO"] = "GEN_TOBACCO";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED"] = "GEN_UNDEFINED";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_2"] = "GEN_UNDEFINED_2";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_3"] = "GEN_UNDEFINED_3";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_4"] = "GEN_UNDEFINED_4";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_5"] = "GEN_UNDEFINED_5";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_6"] = "GEN_UNDEFINED_6";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_7"] = "GEN_UNDEFINED_7";
    /** General Undefined – Reserved for Conexxus Future Use */ VisaNonFuelProductCode["GEN_UNDEFINED_8"] = "GEN_UNDEFINED_8";
    /** Ground Equipment Service Fees */ VisaNonFuelProductCode["GES_FEE"] = "GES_FEE";
    /** Gratuity */ VisaNonFuelProductCode["GRATUITY"] = "GRATUITY";
    /** Groceries - Edible */ VisaNonFuelProductCode["GROCERY_EDIBLE"] = "GROCERY_EDIBLE";
    /** Groceries - Non-Edible */ VisaNonFuelProductCode["GROCERY_NON_EDIBLE"] = "GROCERY_NON_EDIBLE";
    /** Groceries - Perishable */ VisaNonFuelProductCode["GROCERY_PER_EDIBLE"] = "GROCERY_PER_EDIBLE";
    /** GST/HST (Canadian)/VAT 1 */ VisaNonFuelProductCode["GST_HST_VAT_1"] = "GST_HST_VAT_1";
    /** Hangar Fee */ VisaNonFuelProductCode["HANGAR_FEE"] = "HANGAR_FEE";
    /** Home Delivery */ VisaNonFuelProductCode["HOME_DELIVERY"] = "HOME_DELIVERY";
    /** Hoses */ VisaNonFuelProductCode["HOSES"] = "HOSES";
    /** Hot Dispensed Beverages */ VisaNonFuelProductCode["HOT_DISPENSED_BEV"] = "HOT_DISPENSED_BEV";
    /** Inspection */ VisaNonFuelProductCode["INSPECTION"] = "INSPECTION";
    /** Instruction Fee */ VisaNonFuelProductCode["INSTRUCTION_FEE"] = "INSTRUCTION_FEE";
    /** IT/Bladder */ VisaNonFuelProductCode["IT_BLADDER"] = "IT_BLADDER";
    /** Jet Federal Excise Tax */ VisaNonFuelProductCode["JET_FD_E_TAX"] = "JET_FD_E_TAX";
    /** Labor */ VisaNonFuelProductCode["LABOR"] = "LABOR";
    /** Lamps */ VisaNonFuelProductCode["LAMPS"] = "LAMPS";
    /** Landing Fee */ VisaNonFuelProductCode["LANDING_FEE"] = "LANDING_FEE";
    /** Launch Fee */ VisaNonFuelProductCode["LAUNCH_FEE"] = "LAUNCH_FEE";
    /** Liquor */ VisaNonFuelProductCode["LIQUOR"] = "LIQUOR";
    /** Local Discount 1 */ VisaNonFuelProductCode["LOCAL_DISCOUNT_1"] = "LOCAL_DISCOUNT_1";
    /** Local Discount 2 */ VisaNonFuelProductCode["LOCAL_DISCOUNT_2"] = "LOCAL_DISCOUNT_2";
    /** Local Discount 3 */ VisaNonFuelProductCode["LOCAL_DISCOUNT_3"] = "LOCAL_DISCOUNT_3";
    /** Local Discount 4 */ VisaNonFuelProductCode["LOCAL_DISCOUNT_4"] = "LOCAL_DISCOUNT_4";
    /** Local Discount 5 */ VisaNonFuelProductCode["LOCAL_DISCOUNT_5"] = "LOCAL_DISCOUNT_5";
    /** Lodging */ VisaNonFuelProductCode["LODGING"] = "LODGING";
    /** Lottery - Other */ VisaNonFuelProductCode["LOTTERT_OT"] = "LOTTERT_OT";
    /** Lottery - Instant */ VisaNonFuelProductCode["LOTTERY_IN"] = "LOTTERY_IN";
    /** Lottery - Online */ VisaNonFuelProductCode["LOTTERY_ON"] = "LOTTERY_ON";
    /** Lottery Pay Out - Instant */ VisaNonFuelProductCode["LOTTERY_PO_IN"] = "LOTTERY_PO_IN";
    /** Lottery Pay Out - Online */ VisaNonFuelProductCode["LOTTERY_PO_ON"] = "LOTTERY_PO_ON";
    /** Lottery Pay Out - Other */ VisaNonFuelProductCode["LOTTERY_PO_OT"] = "LOTTERY_PO_OT";
    /** Lube */ VisaNonFuelProductCode["LUBE"] = "LUBE";
    /** Marine Labor */ VisaNonFuelProductCode["MARINE_LABOR"] = "MARINE_LABOR";
    /** Marine Service */ VisaNonFuelProductCode["MARINE_SERVICE"] = "MARINE_SERVICE";
    /** Marine Work Order */ VisaNonFuelProductCode["MARINE_WO"] = "MARINE_WO";
    /** Membership/Loyalty */ VisaNonFuelProductCode["MEMBERSHIP"] = "MEMBERSHIP";
    /** <Deprecated> Miscellaneous */ VisaNonFuelProductCode["MISC"] = "MISC";
    /** Miscellaneous Administrative */ VisaNonFuelProductCode["MISC_ADMIN"] = "MISC_ADMIN";
    /** Miscellaneous Aviation Products/Services */ VisaNonFuelProductCode["MISC_AV_PS"] = "MISC_AV_PS";
    /** Miscellaneous Aviation Tax */ VisaNonFuelProductCode["MISC_AV_TAX"] = "MISC_AV_TAX";
    /** Miscellaneous Marine Products/Services */ VisaNonFuelProductCode["MISC_MARINE_PS"] = "MISC_MARINE_PS";
    /** Miscellaneous Negative Administrative */ VisaNonFuelProductCode["MISC_NEG_ADMIN"] = "MISC_NEG_ADMIN";
    /** Miscellaneous Vehicle Products / Services */ VisaNonFuelProductCode["MISC_VEHICLE_PS"] = "MISC_VEHICLE_PS";
    /** Money Order - Dividend Check */ VisaNonFuelProductCode["MONEY_ORDER_DC"] = "MONEY_ORDER_DC";
    /** Money Order - Gift Certificate */ VisaNonFuelProductCode["MONEY_ORDER_GC"] = "MONEY_ORDER_GC";
    /** Money Order - Official Check */ VisaNonFuelProductCode["MONEY_ORDER_OC"] = "MONEY_ORDER_OC";
    /** Money Order - Payroll Check */ VisaNonFuelProductCode["MONEY_ORDER_PC"] = "MONEY_ORDER_PC";
    /** Money Order - Rebate Check */ VisaNonFuelProductCode["MONEY_ORDER_REBC"] = "MONEY_ORDER_REBC";
    /** Money Order - Refund Check */ VisaNonFuelProductCode["MONEY_ORDER_REFC"] = "MONEY_ORDER_REFC";
    /** Money Order - Utility Check */ VisaNonFuelProductCode["MONEY_ORDER_UC"] = "MONEY_ORDER_UC";
    /** Money Order - Vendor Payment */ VisaNonFuelProductCode["MONEY_ORDER_VP"] = "MONEY_ORDER_VP";
    /** Motor Oil */ VisaNonFuelProductCode["MOTOR_OIL"] = "MOTOR_OIL";
    /** Multiple Payee Bill Pay */ VisaNonFuelProductCode["MULTI_BILL_PAY"] = "MULTI_BILL_PAY";
    /** Oil Change */ VisaNonFuelProductCode["OIL_CHANGE"] = "OIL_CHANGE";
    /** Oil Filter */ VisaNonFuelProductCode["OIL_FILTER"] = "OIL_FILTER";
    /** Other Dairy */ VisaNonFuelProductCode["OTHER_DAIRY"] = "OTHER_DAIRY";
    /** Other Dispensed Beverages */ VisaNonFuelProductCode["OTHER_DISPENSED_BEV"] = "OTHER_DISPENSED_BEV";
    /** Other Lubricants */ VisaNonFuelProductCode["OTHER_LUBE"] = "OTHER_LUBE";
    /** Other Packaged Beverages */ VisaNonFuelProductCode["OTHER_PACKAGED_BEV"] = "OTHER_PACKAGED_BEV";
    /** Overtime Fees */ VisaNonFuelProductCode["OVERTIME_FEE"] = "OVERTIME_FEE";
    /** Oxygen */ VisaNonFuelProductCode["OXYGEN"] = "OXYGEN";
    /** Packaged Beverages (non-alcoholic) */ VisaNonFuelProductCode["PACKAGED_BEV_NA"] = "PACKAGED_BEV_NA";
    /** Bread - Packaged */ VisaNonFuelProductCode["PACKAGED_BREAD"] = "PACKAGED_BREAD";
    /** Packaged Sandwiches/Deli Products */ VisaNonFuelProductCode["PACKAGED_DELI"] = "PACKAGED_DELI";
    /** Packaged Ice Cream/Novelties */ VisaNonFuelProductCode["PACKAGED_ICE_CREAM"] = "PACKAGED_ICE_CREAM";
    /** Packaged Juice */ VisaNonFuelProductCode["PACKAGED_JUICE"] = "PACKAGED_JUICE";
    /** Pilot Supplies */ VisaNonFuelProductCode["PILOT_SUPPLIES"] = "PILOT_SUPPLIES";
    /** PIN Activate Prepaid Card */ VisaNonFuelProductCode["PIN_PREPAID_ACT"] = "PIN_PREPAID_ACT";
    /** PIN Return Prepaid Card */ VisaNonFuelProductCode["PIN_PREPAID_RET"] = "PIN_PREPAID_RET";
    /** POS/Loyalty Reserved Discount 1 */ VisaNonFuelProductCode["POS_RES_DISCOUNT_1"] = "POS_RES_DISCOUNT_1";
    /** POS/Loyalty Reserved Discount 2 */ VisaNonFuelProductCode["POS_RES_DISCOUNT_2"] = "POS_RES_DISCOUNT_2";
    /** POS/Loyalty Reserved Discount 3 */ VisaNonFuelProductCode["POS_RES_DISCOUNT_3"] = "POS_RES_DISCOUNT_3";
    /** POS/Loyalty Reserved Discount 4 */ VisaNonFuelProductCode["POS_RES_DISCOUNT_4"] = "POS_RES_DISCOUNT_4";
    /** POS/Loyalty Reserved Discount 5 */ VisaNonFuelProductCode["POS_RES_DISCOUNT_5"] = "POS_RES_DISCOUNT_5";
    /** Prepaid Cards - Activation/Recharge */ VisaNonFuelProductCode["PREPAID_ACT"] = "PREPAID_ACT";
    /** Prepaid Cards - Purchase */ VisaNonFuelProductCode["PREPAID_PURCHASE"] = "PREPAID_PURCHASE";
    /** Prepared Foods */ VisaNonFuelProductCode["PREPARED_FOOD"] = "PREPARED_FOOD";
    /** Preventative Maintenance */ VisaNonFuelProductCode["PREV_MAINTENANCE"] = "PREV_MAINTENANCE";
    /** Proprietary Prepaid Card Activate */ VisaNonFuelProductCode["PROP_PREPAID_ACT"] = "PROP_PREPAID_ACT";
    /** Proprietary Prepaid Card Reload */ VisaNonFuelProductCode["PROP_PREPAID_REL"] = "PROP_PREPAID_REL";
    /** PST/QST (Canadian) VAT 2 */ VisaNonFuelProductCode["PST_HST_VAT_2"] = "PST_HST_VAT_2";
    /** Ramp Fees */ VisaNonFuelProductCode["RAMP_FEES"] = "RAMP_FEES";
    /** Real Time Recharge */ VisaNonFuelProductCode["REAL_TIME_RECHARGE"] = "REAL_TIME_RECHARGE";
    /** Repairs */ VisaNonFuelProductCode["REPAIRS"] = "REPAIRS";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_1"] = "RESERVED_1";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_2"] = "RESERVED_2";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_3"] = "RESERVED_3";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_4"] = "RESERVED_4";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_5"] = "RESERVED_5";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_6"] = "RESERVED_6";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_7"] = "RESERVED_7";
    /** Reserved for future use */ VisaNonFuelProductCode["RESERVED_8"] = "RESERVED_8";
    /** Re-service */ VisaNonFuelProductCode["RE_SERVICE"] = "RE_SERVICE";
    /** Road Service */ VisaNonFuelProductCode["ROAD_SERVICE"] = "ROAD_SERVICE";
    /** RV Dump Fee */ VisaNonFuelProductCode["RV_DUMP_FEE"] = "RV_DUMP_FEE";
    /** <Deprecated> Sales Tax as Shown for Non-Fuel Products */ VisaNonFuelProductCode["SALES_TAX_NON_FUEL"] = "SALES_TAX_NON_FUEL";
    /** Salty Snacks */ VisaNonFuelProductCode["SALTY_SNACKS"] = "SALTY_SNACKS";
    /** Scales */ VisaNonFuelProductCode["SCALES"] = "SCALES";
    /** Secure Fees */ VisaNonFuelProductCode["SECURE_FEE"] = "SECURE_FEE";
    /** Service Package */ VisaNonFuelProductCode["SERVICE_PACKAGE"] = "SERVICE_PACKAGE";
    /** Shower */ VisaNonFuelProductCode["SHOWER"] = "SHOWER";
    /** Single Payee Bill Pay */ VisaNonFuelProductCode["SINGLE_BILL_PAY"] = "SINGLE_BILL_PAY";
    /** Slip Rental */ VisaNonFuelProductCode["SLIP_RENTAL"] = "SLIP_RENTAL";
    /** Soda */ VisaNonFuelProductCode["SODA"] = "SODA";
    /** Split Tender */ VisaNonFuelProductCode["SPLIT_TENDER"] = "SPLIT_TENDER";
    /** Static Dissipater Additive */ VisaNonFuelProductCode["STATIC_DISSIPATER_ADDITIVE"] = "STATIC_DISSIPATER_ADDITIVE";
    /** Storage */ VisaNonFuelProductCode["STORAGE"] = "STORAGE";
    /** Sweet Snacks - Packaged */ VisaNonFuelProductCode["SWEET_SNACKS"] = "SWEET_SNACKS";
    /** SWT Rate (Canadian) */ VisaNonFuelProductCode["SWT_RATE"] = "SWT_RATE";
    /** Synthetic Oil */ VisaNonFuelProductCode["SYNTHETIC_OIL"] = "SYNTHETIC_OIL";
    /** Tax 1 */ VisaNonFuelProductCode["TAX_1"] = "TAX_1";
    /** Tax 2 */ VisaNonFuelProductCode["TAX_2"] = "TAX_2";
    /** Tax 3 */ VisaNonFuelProductCode["TAX_3"] = "TAX_3";
    /** Tax 4 */ VisaNonFuelProductCode["TAX_4"] = "TAX_4";
    /** Tax 5 */ VisaNonFuelProductCode["TAX_5"] = "TAX_5";
    /** Tax 6 */ VisaNonFuelProductCode["TAX_6"] = "TAX_6";
    /** Tax 7 */ VisaNonFuelProductCode["TAX_7"] = "TAX_7";
    /** Tax 8 */ VisaNonFuelProductCode["TAX_8"] = "TAX_8";
    /** Tax Discount/Forgiven */ VisaNonFuelProductCode["TAX_DISCOUNT_F"] = "TAX_DISCOUNT_F";
    /** 3rd Party Prepaid Card Activate */ VisaNonFuelProductCode["THREE_P_PREPAID_ACT"] = "THREE_P_PREPAID_ACT";
    /** 3rd Party Prepaid Card Reload */ VisaNonFuelProductCode["THREE_P_PREPAID_REL"] = "THREE_P_PREPAID_REL";
    /** Tires */ VisaNonFuelProductCode["TIRES"] = "TIRES";
    /** <Deprecated> Tires, Batteries, and Accessories */ VisaNonFuelProductCode["TIRES_BATTERIES_ACCESSORIES"] = "TIRES_BATTERIES_ACCESSORIES";
    /** Federal Excise Tax (Tires) */ VisaNonFuelProductCode["TIRES_FET"] = "TIRES_FET";
    /** Tire-related (Wheel Balance, Valve Stem) */ VisaNonFuelProductCode["TIRE_RELATED"] = "TIRE_RELATED";
    /** Tire Repair */ VisaNonFuelProductCode["TIRE_REPAIR"] = "TIRE_REPAIR";
    /** Tire Rotation */ VisaNonFuelProductCode["TIRE_ROTATION"] = "TIRE_ROTATION";
    /** Tobacco - Other */ VisaNonFuelProductCode["TOBACCO_OTHER"] = "TOBACCO_OTHER";
    /** Toll Payments */ VisaNonFuelProductCode["TOLL"] = "TOLL";
    /** Towing */ VisaNonFuelProductCode["TOWING"] = "TOWING";
    /** Trailer Wash */ VisaNonFuelProductCode["TRAILER_WASH"] = "TRAILER_WASH";
    /** Transmission Service */ VisaNonFuelProductCode["TRANSMISSION_SERVICE"] = "TRANSMISSION_SERVICE";
    /** Transportation */ VisaNonFuelProductCode["TRANSPORTATION"] = "TRANSPORTATION";
    /** Truck Tank Cleaning */ VisaNonFuelProductCode["TRUNK_TANK_CLEANING"] = "TRUNK_TANK_CLEANING";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV"] = "UNASSIGNED_BEV";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_2"] = "UNASSIGNED_BEV_2";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_3"] = "UNASSIGNED_BEV_3";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_4"] = "UNASSIGNED_BEV_4";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_5"] = "UNASSIGNED_BEV_5";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_6"] = "UNASSIGNED_BEV_6";
    /** Unassigned Beverage Items */ VisaNonFuelProductCode["UNASSIGNED_BEV_7"] = "UNASSIGNED_BEV_7";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY"] = "UNASSIGNED_GROCERY";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY_2"] = "UNASSIGNED_GROCERY_2";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY_3"] = "UNASSIGNED_GROCERY_3";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY_4"] = "UNASSIGNED_GROCERY_4";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY_5"] = "UNASSIGNED_GROCERY_5";
    /** Unassigned Food and Grocery Items */ VisaNonFuelProductCode["UNASSIGNED_GROCERY_6"] = "UNASSIGNED_GROCERY_6";
    /** Unknown/Undefined */ VisaNonFuelProductCode["UNKNOWN"] = "UNKNOWN";
    /** Vehicle Accessories */ VisaNonFuelProductCode["VEHICLE_ACC"] = "VEHICLE_ACC";
    /** Vehicle Fuel Additives/Treatment (Injected) */ VisaNonFuelProductCode["VEHICLE_FUEL_ADDITIVES"] = "VEHICLE_FUEL_ADDITIVES";
    /** Vehicle Glass */ VisaNonFuelProductCode["VEHICLE_GLASS"] = "VEHICLE_GLASS";
    /** Vehicle Parking */ VisaNonFuelProductCode["VEHICLE_PARKING"] = "VEHICLE_PARKING";
    /** Vehicle Parts */ VisaNonFuelProductCode["VEHICLE_PARTS"] = "VEHICLE_PARTS";
    /** Vehicle Prep */ VisaNonFuelProductCode["VEHICLE_PREP"] = "VEHICLE_PREP";
    /** Vehicle Rental */ VisaNonFuelProductCode["VEHICLE_RENTAL"] = "VEHICLE_RENTAL";
    /** Washer Fluid */ VisaNonFuelProductCode["WASHER_FLUID"] = "WASHER_FLUID";
    /** Wash Out */ VisaNonFuelProductCode["WASH_OUT"] = "WASH_OUT";
    /** <Deprecated> Weather Fees */ VisaNonFuelProductCode["WEATHER_FEES"] = "WEATHER_FEES";
    /** Wine */ VisaNonFuelProductCode["WINE"] = "WINE";
    /** Wipers */ VisaNonFuelProductCode["WIPERS"] = "WIPERS";
    /** Wireless Real Time Recharge */ VisaNonFuelProductCode["WL_REAL_TIME_RECHARGE"] = "WL_REAL_TIME_RECHARGE";
    /** Work Order */ VisaNonFuelProductCode["WORK_ORDER"] = "WORK_ORDER";
    return VisaNonFuelProductCode;
}({});
var $2f53fee15f29b056$export$449169fd8b2ec732 = /*#__PURE__*/ function(VisaTaxTreatment) {
    /** Gross prices with taxes calculated at the invoice level */ VisaTaxTreatment["GIL"] = "GIL";
    /** Gross prices with taxes calculated at the line item level */ VisaTaxTreatment["GLL"] = "GLL";
    /** Net prices with taxes calculated at the invoice level */ VisaTaxTreatment["NIL"] = "NIL";
    /** Net prices with taxes calculated at the line item level */ VisaTaxTreatment["NLL"] = "NLL";
    /** No tax applies on the invoice */ VisaTaxTreatment["NON"] = "NON";
    return VisaTaxTreatment;
}({});
var $2f53fee15f29b056$export$433a5ee3a8a9759f = /*#__PURE__*/ function(VisaThreeDSecureIndicator) {
    /** Visa’s Attempt Server for 3DS verification stand-in. */ VisaThreeDSecureIndicator["ATTEMPTS_SERVER_RESPONDING"] = "ATTEMPTS_SERVER_RESPONDING";
    /** Behavior Biometrics. */ VisaThreeDSecureIndicator["BEHAVIORAL_BIOMETRICS"] = "BEHAVIORAL_BIOMETRICS";
    /** The cardholder received an identity verification request through the Knowledge-Based Authentication method. */ VisaThreeDSecureIndicator["CHALLENGE_KBA"] = "CHALLENGE_KBA";
    /** The cardholder received an identity verification request through the Out-of-Band Authentication method via an application. */ VisaThreeDSecureIndicator["CHALLENGE_OOB_APP"] = "CHALLENGE_OOB_APP";
    /** The cardholder received an identity verification request through the Out-of-Band Authentication method via a biometric device. */ VisaThreeDSecureIndicator["CHALLENGE_OOB_BIOMETRIC"] = "CHALLENGE_OOB_BIOMETRIC";
    /** The cardholder received an identity verification request through the Out-of-Band Authentication method via a method other than a biometric device or an application. */ VisaThreeDSecureIndicator["CHALLENGE_OOB_OTHER"] = "CHALLENGE_OOB_OTHER";
    /** The cardholder received an identity verification request. */ VisaThreeDSecureIndicator["CHALLENGE_OTHER"] = "CHALLENGE_OTHER";
    /** The cardholder received an identity verification request with a one-time passcode via an application. */ VisaThreeDSecureIndicator["CHALLENGE_OTP_APP"] = "CHALLENGE_OTP_APP";
    /** The cardholder received an identity verification request with a one-time passcode via key fob. */ VisaThreeDSecureIndicator["CHALLENGE_OTP_FOB"] = "CHALLENGE_OTP_FOB";
    /** The cardholder received an identity verification request with a one-time passcode via a form other than SMS, email, fob, or application. */ VisaThreeDSecureIndicator["CHALLENGE_OTP_OTHER"] = "CHALLENGE_OTP_OTHER";
    /** The cardholder received an identity verification request with a one-time passcode via SMS. */ VisaThreeDSecureIndicator["CHALLENGE_OTP_SMS"] = "CHALLENGE_OTP_SMS";
    /** The cardholder received an identity verification request with a static passcode. */ VisaThreeDSecureIndicator["CHALLENGE_STATIC_PASSCODE"] = "CHALLENGE_STATIC_PASSCODE";
    /** Decoupled authentication. */ VisaThreeDSecureIndicator["DECOUPLED"] = "DECOUPLED";
    /** Delegated trusted authentication. */ VisaThreeDSecureIndicator["DELEGATED_TRUSTED"] = "DELEGATED_TRUSTED";
    /** Frictionless 3DS Verification */ VisaThreeDSecureIndicator["FRICTIONLESS"] = "FRICTIONLESS";
    /** Frictionless 3DS verification, Risk-Based Authentication. */ VisaThreeDSecureIndicator["FRICTIONLESS_RBA"] = "FRICTIONLESS_RBA";
    /** Frictionless 3DS verification with Risk-Based Authentication review. */ VisaThreeDSecureIndicator["FRICTIONLESS_RBA_REVIEW"] = "FRICTIONLESS_RBA_REVIEW";
    /** Frictionless flow, Smart Attempts. */ VisaThreeDSecureIndicator["FRICTIONLESS_SMART_ATTEMPTS"] = "FRICTIONLESS_SMART_ATTEMPTS";
    /** Frictionless flow, FIDO Standard. */ VisaThreeDSecureIndicator["FRICTIONLESS_USING_FIDO_STANDARD"] = "FRICTIONLESS_USING_FIDO_STANDARD";
    /** Frictionless flow, Visa Secure on behalf of issuer. */ VisaThreeDSecureIndicator["FRICTIONLESS_VISA_SECURE_ON_BEHALF_OF_ISSUER"] = "FRICTIONLESS_VISA_SECURE_ON_BEHALF_OF_ISSUER";
    /** 3DS verification followed an issuer-defined method. */ VisaThreeDSecureIndicator["ISSUER_DEFINED_1"] = "ISSUER_DEFINED_1";
    /** 3DS verification followed an issuer-defined method. */ VisaThreeDSecureIndicator["ISSUER_DEFINED_2"] = "ISSUER_DEFINED_2";
    /** 3DS verification followed an issuer-defined method. */ VisaThreeDSecureIndicator["ISSUER_DEFINED_3"] = "ISSUER_DEFINED_3";
    /** 3DS verification followed an issuer-defined method. */ VisaThreeDSecureIndicator["ISSUER_DEFINED_4"] = "ISSUER_DEFINED_4";
    /** 3DS verification followed an issuer-defined method. */ VisaThreeDSecureIndicator["ISSUER_DEFINED_5"] = "ISSUER_DEFINED_5";
    /** The cardholder received an identity verification request with a push confirmation. */ VisaThreeDSecureIndicator["PUSH_CONFIRMATION"] = "PUSH_CONFIRMATION";
    /** Secure Payment Confirmation. */ VisaThreeDSecureIndicator["SECURE_PAYMENT_CONFIRMATION"] = "SECURE_PAYMENT_CONFIRMATION";
    /** The cardholder received an identity verification request through an unrecognized method. */ VisaThreeDSecureIndicator["UNRECOGNIZED_METHOD"] = "UNRECOGNIZED_METHOD";
    /** Web Authentication. */ VisaThreeDSecureIndicator["WEBAUTHN"] = "WEBAUTHN";
    return VisaThreeDSecureIndicator;
}({});
var $2f53fee15f29b056$export$b62587a318cd0431 = /*#__PURE__*/ function(WalletProviderType) {
    /** Google Pay Wallet */ WalletProviderType["GOOGLE_PAY"] = "GOOGLE_PAY";
    /** Samsung Pay Wallet */ WalletProviderType["SAMSUNG_PAY"] = "SAMSUNG_PAY";
    return WalletProviderType;
}({});
var $2f53fee15f29b056$export$2e77b4389c8dd579 = /*#__PURE__*/ function(WebPushAssetType) {
    /** Card templates */ WebPushAssetType["CARD_TEMPLATES"] = "CARD_TEMPLATES";
    /** Network card assets */ WebPushAssetType["NETWORK_CARD_ASSETS"] = "NETWORK_CARD_ASSETS";
    return WebPushAssetType;
}({});
var $2f53fee15f29b056$export$44cf0f2b0f95535b = /*#__PURE__*/ function(WireStatusReasonCode) {
    /** The Highnote account is closed. */ WireStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The wire was sent to an individual instead of an organization. */ WireStatusReasonCode["ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION"] = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION";
    /** No matching Highnote account. */ WireStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The currency of the wire does not match the currency of the destination account. */ WireStatusReasonCode["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The receiving account does not have the payroll advance feature enabled. */ WireStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    return WireStatusReasonCode;
}({});
var $2f53fee15f29b056$export$100ac91d72aa543e = /*#__PURE__*/ function(WireTransferReviewDirection) {
    /** Represents funds being wired into a `FinancialAccount`. */ WireTransferReviewDirection["INCOMING"] = "INCOMING";
    /** Represents funds being wired out of a `FinancialAccount`. */ WireTransferReviewDirection["OUTGOING"] = "OUTGOING";
    return WireTransferReviewDirection;
}({});
var $2f53fee15f29b056$export$d04a67d7b549806d = /*#__PURE__*/ function(WireTransferStatus) {
    /** The `WireTransfer` is complete. */ WireTransferStatus["COMPLETED"] = "COMPLETED";
    /** The `WireTransfer` has failed. */ WireTransferStatus["FAILED"] = "FAILED";
    /** The `WireTransfer` is pending. */ WireTransferStatus["PENDING"] = "PENDING";
    /** The wire is being processed. */ WireTransferStatus["PROCESSING"] = "PROCESSING";
    return WireTransferStatus;
}({});
var $2f53fee15f29b056$export$1bda044ef01f0df0 = /*#__PURE__*/ function(WireTransferStatusReasonCode) {
    /** The source or receiving account is closed. */ WireTransferStatusReasonCode["ACCOUNT_CLOSED"] = "ACCOUNT_CLOSED";
    /** The receiving account holder is not an Organization. */ WireTransferStatusReasonCode["ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION"] = "ACCOUNT_HOLDER_IS_NOT_AN_ORGANIZATION";
    /** The source or receiving account was not found. */ WireTransferStatusReasonCode["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    /** The source and receiving account have different currency. */ WireTransferStatusReasonCode["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    /** The source account of the WireTransfer did not have enough funds to cover the requested amount. */ WireTransferStatusReasonCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    /** The receiving account does not have PayrollAdvanceFinancialAccountFeature as enabled. */ WireTransferStatusReasonCode["PAYROLL_ADVANCE_FEATURE_NOT_ENABLED"] = "PAYROLL_ADVANCE_FEATURE_NOT_ENABLED";
    return WireTransferStatusReasonCode;
}({});
var $2f53fee15f29b056$export$563d3806c9f00756 = /*#__PURE__*/ function(WireTransferType) {
    /** Represents an incoming wire transfer. */ WireTransferType["INCOMING_WIRE_TRANSFER"] = "INCOMING_WIRE_TRANSFER";
    /** Represents an incoming wire transfer reversal. */ WireTransferType["INCOMING_WIRE_TRANSFER_REVERSAL"] = "INCOMING_WIRE_TRANSFER_REVERSAL";
    /** Represents an outgoing wire transfer. */ WireTransferType["OUTGOING_WIRE_TRANSFER"] = "OUTGOING_WIRE_TRANSFER";
    /** Represents an incoming wire transfer reversal. */ WireTransferType["OUTGOING_WIRE_TRANSFER_REVERSAL"] = "OUTGOING_WIRE_TRANSFER_REVERSAL";
    return WireTransferType;
}({});
const $2f53fee15f29b056$export$e1b7d27748c95052 = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation createDocumentUploadLink($input: CreateDocumentUploadLinkInput!) {
    createDocumentUploadLink(input: $input) {
      __typename
      ... on DocumentUploadLink {
        id
        uploadUrl
        documentUploadSession {
          ... on CheckPaymentDocumentUploadSession {
            id
            status
          }
          ... on USAccountHolderApplicationDocumentUploadSession {
            id
            status
          }
        }
        status
      }
      ... on UserError {
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        message
      }
    }
  }
`;
const $2f53fee15f29b056$export$5c546c499c509c60 = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation createUSPersonAccountHolder(
    $input: CreateUSPersonAccountHolderInput!
  ) {
    createUSPersonAccountHolder(input: $input) {
      __typename
      ... on UserError {
        errors {
          code
          description
          path
        }
      }
      ... on USPersonAccountHolder {
        id
        email
        dateOfBirth
        externalId
        updatedAt
        createdAt
        name {
          givenName
          familyName
          title
          suffix
          middleName
        }
        billingAddress {
          streetAddress
          extendedAddress
          postalCode
          region
          locality
          countryCodeAlpha3
        }
        phoneNumbers {
          countryCode
          number
          label
        }
        identificationDocument {
          socialSecurityNumber {
            numberHash
            countryCodeAlpha3
          }
        }
      }
    }
  }
`;
const $2f53fee15f29b056$export$5e810e4feed6fc43 = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation endDocumentUploadSession($input: EndDocumentUploadSessionInput!) {
    endDocumentUploadSession(input: $input) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        __typename
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
      }
      ... on UserError {
        __typename
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        __typename
        message
      }
    }
  }
`;
const $2f53fee15f29b056$export$5f28a71c66c5828 = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  query FindDocumentUploadSession($id: ID!) {
    node(id: $id) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
        allowedDocumentTypes
        documents {
          ... on DocumentUploadLink {
            __typename
            id
            status
            documentCategoryType
            documentType
            status
            documentUploadSession {
              id
              status
            }
            uploadUrl
          }
        }
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        __typename
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        recommendedDocumentTypes
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
        documents {
          ... on DocumentUploadLink {
            __typename
            id
            status
            documentCategoryType
            documentType
            status
            documentUploadSession {
              id
              status
            }
            uploadUrl
          }
        }
      }
    }
  }
`;
const $2f53fee15f29b056$export$25a9986540ae82ad = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation startDocumentUploadSession(
    $input: StartDocumentUploadSessionInput!
  ) {
    startDocumentUploadSession(input: $input) {
      __typename
      ... on CheckPaymentDocumentUploadSession {
        id
        status
        documents {
          id
          status
        }
      }
      ... on USAccountHolderApplicationDocumentUploadSession {
        id
        status
        primaryDocumentTypes
        secondaryDocumentTypes
        supportingDocumentTypes
        documents {
          id
          status
        }
        uploadRequirements {
          constraints {
            ... on DocumentUploadRequirementConstraint {
              documentType
              numberOfDocuments
            }
          }
        }
      }
      ... on UserError {
        errors {
          path
        }
      }
      ... on AccessDeniedError {
        message
      }
    }
  }
`;
const $2f53fee15f29b056$export$ea20c09e78a8ffaa = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation TokenizePaymentCard($input: TokenizeCardPaymentMethodInput!) {
    tokenizeCardPaymentMethod(input: $input) {
      __typename
      ... on UserError {
        errors {
          code
          description
          errorPath
        }
      }
      ... on PaymentMethodToken {
        id
        instrument {
          ... on PaymentCardInstrument {
            brand
            last4
            cardHolder {
              fullName
              billingAddress {
                streetAddress
                countryCodeAlpha3
                extendedAddress
                locality
                region
                postalCode
              }
            }
          }
        }
        usage
      }
    }
  }
`;
const $2f53fee15f29b056$export$97fcd758f856d2ce = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  mutation UpdatePinForPaymentCardInSecureInputsSdk(
    $input: SetPinForPaymentCardInput!
  ) {
    setPinForPaymentCard(input: $input) {
      __typename
      ... on PaymentCard {
        id
        bin
        last4
      }
      ... on UserError {
        errors {
          path
          code
        }
      }
    }
  }
`;
const $2f53fee15f29b056$export$15c7ad9116f27be9 = (0, ($parcel$interopDefault($dkmxp$graphqltag)))`
  query ViewPaymentCardForSdk($id: ID!) {
    node(id: $id) {
      ... on PaymentCard {
        __typename
        id
        bin
        last4
        expirationMonth
        expirationYear
        restrictedDetails {
          ... on PaymentCardRestrictedDetails {
            __typename
            number
            cvv
          }
        }
      }
    }
  }
`;
const $2f53fee15f29b056$var$defaultWrapper = (action, _operationName, _operationType)=>action();
const $2f53fee15f29b056$var$CreateDocumentUploadLinkDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$e1b7d27748c95052);
const $2f53fee15f29b056$var$CreateUsPersonAccountHolderDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$5c546c499c509c60);
const $2f53fee15f29b056$var$EndDocumentUploadSessionDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$5e810e4feed6fc43);
const $2f53fee15f29b056$var$FindDocumentUploadSessionDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$5f28a71c66c5828);
const $2f53fee15f29b056$var$StartDocumentUploadSessionDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$25a9986540ae82ad);
const $2f53fee15f29b056$var$TokenizePaymentCardDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$ea20c09e78a8ffaa);
const $2f53fee15f29b056$var$UpdatePinForPaymentCardInSecureInputsSdkDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$97fcd758f856d2ce);
const $2f53fee15f29b056$var$ViewPaymentCardForSdkDocumentString = (0, $dkmxp$graphql.print)($2f53fee15f29b056$export$15c7ad9116f27be9);
function $2f53fee15f29b056$export$68dbe58f97d98fc5(client, withWrapper = $2f53fee15f29b056$var$defaultWrapper) {
    return {
        createDocumentUploadLink (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$CreateDocumentUploadLinkDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "createDocumentUploadLink", "mutation");
        },
        createUSPersonAccountHolder (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$CreateUsPersonAccountHolderDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "createUSPersonAccountHolder", "mutation");
        },
        endDocumentUploadSession (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$EndDocumentUploadSessionDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "endDocumentUploadSession", "mutation");
        },
        FindDocumentUploadSession (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$FindDocumentUploadSessionDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "FindDocumentUploadSession", "query");
        },
        startDocumentUploadSession (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$StartDocumentUploadSessionDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "startDocumentUploadSession", "mutation");
        },
        TokenizePaymentCard (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$TokenizePaymentCardDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "TokenizePaymentCard", "mutation");
        },
        UpdatePinForPaymentCardInSecureInputsSdk (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$UpdatePinForPaymentCardInSecureInputsSdkDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "UpdatePinForPaymentCardInSecureInputsSdk", "mutation");
        },
        ViewPaymentCardForSdk (variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders)=>client.rawRequest($2f53fee15f29b056$var$ViewPaymentCardForSdkDocumentString, variables, {
                    ...requestHeaders,
                    ...wrappedRequestHeaders
                }), "ViewPaymentCardForSdk", "query");
        }
    };
}


const $ffe985adad0ad8b2$var$apiUrls = {
    test: "https://api.us.test.highnote.com",
    live: "https://api.us.highnote.com"
};
const $ffe985adad0ad8b2$export$ea1c6121429ff1a = (token, environment = "test", sdk)=>{
    const client = new (0, $dkmxp$graphqlrequest.GraphQLClient)(`${$ffe985adad0ad8b2$var$apiUrls[environment]}/graphql`);
    client.setHeader("authorization", `Bearer ${token}`);
    if (sdk?.name && sdk?.version) client.setHeader("x-highnote-sdk", `${sdk.name}/${sdk.version}`);
    return (0, $2f53fee15f29b056$export$68dbe58f97d98fc5)(client);
};




const $e685c0f46c96cf2f$export$7d576a40358207c0 = [
    "cvv",
    "expirationDate",
    "cardNumber"
];
var $e685c0f46c96cf2f$export$bdb47a4f704771fb = /*#__PURE__*/ function(GlobalPostMessageEventKind) {
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_ERROR"] = "PAYMENT_CARD_FETCH_ERROR";
    GlobalPostMessageEventKind["PAYMENT_CARD_FETCH_SUCCESS"] = "PAYMENT_CARD_FETCH_SUCCESS";
    // Input/configuration error kind
    GlobalPostMessageEventKind["CARD_VIEWER_INPUT_ERROR"] = "CARD_VIEWER_INPUT_ERROR";
    GlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    GlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    GlobalPostMessageEventKind["TOGGLE_CARD_NUMBER_MASK"] = "TOGGLE_CARD_NUMBER_MASK";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_ERROR"] = "COPY_TO_CLIPBOARD_ERROR";
    GlobalPostMessageEventKind["COPY_TO_CLIPBOARD_SUCCESS"] = "COPY_TO_CLIPBOARD_SUCCESS";
    GlobalPostMessageEventKind["CARD_VIEWER_READY"] = "CARD_VIEWER_READY";
    return GlobalPostMessageEventKind;
}({});


// -- Secure channel handshake protocol (DX-8174 / DX-8205) -------------------
// Shared by every Highnote SDK that delivers credentials to a hosted iframe
// without placing them in the iframe URL (browser history/sync, web archives,
// CDN/proxy logs, analytics scripts reading location.href). The SDK posts
// HANDSHAKE_INIT to the iframe on frame `load` (transferring one MessagePort),
// the iframe replies HANDSHAKE_ACK on that port, and the SDK then delivers
// credentials in a CONFIGURE message over the same private port.
//
// This module lives in @highnoteplatform/types — not @highnoteplatform/iframes —
// deliberately: the published SDKs' parcel builds bundle ONLY this package
// (targets.*.includeNodeModules allowlist, built with --no-scope-hoist, i.e. no
// tree-shaking), so importing the iframes package here would drag its entire
// re-export graph into the public SDK bundles. Do not "tidy" this into iframes.
const $9925f9b891daea8a$export$bdf67dc867af0994 = "SECURE_CHANNEL_HANDSHAKE_INIT";
const $9925f9b891daea8a$export$21b7abb723f51b7e = "SECURE_CHANNEL_HANDSHAKE_ACK";
const $9925f9b891daea8a$export$46fb7dfe3495e1c = "SECURE_CHANNEL_CONFIGURE";
const $9925f9b891daea8a$export$9941bb4ec5193584 = 10000;
const $9925f9b891daea8a$export$ca4bc7545e4f4a8d = 15000;
const $9925f9b891daea8a$export$b5130285aa45b350 = (data, typename)=>typeof data === "object" && data !== null && "__typename" in data && data.__typename === typename;
const $9925f9b891daea8a$export$84683bda827d284f = ({ frame: frame, iframeOrigin: iframeOrigin, uuid: uuid, clientToken: clientToken, paymentCardId: paymentCardId, sdkName: sdkName, sdkVersion: sdkVersion, onFailure: onFailure, onHandshakeAck: onHandshakeAck, timeoutMs: timeoutMs = $9925f9b891daea8a$export$9941bb4ec5193584 })=>{
    let disposed = false;
    let failed = false;
    let cleanupPending;
    // onFailure is one-shot for the channel's lifetime. A frame can emit `load`
    // more than once (reload), and both the FRAME_UNREACHABLE and
    // HANDSHAKE_TIMEOUT paths can be reached again on a subsequent load — the
    // integrator must not be re-notified of the same failed handshake, nor
    // receive a failure after an earlier one already fired.
    const reportFailure = (failure)=>{
        if (failed) return;
        failed = true;
        onFailure(failure);
    };
    const onLoad = ()=>{
        // A reloaded frame is a fresh document with a fresh listener; tear down
        // the previous channel so its timeout cannot fire a spurious error.
        cleanupPending?.();
        cleanupPending = undefined;
        const targetWindow = frame.contentWindow;
        if (targetWindow === null) {
            reportFailure("FRAME_UNREACHABLE");
            return;
        }
        const channel = new MessageChannel();
        const sdkPort = channel.port1;
        const timeout = setTimeout(()=>{
            sdkPort.close();
            cleanupPending = undefined;
            reportFailure("HANDSHAKE_TIMEOUT");
        }, timeoutMs);
        cleanupPending = ()=>{
            clearTimeout(timeout);
            sdkPort.close();
        };
        sdkPort.onmessage = (event)=>{
            if (!$9925f9b891daea8a$export$b5130285aa45b350(event.data, $9925f9b891daea8a$export$21b7abb723f51b7e)) return;
            clearTimeout(timeout);
            onHandshakeAck?.();
            const configure = {
                __typename: $9925f9b891daea8a$export$46fb7dfe3495e1c,
                clientToken: clientToken,
                ...paymentCardId === undefined ? {} : {
                    paymentCardId: paymentCardId
                },
                ...sdkName === undefined ? {} : {
                    sdkName: sdkName
                },
                ...sdkVersion === undefined ? {} : {
                    sdkVersion: sdkVersion
                }
            };
            sdkPort.postMessage(configure);
            // CONFIGURE is the last message on this channel; the iframe closes its
            // end on receipt. Close ours too for lifecycle symmetry — the message
            // is already queued on the peer, so closing here does not drop it.
            // (cleanupPending is left as-is; the disposer's close() is idempotent.)
            sdkPort.close();
        };
        const init = {
            __typename: $9925f9b891daea8a$export$bdf67dc867af0994,
            uuid: uuid
        };
        targetWindow.postMessage(init, iframeOrigin, [
            channel.port2
        ]);
    };
    frame.addEventListener("load", onLoad);
    return ()=>{
        if (disposed) return;
        disposed = true;
        frame.removeEventListener("load", onLoad);
        cleanupPending?.();
        cleanupPending = undefined;
    };
};
const $9925f9b891daea8a$export$d572882ed38b887b = ()=>{
    let settled = false; // one handshake-phase error already surfaced
    let configurePhase = false; // ACK received -> iframe is sole authority
    return {
        ack: ()=>{
            configurePhase = true;
        },
        wrapFailure: (deliver)=>(e)=>{
                if (settled) return;
                settled = true;
                deliver(e);
            },
        wrapRelay: (deliver)=>(e)=>{
                if (configurePhase) {
                    deliver(e); // post-ACK: pass every relayed error unconditionally
                    return;
                }
                if (settled) return; // pre-ACK duplicate: swallow
                settled = true;
                deliver(e);
            }
    };
};


const $cb6f5bee9194bcb6$export$1ec34c2c9b231c0f = [
    "pin",
    "cardNumber",
    "expirationMonth",
    "expirationYear",
    "expirationDate",
    "securityCode"
];
const $cb6f5bee9194bcb6$export$2db53370b14e73a1 = [
    "visa",
    "mastercard",
    "amex",
    "discover"
];
var $cb6f5bee9194bcb6$export$5278e3e6401288b4 = /*#__PURE__*/ function(SecureInputsGlobalPostMessageEventKind) {
    SecureInputsGlobalPostMessageEventKind["GENERIC_ERROR"] = "GENERIC_ERROR";
    SecureInputsGlobalPostMessageEventKind["INVALID_CREDENTIAL_ERROR"] = "INVALID_CREDENTIAL_ERROR";
    SecureInputsGlobalPostMessageEventKind["USER_INPUT_ERROR"] = "USER_INPUT_ERROR";
    SecureInputsGlobalPostMessageEventKind["REQUEST_ERROR"] = "REQUEST_ERROR";
    SecureInputsGlobalPostMessageEventKind["ON_INPUT"] = "ON_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_SUBMIT"] = "ON_SUBMIT";
    SecureInputsGlobalPostMessageEventKind["CHANGE_CARD_PIN"] = "CHANGE_CARD_PIN";
    SecureInputsGlobalPostMessageEventKind["TOKENIZE_CARD"] = "TOKENIZE_CARD";
    SecureInputsGlobalPostMessageEventKind["ON_CARD_INPUT"] = "ON_CARD_INPUT";
    SecureInputsGlobalPostMessageEventKind["ON_PIN_CHANGE_SUCCESS"] = "ON_PIN_CHANGE_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_TOKENIZE_CARD_SUCCESS"] = "ON_TOKENIZE_CARD_SUCCESS";
    SecureInputsGlobalPostMessageEventKind["ON_STATE_CHANGE"] = "ON_STATE_CHANGE";
    SecureInputsGlobalPostMessageEventKind["ON_READY"] = "ON_READY";
    return SecureInputsGlobalPostMessageEventKind;
}({});






var $d8c9ae269e622418$export$c278f139ce6eedba = /*#__PURE__*/ function(CheckoutPostMessageKind) {
    CheckoutPostMessageKind["TOKENIZE_SUCCCESS"] = "TOKENIZE_SUCCCESS";
    CheckoutPostMessageKind["TOKENIZE_ERROR"] = "TOKENIZE_ERROR";
    CheckoutPostMessageKind["CHECKOUT_READY"] = "CHECKOUT_READY";
    return CheckoutPostMessageKind;
}({});
class $d8c9ae269e622418$export$4e94f40711c15818 extends Error {
    constructor(message, errors){
        super(message), this.name = "CheckoutConfigInputError";
        this.errors = errors;
    }
}
const $d8c9ae269e622418$export$e65600b7ad68fd67 = [
    "Pay",
    "Submit"
];


// Descriptive SDK identity for the `x-highnote-sdk` adoption-telemetry header
// (`<name>/<version>`). Lives in @highnoteplatform/types because that is the
// only package bundled into every public SDK's parcel build (see
// secureChannel.ts) — the one bundle-safe shared home.
//
// HOW TO INSTRUMENT A NEW SDK
// 1. In the SDK package, import its own package.json name + version:
//        import { name, version } from "../package.json";
// 2. Build the identity so `name` can't drift from the published package name:
//        const SDK = sdkIdentityFromPackage({ name, version });
// 3. Page-context SDK: pass SDK as the 3rd arg to `highnoteClient(...)`, behind a
//    small `xxxClient` factory (see documentUploadClient / riskApplicationClient).
//    Iframe SDK: reuse SDK.name for BOTH the CDN path segment and the
//    secure-channel handshake `sdkName` (see card-viewer/secure-inputs
//    config.ts + handshake.ts) so telemetry and CDN can't desync.
const $7e698d9b7f7a87ff$var$SCOPE_PREFIX = /^@highnoteplatform\//;
const $7e698d9b7f7a87ff$export$3ddec0068072ba94 = (pkg)=>({
        name: pkg.name.replace($7e698d9b7f7a87ff$var$SCOPE_PREFIX, ""),
        version: pkg.version
    });


const $f5b18f506ced5951$export$8acf5617026d4b16 = [
    "borderRadius",
    "backgroundColor",
    "color",
    "cursor",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "letterSpacing",
    "lineHeight",
    "userSelect",
    "border"
];
const $f5b18f506ced5951$export$93b12edf1b0f1762 = [
    ":focus",
    ":hover",
    ":invalid",
    ":valid"
];
const $f5b18f506ced5951$export$679b0194e2408a3e = [
    "live",
    "test"
];


var $c880304287b83bbf$exports = {};
$c880304287b83bbf$exports = JSON.parse("{\"name\":\"@highnoteplatform/document-upload\",\"version\":\"1.1.6\",\"description\":\"A document upload component that enables easy uploads of required documents for an application.\",\"source\":\"src/index.ts\",\"access\":\"public\",\"main\":\"lib/index.js\",\"module\":\"lib/esm/module.js\",\"types\":\"lib/types.d.ts\",\"files\":[\"lib\",\"README.md\"],\"scripts\":{\"clean\":\"rimraf lib dist\",\"prebuild\":\"npm run clean\",\"build\":\"PARCEL_WORKER_BACKEND=process parcel build --detailed-report --no-scope-hoist --no-cache\",\"postbuild\":\"node ../../scripts/fix-node-env.js\",\"prepublishOnly\":\"npm run build\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"prepack\":\"npm run build\",\"predev\":\"node ../../scripts/clean-build-output.js lib dist\",\"dev\":\"parcel watch --port 3010 --hmr-port 2010 --no-cache --dist-dir=lib\"},\"author\":\"packages@highnote.com\",\"license\":\"MIT\",\"homepage\":\"https://highnote.com\",\"devDependencies\":{\"@highnoteplatform/internal-sdk\":\"*\",\"@highnoteplatform/types\":\"*\",\"@types/jest\":\"28.1.8\",\"@types/jsdom\":\"21.1.1\",\"@types/node\":\"^22.0.0\",\"eslint-plugin-jest\":\"27.2.1\",\"jest\":\"^28.1.3\",\"jest-environment-jsdom\":\"^29.5.0\",\"jsdom\":\"21.1.1\",\"ts-jest\":\"28.0.8\"},\"peerDependencies\":{\"graphql\":\">=15.8.x\"},\"targets\":{\"main\":{\"includeNodeModules\":[\"@highnoteplatform/types\",\"@highnoteplatform/internal-sdk\"],\"optimize\":true},\"module\":{\"includeNodeModules\":[\"@highnoteplatform/types\",\"@highnoteplatform/internal-sdk\"],\"optimize\":true}},\"dependencies\":{\"graphql-request\":\"^5.1.0\",\"graphql-tag\":\"^2.12.6\"}}");


const $c3247770741ea03a$var$SDK = (0, $7e698d9b7f7a87ff$export$3ddec0068072ba94)({
    name: $c880304287b83bbf$exports.name,
    version: $c880304287b83bbf$exports.version
});
const $c3247770741ea03a$export$681db5ee54da0f99 = (config)=>(0, $ffe985adad0ad8b2$export$ea1c6121429ff1a)(config.clientToken, config.environment, $c3247770741ea03a$var$SDK);


const $2bbe20b8c555b785$var$isError = (error)=>error !== null && error !== undefined && typeof error === "object" && "name" in error && "message" in error;
const $2bbe20b8c555b785$export$cd3a77372f1d28e3 = (message)=>({
        name: "DocumentUploadConfigError",
        message: message
    });
const $2bbe20b8c555b785$export$29cdd66c4b2bccfa = (message)=>({
        name: "DocumentUploadRequestError",
        message: message
    });
const $2bbe20b8c555b785$export$9fd3b9062419c302 = (message)=>({
        name: "GenericDocumentUploadError",
        message: message
    });
const $2bbe20b8c555b785$export$d0f6f6f8d08fe167 = (error, onError)=>{
    if ($2bbe20b8c555b785$var$isError(error)) {
        if (error.name === "DocumentUploadConfigError" || error.name === "DocumentUploadRequestError" || error.name === "InvalidCredentialError") onError(error);
        else onError($2bbe20b8c555b785$export$9fd3b9062419c302(error.message));
    } else onError($2bbe20b8c555b785$export$9fd3b9062419c302("Unknown error."));
};


const $133a84a83c28a112$export$d0cdc17446b49c7f = async (config, documentType)=>{
    const client = (0, $c3247770741ea03a$export$681db5ee54da0f99)(config);
    const { onError: onError, documentUploadSessionId: documentUploadSessionId } = config;
    try {
        const { data: data } = await client.createDocumentUploadLink({
            input: {
                documentUploadSessionId: documentUploadSessionId,
                documentType: documentType
            }
        });
        const payload = data.createDocumentUploadLink;
        if (payload?.__typename === "DocumentUploadLink" && payload.uploadUrl !== undefined) return payload.uploadUrl;
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    return undefined;
};






const $a7ebecf2cd2c995d$var$fetchDocumentUploadSession = async (config)=>{
    const client = (0, $c3247770741ea03a$export$681db5ee54da0f99)(config);
    const { onError: onError, documentUploadSessionId: documentUploadSessionId } = config;
    try {
        const { data: data } = await client.FindDocumentUploadSession({
            id: documentUploadSessionId
        });
        if ((data.node?.__typename === "USAccountHolderApplicationDocumentUploadSession" || data.node?.__typename === "CheckPaymentDocumentUploadSession") && data.node.status !== undefined) {
            if (data.node.status !== (0, $2f53fee15f29b056$export$7153f0dd9edde3be).INITIATED && data.node.status !== (0, $2f53fee15f29b056$export$7153f0dd9edde3be).IN_PROGRESS) // start a session
            try {
                await client.startDocumentUploadSession({
                    input: {
                        documentUploadSessionId: documentUploadSessionId
                    }
                });
                // get the session
                const result = await client.FindDocumentUploadSession({
                    id: documentUploadSessionId
                });
                return result.data;
            } catch (error) {
                (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
            }
            else return data;
        }
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    return undefined;
};
const $a7ebecf2cd2c995d$export$f8f719707da23294 = async (config)=>{
    const client = (0, $c3247770741ea03a$export$681db5ee54da0f99)(config);
    const { onError: onError, documentUploadSessionId: documentUploadSessionId } = config;
    try {
        const { data: data } = await client.endDocumentUploadSession({
            input: {
                documentUploadSessionId: documentUploadSessionId
            }
        });
        if (data.endDocumentUploadSession !== undefined && (data.endDocumentUploadSession.__typename === "USAccountHolderApplicationDocumentUploadSession" || data.endDocumentUploadSession.__typename === "CheckPaymentDocumentUploadSession")) return true;
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    return false;
};
const $a7ebecf2cd2c995d$var$fetchDocuments = async (config)=>{
    const { onError: onError } = config;
    const documentsRequired = new Set();
    const documentsUploaded = new Set();
    const documentsRecommended = new Set();
    try {
        const data = await $a7ebecf2cd2c995d$var$fetchDocumentUploadSession(config);
        if (data?.node?.__typename === "CheckPaymentDocumentUploadSession") {
            const { allowedDocumentTypes: allowedDocumentTypes = [], documents: documents, status: status } = data.node;
            if (documents) documents.forEach((item)=>{
                if (item?.__typename === "DocumentUploadLink" && item.documentType !== undefined && item.status === "COMPLETED") documentsUploaded.add(item.documentType);
            });
            allowedDocumentTypes.map((item)=>(0, $2f53fee15f29b056$export$d1d99cf900472499)[item]).forEach((item)=>{
                if (!documentsUploaded.has(item)) documentsRequired.add(item);
            });
            return {
                documentsRequired: documentsRequired,
                documentsUploaded: documentsUploaded,
                documentsRecommended: documentsRecommended,
                status: status
            };
        }
        if (data !== undefined && data.node?.__typename === "USAccountHolderApplicationDocumentUploadSession" && data.node.status !== undefined) {
            const { status: status, documents: documents, primaryDocumentTypes: primaryDocumentTypes, secondaryDocumentTypes: secondaryDocumentTypes, supportingDocumentTypes: supportingDocumentTypes, recommendedDocumentTypes: recommendedDocumentTypes } = data.node;
            if (documents) documents.forEach((item)=>{
                if (item?.__typename === "DocumentUploadLink" && item.documentType !== undefined && item.status === "COMPLETED") documentsUploaded.add(item.documentType);
            });
            if (primaryDocumentTypes) primaryDocumentTypes.forEach((item)=>{
                documentsRequired.add(item);
            });
            if (secondaryDocumentTypes) secondaryDocumentTypes.forEach((item)=>{
                documentsRequired.add(item);
            });
            if (supportingDocumentTypes) supportingDocumentTypes.forEach((item)=>{
                documentsRequired.add(item);
            });
            if (Array.isArray(recommendedDocumentTypes)) recommendedDocumentTypes.forEach((item)=>{
                documentsRecommended.add(item);
            });
            return {
                documentsRequired: documentsRequired,
                documentsUploaded: documentsUploaded,
                documentsRecommended: documentsRecommended,
                status: status
            };
        }
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    return undefined;
};
const $a7ebecf2cd2c995d$var$reloadDom = async (config)=>{
    try {
        const reloadElements = document.createElement("div");
        reloadElements.setAttribute("id", "reloaded-document-upload-component");
        const result = await $a7ebecf2cd2c995d$var$fetchDocuments(config);
        if (result) {
            // load documents uploaded
            if (result.documentsUploaded.size > 0) {
                const documentsUploaded = document.createElement("div");
                documentsUploaded.setAttribute("id", "documents-uploaded");
                const documentsUploadedHeader = document.createElement("h4");
                const documentUploadHearText = document.createTextNode("Documents Uploaded");
                documentsUploadedHeader.append(documentUploadHearText);
                documentsUploaded.append(documentsUploadedHeader);
                result.documentsUploaded.forEach((item)=>{
                    const documentUploaded = document.createElement("p");
                    const documentUploadedText = document.createTextNode(item);
                    const icon = document.createElement("i");
                    icon.setAttribute("class", "bi bi-check-circle-fill");
                    documentUploaded.append(documentUploadedText);
                    documentsUploaded.append(documentUploaded);
                    documentUploaded.append(icon);
                });
                reloadElements.append(documentsUploaded);
            }
            const fileUpload = document.createElement("input");
            const documentsRequired = document.createElement("div");
            documentsRequired.setAttribute("id", "documents-required");
            const documentsRequiredHeader = document.createElement("h4");
            const documentsRequiredHeaderText = document.createTextNode("Documents Required");
            documentsRequiredHeader.append(documentsRequiredHeaderText);
            const documentType = document.createElement("select");
            documentType.setAttribute("id", "document-sdk-type");
            documentType.setAttribute("class", "round");
            if (result.documentsRequired.size > 0) // add options to dropdown for upload
            result.documentsRequired.forEach((item)=>{
                // Match the recommended items
                const isRecommendedItem = result.documentsRecommended.has(item);
                const documentRequired = document.createElement("option");
                documentRequired.setAttribute("value", item);
                documentRequired.append(document.createTextNode(isRecommendedItem ? `${item} (Recommended)` : item));
                documentType.append(documentRequired);
            });
            else {
                const documentRequired = document.createElement("option");
                fileUpload.setAttribute("disabled", "disabled");
                if (result.status === "SUBMITTED") {
                    documentRequired.setAttribute("value", "Session is closed");
                    documentRequired.append(document.createTextNode("Session is closed"));
                } else {
                    // close session and disable dropdown
                    const closedSession = await $a7ebecf2cd2c995d$export$f8f719707da23294(config);
                    if (!closedSession) throw new Error("Unable to close document upload session");
                    documentRequired.setAttribute("value", "No more documents required");
                    documentRequired.append(document.createTextNode("No more documents required"));
                }
                documentType.append(documentRequired);
                documentType.setAttribute("disabled", "disabled");
                config.onSuccess(true);
            }
            documentsRequired.append(documentsRequiredHeader);
            documentsRequired.append(documentType);
            fileUpload.setAttribute("id", "file-upload-component");
            fileUpload.setAttribute("type", "file");
            fileUpload.setAttribute("accept", ".jpg, .png, .pdf");
            reloadElements.append(documentsRequired);
            reloadElements.append(fileUpload);
            // add divs for spinner
            const overlay = document.createElement("div");
            overlay.setAttribute("class", "document-onUpload-overlay");
            reloadElements.append(overlay);
            const spanner = document.createElement("div");
            spanner.setAttribute("class", "document-onUpload-spanner");
            const loader = document.createElement("div");
            loader.setAttribute("class", "document-onUpload-loader");
            const message = document.createElement("p");
            const messageText = document.createTextNode("Uploading file, please be patient");
            message.append(messageText);
            spanner.append(loader);
            spanner.append(message);
            reloadElements.append(spanner);
            return reloadElements;
        }
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, config.onError);
    }
    return undefined;
};
var $a7ebecf2cd2c995d$export$2e2bcd8739ae039 = $a7ebecf2cd2c995d$var$reloadDom;




const $0642bdc7fb60cf53$export$6f5e69396aaed660 = async (config, url)=>{
    const client = (0, $c3247770741ea03a$export$681db5ee54da0f99)(config);
    const { onError: onError, documentUploadSessionId: documentUploadSessionId } = config;
    try {
        const { data: data } = await client.FindDocumentUploadSession({
            id: documentUploadSessionId
        });
        if ((data.node?.__typename === "USAccountHolderApplicationDocumentUploadSession" || data.node?.__typename === "CheckPaymentDocumentUploadSession") && data.node.status !== undefined) {
            const { documents: documents } = data.node;
            if (documents !== undefined) {
                const uploadedDocument = documents.find((item)=>item?.__typename === "DocumentUploadLink" && item.uploadUrl === url);
                return uploadedDocument.status;
            }
        }
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    return undefined;
};


const $4895a115c3812db1$var$UPLOAD_REFRESH_INTERVAL = 10000;
const $4895a115c3812db1$var$UPLOAD_REFRESH_RETRY = 5;
const $4895a115c3812db1$var$sleep = async (ms = $4895a115c3812db1$var$UPLOAD_REFRESH_INTERVAL)=>{
    await new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
};
const $4895a115c3812db1$var$poll = async (retry, uploadedDocumentStatus, config, uploadLink)=>{
    if (retry > 0 && uploadedDocumentStatus === "PENDING") {
        await $4895a115c3812db1$var$sleep();
        const status = await (0, $0642bdc7fb60cf53$export$6f5e69396aaed660)(config, uploadLink);
        return status !== undefined && status !== "PENDING" ? status : await $4895a115c3812db1$var$poll(retry - 1, uploadedDocumentStatus, config, uploadLink);
    }
    return uploadedDocumentStatus;
};
const $4895a115c3812db1$export$810c69deeb72a110 = async (config)=>{
    const { onError: onError } = config;
    const reloadedElements = await (0, $a7ebecf2cd2c995d$export$2e2bcd8739ae039)(config);
    const innerDom = document.createElement("div");
    innerDom.setAttribute("id", "inner-document-upload-component");
    if (reloadedElements !== undefined) {
        innerDom.append(reloadedElements);
        // add upload button if documents are required
        const fileUpload = reloadedElements.querySelector("#file-upload-component");
        if (fileUpload) {
            const uploadButton = document.createElement("button");
            uploadButton.setAttribute("id", "document-upload-button");
            const uploadButtonText = document.createTextNode("Upload");
            uploadButton.append(uploadButtonText);
            const stagnantElements = document.createElement("div");
            stagnantElements.setAttribute("id", "stagnant-document-upload-component");
            stagnantElements.append(uploadButton);
            uploadButton.addEventListener("click", async ()=>{
                // upload button action needs to re-query the reloaded file upload element
                const fileUploadElement = reloadedElements.querySelector("#file-upload-component");
                if (!(fileUploadElement instanceof HTMLInputElement)) {
                    (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)((0, $2bbe20b8c555b785$export$9fd3b9062419c302)("Unable to get file upload element"), onError);
                    return;
                }
                const filesToUpload = fileUploadElement.files;
                const documentType = document.querySelector("#document-sdk-type");
                if (filesToUpload !== null && documentType !== null && filesToUpload.length > 0) {
                    const [body] = Array.from(filesToUpload);
                    try {
                        const uploadLink = await (0, $133a84a83c28a112$export$d0cdc17446b49c7f)(config, documentType.options[documentType.selectedIndex].value);
                        if (uploadLink !== undefined) try {
                            const uploadStatus = await fetch(uploadLink, {
                                method: "PUT",
                                body: body
                            });
                            if (uploadStatus.ok && uploadStatus.status === 200) {
                                // wait for the status of the upload to be updated
                                // start spinner
                                const overlay = document.querySelector(".document-onUpload-overlay");
                                const spanner = document.querySelector(".document-onUpload-spanner");
                                if (overlay && spanner) {
                                    overlay.setAttribute("class", "show");
                                    spanner.setAttribute("class", "show");
                                }
                                await $4895a115c3812db1$var$poll($4895a115c3812db1$var$UPLOAD_REFRESH_RETRY, "PENDING", config, uploadLink);
                                // stop spinner
                                if (overlay && spanner) {
                                    overlay.classList.remove("show");
                                    spanner.classList.remove("show");
                                }
                                // clear FileList
                                fileUploadElement.value = "";
                            }
                        } catch (error) {
                            (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
                            fileUploadElement.value = "";
                        }
                        // Cache the current reference
                        const targetElement = reloadedElements;
                        targetElement.innerHTML = "";
                        const newDom = await (0, $a7ebecf2cd2c995d$export$2e2bcd8739ae039)(config);
                        if (newDom) targetElement.innerHTML = newDom.innerHTML;
                    } catch (error) {
                        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
                    }
                } else {
                    (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)((0, $2bbe20b8c555b785$export$9fd3b9062419c302)("Unable to get file or document-sdk-type"), onError);
                    fileUploadElement.value = "";
                }
            });
            innerDom.append(stagnantElements);
        }
        return innerDom;
    }
    return undefined;
};




const $e980f3fe0c1d81f1$export$30ec2dd2924015a = (config)=>{
    const { clientToken: clientToken, documentUploadSessionId: documentUploadSessionId, onError: onError, documentUploadComponent: documentUploadComponent } = config;
    if (!clientToken || typeof clientToken !== "string" || clientToken === "") {
        onError((0, $2bbe20b8c555b785$export$cd3a77372f1d28e3)("Invalid client token."));
        return false;
    } else if (!documentUploadSessionId || typeof documentUploadSessionId !== "string" || documentUploadSessionId === "") {
        onError((0, $2bbe20b8c555b785$export$cd3a77372f1d28e3)("Invalid document session id."));
        return false;
    } else if (!documentUploadComponent.selector || documentUploadSessionId === "" || document.querySelector(documentUploadComponent.selector) === null) {
        onError((0, $2bbe20b8c555b785$export$cd3a77372f1d28e3)("Invalid document upload component."));
        return false;
    } else return true;
};



const $0dd523eaeec6a5c8$var$initializeSdk = async (config)=>{
    const { onError: onError, onLoad: onLoad, documentUploadComponent: documentUploadComponent } = config;
    const { selector: selector } = documentUploadComponent;
    const container = document.querySelector(selector);
    if (container) try {
        container.innerHTML = "";
        const component = await (0, $4895a115c3812db1$export$810c69deeb72a110)(config);
        if (component) {
            container.append(component);
            onLoad(component);
        }
    } catch (error) {
        (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, onError);
    }
    else (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)((0, $2bbe20b8c555b785$export$29cdd66c4b2bccfa)("Invalid document upload component."), onError);
};
const $0dd523eaeec6a5c8$export$9063cee3c5d28fcb = async (config)=>{
    if ((0, $e980f3fe0c1d81f1$export$30ec2dd2924015a)(config)) {
        try {
            await $0dd523eaeec6a5c8$var$initializeSdk(config);
        } catch (error) {
            (0, $2bbe20b8c555b785$export$d0f6f6f8d08fe167)(error, config.onError);
        }
        return {
            unmount: ()=>{
                const { documentUploadComponent: { selector: selector } } = config;
                const container = document.querySelector(selector);
                if (container !== null) container.replaceChildren("");
            },
            endSession: async ()=>await (0, $a7ebecf2cd2c995d$export$f8f719707da23294)(config)
        };
    }
    return undefined;
};


//# sourceMappingURL=index.js.map
